'use strict';
const hdjf9AssetBase = new URL('.', document.currentScript.src).href;
(() => {
  const hdjf9Story = document.getElementById('hdjf9-story');
  var Gb = Object.create;
  var Af = Object.defineProperty,
    Wb = Object.defineProperties,
    Xb = Object.getOwnPropertyDescriptor,
    Yb = Object.getOwnPropertyDescriptors,
    qb = Object.getOwnPropertyNames,
    P_ = Object.getOwnPropertySymbols,
    Zb = Object.getPrototypeOf,
    L_ = Object.prototype.hasOwnProperty,
    Kb = Object.prototype.propertyIsEnumerable;
  var Zi = Math.pow,
    wf = (s, e, t) =>
      e in s
        ? Af(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t })
        : (s[e] = t),
    pt = (s, e) => {
      for (var t in e || (e = {})) L_.call(e, t) && wf(s, t, e[t]);
      if (P_) for (var t of P_(e)) Kb.call(e, t) && wf(s, t, e[t]);
      return s;
    },
    Fi = (s, e) => Wb(s, Yb(e));
  var $b = (s, e) => () => (
    e || s((e = { exports: {} }).exports, e),
    e.exports
  );
  var jb = (s, e, t, i) => {
    if ((e && typeof e == 'object') || typeof e == 'function')
      for (let n of qb(e))
        !L_.call(s, n) &&
          n !== t &&
          Af(s, n, {
            get: () => e[n],
            enumerable: !(i = Xb(e, n)) || i.enumerable,
          });
    return s;
  };
  var Jb = (s, e, t) => (
    (t = s != null ? Gb(Zb(s)) : {}),
    jb(
      e || !s || !s.__esModule
        ? Af(t, 'default', { value: s, enumerable: !0 })
        : t,
      s,
    )
  );
  var y = (s, e, t) => wf(s, typeof e != 'symbol' ? e + '' : e, t);
  var Ns = (s, e, t) =>
    new Promise((i, n) => {
      var r = (l) => {
          try {
            a(t.next(l));
          } catch (c) {
            n(c);
          }
        },
        o = (l) => {
          try {
            a(t.throw(l));
          } catch (c) {
            n(c);
          }
        },
        a = (l) => (l.done ? i(l.value) : Promise.resolve(l.value).then(r, o));
      a((t = t.apply(s, e)).next());
    });
  var Db = $b((bf, Ib) => {
    'use strict';
    (function (s, e) {
      typeof bf == 'object' && typeof Ib != 'undefined'
        ? e(bf)
        : typeof define == 'function' && define.amd
          ? define(['exports'], e)
          : e(
              ((s =
                typeof globalThis != 'undefined'
                  ? globalThis
                  : s || self).UnicornStudio = {}),
            );
    })(bf, function (s) {
      'use strict';
      var e = Object.defineProperty,
        t = (D, h, m) =>
          ((b, S, E) =>
            S in b
              ? e(b, S, {
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                  value: E,
                })
              : (b[S] = E))(D, typeof h != 'symbol' ? h + '' : h, m),
        i =
          typeof globalThis != 'undefined'
            ? globalThis
            : typeof window != 'undefined'
              ? window
              : typeof global != 'undefined'
                ? global
                : typeof self != 'undefined'
                  ? self
                  : {},
        n = { exports: {} };
      (function (D, h) {
        function m(de, me, De) {
          return (
            (m =
              typeof Reflect != 'undefined' && Reflect.get
                ? Reflect.get
                : function (Ge, ze, lt) {
                    var st = (function (dt, gt) {
                      for (
                        ;
                        !Object.prototype.hasOwnProperty.call(dt, gt) &&
                        (dt = E(dt)) !== null;
                      );
                      return dt;
                    })(Ge, ze);
                    if (st) {
                      var ft = Object.getOwnPropertyDescriptor(st, ze);
                      return ft.get ? ft.get.call(lt) : ft.value;
                    }
                  }),
            m(de, me, De || de)
          );
        }
        function b(de, me) {
          return (b =
            Object.setPrototypeOf ||
            function (De, Ge) {
              return ((De.__proto__ = Ge), De);
            })(de, me);
        }
        function S(de) {
          var me = (function () {
            if (
              typeof Reflect == 'undefined' ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if (typeof Proxy == 'function') return !0;
            try {
              return (
                Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                ),
                !0
              );
            } catch (De) {
              return !1;
            }
          })();
          return function () {
            var De,
              Ge = E(de);
            if (me) {
              var ze = E(this).constructor;
              De = Reflect.construct(Ge, arguments, ze);
            } else De = Ge.apply(this, arguments);
            return (function (lt, st) {
              if (st && (fe(st) === 'object' || typeof st == 'function'))
                return st;
              if (st !== void 0)
                throw new TypeError(
                  'Derived constructors may only return object or undefined',
                );
              return (function (ft) {
                if (ft === void 0)
                  throw new ReferenceError(
                    "this hasn't been initialised - super() hasn't been called",
                  );
                return ft;
              })(lt);
            })(this, De);
          };
        }
        function E(de) {
          return (E = Object.setPrototypeOf
            ? Object.getPrototypeOf
            : function (me) {
                return me.__proto__ || Object.getPrototypeOf(me);
              })(de);
        }
        function A(de) {
          return (
            (function (me) {
              if (Array.isArray(me)) return V(me);
            })(de) ||
            (function (me) {
              if (
                (typeof Symbol != 'undefined' && me[Symbol.iterator] != null) ||
                me['@@iterator'] != null
              )
                return Array.from(me);
            })(de) ||
            F(de) ||
            (function () {
              throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            })()
          );
        }
        function F(de, me) {
          if (de) {
            if (typeof de == 'string') return V(de, me);
            var De = Object.prototype.toString.call(de).slice(8, -1);
            return (
              De === 'Object' && de.constructor && (De = de.constructor.name),
              De === 'Map' || De === 'Set'
                ? Array.from(de)
                : De === 'Arguments' ||
                    /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(De)
                  ? V(de, me)
                  : void 0
            );
          }
        }
        function V(de, me) {
          (me == null || me > de.length) && (me = de.length);
          for (var De = 0, Ge = new Array(me); De < me; De++) Ge[De] = de[De];
          return Ge;
        }
        function Y(de, me) {
          var De = Object.keys(de);
          if (Object.getOwnPropertySymbols) {
            var Ge = Object.getOwnPropertySymbols(de);
            (me &&
              (Ge = Ge.filter(function (ze) {
                return Object.getOwnPropertyDescriptor(de, ze).enumerable;
              })),
              De.push.apply(De, Ge));
          }
          return De;
        }
        function X(de) {
          for (var me = 1; me < arguments.length; me++) {
            var De = arguments[me] != null ? arguments[me] : {};
            me % 2
              ? Y(Object(De), !0).forEach(function (Ge) {
                  $(de, Ge, De[Ge]);
                })
              : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    de,
                    Object.getOwnPropertyDescriptors(De),
                  )
                : Y(Object(De)).forEach(function (Ge) {
                    Object.defineProperty(
                      de,
                      Ge,
                      Object.getOwnPropertyDescriptor(De, Ge),
                    );
                  });
          }
          return de;
        }
        function $(de, me, De) {
          return (
            me in de
              ? Object.defineProperty(de, me, {
                  value: De,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (de[me] = De),
            de
          );
        }
        function le(de, me) {
          if (!(de instanceof me))
            throw new TypeError('Cannot call a class as a function');
        }
        function xe(de, me, De) {
          return (
            me &&
              (function (Ge, ze) {
                for (var lt = 0; lt < ze.length; lt++) {
                  var st = ze[lt];
                  ((st.enumerable = st.enumerable || !1),
                    (st.configurable = !0),
                    'value' in st && (st.writable = !0),
                    Object.defineProperty(Ge, st.key, st));
                }
              })(de.prototype, me),
            de
          );
        }
        function fe(de) {
          return (fe =
            typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol'
              ? function (me) {
                  return typeof me;
                }
              : function (me) {
                  return me &&
                    typeof Symbol == 'function' &&
                    me.constructor === Symbol &&
                    me !== Symbol.prototype
                    ? 'symbol'
                    : typeof me;
                })(de);
        }
        var Se, Me;
        ((Se = i),
          (Me = function (de) {
            var me = new Uint8Array([0, 0, 0, 0]),
              De = new Float32Array([
                1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
              ]),
              Ge = (function () {
                function P(T) {
                  var k,
                    G,
                    B,
                    ae,
                    ne =
                      arguments.length > 1 && arguments[1] !== void 0
                        ? arguments[1]
                        : {};
                  (le(this, P),
                    (this.curtains = T),
                    (this.gl = T == null ? void 0 : T.gl),
                    (this.type = 'Texture'),
                    (this.userData = {}),
                    (this.shouldUpdate = !1),
                    (this._samplerName = ne.sampler || 'uTexture'),
                    (this._source = ne.source || null),
                    (this.source = this._source),
                    (this.sourceType = this._source
                      ? 'source'
                      : ne.fromTexture
                        ? 'copy'
                        : 'empty'),
                    (this._copiedFrom = null),
                    (this._videoFrameCallbackID = null),
                    (this._videoFrameCallback = null),
                    (this._videoFallbackRAF = null),
                    (this._sourceLoaded = !1),
                    (this._uploaded = !1),
                    (this._canDraw = !1),
                    (this._size = { width: 1, height: 1 }),
                    (this._globalParameters = this.gl
                      ? ((B = this.gl),
                        (ae = ne.floatingPoint),
                        B instanceof WebGL2RenderingContext
                          ? ae === 'half-float'
                            ? {
                                internalFormat: B.RGBA16F,
                                format: B.RGBA,
                                type: B.HALF_FLOAT,
                              }
                            : ae === 'float'
                              ? {
                                  internalFormat: B.RGBA32F,
                                  format: B.RGBA,
                                  type: B.FLOAT,
                                }
                              : {
                                  internalFormat: B.RGBA8,
                                  format: B.RGBA,
                                  type: B.UNSIGNED_BYTE,
                                }
                          : {
                              internalFormat: B.RGBA,
                              format: B.RGBA,
                              type: B.UNSIGNED_BYTE,
                            })
                      : { internalFormat: 0, format: 0, type: 0 }),
                    (this._sampler = {
                      texture: this.gl ? this.gl.createTexture() : null,
                    }),
                    (this._premultiplyAlpha =
                      (k =
                        (G = ne.premultipliedAlpha) !== null && G !== void 0
                          ? G
                          : ne.premultiplyAlpha) === null ||
                      k === void 0 ||
                      k),
                    this.gl && this._sampler.texture && this._initState(),
                    ne.fromTexture
                      ? this.copy(ne.fromTexture)
                      : this._source
                        ? this.setSource(this._source)
                        : this._uploadFallback());
                }
                return (
                  xe(P, [
                    {
                      key: '_bind',
                      value: function () {
                        this.gl.bindTexture(
                          this.gl.TEXTURE_2D,
                          this._sampler.texture,
                        );
                      },
                    },
                    {
                      key: '_initState',
                      value: function () {
                        var T = this.gl;
                        (this._bind(),
                          T.pixelStorei(
                            T.UNPACK_PREMULTIPLY_ALPHA_WEBGL,
                            this._premultiplyAlpha ? 1 : 0,
                          ),
                          T.texParameteri(
                            T.TEXTURE_2D,
                            T.TEXTURE_WRAP_S,
                            T.CLAMP_TO_EDGE,
                          ),
                          T.texParameteri(
                            T.TEXTURE_2D,
                            T.TEXTURE_WRAP_T,
                            T.CLAMP_TO_EDGE,
                          ),
                          T.texParameteri(
                            T.TEXTURE_2D,
                            T.TEXTURE_MIN_FILTER,
                            T.LINEAR,
                          ),
                          T.texParameteri(
                            T.TEXTURE_2D,
                            T.TEXTURE_MAG_FILTER,
                            T.LINEAR,
                          ),
                          T.bindTexture(T.TEXTURE_2D, null));
                      },
                    },
                    {
                      key: '_uploadFallback',
                      value: function () {
                        if (
                          this.gl &&
                          this._sampler.texture &&
                          !this._copiedFrom
                        ) {
                          var T = this.gl;
                          (this._bind(),
                            this._globalParameters.type === T.UNSIGNED_BYTE
                              ? T.texImage2D(
                                  T.TEXTURE_2D,
                                  0,
                                  this._globalParameters.internalFormat,
                                  1,
                                  1,
                                  0,
                                  this._globalParameters.format,
                                  this._globalParameters.type,
                                  me,
                                )
                              : T.texImage2D(
                                  T.TEXTURE_2D,
                                  0,
                                  this._globalParameters.internalFormat,
                                  1,
                                  1,
                                  0,
                                  this._globalParameters.format,
                                  this._globalParameters.type,
                                  null,
                                ),
                            (this._uploaded = !0),
                            (this._canDraw = !0),
                            T.bindTexture(T.TEXTURE_2D, null));
                        }
                      },
                    },
                    {
                      key: '_scheduleVideoRender',
                      value: function () {
                        this.curtains &&
                          !this._copiedFrom &&
                          ((this.shouldUpdate = !0),
                          typeof this.curtains.requestRender == 'function'
                            ? this.curtains.requestRender()
                            : typeof this.curtains.render == 'function' &&
                              this.curtains.render());
                      },
                    },
                    {
                      key: '_stopVideoFrameUpdates',
                      value: function () {
                        var T = this._source;
                        T &&
                          T instanceof HTMLVideoElement &&
                          (this._videoFrameCallbackID !== null &&
                            typeof T.cancelVideoFrameCallback == 'function' &&
                            T.cancelVideoFrameCallback(
                              this._videoFrameCallbackID,
                            ),
                          (this._videoFrameCallbackID = null),
                          (this._videoFrameCallback = null),
                          this._videoFallbackRAF !== null &&
                            (cancelAnimationFrame(this._videoFallbackRAF),
                            (this._videoFallbackRAF = null)));
                      },
                    },
                    {
                      key: '_startVideoFrameUpdates',
                      value: function () {
                        var T = this,
                          k = this._source;
                        k &&
                          k instanceof HTMLVideoElement &&
                          !this._copiedFrom &&
                          (this._stopVideoFrameUpdates(),
                          typeof k.requestVideoFrameCallback == 'function'
                            ? ((this._videoFrameCallback = function () {
                                (T._scheduleVideoRender(),
                                  (T._videoFrameCallbackID =
                                    k.requestVideoFrameCallback(
                                      T._videoFrameCallback,
                                    )));
                              }),
                              (this._videoFrameCallbackID =
                                k.requestVideoFrameCallback(
                                  this._videoFrameCallback,
                                )))
                            : (this._videoFallbackRAF = requestAnimationFrame(
                                function G() {
                                  T._source === k
                                    ? (!k.paused &&
                                        !k.ended &&
                                        k.readyState >= k.HAVE_CURRENT_DATA &&
                                        T._scheduleVideoRender(),
                                      (T._videoFallbackRAF =
                                        requestAnimationFrame(G)))
                                    : (T._videoFallbackRAF = null);
                                },
                              )));
                      },
                    },
                    {
                      key: '_uploadSource',
                      value: function (T) {
                        if (
                          this.gl &&
                          this._sampler.texture &&
                          !this._copiedFrom
                        ) {
                          var k = this.gl,
                            G = T.videoWidth || T.naturalWidth || T.width || 1,
                            B =
                              T.videoHeight || T.naturalHeight || T.height || 1;
                          ((this._size = { width: G, height: B }),
                            this._bind(),
                            k.pixelStorei(k.UNPACK_FLIP_Y_WEBGL, 1),
                            k.pixelStorei(
                              k.UNPACK_PREMULTIPLY_ALPHA_WEBGL,
                              this._premultiplyAlpha ? 1 : 0,
                            ),
                            k instanceof WebGL2RenderingContext
                              ? k.texImage2D(
                                  k.TEXTURE_2D,
                                  0,
                                  this._globalParameters.internalFormat,
                                  this._globalParameters.format,
                                  this._globalParameters.type,
                                  T,
                                )
                              : k.texImage2D(
                                  k.TEXTURE_2D,
                                  0,
                                  this._globalParameters.format,
                                  this._globalParameters.format,
                                  this._globalParameters.type,
                                  T,
                                ),
                            k.pixelStorei(k.UNPACK_FLIP_Y_WEBGL, 0),
                            (this._sourceLoaded = !0),
                            (this._uploaded = !0),
                            (this._canDraw = !0),
                            (this.sourceType =
                              T instanceof HTMLVideoElement
                                ? 'video'
                                : T instanceof HTMLCanvasElement
                                  ? 'canvas'
                                  : 'image'),
                            k.bindTexture(k.TEXTURE_2D, null));
                        }
                      },
                    },
                    {
                      key: 'setSource',
                      value: function (T) {
                        return (
                          this._stopVideoFrameUpdates(),
                          (this._source = T),
                          (this.source = T),
                          (this._copiedFrom = null),
                          this._uploadSource(T),
                          T instanceof HTMLVideoElement &&
                            this._startVideoFrameUpdates(),
                          this
                        );
                      },
                    },
                    {
                      key: 'copy',
                      value: function (T) {
                        return T
                          ? (this._stopVideoFrameUpdates(),
                            (this._source = T._source || null),
                            (this.source = this._source),
                            (this._copiedFrom = T),
                            (this.sourceType = T.sourceType || 'copy'),
                            (this._sourceLoaded = !!T._sourceLoaded),
                            (this._uploaded = !!T._uploaded),
                            (this._canDraw = T._canDraw !== !1),
                            (this._sampler.texture = T._sampler.texture),
                            (this._size = X({}, T._size)),
                            (this._globalParameters = X(
                              {},
                              T._globalParameters,
                            )),
                            (this.shouldUpdate = !!T.shouldUpdate),
                            this)
                          : this;
                      },
                    },
                    {
                      key: 'update',
                      value: function () {
                        this._source &&
                          !this._copiedFrom &&
                          this._uploadSource(this._source);
                      },
                    },
                    {
                      key: 'needUpdate',
                      value: function () {
                        this._copiedFrom ||
                          (this.update(),
                          this.curtains &&
                          typeof this.curtains.requestRender == 'function'
                            ? this.curtains.requestRender()
                            : this.curtains &&
                              typeof this.curtains.render == 'function' &&
                              this.curtains.render());
                      },
                    },
                    {
                      key: 'remove',
                      value: function () {
                        (this._stopVideoFrameUpdates(),
                          this.gl &&
                            this._sampler.texture &&
                            !this._copiedFrom &&
                            this.gl.deleteTexture(this._sampler.texture));
                      },
                    },
                  ]),
                  P
                );
              })(),
              ze = (function () {
                function P(T) {
                  var k,
                    G,
                    B,
                    ae,
                    ne,
                    Q =
                      arguments.length > 1 && arguments[1] !== void 0
                        ? arguments[1]
                        : {};
                  (le(this, P),
                    (this.curtains = T),
                    (this.gl = T == null ? void 0 : T.gl),
                    (this.type = 'RenderTarget'),
                    (this.userData = {}),
                    (this._depth = !!Q.depth),
                    (this._clear = Q.clear === void 0 || !!Q.clear));
                  var ce =
                      (T == null || (k = T.canvas) === null || k === void 0
                        ? void 0
                        : k.width) || 1,
                    he =
                      (T == null || (G = T.canvas) === null || G === void 0
                        ? void 0
                        : G.height) || 1;
                  ((this._scaleWithCanvas =
                    Q.scaleWithCanvas === void 0 || !!Q.scaleWithCanvas),
                    (this._widthScale =
                      Q.maxWidth !== void 0 && ce > 0 ? Q.maxWidth / ce : null),
                    (this._heightScale =
                      Q.maxHeight !== void 0 && he > 0
                        ? Q.maxHeight / he
                        : null),
                    (this._baseMaxSize = {
                      width: Math.max(1, Math.round(Q.maxWidth || ce)),
                      height: Math.max(1, Math.round(Q.maxHeight || he)),
                    }),
                    (this._minSize = {
                      width: Math.max(1, Math.round(Q.minWidth || 1)),
                      height: Math.max(1, Math.round(Q.minHeight || 1)),
                    }),
                    (this._maxSize = {
                      width: this._baseMaxSize.width,
                      height: this._baseMaxSize.height,
                    }),
                    (this._size = {
                      width: this._baseMaxSize.width,
                      height: this._baseMaxSize.height,
                    }),
                    this._setSize(),
                    (this.index = -1),
                    (this._frameBuffer = null),
                    (this._depthBuffer = null));
                  var He =
                      ((B = Q.texturesOptions) === null || B === void 0
                        ? void 0
                        : B.sampler) || 'uTexture',
                    qe = Q.texturesOptions && Q.texturesOptions.floatingPoint;
                  ((this.textures = [
                    new Ge(T, {
                      sampler: He,
                      premultiplyAlpha:
                        (ae =
                          (ne = Q.texturesOptions) === null || ne === void 0
                            ? void 0
                            : ne.premultiplyAlpha) === null ||
                        ae === void 0 ||
                        ae,
                      floatingPoint: qe,
                    }),
                  ]),
                    T != null &&
                      T.renderTargets &&
                      !T.renderTargets.includes(this) &&
                      (T.renderTargets.push(this),
                      T.renderTargets.forEach(function (Xe, Mt) {
                        Xe.index = Mt;
                      })),
                    this._initRenderTarget());
                }
                return (
                  xe(P, [
                    {
                      key: '_setSize',
                      value: function () {
                        var T,
                          k,
                          G =
                            1 *
                            ((this.curtains === null ||
                            this.curtains === void 0 ||
                            (T = this.curtains.canvas) === null ||
                            T === void 0
                              ? void 0
                              : T.width) || 1),
                          B =
                            1 *
                            ((this.curtains === null ||
                            this.curtains === void 0 ||
                            (k = this.curtains.canvas) === null ||
                            k === void 0
                              ? void 0
                              : k.height) || 1),
                          ae = this._baseMaxSize.width,
                          ne = this._baseMaxSize.height;
                        (this._scaleWithCanvas &&
                          (this._widthScale !== null &&
                            (ae = Math.max(
                              1,
                              Math.round(G * this._widthScale),
                            )),
                          this._heightScale !== null &&
                            (ne = Math.max(
                              1,
                              Math.round(B * this._heightScale),
                            ))),
                          (this._maxSize = { width: ae, height: ne }),
                          (this._size = {
                            width: Math.min(
                              this._maxSize.width,
                              Math.max(this._minSize.width, G),
                            ),
                            height: Math.min(
                              this._maxSize.height,
                              Math.max(this._minSize.height, B),
                            ),
                          }));
                      },
                    },
                    {
                      key: '_initRenderTarget',
                      value: function () {
                        if (this.gl) {
                          var T = this.gl;
                          (this._setSize(),
                            this._frameBuffer ||
                              (this._frameBuffer = T.createFramebuffer()));
                          var k = this.getTexture();
                          k &&
                            (T.bindFramebuffer(
                              T.FRAMEBUFFER,
                              this._frameBuffer,
                            ),
                            T.bindTexture(T.TEXTURE_2D, k._sampler.texture),
                            T.texImage2D(
                              T.TEXTURE_2D,
                              0,
                              k._globalParameters.internalFormat,
                              this._size.width,
                              this._size.height,
                              0,
                              k._globalParameters.format,
                              k._globalParameters.type,
                              null,
                            ),
                            (k._size = X({}, this._size)),
                            (k._sourceLoaded = !0),
                            (k._uploaded = !0),
                            (k._canDraw = !0),
                            (k.sourceType = 'fbo'),
                            T.framebufferTexture2D(
                              T.FRAMEBUFFER,
                              T.COLOR_ATTACHMENT0,
                              T.TEXTURE_2D,
                              k._sampler.texture,
                              0,
                            ),
                            this._depth &&
                              (this._depthBuffer ||
                                (this._depthBuffer = T.createRenderbuffer()),
                              T.bindRenderbuffer(
                                T.RENDERBUFFER,
                                this._depthBuffer,
                              ),
                              T.renderbufferStorage(
                                T.RENDERBUFFER,
                                T.DEPTH_COMPONENT16,
                                this._size.width,
                                this._size.height,
                              ),
                              T.framebufferRenderbuffer(
                                T.FRAMEBUFFER,
                                T.DEPTH_ATTACHMENT,
                                T.RENDERBUFFER,
                                this._depthBuffer,
                              ),
                              T.bindRenderbuffer(T.RENDERBUFFER, null)),
                            T.bindTexture(T.TEXTURE_2D, null),
                            T.bindFramebuffer(T.FRAMEBUFFER, null));
                        }
                      },
                    },
                    {
                      key: 'resize',
                      value: function () {
                        if (this.gl) {
                          var T = this._size.width,
                            k = this._size.height;
                          if (
                            (this._setSize(),
                            T !== this._size.width ||
                              k !== this._size.height ||
                              !this._frameBuffer)
                          )
                            if (this._frameBuffer) {
                              var G = this.getTexture();
                              if (G) {
                                var B = this.gl;
                                (B.bindFramebuffer(
                                  B.FRAMEBUFFER,
                                  this._frameBuffer,
                                ),
                                  B.bindTexture(
                                    B.TEXTURE_2D,
                                    G._sampler.texture,
                                  ),
                                  B.texImage2D(
                                    B.TEXTURE_2D,
                                    0,
                                    G._globalParameters.internalFormat,
                                    this._size.width,
                                    this._size.height,
                                    0,
                                    G._globalParameters.format,
                                    G._globalParameters.type,
                                    null,
                                  ),
                                  (G._size = X({}, this._size)),
                                  (G._sourceLoaded = !0),
                                  (G._uploaded = !0),
                                  (G._canDraw = !0),
                                  (G.sourceType = 'fbo'),
                                  B.framebufferTexture2D(
                                    B.FRAMEBUFFER,
                                    B.COLOR_ATTACHMENT0,
                                    B.TEXTURE_2D,
                                    G._sampler.texture,
                                    0,
                                  ),
                                  this._depth &&
                                    (this._depthBuffer ||
                                      (this._depthBuffer =
                                        B.createRenderbuffer()),
                                    B.bindRenderbuffer(
                                      B.RENDERBUFFER,
                                      this._depthBuffer,
                                    ),
                                    B.renderbufferStorage(
                                      B.RENDERBUFFER,
                                      B.DEPTH_COMPONENT16,
                                      this._size.width,
                                      this._size.height,
                                    ),
                                    B.framebufferRenderbuffer(
                                      B.FRAMEBUFFER,
                                      B.DEPTH_ATTACHMENT,
                                      B.RENDERBUFFER,
                                      this._depthBuffer,
                                    ),
                                    B.bindRenderbuffer(B.RENDERBUFFER, null)),
                                  B.bindTexture(B.TEXTURE_2D, null),
                                  this.curtains && this.curtains.renderer
                                    ? this.curtains.renderer.bindFrameBuffer(
                                        null,
                                      )
                                    : B.bindFramebuffer(B.FRAMEBUFFER, null));
                              }
                            } else this._initRenderTarget();
                        }
                      },
                    },
                    {
                      key: 'getTexture',
                      value: function () {
                        return this.textures[0] || null;
                      },
                    },
                    {
                      key: 'remove',
                      value: function () {
                        var T,
                          k = this;
                        this.gl &&
                          (this._depthBuffer &&
                            (this.gl.deleteRenderbuffer(this._depthBuffer),
                            (this._depthBuffer = null)),
                          this._frameBuffer &&
                            (this.gl.deleteFramebuffer(this._frameBuffer),
                            (this._frameBuffer = null)),
                          this.textures.forEach(function (G) {
                            return G.remove();
                          }),
                          (T = this.curtains) !== null &&
                            T !== void 0 &&
                            T.renderTargets &&
                            ((this.curtains.renderTargets =
                              this.curtains.renderTargets.filter(function (G) {
                                return G !== k;
                              })),
                            this.curtains.renderTargets.forEach(
                              function (G, B) {
                                G.index = B;
                              },
                            )));
                      },
                    },
                  ]),
                  P
                );
              })(),
              lt = (function () {
                function P() {
                  var T,
                    k,
                    G,
                    B = this,
                    ae =
                      arguments.length > 0 && arguments[0] !== void 0
                        ? arguments[0]
                        : {};
                  (le(this, P),
                    (this.type = 'Curtains'),
                    (this.options = X({}, ae)),
                    (this.container = (G = ae.container)
                      ? typeof G == 'string'
                        ? document.querySelector(G)
                        : G
                      : null),
                    (this.canvas = document.createElement('canvas')),
                    (this.canvas.style.display = 'block'),
                    (this.canvas.style.width = '100%'),
                    (this.canvas.style.height = '100%'),
                    this.container &&
                      !this.container.contains(this.canvas) &&
                      this.container.appendChild(this.canvas));
                  var ne = {
                    alpha: !0,
                    antialias: (T = ae.antialias) !== null && T !== void 0 && T,
                    premultipliedAlpha:
                      (k = ae.premultipliedAlpha) === null || k === void 0 || k,
                    preserveDrawingBuffer: !1,
                  };
                  ((this.gl =
                    this.canvas.getContext('webgl2', ne) ||
                    this.canvas.getContext('webgl', ne)),
                    this.gl instanceof WebGL2RenderingContext
                      ? (this.gl.getExtension('EXT_color_buffer_float'),
                        this.gl.getExtension('OES_texture_float_linear'))
                      : (this.gl.getExtension('OES_texture_half_float'),
                        this.gl.getExtension('OES_texture_half_float_linear'),
                        this.gl.getExtension('OES_texture_float'),
                        this.gl.getExtension('OES_texture_float_linear')),
                    (this.planes = []),
                    (this.renderTargets = []),
                    (this.pixelRatio = ae.pixelRatio || 1),
                    (this.renderingScale = ae.renderingScale || 1),
                    (this._renderRequestID = null),
                    (this._errorCallbacks = []),
                    (this._contextLostCallbacks = []),
                    (this._contextRestoredCallbacks = []));
                  var Q = {
                    currentProgramID: null,
                    currentGeometryID: null,
                    forceBufferUpdate: !1,
                    depthTest: null,
                    blending: null,
                    cullFace: null,
                    frameBufferID: null,
                    activeTexture: null,
                    flipY: null,
                    premultiplyAlpha: null,
                  };
                  ((this.renderer = {
                    gl: this.gl,
                    premultipliedAlpha: ne.premultipliedAlpha,
                    state: Q,
                    nextRender: { execute: function () {} },
                    setDepthTest: function (ce) {
                      B.gl &&
                        (ce && !Q.depthTest
                          ? ((Q.depthTest = ce), B.gl.enable(B.gl.DEPTH_TEST))
                          : !ce &&
                            Q.depthTest &&
                            ((Q.depthTest = ce),
                            B.gl.disable(B.gl.DEPTH_TEST)));
                    },
                    setDepthFunc: function () {
                      B.gl && B.gl.depthFunc(B.gl.LEQUAL);
                    },
                    setBlending: function () {
                      var ce =
                        arguments.length > 0 &&
                        arguments[0] !== void 0 &&
                        arguments[0];
                      B.gl &&
                        (ce && !Q.blending
                          ? ((Q.blending = ce), B.gl.enable(B.gl.BLEND))
                          : !ce &&
                            Q.blending &&
                            ((Q.blending = ce), B.gl.disable(B.gl.BLEND)));
                    },
                    setBlendFunc: function () {
                      B.gl &&
                        (B.gl.enable(B.gl.BLEND),
                        this.premultipliedAlpha
                          ? B.gl.blendFuncSeparate(
                              B.gl.ONE,
                              B.gl.ONE_MINUS_SRC_ALPHA,
                              B.gl.ONE,
                              B.gl.ONE_MINUS_SRC_ALPHA,
                            )
                          : B.gl.blendFuncSeparate(
                              B.gl.SRC_ALPHA,
                              B.gl.ONE_MINUS_SRC_ALPHA,
                              B.gl.ONE,
                              B.gl.ONE_MINUS_SRC_ALPHA,
                            ));
                    },
                    setFaceCulling: function (ce) {
                      if (B.gl && Q.cullFace !== ce)
                        if (((Q.cullFace = ce), ce === 'none'))
                          B.gl.disable(B.gl.CULL_FACE);
                        else {
                          var he = ce === 'front' ? B.gl.FRONT : B.gl.BACK;
                          (B.gl.enable(B.gl.CULL_FACE), B.gl.cullFace(he));
                        }
                    },
                    useProgram: function (ce) {
                      if (B.gl && ce) {
                        var he = ce.id !== void 0 ? ce.id : ce,
                          He = ce.program || ce;
                        (Q.currentProgramID !== null &&
                          Q.currentProgramID === he) ||
                          (B.gl.useProgram(He), (Q.currentProgramID = he));
                      }
                    },
                    bindFrameBuffer: function (ce) {
                      var he =
                        arguments.length > 1 &&
                        arguments[1] !== void 0 &&
                        arguments[1];
                      if (B.gl) {
                        ce && he && !ce._frameBuffer && ce._initRenderTarget();
                        var He = ce
                          ? ce.index !== void 0
                            ? ce.index
                            : ce._frameBuffer
                          : null;
                        He !== Q.frameBufferID &&
                          (B.gl.bindFramebuffer(
                            B.gl.FRAMEBUFFER,
                            ce ? ce._frameBuffer : null,
                          ),
                          (Q.frameBufferID = He));
                      }
                    },
                  }),
                    this.renderer.setBlendFunc(),
                    this.renderer.setDepthFunc(),
                    this.renderer.setDepthTest(!1),
                    (this._onContextLost = function (ce) {
                      (ce.preventDefault(),
                        B._contextLostCallbacks.forEach(function (he) {
                          return he(ce);
                        }));
                    }),
                    (this._onContextRestored = function () {
                      B._contextRestoredCallbacks.forEach(function (ce) {
                        return ce();
                      });
                    }),
                    this.canvas.addEventListener(
                      'webglcontextlost',
                      this._onContextLost,
                      !1,
                    ),
                    this.canvas.addEventListener(
                      'webglcontextrestored',
                      this._onContextRestored,
                      !1,
                    ),
                    this.resize());
                }
                return (
                  xe(P, [
                    {
                      key: '_emitError',
                      value: function (T) {
                        this._errorCallbacks.forEach(function (k) {
                          return k(T);
                        });
                      },
                    },
                    {
                      key: 'onError',
                      value: function (T) {
                        return (
                          typeof T == 'function' &&
                            this._errorCallbacks.push(T),
                          this
                        );
                      },
                    },
                    {
                      key: 'onContextLost',
                      value: function (T) {
                        return (
                          typeof T == 'function' &&
                            this._contextLostCallbacks.push(T),
                          this
                        );
                      },
                    },
                    {
                      key: 'onContextRestored',
                      value: function (T) {
                        return (
                          typeof T == 'function' &&
                            this._contextRestoredCallbacks.push(T),
                          this
                        );
                      },
                    },
                    {
                      key: 'restoreContext',
                      value: function () {
                        return this;
                      },
                    },
                    {
                      key: 'createRenderTarget',
                      value: function () {
                        return new ze(
                          this,
                          arguments.length > 0 && arguments[0] !== void 0
                            ? arguments[0]
                            : {},
                        );
                      },
                    },
                    {
                      key: 'requestRender',
                      value: function () {
                        var T = this;
                        this.gl &&
                          this._renderRequestID === null &&
                          (this._renderRequestID = requestAnimationFrame(
                            function () {
                              ((T._renderRequestID = null), T.render());
                            },
                          ));
                      },
                    },
                    {
                      key: 'resize',
                      value: function () {
                        if (this.container) {
                          var T = Math.max(
                              1,
                              Math.round(
                                this.container.clientWidth *
                                  this.pixelRatio *
                                  this.renderingScale,
                              ),
                            ),
                            k = Math.max(
                              1,
                              Math.round(
                                this.container.clientHeight *
                                  this.pixelRatio *
                                  this.renderingScale,
                              ),
                            );
                          ((this.canvas.width = T),
                            (this.canvas.height = k),
                            this.gl && this.gl.viewport(0, 0, T, k),
                            this.renderTargets.slice().forEach(function (G) {
                              G && typeof G.resize == 'function' && G.resize();
                            }));
                        }
                      },
                    },
                    {
                      key: 'render',
                      value: function () {
                        if (this.gl) {
                          this.renderer.nextRender.execute();
                          var T = this.gl;
                          T.clear(T.COLOR_BUFFER_BIT | T.DEPTH_BUFFER_BIT);
                          var k = A(this.planes)
                              .filter(function (Q) {
                                return Q.visible !== !1;
                              })
                              .sort(function (Q, ce) {
                                return (
                                  (Q.renderOrder || 0) - (ce.renderOrder || 0)
                                );
                              }),
                            G = k.filter(function (Q) {
                              return Q.type === 'PingPongPlane';
                            }),
                            B = k.filter(function (Q) {
                              return Q.type !== 'PingPongPlane';
                            }),
                            ae = B.filter(function (Q) {
                              return !!Q.target;
                            }).sort(function (Q, ce) {
                              var he =
                                  Q.target && Q.target.index !== void 0
                                    ? Q.target.index
                                    : Number.MAX_SAFE_INTEGER,
                                He =
                                  ce.target && ce.target.index !== void 0
                                    ? ce.target.index
                                    : Number.MAX_SAFE_INTEGER;
                              return he !== He
                                ? he - He
                                : (Q.renderOrder || 0) - (ce.renderOrder || 0);
                            }),
                            ne = B.filter(function (Q) {
                              return !Q.target;
                            });
                          (T.disable(T.DEPTH_TEST),
                            T.enable(T.BLEND),
                            T.blendFunc(T.ONE, T.ONE_MINUS_SRC_ALPHA),
                            G.forEach(function (Q) {
                              Q._canDraw !== !1 && Q._render();
                            }),
                            ae.forEach(function (Q) {
                              Q._canDraw !== !1 && Q._render();
                            }),
                            ne.forEach(function (Q) {
                              Q._canDraw !== !1 && Q._render();
                            }));
                        }
                      },
                    },
                    {
                      key: 'dispose',
                      value: function () {
                        (this._renderRequestID !== null &&
                          (cancelAnimationFrame(this._renderRequestID),
                          (this._renderRequestID = null)),
                          this.planes.slice().forEach(function (T) {
                            return T.remove();
                          }),
                          this.renderTargets.slice().forEach(function (T) {
                            return T.remove();
                          }),
                          this.canvas &&
                            (this.canvas.removeEventListener(
                              'webglcontextlost',
                              this._onContextLost,
                            ),
                            this.canvas.removeEventListener(
                              'webglcontextrestored',
                              this._onContextRestored,
                            )),
                          (this.planes = []),
                          (this.renderTargets = []));
                      },
                    },
                  ]),
                  P
                );
              })();
            function st(P, T, k) {
              var G = P.createShader(T);
              if (
                (P.shaderSource(G, k),
                P.compileShader(G),
                !P.getShaderParameter(G, P.COMPILE_STATUS))
              ) {
                var B = P.getShaderInfoLog(G) || 'Unknown shader compile error';
                throw (P.deleteShader(G), new Error(B));
              }
              return G;
            }
            var ft = (function () {
                function P(T, k) {
                  var G = this,
                    B =
                      arguments.length > 2 && arguments[2] !== void 0
                        ? arguments[2]
                        : {};
                  (le(this, P),
                    (this.type = 'Plane'),
                    (this.curtains = T),
                    (this.gl = T == null ? void 0 : T.gl),
                    (this.htmlElement =
                      k || (T == null ? void 0 : T.container) || null),
                    (this.userData = {}),
                    (this.visible = !0),
                    (this.renderOrder = 0),
                    (this.target = null),
                    (this._canDraw = !0),
                    (this.textures = []),
                    (this.videos = []),
                    (this.uniforms = (function () {
                      var ae =
                          arguments.length > 0 && arguments[0] !== void 0
                            ? arguments[0]
                            : {},
                        ne = {};
                      return (
                        Object.keys(ae).forEach(function (Q) {
                          ne[Q] = X({}, ae[Q]);
                        }),
                        ne
                      );
                    })(B.uniforms)),
                    (this._readyCallbacks = []),
                    (this._renderCallbacks = []),
                    (this._afterRenderCallbacks = []),
                    (this._uniformLocations = new Map()),
                    (this._vertexShader =
                      B.vertexShader ||
                      `
attribute vec3 aVertexPosition;
attribute vec2 aTextureCoord;

varying vec2 vTextureCoord;

void main() {
    gl_Position = vec4(aVertexPosition, 1.0);
    vTextureCoord = aTextureCoord;
}
`),
                    (this._fragmentShader =
                      B.fragmentShader ||
                      `
precision mediump float;

uniform sampler2D uTexture;
varying vec2 vTextureCoord;

void main() {
    gl_FragColor = texture2D(uTexture, vTextureCoord);
}
`),
                    (this._geometry = null),
                    (this._program = null),
                    (this._positionLocation = -1),
                    (this._uvLocation = -1),
                    (this._mvMatrixLocation = null),
                    (this._pMatrixLocation = null),
                    this._init(B),
                    T == null || T.planes.push(this),
                    requestAnimationFrame(function () {
                      G._readyCallbacks.forEach(function (ae) {
                        return ae(G);
                      });
                    }));
                }
                return (
                  xe(P, [
                    {
                      key: '_init',
                      value: function (T) {
                        if (this.gl)
                          try {
                            ((this._program = (function (B, ae, ne) {
                              var Q = st(B, B.VERTEX_SHADER, ae),
                                ce = st(B, B.FRAGMENT_SHADER, ne),
                                he = B.createProgram();
                              if (
                                (B.attachShader(he, Q),
                                B.attachShader(he, ce),
                                B.linkProgram(he),
                                B.deleteShader(Q),
                                B.deleteShader(ce),
                                !B.getProgramParameter(he, B.LINK_STATUS))
                              ) {
                                var He =
                                  B.getProgramInfoLog(he) ||
                                  'Unknown program link error';
                                throw (B.deleteProgram(he), new Error(He));
                              }
                              return he;
                            })(
                              this.gl,
                              this._vertexShader,
                              this._fragmentShader,
                            )),
                              (this._positionLocation =
                                this.gl.getAttribLocation(
                                  this._program,
                                  'aVertexPosition',
                                )),
                              (this._uvLocation = this.gl.getAttribLocation(
                                this._program,
                                'aTextureCoord',
                              )),
                              (this._geometry = (function (B) {
                                for (
                                  var ae =
                                      arguments.length > 1 &&
                                      arguments[1] !== void 0
                                        ? arguments[1]
                                        : 1,
                                    ne =
                                      arguments.length > 2 &&
                                      arguments[2] !== void 0
                                        ? arguments[2]
                                        : 1,
                                    Q = Math.max(1, Math.floor(ae)),
                                    ce = Math.max(1, Math.floor(ne)),
                                    he = (Q + 1) * (ce + 1),
                                    He = new Float32Array(3 * he),
                                    qe = new Float32Array(2 * he),
                                    Xe = 0,
                                    Mt = 0,
                                    Yt = 0;
                                  Yt <= ce;
                                  Yt++
                                )
                                  for (
                                    var Jt = Yt / ce, kt = 1 - 2 * Jt, Ti = 0;
                                    Ti <= Q;
                                    Ti++
                                  ) {
                                    var $e = Ti / Q,
                                      an = 2 * $e - 1;
                                    ((He[Xe++] = an),
                                      (He[Xe++] = kt),
                                      (He[Xe++] = 0),
                                      (qe[Mt++] = $e),
                                      (qe[Mt++] = 1 - Jt));
                                  }
                                for (
                                  var Bt = Q * ce * 6,
                                    ln = he > 65535,
                                    Ni = ln
                                      ? new Uint32Array(Bt)
                                      : new Uint16Array(Bt),
                                    cn = 0,
                                    us = 0;
                                  us < ce;
                                  us++
                                )
                                  for (var Wt = 0; Wt < Q; Wt++) {
                                    var oi = us * (Q + 1) + Wt,
                                      ds = oi + 1,
                                      qt = (us + 1) * (Q + 1) + Wt,
                                      Os = qt + 1;
                                    ((Ni[cn++] = oi),
                                      (Ni[cn++] = qt),
                                      (Ni[cn++] = ds),
                                      (Ni[cn++] = ds),
                                      (Ni[cn++] = qt),
                                      (Ni[cn++] = Os));
                                  }
                                var sr = B.createBuffer();
                                (B.bindBuffer(B.ARRAY_BUFFER, sr),
                                  B.bufferData(
                                    B.ARRAY_BUFFER,
                                    He,
                                    B.STATIC_DRAW,
                                  ));
                                var vl = B.createBuffer();
                                (B.bindBuffer(B.ARRAY_BUFFER, vl),
                                  B.bufferData(
                                    B.ARRAY_BUFFER,
                                    qe,
                                    B.STATIC_DRAW,
                                  ));
                                var C_ = B.createBuffer();
                                return (
                                  B.bindBuffer(B.ELEMENT_ARRAY_BUFFER, C_),
                                  B.bufferData(
                                    B.ELEMENT_ARRAY_BUFFER,
                                    Ni,
                                    B.STATIC_DRAW,
                                  ),
                                  B.bindBuffer(B.ARRAY_BUFFER, null),
                                  B.bindBuffer(B.ELEMENT_ARRAY_BUFFER, null),
                                  {
                                    positionBuffer: sr,
                                    uvBuffer: vl,
                                    indexBuffer: C_,
                                    indexCount: Bt,
                                    indexType: ln
                                      ? B.UNSIGNED_INT
                                      : B.UNSIGNED_SHORT,
                                  }
                                );
                              })(this.gl, T.widthSegments, T.heightSegments)),
                              (this._mvMatrixLocation =
                                this.gl.getUniformLocation(
                                  this._program,
                                  'uMVMatrix',
                                )),
                              (this._pMatrixLocation =
                                this.gl.getUniformLocation(
                                  this._program,
                                  'uPMatrix',
                                )),
                              (this._texMatrixLocation =
                                this.gl.getUniformLocation(
                                  this._program,
                                  'uTextureMatrix',
                                )));
                          } catch (B) {
                            var k, G;
                            ((k = this.curtains) === null ||
                              k === void 0 ||
                              (G = k._emitError) === null ||
                              G === void 0 ||
                              G.call(k, B),
                              (this._canDraw = !1));
                          }
                      },
                    },
                    {
                      key: '_bindAttributes',
                      value: function () {
                        var T = this.gl,
                          k = this._geometry;
                        k &&
                          (this._positionLocation >= 0 &&
                            (T.bindBuffer(T.ARRAY_BUFFER, k.positionBuffer),
                            T.enableVertexAttribArray(this._positionLocation),
                            T.vertexAttribPointer(
                              this._positionLocation,
                              3,
                              T.FLOAT,
                              !1,
                              0,
                              0,
                            )),
                          this._uvLocation >= 0 &&
                            (T.bindBuffer(T.ARRAY_BUFFER, k.uvBuffer),
                            T.enableVertexAttribArray(this._uvLocation),
                            T.vertexAttribPointer(
                              this._uvLocation,
                              2,
                              T.FLOAT,
                              !1,
                              0,
                              0,
                            )),
                          T.bindBuffer(T.ELEMENT_ARRAY_BUFFER, k.indexBuffer));
                      },
                    },
                    {
                      key: '_bindUniforms',
                      value: function () {
                        var T = this;
                        if (this._program) {
                          var k = this.gl;
                          (k.useProgram(this._program),
                            Object.keys(this.uniforms).forEach(function (G) {
                              var B = T.uniforms[G];
                              if (B) {
                                var ae = T._uniformLocations.get(G);
                                (ae === void 0 &&
                                  ((ae = k.getUniformLocation(
                                    T._program,
                                    B.name || G,
                                  )),
                                  T._uniformLocations.set(G, ae)),
                                  (function (ne, Q, ce, he) {
                                    if (Q != null && he != null) {
                                      var He =
                                          he &&
                                          fe(he) === 'object' &&
                                          'x' in he &&
                                          'y' in he,
                                        qe = He && 'z' in he;
                                      switch (ce) {
                                        case '1f':
                                          ne.uniform1f(Q, Number(he));
                                          break;
                                        case '2f':
                                          ne.uniform2f(
                                            Q,
                                            He ? he.x : he[0],
                                            He ? he.y : he[1],
                                          );
                                          break;
                                        case '3f':
                                          ne.uniform3f(
                                            Q,
                                            qe ? he.x : he[0],
                                            qe ? he.y : he[1],
                                            qe ? he.z : he[2],
                                          );
                                          break;
                                        case '4f':
                                          ne.uniform4f(
                                            Q,
                                            he[0],
                                            he[1],
                                            he[2],
                                            he[3],
                                          );
                                          break;
                                        case '1i':
                                          ne.uniform1i(Q, Number(he));
                                          break;
                                        case '2i':
                                          ne.uniform2i(Q, he[0], he[1]);
                                          break;
                                        case '3i':
                                          ne.uniform3i(Q, he[0], he[1], he[2]);
                                          break;
                                        case '4i':
                                          ne.uniform4i(
                                            Q,
                                            he[0],
                                            he[1],
                                            he[2],
                                            he[3],
                                          );
                                          break;
                                        case '1fv':
                                          ne.uniform1fv(Q, he);
                                          break;
                                        case '2fv':
                                          ne.uniform2fv(Q, he);
                                          break;
                                        case '3fv':
                                          ne.uniform3fv(Q, he);
                                          break;
                                        case '4fv':
                                          ne.uniform4fv(Q, he);
                                          break;
                                        case 'mat3':
                                          ne.uniformMatrix3fv(Q, !1, he);
                                          break;
                                        case 'mat4':
                                          ne.uniformMatrix4fv(Q, !1, he);
                                          break;
                                        default:
                                          qe
                                            ? ne.uniform3f(Q, he.x, he.y, he.z)
                                            : He
                                              ? ne.uniform2f(Q, he.x, he.y)
                                              : Array.isArray(he) ||
                                                  ArrayBuffer.isView(he)
                                                ? he.length === 16
                                                  ? ne.uniformMatrix4fv(
                                                      Q,
                                                      !1,
                                                      he,
                                                    )
                                                  : he.length === 9
                                                    ? ne.uniformMatrix3fv(
                                                        Q,
                                                        !1,
                                                        he,
                                                      )
                                                    : he.length === 4
                                                      ? ne.uniform4fv(Q, he)
                                                      : he.length === 3
                                                        ? ne.uniform3fv(Q, he)
                                                        : he.length === 2
                                                          ? ne.uniform2fv(Q, he)
                                                          : he.length === 1 &&
                                                            ne.uniform1f(
                                                              Q,
                                                              he[0],
                                                            )
                                                : ne.uniform1f(Q, Number(he));
                                      }
                                    }
                                  })(k, ae, B.type, B.value));
                              }
                            }));
                        }
                      },
                    },
                    {
                      key: '_bindTextures',
                      value: function () {
                        var T,
                          k = this.gl,
                          G = 0,
                          B = (function (ce, he) {
                            var He =
                              (typeof Symbol != 'undefined' &&
                                ce[Symbol.iterator]) ||
                              ce['@@iterator'];
                            if (!He) {
                              if (Array.isArray(ce) || (He = F(ce)) || he) {
                                He && (ce = He);
                                var qe = 0,
                                  Xe = function () {};
                                return {
                                  s: Xe,
                                  n: function () {
                                    return qe >= ce.length
                                      ? { done: !0 }
                                      : { done: !1, value: ce[qe++] };
                                  },
                                  e: function (kt) {
                                    throw kt;
                                  },
                                  f: Xe,
                                };
                              }
                              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                            }
                            var Mt,
                              Yt = !0,
                              Jt = !1;
                            return {
                              s: function () {
                                He = He.call(ce);
                              },
                              n: function () {
                                var kt = He.next();
                                return ((Yt = kt.done), kt);
                              },
                              e: function (kt) {
                                ((Jt = !0), (Mt = kt));
                              },
                              f: function () {
                                try {
                                  Yt || He.return == null || He.return();
                                } finally {
                                  if (Jt) throw Mt;
                                }
                              },
                            };
                          })(this.textures);
                        try {
                          for (B.s(); !(T = B.n()).done; ) {
                            var ae,
                              ne = T.value;
                            if (
                              ne != null &&
                              (ae = ne._sampler) !== null &&
                              ae !== void 0 &&
                              ae.texture
                            ) {
                              (k.activeTexture(k.TEXTURE0 + G),
                                ne._copiedFrom && ne.copy(ne._copiedFrom),
                                ne.shouldUpdate && ne.update());
                              var Q = k.getUniformLocation(
                                this._program,
                                ne._samplerName,
                              );
                              Q != null &&
                                (k.bindTexture(
                                  k.TEXTURE_2D,
                                  ne._sampler.texture,
                                ),
                                k.uniform1i(Q, G),
                                G++);
                            }
                          }
                        } catch (ce) {
                          B.e(ce);
                        } finally {
                          B.f();
                        }
                      },
                    },
                    {
                      key: '_prepareRenderTarget',
                      value: function (T) {
                        var k, G;
                        if (!T || !this.gl)
                          return (
                            this.curtains.renderer.bindFrameBuffer(null),
                            void this.gl.viewport(
                              0,
                              0,
                              this.curtains.canvas.width,
                              this.curtains.canvas.height,
                            )
                          );
                        this.curtains.renderer.bindFrameBuffer(T, !0);
                        var B =
                            ((k = T._size) === null || k === void 0
                              ? void 0
                              : k.width) || this.curtains.canvas.width,
                          ae =
                            ((G = T._size) === null || G === void 0
                              ? void 0
                              : G.height) || this.curtains.canvas.height;
                        (this.gl.viewport(0, 0, B, ae),
                          T._clear !== !1 &&
                            (this.gl.clearColor(0, 0, 0, 0),
                            this.gl.clear(
                              this.gl.COLOR_BUFFER_BIT |
                                (T._depth ? this.gl.DEPTH_BUFFER_BIT : 0),
                            )));
                      },
                    },
                    {
                      key: '_render',
                      value: function () {
                        var T = this;
                        this.gl &&
                          this._program &&
                          this._geometry &&
                          (this._renderCallbacks.forEach(function (k) {
                            return k(T);
                          }),
                          this._prepareRenderTarget(this.target),
                          this.gl.useProgram(this._program),
                          this._mvMatrixLocation &&
                            this.gl.uniformMatrix4fv(
                              this._mvMatrixLocation,
                              !1,
                              De,
                            ),
                          this._pMatrixLocation &&
                            this.gl.uniformMatrix4fv(
                              this._pMatrixLocation,
                              !1,
                              De,
                            ),
                          this._texMatrixLocation &&
                            this.gl.uniformMatrix4fv(
                              this._texMatrixLocation,
                              !1,
                              De,
                            ),
                          this._bindAttributes(),
                          this._bindUniforms(),
                          this._bindTextures(),
                          this.gl.drawElements(
                            this.gl.TRIANGLES,
                            this._geometry.indexCount,
                            this._geometry.indexType,
                            0,
                          ),
                          this.curtains.renderer.bindFrameBuffer(null),
                          this.gl.viewport(
                            0,
                            0,
                            this.curtains.canvas.width,
                            this.curtains.canvas.height,
                          ),
                          this._afterRenderCallbacks.forEach(function (k) {
                            return k(T);
                          }));
                      },
                    },
                    {
                      key: 'onReady',
                      value: function (T) {
                        return (
                          typeof T == 'function' &&
                            this._readyCallbacks.push(T),
                          this
                        );
                      },
                    },
                    {
                      key: 'onRender',
                      value: function (T) {
                        return (
                          typeof T == 'function' &&
                            this._renderCallbacks.push(T),
                          this
                        );
                      },
                    },
                    {
                      key: 'onAfterRender',
                      value: function (T) {
                        return (
                          typeof T == 'function' &&
                            this._afterRenderCallbacks.push(T),
                          this
                        );
                      },
                    },
                    {
                      key: 'setRenderOrder',
                      value: function () {
                        var T =
                          arguments.length > 0 && arguments[0] !== void 0
                            ? arguments[0]
                            : 0;
                        return ((this.renderOrder = T), this);
                      },
                    },
                    {
                      key: 'setRenderTarget',
                      value: function (T) {
                        var k;
                        return (
                          (this.target = T),
                          T &&
                            (k = this.curtains) !== null &&
                            k !== void 0 &&
                            k.renderTargets &&
                            !this.curtains.renderTargets.includes(T) &&
                            (this.curtains.renderTargets.push(T),
                            this.curtains.renderTargets.forEach(
                              function (G, B) {
                                G.index = B;
                              },
                            )),
                          this
                        );
                      },
                    },
                    {
                      key: 'createTexture',
                      value: function () {
                        var T,
                          k,
                          G =
                            arguments.length > 0 && arguments[0] !== void 0
                              ? arguments[0]
                              : {},
                          B = G.sampler || 'uTexture',
                          ae = this.textures.find(function (ce) {
                            return ce._samplerName === B;
                          });
                        if (ae && G.fromTexture)
                          return (ae.copy(G.fromTexture), ae);
                        var ne = new Ge(this.curtains, {
                          sampler: B,
                          premultipliedAlpha:
                            (T =
                              (k = G.premultipliedAlpha) !== null &&
                              k !== void 0
                                ? k
                                : G.premultiplyAlpha) === null ||
                            T === void 0 ||
                            T,
                          fromTexture: G.fromTexture,
                        });
                        if (ae) {
                          var Q = this.textures.indexOf(ae);
                          return ((this.textures[Q] = ne), ne);
                        }
                        return (this.textures.push(ne), ne);
                      },
                    },
                    {
                      key: 'addTexture',
                      value: function (T) {
                        if (!T) return null;
                        var k = T._samplerName || 'uTexture',
                          G = this.textures.findIndex(function (B) {
                            return B._samplerName === k;
                          });
                        return (
                          G >= 0
                            ? (this.textures[G] = T)
                            : this.textures.push(T),
                          T
                        );
                      },
                    },
                    {
                      key: 'loadCanvas',
                      value: function (T) {
                        var k =
                            arguments.length > 1 && arguments[1] !== void 0
                              ? arguments[1]
                              : {},
                          G = arguments.length > 2 ? arguments[2] : void 0,
                          B = arguments.length > 3 ? arguments[3] : void 0;
                        try {
                          var ae,
                            ne,
                            Q = new Ge(this.curtains, {
                              sampler: k.sampler || 'uTexture',
                              source: T,
                              premultipliedAlpha:
                                (ae =
                                  (ne = k.premultipliedAlpha) !== null &&
                                  ne !== void 0
                                    ? ne
                                    : k.premultiplyAlpha) === null ||
                                ae === void 0 ||
                                ae,
                            });
                          return (
                            (Q.shouldUpdate = !0),
                            this.addTexture(Q),
                            typeof G == 'function' && G(Q),
                            Q
                          );
                        } catch (ce) {
                          return (typeof B == 'function' && B(ce), null);
                        }
                      },
                    },
                    {
                      key: 'loadVideo',
                      value: function (T) {
                        var k,
                          G,
                          B,
                          ae = this,
                          ne =
                            arguments.length > 1 && arguments[1] !== void 0
                              ? arguments[1]
                              : {},
                          Q = arguments.length > 2 ? arguments[2] : void 0,
                          ce = arguments.length > 3 ? arguments[3] : void 0;
                        (T instanceof HTMLVideoElement
                          ? (k = T)
                          : (((k =
                              document.createElement('video')).crossOrigin =
                              'anonymous'),
                            (k.src = T)),
                          (k.preload = 'auto'),
                          (k.muted = !0),
                          (k.loop = !0),
                          k.setAttribute('playsinline', ''),
                          k.crossOrigin || (k.crossOrigin = 'anonymous'));
                        var he = new Ge(ae.curtains, {
                          sampler: ne.sampler || 'uVideoTexture',
                          premultipliedAlpha:
                            (G =
                              (B = ne.premultipliedAlpha) !== null &&
                              B !== void 0
                                ? B
                                : ne.premultiplyAlpha) === null ||
                            G === void 0 ||
                            G,
                        });
                        ((he.shouldUpdate = !0), ae.addTexture(he));
                        var He = function () {
                          try {
                            (he.setSource(k),
                              (he.shouldUpdate = !0),
                              ae.videos.push(k),
                              typeof Q == 'function' && Q(he));
                          } catch (qe) {
                            typeof ce == 'function' && ce(qe);
                          }
                        };
                        return (
                          k.readyState >= k.HAVE_CURRENT_DATA
                            ? He()
                            : (k.addEventListener('loadeddata', He, {
                                once: !0,
                              }),
                              k.addEventListener(
                                'error',
                                function (qe) {
                                  typeof ce == 'function' && ce(qe);
                                },
                                { once: !0 },
                              ),
                              T instanceof HTMLVideoElement || k.load()),
                          k
                        );
                      },
                    },
                    {
                      key: 'remove',
                      value: function () {
                        var T,
                          k = this;
                        this.gl &&
                          (this.textures.forEach(function (G) {
                            return G.remove();
                          }),
                          this._geometry &&
                            (this.gl.deleteBuffer(
                              this._geometry.positionBuffer,
                            ),
                            this.gl.deleteBuffer(this._geometry.uvBuffer),
                            this.gl.deleteBuffer(this._geometry.indexBuffer)),
                          this._program && this.gl.deleteProgram(this._program),
                          (T = this.curtains) !== null &&
                            T !== void 0 &&
                            T.planes &&
                            (this.curtains.planes = this.curtains.planes.filter(
                              function (G) {
                                return G !== k;
                              },
                            )));
                      },
                    },
                  ]),
                  P
                );
              })(),
              dt = (function () {
                function P(T) {
                  (le(this, P), (this.curtains = T), (this.cache = new Map()));
                }
                return (
                  xe(P, [
                    {
                      key: 'loadImage',
                      value: function (T) {
                        var k = this,
                          G =
                            arguments.length > 1 && arguments[1] !== void 0
                              ? arguments[1]
                              : {},
                          B = arguments.length > 2 ? arguments[2] : void 0,
                          ae = arguments.length > 3 ? arguments[3] : void 0;
                        if (!T)
                          return (
                            typeof ae == 'function' &&
                              ae(new Error('Missing image src')),
                            null
                          );
                        var ne = this.cache.get(T),
                          Q = function (qe) {
                            var Xe,
                              Mt,
                              Yt = new Ge(k.curtains, {
                                sampler: G.sampler || 'uTexture',
                                source: qe,
                                premultipliedAlpha:
                                  (Xe =
                                    (Mt = G.premultipliedAlpha) !== null &&
                                    Mt !== void 0
                                      ? Mt
                                      : G.premultiplyAlpha) === null ||
                                  Xe === void 0 ||
                                  Xe,
                              });
                            typeof B == 'function' && B(Yt);
                          };
                        if (ne != null && ne.loaded && ne.image)
                          return (Q(ne.image), ne.image);
                        var ce =
                          (ne == null ? void 0 : ne.image) || new Image();
                        ce.crossOrigin = 'anonymous';
                        var he = ne || { image: ce, loaded: !1 };
                        this.cache.set(T, he);
                        var He = function () {
                          ((he.loaded = !0), Q(ce));
                        };
                        return ce.complete && ce.naturalWidth > 0
                          ? (He(), ce)
                          : (ce.addEventListener('load', He, { once: !0 }),
                            ce.addEventListener(
                              'error',
                              function (qe) {
                                typeof ae == 'function' && ae(qe);
                              },
                              { once: !0 },
                            ),
                            ce.src || (ce.src = T),
                            ce);
                      },
                    },
                    {
                      key: 'loadCanvas',
                      value: function (T) {
                        var k =
                            arguments.length > 1 && arguments[1] !== void 0
                              ? arguments[1]
                              : {},
                          G = arguments.length > 2 ? arguments[2] : void 0,
                          B = arguments.length > 3 ? arguments[3] : void 0;
                        try {
                          var ae,
                            ne,
                            Q = new Ge(this.curtains, {
                              sampler: k.sampler || 'uTexture',
                              source: T,
                              premultipliedAlpha:
                                (ae =
                                  (ne = k.premultipliedAlpha) !== null &&
                                  ne !== void 0
                                    ? ne
                                    : k.premultiplyAlpha) === null ||
                                ae === void 0 ||
                                ae,
                            });
                          return (
                            (Q.shouldUpdate = !0),
                            typeof G == 'function' && G(Q),
                            Q
                          );
                        } catch (ce) {
                          return (typeof B == 'function' && B(ce), null);
                        }
                      },
                    },
                  ]),
                  P
                );
              })(),
              gt = (function () {
                function P() {
                  var T =
                      arguments.length > 0 && arguments[0] !== void 0
                        ? arguments[0]
                        : 0,
                    k =
                      arguments.length > 1 && arguments[1] !== void 0
                        ? arguments[1]
                        : T;
                  (le(this, P),
                    (this.type = 'Vec2'),
                    (this._x = Number.isFinite(T) ? T : 0),
                    (this._y = Number.isFinite(k) ? k : 0));
                }
                return (
                  xe(P, [
                    {
                      key: 'x',
                      get: function () {
                        return this._x;
                      },
                      set: function (T) {
                        this._x = Number.isFinite(T) ? T : this._x;
                      },
                    },
                    {
                      key: 'y',
                      get: function () {
                        return this._y;
                      },
                      set: function (T) {
                        this._y = Number.isFinite(T) ? T : this._y;
                      },
                    },
                    {
                      key: 'equals',
                      value: function (T) {
                        return !!T && this._x === T.x && this._y === T.y;
                      },
                    },
                  ]),
                  P
                );
              })(),
              Gt = (function () {
                function P() {
                  var T =
                      arguments.length > 0 && arguments[0] !== void 0
                        ? arguments[0]
                        : 0,
                    k =
                      arguments.length > 1 && arguments[1] !== void 0
                        ? arguments[1]
                        : T,
                    G =
                      arguments.length > 2 && arguments[2] !== void 0
                        ? arguments[2]
                        : T;
                  (le(this, P),
                    (this.type = 'Vec3'),
                    (this._x = Number.isFinite(T) ? T : 0),
                    (this._y = Number.isFinite(k) ? k : 0),
                    (this._z = Number.isFinite(G) ? G : 0));
                }
                return (
                  xe(P, [
                    {
                      key: 'x',
                      get: function () {
                        return this._x;
                      },
                      set: function (T) {
                        this._x = Number.isFinite(T) ? T : this._x;
                      },
                    },
                    {
                      key: 'y',
                      get: function () {
                        return this._y;
                      },
                      set: function (T) {
                        this._y = Number.isFinite(T) ? T : this._y;
                      },
                    },
                    {
                      key: 'z',
                      get: function () {
                        return this._z;
                      },
                      set: function (T) {
                        this._z = Number.isFinite(T) ? T : this._z;
                      },
                    },
                  ]),
                  P
                );
              })(),
              Ot = (function (P) {
                (function (G, B) {
                  if (typeof B != 'function' && B !== null)
                    throw new TypeError(
                      'Super expression must either be null or a function',
                    );
                  ((G.prototype = Object.create(B && B.prototype, {
                    constructor: { value: G, writable: !0, configurable: !0 },
                  })),
                    B && b(G, B));
                })(k, P);
                var T = S(k);
                function k(G, B) {
                  var ae,
                    ne =
                      arguments.length > 2 && arguments[2] !== void 0
                        ? arguments[2]
                        : {};
                  (le(this, k),
                    ((ae = T.call(this, G, B, ne)).type = 'PingPongPlane'));
                  var Q = Object.assign({}, ne.texturesOptions, {
                    sampler: ne.sampler || 'uPingPongTexture',
                  });
                  return (
                    Q.premultiplyAlpha === void 0 &&
                      Q.premultipliedAlpha === void 0 &&
                      (Q.premultiplyAlpha = !0),
                    (ae._targets = [
                      new ze(G, {
                        clear: !1,
                        maxWidth: G.canvas.width,
                        maxHeight: G.canvas.height,
                        texturesOptions: Q,
                      }),
                      new ze(G, {
                        clear: !1,
                        maxWidth: G.canvas.width,
                        maxHeight: G.canvas.height,
                        texturesOptions: Q,
                      }),
                    ]),
                    (ae._readIndex = 0),
                    (ae._sampler = ne.sampler || 'uPingPongTexture'),
                    ae.createTexture({
                      sampler: ae._sampler,
                      fromTexture: ae._targets[ae._readIndex].getTexture(),
                    }),
                    ae.setRenderTarget(ae._targets[ae._readIndex]),
                    ae
                  );
                }
                return (
                  xe(k, [
                    {
                      key: 'getTexture',
                      value: function () {
                        return (
                          this.textures.find(function (G) {
                            return G._samplerName === this._sampler;
                          }, this) ||
                          this._targets[this._readIndex].getTexture()
                        );
                      },
                    },
                    {
                      key: '_render',
                      value: function () {
                        var G = this._readIndex === 0 ? 1 : 0;
                        (this.setRenderTarget(this._targets[G]),
                          m(E(k.prototype), '_render', this).call(this),
                          (this._readIndex = G));
                        var B = this._targets[this._readIndex].getTexture(),
                          ae = this.textures.find(function (ne) {
                            return ne._samplerName === this._sampler;
                          }, this);
                        ae && B && ae.copy(B);
                      },
                    },
                    {
                      key: 'remove',
                      value: function () {
                        (this._targets.forEach(function (G) {
                          return G.remove();
                        }),
                          m(E(k.prototype), 'remove', this).call(this));
                      },
                    },
                  ]),
                  k
                );
              })(ft);
            ((de.Curtains = lt),
              (de.PingPongPlane = Ot),
              (de.Plane = ft),
              (de.RenderTarget = ze),
              (de.TextureLoader = dt),
              (de.Vec2 = gt),
              (de.Vec3 = Gt),
              Object.defineProperty(de, '__esModule', { value: !0 }));
          }),
          fe(h) === 'object'
            ? Me(h)
            : Me(
                ((Se =
                  typeof globalThis != 'undefined'
                    ? globalThis
                    : Se || self).window = Se.window || {}),
              ));
      })(0, n.exports);
      var r = n.exports;
      let o,
        a,
        l,
        c,
        u = !1,
        f = window.innerHeight || document.documentElement.clientHeight,
        d = window.innerWidth || document.documentElement.clientWidth,
        p = null,
        _ = W(),
        x = 0,
        g = 0,
        v = 0,
        w = 0,
        L = null,
        R = 0.001,
        U = ['relative', 'fixed', 'auto'],
        O = ['relative', 'fixed'],
        N = { enterTime: null, movePos: { x: 0.5, y: 0.5 } },
        M = ['lightColor', 'ambientLightColor', 'fillLightColor'],
        I = '2.1.12';
      function z(D) {
        if (D == null || D === '' || (typeof D == 'string' && D.trim() === ''))
          return null;
        let h = Number(D);
        return Number.isFinite(h) ? h : null;
      }
      function W() {
        return p !== null ? p : window.scrollY || window.pageYOffset || 0;
      }
      function q(D = W()) {
        let h = z(D);
        return h !== null && ((_ = h), (g = _ - x), (x = _), !0);
      }
      function re(D) {
        return window.atob(D);
      }
      function oe(D) {
        var h;
        return O.includes(D)
          ? D
          : (h = O[D != null ? D : 0]) != null
            ? h
            : O[0];
      }
      function K() {
        return (
          'id-' +
          Math.random().toString(36).substring(2, 15) +
          Math.random().toString(36).substring(2, 15)
        );
      }
      function ie(D) {
        let h = {
          linear: (m) => m,
          easeInQuad: (m) => m * m,
          easeOutQuad: (m) => 1 - (1 - m) * (1 - m),
          easeInOutQuad: (m) =>
            m < 0.5 ? 2 * m * m : 1 - Math.pow(-2 * m + 2, 2) / 2,
          easeInCubic: (m) => m * m * m,
          easeOutCubic: (m) => 1 - Math.pow(1 - m, 3),
          easeInOutCubic: (m) =>
            m < 0.5 ? 4 * m * m * m : 1 - Math.pow(-2 * m + 2, 3) / 2,
          easeInQuart: (m) => Zi(m, 4),
          easeOutQuart: (m) => 1 - Math.pow(1 - m, 4),
          easeInOutQuart: (m) =>
            m < 0.5 ? 8 * Zi(m, 4) : 1 - Math.pow(-2 * m + 2, 4) / 2,
          easeInQuint: (m) => Zi(m, 5),
          easeOutQuint: (m) => 1 - Math.pow(1 - m, 5),
          easeInOutQuint: (m) =>
            m < 0.5 ? 16 * Zi(m, 5) : 1 - Math.pow(-2 * m + 2, 5) / 2,
          easeOutElastic: (m) => {
            let b = (2 * Math.PI) / 3;
            return m === 0
              ? 0
              : m === 1
                ? 1
                : Math.pow(2, -10 * m) * Math.sin((10 * m - 0.75) * b) + 1;
          },
          easeInElastic: (m) => {
            let b = (2 * Math.PI) / 3;
            return m === 0
              ? 0
              : m === 1
                ? 1
                : -Math.pow(2, 10 * m - 10) * Math.sin((10 * m - 10.75) * b);
          },
          easeInOutElastic: (m) => {
            let b = (2 * Math.PI) / 4.5;
            return m === 0
              ? 0
              : m === 1
                ? 1
                : m < 0.5
                  ? (-Math.pow(2, 20 * m - 10) *
                      Math.sin((20 * m - 11.125) * b)) /
                    2
                  : (Math.pow(2, -20 * m + 10) *
                      Math.sin((20 * m - 11.125) * b)) /
                      2 +
                    1;
          },
          easeOutSpringSoft: (m) =>
            m === 0 || m === 1
              ? m
              : 1 - Math.exp(-5 * m) * Math.cos(3 * m * Math.PI),
          easeOutSpring: (m) =>
            m === 0 || m === 1
              ? m
              : 1 - Math.exp(-6 * m) * Math.cos(4.5 * m * Math.PI),
          easeInSpring: (m) => {
            if (m === 0 || m === 1) return m;
            let b = 1 - m;
            return Math.exp(-6 * b) * Math.cos(4.5 * b * Math.PI);
          },
          easeInOutSpring: (m) => {
            if (m === 0 || m === 1) return m;
            if (m < 0.5) {
              let S = 1 - 2 * m;
              return (Math.exp(-6 * S) * Math.cos(4.5 * S * Math.PI)) / 2;
            }
            let b = 2 * m - 1;
            return 1 - (Math.exp(-6 * b) * Math.cos(4.5 * b * Math.PI)) / 2;
          },
          easeInSine: (m) => 1 - Math.cos((m * Math.PI) / 2),
          easeOutSine: (m) => Math.sin((m * Math.PI) / 2),
          easeInOutSine: (m) => -(Math.cos(Math.PI * m) - 1) / 2,
          easeInCirc: (m) => 1 - Math.sqrt(1 - Zi(m, 2)),
          easeOutCirc: (m) => Math.sqrt(1 - Math.pow(m - 1, 2)),
          easeInOutCirc: (m) =>
            m < 0.5
              ? (1 - Math.sqrt(1 - Zi(2 * m, 2))) / 2
              : (Math.sqrt(1 - Math.pow(-2 * m + 2, 2)) + 1) / 2,
          easeInExpo: (m) => (m === 0 ? 0 : Math.pow(2, 10 * m - 10)),
          easeOutExpo: (m) => (m === 1 ? 1 : 1 - Math.pow(2, -10 * m)),
          easeInOutExpo: (m) =>
            m === 0
              ? 0
              : m === 1
                ? 1
                : m < 0.5
                  ? Math.pow(2, 20 * m - 10) / 2
                  : (2 - Math.pow(2, -20 * m + 10)) / 2,
          easeInBack: (m) => 2.70158 * m * m * m - 1.70158 * m * m,
          easeOutBack: (m) =>
            1 + 2.70158 * Math.pow(m - 1, 3) + 1.70158 * Math.pow(m - 1, 2),
          easeInOutBack: (m) => {
            let b = 2.5949095;
            return m < 0.5
              ? (Math.pow(2 * m, 2) * (7.189819 * m - b)) / 2
              : (Math.pow(2 * m - 2, 2) * ((b + 1) * (2 * m - 2) + b) + 2) / 2;
          },
        };
        if (
          !(
            typeof D == 'string' &&
            (D.includes('=>') || D.includes('function'))
          )
        ) {
          if (h[D]) return h[D];
        }
        return h.easeInOutQuad;
      }
      function J(D) {
        return (
          D && typeof D == 'string' && (D = JSON.parse(D)),
          Object.values(D)
        );
      }
      function pe(D, h, m) {
        for (let b = 0; b < m; b++) D = (D + h) / 2;
        return +((D + h) / 2).toFixed(4);
      }
      function Ee(D, h, m, b, S) {
        return {
          value:
            D +
            (m =
              (m +
                (h - D) *
                  (0.05 +
                    0.35 * (1 - Math.max(0, Math.min(1, b != null ? b : 0))))) *
              (0.5 + 0.32 * S)),
          velocity: m,
        };
      }
      document.hidden !== void 0
        ? ((o = 'hidden'), (a = 'visibilitychange'))
        : document.msHidden !== void 0
          ? ((o = 'msHidden'), (a = 'msvisibilitychange'))
          : document.webkitHidden !== void 0 &&
            ((o = 'webkitHidden'), (a = 'webkitvisibilitychange'));
      let Z = null;
      function Ne() {
        return (
          Z === null &&
            (Z =
              /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent,
              )),
          Z
        );
      }
      function Be(D, h) {
        return D.getAttribute(h);
      }
      function ht(D) {
        var h, m, b, S;
        if (D.local.isDynamicCache !== void 0) return D.local.isDynamicCache;
        if (D.isFlattened) {
          let $ =
              D.states &&
              [
                ...D.states.appear,
                ...D.states.scroll,
                ...D.states.hover,
                ...D.states.mousemove,
              ].length > 0,
            le =
              Array.isArray((h = D.data) == null ? void 0 : h.timeUniforms) &&
              D.data.timeUniforms.some((de) => {
                var me;
                return (
                  (de == null ? void 0 : de.animating) !== !1 &&
                  Math.abs(
                    Number(
                      (me = de == null ? void 0 : de.speed) != null ? me : 0,
                    ),
                  ) > 1e-5
                );
              }),
            xe = !!((m = D.data) != null && m.hasMouseTracking),
            fe = !!((b = D.data) != null && b.hasVideoSublayers),
            Se =
              Array.isArray(D.sublayers) &&
              D.sublayers.some(
                (de) =>
                  !!de &&
                  (de.type === 'video' ||
                    ((de.layerType === 'effect' || de.layerType === 'model') &&
                      !!de.animating)),
              ),
            Me = $ || le || xe || fe || Se;
          return ((D.local.isDynamicCache = Me), Me);
        }
        let E = [
            'trackMouse',
            'axisTilt',
            'trackMouseMove',
            'rotationTracking',
            'lightTracking',
          ].some(($) => D.hasOwnProperty($) && D[$] !== 0),
          A =
            D.states &&
            [
              ...D.states.appear,
              ...D.states.scroll,
              ...D.states.hover,
              ...D.states.mousemove,
            ].length > 0,
          F =
            (D.layerType === 'effect' || D.isModel) &&
            (D.animating || D.usesPingPong),
          V = D.type === 'video',
          Y =
            Array.isArray((S = D.data) == null ? void 0 : S.textures) &&
            D.data.textures.some(
              ($) =>
                ($ == null ? void 0 : $.type) === 'video' &&
                ($ == null ? void 0 : $.src),
            ),
          X = E || A || F || V || Y;
        return ((D.local.isDynamicCache = X), X);
      }
      function ot(D, h) {
        var ft, dt, gt, Gt;
        var m, b, S, E;
        if (D.noTextAsHtml || !h) return;
        let A = (function (Ot) {
            if (!Ot || typeof Ot != 'string') return '';
            let P = Ot.trim();
            if (!P || /[\u0000-\u001F\u007F]/.test(P)) return '';
            let T = P.match(/^([a-z][a-z0-9+.-]*):/i);
            if (T) {
              let k = T[1].toLowerCase();
              return ['http', 'https', 'mailto', 'tel'].includes(k) ? P : '';
            }
            return P.startsWith('/') ||
              P.startsWith('#') ||
              P.startsWith('?') ||
              P.startsWith('./') ||
              P.startsWith('../') ||
              P.startsWith('//')
              ? P
              : '';
          })(D.href),
          F = oe(D.leftMode),
          V = oe(D.topMode),
          Y = D.widthMode === 'fixed' ? D.width : D.width * h.offsetWidth,
          X = D.height,
          $ =
            D.fontSizeMode === 'fixed'
              ? D.fontSize
              : D.fontSize * h.offsetWidth,
          le = D.fontSizeMode === 'fixed' ? D.lineHeight : D.lineHeight * $,
          xe =
            D.fontSizeMode === 'fixed' ? D.letterSpacing : D.letterSpacing * $,
          fe = V === 'fixed' ? D.top : D.top * h.offsetHeight,
          Se = F === 'fixed' ? D.left : D.left * h.offsetWidth,
          Me = ue(D.anchorPoint);
        ((Se -= Me.x * Y),
          (fe -= Me.y * X),
          (fe += h.offsetTop),
          (Se += h.offsetLeft));
        let de = document.querySelector(`[data-us-text="${D.local.id}"]`),
          me = A ? 'a' : 'div',
          De = !de;
        (de &&
          de.tagName.toLowerCase() !== me &&
          (de.remove(), (de = null), (De = !0)),
          (de = de || document.createElement(me)));
        let Ge = Array.isArray(D.fill) ? D.fill : [],
          ze = {
            MULTIPLY: 'multiply',
            SCREEN: 'screen',
            OVERLAY: 'overlay',
            DARKEN: 'darken',
            LIGHTEN: 'lighten',
            COLOR_DODGE: 'color-dodge',
            COLOR_BURN: 'color-burn',
            HARD_LIGHT: 'hard-light',
            SOFT_LIGHT: 'soft-light',
            DIFFERENCE: 'difference',
            EXCLUSION: 'exclusion',
          }[
            D.blendMode && D.blendMode !== 0
              ? String(D.blendMode).toUpperCase()
              : 'NORMAL'
          ],
          lt =
            (gt =
              (dt =
                (ft =
                  (b = (m = D.local) == null ? void 0 : m.stateEffectProps) ==
                  null
                    ? void 0
                    : b.opacity) != null
                  ? ft
                  : D.opacity) != null
                ? dt
                : (S = D.data) == null
                  ? void 0
                  : S.elementOpacity) != null
              ? gt
              : 1,
          st = 'color:transparent;';
        (D.htmlOnly && (st = `color:${Ge[0] || '#000000'};`),
          de.setAttribute('data-us-text', D.local.id),
          A
            ? (de.setAttribute('href', A),
              de.setAttribute('target', '_blank'),
              de.setAttribute('rel', 'noopener'))
            : (de.removeAttribute('href'),
              de.removeAttribute('target'),
              de.removeAttribute('rel')),
          (de.style.cssText = `width:${Y}px;top:${fe}px;left:${Se}px;font-size:${$}px;line-height:${le}px;letter-spacing:${xe}px;font-family:${D.fontFamily};font-style:${(E = D.fontStyle) != null && E.includes('italic') ? 'italic' : 'normal'};font-weight:${D.fontWeight};text-align:${D.textAlign};position:absolute;word-break:break-word;white-space:pre-wrap;transform:rotateZ(${Math.round(360 * D.rotation)}deg);opacity:${lt};z-index:${D.htmlOnly ? 100 + ((Gt = D.htmlRenderOrder) != null ? Gt : 0) : 2};display:block;text-decoration:none;pointer-events:${A ? 'auto' : 'none'};cursor:${A ? 'pointer' : 'inherit'};${ze ? `mix-blend-mode:${ze};` : ''}${st}`),
          (de.innerText = D.textContent),
          De && h.appendChild(de));
      }
      function tt() {
        Te.filter((D) => !document.body.contains(D.element)).forEach((D) => {
          D.curtain && D.curtain.dispose();
          let h = Te.indexOf(D);
          h !== -1 && Te.splice(h, 1);
        });
      }
      function ve(D) {
        return (
          D &&
          D.renderer &&
          D.renderer.nextRender &&
          typeof D.renderer.nextRender.execute == 'function'
        );
      }
      function Pe() {
        cancelAnimationFrame(l);
        let D = Te.filter(
            (m) => !m.destroyed && m.getDynamicLayers().length > 0,
          ),
          h = (m) => {
            let b = !1;
            (D.forEach((S) => {
              if (!S.destroyed)
                if (S.isInView && S.initialized) {
                  S.rendering = !0;
                  let E = m - (S.lastTime || 0);
                  ((S.lastTime && !(E >= S.frameDuration)) ||
                    S.paused ||
                    (S.renderFrame(),
                    (S.lastTime = S.lastTime ? m - (E % S.frameDuration) : m)),
                    (b = !0));
                } else S.rendering = !1;
            }),
              (!v || m - v > 64) &&
                (q(), (v = m), (g > 1e3 || (g < 0 && !x && !_)) && _e()),
              b
                ? ((function () {
                    var S, E, A, F;
                    let V = performance.now(),
                      Y = Ne();
                    for (let X = 0; X < Te.length; X++) {
                      let $ = Te[X];
                      if (
                        $.isInView &&
                        be($) &&
                        !(
                          (Y &&
                            (E =
                              (S = $.interactivity) == null
                                ? void 0
                                : S.mouse) != null &&
                            E.disableMobile) ||
                          ((F =
                            (A = $.interactivity) == null ? void 0 : A.mouse) !=
                            null &&
                            F.disabled)
                        )
                      ) {
                        (($.mouse.pos.y = $.mouse.movePos.y),
                          ($.mouse.pos.x = $.mouse.movePos.x),
                          ($.mouse.lastPos.x = $.mouse.pos.x),
                          ($.mouse.lastPos.y = $.mouse.pos.y));
                        let le = $.isFixed
                            ? $.bbox.top
                            : $.bbox.top + $.scrollY,
                          xe = $.bbox.left;
                        $.mouse.page.x > xe &&
                        $.mouse.page.y > le &&
                        $.mouse.page.x < $.lastBbox.width + xe &&
                        $.mouse.page.y < $.lastBbox.height + le
                          ? $.mouse.enterTime || ($.mouse.enterTime = V)
                          : ($.mouse.enterTime = null);
                      }
                    }
                  })(),
                  (l = requestAnimationFrame(h)))
                : cancelAnimationFrame(l));
          };
        D.length ? (l = requestAnimationFrame(h)) : cancelAnimationFrame(l);
      }
      function Ae(D, h, m) {
        return (D == null ? void 0 : D.type) === 'Vec3' &&
          (h == null ? void 0 : h.type) === 'Vec3'
          ? {
              type: 'Vec3',
              x: D._x + (h._x - D._x) * m,
              y: D._y + (h._y - D._y) * m,
              z: D._z + (h._z - D._z) * m,
            }
          : (D == null ? void 0 : D.type) === 'Vec2' &&
              (h == null ? void 0 : h.type) === 'Vec2'
            ? {
                type: 'Vec2',
                x: D._x + (h._x - D._x) * m,
                y: D._y + (h._y - D._y) * m,
              }
            : D + (h - D) * m;
      }
      function Ze(D, h) {
        return (
          D.type === 'Vec2'
            ? (D = new r.Vec2(D._x, D._y))
            : D.type === 'Vec3' && (D = new r.Vec3(D._x, D._y, D._z)),
          D
        );
      }
      function nt(D, h, m) {
        D != null &&
        D.type &&
        ((D == null ? void 0 : D.type) === 'Vec2' ||
          (D == null ? void 0 : D.type) === 'Vec3')
          ? ((h.value.x = D.x),
            m === 'pos' || m.endsWith('_pos')
              ? (h.value.y = 1 - D.y)
              : (h.value.y = D.y),
            D.type === 'Vec3' && (h.value.z = D.z))
          : (h.value = D);
      }
      function Le(D, h, m) {
        var b, S;
        m &&
          (b = D == null ? void 0 : D.target) != null &&
          b.getTexture &&
          m === D.target.getTexture() &&
          (m = null);
        let E =
          (S = D.textures) == null
            ? void 0
            : S.find((A) => A._samplerName === h);
        if (E) {
          if (m && E._copiedFrom !== m) return (E.copy(m), E);
          if (!m && E._copiedFrom) {
            (E._dispose(), (D.textures = D.textures.filter((F) => F !== E)));
            let A = D.createTexture({ sampler: h, premultiplyAlpha: !0 });
            return (
              (function (F) {
                var V;
                (V = F.textures) == null ||
                  V.forEach((Y, X) => {
                    var $;
                    ((Y.index = X),
                      ($ = F._program) != null &&
                        $.compiled &&
                        Y._setTextureUniforms());
                  });
              })(D),
              A
            );
          }
          return E;
        }
        return D.createTexture({
          sampler: h,
          premultiplyAlpha: !0,
          fromTexture: m,
        });
      }
      class At {
        constructor({
          prop: h,
          value: m,
          endValue: b,
          transition: S,
          breakpoints: E,
          uniformData: A,
          loop: F = 'none',
          loopDelay: V = 0,
        }) {
          (t(this, 'id', K()),
            (this.prop = h),
            (this.transition = S),
            (this.complete = !1),
            (this.progress = 0),
            (this.uniformData = A),
            (this.value = Ze(m)),
            (this.endValue = b !== void 0 ? Ze(b || 0) : null),
            (this.lastTick = void 0),
            (this.initialized = !1),
            (this.startTime = null),
            (this.breakpoints = E || []),
            (this.loop = F),
            (this.loopDelay = V),
            (this.easeFunction = ie(this.transition.ease)));
        }
        updateEffect(h, m) {
          var A;
          if ((h = (A = this.endValue) != null ? A : h) === void 0) return !1;
          let b = performance.now(),
            S = b - ((this.startTime || m) + this.transition.delay);
          if (S < 0) return !1;
          if (this.loop !== 'none') {
            let F = this.transition.duration + this.loopDelay,
              V = S % F;
            if (V > this.transition.duration) return !1;
            let Y = V / this.transition.duration,
              X = Math.floor(S / F),
              $ = Y;
            return (
              this.loop === 'reverse' && X % 2 == 1 && ($ = 1 - Y),
              (this.progress = this.easeFunction($)),
              (this.lastTick = b),
              Ae(this.value, h, this.progress)
            );
          }
          let E = Math.max(0, Math.min(1, S / this.transition.duration));
          return (
            (this.progress = this.easeFunction(E)),
            this.progress !== 0 &&
              (E >= 1
                ? ((this.complete = !0), (this.progress = 0), h)
                : ((this.lastTick = b),
                  !this.complete && Ae(this.value, h, this.progress)))
          );
        }
        resetState() {
          ((this.progress = 0),
            (this.complete = !1),
            (this.lastTick = void 0),
            (this.initialized = !1));
        }
      }
      class Ke {
        constructor({
          prop: h,
          value: m,
          range: b,
          offset: S,
          momentum: E,
          spring: A,
          uniformData: F,
          mode: V = 'scrollIntoView',
          delta: Y = 0.01,
          absScrollValue: X = !0,
          breakpoints: $ = [],
        }) {
          (t(this, 'id', K()),
            (this.prop = h),
            (this.progress = 0),
            (this.momentum = E),
            (this.spring = A != null ? A : 0),
            (this._velocity = 0),
            (this.range = b),
            (this.offset = S),
            (this.mode = V),
            (this.delta = Y),
            (this.absScrollValue = X),
            (this.uniformData = F),
            (this.value = Ze(m)),
            (this.lastTick = void 0),
            (this.breakpoints = $ || []));
        }
        updateEffect(h, { top: m, height: b, isFixed: S }) {
          if (h === void 0) return !1;
          if ((S && (m -= _), this.mode === 'scrollIntoView')) {
            let E = m + _ - f * this.offset,
              A = E + (f + b) * this.range,
              F = (_ - E) / (A - E),
              V = Math.max(0, Math.min(1, F));
            if (this.lastTick !== void 0) {
              if (this.spring > 0) {
                let Y = Ee(
                  this.lastTick,
                  V,
                  this._velocity,
                  this.momentum,
                  this.spring,
                );
                ((V = Y.value), (this._velocity = Y.velocity));
              } else V = pe(V, this.lastTick, 2 * this.momentum);
              if (
                Math.abs(this.lastTick - V) < R &&
                Math.abs(this._velocity) < R
              )
                return !1;
            }
            return ((this.lastTick = V), Ae(h, this.value, V));
          }
          if (this.mode === 'whileScrolling') {
            let E = g * this.delta;
            if (
              (this.absScrollValue && (E = Math.abs(E)),
              this.lastTick !== void 0)
            ) {
              if (this.spring > 0) {
                let A = Ee(
                  this.lastTick,
                  E,
                  this._velocity,
                  this.momentum,
                  this.spring,
                );
                ((E = A.value), (this._velocity = A.velocity));
              } else E = pe(E, this.lastTick, 2 * this.momentum);
              if (Math.abs(E) < R && Math.abs(this._velocity) < R) return !1;
            }
            return (
              (this.lastScrollPos = _),
              (this.lastTick = E),
              Ae(h, this.value, E)
            );
          }
          return !1;
        }
        resetState() {
          this.lastTick = void 0;
        }
      }
      class ut {
        constructor({
          prop: h,
          value: m,
          transition: b,
          breakpoints: S,
          uniformData: E,
          triggerOnElement: A,
        }) {
          (t(this, 'id', K()),
            (this.prop = h),
            (this.transition = b),
            (this.progress = 0),
            (this.rawProgress = 0),
            (this.lastProgress = null),
            (this.value = Ze(m)),
            (this.uniformData = E),
            (this.triggerOnElement = A !== void 0 ? A : 1),
            (this.breakpoints = S || []),
            (this.easeFunction = ie(this.transition.ease)));
        }
        updateEffect(h, m, b) {
          var S;
          if (h === void 0) return !1;
          let E =
              (S = b == null ? void 0 : b.getParent) == null
                ? void 0
                : S.call(b),
            A = performance.now();
          if (
            this.triggerOnElement &&
            ((b != null && b.isElement) ||
              (b != null && b.isModel) ||
              (b != null && b.isFlattened) ||
              E)
          ) {
            let le = (E || b).isHovered(this.prop);
            m = le && !this.lastEnterTime ? A : le ? this.lastEnterTime : null;
          }
          let F = m === null,
            V =
              (A - (F ? this.lastTick || A : m + this.transition.delay)) /
              this.transition.duration,
            Y = Math.max(0, Math.min(1, V));
          F
            ? (this.rawProgress = Math.max(0, this.rawProgress - Y))
            : (this.lastEnterTime !== m &&
                (this.lastProgress = this.rawProgress || 0),
              (this.rawProgress = Math.min(1, this.lastProgress + Y)));
          let X = this.easeFunction(this.rawProgress),
            $ = Math.abs(this.progress - X) > R;
          return (
            (this.progress = X),
            !(!m && !$) &&
              (!m &&
                this.transition.forwardsOnly &&
                ((this.progress = 0), (this.rawProgress = 0)),
              (this.lastTick = A),
              (this.lastEnterTime = m),
              !!$ && Ae(h, this.value, this.progress))
          );
        }
        resetState() {
          this.progress = 0;
        }
      }
      class Tt {
        constructor({
          prop: h,
          value: m,
          sensitivity: b,
          momentum: S,
          spring: E,
          delay: A,
          mode: F,
          axisMode: V,
          point: Y,
          breakpoints: X,
          uniformData: $,
        }) {
          (t(this, 'id', K()),
            (this.prop = h),
            (this.progress = 0),
            (this.sensitivity = b != null ? b : 0.5),
            (this.momentum = S != null ? S : 0.25),
            (this.spring = E != null ? E : 0),
            (this._velocity = 0),
            (this.delay = A != null ? A : 0),
            (this.mode = F != null ? F : 'velocity'),
            (this.axisMode = V != null ? V : 'both'),
            (this.point = Y != null ? Y : { x: 0.5, y: 0.5 }),
            (this.value = Ze(m)),
            (this.uniformData = $),
            (this.lastMousePos = null),
            (this.lastMoveTime = null),
            (this.breakpoints = X || []));
        }
        updateEffect(h, m, b) {
          if (h === void 0) return !1;
          let S = performance.now(),
            E = 0;
          if (this.lastMousePos !== null && m) {
            let V = m.x - this.lastMousePos.x,
              Y = m.y - this.lastMousePos.y;
            ((E =
              this.axisMode === 'x'
                ? Math.abs(V)
                : this.axisMode === 'y'
                  ? Math.abs(Y)
                  : Math.sqrt(V * V + Y * Y)),
              E > 1e-4 && (this.lastMoveTime = S));
          }
          m && (this.lastMousePos = { x: m.x, y: m.y });
          let A,
            F = this.progress;
          if (this.mode === 'proximity') {
            if (!m) return !1;
            let V = 0.5 * ((b == null ? void 0 : b.canvasWidth) || 0),
              Y = 0.5 * ((b == null ? void 0 : b.canvasHeight) || 0);
            if (!V || !Y) return !1;
            let X = this.point.x * V,
              $ = this.point.y * Y,
              le = m.x - X,
              xe = m.y - $,
              fe = Math.sqrt(V * V + Y * Y);
            this.axisMode === 'x'
              ? ((xe = 0), (fe = V))
              : this.axisMode === 'y' && ((le = 0), (fe = Y));
            let Se = Math.sqrt(le * le + xe * xe),
              Me = 1 - Math.min(1, Se / fe),
              de = 1 + 4 * this.sensitivity;
            F = Math.pow(Me, de);
          } else
            (this.lastMoveTime ? S - this.lastMoveTime : 1 / 0) > this.delay
              ? (F = 0)
              : E > 0 &&
                (F = Math.min(1, this.progress + E * (this.sensitivity / 500)));
          if (this.spring > 0) {
            let V = Ee(
              this.progress,
              F,
              this._velocity,
              this.momentum,
              this.spring,
            );
            ((A = V.value), (this._velocity = V.velocity));
          } else A = pe(F, this.progress, this.momentum);
          return Math.abs(A - this.progress) < R &&
            Math.abs(this._velocity) < R &&
            Math.abs(A) < R
            ? (this.progress !== 0 &&
                ((this.progress = 0), (this._velocity = 0)),
              Ae(h, this.value, 0))
            : ((this.progress = A), Ae(h, this.value, A));
        }
        resetState() {
          ((this.progress = 0),
            (this._velocity = 0),
            (this.lastMousePos = null),
            (this.lastMoveTime = null));
        }
      }
      class at {
        constructor(h, m, b) {
          var S;
          (t(this, 'local', {
            id: '',
            projectId: '',
            lastMousePos: { x: 0.5, y: 0.5 },
            createdAt: null,
          }),
            (this.initOptions = b),
            (this.aspectRatio = h.aspectRatio || 1),
            (this.layerName = h.layerName || h.publicId || h.id),
            (this.data = h.data || {}),
            (this.userDownsample = h.userDownsample || 1),
            (this.visible = h.visible !== !1),
            (this.breakpoints =
              ((S = h.breakpoints || []).forEach((E) => {
                var A, F;
                for (let V in E.props)
                  ((A = E.props[V]) == null ? void 0 : A.type) === 'Vec2'
                    ? (E.props[V] = new r.Vec2(E.props[V]._x, E.props[V]._y))
                    : ((F = E.props[V]) == null ? void 0 : F.type) === 'Vec3'
                      ? (E.props[V] = new r.Vec3(
                          E.props[V]._x,
                          E.props[V]._y,
                          E.props[V]._z,
                        ))
                      : typeof E.props[V] == 'object' &&
                        (E.props[V] = J(E.props[V]));
              }),
              S)),
            (this.local.sceneId = m),
            (this.id = h.id || K()),
            (this.publicId = h.publicId || this.id),
            (this.hasPublishedPublicId = Object.prototype.hasOwnProperty.call(
              h,
              'publicId',
            )),
            (this.local.id = this.id),
            (this.editorLayerId = h.editorLayerId),
            (this.compiledFragmentShaders = h.compiledFragmentShaders || []),
            (this.compiledVertexShaders = h.compiledVertexShaders || []),
            (this.states = {
              appear:
                h.states && h.states.appear
                  ? h.states.appear.map((E) => new At(E))
                  : [],
              scroll:
                h.states && h.states.scroll
                  ? h.states.scroll.map((E) => new Ke(E))
                  : [],
              hover:
                h.states && h.states.hover
                  ? h.states.hover.map((E) => new ut(E))
                  : [],
              mousemove:
                h.states && h.states.mousemove
                  ? h.states.mousemove.map((E) => new Tt(E))
                  : [],
            }));
        }
        state() {
          return (
            Te.find((h) => h.id === this.local.sceneId) || this.initOptions
          );
        }
        getIndex() {
          return this.state()
            .layers.map((h) => h.local.id)
            .indexOf(this.local.id);
        }
        getPixelRatio() {
          let h = this.state();
          return h.dpi * h.scale * this.userDownsample;
        }
        getPlane() {
          var h, m, b;
          return (b =
            (m = (h = this.state()) == null ? void 0 : h.curtain) == null
              ? void 0
              : m.planes) == null
            ? void 0
            : b.find(
                (S) =>
                  S.type !== 'PingPongPlane' && S.userData.id === this.local.id,
              );
        }
        getPlanes() {
          var h, m, b;
          return (
            ((b =
              (m = (h = this.state()) == null ? void 0 : h.curtain) == null
                ? void 0
                : m.planes) == null
              ? void 0
              : b.filter(
                  (S) =>
                    S.type !== 'PingPongPlane' &&
                    S.userData.id === this.local.id,
                )) || []
          );
        }
        getMaskedItem() {
          return (
            !!this.mask &&
            this.state().layers.filter((h) => !h.parentLayer)[
              this.getIndex() - 1
            ]
          );
        }
        getChildEffectItems() {
          if (this.effects && this.effects.length) {
            let h = this.state();
            if (!h || !h.layers) return [];
            let m = h.layers.filter((b) =>
              this.effects.includes(b.parentLayer),
            );
            return this.effects
              .map((b) => m.find((S) => S.parentLayer === b))
              .filter((b) => b !== void 0);
          }
          return [];
        }
        setVisible(h = !this.visible) {
          var m, b;
          let S = h !== !1;
          return (
            this.visible === S ||
              ((this.visible = S),
              this.invalidatePerformanceCaches(),
              (b =
                (m = this.state()) == null ? void 0 : m.applyLayerVisibility) ==
                null || b.call(m)),
            this
          );
        }
        show() {
          return this.setVisible(!0);
        }
        hide() {
          return this.setVisible(!1);
        }
        setBreakpointValues(h = null) {
          let m = h || d,
            b = this.breakpoints.sort((A, F) => F.min - A.min),
            S = {};
          if (b.length === 1 && b[0].name === 'Desktop') return;
          if (b.length >= 1 && !b.find((A) => A.name === 'Desktop'))
            throw new Error('Malfored breakpoint data, missing Desktop');
          for (let A = b.length - 1; A >= 0; A--) {
            let F = b[A];
            if (F.max === null || m <= F.max)
              for (let V in F.props) S.hasOwnProperty(V) || (S[V] = F.props[V]);
          }
          let E = this.breakpoints.find((A) => A.name === 'Desktop');
          if (E)
            for (let A in E.props) S.hasOwnProperty(A) || (S[A] = E.props[A]);
          for (let A in S)
            if (this.hasOwnProperty(A)) {
              let F = S[A];
              F != null && F.type
                ? ((this[A].x = F._x),
                  (this[A].y = F._y),
                  F._z !== void 0 && (this[A].z = F._z))
                : (this[A] = F);
            }
          this.local.bpProps = S;
        }
        updateStateEffects() {
          var h, m, b, S, E;
          if (
            (!this.states.appear.some((X) => !X.complete) &&
              !((h = this.states) != null && h.scroll.length) &&
              !((m = this.states) != null && m.hover.length) &&
              !((b = this.states) != null && b.mousemove.length)) ||
            (this.isModel && !this.local.modelLoaded)
          )
            return;
          (this.local.uniformUpdatesPool ||
            (this.local.uniformUpdatesPool = {}),
            this.local.updatedProps
              ? this.local.updatedProps.clear()
              : (this.local.updatedProps = new Set()),
            (this.local.hasUpdates = !1));
          let A = this.state() || {},
            F = A.mouse || N,
            V = performance.now();
          (this.local.cachedBreakpoint &&
            this.local.cachedBreakpoint ===
              ((S = A.currentBreakpoint) == null ? void 0 : S.name)) ||
            (this.local.cachedBreakpoint =
              (E = A.currentBreakpoint) == null ? void 0 : E.name);
          let Y = (X) =>
            !X.breakpoints ||
            X.breakpoints.length === 0 ||
            X.breakpoints.find(($) => $ === this.local.cachedBreakpoint);
          (A.isInView &&
            (this.local.createdAt === null && (this.local.createdAt = V),
            this.states.appear
              .filter((X) => !X.complete)
              .forEach((X) => {
                if (!Y(X))
                  return void (
                    this.local.stateEffectProps &&
                    this.local.stateEffectProps[X.prop] &&
                    delete this.local.stateEffectProps[X.prop]
                  );
                let $ = X.startTime || this.local.createdAt;
                if (!X.initialized) {
                  let fe = [
                    ...this.states.appear.filter((Se) => Se.prop === X.prop),
                  ].sort(
                    (Se, Me) =>
                      (Se.transition.delay || 0) - (Me.transition.delay || 0),
                  )[0];
                  ((fe == null ? void 0 : fe.id) === X.id &&
                    ((this.local.uniformUpdatesPool[X.prop] = X.value),
                    (this.local.hasUpdates = !0),
                    this.local.updatedProps.add(X.prop)),
                    (X.initialized = !0),
                    $ || (X.startTime = V));
                }
                A != null &&
                  A.pauseTime &&
                  ($ += Math.abs(A == null ? void 0 : A.pauseTime));
                let le = this.getEventValue
                    ? this.getEventValue(X.prop, this[X.prop])
                    : this[X.prop],
                  xe = X.updateEffect(le, $);
                (xe !== !1 &&
                  ((this.local.uniformUpdatesPool[X.prop] = xe),
                  (this.local.hasUpdates = !0),
                  this.local.updatedProps.add(X.prop)),
                  this.isText &&
                    X.complete &&
                    this.local.stateEffectProps &&
                    this.local.stateEffectProps[X.prop] &&
                    delete this.local.stateEffectProps[X.prop]);
              })),
            this.states.hover.forEach((X) => {
              if (!Y(X))
                return void (
                  this.local.stateEffectProps &&
                  this.local.stateEffectProps[X.prop] &&
                  delete this.local.stateEffectProps[X.prop]
                );
              let $ = this.getEventValue
                  ? this.getEventValue(X.prop, this[X.prop])
                  : this[X.prop],
                le = X.updateEffect($, F.enterTime, this);
              le !== !1 &&
                ((this.local.uniformUpdatesPool[X.prop] = le),
                (this.local.hasUpdates = !0),
                this.local.updatedProps.add(X.prop));
            }),
            this.states.scroll.forEach((X) => {
              var $;
              if (!Y(X))
                return void (
                  this.local.stateEffectProps &&
                  this.local.stateEffectProps[X.prop] &&
                  delete this.local.stateEffectProps[X.prop]
                );
              let le = A.bbox;
              if (!le) return;
              let xe = this.getEventValue
                  ? this.getEventValue(X.prop, this[X.prop])
                  : this[X.prop],
                fe = X.updateEffect(xe, {
                  top: A.isFixed ? 0 : ($ = A.bbox) == null ? void 0 : $.top,
                  height: le.height / 2,
                  isFixed: A.isFixed,
                });
              fe !== !1 &&
                ((this.local.uniformUpdatesPool[X.prop] = fe),
                (this.local.hasUpdates = !0),
                this.local.updatedProps.add(X.prop));
            }),
            this.states.mousemove.forEach((X) => {
              if (!Y(X))
                return void (
                  this.local.stateEffectProps &&
                  this.local.stateEffectProps[X.prop] &&
                  delete this.local.stateEffectProps[X.prop]
                );
              let $ = this.getEventValue
                  ? this.getEventValue(X.prop, this[X.prop])
                  : this[X.prop],
                le = X.updateEffect($, F.movePos, A);
              le !== !1 &&
                ((this.local.uniformUpdatesPool[X.prop] = le),
                (this.local.hasUpdates = !0),
                this.local.updatedProps.add(X.prop));
            }),
            this.local.hasUpdates &&
              (this.getPlanes().forEach((X) => {
                var $;
                for (let le of this.local.updatedProps) {
                  let xe = this.local.uniformUpdatesPool[le];
                  xe !== void 0 &&
                    (($ = X.uniforms[le]) == null ? void 0 : $.lastValue) !==
                      xe &&
                    (X.uniforms[le] && nt(xe, X.uniforms[le], le),
                    this.updateStateEffectProperty(
                      le,
                      this.fromEventValue ? this.fromEventValue(le, xe) : xe,
                    ));
                }
              }),
              this.isText &&
                this.local.stateEffectProps &&
                Object.keys(this.local.stateEffectProps).length &&
                this.render()));
        }
        updateStateEffectProperty(h, m) {
          (this.local.stateEffectProps || (this.local.stateEffectProps = {}),
            (this.local.stateEffectProps[h] = m));
        }
        invalidatePerformanceCaches() {
          ((this.local.isDynamicCache = void 0),
            (this.local.cachedBreakpoint = void 0),
            (this.local.lastCalculatedMousePos = void 0),
            (this.local.lastCalculatedMouseValues = void 0));
        }
        dispose() {
          this.invalidatePerformanceCaches();
        }
      }
      function ue(D) {
        let h = {
          topLeft: { x: 0, y: 0 },
          topCenter: { x: 0.5, y: 0 },
          topRight: { x: 1, y: 0 },
          rightCenter: { x: 1, y: 0.5 },
          bottomRight: { x: 1, y: 1 },
          bottomCenter: { x: 0.5, y: 1 },
          bottomLeft: { x: 0, y: 1 },
          leftCenter: { x: 0, y: 0.5 },
          center: { x: 0.5, y: 0.5 },
        };
        return h[D] ? h[D] : Object.values(h)[D];
      }
      function Rt(D, h, m, b) {
        var xe, fe, Se, Me, de, me, De, Ge, ze, lt;
        let S = (xe = D.left) != null ? xe : 0.5,
          E = (fe = D.top) != null ? fe : 0.5,
          A = oe(D.leftMode) === 'fixed' ? S : S * h,
          F = oe(D.topMode) === 'fixed' ? E : E * m,
          V = U.includes(D.widthMode)
            ? D.widthMode
            : U[(Se = D.widthMode) != null ? Se : 1],
          Y = U.includes(D.heightMode)
            ? D.heightMode
            : U[(Me = D.heightMode) != null ? Me : 1],
          X =
            D.aspectRatio ||
            (D.imageNaturalSize
              ? D.imageNaturalSize._x / D.imageNaturalSize._y
              : 1),
          $,
          le;
        return (
          V === 'auto' && Y === 'auto'
            ? (($ = (de = D.width) != null ? de : 0),
              (le = (me = D.height) != null ? me : 0))
            : (V !== 'auto' &&
                ($ =
                  V === 'fixed'
                    ? (De = D.width) != null
                      ? De
                      : 0
                    : ((Ge = D.width) != null ? Ge : 0) * h),
              (le =
                Y === 'auto'
                  ? $ / (X || 1)
                  : Y === 'fixed'
                    ? (ze = D.height) != null
                      ? ze
                      : 0
                    : ((lt = D.height) != null ? lt : 0) * m),
              V === 'auto' && ($ = le * (X || 1))),
          (function (st, ft, dt, gt, Gt, Ot) {
            let P = ue(Gt != null ? Gt : 'center');
            (dt < 0 && (dt = Math.abs(dt)),
              gt < 0 && ((ft += gt), (gt = Math.abs(gt))));
            let T = st - P.x * dt,
              k = ft - P.y * gt;
            return (
              2 * Ot.x >= T &&
              2 * Ot.x <= T + dt &&
              2 * Ot.y >= k &&
              2 * Ot.y <= k + gt
            );
          })(A, F, $, le, D.anchorPoint, b)
        );
      }
      class ti extends at {
        constructor(h, m) {
          var b, S, E, A, F, V;
          (super(h, m),
            t(this, 'isElement', !0),
            t(this, 'isGpuElement', !1),
            (this.width = h.width || 0),
            (this.height = h.height || 0),
            (this.widthMode = (b = h.widthMode) != null ? b : 'fixed'),
            (this.heightMode = (S = h.heightMode) != null ? S : 'fixed'),
            (this.anchorPoint = (E = h.anchorPoint) != null ? E : 'center'),
            (this.left = h.left || 0),
            (this.top = h.top || 0),
            (this.leftMode = (A = h.leftMode) != null ? A : 'relative'),
            (this.topMode = (F = h.topMode) != null ? F : 'relative'),
            (this.effects = h.effects || []),
            (this.trackMouse = h.trackMouse || 0),
            (this.trackAxes = h.trackAxes || 'xy'),
            (this.axisTilt = h.axisTilt || 0),
            (this.mouseMomentum = h.mouseMomentum || 0),
            (this.mask = h.mask || 0),
            (this.maskDepthLayer = (V = h.maskDepthLayer) != null ? V : 1));
        }
        unpackage() {
          this.effects = J(this.effects);
          for (let h in this)
            this[h] &&
              this[h].type &&
              (this[h].type === 'Vec2'
                ? (this[h] = new r.Vec2(this[h]._x, this[h]._y))
                : this[h].type === 'Vec3' &&
                  (this[h] = new r.Vec3(this[h]._x, this[h]._y, this[h]._z)));
          return this;
        }
        dispose() {
          (this.local.canvas &&
            ((this.local.canvas.width = 1),
            (this.local.canvas.height = 1),
            (this.local.canvas = null)),
            this.local.ctx && (this.local.ctx = null),
            super.dispose());
        }
        box() {
          let h = ue(this.anchorPoint),
            { width: m, height: b } = this.getAbsoluteDimensions(),
            { left: S, top: E } = this.getAbsolutePosition();
          return {
            anchor: { x: S + m * (0.5 - h.x), y: E + b * (0.5 - h.y) },
            center: { x: S + m / 2, y: E + b / 2 },
            left: S,
            top: E,
            width: m,
            height: b,
          };
        }
        getAbsolutePosition() {
          var le, xe;
          var h, m, b, S;
          let E = this.state(),
            A = E.canvasWidth,
            F = E.canvasHeight,
            V =
              (le =
                (m = (h = this.local) == null ? void 0 : h.stateEffectProps) ==
                null
                  ? void 0
                  : m.left) != null
                ? le
                : this.left,
            Y =
              (xe =
                (S = (b = this.local) == null ? void 0 : b.stateEffectProps) ==
                null
                  ? void 0
                  : S.top) != null
                ? xe
                : this.top,
            X = oe(this.leftMode) === 'fixed' ? V : V * A,
            $ = oe(this.topMode) === 'fixed' ? Y : Y * F;
          return (
            (X = +X.toFixed(1)),
            ($ = +$.toFixed(1)),
            { left: X, top: $ }
          );
        }
        getAbsoluteDimensions() {
          var fe, Se;
          var h, m, b, S;
          let E = this.state(),
            A,
            F,
            V = E.canvasWidth,
            Y = E.canvasHeight,
            X =
              (fe =
                (m = (h = this.local) == null ? void 0 : h.stateEffectProps) ==
                null
                  ? void 0
                  : m.width) != null
                ? fe
                : this.width,
            $ =
              (Se =
                (S = (b = this.local) == null ? void 0 : b.stateEffectProps) ==
                null
                  ? void 0
                  : S.height) != null
                ? Se
                : this.height,
            le = U.includes(this.widthMode)
              ? this.widthMode
              : U[this.widthMode],
            xe = U.includes(this.heightMode)
              ? this.heightMode
              : U[this.heightMode];
          return (
            le !== 'auto' &&
              ((A = le === 'fixed' ? X : X * V),
              xe === 'auto' &&
                ((F = A / (this.aspectRatio || 1)),
                (this.height = le === 'fixed' ? F : F / Y))),
            xe !== 'auto' &&
              ((F = this.heightMode === 'fixed' ? $ : $ * Y),
              le === 'auto' &&
                ((A = F * (this.aspectRatio || 1)),
                (this.width = le === 'fixed' ? A : A / V))),
            this.layerType === 'text' && (F = this.height),
            { width: A, height: F }
          );
        }
        isHovered() {
          let h = this.state();
          return Rt(this, h.canvasWidth, h.canvasHeight, h.mouse.movePos);
        }
      }
      class ee extends ti {
        constructor(h, m, b) {
          (super(h, m),
            t(this, 'layerType', 'shape'),
            t(this, 'isElement', !0),
            t(this, 'isGpuElement', !0),
            (this.initOptions = b));
          for (let S in h) this[S] || (this[S] = h[S]);
          this.breakpoints.length && this.setBreakpointValues();
        }
      }
      class xt extends at {
        constructor(h, m, b) {
          var S;
          (super(h, m),
            t(this, 'layerType', 'effect'),
            (this.initOptions = b),
            (this.type = h.type || 'sine'),
            (this.usesPingPong = h.usesPingPong || !1),
            (this.speed = (S = h.speed) != null ? S : 0.5),
            (this.parentLayer = h.parentLayer || !1),
            (this.animating = h.animating || !1),
            (this.isMask = h.isMask || 0),
            (this.texture = h.texture || null),
            (this.mouseMomentum = h.mouseMomentum || 0));
          for (let E in h) this[E] || (this[E] = h[E]);
          this.breakpoints.length && this.setBreakpointValues();
        }
        unpackage() {
          for (let h in this)
            this[h] &&
              this[h].type &&
              (this[h].type === 'Vec2'
                ? (this[h] = new r.Vec2(this[h]._x, this[h]._y))
                : this[h].type === 'Vec3' &&
                  (this[h] = new r.Vec3(this[h]._x, this[h]._y, this[h]._z)));
          return this;
        }
        getParent() {
          return this.state()
            .layers.filter((h) => h.effects && h.effects.length)
            .find((h) => h.effects.includes(this.parentLayer));
        }
      }
      class _t extends at {
        constructor(h, m, b) {
          var V;
          var S, E, A, F;
          (super(h, m),
            t(this, 'layerType', 'flattened'),
            t(this, 'isFlattened', !0),
            (this.initOptions = b),
            (this.sublayers = h.sublayers || []),
            (this.visible = h.visible !== !1),
            (this.consumedMaskId = h.consumedMaskId || null),
            (this.mask = h.mask || 0),
            (this.maskDepthLayer = (V = h.maskDepthLayer) != null ? V : 0),
            (this.maskInvert = h.maskInvert || 0),
            (this.maskDepth = h.maskDepth || 0),
            (this.maskAlpha = h.maskAlpha || 0),
            (this.local.textSublayers = []),
            (this.local.imageSublayers = []),
            (this.local.videoSublayers = []),
            (this.local.modelSublayers = []),
            (this.local.textInstances = {}),
            (this.local.canvasTextures = {}),
            (this.local.sourceTextures = {}),
            (this.local.modelInstances = {}),
            (this.local.modelTextures = {}),
            this.sublayers.forEach((Y, X) => {
              if (Y.layerType === 'text') {
                this.local.textSublayers.push(Y);
                let $ = pt({}, Y),
                  le = Number.isInteger(Y.sublayerIndex) ? Y.sublayerIndex : X;
                this.local.textInstances[le] = new bt($, m, b).unpackage();
              } else if (Y.layerType === 'image')
                this.local.imageSublayers.push(Y);
              else if (Y.type === 'video') this.local.videoSublayers.push(Y);
              else if (Y.layerType === 'model') {
                this.local.modelSublayers.push(Y);
                let $ = Number.isInteger(Y.sublayerIndex) ? Y.sublayerIndex : X;
                this.local.modelInstances[$] = new Ue(Y, m, b);
              }
            }),
            this.states.hover.some((Y) => Y.triggerOnElement) &&
              Object.values(this.local.modelInstances).forEach((Y) => {
                Y.states.hover = [{ triggerOnElement: 1 }];
              }),
            (this.local.remainingEffectItems = []),
            (this.effects = []),
            h.remainingEffects &&
              h.remainingEffects.length > 0 &&
              ((this.local.remainingEffectItems = h.remainingEffects.map((Y) =>
                new xt(Y, m, b).unpackage(),
              )),
              (this.effects = h.remainingEffects
                .map((Y) => Y.parentLayer)
                .filter(Boolean))),
            [
              ...(((S = h.states) == null ? void 0 : S.appear) || []),
              ...(((E = h.states) == null ? void 0 : E.scroll) || []),
              ...(((A = h.states) == null ? void 0 : A.hover) || []),
              ...(((F = h.states) == null ? void 0 : F.mousemove) || []),
            ].forEach((Y) => {
              var me, De;
              var X, $, le, xe;
              if (!Y.prop || this[Y.prop] !== void 0) return;
              let fe,
                Se = Y.originalProp || Y.prop;
              if (Se && Number.isInteger(Y.sublayerIndex)) {
                let Ge = this.sublayers.find(
                  (ze) => ze.sublayerIndex === Y.sublayerIndex,
                );
                Ge && Ge[Se] !== void 0 && (fe = Ge[Se]);
              }
              let Me =
                  (le =
                    ($ = (X = h.data) == null ? void 0 : X.uniforms) == null
                      ? void 0
                      : $[Y.prop]) == null
                    ? void 0
                    : le.value,
                de = (xe = Y.uniformData) == null ? void 0 : xe.value;
              this[Y.prop] =
                (De = (me = fe != null ? fe : Me) != null ? me : de) != null
                  ? De
                  : Y.value;
            }),
            this.breakpoints.length && this.setBreakpointValues());
        }
        getChildEffectItems() {
          return this.local.remainingEffectItems || [];
        }
        hasRemainingEffects() {
          return (
            this.local.remainingEffectItems &&
            this.local.remainingEffectItems.length > 0
          );
        }
        unpackage() {
          var h, m, b;
          for (let S in this)
            this[S] && this[S].type === 'Vec2'
              ? (this[S] = new r.Vec2(this[S]._x, this[S]._y))
              : this[S] &&
                this[S].type === 'Vec3' &&
                (this[S] = new r.Vec3(this[S]._x, this[S]._y, this[S]._z));
          if ((h = this.data) != null && h.uniforms)
            for (let S in this.data.uniforms) {
              let E = this.data.uniforms[S];
              ((m = E == null ? void 0 : E.value) == null ? void 0 : m.type) ===
              'Vec2'
                ? (E.value = new r.Vec2(E.value._x, E.value._y))
                : ((b = E == null ? void 0 : E.value) == null
                    ? void 0
                    : b.type) === 'Vec3' &&
                  (E.value = new r.Vec3(E.value._x, E.value._y, E.value._z));
            }
          return this;
        }
        areTextAssetsReady() {
          return Object.values(this.local.textInstances).every(
            (h) => h.local.loaded,
          );
        }
        areImageAssetsReady() {
          var h;
          return (
            !((h = this.data) != null && h.textures) ||
            this.data.textures
              .filter((m) => m.type === 'image')
              .every((m) => {
                var b;
                return !!(
                  (b = this.local.sourceTextures) != null && b[m.sublayerIndex]
                );
              })
          );
        }
        areModelAssetsReady() {
          var h;
          if (!((h = this.data) != null && h.textures)) return !0;
          let m = this.data.textures.filter((b) => b.type === 'modelRT');
          return (
            !m.length ||
            m.every((b) => {
              var S, E, A, F;
              let V =
                (S = this.local.modelInstances) == null
                  ? void 0
                  : S[b.sublayerIndex];
              return !!(
                (E = V == null ? void 0 : V.local) != null &&
                E.rendererLoaded &&
                (A = V == null ? void 0 : V.local) != null &&
                A.modelLoaded &&
                (F = this.local.modelTextures) != null &&
                F[b.sublayerIndex]
              );
            })
          );
        }
        resize() {
          Object.entries(this.local.textInstances).forEach(([h, m]) => {
            var b, S;
            (m.resize(),
              (S =
                (b = this.local.canvasTextures[h]) == null
                  ? void 0
                  : b.needUpdate) == null || S.call(b));
          });
        }
        isHovered(h) {
          var m;
          if (h) {
            let S = h.match(/^L(\d+)_/);
            if (S) {
              let E = parseInt(S[1], 10),
                A = (m = this.local.modelInstances) == null ? void 0 : m[E];
              return A != null && A.isHovered
                ? A.isHovered()
                : this._isSublayerHovered(E);
            }
          }
          let b = this.local.modelInstances;
          if (
            b &&
            Object.values(b).some((S) => {
              var E;
              return (E = S == null ? void 0 : S.isHovered) == null
                ? void 0
                : E.call(S);
            })
          )
            return !0;
          for (let S of this.sublayers)
            if (
              S.layerType !== 'model' &&
              S.layerType !== 'effect' &&
              this._isSublayerHovered(S.sublayerIndex)
            )
              return !0;
          return !1;
        }
        _isSublayerHovered(h) {
          var m, b;
          let S =
            (m = this.sublayers) == null
              ? void 0
              : m.find((A) => A.sublayerIndex === h);
          if (!S || S.layerType === 'effect') return !1;
          let E = this.state();
          return (
            !!((b = E == null ? void 0 : E.mouse) != null && b.movePos) &&
            Rt(S, E.canvasWidth, E.canvasHeight, E.mouse.movePos)
          );
        }
      }
      class Ut extends ti {
        constructor(h, m, b) {
          (super(h, m),
            t(this, 'layerType', 'image'),
            t(this, 'isElement', !0),
            t(this, 'isGpuElement', !0),
            (this.initOptions = b));
          for (let S in h) this[S] || (this[S] = h[S]);
          this.breakpoints.length && this.setBreakpointValues();
        }
      }
      class Ue extends at {
        constructor(h, m, b) {
          var E,
            A,
            F,
            V,
            Y,
            X,
            $,
            le,
            xe,
            fe,
            Se,
            Me,
            de,
            me,
            De,
            Ge,
            ze,
            lt,
            st,
            ft,
            dt,
            gt;
          var S;
          (super(h, m, b),
            t(this, 'layerType', 'model'),
            t(this, 'isModel', !0),
            t(this, 'contextType', 'webgl'),
            h.moduleRef &&
              (S = b == null ? void 0 : b.modules) != null &&
              S[h.moduleRef] &&
              (this.moduleUrl = b.modules[h.moduleRef].url),
            (this.trackMouse = h.trackMouse !== void 0 ? h.trackMouse : 0),
            (this.mouseMomentum =
              h.mouseMomentum !== void 0 ? h.mouseMomentum : 0),
            (this.mouseSpring = h.mouseSpring !== void 0 ? h.mouseSpring : 0),
            (this.trackAxes = h.trackAxes || 'xy'),
            (this.lightTracking =
              h.lightTracking !== void 0 ? h.lightTracking : 0),
            (this.rotationTracking =
              h.rotationTracking !== void 0 ? h.rotationTracking : 0),
            (this.speed = h.speed !== void 0 ? h.speed : 0.5),
            (this.pos = new r.Vec3(h.pos._x, h.pos._y, h.pos._z)),
            (this.modelUrl = h.modelUrl),
            (this.scale = h.scale),
            (this.modelRotation = new r.Vec3(
              h.modelRotation._x,
              h.modelRotation._y,
              h.modelRotation._z,
            )),
            (this.lightIntensity = h.lightIntensity),
            (this.lightColor = h.lightColor),
            (this.ambientLightColor = h.ambientLightColor),
            (this.fillLightColor = h.fillLightColor),
            (this.ambientLightIntensity =
              (E = h.ambientLightIntensity) != null ? E : 1.5),
            (this.fillLightIntensity =
              (A = h.fillLightIntensity) != null ? A : 1),
            (this.lightPosition = new r.Vec3(
              h.lightPosition._x,
              h.lightPosition._y,
              h.lightPosition._z,
            )),
            (this.materialMetalness = h.materialMetalness),
            (this.materialRoughness = h.materialRoughness),
            (this.refractScale = h.refractScale),
            (this.animationAxis = new r.Vec3(
              h.animationAxis._x,
              h.animationAxis._y,
              h.animationAxis._z,
            )),
            (this.renderNormals = h.renderNormals),
            (this.animating = h.animating),
            (this.opacity = h.opacity),
            (this.colorMapUrl = h.colorMapUrl),
            (this.colorMapScale = (F = h.colorMapScale) != null ? F : 1),
            (this.colorMapPosition = h.colorMapPosition
              ? new r.Vec2(
                  (V = h.colorMapPosition.x) != null ? V : 0.5,
                  (Y = h.colorMapPosition.y) != null ? Y : 0.5,
                )
              : new r.Vec2(0.5, 0.5)),
            (this.colorMapIntensity =
              (X = h.colorMapIntensity) != null ? X : 1),
            (this.quality = h.quality || 'fast'),
            (this.environmentMapIntensity =
              ($ = h.environmentMapIntensity) != null ? $ : 0),
            (this.environmentMapUrl = h.environmentMapUrl || ''),
            (this.normalMapUrl = h.normalMapUrl || ''),
            (this.normalMapScale = (le = h.normalMapScale) != null ? le : 1),
            (this.normalMapPosition = h.normalMapPosition
              ? new r.Vec2(
                  (xe = h.normalMapPosition.x) != null ? xe : 0.5,
                  (fe = h.normalMapPosition.y) != null ? fe : 0.5,
                )
              : new r.Vec2(0.5, 0.5)),
            (this.normalMapIntensity =
              (Se = h.normalMapIntensity) != null ? Se : 1),
            (this.extrudeDepth = (Me = h.extrudeDepth) != null ? Me : 10),
            (this.bevelEnabled = (de = h.bevelEnabled) != null ? de : !1),
            (this.bevelThickness = (me = h.bevelThickness) != null ? me : 1),
            (this.bevelSize = (De = h.bevelSize) != null ? De : 1),
            (this.bevelSegments = (Ge = h.bevelSegments) != null ? Ge : 2),
            (this.glassIOR = (ze = h.glassIOR) != null ? ze : 1.5),
            (this.glassThickness = (lt = h.glassThickness) != null ? lt : 0.5),
            (this.glassRoughness = (st = h.glassRoughness) != null ? st : 0),
            (this.glassTint = h.glassTint || '#ffffff'),
            (this.glassDispersion = (ft = h.glassDispersion) != null ? ft : 0),
            (this.materialMode =
              h.materialMode || (h.renderNormals ? 'glass' : 'standard')),
            (this.matcapUrl =
              h.matcapUrl ||
              'https://assets.unicorn.studio/media/matcaps/unicorn_matcap_default.webp'),
            (this.matcapIntensity =
              (dt = h.matcapIntensity) != null ? dt : 0.5),
            (this.matcapRotation = (gt = h.matcapRotation) != null ? gt : 0),
            (this.renderNormals =
              this.materialMode === 'glass' || this.renderNormals ? 1 : 0),
            this.breakpoints.length && this.setBreakpointValues());
        }
        unpackage() {
          return (
            (this.pos = new r.Vec3(this.pos._x, this.pos._y, this.pos._z)),
            (this.modelRotation = new r.Vec3(
              this.modelRotation._x,
              this.modelRotation._y,
              this.modelRotation._z,
            )),
            (this.lightPosition = new r.Vec3(
              this.lightPosition._x,
              this.lightPosition._y,
              this.lightPosition._z,
            )),
            (this.animationAxis = new r.Vec3(
              this.animationAxis._x,
              this.animationAxis._y,
              this.animationAxis._z,
            )),
            this
          );
        }
        loadRenderer() {
          return Ns(this, null, function* () {
            let h = this.state();
            if (!h.curtain || !h.curtain.renderer || !h.curtain.renderer.gl)
              return;
            let m =
              this.moduleUrl ||
              `https://cdn.jsdelivr.net/gh/hiunicornstudio/unicornstudio.js@v${I}/extensions/model-renderer.js`;
            try {
              let b = yield import(m);
              ((this.local.initialize = b.initialize),
                (this.local.loadModel = b.loadModel),
                (this.local.draw = b.draw),
                (this.local.dispose = b.dispose),
                (this.local.rendererLoaded = !0),
                requestAnimationFrame(() => {
                  var S;
                  let E = h.curtain.renderer.gl;
                  (this.local.renderTarget &&
                    !this.local.renderTarget._frameBuffer &&
                    this.local.renderTarget._initRenderTarget(),
                    E.pixelStorei(E.UNPACK_FLIP_Y_WEBGL, !1),
                    E.pixelStorei(E.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1),
                    this.local.initialize(E, this),
                    (this.local.initialized = !0),
                    this.local.loadModel(this));
                  let A = (S = h.curtain) == null ? void 0 : S.renderer;
                  A &&
                    ((A.state.flipY = null), (A.state.premultiplyAlpha = null));
                }));
            } catch (b) {}
          });
        }
        handleModelLoaded() {
          var h, m, b;
          if (((this.local.modelLoaded = !0), this.local.renderTarget)) {
            let S = this.local.renderTarget.getTexture(),
              E =
                this.getPlane() ||
                ((m =
                  (h = this.local.hostLayer) == null ? void 0 : h.getPlane) ==
                null
                  ? void 0
                  : m.call(h)),
              A = this.local.targetSamplerName || 'uTexture',
              F =
                (b = E == null ? void 0 : E.textures) == null
                  ? void 0
                  : b.find((V) => V._samplerName === A);
            F && S && F.copy(S);
          }
          this.animating ||
            (this.renderModel(), (this.local.renderedOnce = !0));
        }
        renderModel() {
          var xe, fe;
          var h, m, b, S, E, A, F, V;
          if (!this.local.rendererLoaded || !this.local.modelLoaded) return;
          let Y = this.state();
          if (
            !Y ||
            Y.destroyed ||
            !Y.curtain ||
            !Y.curtain.renderer ||
            !Y.curtain.renderer.gl
          )
            return;
          let X = Y.curtain.renderer.gl;
          if (X.drawingBufferWidth === 0 || X.drawingBufferHeight === 0) return;
          if (this.animating) {
            this.local.time === void 0 && (this.local.time = 0);
            let Se =
                (fe =
                  (xe =
                    (h = this.local.stateEffectProps) == null
                      ? void 0
                      : h.speed) != null
                    ? xe
                    : this.speed) != null
                  ? fe
                  : 0.5,
              Me = Y.fps ? 60 / Y.fps : 1;
            this.local.time += Se * Me * 60;
          }
          let $ =
            this.materialMode || (this.renderNormals ? 'glass' : 'standard');
          if (this.environmentMapIntensity > 0) {
            let Se =
              this.getPlane() ||
              ((b = (m = this.local.hostLayer) == null ? void 0 : m.getPlane) ==
              null
                ? void 0
                : b.call(m));
            if (Se && !((S = this.environmentMapUrl) != null && S.trim())) {
              let Me = Se.textures.find(
                (de) => de._samplerName === 'uBgTexture',
              );
              Me != null && Me._copiedFrom && Me._sampler
                ? (this.local.envTexture = {
                    gl: X,
                    webglTexture: Me._sampler.texture,
                    width: Me._size.width,
                    height: Me._size.height,
                  })
                : (this.local.envTexture = null);
            } else
              ((E = this.environmentMapUrl) != null && E.trim()) ||
                (this.local.envTexture = null);
          } else this.local.envTexture = null;
          if ($ === 'glass') {
            let Se =
              this.getPlane() ||
              ((F = (A = this.local.hostLayer) == null ? void 0 : A.getPlane) ==
              null
                ? void 0
                : F.call(A));
            if (Se) {
              let Me = Se.textures.find(
                (de) => de._samplerName === 'uBgTexture',
              );
              Me != null && Me._copiedFrom && Me._sampler && Me._sampler.texture
                ? (this.local.backgroundTexture = {
                    gl: X,
                    webglTexture: Me._sampler.texture,
                    width: Me._size.width,
                    height: Me._size.height,
                  })
                : (this.local.backgroundTexture = null);
            } else this.local.backgroundTexture = null;
          } else this.local.backgroundTexture = null;
          let le =
            this.local.time !== void 0 ? this.local.time : performance.now();
          if (this.local.renderTarget)
            if (this.local.renderTarget._frameBuffer) {
              let Se = this.local.renderTarget._frameBuffer,
                Me = this.local.renderTarget._size.width,
                de = this.local.renderTarget._size.height;
              (X.pixelStorei(X.UNPACK_FLIP_Y_WEBGL, !1),
                X.pixelStorei(X.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1),
                X.bindFramebuffer(X.FRAMEBUFFER, Se),
                X.viewport(0, 0, Me, de));
              try {
                this.local.draw(X, le, this);
              } finally {
                (X.bindFramebuffer(X.FRAMEBUFFER, null),
                  X.viewport(0, 0, X.drawingBufferWidth, X.drawingBufferHeight),
                  X.pixelStorei(X.UNPACK_FLIP_Y_WEBGL, !0),
                  X.pixelStorei(X.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0));
                let me = (V = Y.curtain) == null ? void 0 : V.renderer;
                me &&
                  (me.setBlendFunc(),
                  (me.state.currentProgramID = null),
                  (me.state.currentGeometryID = null),
                  (me.state.forceBufferUpdate = !0),
                  (me.state.frameBufferID = null),
                  (me.state.activeTexture = null),
                  (me.state.depthTest = null),
                  (me.state.cullFace = null),
                  (me.state.flipY = null),
                  (me.state.premultiplyAlpha = null));
              }
            } else
              (this.local.draw(X, le, this),
                X.pixelStorei(X.UNPACK_FLIP_Y_WEBGL, !0));
        }
        resize() {
          var h;
          let m = this.state();
          if (
            !(m != null && m.resizeRenderTarget) ||
            !this.local.renderTarget ||
            !((h = m.curtain) != null && h.canvas)
          )
            return;
          let b = this.getPlane(),
            S = this.userDownsample || 1;
          b != null &&
            b.userData &&
            b.userData.downSample !== void 0 &&
            (S =
              typeof b.userData.downSample == 'number'
                ? b.userData.downSample
                : 1);
          let E = m.curtain.canvas.width * S,
            A = m.curtain.canvas.height * S;
          m.resizeRenderTarget(this.local.renderTarget, E, A);
        }
        cleanup() {
          var h;
          if (
            (this.local.dispose && this.local.dispose(this),
            (this.local.initialize = null),
            (this.local.loadModel = null),
            (this.local.draw = null),
            (this.local.dispose = null),
            (this.local.rendererLoaded = !1),
            (this.local.initialized = !1),
            (this.local.modelLoaded = !1),
            this.local.renderTarget)
          ) {
            this.local.renderTarget.remove();
            let m = this.getPlane();
            (m && ((h = m.removeRenderTarget) == null || h.call(m)),
              (this.local.renderTarget = null));
          }
        }
        isAnimating() {
          return (
            this.visible &&
            (this.animating ||
              this.trackMouse > 0 ||
              this.rotationTracking > 0 ||
              this.lightTracking > 0)
          );
        }
        getProp(h) {
          var b;
          var m;
          return (b =
            (m = this.local.stateEffectProps) == null ? void 0 : m[h]) != null
            ? b
            : this[h];
        }
        isAnimatableLightColorProp(h) {
          return M.includes(h);
        }
        getEventValue(h, m = this[h]) {
          var S, E, A;
          if (!this.isAnimatableLightColorProp(h) || m == null) return m;
          if ((m == null ? void 0 : m.type) === 'Vec3')
            return m instanceof r.Vec3
              ? m.clone()
              : new r.Vec3(
                  (S = m.x) != null ? S : m._x,
                  (E = m.y) != null ? E : m._y,
                  (A = m.z) != null ? A : m._z,
                );
          let b = (function (F) {
            if (!F || typeof F != 'string') return null;
            (F.length === 9
              ? (F = F.substring(0, 7))
              : F.length === 8 && F[0] !== '#' && (F = '#' + F.substring(0, 6)),
              (F = F.replace(
                /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
                function (Y, X, $, le) {
                  return X + X + $ + $ + le + le;
                },
              )));
            let V = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(F);
            return V
              ? [parseInt(V[1], 16), parseInt(V[2], 16), parseInt(V[3], 16)]
              : null;
          })(m);
          return b ? new r.Vec3(...b.map((F) => F / 255)) : m;
        }
        fromEventValue(h, m) {
          var b, S, E, A, F, V;
          return !this.isAnimatableLightColorProp(h) ||
            m == null ||
            typeof m == 'string'
            ? m
            : (m == null ? void 0 : m.type) === 'Vec3'
              ? (function (Y, X, $) {
                  return (
                    '#' +
                    ((1 << 24) + (Y << 16) + (X << 8) + $).toString(16).slice(1)
                  );
                })(
                  ...[
                    (S = (b = m.x) != null ? b : m._x) != null ? S : 0,
                    (A = (E = m.y) != null ? E : m._y) != null ? A : 0,
                    (V = (F = m.z) != null ? F : m._z) != null ? V : 0,
                  ].map((Y) => Math.max(0, Math.min(255, Math.round(255 * Y)))),
                )
              : m;
        }
        isHovered() {
          if (!this.local.boundingBox) return !1;
          let h = this.state(),
            m = h.canvasWidth,
            b = h.canvasHeight,
            S = this.local.boundingBox.min,
            E = this.local.boundingBox.max,
            A = S.x * m,
            F = S.y * b,
            V = E.x * m,
            Y = E.y * b,
            X = h.mouse.movePos;
          return 2 * X.x >= A && 2 * X.x <= V && 2 * X.y >= F && 2 * X.y <= Y;
        }
        dispose() {
          (this.cleanup(), super.dispose());
        }
      }
      class bt extends ti {
        constructor(h, m, b) {
          var E;
          (super(h, m),
            t(this, 'layerType', 'text'),
            t(this, 'isText', !0),
            (this.initOptions = b),
            (this.opacity = (E = h.opacity) != null ? E : 1),
            (this.displace = h.displace || 0),
            (this.bgDisplace = h.bgDisplace || 0),
            (this.dispersion = h.dispersion || 0),
            (this.rotation = h.rotation || 0),
            (this.blendMode = h.blendMode || 'NORMAL'));
          let S = this.default(h || {});
          for (let A in S) this[A] = S[A];
          (this.breakpoints.length && this.setBreakpointValues(),
            (this.isSafari = /^((?!chrome|android).)*safari/i.test(
              navigator.userAgent,
            )),
            Object.keys(h).length && this.createLocalCanvas(),
            this.loadFont());
        }
        createLocalCanvas() {
          let h = this.state(),
            m = document.createElement('canvas'),
            b = this.getPixelRatio();
          ((m.width = h.canvasWidth * b), (m.height = h.canvasHeight * b));
          let S = m.getContext('2d');
          (S.scale(b, b), (this.local.canvas = m), (this.local.ctx = S));
        }
        resize() {
          var h, m, b;
          let S = this.state();
          if (this.local.canvas) {
            let A = this.getPixelRatio();
            ((this.local.canvas.width = S.canvasWidth * A),
              (this.local.canvas.height = S.canvasHeight * A),
              this.local.ctx.scale(A, A));
          }
          let E = (h = S.currentBreakpoint) == null ? void 0 : h.name;
          (((b = (m = this.states) == null ? void 0 : m.appear) != null &&
            b.some(
              (A) =>
                !A.complete &&
                (!A.breakpoints ||
                  A.breakpoints.length === 0 ||
                  A.breakpoints.includes(E)),
            )) ||
            this.render(),
            ot(this, this.state().element));
        }
        default(h) {
          var m, b, S;
          return {
            fill: h.fill || ['#ffffff'],
            fontSize: (m = h.fontSize) != null ? m : 24,
            fontSizeMode: h.fontSizeMode || 'fixed',
            fontCSS: h.fontCSS || null,
            lineHeight: (b = h.lineHeight) != null ? b : 25,
            letterSpacing: h.letterSpacing || 0,
            fontFamily: h.fontFamily || 'arial',
            fontStyle: h.fontStyle || 'normal',
            fontWeight: h.fontWeight || 'normal',
            textAlign: h.textAlign || 'left',
            textContent: h.textContent || '',
            href: h.href || '',
            gradientAngle: h.gradientAngle || h.gradAngle || 0,
            gradientType: h.gradientType || h.gradType || 'linear',
            noTextAsHtml: h.noTextAsHtml || !1,
            htmlOnly: h.htmlOnly || !1,
            htmlRenderOrder: (S = h.htmlRenderOrder) != null ? S : 0,
          };
        }
        unpackage() {
          return ((this.fill = J(this.fill)), this);
        }
        loadFont() {
          var h;
          let m = this.fontStyle.includes('italic') ? 'italic' : 'normal',
            b = (F) =>
              F === 'normal' || F === '400' || F === 400
                ? 'normal'
                : F.toString(),
            S = isNaN(parseInt(this.fontWeight))
              ? 'normal'
              : b(this.fontWeight);
          if (
            Array.from(document.fonts).some(
              (F) =>
                F.family === this.fontFamily &&
                F.style === m &&
                b(F.weight) === S &&
                F.status === 'loaded',
            ) ||
            !((h = this.fontCSS) != null && h.src)
          )
            return void this.handleFontLoaded();
          let E = this.fontCSS.src.split(' ').join('%20'),
            A = new FontFace(this.fontFamily, `url(${E})`, {
              style: m,
              weight: S,
            });
          (document.fonts.add(A),
            A.load()
              .then(() => {
                this.handleFontLoaded();
              })
              .catch((F) => {
                this.handleFontLoaded();
              }));
        }
        handleFontLoaded() {
          ((this.local.loaded = !0), this.render(), this.render());
          let h = this.state();
          (h.renderFrame && h.renderFrame(), ot(this, this.state().element));
        }
        getAbsoluteFontValues(h) {
          var m, b, S, E, A, F;
          let V =
              ((b = (m = this.local) == null ? void 0 : m.stateEffectProps) ==
              null
                ? void 0
                : b.fontSize) || this.fontSize,
            Y =
              ((E = (S = this.local) == null ? void 0 : S.stateEffectProps) ==
              null
                ? void 0
                : E.lineHeight) || this.lineHeight,
            X =
              ((F = (A = this.local) == null ? void 0 : A.stateEffectProps) ==
              null
                ? void 0
                : F.letterSpacing) || this.letterSpacing,
            $ = this.fontSizeMode === 'fixed' ? V : V * h.canvasWidth;
          return {
            fontSize: $,
            lineHeight: this.fontSizeMode === 'fixed' ? Y : Y * $,
            letterSpacing: this.fontSizeMode === 'fixed' ? X : X * $,
          };
        }
        render() {
          var Gt;
          var h, m, b;
          if (!((h = this.local) != null && h.ctx)) return;
          let S = this.local.ctx,
            { left: E, top: A, width: F } = this.box(),
            V = ue(this.anchorPoint),
            Y =
              ((Gt =
                (b = (m = this.local) == null ? void 0 : m.stateEffectProps) ==
                null
                  ? void 0
                  : b.rotation) != null
                ? Gt
                : this.rotation) || 0,
            X = this.state(),
            $ = this.height,
            le = E - V.x * F,
            xe = A - V.y * $,
            fe = 0,
            {
              fontSize: Se,
              lineHeight: Me,
              letterSpacing: de,
            } = this.getAbsoluteFontValues(X),
            me = this.fontStyle.includes('italic') ? 'italic' : 'normal',
            De = /^\d+$/.test(this.fontStyle) ? this.fontStyle : '400';
          (S.clearRect(0, 0, X.canvasWidth, X.canvasHeight),
            (S.font = `${me} ${De} ${Se}px/${Me}px ${this.fontFamily}, -apple-system, BlinkMacSystemFont, Helvetica, Arial`),
            this.isSafari ||
              ((S.textAlign = this.textAlign), (S.letterSpacing = de + 'px')));
          let Ge = S.measureText('m').width;
          ((F = Math.max(F, Ge)), S.save());
          let ze = le + F / 2,
            lt = xe + $ / 2;
          (S.translate(ze, lt),
            S.rotate((360 * Y * Math.PI) / 180),
            S.translate(-ze, -lt),
            this.textAlign === 'center' && (le += F / 2),
            this.textAlign === 'right' && (le += F),
            (S.fillStyle = this.fill[0]));
          let st = (Ot, P) => {
              let T = xe + Me * P + Me / 2 + Se / 3;
              this.isSafari
                ? ((k, G, B, ae, ne, Q, ce) => {
                    let he,
                      He = G.split('').reduce(
                        (qe, Xe, Mt) =>
                          qe +
                          k.measureText(Xe).width +
                          (Mt < G.length - 1 ? ne : 0),
                        0,
                      );
                    if (
                      ((he = Q === 'center' ? B + (ce - He) / 2 - ce / 2 : B),
                      Q === 'right')
                    )
                      for (let qe = G.length - 1; qe >= 0; qe--) {
                        let Xe = G[qe];
                        ((he -= k.measureText(Xe).width),
                          k.fillText(Xe, he, ae),
                          qe > 0 && (he -= ne));
                      }
                    else
                      for (let qe = 0; qe < G.length; qe++)
                        (k.fillText(G[qe], he, ae),
                          (he += k.measureText(G[qe]).width + ne));
                  })(S, Ot, le, T, de, this.textAlign, F)
                : S.fillText(Ot, le, T);
            },
            ft = this.textContent
              ? this.textContent.split(`
`)
              : [''],
            dt = ft.length,
            gt = (Ot, P, T) =>
              P.split('').reduce(
                (k, G, B) => (
                  (k += Ot.measureText(G).width),
                  B < P.length - 1 && (k += T),
                  k
                ),
                0,
              );
          for (let Ot = 0; Ot < dt; Ot++) {
            let P = '',
              T = ft[Ot].split(/(\s|\n)/);
            for (let k = 0; k < T.length; k++) {
              let G = T[k],
                B = P + G;
              if (
                (this.isSafari && de ? gt(S, B, de) : S.measureText(B).width) >
                  F ||
                G ===
                  `
`
              ) {
                if (P !== '')
                  ((ft[Ot] = P.trim()),
                    k !== T.length - 1
                      ? (ft.splice(Ot + 1, 0, T.slice(k).join('')), dt++)
                      : G !==
                          `
` && ft.push(G));
                else {
                  let ae = G,
                    ne = Ot;
                  for (; ae.length > 0; ) {
                    let Q = '';
                    for (
                      let ce = 0;
                      ce < ae.length &&
                      (S.measureText(Q + ae[ce]).width <= F || ce == 0);
                      ce++
                    )
                      Q += ae[ce];
                    ((ae = ae.slice(Q.length)),
                      (ft[ne] = Q.trim()),
                      ae.length > 0 && (ft.splice(ne + 1, 0, ae), ne++, dt++));
                  }
                  T.slice(k + 1).length > 0 &&
                    (ft[ne] += T.slice(k + 1).join(''));
                }
                break;
              }
              ((P = B), k === T.length - 1 && (ft[Ot] = P.trim()));
            }
          }
          (ft.forEach((Ot, P) => {
            (st(Ot, fe), P < ft.length - 1 && fe++);
          }),
            S.translate(-(le + F / 2), -(xe + $ / 2)),
            S.restore(),
            (this.height = Me * fe + Me));
        }
      }
      function H() {
        let D = performance.now();
        document[o]
          ? (cancelAnimationFrame(l),
            Te.forEach((h) => {
              h.pauseTime = D;
            }))
          : (Pe(),
            Te.forEach((h) => {
              ((h.pauseTime = h.pauseTime - D),
                h.curtain.planes.forEach((m) => {
                  m.videos.forEach((b) => {
                    b.play();
                  });
                }));
            }));
      }
      function C() {
        ((f = window.innerHeight || document.documentElement.clientHeight),
          (d = window.innerWidth || document.documentElement.clientWidth),
          Te.filter((D) => D.initialized).forEach((D) => {
            D.refresh();
          }),
          _e());
      }
      function se(D, h, m = 50) {
        let b = h || D.getBoundingClientRect(),
          S =
            (b.top >= -m && b.top <= f + m) ||
            (b.bottom >= -m && b.bottom <= f + m) ||
            (b.top <= 0 && b.bottom >= f),
          E =
            (b.left >= -m && b.left <= d + m) ||
            (b.right >= -m && b.right <= d + m) ||
            (b.left <= 0 && b.right >= d);
        return S && E;
      }
      function _e() {
        Te.filter((D) => D.getDynamicLayers().length).forEach((D) => {
          let h = D.element.getBoundingClientRect();
          ((D.scrollY = _),
            D.lastBbox &&
              (Math.abs(h.top - D.lastBbox.top) === 0 && g > 0
                ? ((D.fixedCounter = (D.fixedCounter || 0) + 1),
                  D.fixedCounter > 3 && (D.isFixed = !0))
                : (D.fixedCounter = 0)),
            (D.lastBbox = D.bbox),
            (D.bbox = h));
        });
      }
      function we() {
        let D = performance.now();
        Te.filter((h) => h.getDynamicLayers().length).forEach((h) => {
          if (se(h.element, h.bbox, 100)) {
            if (!h.isInView) {
              ((h.isInView = !0), (h.pauseTime = h.pauseTime - D));
              let m = h.element.offsetWidth > 0 && h.element.offsetHeight > 0;
              (m && h.curtain
                ? h.resize()
                : m ||
                  requestAnimationFrame(() => {
                    h.element.offsetWidth > 0 &&
                      h.element.offsetHeight > 0 &&
                      h.curtain &&
                      h.resize();
                  }),
                !h.lazyLoad ||
                  h.initialized ||
                  h.initializing ||
                  h.initializePlanes());
            }
          } else h.isInView && ((h.isInView = !1), (h.pauseTime = D));
        });
      }
      function Oe() {
        (q(), _e(), we());
        let D = Te.filter((m) => m.getDynamicLayers().length),
          h = Te.filter((m) => m.rendering);
        D.length && !h.length && Pe();
      }
      function Re() {
        let D = Te.filter((b) => b.getDynamicLayers().length),
          h = Te.filter((b) => b.rendering);
        D.length && !h.length && Pe();
        let m = performance.now();
        ((!w || m - w > 80) && (_e(), (w = m)),
          clearTimeout(L),
          (L = setTimeout(Oe, 80)),
          we());
      }
      function ge() {
        (q(), Re());
      }
      function be(D) {
        var h;
        if (D._hasMousePos) return !0;
        if (!((h = D.curtain) != null && h.planes)) return !1;
        let m = D.curtain.planes.find((b) => b.uniforms.mousePos);
        return (m && (D._hasMousePos = !0), !!m);
      }
      function ke(D) {
        for (let h = 0; h < Te.length; h++) {
          let m = Te[h];
          m.isInView &&
            ((m.mouse.page.x = 99999999999),
            (m.mouse.page.y = 99999999999),
            (m.mouse.enterTime = null));
        }
      }
      function Ve(D) {
        let h = performance.now();
        for (let m = 0; m < Te.length; m++) {
          let b = Te[m];
          if (!b.isInView || !b.initialized) continue;
          let S,
            E,
            A = b.bbox;
          (Math.abs(g) > 1 &&
            h - b.lastBboxTime > 64 &&
            ((A = b.element.getBoundingClientRect()),
            (b.lastBbox = b.bbox),
            (b.bbox = A),
            (b.scrollY = _),
            (b.lastBboxTime = h)),
            D.targetTouches
              ? ((S = D.targetTouches[0].pageX), (E = D.targetTouches[0].pageY))
              : ((S = D.pageX), (E = D.pageY)),
            b.isFixed &&
              ((b.scrollY = 0),
              (E = D.targetTouches ? D.targetTouches[0].clientY : D.clientY)));
          let F = S - A.left,
            V = E - (A.top + (b.isFixed ? 0 : b.scrollY));
          ((b.mouse.page.x = S),
            (b.mouse.page.y = E),
            (b.mouse.movePos.x = 0.5 * F),
            (b.mouse.movePos.y = 0.5 * V),
            (b.mouse.movedInView = !0));
        }
      }
      let Te = [];
      class Ie {
        constructor(h) {
          (t(this, 'local', {}),
            t(this, 'scrollY', 0),
            t(this, 'paused', !1),
            t(this, 'destroyed', !1),
            t(this, 'lastBboxTime', 0),
            (this.id = h.id));
          let m = [
            { name: 'Desktop', max: 1 / 0, min: 992 },
            { name: 'Tablet', max: 991, min: 576 },
            { name: 'Mobile', max: 575, min: 0 },
          ];
          if (h.breakpoints)
            for (let b of h.breakpoints) {
              let S = m.find((E) => E.name === b.name);
              S &&
                (b.min !== void 0 && (S.min = b.min),
                b.max !== void 0 && (S.max = b.max));
            }
          ((this.breakpoints = m),
            (this.projectId = h.projectId),
            (this.canvasWidth = h.width || h.element.offsetWidth || d),
            (this.canvasHeight = h.height || h.element.offsetHeight || f),
            (this.curtain = void 0),
            (this.curtainRafId = void 0),
            (this.dpi = +h.dpi || Math.min(1.5, window.devicePixelRatio)),
            (this.element = h.element),
            (this.fps = h.fps || 60),
            (this.name = h.name),
            (this.frameDuration = 1e3 / (h.fps || 60)),
            (this.layers = h.layers),
            (this.lazyLoad = h.lazyLoad),
            (this.initialized = !1),
            (this.lasTick = null),
            (this.lastTime = 0),
            (this.rendering = !1),
            (this.bbox = {}),
            (this.isFixed =
              h.fixed ||
              window.getComputedStyle(this.element).position === 'fixed'),
            (this.interactivity = {
              mouse: { disableMobile: !1, disabled: !1 },
            }),
            (this.mouse = {
              downPos: { x: 0.5, y: 0.5 },
              movePos: { x: 0.5, y: 0.5 },
              lastPos: { x: 0.5, y: 0.5 },
              delta: { x: 0, y: 0 },
              page: { x: 99999999999, y: 99999999999 },
              dragging: !1,
              movedInView: !1,
              enterTime: null,
              ticks: 0,
              pos: { x: 0, y: 0 },
            }),
            (this.renderingScale = h.renderingScale || 1),
            (this.scale = h.scale || 1),
            (this.split = !1),
            (this.versionId = ''),
            h.width &&
              h.height &&
              ((this.element.style.width = h.width + 'px'),
              (this.element.style.height = h.height + 'px')),
            (this.bbox = this.element.getBoundingClientRect()),
            (this.lastBbox = this.bbox),
            (this.currentBreakpoint = this.breakpoints.find(
              (b) => d >= b.min && d <= b.max,
            )),
            this.createCurtains(),
            this.setCanvasScale(),
            ve(this.curtain) &&
              this.curtain.gl &&
              (this.textureLoader = new r.TextureLoader(this.curtain)));
        }
        hasValidTextureLoader() {
          var h;
          return !(
            !this.textureLoader ||
            (!((h = this.textureLoader.renderer) != null && h.cache) &&
              !this.textureLoader.cache)
          );
        }
        preloadImage(h, m, b, S = !0) {
          if (!h) return;
          if (!this.hasValidTextureLoader()) return void (b && b(null));
          this.local.preloadedImages = this.local.preloadedImages || {};
          let E = this.local.preloadedImages[h];
          if (
            (E ||
              ((E = this.local.preloadedImages[h] =
                { texture: null, loading: !0, claimed: !1, queue: [] }),
              this.textureLoader.loadImage(
                h,
                { sampler: m, premultipliedAlpha: S },
                (F) => {
                  ((E.texture = F), (E.loading = !1));
                  for (let V of E.queue) this._resolvePreloadedImage(h, V);
                  E.queue = [];
                },
                () => {
                  ((E.loading = !1),
                    E.queue.forEach((F) => F.callback(null)),
                    (E.queue = []));
                },
              )),
            !b)
          )
            return;
          let A = { callback: b, sampler: m, premultiplyAlpha: S };
          E.loading ? E.queue.push(A) : this._resolvePreloadedImage(h, A);
        }
        _resolvePreloadedImage(h, m) {
          if (!this.hasValidTextureLoader()) return void m.callback(null);
          let b = this.local.preloadedImages[h];
          b.claimed
            ? this.textureLoader.loadImage(
                h,
                { sampler: m.sampler, premultipliedAlpha: m.premultiplyAlpha },
                m.callback,
                () => m.callback(null),
              )
            : ((b.claimed = !0), m.callback(b.texture));
        }
        preloadVideo(h) {
          if (!h) return null;
          let m = h.includes(', ')
            ? (function (b) {
                let S = b.split(',').map((V) => V.trim()),
                  E = /^((?!chrome|android).)*safari/i.test(
                    navigator.userAgent,
                  ),
                  A = /iPad|iPhone|iPod/.test(navigator.userAgent);
                if (E || A) {
                  let V = S.find(
                    (Y) => Y.endsWith('.mov') || Y.endsWith('.mp4'),
                  );
                  if (V) return V;
                }
                return S.find((V) => V.endsWith('.webm')) || S[0];
              })(h)
            : h;
          if (
            ((this.local.preloadedVideos = this.local.preloadedVideos || {}),
            !this.local.preloadedVideos[m])
          ) {
            let b = document.createElement('video');
            ((b.crossOrigin = 'anonymous'),
              (b.muted = !0),
              (b.preload = 'auto'),
              b.setAttribute('playsinline', ''),
              (b.src = m),
              b.load(),
              (this.local.preloadedVideos[m] = b));
          }
          return this.local.preloadedVideos[m];
        }
        shouldPreloadLayerAssets(h) {
          return (h == null ? void 0 : h.visible) !== !1;
        }
        ensureImageLayerTexture(h, m = null) {
          h.layerType !== 'image' ||
            !h.src ||
            h.local.sourceTexture ||
            h.local.sourceTextureLoading ||
            ((h.local.sourceTextureLoading = !0),
            this.preloadImage(h.src, 'uSourceImage', (b) => {
              var S, E;
              if (((h.local.sourceTextureLoading = !1), !b)) return;
              ((h.local.sourceTexture = b), (h.local.imageReady = !0));
              let A =
                m ||
                ((S = h.getPlanes) == null
                  ? void 0
                  : S.call(h).find((F) => {
                      var V;
                      return !((V = F.userData) != null && V.isComposite);
                    })) ||
                ((E = h.getPlane) == null ? void 0 : E.call(h));
              (A &&
                !A.textures.some((F) => F._samplerName === 'uSourceImage') &&
                A.addTexture(b),
                this.requestSceneRender());
            }));
        }
        isFlattenedSublayerHidden(h, m, b = null) {
          var le;
          var S, E, A, F;
          let V = m == null ? void 0 : m.sublayerIndex;
          if (!(h != null && h.isFlattened) || !Number.isInteger(V)) return !1;
          let Y = `L${V}_elemOpacity`,
            X = `L${V}_opacity`,
            $ =
              ((S = b == null ? void 0 : b.uniforms) == null ? void 0 : S[Y]) ||
              ((E = b == null ? void 0 : b.uniforms) == null ? void 0 : E[X]);
          return $ && $.value === 0
            ? !0
            : ((le = (A = h.local.bpProps) == null ? void 0 : A[Y]) != null
                ? le
                : (F = h.local.bpProps) == null
                  ? void 0
                  : F[X]) === 0;
        }
        ensureFlattenedTexture(h, m, b = null) {
          var S;
          if (
            h != null &&
            h.isFlattened &&
            m &&
            !this.isFlattenedSublayerHidden(h, m, b)
          ) {
            if (m.type === 'image' && m.src) {
              h.local.sourceTextures = h.local.sourceTextures || {};
              let E = h.local.sourceTextures[m.sublayerIndex];
              return E
                ? void (
                    b &&
                    !b.textures.some((A) => A._samplerName === m.sampler) &&
                    b.addTexture(E)
                  )
                : void this.preloadImage(m.src, m.sampler, (A) => {
                    var F;
                    if (!A) return;
                    h.local.sourceTextures[m.sublayerIndex] = A;
                    let V =
                        b || ((F = h.getPlane) == null ? void 0 : F.call(h)),
                      Y = !1;
                    (V &&
                      !V.textures.some((X) => X._samplerName === m.sampler) &&
                      (V.addTexture(A), (Y = !0)),
                      Y && this.requestSceneRender());
                  });
            }
            if (m.type === 'video') {
              let E = h.sublayers.find(
                (F) => F.sublayerIndex === m.sublayerIndex,
              );
              if (!(E != null && E.src)) return;
              (h.local.videoElements || (h.local.videoElements = {}),
                h.local.videoTextures || (h.local.videoTextures = {}),
                h.local.videoTextureLoading ||
                  (h.local.videoTextureLoading = {}));
              let A =
                h.local.videoElements[m.sublayerIndex] ||
                this.preloadVideo(E.src);
              return (
                (h.local.videoElements[m.sublayerIndex] = A),
                !b || b.textures.some((F) => F._samplerName === m.sampler)
                  ? void 0
                  : h.local.videoTextures[m.sampler]
                    ? void b.addTexture(h.local.videoTextures[m.sampler])
                    : h.local.videoTextureLoading[m.sampler]
                      ? void 0
                      : ((h.local.videoTextureLoading[m.sampler] = !0),
                        void b.loadVideo(
                          A,
                          { premultipliedAlpha: !0, sampler: m.sampler },
                          (F) => {
                            ((h.local.videoTextureLoading[m.sampler] = !1),
                              (h.local.videoTextures[m.sampler] = F));
                            let V =
                              (F == null ? void 0 : F.source) ||
                              (F == null ? void 0 : F._source) ||
                              A;
                            V &&
                              ((V.loop =
                                !(E != null && E.hasOwnProperty('loop')) ||
                                E.loop),
                              (V.playbackRate =
                                (E == null ? void 0 : E.playbackRate) || 1),
                              V.play(),
                              this.requestSceneRender());
                          },
                          () => {
                            h.local.videoTextureLoading[m.sampler] = !1;
                          },
                        ))
              );
            }
            if (m.type === 'media' && m.src) {
              if (
                b != null &&
                b.textures.some((E) => E._samplerName === m.sampler)
              )
                return;
              this.preloadImage(
                m.src,
                m.sampler,
                (E) => {
                  var A;
                  if (!E) return;
                  let F = b || ((A = h.getPlane) == null ? void 0 : A.call(h));
                  F &&
                    !F.textures.some((V) => V._samplerName === m.sampler) &&
                    (F.addTexture(E), this.requestSceneRender());
                },
                !1,
              );
            } else if (m.type === 'modelRT') {
              let E =
                (S = h.local.modelInstances) == null
                  ? void 0
                  : S[m.sublayerIndex];
              if (!E || !this.curtain) return;
              ((E.local.hostLayer = h),
                (E.local.targetSamplerName = m.sampler),
                E.local.renderTarget ||
                  (E.local.renderTarget = new r.RenderTarget(this.curtain, {
                    depth: !0,
                    maxWidth:
                      this.curtain.canvas.width * (E.userDownsample || 1),
                    maxHeight:
                      this.curtain.canvas.height * (E.userDownsample || 1),
                    texturesOptions: {
                      sampler: m.sampler,
                      premultiplyAlpha: !0,
                    },
                  })));
              let A = E.local.renderTarget.getTexture();
              (A &&
                ((h.local.modelTextures[m.sublayerIndex] = A),
                b &&
                  !b.textures.some((F) => F._samplerName === m.sampler) &&
                  (b.addTexture(A), this.requestSceneRender())),
                E.local.rendererLoaded ||
                  E.local.rendererLoading ||
                  ((E.local.rendererLoading = !0),
                  Promise.resolve(E.loadRenderer()).finally(() => {
                    E.local.rendererLoading = !1;
                  })));
            }
          }
        }
        preloadTextures() {
          this.hasValidTextureLoader() &&
            this.layers.forEach((h) => {
              var m, b, S, E, A, F, V;
              let Y = this.shouldPreloadLayerAssets(h);
              if (h.isFlattened)
                return (
                  (h.local.canvasTextures = {}),
                  (h.local.sourceTextures = {}),
                  void (
                    ((m = h.data) == null ? void 0 : m.textures) &&
                    h.data.textures.forEach((X) => {
                      var $, le;
                      if (X.type === 'canvas') {
                        let xe =
                          ($ = h.local.textInstances) == null
                            ? void 0
                            : $[X.sublayerIndex];
                        (le = xe == null ? void 0 : xe.local) != null &&
                          le.canvas &&
                          this.textureLoader.loadCanvas(
                            xe.local.canvas,
                            { sampler: X.sampler, premultiplyAlpha: !0 },
                            (fe) => {
                              var Se;
                              ((fe.shouldUpdate = !0),
                                (h.local.canvasTextures[X.sublayerIndex] = fe));
                              let Me =
                                (Se = h.getPlane) == null ? void 0 : Se.call(h);
                              Me &&
                                !Me.textures.some(
                                  (de) => de._samplerName === X.sampler,
                                ) &&
                                Me.addTexture(fe);
                            },
                          );
                      } else Y && this.ensureFlattenedTexture(h, X);
                    })
                  )
                );
              if (h.isElement)
                h.local.canvas && !h.htmlOnly
                  ? this.textureLoader.loadCanvas(
                      h.local.canvas,
                      { sampler: 'uTexture', premultiplyAlpha: !0 },
                      (X) => {
                        ((X.userData.hasStateEffects =
                          h.states.appear.length > 0 ||
                          h.states.scroll.length > 0 ||
                          h.states.hover.length > 0 ||
                          h.states.mousemove.length > 0),
                          (h.preloadedCanvasTexture = X));
                      },
                      (X) => {},
                    )
                  : h.layerType === 'image' &&
                    h.src &&
                    Y &&
                    this.ensureImageLayerTexture(h);
              else {
                let X =
                    ((b = h == null ? void 0 : h.texture) == null
                      ? void 0
                      : b.src) ||
                    ((E =
                      (S = h == null ? void 0 : h.data) == null
                        ? void 0
                        : S.texture) == null
                      ? void 0
                      : E.src),
                  $ =
                    ((A = h == null ? void 0 : h.texture) == null
                      ? void 0
                      : A.sampler) ||
                    ((V =
                      (F = h == null ? void 0 : h.data) == null
                        ? void 0
                        : F.texture) == null
                      ? void 0
                      : V.sampler) ||
                    'uTexture';
                Y && X && this.preloadImage(X, $, null, !1);
              }
            });
        }
        setCanvasScale() {
          ((this.canvasWidth = this.element.offsetWidth),
            (this.canvasHeight = this.element.offsetHeight));
        }
        destroy() {
          var h, m;
          ((this.destroyed = !0), (this.rendering = !1), (this.isInView = !1));
          let b = Te.findIndex((S) => S.id === this.id);
          (b !== -1 && Te.splice(b, 1),
            this.layers.filter((S) => S.dispose).forEach((S) => S.dispose()),
            (this.layers = []),
            (h = this.curtain) != null &&
              h.gl &&
              (this.curtain.dispose(), (this.curtain = null)),
            this.element &&
              (this.element.removeAttribute('data-us-initialized'),
              this.element.removeAttribute('data-scene-id'),
              (m = this.element.querySelector('canvas')) == null || m.remove(),
              this.element.querySelectorAll('[data-us-text]').forEach((S) => {
                S.remove();
              })),
            Pe(),
            Te.length || j());
        }
        syncPlaneVisibility() {
          this.layers
            .filter((h) => !h.parentLayer)
            .forEach((h) => {
              let m = h.visible;
              (h.getChildEffectItems().forEach((b) => {
                let S = m && b.visible;
                b.getPlanes().forEach((E) => {
                  E.visible = S;
                });
              }),
                h.getPlanes().forEach((b) => {
                  b.visible = m;
                }));
            });
        }
        applyLayerVisibility() {
          let h = !1;
          (this.layers
            .filter((m) => !m.parentLayer)
            .forEach((m) => {
              let b = m.visible;
              (m.getChildEffectItems().forEach((S) => {
                let E = b && S.visible;
                S.getPlanes().forEach((A) => {
                  (A.visible !== E && (h = !0), (A.visible = E));
                });
              }),
                m.getPlanes().forEach((S) => {
                  (S.visible !== b && (h = !0), (S.visible = b));
                }),
                b &&
                  m.isModel &&
                  !m.local.rendererLoaded &&
                  !m.local.rendererLoading &&
                  ((m.local.rendererLoading = !0),
                  Promise.resolve(m.loadRenderer()).finally(() => {
                    m.local.rendererLoading = !1;
                  })));
            }),
            h &&
              (this.calculateRenderOrders(),
              this.createTextures(),
              this.renderFrame()));
        }
        resize() {
          var h;
          ((this.lastBbox = this.bbox),
            (this.bbox = this.element.getBoundingClientRect()),
            this.setCanvasScale());
          let m = this.currentBreakpoint;
          this.currentBreakpoint = this.breakpoints.find(
            (S) => d >= S.min && d <= S.max,
          );
          let b =
            (m == null ? void 0 : m.name) !==
            ((h = this.currentBreakpoint) == null ? void 0 : h.name);
          for (let S = 0; S < this.layers.length; S++) {
            let E = this.layers[S];
            b &&
              E.breakpoints.length &&
              (E.setBreakpointValues(), this.applyBreakpointUniforms(E));
          }
          if (ve(this.curtain)) {
            (this.curtain.resize(),
              (this.curtain.canvas.style.width = this.canvasWidth + 'px'),
              (this.curtain.canvas.style.height = this.canvasHeight + 'px'));
            for (let S = 0; S < this.curtain.planes.length; S++) {
              let E = this.curtain.planes[S];
              (E.uniforms.resolution &&
                ((E.uniforms.resolution.value.x = this.curtain.canvas.width),
                (E.uniforms.resolution.value.y = this.curtain.canvas.height)),
                E.uniforms.artboardResolution &&
                  ((E.uniforms.artboardResolution.value.x = this.canvasWidth),
                  (E.uniforms.artboardResolution.value.y = this.canvasHeight)));
            }
          }
          for (let S = 0; S < this.layers.length; S++) {
            let E = this.layers[S];
            E.visible && E.resize && E.resize();
          }
          b &&
            (this.applyLayerVisibility(),
            this.createTextures(),
            this.renderFrame());
        }
        refresh() {
          ((this.initialized = !1),
            this.layers.forEach((h) => {
              var m, b;
              ((m = h.states) == null ||
                m.scroll.forEach((S) => S.resetState()),
                (b = h.states) == null ||
                  b.appear.forEach((S) => {
                    var E, A;
                    h[S.prop] =
                      (A =
                        (E = S.endValue) != null
                          ? E
                          : h.local.stateEffectProps[S.prop]) != null
                        ? A
                        : h[S.prop];
                  }),
                h.breakpoints.length &&
                  (h.setBreakpointValues(), this.applyBreakpointUniforms(h)),
                h.preloadedCanvasTexture &&
                  (h.preloadedCanvasTexture.shouldUpdate = !0));
            }),
            requestAnimationFrame(() => {
              this.curtain &&
                (this.curtain.planes.forEach((h) => {
                  h._canDraw = !0;
                }),
                (this.scrollY = _),
                this.applyLayerVisibility(),
                this.resize(),
                this.handlePlaneCreation());
            }));
        }
        getDynamicLayers() {
          return this.layers.filter((h) => ht(h));
        }
        createCurtains() {
          ((this.curtain = new r.Curtains({
            container: this.element,
            premultipliedAlpha: !0,
            antialias: !1,
            autoRender: !1,
            autoResize: !1,
            watchScroll: !1,
            renderingScale: Math.min(Math.max(0.25, this.renderingScale), 1),
            production: !1,
            pixelRatio: this.dpi,
          })),
            this.curtain.gl &&
              (this.curtain.onError((h) => {}),
              this.curtain.onContextLost(() => {
                this.curtain.restoreContext();
              }),
              this.curtain.onContextRestored(() => {
                this.initialized &&
                  (this.layers.forEach((h) => {
                    h.preloadedCanvasTexture &&
                      (h.preloadedCanvasTexture.shouldUpdate = !0);
                  }),
                  requestAnimationFrame(() => {
                    this.curtain &&
                      (this.curtain.planes.forEach((h) => {
                        h._canDraw = !0;
                      }),
                      this.renderFrame());
                  }));
              }),
              (this.scrollY = _)));
        }
        applyBreakpointUniforms(h) {
          h.local.bpProps &&
            h.getPlanes().forEach((m) => {
              var b, S;
              for (let E in m.uniforms)
                E in h.local.bpProps
                  ? nt(h.local.bpProps[E], m.uniforms[E], E)
                  : (S = (b = h.data) == null ? void 0 : b.uniforms) != null &&
                    S[E] &&
                    nt(h.data.uniforms[E].value, m.uniforms[E], E);
            });
        }
        renderFrame() {
          this.destroyed ||
            (ve(this.curtain) &&
              (this.layers.forEach((h) => {
                h.local.currentFrameMouseValues = null;
              }),
              this.handleStateEffects(),
              this.curtain.render()));
        }
        requestSceneRender() {
          ve(this.curtain) &&
            (typeof this.curtain.requestRender == 'function'
              ? this.curtain.requestRender()
              : this.renderFrame());
        }
        renderNFrames(h, m) {
          let b = 0,
            S = () => {
              (this.renderFrame(),
                b < h ? (b++, requestAnimationFrame(S)) : m && m());
            };
          this.rendering || S();
        }
        setInteractiveParams(h, m) {
          let b = { mouse: { disableMobile: !1, disabled: !1 } };
          (m &&
            m.mouse &&
            ('disableMobile' in m.mouse &&
              (b.mouse.disableMobile = m.mouse.disableMobile),
            'disabled' in m.mouse && (b.mouse.disabled = m.mouse.disabled)),
            h &&
              h.interactivity &&
              h.interactivity.mouse &&
              ('disableMobile' in h.interactivity.mouse &&
                (b.mouse.disableMobile = h.interactivity.mouse.disableMobile),
              'disabled' in h.interactivity.mouse &&
                (b.mouse.disabled = h.interactivity.mouse.disabled)),
            (this.interactivity = b));
        }
        getSplitOrderedItems() {
          let h = this.getOrderedItems(),
            m = 0,
            b = h[m];
          if (b) {
            let S = b.parentLayer ? b.getParent() : null,
              E = S && ht(S),
              A =
                S &&
                S.effects &&
                S.effects.length &&
                S.getChildEffectItems().filter((F) => ht(F)).length;
            for (; b && !ht(b) && !E && !A; )
              (m++,
                (b = h[m]),
                b &&
                  ((S = b.parentLayer ? b.getParent() : null),
                  (E = S && ht(S)),
                  (A =
                    S &&
                    S.effects &&
                    S.effects.length &&
                    S.getChildEffectItems().filter((F) => ht(F)).length)));
            return {
              static: this.getOrderedItems().splice(0, m),
              dynamic: this.getOrderedItems().splice(m),
            };
          }
          return { static: [], dynamic: [] };
        }
        initializePlanes(h) {
          ((this.initializing = !0),
            ve(this.curtain)
              ? this.handleItemPlanes(() => {
                  (this.handlePlaneCreation(), h && h(this));
                })
              : (this.initializing = !1));
        }
        getPassPlane(h, m) {
          var b;
          return (b = this.curtain) == null
            ? void 0
            : b.planes.find(
                (S) =>
                  S.userData.id === h.local.id && S.userData.passIndex === m,
              );
        }
        getRenderTargets() {
          var h;
          return (h = this.curtain) == null
            ? void 0
            : h.renderTargets.filter((m) => m.userData.id);
        }
        getPlanes() {
          var h;
          return (h = this.curtain) == null
            ? void 0
            : h.planes.filter((m) => m.type !== 'PingPongPlane');
        }
        getPlaneParams(h, m) {
          var le;
          var b, S, E, A, F;
          let V =
              ((b = h.data) != null && b.heightSegments) ||
              ((S = h.data) != null && S.widthSegments)
                ? 500
                : 1,
            Y = {
              resolution: {
                name: 'uResolution',
                type: '2f',
                value: new r.Vec2(this.canvasWidth, this.canvasHeight),
              },
              mousePos: {
                name: 'uMousePos',
                type: '2f',
                value: new r.Vec2(0.5),
              },
              time: { name: 'uTime', type: '1f', value: 0 },
              dpi: {
                name: 'uDpi',
                type: '1f',
                value: this.dpi * +this.renderingScale,
              },
            };
          h.usesPingPong &&
            (Y.previousMousePos = {
              name: 'uPreviousMousePos',
              type: '2f',
              value: new r.Vec2(0.5),
            });
          let X = h.compiledFragmentShaders[m] || h.compiledFragmentShaders[0],
            $ =
              (le = h.compiledVertexShaders[m]) != null
                ? le
                : h.compiledVertexShaders[0];
          if (
            (h.states &&
              [
                ...h.states.appear,
                ...h.states.scroll,
                ...h.states.hover,
                ...h.states.mousemove,
              ].forEach((xe) => {
                Y[xe.prop] ||
                  (xe.uniformData &&
                    ((Y[xe.prop] = xe.uniformData),
                    (Y[xe.prop].value = h[xe.prop])));
              }),
            (E = h.data) == null ? void 0 : E.uniforms)
          )
            for (let xe in h.data.uniforms) {
              let fe = h.data.uniforms[xe];
              ((Y[xe] = h.data.uniforms[xe]),
                ((A = fe.value) == null ? void 0 : A.type) === 'Vec3'
                  ? (Y[xe].value = new r.Vec3(
                      fe.value._x,
                      fe.value._y,
                      fe.value._z,
                    ))
                  : ((F = fe.value) == null ? void 0 : F.type) === 'Vec2'
                    ? (Y[xe].value = new r.Vec2(fe.value._x, fe.value._y))
                    : typeof fe.value == 'object' &&
                      (Y[xe].value = J(fe.value)));
            }
          return {
            fragmentShader: X,
            vertexShader: $,
            widthSegments: V,
            heightSegments: V,
            texturesOptions: {
              floatingPoint: 'half-float',
              premultiplyAlpha: !0,
            },
            uniforms: Y,
          };
        }
        getCompositePlaneRenderOrder(h, m, b) {
          let S = h.getChildEffectItems();
          if (S.length === 0) return b;
          let E = S[S.length - 1],
            A = m.indexOf(E);
          return A !== -1 ? A + 1 : b + S.length;
        }
        createPlane(h, m) {
          var b;
          let S, E;
          ((S =
            h.isElement || h.isModel || h.isFlattened
              ? this.getPlaneParams(h)
              : this.getPlaneParams(h, m ? m.index : null)),
            (S.watchScroll = !1));
          try {
            if (!this.curtain.container)
              throw new Error("Can't find scene container");
            let A =
                (m == null ? void 0 : m.downSample) ||
                ((m == null ? void 0 : m.index) === 0 &&
                  ((b = h.data) == null ? void 0 : b.downSample)),
              F = this.renderingScale;
            if (
              (A &&
                ((F = typeof A == 'number' ? A : 0.5),
                (F *= this.renderingScale)),
              h.userDownsample &&
                typeof h.userDownsample == 'number' &&
                (F *= h.userDownsample),
              (E = new r.Plane(this.curtain, this.curtain.container, S)),
              !E || !E.userData || !E.textures)
            )
              throw new Error('Plane not properly initialized');
            return (
              (E.textures.length = 0),
              (E.userData.id = h.local.id),
              (E.userData.layerType = h.layerType),
              (E.userData.type = h.type),
              (E.userData.downSample = F),
              E
            );
          } catch (A) {
            return null;
          }
        }
        createPingPongPlane(h, m) {
          var b;
          let S =
              typeof (m == null ? void 0 : m.index) == 'number'
                ? m.index
                : 1 + ((m == null ? void 0 : m.length) || 0),
            E = this.getPlaneParams(h, S),
            A =
              (b = this.curtain) == null
                ? void 0
                : b.planes.find(
                    (F) =>
                      F.type === 'PingPongPlane' &&
                      F.userData.id === h.local.id,
                  );
          if (!A) {
            if (
              ((A = new r.PingPongPlane(
                this.curtain,
                this.curtain.container,
                E,
              )),
              !A)
            )
              return;
            ((A.userData.id = h.local.id),
              (A.userData.pingpong = !0),
              A.onReady(() => {
                (this.setInitialEffectPlaneUniforms(
                  A,
                  h,
                  h == null ? void 0 : h.getParent(),
                  m,
                ),
                  (A.userData.isReady = !0));
              }).onRender(() => {
                this.setEffectPlaneUniforms(A, h);
              }));
          }
          if (A) return A;
        }
        createEffectPlane(h, m) {
          let b = this.createPlane(h, m);
          if (!b) return;
          let S = h.getParent();
          if (!b || !b.userData || !b.textures)
            throw new Error('Plane not properly initialized', b);
          (m &&
            ((b.userData.passIndex = m.index),
            (b.userData.length = h.data.passes.length),
            (b.userData.needsPreviousFrame = m.needsPreviousFrame),
            Object.entries(m).forEach(([E, A]) => {
              b.uniforms[E] && (b.uniforms[E].value = A);
            })),
            this.setInitialEffectPlaneUniforms(b, h, S, m),
            b
              .onReady(() => {
                b.userData.isReady = !0;
              })
              .onRender(() => this.setEffectPlaneUniforms(b, h))
              .onAfterRender(() => {
                var A;
                let E = b.userData.needsPreviousFrame;
                if (E) {
                  let F = (A = b.userData.passIndex) != null ? A : 0,
                    V = h.local.previousFrameTargets || {},
                    Y = h.local.previousFrameInputTargets || {},
                    X = E === 'target' ? Y[F] : b.target,
                    $ = V[F];
                  X && $ && this.blitRenderTarget(X, $);
                }
              }));
        }
        createFlattenedPlane(h) {
          var m;
          let b = this.createPlane(h);
          b &&
            (b
              .onReady(() => {
                (this.setInitialFlattenedPlaneUniforms(b, h),
                  (b.userData.isReady = !0));
              })
              .onRender(() => this.setFlattenedPlaneUniforms(b, h)),
            (h.hasRemainingEffects() || (h.mask && h.mask !== 0)) &&
              (h.hasRemainingEffects() &&
                h.getChildEffectItems().forEach((S) => {
                  S.getPlanes().length || this.createEffectPlanes(S);
                }),
              (m = h.data) != null &&
                m.compositeShader &&
                this.createCompositePlane(h)));
        }
        createElementPlane(h) {
          let m = this.createPlane(h);
          m &&
            (h.getChildEffectItems().filter((b) => b.visible).length > 0 &&
              this.createCompositePlane(h),
            m
              .onReady(() => {
                (this.setInitialElementPlaneUniforms(m, h),
                  (m.userData.isReady = !0));
              })
              .onRender(() => this.setElementPlaneUniforms(m, h)));
        }
        createCompositePlane(h) {
          var m, b, S;
          if (!((m = h.data) != null && m.compositeShader)) return null;
          let E = {
            vertexShader: h.data.compositeShader.vertexShader,
            fragmentShader: h.data.compositeShader.fragmentShader,
            texturesOptions: { premultiplyAlpha: !0 },
            uniforms: {},
          };
          if (h.data.compositeUniforms)
            for (let F in h.data.compositeUniforms) {
              let V = h.data.compositeUniforms[F];
              ((E.uniforms[F] = pt({}, V)),
                ((b = V.value) == null ? void 0 : b.type) === 'Vec3'
                  ? (E.uniforms[F].value = new r.Vec3(
                      V.value._x,
                      V.value._y,
                      V.value._z,
                    ))
                  : ((S = V.value) == null ? void 0 : S.type) === 'Vec2' &&
                    (E.uniforms[F].value = new r.Vec2(V.value._x, V.value._y)));
            }
          let A = new r.Plane(this.curtain, this.curtain.container, E);
          return A && A.userData
            ? ((A.textures.length = 0),
              (A.userData.id = h.local.id),
              (A.userData.isComposite = !0),
              A.onReady(() => {
                A.userData.isReady = !0;
              }).onRender(() => {
                this.setCompositePlaneUniforms(A, h);
              }),
              A)
            : null;
        }
        setCompositePlaneUniforms(h, m) {
          var E, A;
          var b, S;
          if (
            h != null &&
            h.uniforms &&
            h.visible &&
            (h.uniforms.resolution &&
              ((h.uniforms.resolution.value.x = this.curtain.canvas.width),
              (h.uniforms.resolution.value.y = this.curtain.canvas.height)),
            h.uniforms.opacity &&
              (h.uniforms.opacity.value =
                (A =
                  (E =
                    (S = (b = m.local) == null ? void 0 : b.stateEffectProps) ==
                    null
                      ? void 0
                      : S.opacity) != null
                    ? E
                    : m.opacity) != null
                  ? A
                  : 1),
            h.uniforms.mousePos)
          ) {
            m.local.currentFrameMouseValues ||
              (m.local.currentFrameMouseValues =
                this.calculateItemMouseValues(m));
            let F = m.local.currentFrameMouseValues;
            F &&
              this.mouse.movedInView &&
              ((h.uniforms.mousePos.value.x = F.x),
              (h.uniforms.mousePos.value.y = F.y));
          }
        }
        handleMediaTextures(h, m, b) {
          var S, E, A;
          if (
            (((E = (S = m.data) == null ? void 0 : S.textures) != null &&
            E.length
              ? m.data.textures
              : [m.texture, (A = m.data) == null ? void 0 : A.texture].filter(
                  (F) => (F == null ? void 0 : F.src),
                )
            )
              .filter((F) => (F == null ? void 0 : F.src))
              .forEach((F) => {
                var Y;
                var V;
                if (
                  (V =
                    m.compiledFragmentShaders[
                      (Y = b.passIndex) != null ? Y : 0
                    ]) != null &&
                  V.includes(F.sampler)
                ) {
                  if (F.type === 'video') {
                    let X =
                      F.sampler === 'uVideoTexture' && m.src ? m.src : F.src;
                    if (
                      !X ||
                      h.textures.some((le) => le._samplerName === F.sampler)
                    )
                      return;
                    let $ = this.preloadVideo(X);
                    return $
                      ? void h.loadVideo(
                          $,
                          { premultipliedAlpha: !0, sampler: F.sampler },
                          (le) => {
                            var fe, Se;
                            let xe = le == null ? void 0 : le.source;
                            xe &&
                              ((xe.loop =
                                (Se = (fe = F.loop) != null ? fe : m.loop) !=
                                null
                                  ? Se
                                  : !0),
                              (xe.playbackRate =
                                F.playbackRate || m.playbackRate || 1),
                              xe.play(),
                              (h.userData.textureLoaded = !0));
                          },
                        )
                      : void 0;
                  }
                  this.preloadImage(
                    F.src,
                    F.sampler,
                    (X) => {
                      X &&
                        (h.textures.some(($) => $._samplerName === F.sampler) ||
                          h.addTexture(X),
                        (h.userData.textureLoaded = !0));
                    },
                    !1,
                  );
                }
              }),
            m.type === 'video' && m.src)
          ) {
            if (h.textures.some((V) => V._samplerName === 'uVideoTexture'))
              return;
            let F = this.preloadVideo(m.src);
            h.loadVideo(
              F,
              { premultipliedAlpha: !0, sampler: 'uVideoTexture' },
              (V) => {
                let Y = V == null ? void 0 : V.source;
                Y &&
                  ((Y.loop = !m.hasOwnProperty('loop') || m.loop),
                  (Y.playbackRate = m.playbackRate || 1),
                  Y.play(),
                  (h.userData.textureLoaded = !0));
              },
            );
          }
        }
        handleEffectPlane(h, m, b, S) {
          var X;
          var E;
          let A =
            'passIndex' in b ? this.getPassPlane(h, b.passIndex) : h.getPlane();
          if (!A) return !1;
          let F = S[m - 1],
            V =
              (E = this.curtain) == null
                ? void 0
                : E.planes.find(
                    ($) =>
                      $.type === 'PingPongPlane' &&
                      $.userData.id === h.local.id,
                  ),
            Y = h.compiledFragmentShaders[(X = b.passIndex) != null ? X : 0];
          if (
            (V &&
              Y != null &&
              Y.includes('uPingPongTexture') &&
              Le(A, 'uPingPongTexture', V.getTexture()),
            F ? Le(A, 'uTexture', F.getTexture()) : Le(A, 'uTexture'),
            Y == null ? void 0 : Y.includes('uBgTexture'))
          ) {
            let $ = S[m - (1 + b.passIndex)];
            $ && Le(A, 'uBgTexture', $.getTexture());
          }
          (b.needsPreviousFrame &&
            Le(
              A,
              'uPreviousFrameTexture',
              this.createPreviousFrameTarget(h, b, m, S),
            ),
            this.handleMediaTextures(A, h, b));
        }
        handleModelPlane(h, m, b) {
          var S;
          let E = h.getPlane(),
            A = b[m - 1],
            F = this.findPreviousLayerForMask(h, 0);
          (E.textures.forEach((V) => {}),
            (E.textures = []),
            h.local.renderTarget
              ? E.addTexture(h.local.renderTarget.getTexture())
              : A
                ? Le(E, 'uTexture', A.getTexture())
                : Le(E, 'uTexture'),
            (S = F == null ? void 0 : F.local) != null && S.lastTarget
              ? Le(E, 'uBgTexture', F.local.lastTarget.getTexture())
              : Le(E, 'uBgTexture'));
        }
        createPreviousFrameTarget(h, m, b, S) {
          var Y, X;
          let E = (X = (Y = m.passIndex) != null ? Y : m.index) != null ? X : 0,
            A = m.downSample || 1,
            F = this.curtain.canvas.width * A,
            V = this.curtain.canvas.height * A;
          return (
            h.local.previousFrameTargets || (h.local.previousFrameTargets = {}),
            h.local.previousFrameInputTargets ||
              (h.local.previousFrameInputTargets = {}),
            h.local.previousFrameTargets[E] ||
              ((h.local.previousFrameTargets[E] = new r.RenderTarget(
                this.curtain,
                { depth: !1, clear: !1, maxWidth: F, maxHeight: V },
              )),
              (h.local.previousFrameTargets[E].userData.isPingPong = !0),
              (h.local.previousFrameTargets[E].userData.isPreviousFrame = !0)),
            m.needsPreviousFrame === 'target' &&
              b !== void 0 &&
              (h.local.previousFrameInputTargets[E] = S[b - (1 + m.passIndex)]),
            h.local.previousFrameTargets[E].getTexture()
          );
        }
        findPreviousLayerForMask(h, m) {
          var b;
          let S = this.layers.filter((F) => !F.parentLayer),
            E = S.indexOf(h);
          if (E < 0) return null;
          let A = E - m - 1;
          if (A < 0) return null;
          for (let F = Math.max(0, A); F >= 0; F--) {
            let V = S[F];
            if (
              V != null &&
              V.visible &&
              (b = V == null ? void 0 : V.local) != null &&
              b.lastTarget &&
              V !== h
            )
              return V;
          }
          return null;
        }
        handleFlattenedPlane(h, m, b) {
          var S;
          let E = h.getPlane();
          if (!E) return;
          let A = b[m - 1];
          (A && Le(E, 'uBgTexture', A.getTexture()),
            (S = h.data) != null &&
              S.textures &&
              h.data.textures.forEach((F) => {
                F.type === 'canvas'
                  ? h.local.canvasTextures &&
                    h.local.canvasTextures[F.sublayerIndex] &&
                    E.addTexture(h.local.canvasTextures[F.sublayerIndex])
                  : this.ensureFlattenedTexture(h, F, E);
              }));
        }
        ensureFlattenedPlaneTextures(h, m) {
          var b;
          h &&
            (b = m.data) != null &&
            b.textures &&
            m.data.textures.forEach((S) => {
              var E;
              if (!h.textures.some((A) => A._samplerName === S.sampler))
                if (S.type === 'canvas') {
                  let A =
                    (E = m.local.canvasTextures) == null
                      ? void 0
                      : E[S.sublayerIndex];
                  A && h.addTexture(A);
                } else this.ensureFlattenedTexture(m, S, h);
            });
        }
        handleElementPlane(h, m, b) {
          var V;
          let S = h.getPlanes().find((Y) => !Y.userData.isComposite);
          if (!S) return !1;
          let E = h.getChildEffectItems().filter((Y) => Y.visible),
            A,
            F = b[m - 1];
          if (h.mask && h.maskDepthLayer > 0) {
            let Y = this.findPreviousLayerForMask(
              h,
              (V = h.maskDepthLayer) != null ? V : 0,
            );
            Y && (A = Y.local.lastTarget);
          }
          if (h.isGpuElement)
            return (
              h.layerType === 'image' &&
                (S.textures.some((Y) => Y._samplerName === 'uSourceImage') ||
                  (h.local.sourceTexture
                    ? (S.addTexture(h.local.sourceTexture),
                      (h.local.imageReady = !0))
                    : this.ensureImageLayerTexture(h, S))),
              void (
                E.length === 0 &&
                F &&
                (Le(S, 'uBgTexture', F.getTexture()),
                A && h.mask && Le(S, 'uPreviousLayerTexture', A.getTexture()))
              )
            );
          (E.length || (S.textures.length = 0),
            F && E.length
              ? Le(S, 'uTexture', F.getTexture())
              : S &&
                h.preloadedCanvasTexture &&
                S.addTexture(h.preloadedCanvasTexture),
            F &&
              (E.length &&
                (F =
                  b[m - (1 + E.reduce((Y, X) => Y + X.getPlanes().length, 0))]),
              F &&
                (Le(S, 'uBgTexture', F.getTexture()),
                A &&
                  h.mask &&
                  Le(S, 'uPreviousLayerTexture', A.getTexture()))));
        }
        handleCompositePlane(h, m, b, S) {
          var $;
          let E = h.getPlanes().find((le) => le.userData.isComposite);
          if (!E) return;
          let A;
          if (h.mask && h.maskDepthLayer > 0) {
            let le = this.findPreviousLayerForMask(
              h,
              ($ = h.maskDepthLayer) != null ? $ : 0,
            );
            le && (A = le.local.lastTarget);
          }
          let F = S[m - 1];
          F && Le(E, 'uTexture', F.getTexture());
          let V = b.findIndex(
              (le) => le.userData.id === h.local.id && !le.userData.isComposite,
            ),
            Y = V > 0 ? V - 1 : -1,
            X = Y >= 0 ? S[Y] : null;
          X &&
            (Le(E, 'uBgTexture', X.getTexture()),
            A && h.mask && Le(E, 'uPreviousLayerTexture', A.getTexture()));
        }
        handleChildEffectPlane(h, m, b, S) {
          var ft;
          var E, A, F, V, Y, X, $, le, xe;
          let fe =
              'passIndex' in b
                ? this.getPassPlane(h, b.passIndex)
                : h.getPlane(),
            Se = h.getParent();
          if (!fe || !Se) return;
          let Me = S[m - 1],
            de =
              (E = this.curtain) == null
                ? void 0
                : E.planes.find(
                    (dt) =>
                      dt.type === 'PingPongPlane' &&
                      dt.userData.id === h.local.id,
                  ),
            me = h.compiledFragmentShaders[(ft = b.passIndex) != null ? ft : 0],
            De = Se.effects.filter((dt) => {
              if (this.layers.find((gt) => gt.parentLayer === dt))
                return this.layers.find((gt) => gt.parentLayer === dt);
            }),
            Ge = De.indexOf(h.parentLayer),
            ze = De.at(-1) === De[Ge],
            lt = b.passIndex === b.length,
            st = Se.isGpuElement || Se.isFlattened;
          if (
            (de &&
              me != null &&
              me.includes('uPingPongTexture') &&
              Le(fe, 'uPingPongTexture', de.getTexture()),
            me == null ? void 0 : me.includes('uBgTexture'))
          )
            if (Ge && b.length > 1) {
              let dt = S[m - (1 + b.length)];
              dt && Le(fe, 'uBgTexture', dt.getTexture());
            } else if (st) {
              let dt = Se.getPlanes().find((gt) => !gt.userData.isComposite);
              Le(
                fe,
                'uBgTexture',
                (V = dt == null ? void 0 : dt.target) == null
                  ? void 0
                  : V.getTexture(),
              );
            } else
              (F =
                (A = Se.preloadedCanvasTexture) == null
                  ? void 0
                  : A.userData) != null && F.used
                ? fe.loadCanvas(
                    Se.local.canvas,
                    { sampler: 'uBgTexture', premultiplyAlpha: !0 },
                    (dt) => {
                      dt.shouldUpdate = Se.preloadedCanvasTexture.shouldUpdate;
                    },
                  )
                : Se.preloadedCanvasTexture &&
                  ((Se.preloadedCanvasTexture._samplerName = 'uBgTexture'),
                  fe.addTexture(Se.preloadedCanvasTexture));
          if (Me && (Ge || b.passIndex)) {
            if (h.isMask && (!b.length || (ze && lt)))
              if (!st && Se.preloadedCanvasTexture)
                fe.addTexture(Se.preloadedCanvasTexture);
              else {
                let dt = Se.getPlanes().find((gt) => !gt.userData.isComposite);
                Le(
                  fe,
                  'uMaskTexture',
                  (Y = dt == null ? void 0 : dt.target) == null
                    ? void 0
                    : Y.getTexture(),
                );
              }
            Le(fe, 'uTexture', Me.getTexture());
          } else if (h.isMask) {
            if (!b.length || (ze && lt))
              if (!st && Se.preloadedCanvasTexture)
                fe.addTexture(Se.preloadedCanvasTexture);
              else {
                let dt = Se.getPlanes().find((gt) => !gt.userData.isComposite);
                Le(
                  fe,
                  'uMaskTexture',
                  (X = dt == null ? void 0 : dt.target) == null
                    ? void 0
                    : X.getTexture(),
                );
              }
            (ze && lt && !st
              ? fe.addTexture(Se.preloadedCanvasTexture)
              : Me
                ? Le(fe, 'uTexture', Me.getTexture())
                : Le(fe, 'uTexture'),
              (Me = S[m - 2]),
              Me && Le(fe, 'uTexture', Me.getTexture()));
          } else if (me != null && me.includes('uTexture'))
            if (st) {
              let dt = Se.getPlanes().find((gt) => !gt.userData.isComposite);
              Le(
                fe,
                'uTexture',
                ($ = dt == null ? void 0 : dt.target) == null
                  ? void 0
                  : $.getTexture(),
              );
            } else
              Se.preloadedCanvasTexture
                ? (fe.addTexture(Se.preloadedCanvasTexture),
                  Se.preloadedCanvasTexture &&
                    (Se.preloadedCanvasTexture.userData.used = !0))
                : Le(fe, 'uTexture', Me.getTexture());
          (b.needsPreviousFrame &&
            Le(
              fe,
              'uPreviousFrameTexture',
              this.createPreviousFrameTarget(h, b, m, S),
            ),
            h.type === 'custom' &&
              Le(
                fe,
                'uCustomTexture',
                (xe = (le = S[m]) == null ? void 0 : le.getTexture) == null
                  ? void 0
                  : xe.call(le),
              ),
            this.handleMediaTextures(fe, h, b));
        }
        createPlanes() {
          (this.getOrderedItems().forEach((h) => {
            (h.layerType === 'text' && h.htmlOnly) ||
              h.getPlanes().length ||
              (h.isFlattened
                ? this.createFlattenedPlane(h)
                : h.isElement
                  ? this.createElementPlane(h)
                  : h.isModel
                    ? this.createModelPlane(h)
                    : this.createEffectPlanes(h));
          }),
            this.calculateRenderOrders());
        }
        calculateRenderOrders() {
          var h;
          let m = -9999;
          this.layers
            .filter((S) => !S.parentLayer)
            .forEach((S) => {
              var E, A, F;
              if (S.isBackground)
                return void ((E = S.getPlane()) == null || E.setRenderOrder(m));
              let V = S.getPlanes().filter(($) => !$.userData.isComposite),
                Y =
                  S.isGpuElement ||
                  (S.isFlattened &&
                    (((A = S.hasRemainingEffects) == null
                      ? void 0
                      : A.call(S)) ||
                      (S.mask && S.mask !== 0)));
              (Y && V.forEach(($) => $.setRenderOrder(m++)),
                (F = S.effects) != null &&
                  F.length &&
                  S.getChildEffectItems().forEach(($) => {
                    $.visible &&
                      $.getPlanes().forEach((le) => le.setRenderOrder(m++));
                  }),
                Y || V.forEach(($) => $.setRenderOrder(m++)));
              let X = S.getPlanes().find(($) => $.userData.isComposite);
              X && X.setRenderOrder(m++);
            });
          let b = this.getPlanes()
            .filter((S) => S.visible)
            .sort((S, E) => S.renderOrder - E.renderOrder)
            .at(-1);
          if (b != null && b.target) {
            let S = b.target;
            ((h = b.removeRenderTarget) == null || h.call(b), S.remove());
          }
        }
        createModelPlane(h) {
          let m = this.createPlane(h);
          m &&
            m
              .onReady(() => {
                ((m.userData.isReady = !0),
                  (m.userData.createdAt = performance.now()));
                let b = h.userDownsample || 1,
                  S = this.curtain.canvas.width * b,
                  E = this.curtain.canvas.height * b;
                h.local.renderTarget ||
                  ((h.local.renderTarget = new r.RenderTarget(this.curtain, {
                    depth: !0,
                    maxWidth: S,
                    maxHeight: E,
                    texturesOptions: {
                      sampler: 'uTexture',
                      premultiplyAlpha: !0,
                    },
                  })),
                  h.local.rendererLoaded ||
                    h.visible === !1 ||
                    h.local.rendererLoading ||
                    ((h.local.rendererLoading = !0),
                    Promise.resolve(h.loadRenderer()).finally(() => {
                      h.local.rendererLoading = !1;
                    })));
              })
              .onRender(() => {
                m.visible &&
                  (this.setModelPlaneUniforms(m, h),
                  this.curtain.gl && h.renderModel());
              });
        }
        createEffectPlanes(h) {
          var $, le, xe, fe;
          var m, b, S, E, A;
          let F = h.data,
            V =
              h.type === 'custom'
                ? (m = h.customPasses) == null
                  ? void 0
                  : m[0]
                : null,
            Y =
              h.type === 'custom'
                ? ((b = h.customPasses) == null ? void 0 : b.length) ||
                  (((S = F.passes) == null ? void 0 : S.length) || 0) + 1
                : (((E = F.passes) == null ? void 0 : E.length) || 0) + 1,
            X = !!(
              (A = h.customPasses) != null &&
              A.some((Se) => (Se == null ? void 0 : Se.pingPong))
            );
          if (F.passes && F.passes.length) {
            let Se = {
              index: 0,
              downSample:
                ($ = V == null ? void 0 : V.downSample) != null
                  ? $
                  : F.downSample,
              length: Y,
              includeBg: V == null ? void 0 : V.includeBg,
              needsPreviousFrame:
                (le = V == null ? void 0 : V.needsPreviousFrame) != null
                  ? le
                  : F.needsPreviousFrame,
            };
            (V != null && V.pingPong
              ? this.createPingPongPlane(h, Se)
              : this.createEffectPlane(h, Se),
              F.passes.forEach((Me, de) => {
                let me = {
                  index: de + 1,
                  length: Y,
                  downSample: Me.downSample,
                  includeBg: Me.includeBg,
                  needsPreviousFrame: Me.needsPreviousFrame,
                  [Me.prop]: Me.value,
                };
                Me.pingPong
                  ? this.createPingPongPlane(h, me)
                  : this.createEffectPlane(h, me);
              }),
              h.usesPingPong && !X && this.createPingPongPlane(h, F.passes));
          } else {
            let Se = V
              ? {
                  index: 0,
                  downSample: (xe = V.downSample) != null ? xe : F.downSample,
                  length: Y,
                  includeBg: V.includeBg,
                  needsPreviousFrame:
                    (fe = V.needsPreviousFrame) != null
                      ? fe
                      : F.needsPreviousFrame,
                }
              : null;
            (V != null && V.pingPong
              ? this.createPingPongPlane(h, Se)
              : Se
                ? this.createEffectPlane(h, Se)
                : this.createEffectPlane(h),
              h.usesPingPong && !X && this.createPingPongPlane(h));
          }
        }
        createTextures() {
          let h = this.getPlanes()
              .filter((S) => S.visible)
              .sort((S, E) => S.renderOrder - E.renderOrder),
            m = this.getRenderTargets(),
            b = h.length;
          for (let S = 0; S < b; S++) {
            let E = h[S],
              A = this.layers.find((F) => F.local.id === E.userData.id);
            (S < b - 1 && this.assignRenderTargetToPlane(h, m, S, A, E),
              this.handleTextures(A, S, E.userData, h, m),
              (A.local.lastTarget = E.target));
          }
        }
        resizeRenderTarget(h, m, b) {
          var S, E, A;
          let F = ((S = h._size) == null ? void 0 : S.width) || 0,
            V = ((E = h._size) == null ? void 0 : E.height) || 0;
          if (Math.abs(F - m) <= 1 && Math.abs(V - b) <= 1) return;
          let Y = (A = h.textures) == null ? void 0 : A[0];
          if (
            (!h._frameBuffer || !(Y != null && Y._copiedFrom)) &&
            ((h._size = { width: m, height: b }),
            (h._maxSize = { width: m, height: b }),
            (h._minSize = { width: m, height: b }),
            h._frameBuffer && Y)
          ) {
            Y._size = { width: m, height: b };
            let X = this.curtain.gl;
            (X.bindTexture(X.TEXTURE_2D, Y._sampler.texture),
              X.texImage2D(
                X.TEXTURE_2D,
                0,
                Y._globalParameters.internalFormat,
                m,
                b,
                0,
                Y._globalParameters.format,
                Y._globalParameters.type,
                null,
              ),
              this.curtain.renderer.bindFrameBuffer(h, !0),
              h._depth &&
                h._depthBuffer &&
                (X.bindRenderbuffer(X.RENDERBUFFER, h._depthBuffer),
                X.renderbufferStorage(
                  X.RENDERBUFFER,
                  X.DEPTH_COMPONENT16,
                  m,
                  b,
                ),
                X.framebufferRenderbuffer(
                  X.FRAMEBUFFER,
                  X.DEPTH_ATTACHMENT,
                  X.RENDERBUFFER,
                  h._depthBuffer,
                )),
              this.curtain.renderer.bindFrameBuffer(null));
          }
        }
        ensureRenderTargetInitialized(h, m, b) {
          h &&
            (m && b && this.resizeRenderTarget(h, m, b),
            h._frameBuffer ||
              (this.curtain.renderer.bindFrameBuffer(h, !0),
              this.curtain.renderer.bindFrameBuffer(null)));
        }
        blitRenderTarget(h, m) {
          var b, S, E;
          let A = (b = this.curtain) == null ? void 0 : b.gl;
          if (!A || typeof A.blitFramebuffer != 'function') return;
          let F =
              ((S = h._size) == null ? void 0 : S.width) ||
              this.curtain.canvas.width,
            V =
              ((E = h._size) == null ? void 0 : E.height) ||
              this.curtain.canvas.height;
          (this.ensureRenderTargetInitialized(h, F, V),
            this.ensureRenderTargetInitialized(m, F, V),
            h != null &&
              h._frameBuffer &&
              m != null &&
              m._frameBuffer &&
              (A.bindFramebuffer(A.READ_FRAMEBUFFER, h._frameBuffer),
              A.bindFramebuffer(A.DRAW_FRAMEBUFFER, m._frameBuffer),
              A.blitFramebuffer(
                0,
                0,
                F,
                V,
                0,
                0,
                F,
                V,
                A.COLOR_BUFFER_BIT,
                A.NEAREST,
              ),
              A.bindFramebuffer(A.READ_FRAMEBUFFER, null),
              A.bindFramebuffer(A.DRAW_FRAMEBUFFER, null)));
        }
        assignRenderTargetToPlane(h, m, b, S, E) {
          let A = this.getTextureParams(h, b, S),
            F = m[b];
          (F
            ? this.resizeRenderTarget(F, A.maxWidth, A.maxHeight)
            : ((F = new r.RenderTarget(this.curtain, A)), (m[b] = F)),
            (F.userData.id = E.userData.id),
            E && E.setRenderTarget(F));
        }
        handleTextures(h, m, b, S, E) {
          b.isComposite
            ? this.handleCompositePlane(h, m, S, E)
            : h.isFlattened
              ? this.handleFlattenedPlane(h, m, E)
              : h.isElement
                ? this.handleElementPlane(h, m, E)
                : h.isModel
                  ? this.handleModelPlane(h, m, E)
                  : h.parentLayer
                    ? this.handleChildEffectPlane(h, m, b, E)
                    : this.handleEffectPlane(h, m, b, E);
        }
        handleItemPlanes(h) {
          (this.createPlanes(),
            this.syncPlaneVisibility(),
            this.createTextures(),
            this.checkIfReady(h));
        }
        checkIfReady(h) {
          let m = () => {
            var b;
            let S = !1,
              E = (b = this.curtain) == null ? void 0 : b.planes;
            if (E) {
              for (let A = 0; A < E.length; A++)
                if (!E[A].userData.isReady) {
                  S = !0;
                  break;
                }
              S ? (this.renderFrame(), requestAnimationFrame(m)) : h();
            }
          };
          m();
        }
        setModelPlaneUniforms(h, m) {
          var A;
          var b, S;
          ((h.uniforms.resolution.value.x = this.curtain.canvas.width),
            (h.uniforms.resolution.value.y = this.curtain.canvas.height),
            m.local.currentFrameMouseValues ||
              (m.local.currentFrameMouseValues =
                this.calculateItemMouseValues(m)));
          let E = m.local.currentFrameMouseValues;
          (E && !m.local.mouse && (m.local.mouse = { x: 0.5, y: 0.5 }),
            E && ((m.local.mouse.x = E.x), (m.local.mouse.y = E.y)),
            h.uniforms.opacity &&
              (h.uniforms.opacity.value = m.local.modelLoaded
                ? (A =
                    (S = (b = m.local) == null ? void 0 : b.stateEffectProps) ==
                    null
                      ? void 0
                      : S.opacity) != null
                  ? A
                  : m.opacity
                : 0));
        }
        setInitialEffectPlaneUniforms(h, m, b, S) {
          var E;
          if (!h.userData.initialUniformsSet || !h.userData.isReady) {
            for (let A in h.uniforms)
              ((E = m.states) != null && E.scroll.some((F) => F.prop === A)) ||
                (m.local.bpProps && A in m.local.bpProps
                  ? nt(m.local.bpProps[A], h.uniforms[A], A)
                  : A in m && nt(m[A], h.uniforms[A], A));
            (b &&
              S &&
              S.index < S.length - 1 &&
              h.uniforms.isMask &&
              (h.uniforms.isMask.value = 0),
              b &&
                m.isMask &&
                !m.mouseMomentum &&
                (m.mouseMomentum = b.mouseMomentum),
              (h.uniforms.resolution.value.x = this.curtain.canvas.width),
              (h.uniforms.resolution.value.y = this.curtain.canvas.height),
              (h.userData.initialUniformsSet = !0));
          }
        }
        handleStateEffects() {
          this.layers.forEach((h) => {
            let m = h.parentLayer ? h.getParent() : null;
            (m ? m.visible : h.visible) && h.updateStateEffects();
          });
        }
        setInitialFlattenedPlaneUniforms(h, m) {
          var b, S;
          (h.uniforms.resolution &&
            this.curtain.canvas &&
            ((h.uniforms.resolution.value.x = this.curtain.canvas.width),
            (h.uniforms.resolution.value.y = this.curtain.canvas.height)),
            h.uniforms.artboardResolution &&
              ((h.uniforms.artboardResolution.value.x = this.canvasWidth),
              (h.uniforms.artboardResolution.value.y = this.canvasHeight)));
          for (let E in h.uniforms)
            ((b = m.states) != null && b.scroll.some((A) => A.prop === E)) ||
              ((S = m.states) != null &&
                S.appear.some((A) => A.prop === E && !A.complete)) ||
              (m.local.bpProps && E in m.local.bpProps
                ? nt(m.local.bpProps[E], h.uniforms[E], E)
                : E in m && nt(m[E], h.uniforms[E], E));
        }
        setFlattenedPlaneUniforms(h, m) {
          var b, S, E, A, F;
          if (!h.visible) return;
          if (
            (this.ensureFlattenedPlaneTextures(h, m),
            m.local.modelInstances &&
              Object.entries(m.local.modelInstances).forEach(([Y, X]) => {
                if (!X || !X.local) return;
                let $ =
                  h.uniforms[`L${Y}_elemOpacity`] ||
                  h.uniforms[`L${Y}_opacity`];
                if ($ && $.value === 0) return;
                let le = `L${Y}_`,
                  xe = {};
                if (m.local.bpProps)
                  for (let Se in m.local.bpProps)
                    Se.startsWith(le) &&
                      (xe[Se.slice(le.length)] = m.local.bpProps[Se]);
                if (m.local.stateEffectProps)
                  for (let Se in m.local.stateEffectProps)
                    Se.startsWith(le) &&
                      (xe[Se.slice(le.length)] = m.local.stateEffectProps[Se]);
                X.local.stateEffectProps = xe;
                let fe = this.calculateItemMouseValues(X);
                (fe && !X.local.mouse && (X.local.mouse = { x: 0.5, y: 0.5 }),
                  fe && ((X.local.mouse.x = fe.x), (X.local.mouse.y = fe.y)),
                  X.renderModel());
              }),
            (b = m.local.stateEffectProps) != null &&
              b.playbackRate &&
              h.videos.at(-1) &&
              (h.videos.at(-1).playbackRate =
                m.local.stateEffectProps.playbackRate),
            h.uniforms.mousePos && this.mouse.movedInView)
          ) {
            m.local.currentFrameMouseValues ||
              (m.local.currentFrameMouseValues =
                this.calculateItemMouseValues(m));
            let Y = m.local.currentFrameMouseValues;
            Y &&
              ((h.uniforms.mousePos.value.x = Y.x),
              (h.uniforms.mousePos.value.y = Y.y));
          }
          let V = (Y) => {
            let X = Y.match(/^L(\d+)_/);
            if (!X) return !1;
            let $ = X[1],
              le =
                h.uniforms[`L${$}_elemOpacity`] || h.uniforms[`L${$}_opacity`];
            return le && le.value === 0;
          };
          if (
            ((E = (S = m.data) == null ? void 0 : S.timeUniforms) != null &&
              E.length &&
              m.data.timeUniforms.forEach(
                ({ key: Y, speed: X, animating: $ }) => {
                  var xe, fe, Se;
                  var le;
                  if (!V(Y) && h.uniforms[Y] && $ !== !1) {
                    let Me = Y.replace(/_time$/, '_speed'),
                      de =
                        (Se =
                          (fe =
                            (xe =
                              (le = m.local.stateEffectProps) == null
                                ? void 0
                                : le[Me]) != null
                              ? xe
                              : m[Me]) != null
                            ? fe
                            : X) != null
                          ? Se
                          : 1;
                    h.uniforms[Y].value += (60 * de) / this.fps;
                  }
                },
              ),
            (F = (A = m.data) == null ? void 0 : A.mouseUniforms) == null
              ? void 0
              : F.length)
          ) {
            let Y = this.bbox.width / 2,
              X = this.bbox.height / 2,
              $ = this.mouse.pos.x,
              le = this.mouse.pos.y;
            (m.local.mouseStates || (m.local.mouseStates = {}),
              m.data.mouseUniforms.forEach(
                ({ key: xe, momentum: fe, spring: Se, trackAxes: Me }) => {
                  if (!h.uniforms[xe] || V(xe)) return;
                  let de = Me || 'xy',
                    me = de === 'x' || de === 'xy',
                    De = de === 'y' || de === 'xy',
                    Ge = Se || 0;
                  if (!m.local.mouseStates[xe])
                    return (
                      (m.local.mouseStates[xe] = {
                        x: me ? $ / Y : 0.5,
                        y: De ? 1 - le / X : 0.5,
                        vx: 0,
                        vy: 0,
                      }),
                      (h.uniforms[xe].value.x = m.local.mouseStates[xe].x),
                      void (h.uniforms[xe].value.y = m.local.mouseStates[xe].y)
                    );
                  let ze = m.local.mouseStates[xe],
                    lt = ze.x * Y,
                    st = (1 - ze.y) * X;
                  if (Ge > 0) {
                    if (me) {
                      let ft = Ee(lt, $, ze.vx, fe, Ge);
                      ((ze.x = ft.value / Y), (ze.vx = ft.velocity));
                    } else ze.x = 0.5;
                    if (De) {
                      let ft = Ee(st, le, ze.vy, fe, Ge);
                      ((ze.y = 1 - ft.value / X), (ze.vy = ft.velocity));
                    } else ze.y = 0.5;
                  } else
                    ((ze.x = me ? pe($, lt, 2 * fe) / Y : 0.5),
                      (ze.y = De ? 1 - pe(le, st, 2 * fe) / X : 0.5));
                  ((h.uniforms[xe].value.x = ze.x),
                    (h.uniforms[xe].value.y = ze.y));
                },
              ));
          }
        }
        setInitialElementPlaneUniforms(h, m) {
          var S;
          var b;
          ((h.uniforms.resolution.value.x = this.curtain.canvas.width),
            (h.uniforms.resolution.value.y = this.curtain.canvas.height),
            h.uniforms.artboardResolution &&
              ((h.uniforms.artboardResolution.value.x = this.canvasWidth),
              (h.uniforms.artboardResolution.value.y = this.canvasHeight)));
          for (let E in h.uniforms)
            m.local.bpProps && E in m.local.bpProps
              ? (h.uniforms[E].value = m.local.bpProps[E])
              : E in m &&
                (h.uniforms[E].value =
                  (S =
                    (b = m.local.stateEffectProps) == null ? void 0 : b[E]) !=
                  null
                    ? S
                    : m[E]);
        }
        setElementPlaneUniforms(h, m) {
          if (
            h.visible &&
            (h.uniforms.resolution &&
              ((h.uniforms.resolution.value.x = this.curtain.canvas.width),
              (h.uniforms.resolution.value.y = this.curtain.canvas.height)),
            h.uniforms.artboardResolution &&
              ((h.uniforms.artboardResolution.value.x = this.canvasWidth),
              (h.uniforms.artboardResolution.value.y = this.canvasHeight)),
            h.uniforms.mousePos)
          ) {
            m.local.currentFrameMouseValues ||
              (m.local.currentFrameMouseValues =
                this.calculateItemMouseValues(m));
            let b = m.local.currentFrameMouseValues;
            !this.mouse.movedInView ||
              (h.uniforms.mousePos.value.x === b.x &&
                h.uniforms.mousePos.value.y === b.y) ||
              ((h.uniforms.mousePos.value.x = b.x),
              (h.uniforms.mousePos.value.y = b.y));
          }
        }
        calculateItemMouseValues(h) {
          if (!this.mouse.movedInView) return null;
          let m = this.bbox.width / 2,
            b = this.bbox.height / 2,
            S = this.getMousePosWithMomentum(h, m, b);
          return (
            h.local.mouseValuePool ||
              (h.local.mouseValuePool = new r.Vec2(0.5)),
            (h.local.mouseValuePool.x = S.x),
            (h.local.mouseValuePool.y = S.y),
            h.local.mouseValuePool
          );
        }
        getMousePosWithMomentum(h, m, b) {
          let S = this.mouse.pos.x,
            E = this.mouse.pos.y,
            A = h.trackAxes || 'xy',
            F = A === 'x' || A === 'xy',
            V = A === 'y' || A === 'xy',
            Y = h.mouseMomentum || 0,
            X = h.mouseSpring || 0,
            $ = S / m,
            le = 1 - E / b;
          if (!Y && !X) return { x: F ? $ : 0.5, y: V ? le : 0.5 };
          if (!h.local.lastMousePos)
            return (
              (h.local.lastMousePos = { x: F ? $ : 0.5, y: V ? le : 0.5 }),
              h.local.lastMousePos
            );
          let xe = h.local.lastMousePos.x * m,
            fe = (1 - h.local.lastMousePos.y) * b;
          if (X > 0) {
            if (
              (h.local.mouseVelocity ||
                (h.local.mouseVelocity = { x: 0, y: 0 }),
              F)
            ) {
              let de = Ee(xe, S, h.local.mouseVelocity.x, Y, X);
              ((S = de.value),
                (h.local.mouseVelocity.x = de.velocity),
                (h.local.lastMousePos.x = S / m));
            } else h.local.lastMousePos.x = 0.5;
            if (V) {
              let de = Ee(fe, E, h.local.mouseVelocity.y, Y, X);
              ((E = de.value),
                (h.local.mouseVelocity.y = de.velocity),
                (h.local.lastMousePos.y = 1 - E / b));
            } else h.local.lastMousePos.y = 0.5;
            return h.local.lastMousePos;
          }
          let Se = Math.abs(S - xe),
            Me = Math.abs(E - fe);
          return (
            (Se < R && Me < R) ||
              (F
                ? ((S = pe(S, xe, 2 * Y)), (h.local.lastMousePos.x = S / m))
                : (h.local.lastMousePos.x = 0.5),
              V
                ? ((E = pe(E, fe, 2 * Y)), (h.local.lastMousePos.y = 1 - E / b))
                : (h.local.lastMousePos.y = 0.5)),
            h.local.lastMousePos
          );
        }
        setEffectPlaneUniforms(h, m) {
          var Y, X;
          var b, S, E, A;
          if (!h.visible) return;
          let F =
            (X =
              (Y = (b = m.local.stateEffectProps) == null ? void 0 : b.speed) !=
              null
                ? Y
                : m.speed) != null
              ? X
              : 1;
          if (
            (m.animating &&
              h.uniforms.time &&
              (h.uniforms.time.value += (60 * F) / this.fps),
            (S = m.local.stateEffectProps) != null &&
              S.playbackRate &&
              h.videos.at(-1) &&
              (h.videos.at(-1).playbackRate =
                m.local.stateEffectProps.playbackRate),
            Ne() &&
              ((A = (E = this.interactivity) == null ? void 0 : E.mouse) == null
                ? void 0
                : A.disableMobile))
          )
            return !1;
          if (!this.mouse.movedInView) return;
          m.local.currentFrameMouseValues ||
            (m.local.currentFrameMouseValues =
              this.calculateItemMouseValues(m));
          let V = m.local.currentFrameMouseValues;
          V &&
            (h.uniforms.previousMousePos &&
              (this.mouse.ticks > 16
                ? ((h.uniforms.previousMousePos.value.x =
                    h.uniforms.mousePos.value.x),
                  (h.uniforms.previousMousePos.value.y =
                    h.uniforms.mousePos.value.y))
                : ((h.uniforms.previousMousePos.value.x = V.x),
                  (h.uniforms.previousMousePos.value.y = V.y))),
            h.uniforms.mousePos &&
              !V.equals(h.uniforms.mousePos.value) &&
              ((h.uniforms.mousePos.value.x = V.x),
              (h.uniforms.mousePos.value.y = V.y)),
            this.mouse.ticks++);
        }
        getOrderedItems() {
          let h = [];
          return (
            this.layers
              .filter((m) => !m.parentLayer)
              .forEach((m) => {
                (m.effects &&
                  m.effects.length &&
                  h.push(...m.getChildEffectItems()),
                  h.push(m));
              }),
            h
          );
        }
        getTextureParams(h, m, b) {
          var S;
          let E = h[m],
            A = 1;
          return (
            E.userData.downSample &&
              (A =
                typeof E.userData.downSample == 'number'
                  ? E.userData.downSample
                  : 0.5),
            {
              maxWidth: this.curtain.canvas.width * A,
              maxHeight: this.curtain.canvas.height * A,
              depth:
                (S = b == null ? void 0 : b.data) == null ? void 0 : S.depth,
            }
          );
        }
        handlePlaneCreation() {
          ((this.initialized = !0),
            (this.initializing = !1),
            this.rendering || this.renderNFrames(2),
            this.waitForAssetsAndDisablePlanes(),
            Pe());
        }
        waitForAssetsAndDisablePlanes() {
          (this.local.preloadedImages &&
            Object.values(this.local.preloadedImages).some((h) => h.loading)) ||
          this.layers.some(
            (h) =>
              h.visible !== !1 &&
              ((h.isModel && !h.local.modelLoaded) ||
                (h.layerType === 'image' && !h.local.imageReady) ||
                (h.layerType === 'text' && !h.local.loaded) ||
                (h.isFlattened &&
                  (!h.areTextAssetsReady() ||
                    !h.areImageAssetsReady() ||
                    !h.areModelAssetsReady()))),
          )
            ? setTimeout(() => this.waitForAssetsAndDisablePlanes(), 32)
            : (this.layers
                .filter((h) => h.preloadedCanvasTexture)
                .forEach((h) => {
                  h.preloadedCanvasTexture.shouldUpdate =
                    h.preloadedCanvasTexture.userData.hasStateEffects || !1;
                }),
              this.layers
                .filter((h) => h.isFlattened)
                .forEach((h) => {
                  Object.values(h.local.canvasTextures || {}).forEach((m) => {
                    m && (m.shouldUpdate = !1);
                  });
                }),
              this.curtain &&
                this.curtain.planes.forEach((h) => {
                  h.videos.forEach((m) => {
                    m.currentTime = 0;
                  });
                }),
              this.renderFrame(),
              setTimeout(() => this.disablePlanes(), 16));
        }
        disablePlanes() {
          let h = this.getSplitOrderedItems();
          h.dynamic.length || h.static.pop();
          for (let m of h.static)
            m.getPlanes().forEach((b) => {
              b._canDraw = !1;
            });
        }
      }
      function Fe(D, h, m) {
        D.addEventListener(h, m, { passive: !0 });
      }
      function rt(D, h, m) {
        D.removeEventListener(h, m);
      }
      function vt() {
        (Fe(window, 'scroll', ge),
          Ne() ? Fe(window, 'touchmove', Ve) : Fe(window, 'mousemove', Ve),
          Fe(window, 'routeChange', tt),
          Fe(document, 'mouseleave', ke),
          (c = (function (D, h) {
            let m;
            return function (...b) {
              (clearTimeout(m),
                (m = setTimeout(() => {
                  D.apply(this, b);
                }, h)));
            };
          })(C, 16)),
          Ne() ? Fe(window, 'orientationchange', c) : Fe(window, 'resize', c),
          Fe(document, a, H),
          (u = !0));
      }
      function j() {
        (rt(window, 'mousemove', Ve),
          rt(window, 'touchmove', Ve),
          rt(window, 'scroll', ge),
          rt(window, 'routeChange', tt),
          rt(document, 'mouseleave', ke),
          c && (rt(window, 'resize', c), rt(window, 'orientationchange', c)),
          rt(document, a, H),
          (u = !1));
      }
      function Ce() {
        try {
          return !!document.createElement('canvas').getContext('webgl2');
        } catch (D) {
          return !1;
        }
      }
      function ye(D) {
        let h = D.projectId ? D.projectId.split('?')[0] : null,
          m = D.projectId ? D.projectId.split('?')[1] : null;
        return new Promise((b, S) => {
          (function (E, A, F, V, Y) {
            let X;
            if (F) {
              X = F;
              let $ = document.getElementById(F);
              if ($)
                try {
                  let le = JSON.parse($.innerText);
                  return le != null &&
                    le.options &&
                    ((le != null && le.layers) || (le != null && le.history))
                    ? Promise.resolve(le)
                    : (V(new Error(`Did not find valid JSON inside ${F}`)),
                      Promise.reject());
                } catch (le) {
                  return (
                    V(new Error(`Error parsing JSON from ${F}: ${le.message}`)),
                    Promise.reject()
                  );
                }
            } else {
              let $ = 'https://storage.googleapis.com/unicornstudio-production';
              (Y || (A != null && A.includes('production=true'))
                ? (($ = 'https://assets.unicorn.studio'),
                  (A = `v=${Date.now()}`))
                : (A != null && A.includes('update=')) ||
                  (A = `v=${Date.now()}`),
                (X = `${$}/embeds/${E}${A ? '?' + A : ''}`));
            }
            return fetch(X)
              .then(($) => $.json())
              .then(($) => $)
              .catch(($) => {});
          })(h, m, D.filePath, S, D.production)
            .then((E) => {
              var A;
              (E && (E.layers || E.history) && E.options) ||
                S(
                  new Error(
                    `Error fetching data for project id '${D.projectId}'`,
                  ),
                );
              let F = E.options || {},
                V =
                  ((Y = D.element),
                  (
                    typeof HTMLElement == 'object'
                      ? Y instanceof HTMLElement
                      : Y &&
                        typeof Y == 'object' &&
                        Y !== null &&
                        Y.nodeType === 1 &&
                        typeof Y.nodeName == 'string'
                  )
                    ? D.element
                    : document.getElementById(D.elementId));
              var Y;
              if (!V)
                return void S(
                  new Error(
                    `Couldn't find an element with id '${D.elementId}' on the page.`,
                  ),
                );
              let X = K();
              V.setAttribute('data-scene-id', X);
              let $ = D.scale || F.scale || 1,
                le = D.dpi || F.dpi || Math.min(1.5, window.devicePixelRatio),
                xe = (function (Me, de, me, De) {
                  let Ge = De ? Fi(pt({}, me), { modules: De }) : me,
                    ze = [];
                  return (
                    Me.forEach((lt) => {
                      switch (lt.layerType) {
                        case 'text':
                          ze.push(new bt(lt, de, Ge).unpackage());
                          break;
                        case 'image':
                          ze.push(new Ut(lt, de, Ge).unpackage());
                          break;
                        case 'model':
                          ze.push(new Ue(lt, de, Ge).unpackage());
                          break;
                        case 'shape':
                          ze.push(new ee(lt, de, Ge).unpackage());
                          break;
                        case 'effect':
                          ze.push(new xt(lt, de, Ge).unpackage());
                          break;
                        case 'flattened': {
                          let st = new _t(lt, de, Ge).unpackage();
                          (ze.push(st),
                            st.getChildEffectItems().forEach((ft) => {
                              ze.push(ft);
                            }));
                          break;
                        }
                      }
                    }),
                    ze
                  );
                })(
                  E.layers || E.history,
                  X,
                  (function (Me, de, me) {
                    return {
                      canvasWidth: Me.offsetWidth,
                      canvasHeight: Me.offsetHeight,
                      scale: de,
                      dpi: me,
                      element: Me,
                    };
                  })(V, $, le),
                  E.modules,
                );
              if (!Ce()) {
                let Me = (function ({ id: de, element: me, layers: De }) {
                  return {
                    id: de,
                    element: me,
                    layers: De,
                    destroyed: !1,
                    fallbackOnly: !0,
                    getDynamicLayers: () => [],
                    destroy() {
                      ((this.destroyed = !0),
                        this.element &&
                          (this.element.removeAttribute('data-us-initialized'),
                          this.element.removeAttribute('data-scene-id'),
                          this.element
                            .querySelectorAll('[data-us-text]')
                            .forEach((Ge) => {
                              Ge.remove();
                            })));
                    },
                  };
                })({ id: X, element: V, layers: xe });
                return (
                  (function (de, me) {
                    de.forEach((De) => {
                      var Ge;
                      (De.layerType === 'text' && ot(De, me),
                        Object.values(
                          ((Ge = De.local) == null
                            ? void 0
                            : Ge.textInstances) || {},
                        ).forEach((ze) => {
                          ot(ze, me);
                        }));
                    });
                  })(xe, V),
                  Te.push(Me),
                  void b(Me)
                );
              }
              let fe = new Ie({
                id: X,
                fps: D.fps || F.fps || 60,
                dpi: le,
                name: F.name,
                projectId: h || D.filePath.split('.')[0],
                renderingScale: $,
                element: V,
                lazyLoad: D.lazyLoad,
                fixed: D.fixed,
                width: D.width,
                height: D.height,
                breakpoints: D.breakpoints || F.breakpoints,
              });
              ((A = fe.curtain) != null &&
                A.canvas &&
                ((fe.curtain.canvas.innerText = D.altText || ''),
                fe.curtain.canvas.setAttribute(
                  'aria-label',
                  D.ariaLabel || 'Unicorn Studio Scene',
                ),
                fe.curtain.canvas.setAttribute('role', 'img')),
                (F[re('ZnJlZVBsYW4=')] || F[re('aW5jbHVkZUxvZ28=')]) &&
                  (function (Me, de) {
                    let me = document.createElement('a');
                    ((me.href = 'https://unicorn.studio?utm_source=public-url'),
                      (me.style =
                        'position: absolute; display: flex; bottom: 30px; left: 0; width: 190px; margin: 0 auto; right: 0rem; padding: 10px; border-radius: 6px; background-color: rgba(255, 255, 255, 1); box-shadow: 0 3px 9px 0 rgba(0, 0, 0, .2); z-index: 99999999; box-sizing: border-box;'),
                      (me.target = '_blank'));
                    let De = document.createElement('img');
                    ((De.src = re(
                      'aHR0cHM6Ly9hc3NldHMudW5pY29ybi5zdHVkaW8vbWVkaWEvbWFkZV9pbl91c19zbWFsbF93ZWIuc3Zn',
                    )),
                      (De.alt = re('TWFkZSB3aXRoIHVuaWNvcm4uc3R1ZGlv')),
                      (De.style = 'width: 170px; height: auto;'),
                      me.appendChild(De),
                      de.appendChild(me));
                  })(0, V),
                Te.push(fe),
                (fe.layers = xe),
                fe.preloadTextures(),
                fe.setInteractiveParams(D, F),
                (fe.isInView = fe.isFixed || se(fe.element, fe.bbox, 50)),
                (fe.lazyLoad && !fe.isInView) || fe.initializePlanes(),
                u || vt(),
                b(fe));
            })
            .catch((E) => {
              S(E);
            });
        });
      }
      ((s.addScene = ye),
        (s.destroy = function () {
          (Te.forEach((D) => {
            D.destroy();
          }),
            (Te.length = 0),
            j());
        }),
        (s.init = function () {
          return (
            Ce(),
            new Promise((D, h) => {
              let m = [
                  ...document.querySelectorAll(
                    '[data-us-project], [data-us-project-src]',
                  ),
                ],
                b =
                  typeof window != 'undefined' && window.requestIdleCallback
                    ? window.requestIdleCallback
                    : (S) => setTimeout(S, 0);
              m.filter((S) => !S.getAttribute('data-us-initialized')).forEach(
                (S, E) => {
                  (S.setAttribute('data-us-initialized', !0),
                    b(() => {
                      let A = Be(S, 'data-us-project'),
                        F = Be(S, 'data-us-project-src'),
                        V = Be(S, 'data-us-disablemobile'),
                        Y = Be(S, 'data-us-disablemouse');
                      ye({
                        projectId: F ? null : A,
                        filePath: F,
                        element: S,
                        dpi: +Be(S, 'data-us-dpi'),
                        scale: +Be(S, 'data-us-scale'),
                        production: Be(S, 'data-us-production'),
                        fps: +Be(S, 'data-us-fps'),
                        lazyLoad: Be(S, 'data-us-lazyload'),
                        altText: Be(S, 'data-us-alttext'),
                        ariaLabel: Be(S, 'data-us-arialabel'),
                        fixed: Be(S, 'data-us-fixed'),
                        interactivity:
                          V || Y
                            ? { mouse: { disableMobile: V, disabled: Y } }
                            : null,
                      }).then((X) => {
                        E === m.length - 1 && D(Te);
                      });
                    }));
                },
              );
            })
          );
        }),
        (s.scenes = Te),
        (s.setScroll = function (D) {
          let h = z(D);
          h !== null && ((p = h), q(h), Re());
        }),
        (s.unbindEvents = j),
        (s.useNativeScroll = function () {
          ((p = null), q(), Re());
        }),
        (s.version = I),
        Object.defineProperty(s, Symbol.toStringTag, { value: 'Module' }));
    });
  });
  var Ye = (s, e) => (e != null ? e : document).querySelector(s),
    xi = (s, e) => (e != null ? e : document).querySelectorAll(s),
    Rf = (s) =>
      new Promise((e) => {
        setTimeout(() => e(s), s);
      });
  var qn = (s, e, t) => Math.min(Math.max(s, e), t),
    I_ = () =>
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var Fs = (s) => {
    let { targets: e, options: t, isOnce: i = !1, callback: n } = s,
      r = new IntersectionObserver(
        (o, a) => {
          o.forEach((l) => {
            (n(l), i && l.isIntersecting && a.unobserve(l.target));
          });
        },
        pt({ root: null, rootMargin: '0px', threshold: 0 }, t),
      );
    e.forEach((o) => {
      r.observe(o);
    });
  };
  var Qb = (s = 960) => `(min-width: ${s}px)`,
    xl = window.matchMedia(Qb()),
    Xt = () => !xl.matches,
    D_ = () => window.innerHeight > window.innerWidth;
  var O_ = (s) => {
    var e;
    (e = window.dataLayer) == null || e.push({ event: s });
  };
  var go = {
    ready: 'at-cmn:ready',
    modalOpen: 'at-cmn:modal:open',
    modalClose: 'at-cmn:modal:close',
    accordionTransitionEnd: 'at-cmn:accordion:transition-end',
  };
  var Cf = class {
      constructor() {
        y(this, 'openModalNames', new Set());
        y(this, 'listeners', new Set());
        y(this, 'subscribe', (e) => {
          this.listeners.add(e);
        });
        y(this, 'onToggle', (e, t) => {
          let i = this.isOpen;
          (t ? this.openModalNames.add(e) : this.openModalNames.delete(e),
            this.isOpen !== i && this.listeners.forEach((n) => n(this.isOpen)));
        });
        (document.addEventListener(go.modalOpen, (e) =>
          this.onToggle(e.detail.modalName, !0),
        ),
          document.addEventListener(go.modalClose, (e) =>
            this.onToggle(e.detail.modalName, !1),
          ));
      }
      get isOpen() {
        return this.openModalNames.size > 0;
      }
    },
    li = new Cf();
  var Pf = { player: 'data-bg-video', section: 'data-bg-video-section' },
    N_ = { status: { isVisible: 'is-visible' } };
  var Jc = class {
    constructor() {
      y(this, 'videoElm');
      y(this, 'sectionElms');
      y(this, 'isHeld', !1);
      y(this, 'visibleSections', new Set());
      y(this, 'hold', () => {
        this.isHeld = !0;
      });
      y(this, 'release', () => {
        ((this.isHeld = !1), this.update());
      });
      y(this, 'releaseFrom', (e, t) => {
        this.isHeld = !1;
        let { videoElm: i } = this;
        if (i) {
          if (t) {
            let n = e.currentTime;
            i.readyState >= HTMLMediaElement.HAVE_METADATA
              ? (i.currentTime = n)
              : i.addEventListener(
                  'loadedmetadata',
                  () => {
                    i.currentTime = n;
                  },
                  { once: !0 },
                );
          } else if (e.currentSrc && !e.error && !e.paused) {
            let n = e.currentTime,
              r = i.src;
            ((i.loop = !1),
              (i.src = e.currentSrc),
              i.addEventListener(
                'loadedmetadata',
                () => {
                  i.currentTime = n;
                },
                { once: !0 },
              ));
            let o = () => {
              ((i.src = r), (i.loop = !0), i.play().catch(() => {}));
            };
            (i.addEventListener('ended', o, { once: !0 }),
              i.addEventListener('error', o, { once: !0 }));
          }
          this.update();
        }
      });
      y(this, 'init', () => {
        !this.checkElements() ||
          !this.videoElm ||
          (document.addEventListener('visibilitychange', this.update),
          li.subscribe(this.update),
          Fs({
            targets: Array.from(this.sectionElms),
            callback: this.onIntersect,
          }));
      });
      y(
        this,
        'checkElements',
        () => !!(this.videoElm && this.sectionElms.length),
      );
      y(this, 'onIntersect', (e) => {
        (e.isIntersecting
          ? this.visibleSections.add(e.target)
          : this.visibleSections.delete(e.target),
          this.update());
      });
      y(this, 'update', () => {
        if (!this.videoElm) return;
        let e = document.visibilityState === 'visible',
          t = !this.isHeld && this.visibleSections.size > 0 && e && !li.isOpen;
        (this.videoElm.classList.toggle(N_.status.isVisible, t),
          t
            ? this.videoElm.paused && this.videoElm.play().catch(() => {})
            : this.videoElm.paused || this.videoElm.pause());
      });
      ((this.videoElm = Ye(`[${Pf.player}]`)),
        (this.sectionElms = xi(`[${Pf.section}]`)),
        this.init());
    }
  };
  function F_(s, e) {
    for (var t = 0; t < e.length; t++) {
      var i = e[t];
      ((i.enumerable = i.enumerable || !1),
        (i.configurable = !0),
        'value' in i && (i.writable = !0),
        Object.defineProperty(s, i.key, i));
    }
  }
  function eS(s, e, t) {
    return (e && F_(s.prototype, e), t && F_(s, t), s);
  }
  var Wi,
    th,
    tS,
    Dn,
    Ir,
    Dr,
    ra,
    B_,
    _o,
    oa,
    k_,
    rr,
    fs,
    H_,
    z_ = function () {
      return (
        Wi ||
        (typeof window != 'undefined' &&
          (Wi = window.gsap) &&
          Wi.registerPlugin &&
          Wi)
      );
    },
    V_ = 1,
    sa = [],
    Lt = [],
    ps = [],
    bl = Date.now,
    Lf = function (e, t) {
      return t;
    },
    iS = function () {
      var e = oa.core,
        t = e.bridge || {},
        i = e._scrollers,
        n = e._proxies;
      (i.push.apply(i, Lt),
        n.push.apply(n, ps),
        (Lt = i),
        (ps = n),
        (Lf = function (o, a) {
          return t[o](a);
        }));
    },
    ar = function (e, t) {
      return ~ps.indexOf(e) && ps[ps.indexOf(e) + 1][t];
    },
    Sl = function (e) {
      return !!~k_.indexOf(e);
    },
    un = function (e, t, i, n, r) {
      return e.addEventListener(t, i, { passive: n !== !1, capture: !!r });
    },
    hn = function (e, t, i, n) {
      return e.removeEventListener(t, i, !!n);
    },
    Qc = 'scrollLeft',
    eh = 'scrollTop',
    If = function () {
      return (rr && rr.isPressed) || Lt.cache++;
    },
    ih = function (e, t) {
      var i = function n(r) {
        if (r || r === 0) {
          V_ && (Dn.history.scrollRestoration = 'manual');
          var o = rr && rr.isPressed;
          ((r = n.v = Math.round(r) || (rr && rr.iOS ? 1 : 0)),
            e(r),
            (n.cacheID = Lt.cache),
            o && Lf('ss', r));
        } else
          (t || Lt.cache !== n.cacheID || Lf('ref')) &&
            ((n.cacheID = Lt.cache), (n.v = e()));
        return n.v + n.offset;
      };
      return ((i.offset = 0), e && i);
    },
    Ki = {
      s: Qc,
      p: 'left',
      p2: 'Left',
      os: 'right',
      os2: 'Right',
      d: 'width',
      d2: 'Width',
      a: 'x',
      sc: ih(function (s) {
        return arguments.length
          ? Dn.scrollTo(s, Mi.sc())
          : Dn.pageXOffset || Ir[Qc] || Dr[Qc] || ra[Qc] || 0;
      }),
    },
    Mi = {
      s: eh,
      p: 'top',
      p2: 'Top',
      os: 'bottom',
      os2: 'Bottom',
      d: 'height',
      d2: 'Height',
      a: 'y',
      op: Ki,
      sc: ih(function (s) {
        return arguments.length
          ? Dn.scrollTo(Ki.sc(), s)
          : Dn.pageYOffset || Ir[eh] || Dr[eh] || ra[eh] || 0;
      }),
    },
    dn = function (e, t) {
      return (
        ((t && t._ctx && t._ctx.selector) || Wi.utils.toArray)(e)[0] ||
        (typeof e == 'string' && Wi.config().nullTargetWarn !== !1
          ? void 0
          : null)
      );
    },
    nS = function (e, t) {
      for (var i = t.length; i--; )
        if (t[i] === e || t[i].contains(e)) return !0;
      return !1;
    },
    or = function (e, t) {
      var i = t.s,
        n = t.sc;
      Sl(e) && (e = Ir.scrollingElement || Dr);
      var r = Lt.indexOf(e),
        o = n === Mi.sc ? 1 : 2;
      (!~r && (r = Lt.push(e) - 1), Lt[r + o] || un(e, 'scroll', If));
      var a = Lt[r + o],
        l =
          a ||
          (Lt[r + o] =
            ih(ar(e, i), !0) ||
            (Sl(e)
              ? n
              : ih(function (c) {
                  return arguments.length ? (e[i] = c) : e[i];
                })));
      return (
        (l.target = e),
        a || (l.smooth = Wi.getProperty(e, 'scrollBehavior') === 'smooth'),
        l
      );
    },
    nh = function (e, t, i) {
      var n = e,
        r = e,
        o = bl(),
        a = o,
        l = t || 50,
        c = Math.max(500, l * 3),
        u = function (_, x) {
          var g = bl();
          x || g - o > l
            ? ((r = n), (n = _), (a = o), (o = g))
            : i
              ? (n += _)
              : (n = r + ((_ - r) / (g - a)) * (o - a));
        },
        f = function () {
          ((r = n = i ? 0 : n), (a = o = 0));
        },
        d = function (_) {
          var x = a,
            g = r,
            v = bl();
          return (
            (_ || _ === 0) && _ !== n && u(_),
            o === a || v - a > c
              ? 0
              : ((n + (i ? g : -g)) / ((i ? v : o) - x)) * 1e3
          );
        };
      return { update: u, reset: f, getVelocity: d };
    },
    yl = function (e, t) {
      return (
        t && !e._gsapAllow && e.cancelable !== !1 && e.preventDefault(),
        e.changedTouches ? e.changedTouches[0] : e
      );
    },
    U_ = function (e) {
      var t = Math.max.apply(Math, e),
        i = Math.min.apply(Math, e);
      return Math.abs(t) >= Math.abs(i) ? t : i;
    },
    G_ = function () {
      ((oa = Wi.core.globals().ScrollTrigger), oa && oa.core && iS());
    },
    W_ = function (e) {
      return (
        (Wi = e || z_()),
        !th &&
          Wi &&
          typeof document != 'undefined' &&
          document.body &&
          ((Dn = window),
          (Ir = document),
          (Dr = Ir.documentElement),
          (ra = Ir.body),
          (k_ = [Dn, Ir, Dr, ra]),
          (tS = Wi.utils.clamp),
          (H_ = Wi.core.context || function () {}),
          (_o = 'onpointerenter' in ra ? 'pointer' : 'mouse'),
          (B_ = mi.isTouch =
            Dn.matchMedia &&
            Dn.matchMedia('(hover: none), (pointer: coarse)').matches
              ? 1
              : 'ontouchstart' in Dn ||
                  navigator.maxTouchPoints > 0 ||
                  navigator.msMaxTouchPoints > 0
                ? 2
                : 0),
          (fs = mi.eventTypes =
            (
              'ontouchstart' in Dr
                ? 'touchstart,touchmove,touchcancel,touchend'
                : 'onpointerdown' in Dr
                  ? 'pointerdown,pointermove,pointercancel,pointerup'
                  : 'mousedown,mousemove,mouseup,mouseup'
            ).split(',')),
          setTimeout(function () {
            return (V_ = 0);
          }, 500),
          (th = 1)),
        oa || G_(),
        th
      );
    };
  Ki.op = Mi;
  Lt.cache = 0;
  var mi = (function () {
    function s(t) {
      this.init(t);
    }
    var e = s.prototype;
    return (
      (e.init = function (i) {
        (th || W_(Wi), oa || G_());
        var n = i.tolerance,
          r = i.dragMinimum,
          o = i.type,
          a = i.target,
          l = i.lineHeight,
          c = i.debounce,
          u = i.preventDefault,
          f = i.onStop,
          d = i.onStopDelay,
          p = i.ignore,
          _ = i.wheelSpeed,
          x = i.event,
          g = i.onDragStart,
          v = i.onDragEnd,
          w = i.onDrag,
          L = i.onPress,
          R = i.onRelease,
          U = i.onRight,
          O = i.onLeft,
          N = i.onUp,
          M = i.onDown,
          I = i.onChangeX,
          z = i.onChangeY,
          W = i.onChange,
          q = i.onToggleX,
          re = i.onToggleY,
          oe = i.onHover,
          K = i.onHoverEnd,
          ie = i.onMove,
          J = i.ignoreCheck,
          pe = i.isNormalizer,
          Ee = i.onGestureStart,
          Z = i.onGestureEnd,
          Ne = i.onWheel,
          Be = i.onEnable,
          ht = i.onDisable,
          ot = i.onClick,
          tt = i.scrollSpeed,
          ve = i.capture,
          Pe = i.allowClicks,
          Ae = i.lockAxis,
          Ze = i.onLockAxis;
        ((this.target = a = dn(a) || Dr),
          (this.vars = i),
          p && (p = Wi.utils.toArray(p)),
          (n = n || 1e-9),
          (r = r || 0),
          (_ = _ || 1),
          (tt = tt || 1),
          (o = o || 'wheel,touch,pointer'),
          (c = c !== !1),
          l || (l = parseFloat(Dn.getComputedStyle(ra).lineHeight) || 22));
        var nt,
          Le,
          At,
          Ke,
          ut,
          Tt,
          at,
          ue = this,
          Rt = 0,
          ti = 0,
          ee = i.passive || (!u && i.passive !== !1),
          xt = or(a, Ki),
          _t = or(a, Mi),
          Ut = xt(),
          Ue = _t(),
          bt =
            ~o.indexOf('touch') &&
            !~o.indexOf('pointer') &&
            fs[0] === 'pointerdown',
          H = Sl(a),
          C = a.ownerDocument || Ir,
          se = [0, 0, 0],
          _e = [0, 0, 0],
          we = 0,
          Oe = function () {
            return (we = bl());
          },
          Re = function (S, E) {
            return (
              ((ue.event = S) && p && nS(S.target, p)) ||
              (E && bt && S.pointerType !== 'touch') ||
              (J && J(S, E))
            );
          },
          ge = function () {
            (ue._vx.reset(), ue._vy.reset(), Le.pause(), f && f(ue));
          },
          be = function () {
            var S = (ue.deltaX = U_(se)),
              E = (ue.deltaY = U_(_e)),
              A = Math.abs(S) >= n,
              F = Math.abs(E) >= n;
            (W && (A || F) && W(ue, S, E, se, _e),
              A &&
                (U && ue.deltaX > 0 && U(ue),
                O && ue.deltaX < 0 && O(ue),
                I && I(ue),
                q && ue.deltaX < 0 != Rt < 0 && q(ue),
                (Rt = ue.deltaX),
                (se[0] = se[1] = se[2] = 0)),
              F &&
                (M && ue.deltaY > 0 && M(ue),
                N && ue.deltaY < 0 && N(ue),
                z && z(ue),
                re && ue.deltaY < 0 != ti < 0 && re(ue),
                (ti = ue.deltaY),
                (_e[0] = _e[1] = _e[2] = 0)),
              (Ke || At) &&
                (ie && ie(ue),
                At && (g && At === 1 && g(ue), w && w(ue), (At = 0)),
                (Ke = !1)),
              Tt && !(Tt = !1) && Ze && Ze(ue),
              ut && (Ne(ue), (ut = !1)),
              (nt = 0));
          },
          ke = function (S, E, A) {
            ((se[A] += S),
              (_e[A] += E),
              ue._vx.update(S),
              ue._vy.update(E),
              c ? nt || (nt = requestAnimationFrame(be)) : be());
          },
          Ve = function (S, E) {
            (Ae &&
              !at &&
              ((ue.axis = at = Math.abs(S) > Math.abs(E) ? 'x' : 'y'),
              (Tt = !0)),
              at !== 'y' && ((se[2] += S), ue._vx.update(S, !0)),
              at !== 'x' && ((_e[2] += E), ue._vy.update(E, !0)),
              c ? nt || (nt = requestAnimationFrame(be)) : be());
          },
          Te = function (S) {
            if (!Re(S, 1)) {
              S = yl(S, u);
              var E = S.clientX,
                A = S.clientY,
                F = E - ue.x,
                V = A - ue.y,
                Y = ue.isDragging;
              ((ue.x = E),
                (ue.y = A),
                (Y ||
                  ((F || V) &&
                    (Math.abs(ue.startX - E) >= r ||
                      Math.abs(ue.startY - A) >= r))) &&
                  (At || (At = Y ? 2 : 1),
                  Y || (ue.isDragging = !0),
                  Ve(F, V)));
            }
          },
          Ie = (ue.onPress = function (b) {
            Re(b, 1) ||
              (b && b.button) ||
              ((ue.axis = at = null),
              Le.pause(),
              (ue.isPressed = !0),
              (b = yl(b)),
              (Rt = ti = 0),
              (ue.startX = ue.x = b.clientX),
              (ue.startY = ue.y = b.clientY),
              ue._vx.reset(),
              ue._vy.reset(),
              un(pe ? a : C, fs[1], Te, ee, !0),
              (ue.deltaX = ue.deltaY = 0),
              L && L(ue));
          }),
          Fe = (ue.onRelease = function (b) {
            if (!Re(b, 1)) {
              hn(pe ? a : C, fs[1], Te, !0);
              var S = !isNaN(ue.y - ue.startY),
                E = ue.isDragging,
                A =
                  E &&
                  (Math.abs(ue.x - ue.startX) > 3 ||
                    Math.abs(ue.y - ue.startY) > 3),
                F = yl(b);
              (!A &&
                S &&
                (ue._vx.reset(),
                ue._vy.reset(),
                u &&
                  Pe &&
                  Wi.delayedCall(0.08, function () {
                    if (bl() - we > 300 && !b.defaultPrevented) {
                      if (b.target.click) b.target.click();
                      else if (C.createEvent) {
                        var V = C.createEvent('MouseEvents');
                        (V.initMouseEvent(
                          'click',
                          !0,
                          !0,
                          Dn,
                          1,
                          F.screenX,
                          F.screenY,
                          F.clientX,
                          F.clientY,
                          !1,
                          !1,
                          !1,
                          !1,
                          0,
                          null,
                        ),
                          b.target.dispatchEvent(V));
                      }
                    }
                  })),
                (ue.isDragging = ue.isGesturing = ue.isPressed = !1),
                f && E && !pe && Le.restart(!0),
                At && be(),
                v && E && v(ue),
                R && R(ue, A));
            }
          }),
          rt = function (S) {
            return (
              S.touches &&
              S.touches.length > 1 &&
              (ue.isGesturing = !0) &&
              Ee(S, ue.isDragging)
            );
          },
          vt = function () {
            return (ue.isGesturing = !1) || Z(ue);
          },
          j = function (S) {
            if (!Re(S)) {
              var E = xt(),
                A = _t();
              (ke((E - Ut) * tt, (A - Ue) * tt, 1),
                (Ut = E),
                (Ue = A),
                f && Le.restart(!0));
            }
          },
          Ce = function (S) {
            if (!Re(S)) {
              ((S = yl(S, u)), Ne && (ut = !0));
              var E =
                (S.deltaMode === 1
                  ? l
                  : S.deltaMode === 2
                    ? Dn.innerHeight
                    : 1) * _;
              (ke(S.deltaX * E, S.deltaY * E, 0), f && !pe && Le.restart(!0));
            }
          },
          ye = function (S) {
            if (!Re(S)) {
              var E = S.clientX,
                A = S.clientY,
                F = E - ue.x,
                V = A - ue.y;
              ((ue.x = E),
                (ue.y = A),
                (Ke = !0),
                f && Le.restart(!0),
                (F || V) && Ve(F, V));
            }
          },
          D = function (S) {
            ((ue.event = S), oe(ue));
          },
          h = function (S) {
            ((ue.event = S), K(ue));
          },
          m = function (S) {
            return Re(S) || (yl(S, u) && ot(ue));
          };
        ((Le = ue._dc = Wi.delayedCall(d || 0.25, ge).pause()),
          (ue.deltaX = ue.deltaY = 0),
          (ue._vx = nh(0, 50, !0)),
          (ue._vy = nh(0, 50, !0)),
          (ue.scrollX = xt),
          (ue.scrollY = _t),
          (ue.isDragging = ue.isGesturing = ue.isPressed = !1),
          H_(this),
          (ue.enable = function (b) {
            return (
              ue.isEnabled ||
                (un(H ? C : a, 'scroll', If),
                o.indexOf('scroll') >= 0 && un(H ? C : a, 'scroll', j, ee, ve),
                o.indexOf('wheel') >= 0 && un(a, 'wheel', Ce, ee, ve),
                ((o.indexOf('touch') >= 0 && B_) ||
                  o.indexOf('pointer') >= 0) &&
                  (un(a, fs[0], Ie, ee, ve),
                  un(C, fs[2], Fe),
                  un(C, fs[3], Fe),
                  Pe && un(a, 'click', Oe, !0, !0),
                  ot && un(a, 'click', m),
                  Ee && un(C, 'gesturestart', rt),
                  Z && un(C, 'gestureend', vt),
                  oe && un(a, _o + 'enter', D),
                  K && un(a, _o + 'leave', h),
                  ie && un(a, _o + 'move', ye)),
                (ue.isEnabled = !0),
                (ue.isDragging = ue.isGesturing = ue.isPressed = Ke = At = !1),
                ue._vx.reset(),
                ue._vy.reset(),
                (Ut = xt()),
                (Ue = _t()),
                b && b.type && Ie(b),
                Be && Be(ue)),
              ue
            );
          }),
          (ue.disable = function () {
            ue.isEnabled &&
              (sa.filter(function (b) {
                return b !== ue && Sl(b.target);
              }).length || hn(H ? C : a, 'scroll', If),
              ue.isPressed &&
                (ue._vx.reset(), ue._vy.reset(), hn(pe ? a : C, fs[1], Te, !0)),
              hn(H ? C : a, 'scroll', j, ve),
              hn(a, 'wheel', Ce, ve),
              hn(a, fs[0], Ie, ve),
              hn(C, fs[2], Fe),
              hn(C, fs[3], Fe),
              hn(a, 'click', Oe, !0),
              hn(a, 'click', m),
              hn(C, 'gesturestart', rt),
              hn(C, 'gestureend', vt),
              hn(a, _o + 'enter', D),
              hn(a, _o + 'leave', h),
              hn(a, _o + 'move', ye),
              (ue.isEnabled = ue.isPressed = ue.isDragging = !1),
              ht && ht(ue));
          }),
          (ue.kill = ue.revert =
            function () {
              ue.disable();
              var b = sa.indexOf(ue);
              (b >= 0 && sa.splice(b, 1), rr === ue && (rr = 0));
            }),
          sa.push(ue),
          pe && Sl(a) && (rr = ue),
          ue.enable(x));
      }),
      eS(s, [
        {
          key: 'velocityX',
          get: function () {
            return this._vx.getVelocity();
          },
        },
        {
          key: 'velocityY',
          get: function () {
            return this._vy.getVelocity();
          },
        },
      ]),
      s
    );
  })();
  mi.version = '3.15.0';
  mi.create = function (s) {
    return new mi(s);
  };
  mi.register = W_;
  mi.getAll = function () {
    return sa.slice();
  };
  mi.getById = function (s) {
    return sa.filter(function (e) {
      return e.vars.id === s;
    })[0];
  };
  z_() && Wi.registerPlugin(mi);
  var Qe,
    ha,
    Nt,
    $t,
    Fn,
    Zt,
    Yf,
    xh,
    Fl,
    Cl,
    Tl,
    sh,
    $i,
    Sh,
    kf,
    pn,
    X_,
    Y_,
    ua,
    l0,
    Df,
    c0,
    fn,
    Hf,
    h0,
    u0,
    Or,
    zf,
    qf,
    da,
    Zf,
    Pl,
    Vf,
    Of,
    rh = 1,
    ji = Date.now,
    Nf = ji(),
    $n = 0,
    Ml = 0,
    q_ = function (e, t, i) {
      var n = Nn(e) && (e.substr(0, 6) === 'clamp(' || e.indexOf('max') > -1);
      return ((i['_' + t + 'Clamp'] = n), n ? e.substr(6, e.length - 7) : e);
    },
    Z_ = function (e, t) {
      return t && (!Nn(e) || e.substr(0, 6) !== 'clamp(')
        ? 'clamp(' + e + ')'
        : e;
    },
    sS = function s() {
      return Ml && requestAnimationFrame(s);
    },
    K_ = function () {
      return (Sh = 1);
    },
    $_ = function () {
      return (Sh = 0);
    },
    Us = function (e) {
      return e;
    },
    wl = function (e) {
      return Math.round(e * 1e5) / 1e5 || 0;
    },
    d0 = function () {
      return typeof window != 'undefined';
    },
    f0 = function () {
      return Qe || (d0() && (Qe = window.gsap) && Qe.registerPlugin && Qe);
    },
    Eo = function (e) {
      return !!~Yf.indexOf(e);
    },
    p0 = function (e) {
      return (
        (e === 'Height' ? Zf : Nt['inner' + e]) ||
        Fn['client' + e] ||
        Zt['client' + e]
      );
    },
    m0 = function (e) {
      return (
        ar(e, 'getBoundingClientRect') ||
        (Eo(e)
          ? function () {
              return ((vh.width = Nt.innerWidth), (vh.height = Zf), vh);
            }
          : function () {
              return lr(e);
            })
      );
    },
    rS = function (e, t, i) {
      var n = i.d,
        r = i.d2,
        o = i.a;
      return (o = ar(e, 'getBoundingClientRect'))
        ? function () {
            return o()[n];
          }
        : function () {
            return (t ? p0(r) : e['client' + r]) || 0;
          };
    },
    oS = function (e, t) {
      return !t || ~ps.indexOf(e)
        ? m0(e)
        : function () {
            return vh;
          };
    },
    Bs = function (e, t) {
      var i = t.s,
        n = t.d2,
        r = t.d,
        o = t.a;
      return Math.max(
        0,
        (i = 'scroll' + n) && (o = ar(e, i))
          ? o() - m0(e)()[r]
          : Eo(e)
            ? (Fn[i] || Zt[i]) - p0(n)
            : e[i] - e['offset' + n],
      );
    },
    oh = function (e, t) {
      for (var i = 0; i < ua.length; i += 3)
        (!t || ~t.indexOf(ua[i + 1])) && e(ua[i], ua[i + 1], ua[i + 2]);
    },
    Nn = function (e) {
      return typeof e == 'string';
    },
    Ji = function (e) {
      return typeof e == 'function';
    },
    Al = function (e) {
      return typeof e == 'number';
    },
    vo = function (e) {
      return typeof e == 'object';
    },
    El = function (e, t, i) {
      return e && e.progress(t ? 0 : 1) && i && e.pause();
    },
    aa = function (e, t, i) {
      if (e.enabled) {
        var n = e._ctx
          ? e._ctx.add(function () {
              return t(e, i);
            })
          : t(e, i);
        n && n.totalTime && (e.callbackAnimation = n);
      }
    },
    la = Math.abs,
    g0 = 'left',
    _0 = 'top',
    Kf = 'right',
    $f = 'bottom',
    yo = 'width',
    bo = 'height',
    Ll = 'Right',
    Il = 'Left',
    Dl = 'Top',
    Ol = 'Bottom',
    wi = 'padding',
    Zn = 'margin',
    pa = 'Width',
    jf = 'Height',
    Ci = 'px',
    Kn = function (e) {
      return Nt.getComputedStyle(
        e.nodeType === Node.DOCUMENT_NODE ? e.scrollingElement : e,
      );
    },
    aS = function (e) {
      var t = Kn(e).position;
      e.style.position = t === 'absolute' || t === 'fixed' ? t : 'relative';
    },
    j_ = function (e, t) {
      for (var i in t) i in e || (e[i] = t[i]);
      return e;
    },
    lr = function (e, t) {
      var i =
          t &&
          Kn(e)[kf] !== 'matrix(1, 0, 0, 1, 0, 0)' &&
          Qe.to(e, {
            x: 0,
            y: 0,
            xPercent: 0,
            yPercent: 0,
            rotation: 0,
            rotationX: 0,
            rotationY: 0,
            scale: 1,
            skewX: 0,
            skewY: 0,
          }).progress(1),
        n = e.getBoundingClientRect
          ? e.getBoundingClientRect()
          : e.scrollingElement.getBoundingClientRect();
      return (i && i.progress(0).kill(), n);
    },
    yh = function (e, t) {
      var i = t.d2;
      return e['offset' + i] || e['client' + i] || 0;
    },
    v0 = function (e) {
      var t = [],
        i = e.labels,
        n = e.duration(),
        r;
      for (r in i) t.push(i[r] / n);
      return t;
    },
    lS = function (e) {
      return function (t) {
        return Qe.utils.snap(v0(e), t);
      };
    },
    Jf = function (e) {
      var t = Qe.utils.snap(e),
        i =
          Array.isArray(e) &&
          e.slice(0).sort(function (n, r) {
            return n - r;
          });
      return i
        ? function (n, r, o) {
            o === void 0 && (o = 0.001);
            var a;
            if (!r) return t(n);
            if (r > 0) {
              for (n -= o, a = 0; a < i.length; a++) if (i[a] >= n) return i[a];
              return i[a - 1];
            } else for (a = i.length, n += o; a--; ) if (i[a] <= n) return i[a];
            return i[0];
          }
        : function (n, r, o) {
            o === void 0 && (o = 0.001);
            var a = t(n);
            return !r || Math.abs(a - n) < o || a - n < 0 == r < 0
              ? a
              : t(r < 0 ? n - e : n + e);
          };
    },
    cS = function (e) {
      return function (t, i) {
        return Jf(v0(e))(t, i.direction);
      };
    },
    ah = function (e, t, i, n) {
      return i.split(',').forEach(function (r) {
        return e(t, r, n);
      });
    },
    Bi = function (e, t, i, n, r) {
      return e.addEventListener(t, i, { passive: !n, capture: !!r });
    },
    Ui = function (e, t, i, n) {
      return e.removeEventListener(t, i, !!n);
    },
    lh = function (e, t, i) {
      ((i = i && i.wheelHandler),
        i && (e(t, 'wheel', i), e(t, 'touchmove', i)));
    },
    J_ = {
      startColor: 'green',
      endColor: 'red',
      indent: 0,
      fontSize: '16px',
      fontWeight: 'normal',
    },
    ch = { toggleActions: 'play', anticipatePin: 0 },
    bh = { top: 0, left: 0, center: 0.5, bottom: 1, right: 1 },
    ph = function (e, t) {
      if (Nn(e)) {
        var i = e.indexOf('='),
          n = ~i ? +(e.charAt(i - 1) + 1) * parseFloat(e.substr(i + 1)) : 0;
        (~i && (e.indexOf('%') > i && (n *= t / 100), (e = e.substr(0, i - 1))),
          (e =
            n +
            (e in bh
              ? bh[e] * t
              : ~e.indexOf('%')
                ? (parseFloat(e) * t) / 100
                : parseFloat(e) || 0)));
      }
      return e;
    },
    hh = function (e, t, i, n, r, o, a, l) {
      var c = r.startColor,
        u = r.endColor,
        f = r.fontSize,
        d = r.indent,
        p = r.fontWeight,
        _ = $t.createElement('div'),
        x = Eo(i) || ar(i, 'pinType') === 'fixed',
        g = e.indexOf('scroller') !== -1,
        v = x ? Zt : i.tagName === 'IFRAME' ? i.contentDocument.body : i,
        w = e.indexOf('start') !== -1,
        L = w ? c : u,
        R =
          'border-color:' +
          L +
          ';font-size:' +
          f +
          ';color:' +
          L +
          ';font-weight:' +
          p +
          ';pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;';
      return (
        (R += 'position:' + ((g || l) && x ? 'fixed;' : 'absolute;')),
        (g || l || !x) &&
          (R += (n === Mi ? Kf : $f) + ':' + (o + parseFloat(d)) + 'px;'),
        a &&
          (R +=
            'box-sizing:border-box;text-align:left;width:' +
            a.offsetWidth +
            'px;'),
        (_._isStart = w),
        _.setAttribute('class', 'gsap-marker-' + e + (t ? ' marker-' + t : '')),
        (_.style.cssText = R),
        (_.innerText = t || t === 0 ? e + '-' + t : e),
        v.children[0] ? v.insertBefore(_, v.children[0]) : v.appendChild(_),
        (_._offset = _['offset' + n.op.d2]),
        mh(_, 0, n, w),
        _
      );
    },
    mh = function (e, t, i, n) {
      var r = { display: 'block' },
        o = i[n ? 'os2' : 'p2'],
        a = i[n ? 'p2' : 'os2'];
      ((e._isFlipped = n),
        (r[i.a + 'Percent'] = n ? -100 : 0),
        (r[i.a] = n ? '1px' : 0),
        (r['border' + o + pa] = 1),
        (r['border' + a + pa] = 0),
        (r[i.p] = t + 'px'),
        Qe.set(e, r));
    },
    It = [],
    Gf = {},
    Ul,
    Q_ = function () {
      return ji() - $n > 34 && (Ul || (Ul = requestAnimationFrame(cr)));
    },
    ca = function () {
      (!fn || !fn.isPressed || fn.startX > Zt.clientWidth) &&
        (Lt.cache++,
        fn ? Ul || (Ul = requestAnimationFrame(cr)) : cr(),
        $n || Mo('scrollStart'),
        ($n = ji()));
    },
    Ff = function () {
      ((u0 = Nt.innerWidth), (h0 = Nt.innerHeight));
    },
    Rl = function (e) {
      (Lt.cache++,
        (e === !0 ||
          (!$i &&
            !c0 &&
            !$t.fullscreenElement &&
            !$t.webkitFullscreenElement &&
            (!Hf ||
              u0 !== Nt.innerWidth ||
              Math.abs(Nt.innerHeight - h0) > Nt.innerHeight * 0.25))) &&
          xh.restart(!0));
    },
    To = {},
    hS = [],
    x0 = function s() {
      return Ui(Je, 'scrollEnd', s) || xo(!0);
    },
    Mo = function (e) {
      return (
        (To[e] &&
          To[e].map(function (t) {
            return t();
          })) ||
        hS
      );
    },
    On = [],
    y0 = function (e) {
      for (var t = 0; t < On.length; t += 5)
        (!e || (On[t + 4] && On[t + 4].query === e)) &&
          ((On[t].style.cssText = On[t + 1]),
          On[t].getBBox && On[t].setAttribute('transform', On[t + 2] || ''),
          (On[t + 3].uncache = 1));
    },
    b0 = function () {
      return Lt.forEach(function (e) {
        return Ji(e) && ++e.cacheID && (e.rec = e());
      });
    },
    Qf = function (e, t) {
      var i;
      for (pn = 0; pn < It.length; pn++)
        ((i = It[pn]),
          i && (!t || i._ctx === t) && (e ? i.kill(1) : i.revert(!0, !0)));
      ((Pl = !0), t && y0(t), t || Mo('revert'));
    },
    S0 = function (e, t) {
      (Lt.cache++,
        (t || !mn) &&
          Lt.forEach(function (i) {
            return Ji(i) && i.cacheID++ && (i.rec = 0);
          }),
        Nn(e) && (Nt.history.scrollRestoration = qf = e));
    },
    mn,
    So = 0,
    e0,
    uS = function () {
      if (e0 !== So) {
        var e = (e0 = So);
        requestAnimationFrame(function () {
          return e === So && xo(!0);
        });
      }
    },
    E0 = function () {
      (Zt.appendChild(da),
        (Zf = (!fn && da.offsetHeight) || Nt.innerHeight),
        Zt.removeChild(da));
    },
    t0 = function (e) {
      return Fl(
        '.gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end',
      ).forEach(function (t) {
        return (t.style.display = e ? 'none' : 'block');
      });
    },
    xo = function (e, t) {
      if (
        ((Fn = $t.documentElement),
        (Zt = $t.body),
        (Yf = [Nt, $t, Fn, Zt]),
        $n && !e && !Pl)
      ) {
        Bi(Je, 'scrollEnd', x0);
        return;
      }
      (E0(), (mn = Je.isRefreshing = !0), Pl || b0());
      var i = Mo('refreshInit');
      (l0 && Je.sort(),
        t || Qf(),
        Lt.forEach(function (n) {
          Ji(n) && (n.smooth && (n.target.style.scrollBehavior = 'auto'), n(0));
        }),
        It.slice(0).forEach(function (n) {
          return n.refresh();
        }),
        (Pl = !1),
        It.forEach(function (n) {
          if (n._subPinOffset && n.pin) {
            var r = n.vars.horizontal ? 'offsetWidth' : 'offsetHeight',
              o = n.pin[r];
            (n.revert(!0, 1), n.adjustPinSpacing(n.pin[r] - o), n.refresh());
          }
        }),
        (Vf = 1),
        t0(!0),
        It.forEach(function (n) {
          var r = Bs(n.scroller, n._dir),
            o = n.vars.end === 'max' || (n._endClamp && n.end > r),
            a = n._startClamp && n.start >= r;
          (o || a) &&
            n.setPositions(
              a ? r - 1 : n.start,
              o ? Math.max(a ? r : n.start + 1, r) : n.end,
              !0,
            );
        }),
        t0(!1),
        (Vf = 0),
        i.forEach(function (n) {
          return n && n.render && n.render(-1);
        }),
        Lt.forEach(function (n) {
          Ji(n) &&
            (n.smooth &&
              requestAnimationFrame(function () {
                return (n.target.style.scrollBehavior = 'smooth');
              }),
            n.rec && n(n.rec));
        }),
        S0(qf, 1),
        xh.pause(),
        So++,
        (mn = 2),
        cr(2),
        It.forEach(function (n) {
          return Ji(n.vars.onRefresh) && n.vars.onRefresh(n);
        }),
        (mn = Je.isRefreshing = !1),
        Mo('refresh'));
    },
    Wf = 0,
    gh = 1,
    Nl,
    cr = function (e) {
      if (e === 2 || (!mn && !Pl)) {
        ((Je.isUpdating = !0), Nl && Nl.update(0));
        var t = It.length,
          i = ji(),
          n = i - Nf >= 50,
          r = t && It[0].scroll();
        if (
          ((gh = Wf > r ? -1 : 1),
          mn || (Wf = r),
          n &&
            ($n && !Sh && i - $n > 200 && (($n = 0), Mo('scrollEnd')),
            (Tl = Nf),
            (Nf = i)),
          gh < 0)
        ) {
          for (pn = t; pn-- > 0; ) It[pn] && It[pn].update(0, n);
          gh = 1;
        } else for (pn = 0; pn < t; pn++) It[pn] && It[pn].update(0, n);
        Je.isUpdating = !1;
      }
      Ul = 0;
    },
    Xf = [
      g0,
      _0,
      $f,
      Kf,
      Zn + Ol,
      Zn + Ll,
      Zn + Dl,
      Zn + Il,
      'display',
      'flexShrink',
      'float',
      'zIndex',
      'gridColumnStart',
      'gridColumnEnd',
      'gridRowStart',
      'gridRowEnd',
      'gridArea',
      'justifySelf',
      'alignSelf',
      'placeSelf',
      'order',
    ],
    _h = Xf.concat([
      yo,
      bo,
      'boxSizing',
      'max' + pa,
      'max' + jf,
      'position',
      Zn,
      wi,
      wi + Dl,
      wi + Ll,
      wi + Ol,
      wi + Il,
    ]),
    dS = function (e, t, i) {
      fa(i);
      var n = e._gsap;
      if (n.spacerIsNative) fa(n.spacerState);
      else if (e._gsap.swappedIn) {
        var r = t.parentNode;
        r && (r.insertBefore(e, t), r.removeChild(t));
      }
      e._gsap.swappedIn = !1;
    },
    Uf = function (e, t, i, n) {
      if (!e._gsap.swappedIn) {
        for (var r = Xf.length, o = t.style, a = e.style, l; r--; )
          ((l = Xf[r]), (o[l] = i[l]));
        ((o.position = i.position === 'absolute' ? 'absolute' : 'relative'),
          i.display === 'inline' && (o.display = 'inline-block'),
          (a[$f] = a[Kf] = 'auto'),
          (o.flexBasis = i.flexBasis || 'auto'),
          (o.overflow = 'visible'),
          (o.boxSizing = 'border-box'),
          (o[yo] = yh(e, Ki) + Ci),
          (o[bo] = yh(e, Mi) + Ci),
          (o[wi] = a[Zn] = a[_0] = a[g0] = '0'),
          fa(n),
          (a[yo] = a['max' + pa] = i[yo]),
          (a[bo] = a['max' + jf] = i[bo]),
          (a[wi] = i[wi]),
          e.parentNode !== t &&
            (e.parentNode.insertBefore(t, e), t.appendChild(e)),
          (e._gsap.swappedIn = !0));
      }
    },
    fS = /([A-Z])/g,
    fa = function (e) {
      if (e) {
        var t = e.t.style,
          i = e.length,
          n = 0,
          r,
          o;
        for ((e.t._gsap || Qe.core.getCache(e.t)).uncache = 1; n < i; n += 2)
          ((o = e[n + 1]),
            (r = e[n]),
            o
              ? (t[r] = o)
              : t[r] && t.removeProperty(r.replace(fS, '-$1').toLowerCase()));
      }
    },
    uh = function (e) {
      for (var t = _h.length, i = e.style, n = [], r = 0; r < t; r++)
        n.push(_h[r], i[_h[r]]);
      return ((n.t = e), n);
    },
    pS = function (e, t, i) {
      for (var n = [], r = e.length, o = i ? 8 : 0, a; o < r; o += 2)
        ((a = e[o]), n.push(a, a in t ? t[a] : e[o + 1]));
      return ((n.t = e.t), n);
    },
    vh = { left: 0, top: 0 },
    i0 = function (e, t, i, n, r, o, a, l, c, u, f, d, p, _) {
      (Ji(e) && (e = e(l)),
        Nn(e) &&
          e.substr(0, 3) === 'max' &&
          (e = d + (e.charAt(4) === '=' ? ph('0' + e.substr(3), i) : 0)));
      var x = p ? p.time() : 0,
        g,
        v,
        w;
      if ((p && p.seek(0), isNaN(e) || (e = +e), Al(e)))
        (p &&
          (e = Qe.utils.mapRange(
            p.scrollTrigger.start,
            p.scrollTrigger.end,
            0,
            d,
            e,
          )),
          a && mh(a, i, n, !0));
      else {
        Ji(t) && (t = t(l));
        var L = (e || '0').split(' '),
          R,
          U,
          O,
          N;
        ((w = dn(t, l) || Zt),
          (R = lr(w) || {}),
          (!R || (!R.left && !R.top)) &&
            Kn(w).display === 'none' &&
            ((N = w.style.display),
            (w.style.display = 'block'),
            (R = lr(w)),
            N ? (w.style.display = N) : w.style.removeProperty('display')),
          (U = ph(L[0], R[n.d])),
          (O = ph(L[1] || '0', i)),
          (e = R[n.p] - c[n.p] - u + U + r - O),
          a && mh(a, O, n, i - O < 20 || (a._isStart && O > 20)),
          (i -= i - O));
      }
      if ((_ && ((l[_] = e || -0.001), e < 0 && (e = 0)), o)) {
        var M = e + i,
          I = o._isStart;
        ((g = 'scroll' + n.d2),
          mh(
            o,
            M,
            n,
            (I && M > 20) ||
              (!I && (f ? Math.max(Zt[g], Fn[g]) : o.parentNode[g]) <= M + 1),
          ),
          f &&
            ((c = lr(a)),
            f && (o.style[n.op.p] = c[n.op.p] - n.op.m - o._offset + Ci)));
      }
      return (
        p &&
          w &&
          ((g = lr(w)),
          p.seek(d),
          (v = lr(w)),
          (p._caScrollDist = g[n.p] - v[n.p]),
          (e = (e / p._caScrollDist) * d)),
        p && p.seek(x),
        p ? e : Math.round(e)
      );
    },
    mS = /(webkit|moz|length|cssText|inset)/i,
    n0 = function (e, t, i, n) {
      if (e.parentNode !== t) {
        var r = e.style,
          o,
          a;
        if (t === Zt) {
          ((e._stOrig = r.cssText), (a = Kn(e)));
          for (o in a)
            !+o &&
              !mS.test(o) &&
              a[o] &&
              typeof r[o] == 'string' &&
              o !== '0' &&
              (r[o] = a[o]);
          ((r.top = i), (r.left = n));
        } else r.cssText = e._stOrig;
        ((Qe.core.getCache(e).uncache = 1), t.appendChild(e));
      }
    },
    T0 = function (e, t, i) {
      var n = t,
        r = n;
      return function (o) {
        var a = Math.round(e());
        return (
          a !== n &&
            a !== r &&
            Math.abs(a - n) > 3 &&
            Math.abs(a - r) > 3 &&
            ((o = a), i && i()),
          (r = n),
          (n = Math.round(o)),
          n
        );
      };
    },
    dh = function (e, t, i) {
      var n = {};
      ((n[t.p] = '+=' + i), Qe.set(e, n));
    },
    s0 = function (e, t) {
      var i = or(e, t),
        n = '_scroll' + t.p2,
        r = function o(a, l, c, u, f) {
          var d = o.tween,
            p = l.onComplete,
            _ = {};
          c = c || i();
          var x = T0(i, c, function () {
            (d.kill(), (o.tween = 0));
          });
          return (
            (f = (u && f) || 0),
            (u = u || a - c),
            d && d.kill(),
            (l[n] = a),
            (l.inherit = !1),
            (l.modifiers = _),
            (_[n] = function () {
              return x(c + u * d.ratio + f * d.ratio * d.ratio);
            }),
            (l.onUpdate = function () {
              (Lt.cache++, o.tween && cr());
            }),
            (l.onComplete = function () {
              ((o.tween = 0), p && p.call(d));
            }),
            (d = o.tween = Qe.to(e, l)),
            d
          );
        };
      return (
        (e[n] = i),
        (i.wheelHandler = function () {
          return r.tween && r.tween.kill() && (r.tween = 0);
        }),
        Bi(e, 'wheel', i.wheelHandler),
        Je.isTouch && Bi(e, 'touchmove', i.wheelHandler),
        r
      );
    },
    Je = (function () {
      function s(t, i) {
        (ha || s.register(Qe), zf(this), this.init(t, i));
      }
      var e = s.prototype;
      return (
        (e.init = function (i, n) {
          if (
            ((this.progress = this.start = 0),
            this.vars && this.kill(!0, !0),
            !Ml)
          ) {
            this.update = this.refresh = this.kill = Us;
            return;
          }
          i = j_(Nn(i) || Al(i) || i.nodeType ? { trigger: i } : i, ch);
          var r = i,
            o = r.onUpdate,
            a = r.toggleClass,
            l = r.id,
            c = r.onToggle,
            u = r.onRefresh,
            f = r.scrub,
            d = r.trigger,
            p = r.pin,
            _ = r.pinSpacing,
            x = r.invalidateOnRefresh,
            g = r.anticipatePin,
            v = r.onScrubComplete,
            w = r.onSnapComplete,
            L = r.once,
            R = r.snap,
            U = r.pinReparent,
            O = r.pinSpacer,
            N = r.containerAnimation,
            M = r.fastScrollEnd,
            I = r.preventOverlaps,
            z =
              i.horizontal || (i.containerAnimation && i.horizontal !== !1)
                ? Ki
                : Mi,
            W = !f && f !== 0,
            q = dn(i.scroller || Nt),
            re = Qe.core.getCache(q),
            oe = Eo(q),
            K =
              ('pinType' in i
                ? i.pinType
                : ar(q, 'pinType') || (oe && 'fixed')) === 'fixed',
            ie = [i.onEnter, i.onLeave, i.onEnterBack, i.onLeaveBack],
            J = W && i.toggleActions.split(' '),
            pe = 'markers' in i ? i.markers : ch.markers,
            Ee = oe ? 0 : parseFloat(Kn(q)['border' + z.p2 + pa]) || 0,
            Z = this,
            Ne =
              i.onRefreshInit &&
              function () {
                return i.onRefreshInit(Z);
              },
            Be = rS(q, oe, z),
            ht = oS(q, oe),
            ot = 0,
            tt = 0,
            ve = 0,
            Pe = or(q, z),
            Ae,
            Ze,
            nt,
            Le,
            At,
            Ke,
            ut,
            Tt,
            at,
            ue,
            Rt,
            ti,
            ee,
            xt,
            _t,
            Ut,
            Ue,
            bt,
            H,
            C,
            se,
            _e,
            we,
            Oe,
            Re,
            ge,
            be,
            ke,
            Ve,
            Te,
            Ie,
            Fe,
            rt,
            vt,
            j,
            Ce,
            ye,
            D,
            h;
          if (
            ((Z._startClamp = Z._endClamp = !1),
            (Z._dir = z),
            (g *= 45),
            (Z.scroller = q),
            (Z.scroll = N ? N.time.bind(N) : Pe),
            (Le = Pe()),
            (Z.vars = i),
            (n = n || i.animation),
            'refreshPriority' in i &&
              ((l0 = 1), i.refreshPriority === -9999 && (Nl = Z)),
            (re.tweenScroll = re.tweenScroll || {
              top: s0(q, Mi),
              left: s0(q, Ki),
            }),
            (Z.tweenTo = Ae = re.tweenScroll[z.p]),
            (Z.scrubDuration = function (A) {
              ((rt = Al(A) && A),
                rt
                  ? Fe
                    ? Fe.duration(A)
                    : (Fe = Qe.to(n, {
                        ease: 'expo',
                        totalProgress: '+=0',
                        inherit: !1,
                        duration: rt,
                        paused: !0,
                        onComplete: function () {
                          return v && v(Z);
                        },
                      }))
                  : (Fe && Fe.progress(1).kill(), (Fe = 0)));
            }),
            n &&
              ((n.vars.lazy = !1),
              (n._initted && !Z.isReverted) ||
                (n.vars.immediateRender !== !1 &&
                  i.immediateRender !== !1 &&
                  n.duration() &&
                  n.render(0, !0, !0)),
              (Z.animation = n.pause()),
              (n.scrollTrigger = Z),
              Z.scrubDuration(f),
              (Te = 0),
              l || (l = n.vars.id)),
            R &&
              ((!vo(R) || R.push) && (R = { snapTo: R }),
              'scrollBehavior' in Zt.style &&
                Qe.set(oe ? [Zt, Fn] : q, { scrollBehavior: 'auto' }),
              Lt.forEach(function (A) {
                return (
                  Ji(A) &&
                  A.target === (oe ? $t.scrollingElement || Fn : q) &&
                  (A.smooth = !1)
                );
              }),
              (nt = Ji(R.snapTo)
                ? R.snapTo
                : R.snapTo === 'labels'
                  ? lS(n)
                  : R.snapTo === 'labelsDirectional'
                    ? cS(n)
                    : R.directional !== !1
                      ? function (A, F) {
                          return Jf(R.snapTo)(
                            A,
                            ji() - tt < 500 ? 0 : F.direction,
                          );
                        }
                      : Qe.utils.snap(R.snapTo)),
              (vt = R.duration || { min: 0.1, max: 2 }),
              (vt = vo(vt) ? Cl(vt.min, vt.max) : Cl(vt, vt)),
              (j = Qe.delayedCall(R.delay || rt / 2 || 0.1, function () {
                var A = Pe(),
                  F = ji() - tt < 500,
                  V = Ae.tween;
                if (
                  (F || Math.abs(Z.getVelocity()) < 10) &&
                  !V &&
                  !Sh &&
                  ot !== A
                ) {
                  var Y = (A - Ke) / xt,
                    X = n && !W ? n.totalProgress() : Y,
                    $ = F ? 0 : ((X - Ie) / (ji() - Tl)) * 1e3 || 0,
                    le = Qe.utils.clamp(-Y, 1 - Y, (la($ / 2) * $) / 0.185),
                    xe = Y + (R.inertia === !1 ? 0 : le),
                    fe,
                    Se,
                    Me = R,
                    de = Me.onStart,
                    me = Me.onInterrupt,
                    De = Me.onComplete;
                  if (
                    ((fe = nt(xe, Z)),
                    Al(fe) || (fe = xe),
                    (Se = Math.max(0, Math.round(Ke + fe * xt))),
                    A <= ut && A >= Ke && Se !== A)
                  ) {
                    if (V && !V._initted && V.data <= la(Se - A)) return;
                    (R.inertia === !1 && (le = fe - Y),
                      Ae(
                        Se,
                        {
                          duration: vt(
                            la(
                              (Math.max(la(xe - X), la(fe - X)) * 0.185) /
                                $ /
                                0.05 || 0,
                            ),
                          ),
                          ease: R.ease || 'power3',
                          data: la(Se - A),
                          onInterrupt: function () {
                            return j.restart(!0) && me && aa(Z, me);
                          },
                          onComplete: function () {
                            (Z.update(),
                              (ot = Pe()),
                              n &&
                                !W &&
                                (Fe
                                  ? Fe.resetTo(
                                      'totalProgress',
                                      fe,
                                      n._tTime / n._tDur,
                                    )
                                  : n.progress(fe)),
                              (Te = Ie =
                                n && !W ? n.totalProgress() : Z.progress),
                              w && w(Z),
                              De && aa(Z, De));
                          },
                        },
                        A,
                        le * xt,
                        Se - A - le * xt,
                      ),
                      de && aa(Z, de, Ae.tween));
                  }
                } else Z.isActive && ot !== A && j.restart(!0);
              }).pause())),
            l && (Gf[l] = Z),
            (d = Z.trigger = dn(d || (p !== !0 && p))),
            (h = d && d._gsap && d._gsap.stRevert),
            h && (h = h(Z)),
            (p = p === !0 ? d : dn(p)),
            Nn(a) && (a = { targets: d, className: a }),
            p &&
              (_ === !1 ||
                _ === Zn ||
                (_ =
                  !_ &&
                  p.parentNode &&
                  p.parentNode.style &&
                  Kn(p.parentNode).display === 'flex'
                    ? !1
                    : wi),
              (Z.pin = p),
              (Ze = Qe.core.getCache(p)),
              Ze.spacer
                ? (_t = Ze.pinState)
                : (O &&
                    ((O = dn(O)),
                    O && !O.nodeType && (O = O.current || O.nativeElement),
                    (Ze.spacerIsNative = !!O),
                    O && (Ze.spacerState = uh(O))),
                  (Ze.spacer = bt = O || $t.createElement('div')),
                  bt.classList.add('pin-spacer'),
                  l && bt.classList.add('pin-spacer-' + l),
                  (Ze.pinState = _t = uh(p))),
              i.force3D !== !1 && Qe.set(p, { force3D: !0 }),
              (Z.spacer = bt = Ze.spacer),
              (Ve = Kn(p)),
              (Oe = Ve[_ + z.os2]),
              (C = Qe.getProperty(p)),
              (se = Qe.quickSetter(p, z.a, Ci)),
              Uf(p, bt, Ve),
              (Ue = uh(p))),
            pe)
          ) {
            ((ti = vo(pe) ? j_(pe, J_) : J_),
              (ue = hh('scroller-start', l, q, z, ti, 0)),
              (Rt = hh('scroller-end', l, q, z, ti, 0, ue)),
              (H = ue['offset' + z.op.d2]));
            var m = dn(ar(q, 'content') || q);
            ((Tt = this.markerStart = hh('start', l, m, z, ti, H, 0, N)),
              (at = this.markerEnd = hh('end', l, m, z, ti, H, 0, N)),
              N && (D = Qe.quickSetter([Tt, at], z.a, Ci)),
              !K &&
                !(ps.length && ar(q, 'fixedMarkers') === !0) &&
                (aS(oe ? Zt : q),
                Qe.set([ue, Rt], { force3D: !0 }),
                (ge = Qe.quickSetter(ue, z.a, Ci)),
                (ke = Qe.quickSetter(Rt, z.a, Ci))));
          }
          if (N) {
            var b = N.vars.onUpdate,
              S = N.vars.onUpdateParams;
            N.eventCallback('onUpdate', function () {
              (Z.update(0, 0, 1), b && b.apply(N, S || []));
            });
          }
          if (
            ((Z.previous = function () {
              return It[It.indexOf(Z) - 1];
            }),
            (Z.next = function () {
              return It[It.indexOf(Z) + 1];
            }),
            (Z.revert = function (A, F) {
              if (!F) return Z.kill(!0);
              var V = A !== !1 || !Z.enabled,
                Y = $i;
              V !== Z.isReverted &&
                (V &&
                  ((Ce = Math.max(Pe(), Z.scroll.rec || 0)),
                  (ve = Z.progress),
                  (ye = n && n.progress())),
                Tt &&
                  [Tt, at, ue, Rt].forEach(function (X) {
                    return (X.style.display = V ? 'none' : 'block');
                  }),
                V && (($i = Z), Z.update(V)),
                p &&
                  (!U || !Z.isActive) &&
                  (V ? dS(p, bt, _t) : Uf(p, bt, Kn(p), Re)),
                V || Z.update(V),
                ($i = Y),
                (Z.isReverted = V));
            }),
            (Z.refresh = function (A, F, V, Y) {
              if (!(($i || !Z.enabled) && !F)) {
                if (p && A && $n) {
                  Bi(s, 'scrollEnd', x0);
                  return;
                }
                (!mn && Ne && Ne(Z),
                  ($i = Z),
                  Ae.tween && !V && (Ae.tween.kill(), (Ae.tween = 0)),
                  Fe && Fe.pause(),
                  x &&
                    n &&
                    (n.revert({ kill: !1 }).invalidate(),
                    n.getChildren
                      ? n.getChildren(!0, !0, !1).forEach(function (ne) {
                          return (
                            ne.vars.immediateRender && ne.render(0, !0, !0)
                          );
                        })
                      : n.vars.immediateRender && n.render(0, !0, !0)),
                  Z.isReverted || Z.revert(!0, !0),
                  (Z._subPinOffset = !1));
                var X = Be(),
                  $ = ht(),
                  le = N ? N.duration() : Bs(q, z),
                  xe = xt <= 0.01 || !xt,
                  fe = 0,
                  Se = Y || 0,
                  Me = vo(V) ? V.end : i.end,
                  de = i.endTrigger || d,
                  me = vo(V)
                    ? V.start
                    : i.start ||
                      (i.start === 0 || !d ? 0 : p ? '0 0' : '0 100%'),
                  De = (Z.pinnedContainer =
                    i.pinnedContainer && dn(i.pinnedContainer, Z)),
                  Ge = (d && Math.max(0, It.indexOf(Z))) || 0,
                  ze = Ge,
                  lt,
                  st,
                  ft,
                  dt,
                  gt,
                  Gt,
                  Ot,
                  P,
                  T,
                  k,
                  G,
                  B,
                  ae;
                for (
                  pe &&
                  vo(V) &&
                  ((B = Qe.getProperty(ue, z.p)),
                  (ae = Qe.getProperty(Rt, z.p)));
                  ze-- > 0;
                )
                  ((Gt = It[ze]),
                    Gt.end || Gt.refresh(0, 1) || ($i = Z),
                    (Ot = Gt.pin),
                    Ot &&
                      (Ot === d || Ot === p || Ot === De) &&
                      !Gt.isReverted &&
                      (k || (k = []), k.unshift(Gt), Gt.revert(!0, !0)),
                    Gt !== It[ze] && (Ge--, ze--));
                for (
                  Ji(me) && (me = me(Z)),
                    me = q_(me, 'start', Z),
                    Ke =
                      i0(
                        me,
                        d,
                        X,
                        z,
                        Pe(),
                        Tt,
                        ue,
                        Z,
                        $,
                        Ee,
                        K,
                        le,
                        N,
                        Z._startClamp && '_startClamp',
                      ) || (p ? -0.001 : 0),
                    Ji(Me) && (Me = Me(Z)),
                    Nn(Me) &&
                      !Me.indexOf('+=') &&
                      (~Me.indexOf(' ')
                        ? (Me = (Nn(me) ? me.split(' ')[0] : '') + Me)
                        : ((fe = ph(Me.substr(2), X)),
                          (Me = Nn(me)
                            ? me
                            : (N
                                ? Qe.utils.mapRange(
                                    0,
                                    N.duration(),
                                    N.scrollTrigger.start,
                                    N.scrollTrigger.end,
                                    Ke,
                                  )
                                : Ke) + fe),
                          (de = d))),
                    Me = q_(Me, 'end', Z),
                    ut =
                      Math.max(
                        Ke,
                        i0(
                          Me || (de ? '100% 0' : le),
                          de,
                          X,
                          z,
                          Pe() + fe,
                          at,
                          Rt,
                          Z,
                          $,
                          Ee,
                          K,
                          le,
                          N,
                          Z._endClamp && '_endClamp',
                        ),
                      ) || -0.001,
                    fe = 0,
                    ze = Ge;
                  ze--;
                )
                  ((Gt = It[ze] || {}),
                    (Ot = Gt.pin),
                    Ot &&
                      Gt.start - Gt._pinPush <= Ke &&
                      !N &&
                      Gt.end > 0 &&
                      ((lt =
                        Gt.end -
                        (Z._startClamp ? Math.max(0, Gt.start) : Gt.start)),
                      ((Ot === d && Gt.start - Gt._pinPush < Ke) ||
                        Ot === De) &&
                        isNaN(me) &&
                        (fe += lt * (1 - Gt.progress)),
                      Ot === p && (Se += lt)));
                if (
                  ((Ke += fe),
                  (ut += fe),
                  Z._startClamp && (Z._startClamp += fe),
                  Z._endClamp &&
                    !mn &&
                    ((Z._endClamp = ut || -0.001),
                    (ut = Math.min(ut, Bs(q, z)))),
                  (xt = ut - Ke || ((Ke -= 0.01) && 0.001)),
                  xe &&
                    (ve = Qe.utils.clamp(0, 1, Qe.utils.normalize(Ke, ut, Ce))),
                  (Z._pinPush = Se),
                  Tt &&
                    fe &&
                    ((lt = {}),
                    (lt[z.a] = '+=' + fe),
                    De && (lt[z.p] = '-=' + Pe()),
                    Qe.set([Tt, at], lt)),
                  p && !(Vf && Z.end >= Bs(q, z)))
                )
                  ((lt = Kn(p)),
                    (dt = z === Mi),
                    (ft = Pe()),
                    (_e = parseFloat(C(z.a)) + Se),
                    !le &&
                      ut > 1 &&
                      ((G = (oe ? $t.scrollingElement || Fn : q).style),
                      (G = {
                        style: G,
                        value: G['overflow' + z.a.toUpperCase()],
                      }),
                      oe &&
                        Kn(Zt)['overflow' + z.a.toUpperCase()] !== 'scroll' &&
                        (G.style['overflow' + z.a.toUpperCase()] = 'scroll')),
                    Uf(p, bt, lt),
                    (Ue = uh(p)),
                    (st = lr(p, !0)),
                    (P = K && or(q, dt ? Ki : Mi)()),
                    _
                      ? ((Re = [_ + z.os2, xt + Se + Ci]),
                        (Re.t = bt),
                        (ze = _ === wi ? yh(p, z) + xt + Se : 0),
                        ze &&
                          (Re.push(z.d, ze + Ci),
                          bt.style.flexBasis !== 'auto' &&
                            (bt.style.flexBasis = ze + Ci)),
                        fa(Re),
                        De &&
                          It.forEach(function (ne) {
                            ne.pin === De &&
                              ne.vars.pinSpacing !== !1 &&
                              (ne._subPinOffset = !0);
                          }),
                        K && Pe(Ce))
                      : ((ze = yh(p, z)),
                        ze &&
                          bt.style.flexBasis !== 'auto' &&
                          (bt.style.flexBasis = ze + Ci)),
                    K &&
                      ((gt = {
                        top: st.top + (dt ? ft - Ke : P) + Ci,
                        left: st.left + (dt ? P : ft - Ke) + Ci,
                        boxSizing: 'border-box',
                        position: 'fixed',
                      }),
                      (gt[yo] = gt['max' + pa] = Math.ceil(st.width) + Ci),
                      (gt[bo] = gt['max' + jf] = Math.ceil(st.height) + Ci),
                      (gt[Zn] =
                        gt[Zn + Dl] =
                        gt[Zn + Ll] =
                        gt[Zn + Ol] =
                        gt[Zn + Il] =
                          '0'),
                      (gt[wi] = lt[wi]),
                      (gt[wi + Dl] = lt[wi + Dl]),
                      (gt[wi + Ll] = lt[wi + Ll]),
                      (gt[wi + Ol] = lt[wi + Ol]),
                      (gt[wi + Il] = lt[wi + Il]),
                      (Ut = pS(_t, gt, U)),
                      mn && Pe(0)),
                    n
                      ? ((T = n._initted),
                        Df(1),
                        n.render(n.duration(), !0, !0),
                        (we = C(z.a) - _e + xt + Se),
                        (be = Math.abs(xt - we) > 1),
                        K && be && Ut.splice(Ut.length - 2, 2),
                        n.render(0, !0, !0),
                        T || n.invalidate(!0),
                        n.parent || n.totalTime(n.totalTime()),
                        Df(0))
                      : (we = xt),
                    G &&
                      (G.value
                        ? (G.style['overflow' + z.a.toUpperCase()] = G.value)
                        : G.style.removeProperty('overflow-' + z.a)));
                else if (d && Pe() && !N)
                  for (st = d.parentNode; st && st !== Zt; )
                    (st._pinOffset &&
                      ((Ke -= st._pinOffset), (ut -= st._pinOffset)),
                      (st = st.parentNode));
                (k &&
                  k.forEach(function (ne) {
                    return ne.revert(!1, !0);
                  }),
                  (Z.start = Ke),
                  (Z.end = ut),
                  (Le = At = mn ? Ce : Pe()),
                  !N && !mn && (Le < Ce && Pe(Ce), (Z.scroll.rec = 0)),
                  Z.revert(!1, !0),
                  (tt = ji()),
                  j && ((ot = -1), j.restart(!0)),
                  ($i = 0),
                  n &&
                    W &&
                    (n._initted || ye) &&
                    n.progress() !== ye &&
                    n.progress(ye || 0, !0).render(n.time(), !0, !0),
                  (xe || ve !== Z.progress || N || x || (n && !n._initted)) &&
                    (n &&
                      !W &&
                      (n._initted || ve || n.vars.immediateRender !== !1) &&
                      n.totalProgress(
                        N && Ke < -0.001 && !ve
                          ? Qe.utils.normalize(Ke, ut, 0)
                          : ve,
                        !0,
                      ),
                    (Z.progress = xe || (Le - Ke) / xt === ve ? 0 : ve)),
                  p && _ && (bt._pinOffset = Math.round(Z.progress * we)),
                  Fe && Fe.invalidate(),
                  isNaN(B) ||
                    ((B -= Qe.getProperty(ue, z.p)),
                    (ae -= Qe.getProperty(Rt, z.p)),
                    dh(ue, z, B),
                    dh(Tt, z, B - (Y || 0)),
                    dh(Rt, z, ae),
                    dh(at, z, ae - (Y || 0))),
                  xe && !mn && Z.update(),
                  u && !mn && !ee && ((ee = !0), u(Z), (ee = !1)));
              }
            }),
            (Z.getVelocity = function () {
              return ((Pe() - At) / (ji() - Tl)) * 1e3 || 0;
            }),
            (Z.endAnimation = function () {
              (El(Z.callbackAnimation),
                n &&
                  (Fe
                    ? Fe.progress(1)
                    : n.paused()
                      ? W || El(n, Z.direction < 0, 1)
                      : El(n, n.reversed())));
            }),
            (Z.labelToScroll = function (A) {
              return (
                (n &&
                  n.labels &&
                  (Ke || Z.refresh() || Ke) +
                    (n.labels[A] / n.duration()) * xt) ||
                0
              );
            }),
            (Z.getTrailing = function (A) {
              var F = It.indexOf(Z),
                V =
                  Z.direction > 0 ? It.slice(0, F).reverse() : It.slice(F + 1);
              return (
                Nn(A)
                  ? V.filter(function (Y) {
                      return Y.vars.preventOverlaps === A;
                    })
                  : V
              ).filter(function (Y) {
                return Z.direction > 0 ? Y.end <= Ke : Y.start >= ut;
              });
            }),
            (Z.update = function (A, F, V) {
              if (!(N && !V && !A)) {
                var Y = mn === !0 ? Ce : Z.scroll(),
                  X = A ? 0 : (Y - Ke) / xt,
                  $ = X < 0 ? 0 : X > 1 ? 1 : X || 0,
                  le = Z.progress,
                  xe,
                  fe,
                  Se,
                  Me,
                  de,
                  me,
                  De,
                  Ge;
                if (
                  (F &&
                    ((At = Le),
                    (Le = N ? Pe() : Y),
                    R && ((Ie = Te), (Te = n && !W ? n.totalProgress() : $))),
                  g &&
                    p &&
                    !$i &&
                    !rh &&
                    $n &&
                    (!$ && Ke < Y + ((Y - At) / (ji() - Tl)) * g
                      ? ($ = 1e-4)
                      : $ === 1 &&
                        ut > Y + ((Y - At) / (ji() - Tl)) * g &&
                        ($ = 0.9999)),
                  $ !== le && Z.enabled)
                ) {
                  if (
                    ((xe = Z.isActive = !!$ && $ < 1),
                    (fe = !!le && le < 1),
                    (me = xe !== fe),
                    (de = me || !!$ != !!le),
                    (Z.direction = $ > le ? 1 : -1),
                    (Z.progress = $),
                    de &&
                      !$i &&
                      ((Se = $ && !le ? 0 : $ === 1 ? 1 : le === 1 ? 2 : 3),
                      W &&
                        ((Me =
                          (!me && J[Se + 1] !== 'none' && J[Se + 1]) || J[Se]),
                        (Ge =
                          n &&
                          (Me === 'complete' || Me === 'reset' || Me in n)))),
                    I &&
                      (me || Ge) &&
                      (Ge || f || !n) &&
                      (Ji(I)
                        ? I(Z)
                        : Z.getTrailing(I).forEach(function (ft) {
                            return ft.endAnimation();
                          })),
                    W ||
                      (Fe && !$i && !rh
                        ? (Fe._dp._time - Fe._start !== Fe._time &&
                            Fe.render(Fe._dp._time - Fe._start),
                          Fe.resetTo
                            ? Fe.resetTo('totalProgress', $, n._tTime / n._tDur)
                            : ((Fe.vars.totalProgress = $),
                              Fe.invalidate().restart()))
                        : n && n.totalProgress($, !!($i && (tt || A)))),
                    p)
                  ) {
                    if ((A && _ && (bt.style[_ + z.os2] = Oe), !K))
                      se(wl(_e + we * $));
                    else if (de) {
                      if (
                        ((De = !A && $ > le && ut + 1 > Y && Y + 1 >= Bs(q, z)),
                        U)
                      )
                        if (!A && (xe || De)) {
                          var ze = lr(p, !0),
                            lt = Y - Ke;
                          n0(
                            p,
                            Zt,
                            ze.top + (z === Mi ? lt : 0) + Ci,
                            ze.left + (z === Mi ? 0 : lt) + Ci,
                          );
                        } else n0(p, bt);
                      (fa(xe || De ? Ut : Ue),
                        (be && $ < 1 && xe) ||
                          se(_e + ($ === 1 && !De ? we : 0)));
                    }
                  }
                  (R && !Ae.tween && !$i && !rh && j.restart(!0),
                    a &&
                      (me || (L && $ && ($ < 1 || !Of))) &&
                      Fl(a.targets).forEach(function (ft) {
                        return ft.classList[xe || L ? 'add' : 'remove'](
                          a.className,
                        );
                      }),
                    o && !W && !A && o(Z),
                    de && !$i
                      ? (W &&
                          (Ge &&
                            (Me === 'complete'
                              ? n.pause().totalProgress(1)
                              : Me === 'reset'
                                ? n.restart(!0).pause()
                                : Me === 'restart'
                                  ? n.restart(!0)
                                  : n[Me]()),
                          o && o(Z)),
                        (me || !Of) &&
                          (c && me && aa(Z, c),
                          ie[Se] && aa(Z, ie[Se]),
                          L && ($ === 1 ? Z.kill(!1, 1) : (ie[Se] = 0)),
                          me ||
                            ((Se = $ === 1 ? 1 : 3), ie[Se] && aa(Z, ie[Se]))),
                        M &&
                          !xe &&
                          Math.abs(Z.getVelocity()) > (Al(M) ? M : 2500) &&
                          (El(Z.callbackAnimation),
                          Fe
                            ? Fe.progress(1)
                            : El(n, Me === 'reverse' ? 1 : !$, 1)))
                      : W && o && !$i && o(Z));
                }
                if (ke) {
                  var st = N ? (Y / N.duration()) * (N._caScrollDist || 0) : Y;
                  (ge(st + (ue._isFlipped ? 1 : 0)), ke(st));
                }
                D && D((-Y / N.duration()) * (N._caScrollDist || 0));
              }
            }),
            (Z.enable = function (A, F) {
              Z.enabled ||
                ((Z.enabled = !0),
                Bi(q, 'resize', Rl),
                oe || Bi(q, 'scroll', ca),
                Ne && Bi(s, 'refreshInit', Ne),
                A !== !1 && ((Z.progress = ve = 0), (Le = At = ot = Pe())),
                F !== !1 && Z.refresh());
            }),
            (Z.getTween = function (A) {
              return A && Ae ? Ae.tween : Fe;
            }),
            (Z.setPositions = function (A, F, V, Y) {
              if (N) {
                var X = N.scrollTrigger,
                  $ = N.duration(),
                  le = X.end - X.start;
                ((A = X.start + (le * A) / $), (F = X.start + (le * F) / $));
              }
              (Z.refresh(
                !1,
                !1,
                {
                  start: Z_(A, V && !!Z._startClamp),
                  end: Z_(F, V && !!Z._endClamp),
                },
                Y,
              ),
                Z.update());
            }),
            (Z.adjustPinSpacing = function (A) {
              if (Re && A) {
                var F = Re.indexOf(z.d) + 1;
                ((Re[F] = parseFloat(Re[F]) + A + Ci),
                  (Re[1] = parseFloat(Re[1]) + A + Ci),
                  fa(Re));
              }
            }),
            (Z.disable = function (A, F) {
              if (
                (A !== !1 && Z.revert(!0, !0),
                Z.enabled &&
                  ((Z.enabled = Z.isActive = !1),
                  F || (Fe && Fe.pause()),
                  (Ce = 0),
                  Ze && (Ze.uncache = 1),
                  Ne && Ui(s, 'refreshInit', Ne),
                  j &&
                    (j.pause(), Ae.tween && Ae.tween.kill() && (Ae.tween = 0)),
                  !oe))
              ) {
                for (var V = It.length; V--; )
                  if (It[V].scroller === q && It[V] !== Z) return;
                (Ui(q, 'resize', Rl), oe || Ui(q, 'scroll', ca));
              }
            }),
            (Z.kill = function (A, F) {
              (Z.disable(A, F), Fe && !F && Fe.kill(), l && delete Gf[l]);
              var V = It.indexOf(Z);
              (V >= 0 && It.splice(V, 1),
                V === pn && gh > 0 && pn--,
                (V = 0),
                It.forEach(function (Y) {
                  return Y.scroller === Z.scroller && (V = 1);
                }),
                V || mn || (Z.scroll.rec = 0),
                n &&
                  ((n.scrollTrigger = null),
                  A && n.revert({ kill: !1 }),
                  F || n.kill()),
                Tt &&
                  [Tt, at, ue, Rt].forEach(function (Y) {
                    return Y.parentNode && Y.parentNode.removeChild(Y);
                  }),
                Nl === Z && (Nl = 0),
                p &&
                  (Ze && (Ze.uncache = 1),
                  (V = 0),
                  It.forEach(function (Y) {
                    return Y.pin === p && V++;
                  }),
                  V || (Ze.spacer = 0)),
                i.onKill && i.onKill(Z));
            }),
            It.push(Z),
            Z.enable(!1, !1),
            h && h(Z),
            n && n.add && !xt)
          ) {
            var E = Z.update;
            ((Z.update = function () {
              ((Z.update = E), Lt.cache++, Ke || ut || Z.refresh());
            }),
              Qe.delayedCall(0.01, Z.update),
              (xt = 0.01),
              (Ke = ut = 0));
          } else Z.refresh();
          p && uS();
        }),
        (s.register = function (i) {
          return (
            ha ||
              ((Qe = i || f0()),
              d0() && window.document && s.enable(),
              (ha = Ml)),
            ha
          );
        }),
        (s.defaults = function (i) {
          if (i) for (var n in i) ch[n] = i[n];
          return ch;
        }),
        (s.disable = function (i, n) {
          ((Ml = 0),
            It.forEach(function (o) {
              return o[n ? 'kill' : 'disable'](i);
            }),
            Ui(Nt, 'wheel', ca),
            Ui($t, 'scroll', ca),
            clearInterval(sh),
            Ui($t, 'touchcancel', Us),
            Ui(Zt, 'touchstart', Us),
            ah(Ui, $t, 'pointerdown,touchstart,mousedown', K_),
            ah(Ui, $t, 'pointerup,touchend,mouseup', $_),
            xh.kill(),
            oh(Ui));
          for (var r = 0; r < Lt.length; r += 3)
            (lh(Ui, Lt[r], Lt[r + 1]), lh(Ui, Lt[r], Lt[r + 2]));
        }),
        (s.enable = function () {
          if (
            ((Nt = window),
            ($t = document),
            (Fn = $t.documentElement),
            (Zt = $t.body),
            Qe)
          ) {
            if (
              ((Fl = Qe.utils.toArray),
              (Cl = Qe.utils.clamp),
              (zf = Qe.core.context || Us),
              (Df = Qe.core.suppressOverwrites || Us),
              (qf = Nt.history.scrollRestoration || 'auto'),
              (Wf = Nt.pageYOffset || 0),
              Qe.core.globals('ScrollTrigger', s),
              Zt)
            ) {
              ((Ml = 1),
                (da = document.createElement('div')),
                (da.style.height = '100vh'),
                (da.style.position = 'absolute'),
                E0(),
                sS(),
                mi.register(Qe),
                (s.isTouch = mi.isTouch),
                (Or =
                  mi.isTouch &&
                  /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent)),
                (Hf = mi.isTouch === 1),
                Bi(Nt, 'wheel', ca),
                (Yf = [Nt, $t, Fn, Zt]),
                Qe.matchMedia &&
                  ((s.matchMedia = function (u) {
                    var f = Qe.matchMedia(),
                      d;
                    for (d in u) f.add(d, u[d]);
                    return f;
                  }),
                  Qe.addEventListener('matchMediaInit', function () {
                    (b0(), Qf());
                  }),
                  Qe.addEventListener('matchMediaRevert', function () {
                    return y0();
                  }),
                  Qe.addEventListener('matchMedia', function () {
                    (xo(0, 1), Mo('matchMedia'));
                  }),
                  Qe.matchMedia().add('(orientation: portrait)', function () {
                    return (Ff(), Ff);
                  })),
                Ff(),
                Bi($t, 'scroll', ca));
              var i = Zt.hasAttribute('style'),
                n = Zt.style,
                r = n.borderTopStyle,
                o = Qe.core.Animation.prototype,
                a,
                l;
              for (
                o.revert ||
                  Object.defineProperty(o, 'revert', {
                    value: function () {
                      return this.time(-0.01, !0);
                    },
                  }),
                  n.borderTopStyle = 'solid',
                  a = lr(Zt),
                  Mi.m = Math.round(a.top + Mi.sc()) || 0,
                  Ki.m = Math.round(a.left + Ki.sc()) || 0,
                  r
                    ? (n.borderTopStyle = r)
                    : n.removeProperty('border-top-style'),
                  i ||
                    (Zt.setAttribute('style', ''), Zt.removeAttribute('style')),
                  sh = setInterval(Q_, 250),
                  Qe.delayedCall(0.5, function () {
                    return (rh = 0);
                  }),
                  Bi($t, 'touchcancel', Us),
                  Bi(Zt, 'touchstart', Us),
                  ah(Bi, $t, 'pointerdown,touchstart,mousedown', K_),
                  ah(Bi, $t, 'pointerup,touchend,mouseup', $_),
                  kf = Qe.utils.checkPrefix('transform'),
                  _h.push(kf),
                  ha = ji(),
                  xh = Qe.delayedCall(0.2, xo).pause(),
                  ua = [
                    $t,
                    'visibilitychange',
                    function () {
                      var u = Nt.innerWidth,
                        f = Nt.innerHeight;
                      $t.hidden
                        ? ((X_ = u), (Y_ = f))
                        : (X_ !== u || Y_ !== f) && Rl();
                    },
                    $t,
                    'DOMContentLoaded',
                    xo,
                    Nt,
                    'load',
                    xo,
                    Nt,
                    'resize',
                    Rl,
                  ],
                  oh(Bi),
                  It.forEach(function (u) {
                    return u.enable(0, 1);
                  }),
                  l = 0;
                l < Lt.length;
                l += 3
              )
                (lh(Ui, Lt[l], Lt[l + 1]), lh(Ui, Lt[l], Lt[l + 2]));
            } else if ($t) {
              var c = function u() {
                (s.enable(), $t.removeEventListener('DOMContentLoaded', u));
              };
              $t.addEventListener('DOMContentLoaded', c);
            }
          }
        }),
        (s.config = function (i) {
          'limitCallbacks' in i && (Of = !!i.limitCallbacks);
          var n = i.syncInterval;
          ((n && clearInterval(sh)) || ((sh = n) && setInterval(Q_, n)),
            'ignoreMobileResize' in i &&
              (Hf = s.isTouch === 1 && i.ignoreMobileResize),
            'autoRefreshEvents' in i &&
              (oh(Ui) || oh(Bi, i.autoRefreshEvents || 'none'),
              (c0 = (i.autoRefreshEvents + '').indexOf('resize') === -1)));
        }),
        (s.scrollerProxy = function (i, n) {
          var r = dn(i),
            o = Lt.indexOf(r),
            a = Eo(r);
          (~o && Lt.splice(o, a ? 6 : 2),
            n && (a ? ps.unshift(Nt, n, Zt, n, Fn, n) : ps.unshift(r, n)));
        }),
        (s.clearMatchMedia = function (i) {
          It.forEach(function (n) {
            return n._ctx && n._ctx.query === i && n._ctx.kill(!0, !0);
          });
        }),
        (s.isInViewport = function (i, n, r) {
          var o = (Nn(i) ? dn(i) : i).getBoundingClientRect(),
            a = o[r ? yo : bo] * n || 0;
          return r
            ? o.right - a > 0 && o.left + a < Nt.innerWidth
            : o.bottom - a > 0 && o.top + a < Nt.innerHeight;
        }),
        (s.positionInViewport = function (i, n, r) {
          Nn(i) && (i = dn(i));
          var o = i.getBoundingClientRect(),
            a = o[r ? yo : bo],
            l =
              n == null
                ? a / 2
                : n in bh
                  ? bh[n] * a
                  : ~n.indexOf('%')
                    ? (parseFloat(n) * a) / 100
                    : parseFloat(n) || 0;
          return r
            ? (o.left + l) / Nt.innerWidth
            : (o.top + l) / Nt.innerHeight;
        }),
        (s.killAll = function (i) {
          if (
            (It.slice(0).forEach(function (r) {
              return r.vars.id !== 'ScrollSmoother' && r.kill();
            }),
            i !== !0)
          ) {
            var n = To.killAll || [];
            ((To = {}),
              n.forEach(function (r) {
                return r();
              }));
          }
        }),
        s
      );
    })();
  Je.version = '3.15.0';
  Je.saveStyles = function (s) {
    return s
      ? Fl(s).forEach(function (e) {
          if (e && e.style) {
            var t = On.indexOf(e);
            (t >= 0 && On.splice(t, 5),
              On.push(
                e,
                e.style.cssText,
                e.getBBox && e.getAttribute('transform'),
                Qe.core.getCache(e),
                zf(),
              ));
          }
        })
      : On;
  };
  Je.revert = function (s, e) {
    return Qf(!s, e);
  };
  Je.create = function (s, e) {
    return new Je(s, e);
  };
  Je.refresh = function (s) {
    return s ? Rl(!0) : (ha || Je.register()) && xo(!0);
  };
  Je.update = function (s) {
    return ++Lt.cache && cr(s === !0 ? 2 : 0);
  };
  Je.clearScrollMemory = S0;
  Je.maxScroll = function (s, e) {
    return Bs(s, e ? Ki : Mi);
  };
  Je.getScrollFunc = function (s, e) {
    return or(dn(s), e ? Ki : Mi);
  };
  Je.getById = function (s) {
    return Gf[s];
  };
  Je.getAll = function () {
    return It.filter(function (s) {
      return s.vars.id !== 'ScrollSmoother';
    });
  };
  Je.isScrolling = function () {
    return !!$n;
  };
  Je.snapDirectional = Jf;
  Je.addEventListener = function (s, e) {
    var t = To[s] || (To[s] = []);
    ~t.indexOf(e) || t.push(e);
  };
  Je.removeEventListener = function (s, e) {
    var t = To[s],
      i = t && t.indexOf(e);
    i >= 0 && t.splice(i, 1);
  };
  Je.batch = function (s, e) {
    var t = [],
      i = {},
      n = e.interval || 0.016,
      r = e.batchMax || 1e9,
      o = function (c, u) {
        var f = [],
          d = [],
          p = Qe.delayedCall(n, function () {
            (u(f, d), (f = []), (d = []));
          }).pause();
        return function (_) {
          (f.length || p.restart(!0),
            f.push(_.trigger),
            d.push(_),
            r <= f.length && p.progress(1));
        };
      },
      a;
    for (a in e)
      i[a] =
        a.substr(0, 2) === 'on' && Ji(e[a]) && a !== 'onRefreshInit'
          ? o(a, e[a])
          : e[a];
    return (
      Ji(r) &&
        ((r = r()),
        Bi(Je, 'refresh', function () {
          return (r = e.batchMax());
        })),
      Fl(s).forEach(function (l) {
        var c = {};
        for (a in i) c[a] = i[a];
        ((c.trigger = l), t.push(Je.create(c)));
      }),
      t
    );
  };
  var r0 = function (e, t, i, n) {
      return (
        t > n ? e(n) : t < 0 && e(0),
        i > n ? (n - t) / (i - t) : i < 0 ? t / (t - i) : 1
      );
    },
    Bf = function s(e, t) {
      (t === !0
        ? e.style.removeProperty('touch-action')
        : (e.style.touchAction =
            t === !0
              ? 'auto'
              : t
                ? 'pan-' + t + (mi.isTouch ? ' pinch-zoom' : '')
                : 'none'),
        e === Fn && s(Zt, t));
    },
    fh = { auto: 1, scroll: 1 },
    gS = function (e) {
      var t = e.event,
        i = e.target,
        n = e.axis,
        r = (t.changedTouches ? t.changedTouches[0] : t).target,
        o = r._gsap || Qe.core.getCache(r),
        a = ji(),
        l;
      if (!o._isScrollT || a - o._isScrollT > 2e3) {
        for (
          ;
          r &&
          r !== Zt &&
          ((r.scrollHeight <= r.clientHeight &&
            r.scrollWidth <= r.clientWidth) ||
            !(fh[(l = Kn(r)).overflowY] || fh[l.overflowX]));
        )
          r = r.parentNode;
        ((o._isScroll =
          r &&
          r !== i &&
          !Eo(r) &&
          (fh[(l = Kn(r)).overflowY] || fh[l.overflowX])),
          (o._isScrollT = a));
      }
      (o._isScroll || n === 'x') && (t.stopPropagation(), (t._gsapAllow = !0));
    },
    M0 = function (e, t, i, n) {
      return mi.create({
        target: e,
        capture: !0,
        debounce: !1,
        lockAxis: !0,
        type: t,
        onWheel: (n = n && gS),
        onPress: n,
        onDrag: n,
        onScroll: n,
        onEnable: function () {
          return i && Bi($t, mi.eventTypes[0], a0, !1, !0);
        },
        onDisable: function () {
          return Ui($t, mi.eventTypes[0], a0, !0);
        },
      });
    },
    _S = /(input|label|select|textarea)/i,
    o0,
    a0 = function (e) {
      var t = _S.test(e.target.tagName);
      (t || o0) && ((e._gsapAllow = !0), (o0 = t));
    },
    vS = function (e) {
      (vo(e) || (e = {}),
        (e.preventDefault = e.isNormalizer = e.allowClicks = !0),
        e.type || (e.type = 'wheel,touch'),
        (e.debounce = !!e.debounce),
        (e.id = e.id || 'normalizer'));
      var t = e,
        i = t.normalizeScrollX,
        n = t.momentum,
        r = t.allowNestedScroll,
        o = t.onRelease,
        a,
        l,
        c = dn(e.target) || Fn,
        u = Qe.core.globals().ScrollSmoother,
        f = u && u.get(),
        d =
          Or &&
          ((e.content && dn(e.content)) ||
            (f && e.content !== !1 && !f.smooth() && f.content())),
        p = or(c, Mi),
        _ = or(c, Ki),
        x = 1,
        g =
          (mi.isTouch && Nt.visualViewport
            ? Nt.visualViewport.scale * Nt.visualViewport.width
            : Nt.outerWidth) / Nt.innerWidth,
        v = 0,
        w = Ji(n)
          ? function () {
              return n(a);
            }
          : function () {
              return n || 2.8;
            },
        L,
        R,
        U = M0(c, e.type, !0, r),
        O = function () {
          return (R = !1);
        },
        N = Us,
        M = Us,
        I = function () {
          ((l = Bs(c, Mi)),
            (M = Cl(Or ? 1 : 0, l)),
            i && (N = Cl(0, Bs(c, Ki))),
            (L = So));
        },
        z = function () {
          ((d._gsap.y = wl(parseFloat(d._gsap.y) + p.offset) + 'px'),
            (d.style.transform =
              'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ' +
              parseFloat(d._gsap.y) +
              ', 0, 1)'),
            (p.offset = p.cacheID = 0));
        },
        W = function () {
          if (R) {
            requestAnimationFrame(O);
            var pe = wl(a.deltaY / 2),
              Ee = M(p.v - pe);
            if (d && Ee !== p.v + p.offset) {
              p.offset = Ee - p.v;
              var Z = wl((parseFloat(d && d._gsap.y) || 0) - p.offset);
              ((d.style.transform =
                'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ' +
                Z +
                ', 0, 1)'),
                (d._gsap.y = Z + 'px'),
                (p.cacheID = Lt.cache),
                cr());
            }
            return !0;
          }
          (p.offset && z(), (R = !0));
        },
        q,
        re,
        oe,
        K,
        ie = function () {
          (I(),
            q.isActive() &&
              q.vars.scrollY > l &&
              (p() > l ? q.progress(1) && p(l) : q.resetTo('scrollY', l)));
        };
      return (
        d && Qe.set(d, { y: '+=0' }),
        (e.ignoreCheck = function (J) {
          return (
            (Or && J.type === 'touchmove' && W(J)) ||
            (x > 1.05 && J.type !== 'touchstart') ||
            a.isGesturing ||
            (J.touches && J.touches.length > 1)
          );
        }),
        (e.onPress = function () {
          R = !1;
          var J = x;
          ((x = wl(((Nt.visualViewport && Nt.visualViewport.scale) || 1) / g)),
            q.pause(),
            J !== x && Bf(c, x > 1.01 ? !0 : i ? !1 : 'x'),
            (re = _()),
            (oe = p()),
            I(),
            (L = So));
        }),
        (e.onRelease = e.onGestureStart =
          function (J, pe) {
            if ((p.offset && z(), !pe)) K.restart(!0);
            else {
              Lt.cache++;
              var Ee = w(),
                Z,
                Ne;
              (i &&
                ((Z = _()),
                (Ne = Z + (Ee * 0.05 * -J.velocityX) / 0.227),
                (Ee *= r0(_, Z, Ne, Bs(c, Ki))),
                (q.vars.scrollX = N(Ne))),
                (Z = p()),
                (Ne = Z + (Ee * 0.05 * -J.velocityY) / 0.227),
                (Ee *= r0(p, Z, Ne, Bs(c, Mi))),
                (q.vars.scrollY = M(Ne)),
                q.invalidate().duration(Ee).play(0.01),
                ((Or && q.vars.scrollY >= l) || Z >= l - 1) &&
                  Qe.to({}, { onUpdate: ie, duration: Ee }));
            }
            o && o(J);
          }),
        (e.onWheel = function () {
          (q._ts && q.pause(), ji() - v > 1e3 && ((L = 0), (v = ji())));
        }),
        (e.onChange = function (J, pe, Ee, Z, Ne) {
          if (
            (So !== L && I(),
            pe &&
              i &&
              _(N(Z[2] === pe ? re + (J.startX - J.x) : _() + pe - Z[1])),
            Ee)
          ) {
            p.offset && z();
            var Be = Ne[2] === Ee,
              ht = Be ? oe + J.startY - J.y : p() + Ee - Ne[1],
              ot = M(ht);
            (Be && ht !== ot && (oe += ot - ht), p(ot));
          }
          (Ee || pe) && cr();
        }),
        (e.onEnable = function () {
          (Bf(c, i ? !1 : 'x'),
            Je.addEventListener('refresh', ie),
            Bi(Nt, 'resize', ie),
            p.smooth &&
              ((p.target.style.scrollBehavior = 'auto'),
              (p.smooth = _.smooth = !1)),
            U.enable());
        }),
        (e.onDisable = function () {
          (Bf(c, !0),
            Ui(Nt, 'resize', ie),
            Je.removeEventListener('refresh', ie),
            U.kill());
        }),
        (e.lockAxis = e.lockAxis !== !1),
        (a = new mi(e)),
        (a.iOS = Or),
        Or && !p() && p(1),
        Or && Qe.ticker.add(Us),
        (K = a._dc),
        (q = Qe.to(a, {
          ease: 'power4',
          paused: !0,
          inherit: !1,
          scrollX: i ? '+=0.1' : '+=0',
          scrollY: '+=0.1',
          modifiers: {
            scrollY: T0(p, p(), function () {
              return q.pause();
            }),
          },
          onUpdate: cr,
          onComplete: K.vars.onComplete,
        })),
        a
      );
    };
  Je.sort = function (s) {
    if (Ji(s)) return It.sort(s);
    var e = Nt.pageYOffset || 0;
    return (
      Je.getAll().forEach(function (t) {
        return (t._sortY = t.trigger
          ? e + t.trigger.getBoundingClientRect().top
          : t.start + Nt.innerHeight);
      }),
      It.sort(
        s ||
          function (t, i) {
            return (
              (t.vars.refreshPriority || 0) * -1e6 +
              (t.vars.containerAnimation ? 1e6 : t._sortY) -
              ((i.vars.containerAnimation ? 1e6 : i._sortY) +
                (i.vars.refreshPriority || 0) * -1e6)
            );
          },
      )
    );
  };
  Je.observe = function (s) {
    return new mi(s);
  };
  Je.normalizeScroll = function (s) {
    if (typeof s == 'undefined') return fn;
    if (s === !0 && fn) return fn.enable();
    if (s === !1) {
      (fn && fn.kill(), (fn = s));
      return;
    }
    var e = s instanceof mi ? s : vS(s);
    return (
      fn && fn.target === e.target && fn.kill(),
      Eo(e.target) && (fn = e),
      e
    );
  };
  Je.core = {
    _getVelocityProp: nh,
    _inputObserver: M0,
    _scrollers: Lt,
    _proxies: ps,
    bridge: {
      ss: function () {
        ($n || Mo('scrollStart'), ($n = ji()));
      },
      ref: function () {
        return $i;
      },
    },
  };
  f0() && Qe.registerPlugin(Je);
  var Un = {
      target: 'data-scroll-anm',
      start: 'data-scroll-anm-start',
      triggerEl: 'data-scroll-anm-trigger',
      end: 'data-scroll-anm-end',
      once: 'data-scroll-anm-once',
      manual: 'data-scroll-anm-manual',
      lineGroups: 'data-scroll-anm-line-groups',
    },
    wt = {
      inview: 'is-inview',
      leave: 'is-leave',
      leaveBack: 'is-leave-back',
      offstage: 'is-offstage',
    },
    w0 = 'top 85%',
    A0 = '--anm-line-index';
  var xS = (s) => {
      var e;
      return (e = s.className.split(' ').filter(Boolean).pop()) != null
        ? e
        : '';
    },
    ks = (s, e) => ({});
  var ma = (s, e) => {
      Je.create(
        pt(
          {
            trigger: s,
            start: 'top bottom',
            end: 'bottom bottom',
            onLeaveBack: e,
          },
          ks(s, 'reset'),
        ),
      );
    },
    wo = (s, e, t) => {
      let i = Array.from(xi(`[${Un.target}]`, s)),
        n = !1,
        r = (a) => {
          a !== n &&
            ((n = a), i.forEach((l) => l.classList.toggle(wt.leave, a)));
        },
        o = (a) => {
          a.classList.remove(wt.inview, wt.leave, wt.leaveBack);
        };
      return (
        t
          ? (ma(t, () => {
              ((n = !1), i.forEach(o), e == null || e());
            }),
            Je.create(
              pt(
                {
                  trigger: t,
                  start: 'top bottom',
                  end: 'bottom top',
                  onToggle: (a) =>
                    i.forEach((l) =>
                      l.classList.toggle(wt.offstage, !a.isActive),
                    ),
                },
                ks(t, 'offstage'),
              ),
            ))
          : i.forEach((a) => {
              ma(a, () => {
                ((n = !1), o(a), e == null || e());
              });
            }),
        {
          reset: () => {
            ((n = !1), i.forEach(o));
          },
          enter: () => {
            ((n = !1),
              i.forEach((a) => {
                (a.classList.remove(wt.leave, wt.leaveBack),
                  a.classList.add(wt.inview));
              }));
          },
          applyLeave: r,
          leaveBack: () => {
            i.forEach((a) => {
              a.classList.contains(wt.inview) &&
                !a.classList.contains(wt.leave) &&
                a.classList.add(wt.leaveBack);
            });
          },
        }
      );
    },
    Ao = (s, e, t, i = {}) => {
      var n;
      Je.create(
        pt(
          pt(
            {
              trigger: s,
              start: 'top top',
              end: (n = i.end) != null ? n : 'bottom bottom',
              pin: e,
              pinType: 'fixed',
              pinSpacing: !1,
            },
            t,
          ),
          ks(e, 'pin'),
        ),
      );
    };
  var R0 = { root: 'data-bluetooth-root' },
    C0 = 'top 85%',
    P0 = 'top 65%';
  var Eh = class {
    constructor() {
      let e = Ye(`[${R0.root}]`);
      e &&
        xi(`[${Un.target}]`, e).forEach((t) => {
          (Je.create(
            pt(
              {
                trigger: t,
                start: () => (Xt() ? P0 : C0),
                onEnter: () => {
                  (t.classList.remove(wt.leave, wt.leaveBack),
                    t.classList.add(wt.inview));
                },
                onLeaveBack: () => {
                  t.classList.contains(wt.inview) &&
                    !t.classList.contains(wt.leave) &&
                    t.classList.add(wt.leaveBack);
                },
              },
              ks(t, 'enter'),
            ),
          ),
            ma(t, () => {
              t.classList.remove(wt.inview, wt.leave, wt.leaveBack);
            }));
        });
    }
  };
  var ms = {
      pcContent: 'data-feature-content',
      videoItem: 'data-feature-video',
      accordionIndex: 'data-feature-index',
      sliderTrack: 'data-feature-slider-track',
      slide: 'data-feature-slide',
      slideTrackingId: 'data-tracking-id',
      slideVideo: 'data-feature-slide-video',
      sliderPrev: 'data-feature-slider-prev',
      sliderNext: 'data-feature-slider-next',
    },
    L0 = { active: 'is-active' };
  var Bl = class {
    constructor() {
      y(this, 'items');
      y(this, 'activeIndex', 0);
      y(this, 'visibleVideos', new Set());
      y(this, 'init', () => {
        this.checkElements() &&
          ((this.activeIndex = this.getInitialActiveIndex()),
          this.applyActive(),
          Fs({
            targets: this.items.flatMap((e) => (e.video ? [e.video] : [])),
            callback: this.onIntersect,
          }),
          document.addEventListener(
            go.accordionTransitionEnd,
            this.onAccordionChange,
          ),
          li.subscribe(this.updatePlayback));
      });
      y(this, 'checkElements', () => this.items.length > 0);
      y(this, 'hasItem', (e) => this.items.some((t) => t.index === e));
      y(this, 'getInitialActiveIndex', () => {
        let e = Ye(`[${ms.accordionIndex}][open]`),
          t = Number(e == null ? void 0 : e.dataset.featureIndex);
        return this.hasItem(t) ? t : this.items[0].index;
      });
      y(this, 'onAccordionChange', (e) => {
        let { isOpen: t, details: i } = e.detail;
        if (!t) return;
        let n = Number(i.dataset.featureIndex);
        this.hasItem(n) && ((this.activeIndex = n), this.applyActive());
      });
      y(this, 'applyActive', () => {
        (this.items.forEach(({ index: e, wrapper: t }) => {
          t.classList.toggle(L0.active, e === this.activeIndex);
        }),
          this.updatePlayback());
      });
      y(this, 'onIntersect', (e) => {
        let t = e.target;
        (e.isIntersecting
          ? this.visibleVideos.add(t)
          : this.visibleVideos.delete(t),
          this.updatePlayback());
      });
      y(this, 'updatePlayback', () => {
        this.items.forEach(({ index: e, video: t }) => {
          if (!t) return;
          e === this.activeIndex && this.visibleVideos.has(t) && !li.isOpen
            ? t.paused && t.play().catch(() => {})
            : t.paused || t.pause();
        });
      });
      let e = Ye(`[${ms.pcContent}]`);
      ((this.items = e
        ? Array.from(xi(`[${ms.videoItem}]`, e)).map((t) => ({
            index: Number(t.dataset.featureVideo),
            wrapper: t,
            video: t.querySelector('video'),
          }))
        : []),
        this.init());
    }
  };
  var yS = 'transform 0.4s ease',
    bS = 0.15,
    I0 = 0.3,
    kl = class {
      constructor() {
        y(this, 'track');
        y(this, 'slides');
        y(this, 'prevBtn');
        y(this, 'nextBtn');
        y(this, 'currentIndex', 0);
        y(this, 'translate', 0);
        y(this, 'sectionVisible', !1);
        y(this, 'isDragging', !1);
        y(this, 'dragStartX', 0);
        y(this, 'dragStartTranslate', 0);
        y(this, 'lastMoveX', 0);
        y(this, 'lastMoveTime', 0);
        y(this, 'prevMoveX', 0);
        y(this, 'prevMoveTime', 0);
        y(this, 'onResized', () => {
          this.isDragging ||
            !this.track ||
            ((this.translate = -this.currentIndex * this.slideWidth()),
            this.applyTransform(!1));
        });
        y(this, 'init', () => {
          var i, n, r;
          if (!this.checkElements() || !this.track) return;
          let { track: e } = this,
            t = (i = e.parentElement) != null ? i : e;
          (Fs({ targets: [t], callback: this.onSectionIntersect }),
            (n = this.prevBtn) == null ||
              n.addEventListener('click', this.onPrev),
            (r = this.nextBtn) == null ||
              r.addEventListener('click', this.onNext),
            e.addEventListener('pointerdown', this.onPointerDown),
            e.addEventListener('pointermove', this.onPointerMove, {
              passive: !1,
            }),
            e.addEventListener('pointerup', this.onPointerUp),
            e.addEventListener('pointercancel', this.onPointerUp),
            li.subscribe(this.updatePlayback),
            this.applyTransform(!1),
            this.updateNav());
        });
        y(this, 'checkElements', () => !!(this.track && this.slides.length));
        y(this, 'slideWidth', () => {
          var e, t;
          return (t = (e = this.track) == null ? void 0 : e.clientWidth) != null
            ? t
            : 0;
        });
        y(this, 'applyTransform', (e) => {
          this.track &&
            ((this.track.style.transition = e ? yS : 'none'),
            (this.track.style.transform = `translateX(${this.translate}px)`));
        });
        y(this, 'goTo', (e) => {
          var i;
          let t = Math.max(0, Math.min(e, this.slides.length - 1));
          if (t !== this.currentIndex) {
            let n = (i = this.slides[t]) == null ? void 0 : i.trackingId;
            n && O_(n);
          }
          ((this.currentIndex = t),
            (this.translate = -t * this.slideWidth()),
            this.applyTransform(!0),
            this.updateNav(),
            this.updatePlayback());
        });
        y(this, 'onPointerDown', (e) => {
          this.track &&
            ((this.isDragging = !0),
            (this.dragStartX = e.clientX),
            (this.dragStartTranslate = this.translate),
            (this.lastMoveX = e.clientX),
            (this.lastMoveTime = e.timeStamp),
            (this.prevMoveX = e.clientX),
            (this.prevMoveTime = e.timeStamp),
            this.track.setPointerCapture(e.pointerId),
            this.applyTransform(!1),
            (this.track.style.cursor = 'grabbing'));
        });
        y(this, 'onPointerMove', (e) => {
          !this.isDragging ||
            !this.track ||
            (e.pointerType !== 'touch' && e.preventDefault(),
            (this.prevMoveX = this.lastMoveX),
            (this.prevMoveTime = this.lastMoveTime),
            (this.lastMoveX = e.clientX),
            (this.lastMoveTime = e.timeStamp),
            (this.translate =
              this.dragStartTranslate + (e.clientX - this.dragStartX)),
            this.applyTransform(!1));
        });
        y(this, 'onPointerUp', (e) => {
          !this.isDragging ||
            !this.track ||
            ((this.isDragging = !1),
            this.track.hasPointerCapture(e.pointerId) &&
              this.track.releasePointerCapture(e.pointerId),
            (this.track.style.cursor = ''),
            this.goTo(this.resolveDragTarget()));
        });
        y(this, 'resolveDragTarget', () => {
          let e = this.slideWidth() || 1,
            t = this.currentIndex,
            i = Math.round(-this.translate / e),
            n = this.lastMoveX - this.dragStartX,
            r = this.lastMoveTime - this.prevMoveTime,
            o = r > 0 ? (this.lastMoveX - this.prevMoveX) / r : 0,
            a = i;
          if (a === t) {
            let l = e * bS;
            n < -l || o < -I0 ? (a = t + 1) : (n > l || o > I0) && (a = t - 1);
          }
          return Math.max(0, Math.min(a, this.slides.length - 1));
        });
        y(this, 'onSectionIntersect', (e) => {
          ((this.sectionVisible = e.isIntersecting), this.updatePlayback());
        });
        y(this, 'onPrev', () => this.goTo(this.currentIndex - 1));
        y(this, 'onNext', () => this.goTo(this.currentIndex + 1));
        y(this, 'updateNav', () => {
          var t, i;
          let e = this.slides.length - 1;
          ((t = this.prevBtn) == null ||
            t.setAttribute('aria-disabled', String(this.currentIndex <= 0)),
            (i = this.nextBtn) == null ||
              i.setAttribute('aria-disabled', String(this.currentIndex >= e)));
        });
        y(this, 'updatePlayback', () => {
          this.slides.forEach(({ index: e, video: t }) => {
            if (!t) return;
            e === this.currentIndex && this.sectionVisible && !li.isOpen
              ? t.paused && t.play().catch(() => {})
              : t.paused || t.pause();
          });
        });
        ((this.track = Ye(`[${ms.sliderTrack}]`)),
          (this.slides = this.track
            ? Array.from(xi(`[${ms.slide}]`, this.track)).map((e, t) => ({
                index: t,
                el: e,
                video: Ye(`[${ms.slideVideo}]`, e),
                trackingId: e.getAttribute(ms.slideTrackingId),
              }))
            : []),
          (this.prevBtn = Ye(`[${ms.sliderPrev}]`)),
          (this.nextBtn = Ye(`[${ms.sliderNext}]`)),
          this.init());
      }
    };
  var Th = 'page:anchor-scroll-start',
    Mh = 'page:anchor-scroll-complete',
    D0 = 12e3,
    O0 = 0.6,
    N0 = 1.4,
    F0 = (s) => (s <= 0 ? 0 : Math.min(1, 1.001 - Zi(2, -10 * s))),
    SS = new Set(['onetrust-consent-sdk']),
    U0 = {
      prevent: (s) => SS.has(s.id),
      smoothWheel: !0,
      syncTouch: I_(),
      syncTouchLerp: 0.075,
      touchMultiplier: 1,
      touchInertiaExponent: 1.9,
      lerp: 0.0875,
      wheelMultiplier: 0.95,
    };
  var ep = {
      pinArea: 'data-introduction-pin-area',
      sticky: 'data-introduction-sticky',
    },
    tp = 0.8,
    ip = 0.75;
  var wh = class {
    constructor() {
      let e = Ye(`[${ep.pinArea}]`),
        t = Ye(`[${ep.sticky}]`);
      if (!e || !t) return;
      let i = !1,
        n = wo(
          e,
          () => {
            i = !1;
          },
          e,
        );
      (Ao(
        e,
        t,
        {
          onEnter: () => {
            ((i = !0), n.enter());
          },
          onUpdate: (r) => {
            let o = Xt() ? ip : tp,
              a = r.progress >= o;
            (n.applyLeave(a), !a && r.isActive && !i && ((i = !0), n.enter()));
          },
          onLeave: () => n.applyLeave(!0),
          onLeaveBack: () => {
            ((i = !1), n.leaveBack());
          },
        },
        { end: 'bottom top' },
      ),
        document.addEventListener(Th, (r) => {
          let { top: o } = r.detail;
          if (i) return;
          let a = e.getBoundingClientRect().top + window.scrollY,
            l = Xt() ? ip : tp,
            c = a + e.offsetHeight * l;
          o >= a && o < c && ((i = !0), n.enter());
        }));
    }
  };
  function hr(s) {
    if (s === void 0)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called",
      );
    return s;
  }
  function Y0(s, e) {
    ((s.prototype = Object.create(e.prototype)),
      (s.prototype.constructor = s),
      (s.__proto__ = e));
  }
  var Mn = {
      autoSleep: 120,
      force3D: 'auto',
      nullTargetWarn: 1,
      units: { lineHeight: '' },
    },
    Xl = { duration: 0.5, overwrite: !1, delay: 0 },
    yp,
    Xi,
    ai,
    Jn = 1e8,
    ni = 1 / Jn,
    hp = Math.PI * 2,
    ES = hp / 4,
    TS = 0,
    q0 = Math.sqrt,
    MS = Math.cos,
    wS = Math.sin,
    Pi = function (e) {
      return typeof e == 'string';
    },
    gi = function (e) {
      return typeof e == 'function';
    },
    dr = function (e) {
      return typeof e == 'number';
    },
    Fh = function (e) {
      return typeof e == 'undefined';
    },
    Vs = function (e) {
      return typeof e == 'object';
    },
    Tn = function (e) {
      return e !== !1;
    },
    bp = function () {
      return typeof window != 'undefined';
    },
    Ah = function (e) {
      return gi(e) || Pi(e);
    },
    Z0 =
      (typeof ArrayBuffer == 'function' && ArrayBuffer.isView) ||
      function () {},
    en = Array.isArray,
    AS = /random\([^)]+\)/g,
    RS = /,\s*/g,
    B0 = /(?:-?\.?\d|\.)+/gi,
    Sp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
    Lo = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
    np = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
    Ep = /[+-]=-?[.\d]+/,
    CS = /[^,'"\[\]\s]+/gi,
    PS = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
    hi,
    Hs,
    up,
    Tp,
    kn = {},
    Lh = {},
    K0,
    $0 = function (e) {
      return (Lh = _a(e, kn)) && tn;
    },
    Uh = function (e, t) {},
    Yl = function (e, t) {
      return !t && void 0;
    },
    j0 = function (e, t) {
      return (e && (kn[e] = t) && Lh && (Lh[e] = t)) || kn;
    },
    ql = function () {
      return 0;
    },
    LS = { suppressEvents: !0, isStart: !0, kill: !1 },
    Rh = { suppressEvents: !0, kill: !1 },
    IS = { suppressEvents: !0 },
    Mp = {},
    Fr = [],
    dp = {},
    J0,
    Sn = {},
    sp = {},
    k0 = 30,
    Ch = [],
    wp = '',
    Ap = function (e) {
      var t = e[0],
        i,
        n;
      if ((Vs(t) || gi(t) || (e = [e]), !(i = (t._gsap || {}).harness))) {
        for (n = Ch.length; n-- && !Ch[n].targetTest(t); );
        i = Ch[n];
      }
      for (n = e.length; n--; )
        (e[n] && (e[n]._gsap || (e[n]._gsap = new Lp(e[n], i)))) ||
          e.splice(n, 1);
      return e;
    },
    Ur = function (e) {
      return e._gsap || Ap(Qn(e))[0]._gsap;
    },
    Rp = function (e, t, i) {
      return (i = e[t]) && gi(i)
        ? e[t]()
        : (Fh(i) && e.getAttribute && e.getAttribute(t)) || i;
    },
    gn = function (e, t) {
      return (e = e.split(',')).forEach(t) || e;
    },
    _i = function (e) {
      return Math.round(e * 1e5) / 1e5 || 0;
    },
    ci = function (e) {
      return Math.round(e * 1e7) / 1e7 || 0;
    },
    Io = function (e, t) {
      var i = t.charAt(0),
        n = parseFloat(t.substr(2));
      return (
        (e = parseFloat(e)),
        i === '+' ? e + n : i === '-' ? e - n : i === '*' ? e * n : e / n
      );
    },
    DS = function (e, t) {
      for (var i = t.length, n = 0; e.indexOf(t[n]) < 0 && ++n < i; );
      return n < i;
    },
    Ih = function () {
      var e = Fr.length,
        t = Fr.slice(0),
        i,
        n;
      for (dp = {}, Fr.length = 0, i = 0; i < e; i++)
        ((n = t[i]),
          n && n._lazy && (n.render(n._lazy[0], n._lazy[1], !0)._lazy = 0));
    },
    Cp = function (e) {
      return !!(e._initted || e._startAt || e.add);
    },
    Q0 = function (e, t, i, n) {
      (Fr.length && !Xi && Ih(),
        e.render(t, i, n || !!(Xi && t < 0 && Cp(e))),
        Fr.length && !Xi && Ih());
    },
    ev = function (e) {
      var t = parseFloat(e);
      return (t || t === 0) && (e + '').match(CS).length < 2
        ? t
        : Pi(e)
          ? e.trim()
          : e;
    },
    tv = function (e) {
      return e;
    },
    Hn = function (e, t) {
      for (var i in t) i in e || (e[i] = t[i]);
      return e;
    },
    OS = function (e) {
      return function (t, i) {
        for (var n in i)
          n in t || (n === 'duration' && e) || n === 'ease' || (t[n] = i[n]);
      };
    },
    _a = function (e, t) {
      for (var i in t) e[i] = t[i];
      return e;
    },
    H0 = function s(e, t) {
      for (var i in t)
        i !== '__proto__' &&
          i !== 'constructor' &&
          i !== 'prototype' &&
          (e[i] = Vs(t[i]) ? s(e[i] || (e[i] = {}), t[i]) : t[i]);
      return e;
    },
    Dh = function (e, t) {
      var i = {},
        n;
      for (n in e) n in t || (i[n] = e[n]);
      return i;
    },
    Vl = function (e) {
      var t = e.parent || hi,
        i = e.keyframes ? OS(en(e.keyframes)) : Hn;
      if (Tn(e.inherit))
        for (; t; ) (i(e, t.vars.defaults), (t = t.parent || t._dp));
      return e;
    },
    NS = function (e, t) {
      for (var i = e.length, n = i === t.length; n && i-- && e[i] === t[i]; );
      return i < 0;
    },
    iv = function (e, t, i, n, r) {
      (i === void 0 && (i = '_first'), n === void 0 && (n = '_last'));
      var o = e[n],
        a;
      if (r) for (a = t[r]; o && o[r] > a; ) o = o._prev;
      return (
        o
          ? ((t._next = o._next), (o._next = t))
          : ((t._next = e[i]), (e[i] = t)),
        t._next ? (t._next._prev = t) : (e[n] = t),
        (t._prev = o),
        (t.parent = t._dp = e),
        t
      );
    },
    Bh = function (e, t, i, n) {
      (i === void 0 && (i = '_first'), n === void 0 && (n = '_last'));
      var r = t._prev,
        o = t._next;
      (r ? (r._next = o) : e[i] === t && (e[i] = o),
        o ? (o._prev = r) : e[n] === t && (e[n] = r),
        (t._next = t._prev = t.parent = null));
    },
    Br = function (e, t) {
      (e.parent &&
        (!t || e.parent.autoRemoveChildren) &&
        e.parent.remove &&
        e.parent.remove(e),
        (e._act = 0));
    },
    Ro = function (e, t) {
      if (e && (!t || t._end > e._dur || t._start < 0))
        for (var i = e; i; ) ((i._dirty = 1), (i = i.parent));
      return e;
    },
    FS = function (e) {
      for (var t = e.parent; t && t.parent; )
        ((t._dirty = 1), t.totalDuration(), (t = t.parent));
      return e;
    },
    fp = function (e, t, i, n) {
      return (
        e._startAt &&
        (Xi
          ? e._startAt.revert(Rh)
          : (e.vars.immediateRender && !e.vars.autoRevert) ||
            e._startAt.render(t, !0, n))
      );
    },
    US = function s(e) {
      return !e || (e._ts && s(e.parent));
    },
    z0 = function (e) {
      return e._repeat ? va(e._tTime, (e = e.duration() + e._rDelay)) * e : 0;
    },
    va = function (e, t) {
      var i = Math.floor((e = ci(e / t)));
      return e && i === e ? i - 1 : i;
    },
    Oh = function (e, t) {
      return (
        (e - t._start) * t._ts +
        (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur)
      );
    },
    kh = function (e) {
      return (e._end = ci(
        e._start + (e._tDur / Math.abs(e._ts || e._rts || ni) || 0),
      ));
    },
    Hh = function (e, t) {
      var i = e._dp;
      return (
        i &&
          i.smoothChildTiming &&
          e._ts &&
          ((e._start = ci(
            i._time -
              (e._ts > 0
                ? t / e._ts
                : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts),
          )),
          kh(e),
          i._dirty || Ro(i, e)),
        e
      );
    },
    nv = function (e, t) {
      var i;
      if (
        ((t._time ||
          (!t._dur && t._initted) ||
          (t._start < e._time && (t._dur || !t.add))) &&
          ((i = Oh(e.rawTime(), t)),
          (!t._dur || $l(0, t.totalDuration(), i) - t._tTime > ni) &&
            t.render(i, !0)),
        Ro(e, t)._dp && e._initted && e._time >= e._dur && e._ts)
      ) {
        if (e._dur < e.duration())
          for (i = e; i._dp; )
            (i.rawTime() >= 0 && i.totalTime(i._tTime), (i = i._dp));
        e._zTime = -ni;
      }
    },
    zs = function (e, t, i, n) {
      return (
        t.parent && Br(t),
        (t._start = ci(
          (dr(i) ? i : i || e !== hi ? jn(e, i, t) : e._time) + t._delay,
        )),
        (t._end = ci(
          t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0),
        )),
        iv(e, t, '_first', '_last', e._sort ? '_start' : 0),
        pp(t) || (e._recent = t),
        n || nv(e, t),
        e._ts < 0 && Hh(e, e._tTime),
        e
      );
    },
    sv = function (e, t) {
      return (
        (kn.ScrollTrigger || Uh('scrollTrigger', t)) &&
        kn.ScrollTrigger.create(t, e)
      );
    },
    rv = function (e, t, i, n, r) {
      if ((Op(e, t, r), !e._initted)) return 1;
      if (
        !i &&
        e._pt &&
        !Xi &&
        ((e._dur && e.vars.lazy !== !1) || (!e._dur && e.vars.lazy)) &&
        J0 !== En.frame
      )
        return (Fr.push(e), (e._lazy = [r, n]), 1);
    },
    BS = function s(e) {
      var t = e.parent;
      return t && t._ts && t._initted && !t._lock && (t.rawTime() < 0 || s(t));
    },
    pp = function (e) {
      var t = e.data;
      return t === 'isFromStart' || t === 'isStart';
    },
    kS = function (e, t, i, n) {
      var r = e.ratio,
        o =
          t < 0 ||
          (!t &&
            ((!e._start && BS(e) && !(!e._initted && pp(e))) ||
              ((e._ts < 0 || e._dp._ts < 0) && !pp(e))))
            ? 0
            : 1,
        a = e._rDelay,
        l = 0,
        c,
        u,
        f;
      if (
        (a &&
          e._repeat &&
          ((l = $l(0, e._tDur, t)),
          (u = va(l, a)),
          e._yoyo && u & 1 && (o = 1 - o),
          u !== va(e._tTime, a) &&
            ((r = 1 - o),
            e.vars.repeatRefresh && e._initted && e.invalidate())),
        o !== r || Xi || n || e._zTime === ni || (!t && e._zTime))
      ) {
        if (!e._initted && rv(e, t, n, i, l)) return;
        for (
          f = e._zTime,
            e._zTime = t || (i ? ni : 0),
            i || (i = t && !f),
            e.ratio = o,
            e._from && (o = 1 - o),
            e._time = 0,
            e._tTime = l,
            c = e._pt;
          c;
        )
          (c.r(o, c.d), (c = c._next));
        (t < 0 && fp(e, t, i, !0),
          e._onUpdate && !i && Bn(e, 'onUpdate'),
          l && e._repeat && !i && e.parent && Bn(e, 'onRepeat'),
          (t >= e._tDur || t < 0) &&
            e.ratio === o &&
            (o && Br(e, 1),
            !i &&
              !Xi &&
              (Bn(e, o ? 'onComplete' : 'onReverseComplete', !0),
              e._prom && e._prom())));
      } else e._zTime || (e._zTime = t);
    },
    HS = function (e, t, i) {
      var n;
      if (i > t)
        for (n = e._first; n && n._start <= i; ) {
          if (n.data === 'isPause' && n._start > t) return n;
          n = n._next;
        }
      else
        for (n = e._last; n && n._start >= i; ) {
          if (n.data === 'isPause' && n._start < t) return n;
          n = n._prev;
        }
    },
    xa = function (e, t, i, n) {
      var r = e._repeat,
        o = ci(t) || 0,
        a = e._tTime / e._tDur;
      return (
        a && !n && (e._time *= o / e._dur),
        (e._dur = o),
        (e._tDur = r ? (r < 0 ? 1e10 : ci(o * (r + 1) + e._rDelay * r)) : o),
        a > 0 && !n && Hh(e, (e._tTime = e._tDur * a)),
        e.parent && kh(e),
        i || Ro(e.parent, e),
        e
      );
    },
    V0 = function (e) {
      return e instanceof Qi ? Ro(e) : xa(e, e._dur);
    },
    zS = { _start: 0, endTime: ql, totalDuration: ql },
    jn = function s(e, t, i) {
      var n = e.labels,
        r = e._recent || zS,
        o = e.duration() >= Jn ? r.endTime(!1) : e._dur,
        a,
        l,
        c;
      return Pi(t) && (isNaN(t) || t in n)
        ? ((l = t.charAt(0)),
          (c = t.substr(-1) === '%'),
          (a = t.indexOf('=')),
          l === '<' || l === '>'
            ? (a >= 0 && (t = t.replace(/=/, '')),
              (l === '<' ? r._start : r.endTime(r._repeat >= 0)) +
                (parseFloat(t.substr(1)) || 0) *
                  (c ? (a < 0 ? r : i).totalDuration() / 100 : 1))
            : a < 0
              ? (t in n || (n[t] = o), n[t])
              : ((l = parseFloat(t.charAt(a - 1) + t.substr(a + 1))),
                c && i && (l = (l / 100) * (en(i) ? i[0] : i).totalDuration()),
                a > 1 ? s(e, t.substr(0, a - 1), i) + l : o + l))
        : t == null
          ? o
          : +t;
    },
    Gl = function (e, t, i) {
      var n = dr(t[1]),
        r = (n ? 2 : 1) + (e < 2 ? 0 : 1),
        o = t[r],
        a,
        l;
      if ((n && (o.duration = t[1]), (o.parent = i), e)) {
        for (a = o, l = i; l && !('immediateRender' in a); )
          ((a = l.vars.defaults || {}), (l = Tn(l.vars.inherit) && l.parent));
        ((o.immediateRender = Tn(a.immediateRender)),
          e < 2 ? (o.runBackwards = 1) : (o.startAt = t[r - 1]));
      }
      return new yi(t[0], o, t[r + 1]);
    },
    kr = function (e, t) {
      return e || e === 0 ? t(e) : t;
    },
    $l = function (e, t, i) {
      return i < e ? e : i > t ? t : i;
    },
    Yi = function (e, t) {
      return !Pi(e) || !(t = PS.exec(e)) ? '' : t[1];
    },
    VS = function (e, t, i) {
      return kr(i, function (n) {
        return $l(e, t, n);
      });
    },
    mp = [].slice,
    ov = function (e, t) {
      return (
        e &&
        Vs(e) &&
        'length' in e &&
        ((!t && !e.length) || (e.length - 1 in e && Vs(e[0]))) &&
        !e.nodeType &&
        e !== Hs
      );
    },
    GS = function (e, t, i) {
      return (
        i === void 0 && (i = []),
        e.forEach(function (n) {
          var r;
          return (Pi(n) && !t) || ov(n, 1)
            ? (r = i).push.apply(r, Qn(n))
            : i.push(n);
        }) || i
      );
    },
    Qn = function (e, t, i) {
      return ai && !t && ai.selector
        ? ai.selector(e)
        : Pi(e) && !i && (up || !ya())
          ? mp.call((t || Tp).querySelectorAll(e), 0)
          : en(e)
            ? GS(e, i)
            : ov(e)
              ? mp.call(e, 0)
              : e
                ? [e]
                : [];
    },
    gp = function (e) {
      return (
        (e = Qn(e)[0] || Yl('Invalid scope') || {}),
        function (t) {
          var i = e.current || e.nativeElement || e;
          return Qn(
            t,
            i.querySelectorAll
              ? i
              : i === e
                ? Yl('Invalid scope') || Tp.createElement('div')
                : e,
          );
        }
      );
    },
    av = function (e) {
      return e.sort(function () {
        return 0.5 - Math.random();
      });
    },
    lv = function (e) {
      if (gi(e)) return e;
      var t = Vs(e) ? e : { each: e },
        i = Co(t.ease),
        n = t.from || 0,
        r = parseFloat(t.base) || 0,
        o = {},
        a = n > 0 && n < 1,
        l = isNaN(n) || a,
        c = t.axis,
        u = n,
        f = n;
      return (
        Pi(n)
          ? (u = f = { center: 0.5, edges: 0.5, end: 1 }[n] || 0)
          : !a && l && ((u = n[0]), (f = n[1])),
        function (d, p, _) {
          var x = (_ || t).length,
            g = o[x],
            v,
            w,
            L,
            R,
            U,
            O,
            N,
            M,
            I;
          if (!g) {
            if (((I = t.grid === 'auto' ? 0 : (t.grid || [1, Jn])[1]), !I)) {
              for (
                N = -Jn;
                N < (N = _[I++].getBoundingClientRect().left) && I < x;
              );
              I < x && I--;
            }
            for (
              g = o[x] = [],
                v = l ? Math.min(I, x) * u - 0.5 : n % I,
                w = I === Jn ? 0 : l ? (x * f) / I - 0.5 : (n / I) | 0,
                N = 0,
                M = Jn,
                O = 0;
              O < x;
              O++
            )
              ((L = (O % I) - v),
                (R = w - ((O / I) | 0)),
                (g[O] = U =
                  c ? Math.abs(c === 'y' ? R : L) : q0(L * L + R * R)),
                U > N && (N = U),
                U < M && (M = U));
            (n === 'random' && av(g),
              (g.max = N - M),
              (g.min = M),
              (g.v = x =
                (parseFloat(t.amount) ||
                  parseFloat(t.each) *
                    (I > x
                      ? x - 1
                      : c
                        ? c === 'y'
                          ? x / I
                          : I
                        : Math.max(I, x / I)) ||
                  0) * (n === 'edges' ? -1 : 1)),
              (g.b = x < 0 ? r - x : r),
              (g.u = Yi(t.amount || t.each) || 0),
              (i = i && x < 0 ? iE(i) : i));
          }
          return (
            (x = (g[d] - g.min) / g.max || 0),
            ci(g.b + (i ? i(x) : x) * g.v) + g.u
          );
        }
      );
    },
    _p = function (e) {
      var t = Math.pow(10, ((e + '').split('.')[1] || '').length);
      return function (i) {
        var n = ci(Math.round(parseFloat(i) / e) * e * t);
        return (n - (n % 1)) / t + (dr(i) ? 0 : Yi(i));
      };
    },
    cv = function (e, t) {
      var i = en(e),
        n,
        r;
      return (
        !i &&
          Vs(e) &&
          ((n = i = e.radius || Jn),
          e.values
            ? ((e = Qn(e.values)), (r = !dr(e[0])) && (n *= n))
            : (e = _p(e.increment))),
        kr(
          t,
          i
            ? gi(e)
              ? function (o) {
                  return ((r = e(o)), Math.abs(r - o) <= n ? r : o);
                }
              : function (o) {
                  for (
                    var a = parseFloat(r ? o.x : o),
                      l = parseFloat(r ? o.y : 0),
                      c = Jn,
                      u = 0,
                      f = e.length,
                      d,
                      p;
                    f--;
                  )
                    (r
                      ? ((d = e[f].x - a),
                        (p = e[f].y - l),
                        (d = d * d + p * p))
                      : (d = Math.abs(e[f] - a)),
                      d < c && ((c = d), (u = f)));
                  return (
                    (u = !n || c <= n ? e[u] : o),
                    r || u === o || dr(o) ? u : u + Yi(o)
                  );
                }
            : _p(e),
        )
      );
    },
    hv = function (e, t, i, n) {
      return kr(en(e) ? !t : i === !0 ? !!(i = 0) : !n, function () {
        return en(e)
          ? e[~~(Math.random() * e.length)]
          : (i = i || 1e-5) &&
              (n = i < 1 ? Math.pow(10, (i + '').length - 2) : 1) &&
              Math.floor(
                Math.round(
                  (e - i / 2 + Math.random() * (t - e + i * 0.99)) / i,
                ) *
                  i *
                  n,
              ) / n;
      });
    },
    WS = function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      return function (n) {
        return t.reduce(function (r, o) {
          return o(r);
        }, n);
      };
    },
    XS = function (e, t) {
      return function (i) {
        return e(parseFloat(i)) + (t || Yi(i));
      };
    },
    YS = function (e, t, i) {
      return dv(e, t, 0, 1, i);
    },
    uv = function (e, t, i) {
      return kr(i, function (n) {
        return e[~~t(n)];
      });
    },
    qS = function s(e, t, i) {
      var n = t - e;
      return en(e)
        ? uv(e, s(0, e.length), t)
        : kr(i, function (r) {
            return ((n + ((r - e) % n)) % n) + e;
          });
    },
    ZS = function s(e, t, i) {
      var n = t - e,
        r = n * 2;
      return en(e)
        ? uv(e, s(0, e.length - 1), t)
        : kr(i, function (o) {
            return (
              (o = (r + ((o - e) % r)) % r || 0),
              e + (o > n ? r - o : o)
            );
          });
    },
    ba = function (e) {
      return e.replace(AS, function (t) {
        var i = t.indexOf('[') + 1,
          n = t.substring(i || 7, i ? t.indexOf(']') : t.length - 1).split(RS);
        return hv(i ? n : +n[0], i ? 0 : +n[1], +n[2] || 1e-5);
      });
    },
    dv = function (e, t, i, n, r) {
      var o = t - e,
        a = n - i;
      return kr(r, function (l) {
        return i + (((l - e) / o) * a || 0);
      });
    },
    KS = function s(e, t, i, n) {
      var r = isNaN(e + t)
        ? 0
        : function (p) {
            return (1 - p) * e + p * t;
          };
      if (!r) {
        var o = Pi(e),
          a = {},
          l,
          c,
          u,
          f,
          d;
        if ((i === !0 && (n = 1) && (i = null), o))
          ((e = { p: e }), (t = { p: t }));
        else if (en(e) && !en(t)) {
          for (u = [], f = e.length, d = f - 2, c = 1; c < f; c++)
            u.push(s(e[c - 1], e[c]));
          (f--,
            (r = function (_) {
              _ *= f;
              var x = Math.min(d, ~~_);
              return u[x](_ - x);
            }),
            (i = t));
        } else n || (e = _a(en(e) ? [] : {}, e));
        if (!u) {
          for (l in t) Ip.call(a, e, l, 'get', t[l]);
          r = function (_) {
            return Up(_, a) || (o ? e.p : e);
          };
        }
      }
      return kr(i, r);
    },
    G0 = function (e, t, i) {
      var n = e.labels,
        r = Jn,
        o,
        a,
        l;
      for (o in n)
        ((a = n[o] - t),
          a < 0 == !!i && a && r > (a = Math.abs(a)) && ((l = o), (r = a)));
      return l;
    },
    Bn = function (e, t, i) {
      var n = e.vars,
        r = n[t],
        o = ai,
        a = e._ctx,
        l,
        c,
        u;
      if (r)
        return (
          (l = n[t + 'Params']),
          (c = n.callbackScope || e),
          i && Fr.length && Ih(),
          a && (ai = a),
          (u = l ? r.apply(c, l) : r.call(c)),
          (ai = o),
          u
        );
    },
    Hl = function (e) {
      return (
        Br(e),
        e.scrollTrigger && e.scrollTrigger.kill(!!Xi),
        e.progress() < 1 && Bn(e, 'onInterrupt'),
        e
      );
    },
    ga,
    fv = [],
    pv = function (e) {
      if (e)
        if (((e = (!e.name && e.default) || e), bp() || e.headless)) {
          var t = e.name,
            i = gi(e),
            n =
              t && !i && e.init
                ? function () {
                    this._props = [];
                  }
                : e,
            r = {
              init: ql,
              render: Up,
              add: Ip,
              kill: dE,
              modifier: uE,
              rawVars: 0,
            },
            o = {
              targetTest: 0,
              get: 0,
              getSetter: zh,
              aliases: {},
              register: 0,
            };
          if ((ya(), e !== n)) {
            if (Sn[t]) return;
            (Hn(n, Hn(Dh(e, r), o)),
              _a(n.prototype, _a(r, Dh(e, o))),
              (Sn[(n.prop = t)] = n),
              e.targetTest && (Ch.push(n), (Mp[t] = 1)),
              (t =
                (t === 'css'
                  ? 'CSS'
                  : t.charAt(0).toUpperCase() + t.substr(1)) + 'Plugin'));
          }
          (j0(t, n), e.register && e.register(tn, n, _n));
        } else fv.push(e);
    },
    ii = 255,
    zl = {
      aqua: [0, ii, ii],
      lime: [0, ii, 0],
      silver: [192, 192, 192],
      black: [0, 0, 0],
      maroon: [128, 0, 0],
      teal: [0, 128, 128],
      blue: [0, 0, ii],
      navy: [0, 0, 128],
      white: [ii, ii, ii],
      olive: [128, 128, 0],
      yellow: [ii, ii, 0],
      orange: [ii, 165, 0],
      gray: [128, 128, 128],
      purple: [128, 0, 128],
      green: [0, 128, 0],
      red: [ii, 0, 0],
      pink: [ii, 192, 203],
      cyan: [0, ii, ii],
      transparent: [ii, ii, ii, 0],
    },
    rp = function (e, t, i) {
      return (
        (e += e < 0 ? 1 : e > 1 ? -1 : 0),
        ((e * 6 < 1
          ? t + (i - t) * e * 6
          : e < 0.5
            ? i
            : e * 3 < 2
              ? t + (i - t) * (2 / 3 - e) * 6
              : t) *
          ii +
          0.5) |
          0
      );
    },
    mv = function (e, t, i) {
      var n = e ? (dr(e) ? [e >> 16, (e >> 8) & ii, e & ii] : 0) : zl.black,
        r,
        o,
        a,
        l,
        c,
        u,
        f,
        d,
        p,
        _;
      if (!n) {
        if ((e.substr(-1) === ',' && (e = e.substr(0, e.length - 1)), zl[e]))
          n = zl[e];
        else if (e.charAt(0) === '#') {
          if (
            (e.length < 6 &&
              ((r = e.charAt(1)),
              (o = e.charAt(2)),
              (a = e.charAt(3)),
              (e =
                '#' +
                r +
                r +
                o +
                o +
                a +
                a +
                (e.length === 5 ? e.charAt(4) + e.charAt(4) : ''))),
            e.length === 9)
          )
            return (
              (n = parseInt(e.substr(1, 6), 16)),
              [n >> 16, (n >> 8) & ii, n & ii, parseInt(e.substr(7), 16) / 255]
            );
          ((e = parseInt(e.substr(1), 16)),
            (n = [e >> 16, (e >> 8) & ii, e & ii]));
        } else if (e.substr(0, 3) === 'hsl') {
          if (((n = _ = e.match(B0)), !t))
            ((l = (+n[0] % 360) / 360),
              (c = +n[1] / 100),
              (u = +n[2] / 100),
              (o = u <= 0.5 ? u * (c + 1) : u + c - u * c),
              (r = u * 2 - o),
              n.length > 3 && (n[3] *= 1),
              (n[0] = rp(l + 1 / 3, r, o)),
              (n[1] = rp(l, r, o)),
              (n[2] = rp(l - 1 / 3, r, o)));
          else if (~e.indexOf('='))
            return ((n = e.match(Sp)), i && n.length < 4 && (n[3] = 1), n);
        } else n = e.match(B0) || zl.transparent;
        n = n.map(Number);
      }
      return (
        t &&
          !_ &&
          ((r = n[0] / ii),
          (o = n[1] / ii),
          (a = n[2] / ii),
          (f = Math.max(r, o, a)),
          (d = Math.min(r, o, a)),
          (u = (f + d) / 2),
          f === d
            ? (l = c = 0)
            : ((p = f - d),
              (c = u > 0.5 ? p / (2 - f - d) : p / (f + d)),
              (l =
                f === r
                  ? (o - a) / p + (o < a ? 6 : 0)
                  : f === o
                    ? (a - r) / p + 2
                    : (r - o) / p + 4),
              (l *= 60)),
          (n[0] = ~~(l + 0.5)),
          (n[1] = ~~(c * 100 + 0.5)),
          (n[2] = ~~(u * 100 + 0.5))),
        i && n.length < 4 && (n[3] = 1),
        n
      );
    },
    gv = function (e) {
      var t = [],
        i = [],
        n = -1;
      return (
        e.split(ur).forEach(function (r) {
          var o = r.match(Lo) || [];
          (t.push.apply(t, o), i.push((n += o.length + 1)));
        }),
        (t.c = i),
        t
      );
    },
    W0 = function (e, t, i) {
      var n = '',
        r = (e + n).match(ur),
        o = t ? 'hsla(' : 'rgba(',
        a = 0,
        l,
        c,
        u,
        f;
      if (!r) return e;
      if (
        ((r = r.map(function (d) {
          return (
            (d = mv(d, t, 1)) &&
            o +
              (t
                ? d[0] + ',' + d[1] + '%,' + d[2] + '%,' + d[3]
                : d.join(',')) +
              ')'
          );
        })),
        i && ((u = gv(e)), (l = i.c), l.join(n) !== u.c.join(n)))
      )
        for (c = e.replace(ur, '1').split(Lo), f = c.length - 1; a < f; a++)
          n +=
            c[a] +
            (~l.indexOf(a)
              ? r.shift() || o + '0,0,0,0)'
              : (u.length ? u : r.length ? r : i).shift());
      if (!c)
        for (c = e.split(ur), f = c.length - 1; a < f; a++) n += c[a] + r[a];
      return n + c[f];
    },
    ur = (function () {
      var s =
          '(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b',
        e;
      for (e in zl) s += '|' + e + '\\b';
      return new RegExp(s + ')', 'gi');
    })(),
    $S = /hsl[a]?\(/,
    Pp = function (e) {
      var t = e.join(' '),
        i;
      if (((ur.lastIndex = 0), ur.test(t)))
        return (
          (i = $S.test(t)),
          (e[1] = W0(e[1], i)),
          (e[0] = W0(e[0], i, gv(e[1]))),
          !0
        );
    },
    Zl,
    En = (function () {
      var s = Date.now,
        e = 500,
        t = 33,
        i = s(),
        n = i,
        r = 1e3 / 240,
        o = r,
        a = [],
        l,
        c,
        u,
        f,
        d,
        p,
        _ = function x(g) {
          var v = s() - n,
            w = g === !0,
            L,
            R,
            U,
            O;
          if (
            ((v > e || v < 0) && (i += v - t),
            (n += v),
            (U = n - i),
            (L = U - o),
            (L > 0 || w) &&
              ((O = ++f.frame),
              (d = U - f.time * 1e3),
              (f.time = U = U / 1e3),
              (o += L + (L >= r ? 4 : r - L)),
              (R = 1)),
            w || (l = c(x)),
            R)
          )
            for (p = 0; p < a.length; p++) a[p](U, d, O, g);
        };
      return (
        (f = {
          time: 0,
          frame: 0,
          tick: function () {
            _(!0);
          },
          deltaRatio: function (g) {
            return d / (1e3 / (g || 60));
          },
          wake: function () {
            K0 &&
              (!up &&
                bp() &&
                ((Hs = up = window),
                (Tp = Hs.document || {}),
                (kn.gsap = tn),
                (Hs.gsapVersions || (Hs.gsapVersions = [])).push(tn.version),
                $0(Lh || Hs.GreenSockGlobals || (!Hs.gsap && Hs) || {}),
                fv.forEach(pv)),
              (u =
                typeof requestAnimationFrame != 'undefined' &&
                requestAnimationFrame),
              l && f.sleep(),
              (c =
                u ||
                function (g) {
                  return setTimeout(g, (o - f.time * 1e3 + 1) | 0);
                }),
              (Zl = 1),
              _(2));
          },
          sleep: function () {
            ((u ? cancelAnimationFrame : clearTimeout)(l), (Zl = 0), (c = ql));
          },
          lagSmoothing: function (g, v) {
            ((e = g || 1 / 0), (t = Math.min(v || 33, e)));
          },
          fps: function (g) {
            ((r = 1e3 / (g || 240)), (o = f.time * 1e3 + r));
          },
          add: function (g, v, w) {
            var L = v
              ? function (R, U, O, N) {
                  (g(R, U, O, N), f.remove(L));
                }
              : g;
            return (f.remove(g), a[w ? 'unshift' : 'push'](L), ya(), L);
          },
          remove: function (g, v) {
            ~(v = a.indexOf(g)) && a.splice(v, 1) && p >= v && p--;
          },
          _listeners: a,
        }),
        f
      );
    })(),
    ya = function () {
      return !Zl && En.wake();
    },
    Ht = {},
    jS = /^[\d.\-M][\d.\-,\s]/,
    JS = /["']/g,
    QS = function (e) {
      for (
        var t = {},
          i = e.substr(1, e.length - 3).split(':'),
          n = i[0],
          r = 1,
          o = i.length,
          a,
          l,
          c;
        r < o;
        r++
      )
        ((l = i[r]),
          (a = r !== o - 1 ? l.lastIndexOf(',') : l.length),
          (c = l.substr(0, a)),
          (t[n] = isNaN(c) ? c.replace(JS, '').trim() : +c),
          (n = l.substr(a + 1).trim()));
      return t;
    },
    eE = function (e) {
      var t = e.indexOf('(') + 1,
        i = e.indexOf(')'),
        n = e.indexOf('(', t);
      return e.substring(t, ~n && n < i ? e.indexOf(')', i + 1) : i);
    },
    tE = function (e) {
      var t = (e + '').split('('),
        i = Ht[t[0]];
      return i && t.length > 1 && i.config
        ? i.config.apply(
            null,
            ~e.indexOf('{') ? [QS(t[1])] : eE(e).split(',').map(ev),
          )
        : Ht._CE && jS.test(e)
          ? Ht._CE('', e)
          : i;
    },
    iE = function (e) {
      return function (t) {
        return 1 - e(1 - t);
      };
    },
    Co = function (e, t) {
      return (e && (gi(e) ? e : Ht[e] || tE(e))) || t;
    },
    Do = function (e, t, i, n) {
      (i === void 0 &&
        (i = function (l) {
          return 1 - t(1 - l);
        }),
        n === void 0 &&
          (n = function (l) {
            return l < 0.5 ? t(l * 2) / 2 : 1 - t((1 - l) * 2) / 2;
          }));
      var r = { easeIn: t, easeOut: i, easeInOut: n },
        o;
      return (
        gn(e, function (a) {
          ((Ht[a] = kn[a] = r), (Ht[(o = a.toLowerCase())] = i));
          for (var l in r)
            Ht[
              o + (l === 'easeIn' ? '.in' : l === 'easeOut' ? '.out' : '.inOut')
            ] = Ht[a + '.' + l] = r[l];
        }),
        r
      );
    },
    _v = function (e) {
      return function (t) {
        return t < 0.5 ? (1 - e(1 - t * 2)) / 2 : 0.5 + e((t - 0.5) * 2) / 2;
      };
    },
    op = function s(e, t, i) {
      var n = t >= 1 ? t : 1,
        r = (i || (e ? 0.3 : 0.45)) / (t < 1 ? t : 1),
        o = (r / hp) * (Math.asin(1 / n) || 0),
        a = function (u) {
          return u === 1 ? 1 : n * Math.pow(2, -10 * u) * wS((u - o) * r) + 1;
        },
        l =
          e === 'out'
            ? a
            : e === 'in'
              ? function (c) {
                  return 1 - a(1 - c);
                }
              : _v(a);
      return (
        (r = hp / r),
        (l.config = function (c, u) {
          return s(e, c, u);
        }),
        l
      );
    },
    ap = function s(e, t) {
      t === void 0 && (t = 1.70158);
      var i = function (o) {
          return o ? --o * o * ((t + 1) * o + t) + 1 : 0;
        },
        n =
          e === 'out'
            ? i
            : e === 'in'
              ? function (r) {
                  return 1 - i(1 - r);
                }
              : _v(i);
      return (
        (n.config = function (r) {
          return s(e, r);
        }),
        n
      );
    };
  gn('Linear,Quad,Cubic,Quart,Quint,Strong', function (s, e) {
    var t = e < 5 ? e + 1 : e;
    Do(
      s + ',Power' + (t - 1),
      e
        ? function (i) {
            return Math.pow(i, t);
          }
        : function (i) {
            return i;
          },
      function (i) {
        return 1 - Math.pow(1 - i, t);
      },
      function (i) {
        return i < 0.5
          ? Math.pow(i * 2, t) / 2
          : 1 - Math.pow((1 - i) * 2, t) / 2;
      },
    );
  });
  Ht.Linear.easeNone = Ht.none = Ht.Linear.easeIn;
  Do('Elastic', op('in'), op('out'), op());
  (function (s, e) {
    var t = 1 / e,
      i = 2 * t,
      n = 2.5 * t,
      r = function (a) {
        return a < t
          ? s * a * a
          : a < i
            ? s * Math.pow(a - 1.5 / e, 2) + 0.75
            : a < n
              ? s * (a -= 2.25 / e) * a + 0.9375
              : s * Math.pow(a - 2.625 / e, 2) + 0.984375;
      };
    Do(
      'Bounce',
      function (o) {
        return 1 - r(1 - o);
      },
      r,
    );
  })(7.5625, 2.75);
  Do('Expo', function (s) {
    return Math.pow(2, 10 * (s - 1)) * s + s * s * s * s * s * s * (1 - s);
  });
  Do('Circ', function (s) {
    return -(q0(1 - s * s) - 1);
  });
  Do('Sine', function (s) {
    return s === 1 ? 1 : -MS(s * ES) + 1;
  });
  Do('Back', ap('in'), ap('out'), ap());
  Ht.SteppedEase =
    Ht.steps =
    kn.SteppedEase =
      {
        config: function (e, t) {
          e === void 0 && (e = 1);
          var i = 1 / e,
            n = e + (t ? 0 : 1),
            r = t ? 1 : 0,
            o = 1 - ni;
          return function (a) {
            return (((n * $l(0, o, a)) | 0) + r) * i;
          };
        },
      };
  Xl.ease = Ht['quad.out'];
  gn(
    'onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt',
    function (s) {
      return (wp += s + ',' + s + 'Params,');
    },
  );
  var Lp = function (e, t) {
      ((this.id = TS++),
        (e._gsap = this),
        (this.target = e),
        (this.harness = t),
        (this.get = t ? t.get : Rp),
        (this.set = t ? t.getSetter : zh));
    },
    Kl = (function () {
      function s(t) {
        ((this.vars = t),
          (this._delay = +t.delay || 0),
          (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) &&
            ((this._rDelay = t.repeatDelay || 0),
            (this._yoyo = !!t.yoyo || !!t.yoyoEase)),
          (this._ts = 1),
          xa(this, +t.duration, 1, 1),
          (this.data = t.data),
          ai && ((this._ctx = ai), ai.data.push(this)),
          Zl || En.wake());
      }
      var e = s.prototype;
      return (
        (e.delay = function (i) {
          return i || i === 0
            ? (this.parent &&
                this.parent.smoothChildTiming &&
                this.startTime(this._start + i - this._delay),
              (this._delay = i),
              this)
            : this._delay;
        }),
        (e.duration = function (i) {
          return arguments.length
            ? this.totalDuration(
                this._repeat > 0 ? i + (i + this._rDelay) * this._repeat : i,
              )
            : this.totalDuration() && this._dur;
        }),
        (e.totalDuration = function (i) {
          return arguments.length
            ? ((this._dirty = 0),
              xa(
                this,
                this._repeat < 0
                  ? i
                  : (i - this._repeat * this._rDelay) / (this._repeat + 1),
              ))
            : this._tDur;
        }),
        (e.totalTime = function (i, n) {
          if ((ya(), !arguments.length)) return this._tTime;
          var r = this._dp;
          if (r && r.smoothChildTiming && this._ts) {
            for (
              Hh(this, i), !r._dp || r.parent || nv(r, this);
              r && r.parent;
            )
              (r.parent._time !==
                r._start +
                  (r._ts >= 0
                    ? r._tTime / r._ts
                    : (r.totalDuration() - r._tTime) / -r._ts) &&
                r.totalTime(r._tTime, !0),
                (r = r.parent));
            !this.parent &&
              this._dp.autoRemoveChildren &&
              ((this._ts > 0 && i < this._tDur) ||
                (this._ts < 0 && i > 0) ||
                (!this._tDur && !i)) &&
              zs(this._dp, this, this._start - this._delay);
          }
          return (
            (this._tTime !== i ||
              (!this._dur && !n) ||
              (this._initted && Math.abs(this._zTime) === ni) ||
              (!this._initted && this._dur && i) ||
              (!i && !this._initted && (this.add || this._ptLookup))) &&
              (this._ts || (this._pTime = i), Q0(this, i, n)),
            this
          );
        }),
        (e.time = function (i, n) {
          return arguments.length
            ? this.totalTime(
                Math.min(this.totalDuration(), i + z0(this)) %
                  (this._dur + this._rDelay) || (i ? this._dur : 0),
                n,
              )
            : this._time;
        }),
        (e.totalProgress = function (i, n) {
          return arguments.length
            ? this.totalTime(this.totalDuration() * i, n)
            : this.totalDuration()
              ? Math.min(1, this._tTime / this._tDur)
              : this.rawTime() >= 0 && this._initted
                ? 1
                : 0;
        }),
        (e.progress = function (i, n) {
          return arguments.length
            ? this.totalTime(
                this.duration() *
                  (this._yoyo && !(this.iteration() & 1) ? 1 - i : i) +
                  z0(this),
                n,
              )
            : this.duration()
              ? Math.min(1, this._time / this._dur)
              : this.rawTime() > 0
                ? 1
                : 0;
        }),
        (e.iteration = function (i, n) {
          var r = this.duration() + this._rDelay;
          return arguments.length
            ? this.totalTime(this._time + (i - 1) * r, n)
            : this._repeat
              ? va(this._tTime, r) + 1
              : 1;
        }),
        (e.timeScale = function (i, n) {
          if (!arguments.length) return this._rts === -ni ? 0 : this._rts;
          if (this._rts === i) return this;
          var r =
            this.parent && this._ts ? Oh(this.parent._time, this) : this._tTime;
          return (
            (this._rts = +i || 0),
            (this._ts = this._ps || i === -ni ? 0 : this._rts),
            this.totalTime(
              $l(-Math.abs(this._delay), this.totalDuration(), r),
              n !== !1,
            ),
            kh(this),
            FS(this)
          );
        }),
        (e.paused = function (i) {
          return arguments.length
            ? (this._ps !== i &&
                ((this._ps = i),
                i
                  ? ((this._pTime =
                      this._tTime || Math.max(-this._delay, this.rawTime())),
                    (this._ts = this._act = 0))
                  : (ya(),
                    (this._ts = this._rts),
                    this.totalTime(
                      this.parent && !this.parent.smoothChildTiming
                        ? this.rawTime()
                        : this._tTime || this._pTime,
                      this.progress() === 1 &&
                        Math.abs(this._zTime) !== ni &&
                        (this._tTime -= ni),
                    ))),
              this)
            : this._ps;
        }),
        (e.startTime = function (i) {
          if (arguments.length) {
            this._start = ci(i);
            var n = this.parent || this._dp;
            return (
              n &&
                (n._sort || !this.parent) &&
                zs(n, this, this._start - this._delay),
              this
            );
          }
          return this._start;
        }),
        (e.endTime = function (i) {
          return (
            this._start +
            (Tn(i) ? this.totalDuration() : this.duration()) /
              Math.abs(this._ts || 1)
          );
        }),
        (e.rawTime = function (i) {
          var n = this.parent || this._dp;
          return n
            ? i &&
              (!this._ts ||
                (this._repeat && this._time && this.totalProgress() < 1))
              ? this._tTime % (this._dur + this._rDelay)
              : this._ts
                ? Oh(n.rawTime(i), this)
                : this._tTime
            : this._tTime;
        }),
        (e.revert = function (i) {
          i === void 0 && (i = IS);
          var n = Xi;
          return (
            (Xi = i),
            Cp(this) &&
              (this.timeline && this.timeline.revert(i),
              this.totalTime(-0.01, i.suppressEvents)),
            this.data !== 'nested' && i.kill !== !1 && this.kill(),
            (Xi = n),
            this
          );
        }),
        (e.globalTime = function (i) {
          for (var n = this, r = arguments.length ? i : n.rawTime(); n; )
            ((r = n._start + r / (Math.abs(n._ts) || 1)), (n = n._dp));
          return !this.parent && this._sat ? this._sat.globalTime(i) : r;
        }),
        (e.repeat = function (i) {
          return arguments.length
            ? ((this._repeat = i === 1 / 0 ? -2 : i), V0(this))
            : this._repeat === -2
              ? 1 / 0
              : this._repeat;
        }),
        (e.repeatDelay = function (i) {
          if (arguments.length) {
            var n = this._time;
            return ((this._rDelay = i), V0(this), n ? this.time(n) : this);
          }
          return this._rDelay;
        }),
        (e.yoyo = function (i) {
          return arguments.length ? ((this._yoyo = i), this) : this._yoyo;
        }),
        (e.seek = function (i, n) {
          return this.totalTime(jn(this, i), Tn(n));
        }),
        (e.restart = function (i, n) {
          return (
            this.play().totalTime(i ? -this._delay : 0, Tn(n)),
            this._dur || (this._zTime = -ni),
            this
          );
        }),
        (e.play = function (i, n) {
          return (i != null && this.seek(i, n), this.reversed(!1).paused(!1));
        }),
        (e.reverse = function (i, n) {
          return (
            i != null && this.seek(i || this.totalDuration(), n),
            this.reversed(!0).paused(!1)
          );
        }),
        (e.pause = function (i, n) {
          return (i != null && this.seek(i, n), this.paused(!0));
        }),
        (e.resume = function () {
          return this.paused(!1);
        }),
        (e.reversed = function (i) {
          return arguments.length
            ? (!!i !== this.reversed() &&
                this.timeScale(-this._rts || (i ? -ni : 0)),
              this)
            : this._rts < 0;
        }),
        (e.invalidate = function () {
          return ((this._initted = this._act = 0), (this._zTime = -ni), this);
        }),
        (e.isActive = function () {
          var i = this.parent || this._dp,
            n = this._start,
            r;
          return !!(
            !i ||
            (this._ts &&
              this._initted &&
              i.isActive() &&
              (r = i.rawTime(!0)) >= n &&
              r < this.endTime(!0) - ni)
          );
        }),
        (e.eventCallback = function (i, n, r) {
          var o = this.vars;
          return arguments.length > 1
            ? (n
                ? ((o[i] = n),
                  r && (o[i + 'Params'] = r),
                  i === 'onUpdate' && (this._onUpdate = n))
                : delete o[i],
              this)
            : o[i];
        }),
        (e.then = function (i) {
          var n = this,
            r = n._prom;
          return new Promise(function (o) {
            var a = gi(i) ? i : tv,
              l = function () {
                var u = n.then;
                ((n.then = null),
                  r && r(),
                  gi(a) && (a = a(n)) && (a.then || a === n) && (n.then = u),
                  o(a),
                  (n.then = u));
              };
            (n._initted && n.totalProgress() === 1 && n._ts >= 0) ||
            (!n._tTime && n._ts < 0)
              ? l()
              : (n._prom = l);
          });
        }),
        (e.kill = function () {
          Hl(this);
        }),
        s
      );
    })();
  Hn(Kl.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: !1,
    parent: null,
    _initted: !1,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -ni,
    _prom: 0,
    _ps: !1,
    _rts: 1,
  });
  var Qi = (function (s) {
    Y0(e, s);
    function e(i, n) {
      var r;
      return (
        i === void 0 && (i = {}),
        (r = s.call(this, i) || this),
        (r.labels = {}),
        (r.smoothChildTiming = !!i.smoothChildTiming),
        (r.autoRemoveChildren = !!i.autoRemoveChildren),
        (r._sort = Tn(i.sortChildren)),
        hi && zs(i.parent || hi, hr(r), n),
        i.reversed && r.reverse(),
        i.paused && r.paused(!0),
        i.scrollTrigger && sv(hr(r), i.scrollTrigger),
        r
      );
    }
    var t = e.prototype;
    return (
      (t.to = function (n, r, o) {
        return (Gl(0, arguments, this), this);
      }),
      (t.from = function (n, r, o) {
        return (Gl(1, arguments, this), this);
      }),
      (t.fromTo = function (n, r, o, a) {
        return (Gl(2, arguments, this), this);
      }),
      (t.set = function (n, r, o) {
        return (
          (r.duration = 0),
          (r.parent = this),
          Vl(r).repeatDelay || (r.repeat = 0),
          (r.immediateRender = !!r.immediateRender),
          new yi(n, r, jn(this, o), 1),
          this
        );
      }),
      (t.call = function (n, r, o) {
        return zs(this, yi.delayedCall(0, n, r), o);
      }),
      (t.staggerTo = function (n, r, o, a, l, c, u) {
        return (
          (o.duration = r),
          (o.stagger = o.stagger || a),
          (o.onComplete = c),
          (o.onCompleteParams = u),
          (o.parent = this),
          new yi(n, o, jn(this, l)),
          this
        );
      }),
      (t.staggerFrom = function (n, r, o, a, l, c, u) {
        return (
          (o.runBackwards = 1),
          (Vl(o).immediateRender = Tn(o.immediateRender)),
          this.staggerTo(n, r, o, a, l, c, u)
        );
      }),
      (t.staggerFromTo = function (n, r, o, a, l, c, u, f) {
        return (
          (a.startAt = o),
          (Vl(a).immediateRender = Tn(a.immediateRender)),
          this.staggerTo(n, r, a, l, c, u, f)
        );
      }),
      (t.render = function (n, r, o) {
        var a = this._time,
          l = this._dirty ? this.totalDuration() : this._tDur,
          c = this._dur,
          u = n <= 0 ? 0 : ci(n),
          f = this._zTime < 0 != n < 0 && (this._initted || !c),
          d,
          p,
          _,
          x,
          g,
          v,
          w,
          L,
          R,
          U,
          O,
          N;
        if (
          (this !== hi && u > l && n >= 0 && (u = l),
          u !== this._tTime || o || f)
        ) {
          if (
            (a !== this._time &&
              c &&
              ((u += this._time - a), (n += this._time - a)),
            (d = u),
            (R = this._start),
            (L = this._ts),
            (v = !L),
            f && (c || (a = this._zTime), (n || !r) && (this._zTime = n)),
            this._repeat)
          ) {
            if (
              ((O = this._yoyo),
              (g = c + this._rDelay),
              this._repeat < -1 && n < 0)
            )
              return this.totalTime(g * 100 + n, r, o);
            if (
              ((d = ci(u % g)),
              u === l
                ? ((x = this._repeat), (d = c))
                : ((U = ci(u / g)),
                  (x = ~~U),
                  x && x === U && ((d = c), x--),
                  d > c && (d = c)),
              (U = va(this._tTime, g)),
              !a &&
                this._tTime &&
                U !== x &&
                this._tTime - U * g - this._dur <= 0 &&
                (U = x),
              O && x & 1 && ((d = c - d), (N = 1)),
              x !== U && !this._lock)
            ) {
              var M = O && U & 1,
                I = M === (O && x & 1);
              if (
                (x < U && (M = !M),
                (a = M ? 0 : u % c ? c : u),
                (this._lock = 1),
                (this.render(a || (N ? 0 : ci(x * g)), r, !c)._lock = 0),
                (this._tTime = u),
                !r && this.parent && Bn(this, 'onRepeat'),
                this.vars.repeatRefresh &&
                  !N &&
                  ((this.invalidate()._lock = 1), (U = x)),
                (a && a !== this._time) ||
                  v !== !this._ts ||
                  (this.vars.onRepeat && !this.parent && !this._act))
              )
                return this;
              if (
                ((c = this._dur),
                (l = this._tDur),
                I &&
                  ((this._lock = 2),
                  (a = M ? c : -1e-4),
                  this.render(a, !0),
                  this.vars.repeatRefresh && !N && this.invalidate()),
                (this._lock = 0),
                !this._ts && !v)
              )
                return this;
            }
          }
          if (
            (this._hasPause &&
              !this._forcing &&
              this._lock < 2 &&
              ((w = HS(this, ci(a), ci(d))), w && (u -= d - (d = w._start))),
            (this._tTime = u),
            (this._time = d),
            (this._act = !!L),
            this._initted ||
              ((this._onUpdate = this.vars.onUpdate),
              (this._initted = 1),
              (this._zTime = n),
              (a = 0)),
            !a &&
              u &&
              c &&
              !r &&
              !U &&
              (Bn(this, 'onStart'), this._tTime !== u))
          )
            return this;
          if (d >= a && n >= 0)
            for (p = this._first; p; ) {
              if (
                ((_ = p._next), (p._act || d >= p._start) && p._ts && w !== p)
              ) {
                if (p.parent !== this) return this.render(n, r, o);
                if (
                  (p.render(
                    p._ts > 0
                      ? (d - p._start) * p._ts
                      : (p._dirty ? p.totalDuration() : p._tDur) +
                          (d - p._start) * p._ts,
                    r,
                    o,
                  ),
                  d !== this._time || (!this._ts && !v))
                ) {
                  ((w = 0), _ && (u += this._zTime = -ni));
                  break;
                }
              }
              p = _;
            }
          else {
            p = this._last;
            for (var z = n < 0 ? n : d; p; ) {
              if (
                ((_ = p._prev), (p._act || z <= p._end) && p._ts && w !== p)
              ) {
                if (p.parent !== this) return this.render(n, r, o);
                if (
                  (p.render(
                    p._ts > 0
                      ? (z - p._start) * p._ts
                      : (p._dirty ? p.totalDuration() : p._tDur) +
                          (z - p._start) * p._ts,
                    r,
                    o || (Xi && Cp(p)),
                  ),
                  d !== this._time || (!this._ts && !v))
                ) {
                  ((w = 0), _ && (u += this._zTime = z ? -ni : ni));
                  break;
                }
              }
              p = _;
            }
          }
          if (
            w &&
            !r &&
            (this.pause(),
            (w.render(d >= a ? 0 : -ni)._zTime = d >= a ? 1 : -1),
            this._ts)
          )
            return ((this._start = R), kh(this), this.render(n, r, o));
          (this._onUpdate && !r && Bn(this, 'onUpdate', !0),
            ((u === l && this._tTime >= this.totalDuration()) || (!u && a)) &&
              (R === this._start || Math.abs(L) !== Math.abs(this._ts)) &&
              (this._lock ||
                ((n || !c) &&
                  ((u === l && this._ts > 0) || (!u && this._ts < 0)) &&
                  Br(this, 1),
                !r &&
                  !(n < 0 && !a) &&
                  (u || a || !l) &&
                  (Bn(
                    this,
                    u === l && n >= 0 ? 'onComplete' : 'onReverseComplete',
                    !0,
                  ),
                  this._prom &&
                    !(u < l && this.timeScale() > 0) &&
                    this._prom()))));
        }
        return this;
      }),
      (t.add = function (n, r) {
        var o = this;
        if ((dr(r) || (r = jn(this, r, n)), !(n instanceof Kl))) {
          if (en(n))
            return (
              n.forEach(function (a) {
                return o.add(a, r);
              }),
              this
            );
          if (Pi(n)) return this.addLabel(n, r);
          if (gi(n)) n = yi.delayedCall(0, n);
          else return this;
        }
        return this !== n ? zs(this, n, r) : this;
      }),
      (t.getChildren = function (n, r, o, a) {
        (n === void 0 && (n = !0),
          r === void 0 && (r = !0),
          o === void 0 && (o = !0),
          a === void 0 && (a = -Jn));
        for (var l = [], c = this._first; c; )
          (c._start >= a &&
            (c instanceof yi
              ? r && l.push(c)
              : (o && l.push(c),
                n && l.push.apply(l, c.getChildren(!0, r, o)))),
            (c = c._next));
        return l;
      }),
      (t.getById = function (n) {
        for (var r = this.getChildren(1, 1, 1), o = r.length; o--; )
          if (r[o].vars.id === n) return r[o];
      }),
      (t.remove = function (n) {
        return Pi(n)
          ? this.removeLabel(n)
          : gi(n)
            ? this.killTweensOf(n)
            : (n.parent === this && Bh(this, n),
              n === this._recent && (this._recent = this._last),
              Ro(this));
      }),
      (t.totalTime = function (n, r) {
        return arguments.length
          ? ((this._forcing = 1),
            !this._dp &&
              this._ts &&
              (this._start = ci(
                En.time -
                  (this._ts > 0
                    ? n / this._ts
                    : (this.totalDuration() - n) / -this._ts),
              )),
            s.prototype.totalTime.call(this, n, r),
            (this._forcing = 0),
            this)
          : this._tTime;
      }),
      (t.addLabel = function (n, r) {
        return ((this.labels[n] = jn(this, r)), this);
      }),
      (t.removeLabel = function (n) {
        return (delete this.labels[n], this);
      }),
      (t.addPause = function (n, r, o) {
        var a = yi.delayedCall(0, r || ql, o);
        return (
          (a.data = 'isPause'),
          (this._hasPause = 1),
          zs(this, a, jn(this, n))
        );
      }),
      (t.removePause = function (n) {
        var r = this._first;
        for (n = jn(this, n); r; )
          (r._start === n && r.data === 'isPause' && Br(r), (r = r._next));
      }),
      (t.killTweensOf = function (n, r, o) {
        for (var a = this.getTweensOf(n, o), l = a.length; l--; )
          Nr !== a[l] && a[l].kill(n, r);
        return this;
      }),
      (t.getTweensOf = function (n, r) {
        for (var o = [], a = Qn(n), l = this._first, c = dr(r), u; l; )
          (l instanceof yi
            ? DS(l._targets, a) &&
              (c
                ? (!Nr || (l._initted && l._ts)) &&
                  l.globalTime(0) <= r &&
                  l.globalTime(l.totalDuration()) > r
                : !r || l.isActive()) &&
              o.push(l)
            : (u = l.getTweensOf(a, r)).length && o.push.apply(o, u),
            (l = l._next));
        return o;
      }),
      (t.tweenTo = function (n, r) {
        r = r || {};
        var o = this,
          a = jn(o, n),
          l = r,
          c = l.startAt,
          u = l.onStart,
          f = l.onStartParams,
          d = l.immediateRender,
          p,
          _ = yi.to(
            o,
            Hn(
              {
                ease: r.ease || 'none',
                lazy: !1,
                immediateRender: !1,
                time: a,
                overwrite: 'auto',
                duration:
                  r.duration ||
                  Math.abs(
                    (a - (c && 'time' in c ? c.time : o._time)) / o.timeScale(),
                  ) ||
                  ni,
                onStart: function () {
                  if ((o.pause(), !p)) {
                    var g =
                      r.duration ||
                      Math.abs(
                        (a - (c && 'time' in c ? c.time : o._time)) /
                          o.timeScale(),
                      );
                    (_._dur !== g && xa(_, g, 0, 1).render(_._time, !0, !0),
                      (p = 1));
                  }
                  u && u.apply(_, f || []);
                },
              },
              r,
            ),
          );
        return d ? _.render(0) : _;
      }),
      (t.tweenFromTo = function (n, r, o) {
        return this.tweenTo(r, Hn({ startAt: { time: jn(this, n) } }, o));
      }),
      (t.recent = function () {
        return this._recent;
      }),
      (t.nextLabel = function (n) {
        return (n === void 0 && (n = this._time), G0(this, jn(this, n)));
      }),
      (t.previousLabel = function (n) {
        return (n === void 0 && (n = this._time), G0(this, jn(this, n), 1));
      }),
      (t.currentLabel = function (n) {
        return arguments.length
          ? this.seek(n, !0)
          : this.previousLabel(this._time + ni);
      }),
      (t.shiftChildren = function (n, r, o) {
        o === void 0 && (o = 0);
        var a = this._first,
          l = this.labels,
          c;
        for (n = ci(n); a; )
          (a._start >= o && ((a._start += n), (a._end += n)), (a = a._next));
        if (r) for (c in l) l[c] >= o && (l[c] += n);
        return Ro(this);
      }),
      (t.invalidate = function (n) {
        var r = this._first;
        for (this._lock = 0; r; ) (r.invalidate(n), (r = r._next));
        return s.prototype.invalidate.call(this, n);
      }),
      (t.clear = function (n) {
        n === void 0 && (n = !0);
        for (var r = this._first, o; r; )
          ((o = r._next), this.remove(r), (r = o));
        return (
          this._dp && (this._time = this._tTime = this._pTime = 0),
          n && (this.labels = {}),
          Ro(this)
        );
      }),
      (t.totalDuration = function (n) {
        var r = 0,
          o = this,
          a = o._last,
          l = Jn,
          c,
          u,
          f;
        if (arguments.length)
          return o.timeScale(
            (o._repeat < 0 ? o.duration() : o.totalDuration()) /
              (o.reversed() ? -n : n),
          );
        if (o._dirty) {
          for (f = o.parent; a; )
            ((c = a._prev),
              a._dirty && a.totalDuration(),
              (u = a._start),
              u > l && o._sort && a._ts && !o._lock
                ? ((o._lock = 1), (zs(o, a, u - a._delay, 1)._lock = 0))
                : (l = u),
              u < 0 &&
                a._ts &&
                ((r -= u),
                ((!f && !o._dp) || (f && f.smoothChildTiming)) &&
                  ((o._start += ci(u / o._ts)),
                  (o._time -= u),
                  (o._tTime -= u)),
                o.shiftChildren(-u, !1, -1 / 0),
                (l = 0)),
              a._end > r && a._ts && (r = a._end),
              (a = c));
          (xa(o, o === hi && o._time > r ? o._time : r, 1, 1), (o._dirty = 0));
        }
        return o._tDur;
      }),
      (e.updateRoot = function (n) {
        if ((hi._ts && (Q0(hi, Oh(n, hi)), (J0 = En.frame)), En.frame >= k0)) {
          k0 += Mn.autoSleep || 120;
          var r = hi._first;
          if ((!r || !r._ts) && Mn.autoSleep && En._listeners.length < 2) {
            for (; r && !r._ts; ) r = r._next;
            r || En.sleep();
          }
        }
      }),
      e
    );
  })(Kl);
  Hn(Qi.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
  var nE = function (e, t, i, n, r, o, a) {
      var l = new _n(this._pt, e, t, 0, 1, Fp, null, r),
        c = 0,
        u = 0,
        f,
        d,
        p,
        _,
        x,
        g,
        v,
        w;
      for (
        l.b = i,
          l.e = n,
          i += '',
          n += '',
          (v = ~n.indexOf('random(')) && (n = ba(n)),
          o && ((w = [i, n]), o(w, e, t), (i = w[0]), (n = w[1])),
          d = i.match(np) || [];
        (f = np.exec(n));
      )
        ((_ = f[0]),
          (x = n.substring(c, f.index)),
          p ? (p = (p + 1) % 5) : x.substr(-5) === 'rgba(' && (p = 1),
          _ !== d[u++] &&
            ((g = parseFloat(d[u - 1]) || 0),
            (l._pt = {
              _next: l._pt,
              p: x || u === 1 ? x : ',',
              s: g,
              c: _.charAt(1) === '=' ? Io(g, _) - g : parseFloat(_) - g,
              m: p && p < 4 ? Math.round : 0,
            }),
            (c = np.lastIndex)));
      return (
        (l.c = c < n.length ? n.substring(c, n.length) : ''),
        (l.fp = a),
        (Ep.test(n) || v) && (l.e = 0),
        (this._pt = l),
        l
      );
    },
    Ip = function (e, t, i, n, r, o, a, l, c, u) {
      gi(n) && (n = n(r || 0, e, o));
      var f = e[t],
        d =
          i !== 'get'
            ? i
            : gi(f)
              ? c
                ? e[
                    t.indexOf('set') || !gi(e['get' + t.substr(3)])
                      ? t
                      : 'get' + t.substr(3)
                  ](c)
                : e[t]()
              : f,
        p = gi(f) ? (c ? lE : yv) : Np,
        _;
      if (
        (Pi(n) &&
          (~n.indexOf('random(') && (n = ba(n)),
          n.charAt(1) === '=' &&
            ((_ = Io(d, n) + (Yi(d) || 0)), (_ || _ === 0) && (n = _))),
        !u || d !== n || vp)
      )
        return !isNaN(d * n) && n !== ''
          ? ((_ = new _n(
              this._pt,
              e,
              t,
              +d || 0,
              n - (d || 0),
              typeof f == 'boolean' ? hE : bv,
              0,
              p,
            )),
            c && (_.fp = c),
            a && _.modifier(a, this, e),
            (this._pt = _))
          : (!f && !(t in e) && Uh(t, n),
            nE.call(this, e, t, d, n, p, l || Mn.stringFilter, c));
    },
    sE = function (e, t, i, n, r) {
      if (
        (gi(e) && (e = Wl(e, r, t, i, n)),
        !Vs(e) || (e.style && e.nodeType) || en(e) || Z0(e))
      )
        return Pi(e) ? Wl(e, r, t, i, n) : e;
      var o = {},
        a;
      for (a in e) o[a] = Wl(e[a], r, t, i, n);
      return o;
    },
    Dp = function (e, t, i, n, r, o) {
      var a, l, c, u;
      if (
        Sn[e] &&
        (a = new Sn[e]()).init(
          r,
          a.rawVars ? t[e] : sE(t[e], n, r, o, i),
          i,
          n,
          o,
        ) !== !1 &&
        ((i._pt = l = new _n(i._pt, r, e, 0, 1, a.render, a, 0, a.priority)),
        i !== ga)
      )
        for (c = i._ptLookup[i._targets.indexOf(r)], u = a._props.length; u--; )
          c[a._props[u]] = l;
      return a;
    },
    Nr,
    vp,
    Op = function s(e, t, i) {
      var n = e.vars,
        r = n.ease,
        o = n.startAt,
        a = n.immediateRender,
        l = n.lazy,
        c = n.onUpdate,
        u = n.runBackwards,
        f = n.yoyoEase,
        d = n.keyframes,
        p = n.autoRevert,
        _ = e._dur,
        x = e._startAt,
        g = e._targets,
        v = e.parent,
        w = v && v.data === 'nested' ? v.vars.targets : g,
        L = e._overwrite === 'auto' && !yp,
        R = e.timeline,
        U = n.easeReverse || f,
        O,
        N,
        M,
        I,
        z,
        W,
        q,
        re,
        oe,
        K,
        ie,
        J,
        pe;
      if (
        (R && (!d || !r) && (r = 'none'),
        (e._ease = Co(r, Xl.ease)),
        (e._rEase = U && (Co(U) || e._ease)),
        (e._from = !R && !!n.runBackwards),
        e._from && (e.ratio = 1),
        !R || (d && !n.stagger))
      ) {
        if (
          ((re = g[0] ? Ur(g[0]).harness : 0),
          (J = re && n[re.prop]),
          (O = Dh(n, Mp)),
          x &&
            (x._zTime < 0 && x.progress(1),
            t < 0 && u && a && !p
              ? x.render(-1, !0)
              : x.revert(u && _ ? Rh : LS),
            (x._lazy = 0)),
          o)
        ) {
          if (
            (Br(
              (e._startAt = yi.set(
                g,
                Hn(
                  {
                    data: 'isStart',
                    overwrite: !1,
                    parent: v,
                    immediateRender: !0,
                    lazy: !x && Tn(l),
                    startAt: null,
                    delay: 0,
                    onUpdate:
                      c &&
                      function () {
                        return Bn(e, 'onUpdate');
                      },
                    stagger: 0,
                  },
                  o,
                ),
              )),
            ),
            (e._startAt._dp = 0),
            (e._startAt._sat = e),
            t < 0 && (Xi || (!a && !p)) && e._startAt.revert(Rh),
            a && _ && t <= 0 && i <= 0)
          ) {
            t && (e._zTime = t);
            return;
          }
        } else if (u && _ && !x) {
          if (
            (t && (a = !1),
            (M = Hn(
              {
                overwrite: !1,
                data: 'isFromStart',
                lazy: a && !x && Tn(l),
                immediateRender: a,
                stagger: 0,
                parent: v,
              },
              O,
            )),
            J && (M[re.prop] = J),
            Br((e._startAt = yi.set(g, M))),
            (e._startAt._dp = 0),
            (e._startAt._sat = e),
            t < 0 && (Xi ? e._startAt.revert(Rh) : e._startAt.render(-1, !0)),
            (e._zTime = t),
            !a)
          )
            s(e._startAt, ni, ni);
          else if (!t) return;
        }
        for (
          e._pt = e._ptCache = 0, l = (_ && Tn(l)) || (l && !_), N = 0;
          N < g.length;
          N++
        ) {
          if (
            ((z = g[N]),
            (q = z._gsap || Ap(g)[N]._gsap),
            (e._ptLookup[N] = K = {}),
            dp[q.id] && Fr.length && Ih(),
            (ie = w === g ? N : w.indexOf(z)),
            re &&
              (oe = new re()).init(z, J || O, e, ie, w) !== !1 &&
              ((e._pt = I =
                new _n(e._pt, z, oe.name, 0, 1, oe.render, oe, 0, oe.priority)),
              oe._props.forEach(function (Ee) {
                K[Ee] = I;
              }),
              oe.priority && (W = 1)),
            !re || J)
          )
            for (M in O)
              Sn[M] && (oe = Dp(M, O, e, ie, z, w))
                ? oe.priority && (W = 1)
                : (K[M] = I =
                    Ip.call(e, z, M, 'get', O[M], ie, w, 0, n.stringFilter));
          (e._op && e._op[N] && e.kill(z, e._op[N]),
            L &&
              e._pt &&
              ((Nr = e),
              hi.killTweensOf(z, K, e.globalTime(t)),
              (pe = !e.parent),
              (Nr = 0)),
            e._pt && l && (dp[q.id] = 1));
        }
        (W && Bp(e), e._onInit && e._onInit(e));
      }
      ((e._onUpdate = c),
        (e._initted = (!e._op || e._pt) && !pe),
        d && t <= 0 && R.render(Jn, !0, !0));
    },
    rE = function (e, t, i, n, r, o, a, l) {
      var c = ((e._pt && e._ptCache) || (e._ptCache = {}))[t],
        u,
        f,
        d,
        p;
      if (!c)
        for (
          c = e._ptCache[t] = [], d = e._ptLookup, p = e._targets.length;
          p--;
        ) {
          if (((u = d[p][t]), u && u.d && u.d._pt))
            for (u = u.d._pt; u && u.p !== t && u.fp !== t; ) u = u._next;
          if (!u)
            return (
              (vp = 1),
              (e.vars[t] = '+=0'),
              Op(e, a),
              (vp = 0),
              l
                ? Yl(
                    t +
                      ' not eligible for reset. Try splitting into individual properties',
                  )
                : 1
            );
          c.push(u);
        }
      for (p = c.length; p--; )
        ((f = c[p]),
          (u = f._pt || f),
          (u.s = (n || n === 0) && !r ? n : u.s + (n || 0) + o * u.c),
          (u.c = i - u.s),
          f.e && (f.e = _i(i) + Yi(f.e)),
          f.b && (f.b = u.s + Yi(f.b)));
    },
    oE = function (e, t) {
      var i = e[0] ? Ur(e[0]).harness : 0,
        n = i && i.aliases,
        r,
        o,
        a,
        l;
      if (!n) return t;
      r = _a({}, t);
      for (o in n)
        if (o in r)
          for (l = n[o].split(','), a = l.length; a--; ) r[l[a]] = r[o];
      return r;
    },
    aE = function (e, t, i, n) {
      var r = t.ease || n || 'power1.inOut',
        o,
        a;
      if (en(t))
        ((a = i[e] || (i[e] = [])),
          t.forEach(function (l, c) {
            return a.push({ t: (c / (t.length - 1)) * 100, v: l, e: r });
          }));
      else
        for (o in t)
          ((a = i[o] || (i[o] = [])),
            o === 'ease' || a.push({ t: parseFloat(e), v: t[o], e: r }));
    },
    Wl = function (e, t, i, n, r) {
      return gi(e)
        ? e.call(t, i, n, r)
        : Pi(e) && ~e.indexOf('random(')
          ? ba(e)
          : e;
    },
    vv =
      wp +
      'repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,easeReverse,autoRevert',
    xv = {};
  gn(vv + ',id,stagger,delay,duration,paused,scrollTrigger', function (s) {
    return (xv[s] = 1);
  });
  var yi = (function (s) {
    Y0(e, s);
    function e(i, n, r, o) {
      var a;
      (typeof n == 'number' && ((r.duration = n), (n = r), (r = null)),
        (a = s.call(this, o ? n : Vl(n)) || this));
      var l = a.vars,
        c = l.duration,
        u = l.delay,
        f = l.immediateRender,
        d = l.stagger,
        p = l.overwrite,
        _ = l.keyframes,
        x = l.defaults,
        g = l.scrollTrigger,
        v = n.parent || hi,
        w = (en(i) || Z0(i) ? dr(i[0]) : 'length' in n) ? [i] : Qn(i),
        L,
        R,
        U,
        O,
        N,
        M,
        I,
        z;
      if (
        ((a._targets = w.length
          ? Ap(w)
          : Yl(
              'GSAP target ' + i + ' not found. https://gsap.com',
              !Mn.nullTargetWarn,
            ) || []),
        (a._ptLookup = []),
        (a._overwrite = p),
        _ || d || Ah(c) || Ah(u))
      ) {
        n = a.vars;
        var W = n.easeReverse || n.yoyoEase;
        if (
          ((L = a.timeline =
            new Qi({
              data: 'nested',
              defaults: x || {},
              targets: v && v.data === 'nested' ? v.vars.targets : w,
            })),
          L.kill(),
          (L.parent = L._dp = hr(a)),
          (L._start = 0),
          d || Ah(c) || Ah(u))
        ) {
          if (((O = w.length), (I = d && lv(d)), Vs(d)))
            for (N in d) ~vv.indexOf(N) && (z || (z = {}), (z[N] = d[N]));
          for (R = 0; R < O; R++)
            ((U = Dh(n, xv)),
              (U.stagger = 0),
              W && (U.easeReverse = W),
              z && _a(U, z),
              (M = w[R]),
              (U.duration = +Wl(c, hr(a), R, M, w)),
              (U.delay = (+Wl(u, hr(a), R, M, w) || 0) - a._delay),
              !d &&
                O === 1 &&
                U.delay &&
                ((a._delay = u = U.delay), (a._start += u), (U.delay = 0)),
              L.to(M, U, I ? I(R, M, w) : 0),
              (L._ease = Ht.none));
          L.duration() ? (c = u = 0) : (a.timeline = 0);
        } else if (_) {
          (Vl(Hn(L.vars.defaults, { ease: 'none' })),
            (L._ease = Co(_.ease || n.ease || 'none')));
          var q = 0,
            re,
            oe,
            K;
          if (en(_))
            (_.forEach(function (ie) {
              return L.to(w, ie, '>');
            }),
              L.duration());
          else {
            U = {};
            for (N in _)
              N === 'ease' || N === 'easeEach' || aE(N, _[N], U, _.easeEach);
            for (N in U)
              for (
                re = U[N].sort(function (ie, J) {
                  return ie.t - J.t;
                }),
                  q = 0,
                  R = 0;
                R < re.length;
                R++
              )
                ((oe = re[R]),
                  (K = {
                    ease: oe.e,
                    duration: ((oe.t - (R ? re[R - 1].t : 0)) / 100) * c,
                  }),
                  (K[N] = oe.v),
                  L.to(w, K, q),
                  (q += K.duration));
            L.duration() < c && L.to({}, { duration: c - L.duration() });
          }
        }
        c || a.duration((c = L.duration()));
      } else a.timeline = 0;
      return (
        p === !0 && !yp && ((Nr = hr(a)), hi.killTweensOf(w), (Nr = 0)),
        zs(v, hr(a), r),
        n.reversed && a.reverse(),
        n.paused && a.paused(!0),
        (f ||
          (!c &&
            !_ &&
            a._start === ci(v._time) &&
            Tn(f) &&
            US(hr(a)) &&
            v.data !== 'nested')) &&
          ((a._tTime = -ni), a.render(Math.max(0, -u) || 0)),
        g && sv(hr(a), g),
        a
      );
    }
    var t = e.prototype;
    return (
      (t.render = function (n, r, o) {
        var a = this._time,
          l = this._tDur,
          c = this._dur,
          u = n < 0,
          f = n > l - ni && !u ? l : n < ni ? 0 : n,
          d,
          p,
          _,
          x,
          g,
          v,
          w,
          L;
        if (!c) kS(this, n, r, o);
        else if (
          f !== this._tTime ||
          !n ||
          o ||
          (!this._initted && this._tTime) ||
          (this._startAt && this._zTime < 0 !== u) ||
          this._lazy
        ) {
          if (((d = f), (L = this.timeline), this._repeat)) {
            if (((x = c + this._rDelay), this._repeat < -1 && u))
              return this.totalTime(x * 100 + n, r, o);
            if (
              ((d = ci(f % x)),
              f === l
                ? ((_ = this._repeat), (d = c))
                : ((g = ci(f / x)),
                  (_ = ~~g),
                  _ && _ === g ? ((d = c), _--) : d > c && (d = c)),
              (v = this._yoyo && _ & 1),
              v && (d = c - d),
              (g = va(this._tTime, x)),
              d === a && !o && this._initted && _ === g)
            )
              return ((this._tTime = f), this);
            _ !== g &&
              this.vars.repeatRefresh &&
              !v &&
              !this._lock &&
              d !== x &&
              this._initted &&
              ((this._lock = o = 1),
              (this.render(ci(x * _), !0).invalidate()._lock = 0));
          }
          if (!this._initted) {
            if (rv(this, u ? n : d, o, r, f)) return ((this._tTime = 0), this);
            if (a !== this._time && !(o && this.vars.repeatRefresh && _ !== g))
              return this;
            if (c !== this._dur) return this.render(n, r, o);
          }
          if (this._rEase) {
            var R = d < a;
            if (R !== this._inv) {
              var U = R ? a : c - a;
              ((this._inv = R),
                this._from && (this.ratio = 1 - this.ratio),
                (this._invRatio = this.ratio),
                (this._invTime = a),
                (this._invRecip = U ? (R ? -1 : 1) / U : 0),
                (this._invScale = R ? -this.ratio : 1 - this.ratio),
                (this._invEase = R ? this._rEase : this._ease));
            }
            this.ratio = w =
              this._invRatio +
              this._invScale *
                this._invEase((d - this._invTime) * this._invRecip);
          } else this.ratio = w = this._ease(d / c);
          if (
            (this._from && (this.ratio = w = 1 - w),
            (this._tTime = f),
            (this._time = d),
            !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
            !a && f && !r && !g && (Bn(this, 'onStart'), this._tTime !== f))
          )
            return this;
          for (p = this._pt; p; ) (p.r(w, p.d), (p = p._next));
          ((L && L.render(n < 0 ? n : L._dur * L._ease(d / this._dur), r, o)) ||
            (this._startAt && (this._zTime = n)),
            this._onUpdate &&
              !r &&
              (u && fp(this, n, r, o), Bn(this, 'onUpdate')),
            this._repeat &&
              _ !== g &&
              this.vars.onRepeat &&
              !r &&
              this.parent &&
              Bn(this, 'onRepeat'),
            (f === this._tDur || !f) &&
              this._tTime === f &&
              (u && !this._onUpdate && fp(this, n, !0, !0),
              (n || !c) &&
                ((f === this._tDur && this._ts > 0) || (!f && this._ts < 0)) &&
                Br(this, 1),
              !r &&
                !(u && !a) &&
                (f || a || v) &&
                (Bn(this, f === l ? 'onComplete' : 'onReverseComplete', !0),
                this._prom &&
                  !(f < l && this.timeScale() > 0) &&
                  this._prom())));
        }
        return this;
      }),
      (t.targets = function () {
        return this._targets;
      }),
      (t.invalidate = function (n) {
        return (
          (!n || !this.vars.runBackwards) && (this._startAt = 0),
          (this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0),
          (this._ptLookup = []),
          this.timeline && this.timeline.invalidate(n),
          s.prototype.invalidate.call(this, n)
        );
      }),
      (t.resetTo = function (n, r, o, a, l) {
        (Zl || En.wake(), this._ts || this.play());
        var c = Math.min(this._dur, (this._dp._time - this._start) * this._ts),
          u;
        return (
          this._initted || Op(this, c),
          (u = this._ease(c / this._dur)),
          rE(this, n, r, o, a, u, c, l)
            ? this.resetTo(n, r, o, a, 1)
            : (Hh(this, 0),
              this.parent ||
                iv(
                  this._dp,
                  this,
                  '_first',
                  '_last',
                  this._dp._sort ? '_start' : 0,
                ),
              this.render(0))
        );
      }),
      (t.kill = function (n, r) {
        if ((r === void 0 && (r = 'all'), !n && (!r || r === 'all')))
          return (
            (this._lazy = this._pt = 0),
            this.parent
              ? Hl(this)
              : this.scrollTrigger && this.scrollTrigger.kill(!!Xi),
            this
          );
        if (this.timeline) {
          var o = this.timeline.totalDuration();
          return (
            this.timeline.killTweensOf(n, r, Nr && Nr.vars.overwrite !== !0)
              ._first || Hl(this),
            this.parent &&
              o !== this.timeline.totalDuration() &&
              xa(this, (this._dur * this.timeline._tDur) / o, 0, 1),
            this
          );
        }
        var a = this._targets,
          l = n ? Qn(n) : a,
          c = this._ptLookup,
          u = this._pt,
          f,
          d,
          p,
          _,
          x,
          g,
          v;
        if ((!r || r === 'all') && NS(a, l))
          return (r === 'all' && (this._pt = 0), Hl(this));
        for (
          f = this._op = this._op || [],
            r !== 'all' &&
              (Pi(r) &&
                ((x = {}),
                gn(r, function (w) {
                  return (x[w] = 1);
                }),
                (r = x)),
              (r = oE(a, r))),
            v = a.length;
          v--;
        )
          if (~l.indexOf(a[v])) {
            ((d = c[v]),
              r === 'all'
                ? ((f[v] = r), (_ = d), (p = {}))
                : ((p = f[v] = f[v] || {}), (_ = r)));
            for (x in _)
              ((g = d && d[x]),
                g &&
                  ((!('kill' in g.d) || g.d.kill(x) === !0) &&
                    Bh(this, g, '_pt'),
                  delete d[x]),
                p !== 'all' && (p[x] = 1));
          }
        return (this._initted && !this._pt && u && Hl(this), this);
      }),
      (e.to = function (n, r) {
        return new e(n, r, arguments[2]);
      }),
      (e.from = function (n, r) {
        return Gl(1, arguments);
      }),
      (e.delayedCall = function (n, r, o, a) {
        return new e(r, 0, {
          immediateRender: !1,
          lazy: !1,
          overwrite: !1,
          delay: n,
          onComplete: r,
          onReverseComplete: r,
          onCompleteParams: o,
          onReverseCompleteParams: o,
          callbackScope: a,
        });
      }),
      (e.fromTo = function (n, r, o) {
        return Gl(2, arguments);
      }),
      (e.set = function (n, r) {
        return ((r.duration = 0), r.repeatDelay || (r.repeat = 0), new e(n, r));
      }),
      (e.killTweensOf = function (n, r, o) {
        return hi.killTweensOf(n, r, o);
      }),
      e
    );
  })(Kl);
  Hn(yi.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 });
  gn('staggerTo,staggerFrom,staggerFromTo', function (s) {
    yi[s] = function () {
      var e = new Qi(),
        t = mp.call(arguments, 0);
      return (t.splice(s === 'staggerFromTo' ? 5 : 4, 0, 0), e[s].apply(e, t));
    };
  });
  var Np = function (e, t, i) {
      return (e[t] = i);
    },
    yv = function (e, t, i) {
      return e[t](i);
    },
    lE = function (e, t, i, n) {
      return e[t](n.fp, i);
    },
    cE = function (e, t, i) {
      return e.setAttribute(t, i);
    },
    zh = function (e, t) {
      return gi(e[t]) ? yv : Fh(e[t]) && e.setAttribute ? cE : Np;
    },
    bv = function (e, t) {
      return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e6) / 1e6, t);
    },
    hE = function (e, t) {
      return t.set(t.t, t.p, !!(t.s + t.c * e), t);
    },
    Fp = function (e, t) {
      var i = t._pt,
        n = '';
      if (!e && t.b) n = t.b;
      else if (e === 1 && t.e) n = t.e;
      else {
        for (; i; )
          ((n =
            i.p +
            (i.m
              ? i.m(i.s + i.c * e)
              : Math.round((i.s + i.c * e) * 1e4) / 1e4) +
            n),
            (i = i._next));
        n += t.c;
      }
      t.set(t.t, t.p, n, t);
    },
    Up = function (e, t) {
      for (var i = t._pt; i; ) (i.r(e, i.d), (i = i._next));
    },
    uE = function (e, t, i, n) {
      for (var r = this._pt, o; r; )
        ((o = r._next), r.p === n && r.modifier(e, t, i), (r = o));
    },
    dE = function (e) {
      for (var t = this._pt, i, n; t; )
        ((n = t._next),
          (t.p === e && !t.op) || t.op === e
            ? Bh(this, t, '_pt')
            : t.dep || (i = 1),
          (t = n));
      return !i;
    },
    fE = function (e, t, i, n) {
      n.mSet(e, t, n.m.call(n.tween, i, n.mt), n);
    },
    Bp = function (e) {
      for (var t = e._pt, i, n, r, o; t; ) {
        for (i = t._next, n = r; n && n.pr > t.pr; ) n = n._next;
        ((t._prev = n ? n._prev : o) ? (t._prev._next = t) : (r = t),
          (t._next = n) ? (n._prev = t) : (o = t),
          (t = i));
      }
      e._pt = r;
    },
    _n = (function () {
      function s(t, i, n, r, o, a, l, c, u) {
        ((this.t = i),
          (this.s = r),
          (this.c = o),
          (this.p = n),
          (this.r = a || bv),
          (this.d = l || this),
          (this.set = c || Np),
          (this.pr = u || 0),
          (this._next = t),
          t && (t._prev = this));
      }
      var e = s.prototype;
      return (
        (e.modifier = function (i, n, r) {
          ((this.mSet = this.mSet || this.set),
            (this.set = fE),
            (this.m = i),
            (this.mt = r),
            (this.tween = n));
        }),
        s
      );
    })();
  gn(
    wp +
      'parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger,easeReverse',
    function (s) {
      return (Mp[s] = 1);
    },
  );
  kn.TweenMax = kn.TweenLite = yi;
  kn.TimelineLite = kn.TimelineMax = Qi;
  hi = new Qi({
    sortChildren: !1,
    defaults: Xl,
    autoRemoveChildren: !0,
    id: 'root',
    smoothChildTiming: !0,
  });
  Mn.stringFilter = Pp;
  var Po = [],
    Ph = {},
    pE = [],
    X0 = 0,
    mE = 0,
    lp = function (e) {
      return (Ph[e] || pE).map(function (t) {
        return t();
      });
    },
    xp = function () {
      var e = Date.now(),
        t = [];
      e - X0 > 2 &&
        (lp('matchMediaInit'),
        Po.forEach(function (i) {
          var n = i.queries,
            r = i.conditions,
            o,
            a,
            l,
            c;
          for (a in n)
            ((o = Hs.matchMedia(n[a]).matches),
              o && (l = 1),
              o !== r[a] && ((r[a] = o), (c = 1)));
          c && (i.revert(), l && t.push(i));
        }),
        lp('matchMediaRevert'),
        t.forEach(function (i) {
          return i.onMatch(i, function (n) {
            return i.add(null, n);
          });
        }),
        (X0 = e),
        lp('matchMedia'));
    },
    Sv = (function () {
      function s(t, i) {
        ((this.selector = i && gp(i)),
          (this.data = []),
          (this._r = []),
          (this.isReverted = !1),
          (this.id = mE++),
          t && this.add(t));
      }
      var e = s.prototype;
      return (
        (e.add = function (i, n, r) {
          gi(i) && ((r = n), (n = i), (i = gi));
          var o = this,
            a = function () {
              var c = ai,
                u = o.selector,
                f;
              return (
                c && c !== o && c.data.push(o),
                r && (o.selector = gp(r)),
                (ai = o),
                (f = n.apply(o, arguments)),
                gi(f) && o._r.push(f),
                (ai = c),
                (o.selector = u),
                (o.isReverted = !1),
                f
              );
            };
          return (
            (o.last = a),
            i === gi
              ? a(o, function (l) {
                  return o.add(null, l);
                })
              : i
                ? (o[i] = a)
                : a
          );
        }),
        (e.ignore = function (i) {
          var n = ai;
          ((ai = null), i(this), (ai = n));
        }),
        (e.getTweens = function () {
          var i = [];
          return (
            this.data.forEach(function (n) {
              return n instanceof s
                ? i.push.apply(i, n.getTweens())
                : n instanceof yi &&
                    !(n.parent && n.parent.data === 'nested') &&
                    i.push(n);
            }),
            i
          );
        }),
        (e.clear = function () {
          this._r.length = this.data.length = 0;
        }),
        (e.kill = function (i, n) {
          var r = this;
          if (
            (i
              ? (function () {
                  for (var a = r.getTweens(), l = r.data.length, c; l--; )
                    ((c = r.data[l]),
                      c.data === 'isFlip' &&
                        (c.revert(),
                        c.getChildren(!0, !0, !1).forEach(function (u) {
                          return a.splice(a.indexOf(u), 1);
                        })));
                  for (
                    a
                      .map(function (u) {
                        return {
                          g:
                            u._dur ||
                            u._delay ||
                            (u._sat && !u._sat.vars.immediateRender)
                              ? u.globalTime(0)
                              : -1 / 0,
                          t: u,
                        };
                      })
                      .sort(function (u, f) {
                        return f.g - u.g || -1 / 0;
                      })
                      .forEach(function (u) {
                        return u.t.revert(i);
                      }),
                      l = r.data.length;
                    l--;
                  )
                    ((c = r.data[l]),
                      c instanceof Qi
                        ? c.data !== 'nested' &&
                          (c.scrollTrigger && c.scrollTrigger.revert(),
                          c.kill())
                        : !(c instanceof yi) && c.revert && c.revert(i));
                  (r._r.forEach(function (u) {
                    return u(i, r);
                  }),
                    (r.isReverted = !0));
                })()
              : this.data.forEach(function (a) {
                  return a.kill && a.kill();
                }),
            this.clear(),
            n)
          )
            for (var o = Po.length; o--; )
              Po[o].id === this.id && Po.splice(o, 1);
        }),
        (e.revert = function (i) {
          this.kill(i || {});
        }),
        s
      );
    })(),
    gE = (function () {
      function s(t) {
        ((this.contexts = []), (this.scope = t), ai && ai.data.push(this));
      }
      var e = s.prototype;
      return (
        (e.add = function (i, n, r) {
          Vs(i) || (i = { matches: i });
          var o = new Sv(0, r || this.scope),
            a = (o.conditions = {}),
            l,
            c,
            u;
          (ai && !o.selector && (o.selector = ai.selector),
            this.contexts.push(o),
            (n = o.add('onMatch', n)),
            (o.queries = i));
          for (c in i)
            c === 'all'
              ? (u = 1)
              : ((l = Hs.matchMedia(i[c])),
                l &&
                  (Po.indexOf(o) < 0 && Po.push(o),
                  (a[c] = l.matches) && (u = 1),
                  l.addListener
                    ? l.addListener(xp)
                    : l.addEventListener('change', xp)));
          return (
            u &&
              n(o, function (f) {
                return o.add(null, f);
              }),
            this
          );
        }),
        (e.revert = function (i) {
          this.kill(i || {});
        }),
        (e.kill = function (i) {
          this.contexts.forEach(function (n) {
            return n.kill(i, !0);
          });
        }),
        s
      );
    })(),
    Nh = {
      registerPlugin: function () {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
          t[i] = arguments[i];
        t.forEach(function (n) {
          return pv(n);
        });
      },
      timeline: function (e) {
        return new Qi(e);
      },
      getTweensOf: function (e, t) {
        return hi.getTweensOf(e, t);
      },
      getProperty: function (e, t, i, n) {
        Pi(e) && (e = Qn(e)[0]);
        var r = Ur(e || {}).get,
          o = i ? tv : ev;
        return (
          i === 'native' && (i = ''),
          e &&
            (t
              ? o(((Sn[t] && Sn[t].get) || r)(e, t, i, n))
              : function (a, l, c) {
                  return o(((Sn[a] && Sn[a].get) || r)(e, a, l, c));
                })
        );
      },
      quickSetter: function (e, t, i) {
        if (((e = Qn(e)), e.length > 1)) {
          var n = e.map(function (u) {
              return tn.quickSetter(u, t, i);
            }),
            r = n.length;
          return function (u) {
            for (var f = r; f--; ) n[f](u);
          };
        }
        e = e[0] || {};
        var o = Sn[t],
          a = Ur(e),
          l = (a.harness && (a.harness.aliases || {})[t]) || t,
          c = o
            ? function (u) {
                var f = new o();
                ((ga._pt = 0),
                  f.init(e, i ? u + i : u, ga, 0, [e]),
                  f.render(1, f),
                  ga._pt && Up(1, ga));
              }
            : a.set(e, l);
        return o
          ? c
          : function (u) {
              return c(e, l, i ? u + i : u, a, 1);
            };
      },
      quickTo: function (e, t, i) {
        var n,
          r = tn.to(
            e,
            Hn(
              ((n = {}), (n[t] = '+=0.1'), (n.paused = !0), (n.stagger = 0), n),
              i || {},
            ),
          ),
          o = function (l, c, u) {
            return r.resetTo(t, l, c, u);
          };
        return ((o.tween = r), o);
      },
      isTweening: function (e) {
        return hi.getTweensOf(e, !0).length > 0;
      },
      defaults: function (e) {
        return (e && e.ease && (e.ease = Co(e.ease, Xl.ease)), H0(Xl, e || {}));
      },
      config: function (e) {
        return H0(Mn, e || {});
      },
      registerEffect: function (e) {
        var t = e.name,
          i = e.effect,
          n = e.plugins,
          r = e.defaults,
          o = e.extendTimeline;
        ((n || '').split(',').forEach(function (a) {
          return (
            a &&
            !Sn[a] &&
            !kn[a] &&
            Yl(t + ' effect requires ' + a + ' plugin.')
          );
        }),
          (sp[t] = function (a, l, c) {
            return i(Qn(a), Hn(l || {}, r), c);
          }),
          o &&
            (Qi.prototype[t] = function (a, l, c) {
              return this.add(sp[t](a, Vs(l) ? l : (c = l) && {}, this), c);
            }));
      },
      registerEase: function (e, t) {
        Ht[e] = Co(t);
      },
      parseEase: function (e, t) {
        return arguments.length ? Co(e, t) : Ht;
      },
      getById: function (e) {
        return hi.getById(e);
      },
      exportRoot: function (e, t) {
        e === void 0 && (e = {});
        var i = new Qi(e),
          n,
          r;
        for (
          i.smoothChildTiming = Tn(e.smoothChildTiming),
            hi.remove(i),
            i._dp = 0,
            i._time = i._tTime = hi._time,
            n = hi._first;
          n;
        )
          ((r = n._next),
            (t ||
              !(
                !n._dur &&
                n instanceof yi &&
                n.vars.onComplete === n._targets[0]
              )) &&
              zs(i, n, n._start - n._delay),
            (n = r));
        return (zs(hi, i, 0), i);
      },
      context: function (e, t) {
        return e ? new Sv(e, t) : ai;
      },
      matchMedia: function (e) {
        return new gE(e);
      },
      matchMediaRefresh: function () {
        return (
          Po.forEach(function (e) {
            var t = e.conditions,
              i,
              n;
            for (n in t) t[n] && ((t[n] = !1), (i = 1));
            i && e.revert();
          }) || xp()
        );
      },
      addEventListener: function (e, t) {
        var i = Ph[e] || (Ph[e] = []);
        ~i.indexOf(t) || i.push(t);
      },
      removeEventListener: function (e, t) {
        var i = Ph[e],
          n = i && i.indexOf(t);
        n >= 0 && i.splice(n, 1);
      },
      utils: {
        wrap: qS,
        wrapYoyo: ZS,
        distribute: lv,
        random: hv,
        snap: cv,
        normalize: YS,
        getUnit: Yi,
        clamp: VS,
        splitColor: mv,
        toArray: Qn,
        selector: gp,
        mapRange: dv,
        pipe: WS,
        unitize: XS,
        interpolate: KS,
        shuffle: av,
      },
      install: $0,
      effects: sp,
      ticker: En,
      updateRoot: Qi.updateRoot,
      plugins: Sn,
      globalTimeline: hi,
      core: {
        PropTween: _n,
        globals: j0,
        Tween: yi,
        Timeline: Qi,
        Animation: Kl,
        getCache: Ur,
        _removeLinkedListItem: Bh,
        reverting: function () {
          return Xi;
        },
        context: function (e) {
          return (e && ai && (ai.data.push(e), (e._ctx = ai)), ai);
        },
        suppressOverwrites: function (e) {
          return (yp = e);
        },
      },
    };
  gn('to,from,fromTo,delayedCall,set,killTweensOf', function (s) {
    return (Nh[s] = yi[s]);
  });
  En.add(Qi.updateRoot);
  ga = Nh.to({}, { duration: 0 });
  var _E = function (e, t) {
      for (var i = e._pt; i && i.p !== t && i.op !== t && i.fp !== t; )
        i = i._next;
      return i;
    },
    vE = function (e, t) {
      var i = e._targets,
        n,
        r,
        o;
      for (n in t)
        for (r = i.length; r--; )
          ((o = e._ptLookup[r][n]),
            o &&
              (o = o.d) &&
              (o._pt && (o = _E(o, n)),
              o && o.modifier && o.modifier(t[n], e, i[r], n)));
    },
    cp = function (e, t) {
      return {
        name: e,
        headless: 1,
        rawVars: 1,
        init: function (n, r, o) {
          o._onInit = function (a) {
            var l, c;
            if (
              (Pi(r) &&
                ((l = {}),
                gn(r, function (u) {
                  return (l[u] = 1);
                }),
                (r = l)),
              t)
            ) {
              l = {};
              for (c in r) l[c] = t(r[c]);
              r = l;
            }
            vE(a, r);
          };
        },
      };
    },
    tn =
      Nh.registerPlugin(
        {
          name: 'attr',
          init: function (e, t, i, n, r) {
            var o, a, l;
            this.tween = i;
            for (o in t)
              ((l = e.getAttribute(o) || ''),
                (a = this.add(
                  e,
                  'setAttribute',
                  (l || 0) + '',
                  t[o],
                  n,
                  r,
                  0,
                  0,
                  o,
                )),
                (a.op = o),
                (a.b = l),
                this._props.push(o));
          },
          render: function (e, t) {
            for (var i = t._pt; i; )
              (Xi ? i.set(i.t, i.p, i.b, i) : i.r(e, i.d), (i = i._next));
          },
        },
        {
          name: 'endArray',
          headless: 1,
          init: function (e, t) {
            for (var i = t.length; i--; )
              this.add(e, i, e[i] || 0, t[i], 0, 0, 0, 0, 0, 1);
          },
        },
        cp('roundProps', _p),
        cp('modifiers'),
        cp('snap', cv),
      ) || Nh;
  yi.version = Qi.version = tn.version = '3.15.0';
  K0 = 1;
  bp() && ya();
  var xE = Ht.Power0,
    yE = Ht.Power1,
    bE = Ht.Power2,
    SE = Ht.Power3,
    EE = Ht.Power4,
    TE = Ht.Linear,
    ME = Ht.Quad,
    wE = Ht.Cubic,
    AE = Ht.Quart,
    RE = Ht.Quint,
    CE = Ht.Strong,
    PE = Ht.Elastic,
    LE = Ht.Back,
    IE = Ht.SteppedEase,
    DE = Ht.Bounce,
    OE = Ht.Sine,
    NE = Ht.Expo,
    FE = Ht.Circ;
  var Ev,
    Hr,
    Ea,
    Wp,
    Uo,
    UE,
    Tv,
    Xp,
    BE = function () {
      return typeof window != 'undefined';
    },
    pr = {},
    Fo = 180 / Math.PI,
    Ta = Math.PI / 180,
    Sa = Math.atan2,
    Mv = 1e8,
    Yp = /([A-Z])/g,
    kE = /(left|right|width|margin|padding|x)/i,
    HE = /[\s,\(]\S/,
    Gs = {
      autoAlpha: 'opacity,visibility',
      scale: 'scaleX,scaleY',
      alpha: 'opacity',
    },
    Hp = function (e, t) {
      return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u, t);
    },
    zE = function (e, t) {
      return t.set(
        t.t,
        t.p,
        e === 1 ? t.e : Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u,
        t,
      );
    },
    VE = function (e, t) {
      return t.set(
        t.t,
        t.p,
        e ? Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u : t.b,
        t,
      );
    },
    GE = function (e, t) {
      return t.set(
        t.t,
        t.p,
        e === 1 ? t.e : e ? Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u : t.b,
        t,
      );
    },
    WE = function (e, t) {
      var i = t.s + t.c * e;
      t.set(t.t, t.p, ~~(i + (i < 0 ? -0.5 : 0.5)) + t.u, t);
    },
    Dv = function (e, t) {
      return t.set(t.t, t.p, e ? t.e : t.b, t);
    },
    Ov = function (e, t) {
      return t.set(t.t, t.p, e !== 1 ? t.b : t.e, t);
    },
    XE = function (e, t, i) {
      return (e.style[t] = i);
    },
    YE = function (e, t, i) {
      return e.style.setProperty(t, i);
    },
    qE = function (e, t, i) {
      return (e._gsap[t] = i);
    },
    ZE = function (e, t, i) {
      return (e._gsap.scaleX = e._gsap.scaleY = i);
    },
    KE = function (e, t, i, n, r) {
      var o = e._gsap;
      ((o.scaleX = o.scaleY = i), o.renderTransform(r, o));
    },
    $E = function (e, t, i, n, r) {
      var o = e._gsap;
      ((o[t] = i), o.renderTransform(r, o));
    },
    ui = 'transform',
    wn = ui + 'Origin',
    jE = function s(e, t) {
      var i = this,
        n = this.target,
        r = n.style,
        o = n._gsap;
      if (e in pr && r) {
        if (((this.tfm = this.tfm || {}), e !== 'transform'))
          ((e = Gs[e] || e),
            ~e.indexOf(',')
              ? e.split(',').forEach(function (a) {
                  return (i.tfm[a] = fr(n, a));
                })
              : (this.tfm[e] = o.x ? o[e] : fr(n, e)),
            e === wn && (this.tfm.zOrigin = o.zOrigin));
        else
          return Gs.transform.split(',').forEach(function (a) {
            return s.call(i, a, t);
          });
        if (this.props.indexOf(ui) >= 0) return;
        (o.svg &&
          ((this.svgo = n.getAttribute('data-svg-origin')),
          this.props.push(wn, t, '')),
          (e = ui));
      }
      (r || t) && this.props.push(e, t, r[e]);
    },
    Nv = function (e) {
      e.translate &&
        (e.removeProperty('translate'),
        e.removeProperty('scale'),
        e.removeProperty('rotate'));
    },
    JE = function () {
      var e = this.props,
        t = this.target,
        i = t.style,
        n = t._gsap,
        r,
        o;
      for (r = 0; r < e.length; r += 3)
        e[r + 1]
          ? e[r + 1] === 2
            ? t[e[r]](e[r + 2])
            : (t[e[r]] = e[r + 2])
          : e[r + 2]
            ? (i[e[r]] = e[r + 2])
            : i.removeProperty(
                e[r].substr(0, 2) === '--'
                  ? e[r]
                  : e[r].replace(Yp, '-$1').toLowerCase(),
              );
      if (this.tfm) {
        for (o in this.tfm) n[o] = this.tfm[o];
        (n.svg &&
          (n.renderTransform(),
          t.setAttribute('data-svg-origin', this.svgo || '')),
          (r = Xp()),
          (!r || !r.isStart) &&
            !i[ui] &&
            (Nv(i),
            n.zOrigin &&
              i[wn] &&
              ((i[wn] += ' ' + n.zOrigin + 'px'),
              (n.zOrigin = 0),
              n.renderTransform()),
            (n.uncache = 1)));
      }
    },
    Fv = function (e, t) {
      var i = { target: e, props: [], revert: JE, save: jE };
      return (
        e._gsap || tn.core.getCache(e),
        t &&
          e.style &&
          e.nodeType &&
          t.split(',').forEach(function (n) {
            return i.save(n);
          }),
        i
      );
    },
    Uv,
    zp = function (e, t) {
      var i = Hr.createElementNS
        ? Hr.createElementNS(
            (t || 'http://www.w3.org/1999/xhtml').replace(/^https/, 'http'),
            e,
          )
        : Hr.createElement(e);
      return i && i.style ? i : Hr.createElement(e);
    },
    zn = function s(e, t, i) {
      var n = getComputedStyle(e);
      return (
        n[t] ||
        n.getPropertyValue(t.replace(Yp, '-$1').toLowerCase()) ||
        n.getPropertyValue(t) ||
        (!i && s(e, Ma(t) || t, 1)) ||
        ''
      );
    },
    wv = 'O,Moz,ms,Ms,Webkit'.split(','),
    Ma = function (e, t, i) {
      var n = t || Uo,
        r = n.style,
        o = 5;
      if (e in r && !i) return e;
      for (
        e = e.charAt(0).toUpperCase() + e.substr(1);
        o-- && !(wv[o] + e in r);
      );
      return o < 0 ? null : (o === 3 ? 'ms' : o >= 0 ? wv[o] : '') + e;
    },
    Vp = function () {
      BE() &&
        window.document &&
        ((Ev = window),
        (Hr = Ev.document),
        (Ea = Hr.documentElement),
        (Uo = zp('div') || { style: {} }),
        (UE = zp('div')),
        (ui = Ma(ui)),
        (wn = ui + 'Origin'),
        (Uo.style.cssText =
          'border-width:0;line-height:0;position:absolute;padding:0'),
        (Uv = !!Ma('perspective')),
        (Xp = tn.core.reverting),
        (Wp = 1));
    },
    Av = function (e) {
      var t = e.ownerSVGElement,
        i = zp(
          'svg',
          (t && t.getAttribute('xmlns')) || 'http://www.w3.org/2000/svg',
        ),
        n = e.cloneNode(!0),
        r;
      ((n.style.display = 'block'), i.appendChild(n), Ea.appendChild(i));
      try {
        r = n.getBBox();
      } catch (o) {}
      return (i.removeChild(n), Ea.removeChild(i), r);
    },
    Rv = function (e, t) {
      for (var i = t.length; i--; )
        if (e.hasAttribute(t[i])) return e.getAttribute(t[i]);
    },
    Bv = function (e) {
      var t, i;
      try {
        t = e.getBBox();
      } catch (n) {
        ((t = Av(e)), (i = 1));
      }
      return (
        (t && (t.width || t.height)) || i || (t = Av(e)),
        t && !t.width && !t.x && !t.y
          ? {
              x: +Rv(e, ['x', 'cx', 'x1']) || 0,
              y: +Rv(e, ['y', 'cy', 'y1']) || 0,
              width: 0,
              height: 0,
            }
          : t
      );
    },
    kv = function (e) {
      return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && Bv(e));
    },
    Vr = function (e, t) {
      if (t) {
        var i = e.style,
          n;
        (t in pr && t !== wn && (t = ui),
          i.removeProperty
            ? ((n = t.substr(0, 2)),
              (n === 'ms' || t.substr(0, 6) === 'webkit') && (t = '-' + t),
              i.removeProperty(
                n === '--' ? t : t.replace(Yp, '-$1').toLowerCase(),
              ))
            : i.removeAttribute(t));
      }
    },
    zr = function (e, t, i, n, r, o) {
      var a = new _n(e._pt, t, i, 0, 1, o ? Ov : Dv);
      return ((e._pt = a), (a.b = n), (a.e = r), e._props.push(i), a);
    },
    Cv = { deg: 1, rad: 1, turn: 1 },
    QE = { grid: 1, flex: 1 },
    Gr = function s(e, t, i, n) {
      var r = parseFloat(i) || 0,
        o = (i + '').trim().substr((r + '').length) || 'px',
        a = Uo.style,
        l = kE.test(t),
        c = e.tagName.toLowerCase() === 'svg',
        u = (c ? 'client' : 'offset') + (l ? 'Width' : 'Height'),
        f = 100,
        d = n === 'px',
        p = n === '%',
        _,
        x,
        g,
        v;
      if (n === o || !r || Cv[n] || Cv[o]) return r;
      if (
        (o !== 'px' && !d && (r = s(e, t, i, 'px')),
        (v = e.getCTM && kv(e)),
        (p || o === '%') && (pr[t] || ~t.indexOf('adius')))
      )
        return (
          (_ = v ? e.getBBox()[l ? 'width' : 'height'] : e[u]),
          _i(p ? (r / _) * f : (r / 100) * _)
        );
      if (
        ((a[l ? 'width' : 'height'] = f + (d ? o : n)),
        (x =
          (n !== 'rem' && ~t.indexOf('adius')) ||
          (n === 'em' && e.appendChild && !c)
            ? e
            : e.parentNode),
        v && (x = (e.ownerSVGElement || {}).parentNode),
        (!x || x === Hr || !x.appendChild) && (x = Hr.body),
        (g = x._gsap),
        g && p && g.width && l && g.time === En.time && !g.uncache)
      )
        return _i((r / g.width) * f);
      if (p && (t === 'height' || t === 'width')) {
        var w = e.style[t];
        ((e.style[t] = f + n), (_ = e[u]), w ? (e.style[t] = w) : Vr(e, t));
      } else
        ((p || o === '%') &&
          !QE[zn(x, 'display')] &&
          (a.position = zn(e, 'position')),
          x === e && (a.position = 'static'),
          x.appendChild(Uo),
          (_ = Uo[u]),
          x.removeChild(Uo),
          (a.position = 'absolute'));
      return (
        l && p && ((g = Ur(x)), (g.time = En.time), (g.width = x[u])),
        _i(d ? (_ * r) / f : _ && r ? (f / _) * r : 0)
      );
    },
    fr = function (e, t, i, n) {
      var r;
      return (
        Wp || Vp(),
        t in Gs &&
          t !== 'transform' &&
          ((t = Gs[t]), ~t.indexOf(',') && (t = t.split(',')[0])),
        pr[t] && t !== 'transform'
          ? ((r = Ql(e, n)),
            (r =
              t !== 'transformOrigin'
                ? r[t]
                : r.svg
                  ? r.origin
                  : Gh(zn(e, wn)) + ' ' + r.zOrigin + 'px'))
          : ((r = e.style[t]),
            (!r || r === 'auto' || n || ~(r + '').indexOf('calc(')) &&
              (r =
                (Vh[t] && Vh[t](e, t, i)) ||
                zn(e, t) ||
                Rp(e, t) ||
                (t === 'opacity' ? 1 : 0))),
        i && !~(r + '').trim().indexOf(' ') ? Gr(e, t, r, i) + i : r
      );
    },
    eT = function (e, t, i, n) {
      if (!i || i === 'none') {
        var r = Ma(t, e, 1),
          o = r && zn(e, r, 1);
        o && o !== i
          ? ((t = r), (i = o))
          : t === 'borderColor' && (i = zn(e, 'borderTopColor'));
      }
      var a = new _n(this._pt, e.style, t, 0, 1, Fp),
        l = 0,
        c = 0,
        u,
        f,
        d,
        p,
        _,
        x,
        g,
        v,
        w,
        L,
        R,
        U;
      if (
        ((a.b = i),
        (a.e = n),
        (i += ''),
        (n += ''),
        n.substring(0, 6) === 'var(--' &&
          (n = zn(e, n.substring(4, n.indexOf(')')))),
        n === 'auto' &&
          ((x = e.style[t]),
          (e.style[t] = n),
          (n = zn(e, t) || n),
          x ? (e.style[t] = x) : Vr(e, t)),
        (u = [i, n]),
        Pp(u),
        (i = u[0]),
        (n = u[1]),
        (d = i.match(Lo) || []),
        (U = n.match(Lo) || []),
        U.length)
      ) {
        for (; (f = Lo.exec(n)); )
          ((g = f[0]),
            (w = n.substring(l, f.index)),
            _
              ? (_ = (_ + 1) % 5)
              : (w.substr(-5) === 'rgba(' || w.substr(-5) === 'hsla(') &&
                (_ = 1),
            g !== (x = d[c++] || '') &&
              ((p = parseFloat(x) || 0),
              (R = x.substr((p + '').length)),
              g.charAt(1) === '=' && (g = Io(p, g) + R),
              (v = parseFloat(g)),
              (L = g.substr((v + '').length)),
              (l = Lo.lastIndex - L.length),
              L ||
                ((L = L || Mn.units[t] || R),
                l === n.length && ((n += L), (a.e += L))),
              R !== L && (p = Gr(e, t, x, L) || 0),
              (a._pt = {
                _next: a._pt,
                p: w || c === 1 ? w : ',',
                s: p,
                c: v - p,
                m: (_ && _ < 4) || t === 'zIndex' ? Math.round : 0,
              })));
        a.c = l < n.length ? n.substring(l, n.length) : '';
      } else a.r = t === 'display' && n === 'none' ? Ov : Dv;
      return (Ep.test(n) && (a.e = 0), (this._pt = a), a);
    },
    Pv = {
      top: '0%',
      bottom: '100%',
      left: '0%',
      right: '100%',
      center: '50%',
    },
    tT = function (e) {
      var t = e.split(' '),
        i = t[0],
        n = t[1] || '50%';
      return (
        (i === 'top' || i === 'bottom' || n === 'left' || n === 'right') &&
          ((e = i), (i = n), (n = e)),
        (t[0] = Pv[i] || i),
        (t[1] = Pv[n] || n),
        t.join(' ')
      );
    },
    iT = function (e, t) {
      if (t.tween && t.tween._time === t.tween._dur) {
        var i = t.t,
          n = i.style,
          r = t.u,
          o = i._gsap,
          a,
          l,
          c;
        if (r === 'all' || r === !0) ((n.cssText = ''), (l = 1));
        else
          for (r = r.split(','), c = r.length; --c > -1; )
            ((a = r[c]),
              pr[a] && ((l = 1), (a = a === 'transformOrigin' ? wn : ui)),
              Vr(i, a));
        l &&
          (Vr(i, ui),
          o &&
            (o.svg && i.removeAttribute('transform'),
            (n.scale = n.rotate = n.translate = 'none'),
            Ql(i, 1),
            (o.uncache = 1),
            Nv(n)));
      }
    },
    Vh = {
      clearProps: function (e, t, i, n, r) {
        if (r.data !== 'isFromStart') {
          var o = (e._pt = new _n(e._pt, t, i, 0, 0, iT));
          return ((o.u = n), (o.pr = -10), (o.tween = r), e._props.push(i), 1);
        }
      },
    },
    Jl = [1, 0, 0, 1, 0, 0],
    Hv = {},
    zv = function (e) {
      return e === 'matrix(1, 0, 0, 1, 0, 0)' || e === 'none' || !e;
    },
    Lv = function (e) {
      var t = zn(e, ui);
      return zv(t) ? Jl : t.substr(7).match(Sp).map(_i);
    },
    qp = function (e, t) {
      var i = e._gsap || Ur(e),
        n = e.style,
        r = Lv(e),
        o,
        a,
        l,
        c;
      return i.svg && e.getAttribute('transform')
        ? ((l = e.transform.baseVal.consolidate().matrix),
          (r = [l.a, l.b, l.c, l.d, l.e, l.f]),
          r.join(',') === '1,0,0,1,0,0' ? Jl : r)
        : (r === Jl &&
            !e.offsetParent &&
            e !== Ea &&
            !i.svg &&
            ((l = n.display),
            (n.display = 'block'),
            (o = e.parentNode),
            (!o || (!e.offsetParent && !e.getBoundingClientRect().width)) &&
              ((c = 1), (a = e.nextElementSibling), Ea.appendChild(e)),
            (r = Lv(e)),
            l ? (n.display = l) : Vr(e, 'display'),
            c &&
              (a
                ? o.insertBefore(e, a)
                : o
                  ? o.appendChild(e)
                  : Ea.removeChild(e))),
          t && r.length > 6 ? [r[0], r[1], r[4], r[5], r[12], r[13]] : r);
    },
    Gp = function (e, t, i, n, r, o) {
      var a = e._gsap,
        l = r || qp(e, !0),
        c = a.xOrigin || 0,
        u = a.yOrigin || 0,
        f = a.xOffset || 0,
        d = a.yOffset || 0,
        p = l[0],
        _ = l[1],
        x = l[2],
        g = l[3],
        v = l[4],
        w = l[5],
        L = t.split(' '),
        R = parseFloat(L[0]) || 0,
        U = parseFloat(L[1]) || 0,
        O,
        N,
        M,
        I;
      (i
        ? l !== Jl &&
          (N = p * g - _ * x) &&
          ((M = R * (g / N) + U * (-x / N) + (x * w - g * v) / N),
          (I = R * (-_ / N) + U * (p / N) - (p * w - _ * v) / N),
          (R = M),
          (U = I))
        : ((O = Bv(e)),
          (R = O.x + (~L[0].indexOf('%') ? (R / 100) * O.width : R)),
          (U =
            O.y + (~(L[1] || L[0]).indexOf('%') ? (U / 100) * O.height : U))),
        n || (n !== !1 && a.smooth)
          ? ((v = R - c),
            (w = U - u),
            (a.xOffset = f + (v * p + w * x) - v),
            (a.yOffset = d + (v * _ + w * g) - w))
          : (a.xOffset = a.yOffset = 0),
        (a.xOrigin = R),
        (a.yOrigin = U),
        (a.smooth = !!n),
        (a.origin = t),
        (a.originIsAbsolute = !!i),
        (e.style[wn] = '0px 0px'),
        o &&
          (zr(o, a, 'xOrigin', c, R),
          zr(o, a, 'yOrigin', u, U),
          zr(o, a, 'xOffset', f, a.xOffset),
          zr(o, a, 'yOffset', d, a.yOffset)),
        e.setAttribute('data-svg-origin', R + ' ' + U));
    },
    Ql = function (e, t) {
      var i = e._gsap || new Lp(e);
      if ('x' in i && !t && !i.uncache) return i;
      var n = e.style,
        r = i.scaleX < 0,
        o = 'px',
        a = 'deg',
        l = getComputedStyle(e),
        c = zn(e, wn) || '0',
        u,
        f,
        d,
        p,
        _,
        x,
        g,
        v,
        w,
        L,
        R,
        U,
        O,
        N,
        M,
        I,
        z,
        W,
        q,
        re,
        oe,
        K,
        ie,
        J,
        pe,
        Ee,
        Z,
        Ne,
        Be,
        ht,
        ot,
        tt;
      return (
        (u = f = d = x = g = v = w = L = R = 0),
        (p = _ = 1),
        (i.svg = !!(e.getCTM && kv(e))),
        l.translate &&
          ((l.translate !== 'none' ||
            l.scale !== 'none' ||
            l.rotate !== 'none') &&
            (n[ui] =
              (l.translate !== 'none'
                ? 'translate3d(' +
                  (l.translate + ' 0 0').split(' ').slice(0, 3).join(', ') +
                  ') '
                : '') +
              (l.rotate !== 'none' ? 'rotate(' + l.rotate + ') ' : '') +
              (l.scale !== 'none'
                ? 'scale(' + l.scale.split(' ').join(',') + ') '
                : '') +
              (l[ui] !== 'none' ? l[ui] : '')),
          (n.scale = n.rotate = n.translate = 'none')),
        (N = qp(e, i.svg)),
        i.svg &&
          (i.uncache
            ? ((pe = e.getBBox()),
              (c = i.xOrigin - pe.x + 'px ' + (i.yOrigin - pe.y) + 'px'),
              (J = ''))
            : (J = !t && e.getAttribute('data-svg-origin')),
          Gp(e, J || c, !!J || i.originIsAbsolute, i.smooth !== !1, N)),
        (U = i.xOrigin || 0),
        (O = i.yOrigin || 0),
        N !== Jl &&
          ((W = N[0]),
          (q = N[1]),
          (re = N[2]),
          (oe = N[3]),
          (u = K = N[4]),
          (f = ie = N[5]),
          N.length === 6
            ? ((p = Math.sqrt(W * W + q * q)),
              (_ = Math.sqrt(oe * oe + re * re)),
              (x = W || q ? Sa(q, W) * Fo : 0),
              (w = re || oe ? Sa(re, oe) * Fo + x : 0),
              w && (_ *= Math.abs(Math.cos(w * Ta))),
              i.svg &&
                ((u -= U - (U * W + O * re)), (f -= O - (U * q + O * oe))))
            : ((tt = N[6]),
              (ht = N[7]),
              (Z = N[8]),
              (Ne = N[9]),
              (Be = N[10]),
              (ot = N[11]),
              (u = N[12]),
              (f = N[13]),
              (d = N[14]),
              (M = Sa(tt, Be)),
              (g = M * Fo),
              M &&
                ((I = Math.cos(-M)),
                (z = Math.sin(-M)),
                (J = K * I + Z * z),
                (pe = ie * I + Ne * z),
                (Ee = tt * I + Be * z),
                (Z = K * -z + Z * I),
                (Ne = ie * -z + Ne * I),
                (Be = tt * -z + Be * I),
                (ot = ht * -z + ot * I),
                (K = J),
                (ie = pe),
                (tt = Ee)),
              (M = Sa(-re, Be)),
              (v = M * Fo),
              M &&
                ((I = Math.cos(-M)),
                (z = Math.sin(-M)),
                (J = W * I - Z * z),
                (pe = q * I - Ne * z),
                (Ee = re * I - Be * z),
                (ot = oe * z + ot * I),
                (W = J),
                (q = pe),
                (re = Ee)),
              (M = Sa(q, W)),
              (x = M * Fo),
              M &&
                ((I = Math.cos(M)),
                (z = Math.sin(M)),
                (J = W * I + q * z),
                (pe = K * I + ie * z),
                (q = q * I - W * z),
                (ie = ie * I - K * z),
                (W = J),
                (K = pe)),
              g &&
                Math.abs(g) + Math.abs(x) > 359.9 &&
                ((g = x = 0), (v = 180 - v)),
              (p = _i(Math.sqrt(W * W + q * q + re * re))),
              (_ = _i(Math.sqrt(ie * ie + tt * tt))),
              (M = Sa(K, ie)),
              (w = Math.abs(M) > 2e-4 ? M * Fo : 0),
              (R = ot ? 1 / (ot < 0 ? -ot : ot) : 0)),
          i.svg &&
            ((J = e.getAttribute('transform')),
            (i.forceCSS = e.setAttribute('transform', '') || !zv(zn(e, ui))),
            J && e.setAttribute('transform', J))),
        Math.abs(w) > 90 &&
          Math.abs(w) < 270 &&
          (r
            ? ((p *= -1),
              (w += x <= 0 ? 180 : -180),
              (x += x <= 0 ? 180 : -180))
            : ((_ *= -1), (w += w <= 0 ? 180 : -180))),
        (t = t || i.uncache),
        (i.x =
          u -
          ((i.xPercent =
            u &&
            ((!t && i.xPercent) ||
              (Math.round(e.offsetWidth / 2) === Math.round(-u) ? -50 : 0)))
            ? (e.offsetWidth * i.xPercent) / 100
            : 0) +
          o),
        (i.y =
          f -
          ((i.yPercent =
            f &&
            ((!t && i.yPercent) ||
              (Math.round(e.offsetHeight / 2) === Math.round(-f) ? -50 : 0)))
            ? (e.offsetHeight * i.yPercent) / 100
            : 0) +
          o),
        (i.z = d + o),
        (i.scaleX = _i(p)),
        (i.scaleY = _i(_)),
        (i.rotation = _i(x) + a),
        (i.rotationX = _i(g) + a),
        (i.rotationY = _i(v) + a),
        (i.skewX = w + a),
        (i.skewY = L + a),
        (i.transformPerspective = R + o),
        (i.zOrigin = parseFloat(c.split(' ')[2]) || (!t && i.zOrigin) || 0) &&
          (n[wn] = Gh(c)),
        (i.xOffset = i.yOffset = 0),
        (i.force3D = Mn.force3D),
        (i.renderTransform = i.svg ? sT : Uv ? Vv : nT),
        (i.uncache = 0),
        i
      );
    },
    Gh = function (e) {
      return (e = e.split(' '))[0] + ' ' + e[1];
    },
    kp = function (e, t, i) {
      var n = Yi(t);
      return _i(parseFloat(t) + parseFloat(Gr(e, 'x', i + 'px', n))) + n;
    },
    nT = function (e, t) {
      ((t.z = '0px'),
        (t.rotationY = t.rotationX = '0deg'),
        (t.force3D = 0),
        Vv(e, t));
    },
    Oo = '0deg',
    jl = '0px',
    No = ') ',
    Vv = function (e, t) {
      var i = t || this,
        n = i.xPercent,
        r = i.yPercent,
        o = i.x,
        a = i.y,
        l = i.z,
        c = i.rotation,
        u = i.rotationY,
        f = i.rotationX,
        d = i.skewX,
        p = i.skewY,
        _ = i.scaleX,
        x = i.scaleY,
        g = i.transformPerspective,
        v = i.force3D,
        w = i.target,
        L = i.zOrigin,
        R = '',
        U = (v === 'auto' && e && e !== 1) || v === !0;
      if (L && (f !== Oo || u !== Oo)) {
        var O = parseFloat(u) * Ta,
          N = Math.sin(O),
          M = Math.cos(O),
          I;
        ((O = parseFloat(f) * Ta),
          (I = Math.cos(O)),
          (o = kp(w, o, N * I * -L)),
          (a = kp(w, a, -Math.sin(O) * -L)),
          (l = kp(w, l, M * I * -L + L)));
      }
      (g !== jl && (R += 'perspective(' + g + No),
        (n || r) && (R += 'translate(' + n + '%, ' + r + '%) '),
        (U || o !== jl || a !== jl || l !== jl) &&
          (R +=
            l !== jl || U
              ? 'translate3d(' + o + ', ' + a + ', ' + l + ') '
              : 'translate(' + o + ', ' + a + No),
        c !== Oo && (R += 'rotate(' + c + No),
        u !== Oo && (R += 'rotateY(' + u + No),
        f !== Oo && (R += 'rotateX(' + f + No),
        (d !== Oo || p !== Oo) && (R += 'skew(' + d + ', ' + p + No),
        (_ !== 1 || x !== 1) && (R += 'scale(' + _ + ', ' + x + No),
        (w.style[ui] = R || 'translate(0, 0)'));
    },
    sT = function (e, t) {
      var i = t || this,
        n = i.xPercent,
        r = i.yPercent,
        o = i.x,
        a = i.y,
        l = i.rotation,
        c = i.skewX,
        u = i.skewY,
        f = i.scaleX,
        d = i.scaleY,
        p = i.target,
        _ = i.xOrigin,
        x = i.yOrigin,
        g = i.xOffset,
        v = i.yOffset,
        w = i.forceCSS,
        L = parseFloat(o),
        R = parseFloat(a),
        U,
        O,
        N,
        M,
        I;
      ((l = parseFloat(l)),
        (c = parseFloat(c)),
        (u = parseFloat(u)),
        u && ((u = parseFloat(u)), (c += u), (l += u)),
        l || c
          ? ((l *= Ta),
            (c *= Ta),
            (U = Math.cos(l) * f),
            (O = Math.sin(l) * f),
            (N = Math.sin(l - c) * -d),
            (M = Math.cos(l - c) * d),
            c &&
              ((u *= Ta),
              (I = Math.tan(c - u)),
              (I = Math.sqrt(1 + I * I)),
              (N *= I),
              (M *= I),
              u &&
                ((I = Math.tan(u)),
                (I = Math.sqrt(1 + I * I)),
                (U *= I),
                (O *= I))),
            (U = _i(U)),
            (O = _i(O)),
            (N = _i(N)),
            (M = _i(M)))
          : ((U = f), (M = d), (O = N = 0)),
        ((L && !~(o + '').indexOf('px')) || (R && !~(a + '').indexOf('px'))) &&
          ((L = Gr(p, 'x', o, 'px')), (R = Gr(p, 'y', a, 'px'))),
        (_ || x || g || v) &&
          ((L = _i(L + _ - (_ * U + x * N) + g)),
          (R = _i(R + x - (_ * O + x * M) + v))),
        (n || r) &&
          ((I = p.getBBox()),
          (L = _i(L + (n / 100) * I.width)),
          (R = _i(R + (r / 100) * I.height))),
        (I =
          'matrix(' +
          U +
          ',' +
          O +
          ',' +
          N +
          ',' +
          M +
          ',' +
          L +
          ',' +
          R +
          ')'),
        p.setAttribute('transform', I),
        w && (p.style[ui] = I));
    },
    rT = function (e, t, i, n, r) {
      var o = 360,
        a = Pi(r),
        l = parseFloat(r) * (a && ~r.indexOf('rad') ? Fo : 1),
        c = l - n,
        u = n + c + 'deg',
        f,
        d;
      return (
        a &&
          ((f = r.split('_')[1]),
          f === 'short' &&
            ((c %= o), c !== c % (o / 2) && (c += c < 0 ? o : -o)),
          f === 'cw' && c < 0
            ? (c = ((c + o * Mv) % o) - ~~(c / o) * o)
            : f === 'ccw' && c > 0 && (c = ((c - o * Mv) % o) - ~~(c / o) * o)),
        (e._pt = d = new _n(e._pt, t, i, n, c, zE)),
        (d.e = u),
        (d.u = 'deg'),
        e._props.push(i),
        d
      );
    },
    Iv = function (e, t) {
      for (var i in t) e[i] = t[i];
      return e;
    },
    oT = function (e, t, i) {
      var n = Iv({}, i._gsap),
        r = 'perspective,force3D,transformOrigin,svgOrigin',
        o = i.style,
        a,
        l,
        c,
        u,
        f,
        d,
        p,
        _;
      n.svg
        ? ((c = i.getAttribute('transform')),
          i.setAttribute('transform', ''),
          (o[ui] = t),
          (a = Ql(i, 1)),
          Vr(i, ui),
          i.setAttribute('transform', c))
        : ((c = getComputedStyle(i)[ui]),
          (o[ui] = t),
          (a = Ql(i, 1)),
          (o[ui] = c));
      for (l in pr)
        ((c = n[l]),
          (u = a[l]),
          c !== u &&
            r.indexOf(l) < 0 &&
            ((p = Yi(c)),
            (_ = Yi(u)),
            (f = p !== _ ? Gr(i, l, c, _) : parseFloat(c)),
            (d = parseFloat(u)),
            (e._pt = new _n(e._pt, a, l, f, d - f, Hp)),
            (e._pt.u = _ || 0),
            e._props.push(l)));
      Iv(a, n);
    };
  gn('padding,margin,Width,Radius', function (s, e) {
    var t = 'Top',
      i = 'Right',
      n = 'Bottom',
      r = 'Left',
      o = (e < 3 ? [t, i, n, r] : [t + r, t + i, n + i, n + r]).map(
        function (a) {
          return e < 2 ? s + a : 'border' + a + s;
        },
      );
    Vh[e > 1 ? 'border' + s : s] = function (a, l, c, u, f) {
      var d, p;
      if (arguments.length < 4)
        return (
          (d = o.map(function (_) {
            return fr(a, _, c);
          })),
          (p = d.join(' ')),
          p.split(d[0]).length === 5 ? d[0] : p
        );
      ((d = (u + '').split(' ')),
        (p = {}),
        o.forEach(function (_, x) {
          return (p[_] = d[x] = d[x] || d[((x - 1) / 2) | 0]);
        }),
        a.init(l, p, f));
    };
  });
  var Zp = {
    name: 'css',
    register: Vp,
    targetTest: function (e) {
      return e.style && e.nodeType;
    },
    init: function (e, t, i, n, r) {
      var o = this._props,
        a = e.style,
        l = i.vars.startAt,
        c,
        u,
        f,
        d,
        p,
        _,
        x,
        g,
        v,
        w,
        L,
        R,
        U,
        O,
        N,
        M,
        I;
      (Wp || Vp(),
        (this.styles = this.styles || Fv(e)),
        (M = this.styles.props),
        (this.tween = i));
      for (x in t)
        if (
          x !== 'autoRound' &&
          ((u = t[x]), !(Sn[x] && Dp(x, t, i, n, e, r)))
        ) {
          if (
            ((p = typeof u),
            (_ = Vh[x]),
            p === 'function' && ((u = u.call(i, n, e, r)), (p = typeof u)),
            p === 'string' && ~u.indexOf('random(') && (u = ba(u)),
            _)
          )
            _(this, e, x, u, i) && (N = 1);
          else if (x.substr(0, 2) === '--')
            ((c = (getComputedStyle(e).getPropertyValue(x) + '').trim()),
              (u += ''),
              (ur.lastIndex = 0),
              ur.test(c) ||
                ((g = Yi(c)),
                (v = Yi(u)),
                v ? g !== v && (c = Gr(e, x, c, v) + v) : g && (u += g)),
              this.add(a, 'setProperty', c, u, n, r, 0, 0, x),
              o.push(x),
              M.push(x, 0, a[x]));
          else if (p !== 'undefined') {
            if (
              (l && x in l
                ? ((c =
                    typeof l[x] == 'function' ? l[x].call(i, n, e, r) : l[x]),
                  Pi(c) && ~c.indexOf('random(') && (c = ba(c)),
                  Yi(c + '') ||
                    c === 'auto' ||
                    (c += Mn.units[x] || Yi(fr(e, x)) || ''),
                  (c + '').charAt(1) === '=' && (c = fr(e, x)))
                : (c = fr(e, x)),
              (d = parseFloat(c)),
              (w = p === 'string' && u.charAt(1) === '=' && u.substr(0, 2)),
              w && (u = u.substr(2)),
              (f = parseFloat(u)),
              x in Gs &&
                (x === 'autoAlpha' &&
                  (d === 1 && fr(e, 'visibility') === 'hidden' && f && (d = 0),
                  M.push('visibility', 0, a.visibility),
                  zr(
                    this,
                    a,
                    'visibility',
                    d ? 'inherit' : 'hidden',
                    f ? 'inherit' : 'hidden',
                    !f,
                  )),
                x !== 'scale' &&
                  x !== 'transform' &&
                  ((x = Gs[x]), ~x.indexOf(',') && (x = x.split(',')[0]))),
              (L = x in pr),
              L)
            ) {
              if (
                (this.styles.save(x),
                (I = u),
                p === 'string' && u.substring(0, 6) === 'var(--')
              ) {
                if (
                  ((u = zn(e, u.substring(4, u.indexOf(')')))),
                  u.substring(0, 5) === 'calc(')
                ) {
                  var z = e.style.perspective;
                  ((e.style.perspective = u),
                    (u = zn(e, 'perspective')),
                    z ? (e.style.perspective = z) : Vr(e, 'perspective'));
                }
                f = parseFloat(u);
              }
              if (
                (R ||
                  ((U = e._gsap),
                  (U.renderTransform && !t.parseTransform) ||
                    Ql(e, t.parseTransform),
                  (O = t.smoothOrigin !== !1 && U.smooth),
                  (R = this._pt =
                    new _n(this._pt, a, ui, 0, 1, U.renderTransform, U, 0, -1)),
                  (R.dep = 1)),
                x === 'scale')
              )
                ((this._pt = new _n(
                  this._pt,
                  U,
                  'scaleY',
                  U.scaleY,
                  (w ? Io(U.scaleY, w + f) : f) - U.scaleY || 0,
                  Hp,
                )),
                  (this._pt.u = 0),
                  o.push('scaleY', x),
                  (x += 'X'));
              else if (x === 'transformOrigin') {
                (M.push(wn, 0, a[wn]),
                  (u = tT(u)),
                  U.svg
                    ? Gp(e, u, 0, O, 0, this)
                    : ((v = parseFloat(u.split(' ')[2]) || 0),
                      v !== U.zOrigin && zr(this, U, 'zOrigin', U.zOrigin, v),
                      zr(this, a, x, Gh(c), Gh(u))));
                continue;
              } else if (x === 'svgOrigin') {
                Gp(e, u, 1, O, 0, this);
                continue;
              } else if (x in Hv) {
                rT(this, U, x, d, w ? Io(d, w + u) : u);
                continue;
              } else if (x === 'smoothOrigin') {
                zr(this, U, 'smooth', U.smooth, u);
                continue;
              } else if (x === 'force3D') {
                U[x] = u;
                continue;
              } else if (x === 'transform') {
                oT(this, u, e);
                continue;
              }
            } else x in a || (x = Ma(x) || x);
            if (
              L ||
              ((f || f === 0) && (d || d === 0) && !HE.test(u) && x in a)
            )
              ((g = (c + '').substr((d + '').length)),
                f || (f = 0),
                (v = Yi(u) || (x in Mn.units ? Mn.units[x] : g)),
                g !== v && (d = Gr(e, x, c, v)),
                (this._pt = new _n(
                  this._pt,
                  L ? U : a,
                  x,
                  d,
                  (w ? Io(d, w + f) : f) - d,
                  !L && (v === 'px' || x === 'zIndex') && t.autoRound !== !1
                    ? WE
                    : Hp,
                )),
                (this._pt.u = v || 0),
                L && I !== u
                  ? ((this._pt.b = c), (this._pt.e = I), (this._pt.r = GE))
                  : g !== v &&
                    v !== '%' &&
                    ((this._pt.b = c), (this._pt.r = VE)));
            else if (x in a) eT.call(this, e, x, c, w ? w + u : u);
            else if (x in e) this.add(e, x, c || e[x], w ? w + u : u, n, r);
            else if (x !== 'parseTransform') {
              Uh(x, u);
              continue;
            }
            (L ||
              (x in a
                ? M.push(x, 0, a[x])
                : typeof e[x] == 'function'
                  ? M.push(x, 2, e[x]())
                  : M.push(x, 1, c || e[x])),
              o.push(x));
          }
        }
      N && Bp(this);
    },
    render: function (e, t) {
      if (t.tween._time || !Xp())
        for (var i = t._pt; i; ) (i.r(e, i.d), (i = i._next));
      else t.styles.revert();
    },
    get: fr,
    aliases: Gs,
    getSetter: function (e, t, i) {
      var n = Gs[t];
      return (
        n && n.indexOf(',') < 0 && (t = n),
        t in pr && t !== wn && (e._gsap.x || fr(e, 'x'))
          ? i && Tv === i
            ? t === 'scale'
              ? ZE
              : qE
            : (Tv = i || {}) && (t === 'scale' ? KE : $E)
          : e.style && !Fh(e.style[t])
            ? XE
            : ~t.indexOf('-')
              ? YE
              : zh(e, t)
      );
    },
    core: { _removeProperty: Vr, _getMatrix: qp },
  };
  tn.utils.checkPrefix = Ma;
  tn.core.getStyleSaver = Fv;
  (function (s, e, t, i) {
    var n = gn(s + ',' + e + ',' + t, function (r) {
      pr[r] = 1;
    });
    (gn(e, function (r) {
      ((Mn.units[r] = 'deg'), (Hv[r] = 1));
    }),
      (Gs[n[13]] = s + ',' + e),
      gn(i, function (r) {
        var o = r.split(':');
        Gs[o[1]] = n[o[0]];
      }));
  })(
    'x,y,z,scale,scaleX,scaleY,xPercent,yPercent',
    'rotation,rotationX,rotationY,skewX,skewY',
    'transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective',
    '0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY',
  );
  gn(
    'x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective',
    function (s) {
      Mn.units[s] = 'px';
    },
  );
  tn.registerPlugin(Zp);
  var Et = tn.registerPlugin(Zp) || tn,
    EL = Et.core.Tween;
  var Wv,
    Kp = ((Wv = window.history.state) == null ? void 0 : Wv.hdjF9) === !0,
    Xv = 'hdjF9:leaveScrollY',
    wa = (() => {
      if (!Kp) return null;
      try {
        let s = window.sessionStorage.getItem(Xv);
        if (s === null) return null;
        let e = Number(s);
        return Number.isFinite(e) ? e : null;
      } catch (s) {
        return null;
      }
    })();
  window.addEventListener('pagehide', () => {
    try {
      window.sessionStorage.setItem(Xv, String(window.scrollY));
    } catch (s) {}
  });
  var aT = 3e3,
    Gv = () => {
      window.setTimeout(() => {
        var s;
        window.history.replaceState(
          Fi(pt({}, (s = window.history.state) != null ? s : {}), {
            hdjF9: !0,
          }),
          '',
        );
      }, aT);
    };
  document.readyState === 'complete'
    ? Gv()
    : window.addEventListener('load', Gv, { once: !0 });
  var $p = {
      pinArea: 'data-playback-pin-area',
      sticky: 'data-playback-sticky',
    },
    Wh = 0.75;
  var ct = {
      canvas: 'data-product-canvas',
      bgVideo: 'data-bg-video',
      viewer: 'data-product-viewer',
      viewerOverlay: 'data-product-viewer-overlay',
      viewerZoomTrack: 'data-product-viewer-zoom-track',
      viewerZoomKnob: 'data-product-viewer-zoom-knob',
      viewerZoomIn: 'data-product-viewer-zoom-in',
      viewerZoomOut: 'data-product-viewer-zoom-out',
      viewerBox: 'data-product-viewer-box',
      viewerReset: 'data-product-viewer-reset',
      inViewRoots: [
        '#AT-Top',
        '#AT-Overview',
        '#AT-SoundQuality',
        '#AT-Viewer',
        '#AT-Cta',
      ],
      scrollAway: 'data-product-scroll-away',
      topTitle: 'data-top-title',
      topSection: '#AT-Top',
      bluetoothText: 'data-product-bluetooth-text',
      ctaContents: 'data-product-cta-contents',
      sections: {
        introduction: 'data-product-introduction',
        playstyle: 'data-product-playstyle',
        soniclink: 'data-product-soniclink',
        led: 'data-product-led',
        ledGenerator: 'data-product-led-generator',
        movie: 'data-product-movie',
        scene: 'data-product-scene',
        playback: 'data-product-playback',
        bluetooth: 'data-product-bluetooth',
        feature: 'data-product-feature',
        testimonial: 'data-product-testimonial',
        cta: 'data-product-cta',
      },
    },
    jp = 0.5,
    Jp = 0.25,
    Kv = 80,
    $v = 40,
    jv = 48,
    mr = {
      startPose: { rx: -64, ry: 0, rz: 0, scale: 1.9 },
      risePy: 0.03,
      riseDuration: 2.4,
      riseEase: 'power2.out',
      settleDelay: 0.5,
      settleDuration: 3,
      settleEase: 'power2.inOut',
      offscreenMarginPx: 40,
      ledColor: 'rgb(0, 0, 255)',
      ledOnLead: 1,
      ledOnFade: 1.6,
      ledOffDelay: 0.6,
      ledOffFade: 1.6,
      ledRestoreFade: 0.4,
      lightsOnFade: 0.8,
      titleRevealLead: 1.6,
      introHoldReleaseDelay: 0.8,
    },
    rm = 'hdjF9:introPlayed',
    Yh = () => {
      try {
        return window.sessionStorage.getItem(rm) === '1';
      } catch (s) {
        return !1;
      }
    },
    Ws = {
      riseWorld: 0.03,
      startRxOffset: -10,
      startRyOffset: -30,
      duration: 1,
      ease: 'power2.out',
    },
    om = -0.15,
    Jv = `top ${om * 100}%`,
    Yv = 0.05,
    Qv = 20,
    ex = 8,
    tx = 48,
    ix = 1 / 3,
    lT = `top ${100 + 200 * (1 - Wh)}%`,
    am = 'bluetooth-depart',
    lm = 'cta-depart',
    cT = 13228287,
    Qp = 5417983,
    em = 6,
    tm = { color: 1008547, intensity: 2.5, position: [-20, 20, -20] },
    im = { color: 6410495, intensity: 3.8, position: [10.5, 18, -20] },
    nm = { color: 16723673, intensity: 1, position: [12, -17.5, -20] },
    sm = { color: 16777215, intensity: 1.3, position: [-10, 3, 5] },
    qv = 0.07,
    hT = 0.35,
    Zv = {
      glbUrl: hdjf9AssetBase + 'hdjf9-3d-GLTF_HDJ-F9_260119.glb',
      dracoPath: hdjf9AssetBase,
      maxPixelRatio: 2,
      camera: { fov: 45, near: 0.1, far: 1e3, fitScale: 1.5 },
      lights: {
        ambientColor: cT,
        ambientIntensity: 0,
        directionalColor: Qp,
        directionalIntensity: em,
        directionalPosition: [11.5, -20, -12],
        introColor: 16777215,
        accent1: tm,
        accent2: im,
        accent3: nm,
      },
      envMap: {
        intensity: 1.5,
        updateInterval: 6,
        lightIntensity: 1,
        visibilityFadeDuration: 0.4,
      },
      ledMaterial: {
        name: 'LED_white',
        emissiveIntensity: 1,
        fadeDuration: 0.6,
        glow: { strength: 0.7, scale: 0.25, iterations: 3 },
        fixedWhiteMeshes: ['033'],
      },
      ledSpotlight: {
        color: 16777215,
        strength: 0.25,
        ellipse: 1,
        width: 0.18,
        height: 0.107,
        offsetX: -0.005,
        offsetY: -0.085,
        offsetZ: -0.15,
        bottomFade: 0.8,
        shadowOffset: [-0.055, 0.1],
        shadowSquash: 0.32,
        shadowStrength: 0.62,
        resolution: 120,
        blurIterations: 3,
      },
      matteLook: {
        albedo: 0.05,
        metalnessScale: 0.25,
        roughnessAdd: 0.2,
        surfaceFullAt: 0.16,
        targets: [
          'hangar',
          'hanyou_K',
          'band',
          'PAD_mesh',
          'PAD_01',
          'tanshi_K',
          'neji',
        ],
      },
      scrub: 0.8,
      sceneEmergeViewportRatio: jp,
      bluetoothDepart: 'text-bottom',
      initial: {
        pose: {
          rx: -40,
          ry: 152,
          rz: 20,
          px: 0,
          py: 0,
          pz: 0,
          scale: 1,
          camZ: 1.2,
        },
        opacity: 1,
        spinY: 180,
        fitHeight: { camZ1Px: 578, designVh: 900, maxRatio: 0.92 },
      },
      steps: {
        introduction: {
          trigger: ct.sections.introduction,
          start: 'top bottom',
          end: 'top top',
          pose: { rx: 0, ry: 0, rz: 0, px: 0, py: 0.02, scale: 1, camZ: 0.92 },
          spinYFrom: 180,
          spinY: 720,
          light: Qp,
          directionalIntensity: em,
          accent1: tm,
          accent2: im,
          accent3: nm,
          fitHeight: { camZ1Px: 747, designVh: 900, maxRatio: 0.92 },
        },
        playstyle: {
          trigger: ct.sections.introduction,
          start: 'top top',
          endTrigger: ct.sections.playstyle,
          end: 'top -100%',
          poseEase: 'power2.in',
          pose: { px: 0, py: 0, scale: 0 },
          spinYFrom: 720,
          spinY: 900,
          opacity: 0,
          opacityEase: 'expo.in',
        },
        soniclinkIn: {
          trigger: ct.sections.soniclink,
          start: 'top center',
          end: 'top top',
          opacity: 1,
        },
        soniclink: {
          trigger: ct.sections.soniclink,
          start: 'top center',
          end: 'top top',
          poseFrom: {
            rx: -8,
            ry: -29,
            rz: 0,
            px: 0.03,
            py: 0.11,
            scale: 0.5,
            camZ: 0.78,
          },
          pose: {
            rx: -8,
            ry: -29,
            rz: 0,
            px: 0,
            py: 0.07,
            scale: 1,
            camZ: 0.78,
          },
          spinYFrom: 180,
          spinY: 0,
          light: 16777215,
          directionalIntensity: 1.5,
          accent1: { color: 16777215, intensity: 2.6, position: [3, 5, 3.5] },
          accent2: { color: 16777215, intensity: 1.5, position: [15, -4, -7] },
          accent3: sm,
          look: qv,
        },
        led: {
          trigger: ct.sections.led,
          endTrigger: ct.sections.ledGenerator,
          start: 'top bottom',
          end: 'top top',
          poseEase: 'none',
          pose: { rx: -42, ry: -16, rz: 9, px: -0.08, py: -0.005, camZ: 0.85 },
          spinYFrom: 0,
          spinY: 360,
          fitHeight: { camZ1Px: 571, designVh: 900, maxRatio: 0.92 },
        },
        movie: {
          trigger: ct.sections.ledGenerator,
          start: 'bottom top',
          end: '+=250',
          opacity: 0,
        },
        sceneIn: {
          trigger: ct.sections.scene,
          start: 'bottom top',
          end: `+=${jp * 100}%`,
          opacity: 1,
        },
        sceneAlign: {
          trigger: ct.sections.ledGenerator,
          start: 'bottom top',
          endTrigger: ct.sections.scene,
          end: 'bottom top',
          poseFrom: { rx: -42, ry: -16, rz: 9, px: -0.08 },
          pose: { rx: 0, ry: 0, rz: 0, px: 0 },
          spinYFrom: 360,
          spinY: 360,
          look: hT,
        },
        scene: {
          trigger: ct.sections.scene,
          start: 'bottom top',
          end: `+=${jp * 100}%`,
          scaleFrom: 0.25,
          poseFrom: { rx: 0, ry: 0, rz: 0, px: 0, camZ: 0.85 },
          pose: { rx: 0, ry: 0, rz: 0, px: 0, scale: 1, camZ: 1 },
          fitHeight: { camZ1Px: 620, designVh: 900, maxRatio: 0.92 },
          accent1: { color: 16777215, intensity: 3.2, position: [3, 5, 3.5] },
          accent2: { color: 14674431, intensity: 2.2, position: [15, -4, -7] },
          accent3: Fi(pt({}, sm), { intensity: 0 }),
        },
        playback: {
          trigger: ct.sections.playback,
          start: 'top center',
          end: 'top top',
          poseFrom: { rx: 0, ry: 0, rz: 0, px: 0, py: 0, camZ: 1 },
          pose: { rx: -61, ry: -20, rz: 2, px: 0.065, py: 0.01, camZ: 0.7 },
          fitHeight: { camZ1Px: 627, designVh: 900, maxRatio: 0.92 },
        },
        playbackSpin: {
          trigger: ct.sections.scene,
          start: 'bottom top',
          endTrigger: ct.sections.playback,
          end: 'top top',
          poseEase: 'none',
          spinYFrom: 360,
          spinY: 180,
        },
        bluetooth: {
          trigger: ct.sections.bluetooth,
          start: lT,
          end: am,
          poseEase: 'none',
          poseFrom: { rx: -61, ry: -20, rz: 2, px: 0.065, py: 0.01, camZ: 0.7 },
          pose: { rx: -9, ry: 64, rz: 10, px: -0.1, py: -0.03, camZ: 1.1 },
          fitHeight: { camZ1Px: 635, designVh: 900, maxRatio: 0.92 },
          spinYFrom: 180,
          spinY: -180,
        },
        feature: {
          trigger: ct.sections.bluetooth,
          start: 'bottom top',
          end: '+=250',
          opacity: 0,
          accent1: { color: 16777215, intensity: 2.6, position: [3, 5, 3.5] },
          accent2: { color: 16777215, intensity: 1.5, position: [15, -4, -7] },
          accent3: sm,
          look: qv,
        },
        testimonial: {
          trigger: ct.sections.testimonial,
          start: 'top bottom',
          end: 'top center',
          opacity: 0,
        },
        cta: {
          trigger: ct.sections.cta,
          start: 'top bottom',
          end: 'top top',
          poseEase: 'none',
          pose: { rx: -40, ry: 152, rz: 20, px: -0.08, scale: 1, camZ: 1 },
          light: Qp,
          directionalIntensity: em,
          accent1: tm,
          accent2: im,
          accent3: nm,
          look: 0,
          fitHeight: { camZ1Px: 598, designVh: 900, maxRatio: 0.92 },
        },
        ctaIn: {
          trigger: ct.sections.cta,
          start: 'top center',
          end: '+=250',
          opacity: 1,
        },
        ctaExit: {
          trigger: ct.sections.cta,
          start: 'bottom center',
          end: '+=250',
          opacity: 0,
        },
      },
      viewer: {
        pose: { rx: 0, ry: 0, rz: 0, px: 0, py: 0, pz: 0, scale: 1, camZ: 0.9 },
        zoom: { min: 0.67, max: 0.94 },
        enterDuration: 0.6,
        resetDuration: 0.6,
        resetBoxDelay: 0.2,
        ambientIntensity: 1.9,
        reflection: {
          opacity: 0.33,
          fadeScale: 0.42,
          blur: 0.4,
          floorOffset: 0,
          footprintScale: 1.15,
          feather: 0.55,
        },
      },
    },
    uT = {
      viewer: {
        zoom: { min: 0.52, max: 0.72 },
        reflection: { fadeScale: 0.34, footprintScale: 1 },
      },
      ledGeneratorDepart: 'center',
      bluetoothDepart: 'top',
      bluetoothDepartTopRatio: Yv,
      ctaDepart: 'contents-gap',
      sceneEmergeViewportRatio: Jp,
      ledSpotlight: {
        width: 0.165,
        height: 0.097,
        offsetX: 0.011,
        offsetY: -0.08,
        shadowOffset: [-0.075, 0.1],
      },
      initial: {
        pose: { py: 0.02, camZ: 1.6 },
        fitHeight: { camZ1Px: 542, designVh: 844 },
      },
      steps: {
        introduction: {
          pose: { py: 0, camZ: 1.715 },
          fitHeight: { camZ1Px: 573, designVh: 844 },
        },
        soniclink: {
          poseFrom: { px: 0.02, py: 0.11, camZ: 1.2 },
          pose: { py: 0.085, camZ: 1.2 },
        },
        led: {
          end: 'center center',
          pose: { px: -0.025, camZ: 1.5, py: -0.03 },
          fitHeight: { camZ1Px: 427, designVh: 844 },
        },
        sceneAlign: { poseFrom: { px: -0.025 } },
        scene: {
          end: `+=${Jp * 100}%`,
          poseFrom: { px: 0, camZ: 1.5 },
          pose: { px: 0, camZ: 1.5 },
          fitHeight: { camZ1Px: 582, designVh: 844 },
        },
        sceneIn: { end: `+=${Jp * 100}%` },
        playback: {
          start: 'top 25%',
          poseFrom: { px: 0, py: 0, camZ: 1.5 },
          pose: { px: 0, py: -0.055, camZ: 1.5 },
          fitHeight: { camZ1Px: 585, designVh: 844 },
        },
        bluetooth: {
          end: `top ${Yv * 100}%`,
          poseFrom: { px: 0, py: -0.055, camZ: 1.5 },
          pose: { rx: -25, ry: 40, rz: 11, px: 0.04, py: -0.14, camZ: 1.9 },
          fitHeight: { camZ1Px: 571, designVh: 844 },
        },
        cta: {
          end: lm,
          poseFrom: { px: 0.04, camZ: 1.9 },
          pose: { px: 0, py: 0.04, camZ: 1.7 },
          fitHeight: { camZ1Px: 550, designVh: 844 },
        },
      },
    },
    Xh = (s) => typeof s == 'object' && s !== null && !Array.isArray(s),
    nx = (s, e) => {
      if (!Xh(s) || !Xh(e)) return e != null ? e : s;
      let t = pt({}, s);
      return (
        Object.keys(e).forEach((i) => {
          let n = e[i];
          if (n === void 0) return;
          let r = s[i];
          t[i] = Xh(r) && Xh(n) ? nx(r, n) : n;
        }),
        t
      );
    },
    ec = (s) => (s ? nx(Zv, uT) : Zv);
  var Wr = {
      root: 'data-loading',
      video: 'data-loading-video',
      videoIntro2: 'data-loading-video-intro2',
      videoLoop: 'data-loading-video-loop',
      bar: 'data-loading-bar',
    },
    gr = {
      active: 'is-active',
      videoFallback: 'is-video-fallback',
      bodyOpen: 'is-loading-open',
      barJs: 'is-bar-js',
    },
    tc = 'is-intro-hold',
    es = {
      posterFallbackDelayMs: 400,
      minWaitMs: 1500,
      barProgressDurationMs: 8e3,
      fadeDuration: 0.6,
      barProgressMax: 0.9,
      barCompleteDuration: 0.25,
      reentrySettleMs: 250,
      reentrySettleMaxMs: 2e3,
      reentryOpenDelayMs: 1e3,
    };
  var dT = (s) => {
      let { transform: e } = getComputedStyle(s),
        t = /matrix\(([^,]+),/.exec(e);
      if (!t) return 0;
      let i = parseFloat(t[1]);
      return Number.isFinite(i) ? Math.max(0, i) : 0;
    },
    fT = (s) =>
      new Promise((e) => {
        let t = performance.now(),
          i = window.scrollY,
          n = performance.now(),
          r = () => {
            let o = performance.now(),
              a = window.scrollY;
            a !== i && ((i = a), (n = o));
            let l = s !== null && s > 0 && a < s - window.innerHeight;
            if (
              (o - n >= es.reentrySettleMs && !l) ||
              o - t >= es.reentrySettleMaxMs
            ) {
              e();
              return;
            }
            window.requestAnimationFrame(r);
          };
        window.requestAnimationFrame(r);
      }),
    qh = class {
      constructor(e, t, i, n) {
        this.smoothScroll = e;
        this.bgVideo = t;
        this.modelReady = i;
        this.onDismissed = n;
        y(this, 'rootElm');
        y(this, 'videoElm');
        y(this, 'intro2VideoElm');
        y(this, 'loopVideoElm');
        y(this, 'currentIntroElm', null);
        y(this, 'barElm');
        y(this, 'barTween', null);
        y(this, 'isDismissed', !1);
        y(this, 'onDismissedDone', !1);
        y(this, 'isLoopPhase', !1);
        y(this, 'init', () =>
          Ns(this, null, function* () {
            var a, l;
            if (!this.videoElm || !this.intro2VideoElm || !this.loopVideoElm)
              return;
            let { videoElm: e, intro2VideoElm: t, loopVideoElm: i } = this;
            if (
              (this.smoothScroll.stop('loading'),
              this.bgVideo.hold(),
              (hdjf9Story || document.body).classList.add(gr.bodyOpen),
              Yh() || (hdjf9Story || document.body).classList.add(tc),
              (a = this.rootElm) == null || a.focus({ preventScroll: !0 }),
              document.addEventListener('focusin', this.trapFocus, !0),
              this.videoElm && this.rootElm)
            ) {
              let { videoElm: u, rootElm: f } = this,
                d = window.setTimeout(() => {
                  u.paused && f.classList.add(gr.videoFallback);
                }, es.posterFallbackDelayMs);
              u.addEventListener(
                'playing',
                () => {
                  (window.clearTimeout(d),
                    f.classList.remove(gr.videoFallback));
                },
                { once: !0 },
              );
            }
            if (
              Kp &&
              (this.takeOverBar(
                (es.reentrySettleMaxMs + es.reentryOpenDelayMs) / 1e3,
              ),
              yield fT(wa),
              Math.max(window.scrollY, (l = wa) != null ? l : 0) >
                window.innerHeight * 0.5)
            ) {
              (wa !== null &&
                Math.abs(window.scrollY - wa) > window.innerHeight &&
                window.scrollTo(0, wa),
                this.smoothScroll.syncScroll(window.scrollY),
                this.onDismissed(),
                (this.onDismissedDone = !0),
                yield Rf(es.reentryOpenDelayMs),
                this.dismiss(!0));
              return;
            }
            this.takeOverBar(es.barProgressDurationMs / 1e3);
            let n = new Promise((u) => {
                (e.addEventListener(
                  'ended',
                  () => {
                    ((t.currentTime = 0),
                      t
                        .play()
                        .then(() => {
                          (t.classList.add(gr.active),
                            e.pause(),
                            (this.currentIntroElm = t));
                        })
                        .catch(() => u()));
                  },
                  { once: !0 },
                ),
                  t.addEventListener(
                    'ended',
                    () => {
                      ((i.currentTime = 0),
                        i
                          .play()
                          .then(() => {
                            (i.classList.add(gr.active),
                              t.pause(),
                              (this.isLoopPhase = !0));
                          })
                          .catch(() => {})
                          .finally(() => u()));
                    },
                    { once: !0 },
                  ));
                let f = () => {
                  var d;
                  ((d = this.rootElm) == null ||
                    d.classList.add(gr.videoFallback),
                    u());
                };
                (e.addEventListener('error', f, { once: !0 }),
                  t.addEventListener('error', () => u(), { once: !0 }),
                  e.play().catch(f));
              }),
              r =
                document.readyState === 'complete'
                  ? Promise.resolve()
                  : new Promise((u) => {
                      window.addEventListener('load', () => u(), { once: !0 });
                    }),
              o = Rf(es.minWaitMs);
            (yield Promise.all([r, o, n, this.modelReady]), this.dismiss());
          }),
        );
        y(this, 'takeOverBar', (e) => {
          var n;
          let t = this.barElm;
          if (!t) return;
          (n = this.barTween) == null || n.kill();
          let i = dT(t);
          (t.classList.add(gr.barJs),
            Et.set(t, { scaleX: i }),
            (this.barTween = Et.to(t, {
              scaleX: es.barProgressMax,
              duration: e,
              ease: 'power2.out',
            })));
        });
        y(this, 'trapFocus', (e) => {
          let { rootElm: t } = this;
          if (!t) return;
          let i = e.target;
          (i && t.contains(i)) || t.focus({ preventScroll: !0 });
        });
        y(
          this,
          'checkElements',
          () =>
            !!(
              this.rootElm &&
              this.videoElm &&
              this.intro2VideoElm &&
              this.loopVideoElm &&
              this.barElm
            ),
        );
        y(this, 'dismiss', (e = !1) => {
          var l;
          if (this.isDismissed || !this.rootElm) return;
          this.isDismissed = !0;
          let {
            rootElm: t,
            videoElm: i,
            intro2VideoElm: n,
            loopVideoElm: r,
            barElm: o,
          } = this;
          ((l = this.barTween) == null || l.kill(),
            e && !this.onDismissedDone && this.onDismissed());
          let a = Et.timeline();
          (a.to(o, {
            scaleX: 1,
            duration: es.barCompleteDuration,
            ease: 'power1.inOut',
          }),
            a.call(() => {
              if (e) {
                this.bgVideo.release();
                return;
              }
              let c = this.isLoopPhase ? r : this.currentIntroElm;
              c && this.bgVideo.releaseFrom(c, this.isLoopPhase);
            }),
            a.to(t, {
              opacity: 0,
              duration: e ? 0.2 : es.fadeDuration,
              onComplete: () => {
                (this.smoothScroll.start('loading'),
                  (hdjf9Story || document.body).classList.remove(gr.bodyOpen),
                  document.removeEventListener('focusin', this.trapFocus, !0),
                  [i, n, r].forEach((c) => {
                    c && (c.pause(), c.removeAttribute('src'), c.load());
                  }),
                  t.remove(),
                  (this.rootElm = null),
                  (this.videoElm = null),
                  (this.intro2VideoElm = null),
                  (this.loopVideoElm = null),
                  (this.currentIntroElm = null),
                  (this.barElm = null),
                  (this.barTween = null),
                  !e && !this.onDismissedDone && this.onDismissed());
              },
            }));
        });
        ((this.rootElm = Ye(`[${Wr.root}]`)),
          (this.videoElm = this.rootElm
            ? Ye(`[${Wr.video}]`, this.rootElm)
            : null),
          (this.intro2VideoElm = this.rootElm
            ? Ye(`[${Wr.videoIntro2}]`, this.rootElm)
            : null),
          (this.loopVideoElm = this.rootElm
            ? Ye(`[${Wr.videoLoop}]`, this.rootElm)
            : null),
          (this.currentIntroElm = this.videoElm),
          (this.barElm = this.rootElm ? Ye(`[${Wr.bar}]`, this.rootElm) : null),
          this.checkElements() && this.init());
      }
    };
  var Zh = class {
    constructor() {
      let e = Ye(`[${$p.pinArea}]`),
        t = Ye(`[${$p.sticky}]`);
      if (!e || !t) return;
      let i = wo(t);
      Ao(e, t, {
        onEnter: i.enter,
        onUpdate: (n) => {
          i.applyLeave(n.progress >= Wh);
        },
        onLeaveBack: i.leaveBack,
      });
    }
  };
  var so = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 },
    ro = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 },
    Hx = 0,
    Zm = 1,
    zx = 2;
  var Nc = 1,
    Vx = 2,
    tl = 3,
    Ss = 0,
    bn = 1,
    Gi = 2,
    Qs = 0,
    Go = 1,
    Fc = 2,
    Km = 3,
    $m = 4,
    Gx = 5;
  var Jr = 100,
    Wx = 101,
    Xx = 102,
    Yx = 103,
    qx = 104,
    Zx = 200,
    Kx = 201,
    $x = 202,
    jx = 203,
    Su = 204,
    Eu = 205,
    Jx = 206,
    Qx = 207,
    ey = 208,
    ty = 209,
    iy = 210,
    ny = 211,
    sy = 212,
    ry = 213,
    oy = 214,
    Tu = 0,
    Mu = 1,
    wu = 2,
    Wo = 3,
    Au = 4,
    Ru = 5,
    Cu = 6,
    Pu = 7,
    jm = 0,
    ay = 1,
    ly = 2,
    ws = 0,
    Jm = 1,
    Qm = 2,
    eg = 3,
    tg = 4,
    ig = 5,
    ng = 6,
    sg = 7,
    Nm = 'attached',
    cy = 'detached',
    rg = 300,
    oo = 301,
    Jo = 302,
    il = 303,
    Ju = 304,
    Uc = 306,
    Qr = 1e3,
    ns = 1001,
    Va = 1002,
    bi = 1003,
    Qu = 1004;
  var Qo = 1005;
  var Si = 1006,
    nl = 1007;
  var As = 1008;
  var Ln = 1009,
    og = 1010,
    ag = 1011,
    sl = 1012,
    ed = 1013,
    Rs = 1014,
    Xn = 1015,
    er = 1016,
    td = 1017,
    id = 1018,
    rl = 1020,
    lg = 35902,
    cg = 35899,
    hg = 1021,
    ug = 1022,
    Yn = 1023,
    qs = 1026,
    ao = 1027,
    nd = 1028,
    sd = 1029,
    lo = 1030,
    rd = 1031;
  var od = 1033,
    Bc = 33776,
    kc = 33777,
    Hc = 33778,
    zc = 33779,
    ad = 35840,
    ld = 35841,
    cd = 35842,
    hd = 35843,
    ud = 36196,
    dd = 37492,
    fd = 37496,
    pd = 37488,
    md = 37489,
    Vc = 37490,
    gd = 37491,
    _d = 37808,
    vd = 37809,
    xd = 37810,
    yd = 37811,
    bd = 37812,
    Sd = 37813,
    Ed = 37814,
    Td = 37815,
    Md = 37816,
    wd = 37817,
    Ad = 37818,
    Rd = 37819,
    Cd = 37820,
    Pd = 37821,
    Ld = 36492,
    Id = 36494,
    Dd = 36495,
    Od = 36283,
    Nd = 36284,
    Gc = 36285,
    Fd = 36286;
  var Xo = 2300,
    Yo = 2301,
    bu = 2302,
    Fm = 2303,
    Um = 2400,
    Bm = 2401,
    km = 2402,
    hy = 2500;
  var dg = 0,
    Wc = 1,
    ol = 2,
    uy = 3200;
  var Ud = 0,
    dy = 1,
    Lr = '',
    zt = 'srgb',
    qi = 'srgb-linear',
    dc = 'linear',
    Kt = 'srgb';
  var Vo = 7680;
  var Hm = 519,
    fy = 512,
    py = 513,
    my = 514,
    Bd = 515,
    gy = 516,
    _y = 517,
    kd = 518,
    vy = 519,
    Lu = 35044;
  var fg = '300 es',
    ys = 2e3,
    Ga = 2001;
  function pT(s) {
    for (let e = s.length - 1; e >= 0; --e) if (s[e] >= 65535) return !0;
    return !1;
  }
  function mT(s) {
    return ArrayBuffer.isView(s) && !(s instanceof DataView);
  }
  function Wa(s) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', s);
  }
  function xy() {
    let s = Wa('canvas');
    return ((s.style.display = 'block'), s);
  }
  var sx = {},
    Xa = null;
  function fc(...s) {
    let e = 'THREE.' + s.shift();
    Xa && Xa('log', e, ...s);
  }
  function yy(s) {
    let e = s[0];
    if (typeof e == 'string' && e.startsWith('TSL:')) {
      let t = s[1];
      t && t.isStackTrace
        ? (s[0] += ' ' + t.getLocation())
        : (s[1] =
            'Stack trace not available. Enable "THREE.Node.captureStackTrace" to capture stack traces.');
    }
    return s;
  }
  function it(...s) {
    s = yy(s);
    let e = 'THREE.' + s.shift();
    if (Xa) Xa('warn', e, ...s);
    else {
      let t = s[0];
      t && t.isStackTrace;
    }
  }
  function mt(...s) {
    s = yy(s);
    let e = 'THREE.' + s.shift();
    if (Xa) Xa('error', e, ...s);
    else {
      let t = s[0];
      t && t.isStackTrace;
    }
  }
  function Iu(...s) {
    let e = s.join(' ');
    e in sx || ((sx[e] = !0), it(...s));
  }
  function by(s, e, t) {
    return new Promise(function (i, n) {
      function r() {
        switch (s.clientWaitSync(e, s.SYNC_FLUSH_COMMANDS_BIT, 0)) {
          case s.WAIT_FAILED:
            n();
            break;
          case s.TIMEOUT_EXPIRED:
            setTimeout(r, t);
            break;
          default:
            i();
        }
      }
      setTimeout(r, t);
    });
  }
  var Sy = {
      [Tu]: Mu,
      [wu]: Cu,
      [Au]: Pu,
      [Wo]: Ru,
      [Mu]: Tu,
      [Cu]: wu,
      [Pu]: Au,
      [Ru]: Wo,
    },
    Es = class {
      addEventListener(e, t) {
        this._listeners === void 0 && (this._listeners = {});
        let i = this._listeners;
        (i[e] === void 0 && (i[e] = []),
          i[e].indexOf(t) === -1 && i[e].push(t));
      }
      hasEventListener(e, t) {
        let i = this._listeners;
        return i === void 0 ? !1 : i[e] !== void 0 && i[e].indexOf(t) !== -1;
      }
      removeEventListener(e, t) {
        let i = this._listeners;
        if (i === void 0) return;
        let n = i[e];
        if (n !== void 0) {
          let r = n.indexOf(t);
          r !== -1 && n.splice(r, 1);
        }
      }
      dispatchEvent(e) {
        let t = this._listeners;
        if (t === void 0) return;
        let i = t[e.type];
        if (i !== void 0) {
          e.target = this;
          let n = i.slice(0);
          for (let r = 0, o = n.length; r < o; r++) n[r].call(this, e);
          e.target = null;
        }
      }
    },
    nn = [
      '00',
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '0a',
      '0b',
      '0c',
      '0d',
      '0e',
      '0f',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '1a',
      '1b',
      '1c',
      '1d',
      '1e',
      '1f',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
      '27',
      '28',
      '29',
      '2a',
      '2b',
      '2c',
      '2d',
      '2e',
      '2f',
      '30',
      '31',
      '32',
      '33',
      '34',
      '35',
      '36',
      '37',
      '38',
      '39',
      '3a',
      '3b',
      '3c',
      '3d',
      '3e',
      '3f',
      '40',
      '41',
      '42',
      '43',
      '44',
      '45',
      '46',
      '47',
      '48',
      '49',
      '4a',
      '4b',
      '4c',
      '4d',
      '4e',
      '4f',
      '50',
      '51',
      '52',
      '53',
      '54',
      '55',
      '56',
      '57',
      '58',
      '59',
      '5a',
      '5b',
      '5c',
      '5d',
      '5e',
      '5f',
      '60',
      '61',
      '62',
      '63',
      '64',
      '65',
      '66',
      '67',
      '68',
      '69',
      '6a',
      '6b',
      '6c',
      '6d',
      '6e',
      '6f',
      '70',
      '71',
      '72',
      '73',
      '74',
      '75',
      '76',
      '77',
      '78',
      '79',
      '7a',
      '7b',
      '7c',
      '7d',
      '7e',
      '7f',
      '80',
      '81',
      '82',
      '83',
      '84',
      '85',
      '86',
      '87',
      '88',
      '89',
      '8a',
      '8b',
      '8c',
      '8d',
      '8e',
      '8f',
      '90',
      '91',
      '92',
      '93',
      '94',
      '95',
      '96',
      '97',
      '98',
      '99',
      '9a',
      '9b',
      '9c',
      '9d',
      '9e',
      '9f',
      'a0',
      'a1',
      'a2',
      'a3',
      'a4',
      'a5',
      'a6',
      'a7',
      'a8',
      'a9',
      'aa',
      'ab',
      'ac',
      'ad',
      'ae',
      'af',
      'b0',
      'b1',
      'b2',
      'b3',
      'b4',
      'b5',
      'b6',
      'b7',
      'b8',
      'b9',
      'ba',
      'bb',
      'bc',
      'bd',
      'be',
      'bf',
      'c0',
      'c1',
      'c2',
      'c3',
      'c4',
      'c5',
      'c6',
      'c7',
      'c8',
      'c9',
      'ca',
      'cb',
      'cc',
      'cd',
      'ce',
      'cf',
      'd0',
      'd1',
      'd2',
      'd3',
      'd4',
      'd5',
      'd6',
      'd7',
      'd8',
      'd9',
      'da',
      'db',
      'dc',
      'dd',
      'de',
      'df',
      'e0',
      'e1',
      'e2',
      'e3',
      'e4',
      'e5',
      'e6',
      'e7',
      'e8',
      'e9',
      'ea',
      'eb',
      'ec',
      'ed',
      'ee',
      'ef',
      'f0',
      'f1',
      'f2',
      'f3',
      'f4',
      'f5',
      'f6',
      'f7',
      'f8',
      'f9',
      'fa',
      'fb',
      'fc',
      'fd',
      'fe',
      'ff',
    ],
    rx = 1234567,
    hc = Math.PI / 180,
    qo = 180 / Math.PI;
  function bs() {
    let s = (Math.random() * 4294967295) | 0,
      e = (Math.random() * 4294967295) | 0,
      t = (Math.random() * 4294967295) | 0,
      i = (Math.random() * 4294967295) | 0;
    return (
      nn[s & 255] +
      nn[(s >> 8) & 255] +
      nn[(s >> 16) & 255] +
      nn[(s >> 24) & 255] +
      '-' +
      nn[e & 255] +
      nn[(e >> 8) & 255] +
      '-' +
      nn[((e >> 16) & 15) | 64] +
      nn[(e >> 24) & 255] +
      '-' +
      nn[(t & 63) | 128] +
      nn[(t >> 8) & 255] +
      '-' +
      nn[(t >> 16) & 255] +
      nn[(t >> 24) & 255] +
      nn[i & 255] +
      nn[(i >> 8) & 255] +
      nn[(i >> 16) & 255] +
      nn[(i >> 24) & 255]
    ).toLowerCase();
  }
  function Dt(s, e, t) {
    return Math.max(e, Math.min(t, s));
  }
  function pg(s, e) {
    return ((s % e) + e) % e;
  }
  function gT(s, e, t, i, n) {
    return i + ((s - e) * (n - i)) / (t - e);
  }
  function _T(s, e, t) {
    return s !== e ? (t - s) / (e - s) : 0;
  }
  function uc(s, e, t) {
    return (1 - t) * s + t * e;
  }
  function vT(s, e, t, i) {
    return uc(s, e, 1 - Math.exp(-t * i));
  }
  function xT(s, e = 1) {
    return e - Math.abs(pg(s, e * 2) - e);
  }
  function yT(s, e, t) {
    return s <= e
      ? 0
      : s >= t
        ? 1
        : ((s = (s - e) / (t - e)), s * s * (3 - 2 * s));
  }
  function bT(s, e, t) {
    return s <= e
      ? 0
      : s >= t
        ? 1
        : ((s = (s - e) / (t - e)), s * s * s * (s * (s * 6 - 15) + 10));
  }
  function ST(s, e) {
    return s + Math.floor(Math.random() * (e - s + 1));
  }
  function ET(s, e) {
    return s + Math.random() * (e - s);
  }
  function TT(s) {
    return s * (0.5 - Math.random());
  }
  function MT(s) {
    s !== void 0 && (rx = s);
    let e = (rx += 1831565813);
    return (
      (e = Math.imul(e ^ (e >>> 15), e | 1)),
      (e ^= e + Math.imul(e ^ (e >>> 7), e | 61)),
      ((e ^ (e >>> 14)) >>> 0) / 4294967296
    );
  }
  function wT(s) {
    return s * hc;
  }
  function AT(s) {
    return s * qo;
  }
  function RT(s) {
    return (s & (s - 1)) === 0 && s !== 0;
  }
  function CT(s) {
    return Math.pow(2, Math.ceil(Math.log(s) / Math.LN2));
  }
  function PT(s) {
    return Math.pow(2, Math.floor(Math.log(s) / Math.LN2));
  }
  function LT(s, e, t, i, n) {
    let r = Math.cos,
      o = Math.sin,
      a = r(t / 2),
      l = o(t / 2),
      c = r((e + i) / 2),
      u = o((e + i) / 2),
      f = r((e - i) / 2),
      d = o((e - i) / 2),
      p = r((i - e) / 2),
      _ = o((i - e) / 2);
    switch (n) {
      case 'XYX':
        s.set(a * u, l * f, l * d, a * c);
        break;
      case 'YZY':
        s.set(l * d, a * u, l * f, a * c);
        break;
      case 'ZXZ':
        s.set(l * f, l * d, a * u, a * c);
        break;
      case 'XZX':
        s.set(a * u, l * _, l * p, a * c);
        break;
      case 'YXY':
        s.set(l * p, a * u, l * _, a * c);
        break;
      case 'ZYZ':
        s.set(l * _, l * p, a * u, a * c);
        break;
      default:
        it(
          'MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' +
            n,
        );
    }
  }
  function xs(s, e) {
    switch (e.constructor) {
      case Float32Array:
        return s;
      case Uint32Array:
        return s / 4294967295;
      case Uint16Array:
        return s / 65535;
      case Uint8Array:
        return s / 255;
      case Int32Array:
        return Math.max(s / 2147483647, -1);
      case Int16Array:
        return Math.max(s / 32767, -1);
      case Int8Array:
        return Math.max(s / 127, -1);
      default:
        throw new Error('Invalid component type.');
    }
  }
  function jt(s, e) {
    switch (e.constructor) {
      case Float32Array:
        return s;
      case Uint32Array:
        return Math.round(s * 4294967295);
      case Uint16Array:
        return Math.round(s * 65535);
      case Uint8Array:
        return Math.round(s * 255);
      case Int32Array:
        return Math.round(s * 2147483647);
      case Int16Array:
        return Math.round(s * 32767);
      case Int8Array:
        return Math.round(s * 127);
      default:
        throw new Error('Invalid component type.');
    }
  }
  var Vt = {
      DEG2RAD: hc,
      RAD2DEG: qo,
      generateUUID: bs,
      clamp: Dt,
      euclideanModulo: pg,
      mapLinear: gT,
      inverseLerp: _T,
      lerp: uc,
      damp: vT,
      pingpong: xT,
      smoothstep: yT,
      smootherstep: bT,
      randInt: ST,
      randFloat: ET,
      randFloatSpread: TT,
      seededRandom: MT,
      degToRad: wT,
      radToDeg: AT,
      isPowerOfTwo: RT,
      ceilPowerOfTwo: CT,
      floorPowerOfTwo: PT,
      setQuaternionFromProperEuler: LT,
      normalize: jt,
      denormalize: xs,
    },
    xg = class xg {
      constructor(e = 0, t = 0) {
        ((this.x = e), (this.y = t));
      }
      get width() {
        return this.x;
      }
      set width(e) {
        this.x = e;
      }
      get height() {
        return this.y;
      }
      set height(e) {
        this.y = e;
      }
      set(e, t) {
        return ((this.x = e), (this.y = t), this);
      }
      setScalar(e) {
        return ((this.x = e), (this.y = e), this);
      }
      setX(e) {
        return ((this.x = e), this);
      }
      setY(e) {
        return ((this.y = e), this);
      }
      setComponent(e, t) {
        switch (e) {
          case 0:
            this.x = t;
            break;
          case 1:
            this.y = t;
            break;
          default:
            throw new Error('index is out of range: ' + e);
        }
        return this;
      }
      getComponent(e) {
        switch (e) {
          case 0:
            return this.x;
          case 1:
            return this.y;
          default:
            throw new Error('index is out of range: ' + e);
        }
      }
      clone() {
        return new this.constructor(this.x, this.y);
      }
      copy(e) {
        return ((this.x = e.x), (this.y = e.y), this);
      }
      add(e) {
        return ((this.x += e.x), (this.y += e.y), this);
      }
      addScalar(e) {
        return ((this.x += e), (this.y += e), this);
      }
      addVectors(e, t) {
        return ((this.x = e.x + t.x), (this.y = e.y + t.y), this);
      }
      addScaledVector(e, t) {
        return ((this.x += e.x * t), (this.y += e.y * t), this);
      }
      sub(e) {
        return ((this.x -= e.x), (this.y -= e.y), this);
      }
      subScalar(e) {
        return ((this.x -= e), (this.y -= e), this);
      }
      subVectors(e, t) {
        return ((this.x = e.x - t.x), (this.y = e.y - t.y), this);
      }
      multiply(e) {
        return ((this.x *= e.x), (this.y *= e.y), this);
      }
      multiplyScalar(e) {
        return ((this.x *= e), (this.y *= e), this);
      }
      divide(e) {
        return ((this.x /= e.x), (this.y /= e.y), this);
      }
      divideScalar(e) {
        return this.multiplyScalar(1 / e);
      }
      applyMatrix3(e) {
        let t = this.x,
          i = this.y,
          n = e.elements;
        return (
          (this.x = n[0] * t + n[3] * i + n[6]),
          (this.y = n[1] * t + n[4] * i + n[7]),
          this
        );
      }
      min(e) {
        return (
          (this.x = Math.min(this.x, e.x)),
          (this.y = Math.min(this.y, e.y)),
          this
        );
      }
      max(e) {
        return (
          (this.x = Math.max(this.x, e.x)),
          (this.y = Math.max(this.y, e.y)),
          this
        );
      }
      clamp(e, t) {
        return (
          (this.x = Dt(this.x, e.x, t.x)),
          (this.y = Dt(this.y, e.y, t.y)),
          this
        );
      }
      clampScalar(e, t) {
        return ((this.x = Dt(this.x, e, t)), (this.y = Dt(this.y, e, t)), this);
      }
      clampLength(e, t) {
        let i = this.length();
        return this.divideScalar(i || 1).multiplyScalar(Dt(i, e, t));
      }
      floor() {
        return (
          (this.x = Math.floor(this.x)),
          (this.y = Math.floor(this.y)),
          this
        );
      }
      ceil() {
        return (
          (this.x = Math.ceil(this.x)),
          (this.y = Math.ceil(this.y)),
          this
        );
      }
      round() {
        return (
          (this.x = Math.round(this.x)),
          (this.y = Math.round(this.y)),
          this
        );
      }
      roundToZero() {
        return (
          (this.x = Math.trunc(this.x)),
          (this.y = Math.trunc(this.y)),
          this
        );
      }
      negate() {
        return ((this.x = -this.x), (this.y = -this.y), this);
      }
      dot(e) {
        return this.x * e.x + this.y * e.y;
      }
      cross(e) {
        return this.x * e.y - this.y * e.x;
      }
      lengthSq() {
        return this.x * this.x + this.y * this.y;
      }
      length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      }
      manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
      }
      normalize() {
        return this.divideScalar(this.length() || 1);
      }
      angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
      }
      angleTo(e) {
        let t = Math.sqrt(this.lengthSq() * e.lengthSq());
        if (t === 0) return Math.PI / 2;
        let i = this.dot(e) / t;
        return Math.acos(Dt(i, -1, 1));
      }
      distanceTo(e) {
        return Math.sqrt(this.distanceToSquared(e));
      }
      distanceToSquared(e) {
        let t = this.x - e.x,
          i = this.y - e.y;
        return t * t + i * i;
      }
      manhattanDistanceTo(e) {
        return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
      }
      setLength(e) {
        return this.normalize().multiplyScalar(e);
      }
      lerp(e, t) {
        return (
          (this.x += (e.x - this.x) * t),
          (this.y += (e.y - this.y) * t),
          this
        );
      }
      lerpVectors(e, t, i) {
        return (
          (this.x = e.x + (t.x - e.x) * i),
          (this.y = e.y + (t.y - e.y) * i),
          this
        );
      }
      equals(e) {
        return e.x === this.x && e.y === this.y;
      }
      fromArray(e, t = 0) {
        return ((this.x = e[t]), (this.y = e[t + 1]), this);
      }
      toArray(e = [], t = 0) {
        return ((e[t] = this.x), (e[t + 1] = this.y), e);
      }
      fromBufferAttribute(e, t) {
        return ((this.x = e.getX(t)), (this.y = e.getY(t)), this);
      }
      rotateAround(e, t) {
        let i = Math.cos(t),
          n = Math.sin(t),
          r = this.x - e.x,
          o = this.y - e.y;
        return (
          (this.x = r * i - o * n + e.x),
          (this.y = r * n + o * i + e.y),
          this
        );
      }
      random() {
        return ((this.x = Math.random()), (this.y = Math.random()), this);
      }
      *[Symbol.iterator]() {
        (yield this.x, yield this.y);
      }
    };
  xg.prototype.isVector2 = !0;
  var et = xg,
    zi = class {
      constructor(e = 0, t = 0, i = 0, n = 1) {
        ((this.isQuaternion = !0),
          (this._x = e),
          (this._y = t),
          (this._z = i),
          (this._w = n));
      }
      static slerpFlat(e, t, i, n, r, o, a) {
        let l = i[n + 0],
          c = i[n + 1],
          u = i[n + 2],
          f = i[n + 3],
          d = r[o + 0],
          p = r[o + 1],
          _ = r[o + 2],
          x = r[o + 3];
        if (f !== x || l !== d || c !== p || u !== _) {
          let g = l * d + c * p + u * _ + f * x;
          g < 0 && ((d = -d), (p = -p), (_ = -_), (x = -x), (g = -g));
          let v = 1 - a;
          if (g < 0.9995) {
            let w = Math.acos(g),
              L = Math.sin(w);
            ((v = Math.sin(v * w) / L),
              (a = Math.sin(a * w) / L),
              (l = l * v + d * a),
              (c = c * v + p * a),
              (u = u * v + _ * a),
              (f = f * v + x * a));
          } else {
            ((l = l * v + d * a),
              (c = c * v + p * a),
              (u = u * v + _ * a),
              (f = f * v + x * a));
            let w = 1 / Math.sqrt(l * l + c * c + u * u + f * f);
            ((l *= w), (c *= w), (u *= w), (f *= w));
          }
        }
        ((e[t] = l), (e[t + 1] = c), (e[t + 2] = u), (e[t + 3] = f));
      }
      static multiplyQuaternionsFlat(e, t, i, n, r, o) {
        let a = i[n],
          l = i[n + 1],
          c = i[n + 2],
          u = i[n + 3],
          f = r[o],
          d = r[o + 1],
          p = r[o + 2],
          _ = r[o + 3];
        return (
          (e[t] = a * _ + u * f + l * p - c * d),
          (e[t + 1] = l * _ + u * d + c * f - a * p),
          (e[t + 2] = c * _ + u * p + a * d - l * f),
          (e[t + 3] = u * _ - a * f - l * d - c * p),
          e
        );
      }
      get x() {
        return this._x;
      }
      set x(e) {
        ((this._x = e), this._onChangeCallback());
      }
      get y() {
        return this._y;
      }
      set y(e) {
        ((this._y = e), this._onChangeCallback());
      }
      get z() {
        return this._z;
      }
      set z(e) {
        ((this._z = e), this._onChangeCallback());
      }
      get w() {
        return this._w;
      }
      set w(e) {
        ((this._w = e), this._onChangeCallback());
      }
      set(e, t, i, n) {
        return (
          (this._x = e),
          (this._y = t),
          (this._z = i),
          (this._w = n),
          this._onChangeCallback(),
          this
        );
      }
      clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
      }
      copy(e) {
        return (
          (this._x = e.x),
          (this._y = e.y),
          (this._z = e.z),
          (this._w = e.w),
          this._onChangeCallback(),
          this
        );
      }
      setFromEuler(e, t = !0) {
        let i = e._x,
          n = e._y,
          r = e._z,
          o = e._order,
          a = Math.cos,
          l = Math.sin,
          c = a(i / 2),
          u = a(n / 2),
          f = a(r / 2),
          d = l(i / 2),
          p = l(n / 2),
          _ = l(r / 2);
        switch (o) {
          case 'XYZ':
            ((this._x = d * u * f + c * p * _),
              (this._y = c * p * f - d * u * _),
              (this._z = c * u * _ + d * p * f),
              (this._w = c * u * f - d * p * _));
            break;
          case 'YXZ':
            ((this._x = d * u * f + c * p * _),
              (this._y = c * p * f - d * u * _),
              (this._z = c * u * _ - d * p * f),
              (this._w = c * u * f + d * p * _));
            break;
          case 'ZXY':
            ((this._x = d * u * f - c * p * _),
              (this._y = c * p * f + d * u * _),
              (this._z = c * u * _ + d * p * f),
              (this._w = c * u * f - d * p * _));
            break;
          case 'ZYX':
            ((this._x = d * u * f - c * p * _),
              (this._y = c * p * f + d * u * _),
              (this._z = c * u * _ - d * p * f),
              (this._w = c * u * f + d * p * _));
            break;
          case 'YZX':
            ((this._x = d * u * f + c * p * _),
              (this._y = c * p * f + d * u * _),
              (this._z = c * u * _ - d * p * f),
              (this._w = c * u * f - d * p * _));
            break;
          case 'XZY':
            ((this._x = d * u * f - c * p * _),
              (this._y = c * p * f - d * u * _),
              (this._z = c * u * _ + d * p * f),
              (this._w = c * u * f + d * p * _));
            break;
          default:
            it(
              'Quaternion: .setFromEuler() encountered an unknown order: ' + o,
            );
        }
        return (t === !0 && this._onChangeCallback(), this);
      }
      setFromAxisAngle(e, t) {
        let i = t / 2,
          n = Math.sin(i);
        return (
          (this._x = e.x * n),
          (this._y = e.y * n),
          (this._z = e.z * n),
          (this._w = Math.cos(i)),
          this._onChangeCallback(),
          this
        );
      }
      setFromRotationMatrix(e) {
        let t = e.elements,
          i = t[0],
          n = t[4],
          r = t[8],
          o = t[1],
          a = t[5],
          l = t[9],
          c = t[2],
          u = t[6],
          f = t[10],
          d = i + a + f;
        if (d > 0) {
          let p = 0.5 / Math.sqrt(d + 1);
          ((this._w = 0.25 / p),
            (this._x = (u - l) * p),
            (this._y = (r - c) * p),
            (this._z = (o - n) * p));
        } else if (i > a && i > f) {
          let p = 2 * Math.sqrt(1 + i - a - f);
          ((this._w = (u - l) / p),
            (this._x = 0.25 * p),
            (this._y = (n + o) / p),
            (this._z = (r + c) / p));
        } else if (a > f) {
          let p = 2 * Math.sqrt(1 + a - i - f);
          ((this._w = (r - c) / p),
            (this._x = (n + o) / p),
            (this._y = 0.25 * p),
            (this._z = (l + u) / p));
        } else {
          let p = 2 * Math.sqrt(1 + f - i - a);
          ((this._w = (o - n) / p),
            (this._x = (r + c) / p),
            (this._y = (l + u) / p),
            (this._z = 0.25 * p));
        }
        return (this._onChangeCallback(), this);
      }
      setFromUnitVectors(e, t) {
        let i = e.dot(t) + 1;
        return (
          i < 1e-8
            ? ((i = 0),
              Math.abs(e.x) > Math.abs(e.z)
                ? ((this._x = -e.y),
                  (this._y = e.x),
                  (this._z = 0),
                  (this._w = i))
                : ((this._x = 0),
                  (this._y = -e.z),
                  (this._z = e.y),
                  (this._w = i)))
            : ((this._x = e.y * t.z - e.z * t.y),
              (this._y = e.z * t.x - e.x * t.z),
              (this._z = e.x * t.y - e.y * t.x),
              (this._w = i)),
          this.normalize()
        );
      }
      angleTo(e) {
        return 2 * Math.acos(Math.abs(Dt(this.dot(e), -1, 1)));
      }
      rotateTowards(e, t) {
        let i = this.angleTo(e);
        if (i === 0) return this;
        let n = Math.min(1, t / i);
        return (this.slerp(e, n), this);
      }
      identity() {
        return this.set(0, 0, 0, 1);
      }
      invert() {
        return this.conjugate();
      }
      conjugate() {
        return (
          (this._x *= -1),
          (this._y *= -1),
          (this._z *= -1),
          this._onChangeCallback(),
          this
        );
      }
      dot(e) {
        return (
          this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w
        );
      }
      lengthSq() {
        return (
          this._x * this._x +
          this._y * this._y +
          this._z * this._z +
          this._w * this._w
        );
      }
      length() {
        return Math.sqrt(
          this._x * this._x +
            this._y * this._y +
            this._z * this._z +
            this._w * this._w,
        );
      }
      normalize() {
        let e = this.length();
        return (
          e === 0
            ? ((this._x = 0), (this._y = 0), (this._z = 0), (this._w = 1))
            : ((e = 1 / e),
              (this._x = this._x * e),
              (this._y = this._y * e),
              (this._z = this._z * e),
              (this._w = this._w * e)),
          this._onChangeCallback(),
          this
        );
      }
      multiply(e) {
        return this.multiplyQuaternions(this, e);
      }
      premultiply(e) {
        return this.multiplyQuaternions(e, this);
      }
      multiplyQuaternions(e, t) {
        let i = e._x,
          n = e._y,
          r = e._z,
          o = e._w,
          a = t._x,
          l = t._y,
          c = t._z,
          u = t._w;
        return (
          (this._x = i * u + o * a + n * c - r * l),
          (this._y = n * u + o * l + r * a - i * c),
          (this._z = r * u + o * c + i * l - n * a),
          (this._w = o * u - i * a - n * l - r * c),
          this._onChangeCallback(),
          this
        );
      }
      slerp(e, t) {
        let i = e._x,
          n = e._y,
          r = e._z,
          o = e._w,
          a = this.dot(e);
        a < 0 && ((i = -i), (n = -n), (r = -r), (o = -o), (a = -a));
        let l = 1 - t;
        if (a < 0.9995) {
          let c = Math.acos(a),
            u = Math.sin(c);
          ((l = Math.sin(l * c) / u),
            (t = Math.sin(t * c) / u),
            (this._x = this._x * l + i * t),
            (this._y = this._y * l + n * t),
            (this._z = this._z * l + r * t),
            (this._w = this._w * l + o * t),
            this._onChangeCallback());
        } else
          ((this._x = this._x * l + i * t),
            (this._y = this._y * l + n * t),
            (this._z = this._z * l + r * t),
            (this._w = this._w * l + o * t),
            this.normalize());
        return this;
      }
      slerpQuaternions(e, t, i) {
        return this.copy(e).slerp(t, i);
      }
      random() {
        let e = 2 * Math.PI * Math.random(),
          t = 2 * Math.PI * Math.random(),
          i = Math.random(),
          n = Math.sqrt(1 - i),
          r = Math.sqrt(i);
        return this.set(
          n * Math.sin(e),
          n * Math.cos(e),
          r * Math.sin(t),
          r * Math.cos(t),
        );
      }
      equals(e) {
        return (
          e._x === this._x &&
          e._y === this._y &&
          e._z === this._z &&
          e._w === this._w
        );
      }
      fromArray(e, t = 0) {
        return (
          (this._x = e[t]),
          (this._y = e[t + 1]),
          (this._z = e[t + 2]),
          (this._w = e[t + 3]),
          this._onChangeCallback(),
          this
        );
      }
      toArray(e = [], t = 0) {
        return (
          (e[t] = this._x),
          (e[t + 1] = this._y),
          (e[t + 2] = this._z),
          (e[t + 3] = this._w),
          e
        );
      }
      fromBufferAttribute(e, t) {
        return (
          (this._x = e.getX(t)),
          (this._y = e.getY(t)),
          (this._z = e.getZ(t)),
          (this._w = e.getW(t)),
          this._onChangeCallback(),
          this
        );
      }
      toJSON() {
        return this.toArray();
      }
      _onChange(e) {
        return ((this._onChangeCallback = e), this);
      }
      _onChangeCallback() {}
      *[Symbol.iterator]() {
        (yield this._x, yield this._y, yield this._z, yield this._w);
      }
    },
    yg = class yg {
      constructor(e = 0, t = 0, i = 0) {
        ((this.x = e), (this.y = t), (this.z = i));
      }
      set(e, t, i) {
        return (
          i === void 0 && (i = this.z),
          (this.x = e),
          (this.y = t),
          (this.z = i),
          this
        );
      }
      setScalar(e) {
        return ((this.x = e), (this.y = e), (this.z = e), this);
      }
      setX(e) {
        return ((this.x = e), this);
      }
      setY(e) {
        return ((this.y = e), this);
      }
      setZ(e) {
        return ((this.z = e), this);
      }
      setComponent(e, t) {
        switch (e) {
          case 0:
            this.x = t;
            break;
          case 1:
            this.y = t;
            break;
          case 2:
            this.z = t;
            break;
          default:
            throw new Error('index is out of range: ' + e);
        }
        return this;
      }
      getComponent(e) {
        switch (e) {
          case 0:
            return this.x;
          case 1:
            return this.y;
          case 2:
            return this.z;
          default:
            throw new Error('index is out of range: ' + e);
        }
      }
      clone() {
        return new this.constructor(this.x, this.y, this.z);
      }
      copy(e) {
        return ((this.x = e.x), (this.y = e.y), (this.z = e.z), this);
      }
      add(e) {
        return ((this.x += e.x), (this.y += e.y), (this.z += e.z), this);
      }
      addScalar(e) {
        return ((this.x += e), (this.y += e), (this.z += e), this);
      }
      addVectors(e, t) {
        return (
          (this.x = e.x + t.x),
          (this.y = e.y + t.y),
          (this.z = e.z + t.z),
          this
        );
      }
      addScaledVector(e, t) {
        return (
          (this.x += e.x * t),
          (this.y += e.y * t),
          (this.z += e.z * t),
          this
        );
      }
      sub(e) {
        return ((this.x -= e.x), (this.y -= e.y), (this.z -= e.z), this);
      }
      subScalar(e) {
        return ((this.x -= e), (this.y -= e), (this.z -= e), this);
      }
      subVectors(e, t) {
        return (
          (this.x = e.x - t.x),
          (this.y = e.y - t.y),
          (this.z = e.z - t.z),
          this
        );
      }
      multiply(e) {
        return ((this.x *= e.x), (this.y *= e.y), (this.z *= e.z), this);
      }
      multiplyScalar(e) {
        return ((this.x *= e), (this.y *= e), (this.z *= e), this);
      }
      multiplyVectors(e, t) {
        return (
          (this.x = e.x * t.x),
          (this.y = e.y * t.y),
          (this.z = e.z * t.z),
          this
        );
      }
      applyEuler(e) {
        return this.applyQuaternion(ox.setFromEuler(e));
      }
      applyAxisAngle(e, t) {
        return this.applyQuaternion(ox.setFromAxisAngle(e, t));
      }
      applyMatrix3(e) {
        let t = this.x,
          i = this.y,
          n = this.z,
          r = e.elements;
        return (
          (this.x = r[0] * t + r[3] * i + r[6] * n),
          (this.y = r[1] * t + r[4] * i + r[7] * n),
          (this.z = r[2] * t + r[5] * i + r[8] * n),
          this
        );
      }
      applyNormalMatrix(e) {
        return this.applyMatrix3(e).normalize();
      }
      applyMatrix4(e) {
        let t = this.x,
          i = this.y,
          n = this.z,
          r = e.elements,
          o = 1 / (r[3] * t + r[7] * i + r[11] * n + r[15]);
        return (
          (this.x = (r[0] * t + r[4] * i + r[8] * n + r[12]) * o),
          (this.y = (r[1] * t + r[5] * i + r[9] * n + r[13]) * o),
          (this.z = (r[2] * t + r[6] * i + r[10] * n + r[14]) * o),
          this
        );
      }
      applyQuaternion(e) {
        let t = this.x,
          i = this.y,
          n = this.z,
          r = e.x,
          o = e.y,
          a = e.z,
          l = e.w,
          c = 2 * (o * n - a * i),
          u = 2 * (a * t - r * n),
          f = 2 * (r * i - o * t);
        return (
          (this.x = t + l * c + o * f - a * u),
          (this.y = i + l * u + a * c - r * f),
          (this.z = n + l * f + r * u - o * c),
          this
        );
      }
      project(e) {
        return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(
          e.projectionMatrix,
        );
      }
      unproject(e) {
        return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(
          e.matrixWorld,
        );
      }
      transformDirection(e) {
        let t = this.x,
          i = this.y,
          n = this.z,
          r = e.elements;
        return (
          (this.x = r[0] * t + r[4] * i + r[8] * n),
          (this.y = r[1] * t + r[5] * i + r[9] * n),
          (this.z = r[2] * t + r[6] * i + r[10] * n),
          this.normalize()
        );
      }
      divide(e) {
        return ((this.x /= e.x), (this.y /= e.y), (this.z /= e.z), this);
      }
      divideScalar(e) {
        return this.multiplyScalar(1 / e);
      }
      min(e) {
        return (
          (this.x = Math.min(this.x, e.x)),
          (this.y = Math.min(this.y, e.y)),
          (this.z = Math.min(this.z, e.z)),
          this
        );
      }
      max(e) {
        return (
          (this.x = Math.max(this.x, e.x)),
          (this.y = Math.max(this.y, e.y)),
          (this.z = Math.max(this.z, e.z)),
          this
        );
      }
      clamp(e, t) {
        return (
          (this.x = Dt(this.x, e.x, t.x)),
          (this.y = Dt(this.y, e.y, t.y)),
          (this.z = Dt(this.z, e.z, t.z)),
          this
        );
      }
      clampScalar(e, t) {
        return (
          (this.x = Dt(this.x, e, t)),
          (this.y = Dt(this.y, e, t)),
          (this.z = Dt(this.z, e, t)),
          this
        );
      }
      clampLength(e, t) {
        let i = this.length();
        return this.divideScalar(i || 1).multiplyScalar(Dt(i, e, t));
      }
      floor() {
        return (
          (this.x = Math.floor(this.x)),
          (this.y = Math.floor(this.y)),
          (this.z = Math.floor(this.z)),
          this
        );
      }
      ceil() {
        return (
          (this.x = Math.ceil(this.x)),
          (this.y = Math.ceil(this.y)),
          (this.z = Math.ceil(this.z)),
          this
        );
      }
      round() {
        return (
          (this.x = Math.round(this.x)),
          (this.y = Math.round(this.y)),
          (this.z = Math.round(this.z)),
          this
        );
      }
      roundToZero() {
        return (
          (this.x = Math.trunc(this.x)),
          (this.y = Math.trunc(this.y)),
          (this.z = Math.trunc(this.z)),
          this
        );
      }
      negate() {
        return (
          (this.x = -this.x),
          (this.y = -this.y),
          (this.z = -this.z),
          this
        );
      }
      dot(e) {
        return this.x * e.x + this.y * e.y + this.z * e.z;
      }
      lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
      }
      length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
      }
      manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
      }
      normalize() {
        return this.divideScalar(this.length() || 1);
      }
      setLength(e) {
        return this.normalize().multiplyScalar(e);
      }
      lerp(e, t) {
        return (
          (this.x += (e.x - this.x) * t),
          (this.y += (e.y - this.y) * t),
          (this.z += (e.z - this.z) * t),
          this
        );
      }
      lerpVectors(e, t, i) {
        return (
          (this.x = e.x + (t.x - e.x) * i),
          (this.y = e.y + (t.y - e.y) * i),
          (this.z = e.z + (t.z - e.z) * i),
          this
        );
      }
      cross(e) {
        return this.crossVectors(this, e);
      }
      crossVectors(e, t) {
        let i = e.x,
          n = e.y,
          r = e.z,
          o = t.x,
          a = t.y,
          l = t.z;
        return (
          (this.x = n * l - r * a),
          (this.y = r * o - i * l),
          (this.z = i * a - n * o),
          this
        );
      }
      projectOnVector(e) {
        let t = e.lengthSq();
        if (t === 0) return this.set(0, 0, 0);
        let i = e.dot(this) / t;
        return this.copy(e).multiplyScalar(i);
      }
      projectOnPlane(e) {
        return (cm.copy(this).projectOnVector(e), this.sub(cm));
      }
      reflect(e) {
        return this.sub(cm.copy(e).multiplyScalar(2 * this.dot(e)));
      }
      angleTo(e) {
        let t = Math.sqrt(this.lengthSq() * e.lengthSq());
        if (t === 0) return Math.PI / 2;
        let i = this.dot(e) / t;
        return Math.acos(Dt(i, -1, 1));
      }
      distanceTo(e) {
        return Math.sqrt(this.distanceToSquared(e));
      }
      distanceToSquared(e) {
        let t = this.x - e.x,
          i = this.y - e.y,
          n = this.z - e.z;
        return t * t + i * i + n * n;
      }
      manhattanDistanceTo(e) {
        return (
          Math.abs(this.x - e.x) +
          Math.abs(this.y - e.y) +
          Math.abs(this.z - e.z)
        );
      }
      setFromSpherical(e) {
        return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
      }
      setFromSphericalCoords(e, t, i) {
        let n = Math.sin(t) * e;
        return (
          (this.x = n * Math.sin(i)),
          (this.y = Math.cos(t) * e),
          (this.z = n * Math.cos(i)),
          this
        );
      }
      setFromCylindrical(e) {
        return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
      }
      setFromCylindricalCoords(e, t, i) {
        return (
          (this.x = e * Math.sin(t)),
          (this.y = i),
          (this.z = e * Math.cos(t)),
          this
        );
      }
      setFromMatrixPosition(e) {
        let t = e.elements;
        return ((this.x = t[12]), (this.y = t[13]), (this.z = t[14]), this);
      }
      setFromMatrixScale(e) {
        let t = this.setFromMatrixColumn(e, 0).length(),
          i = this.setFromMatrixColumn(e, 1).length(),
          n = this.setFromMatrixColumn(e, 2).length();
        return ((this.x = t), (this.y = i), (this.z = n), this);
      }
      setFromMatrixColumn(e, t) {
        return this.fromArray(e.elements, t * 4);
      }
      setFromMatrix3Column(e, t) {
        return this.fromArray(e.elements, t * 3);
      }
      setFromEuler(e) {
        return ((this.x = e._x), (this.y = e._y), (this.z = e._z), this);
      }
      setFromColor(e) {
        return ((this.x = e.r), (this.y = e.g), (this.z = e.b), this);
      }
      equals(e) {
        return e.x === this.x && e.y === this.y && e.z === this.z;
      }
      fromArray(e, t = 0) {
        return (
          (this.x = e[t]),
          (this.y = e[t + 1]),
          (this.z = e[t + 2]),
          this
        );
      }
      toArray(e = [], t = 0) {
        return ((e[t] = this.x), (e[t + 1] = this.y), (e[t + 2] = this.z), e);
      }
      fromBufferAttribute(e, t) {
        return (
          (this.x = e.getX(t)),
          (this.y = e.getY(t)),
          (this.z = e.getZ(t)),
          this
        );
      }
      random() {
        return (
          (this.x = Math.random()),
          (this.y = Math.random()),
          (this.z = Math.random()),
          this
        );
      }
      randomDirection() {
        let e = Math.random() * Math.PI * 2,
          t = Math.random() * 2 - 1,
          i = Math.sqrt(1 - t * t);
        return (
          (this.x = i * Math.cos(e)),
          (this.y = t),
          (this.z = i * Math.sin(e)),
          this
        );
      }
      *[Symbol.iterator]() {
        (yield this.x, yield this.y, yield this.z);
      }
    };
  yg.prototype.isVector3 = !0;
  var te = yg,
    cm = new te(),
    ox = new zi(),
    bg = class bg {
      constructor(e, t, i, n, r, o, a, l, c) {
        ((this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1]),
          e !== void 0 && this.set(e, t, i, n, r, o, a, l, c));
      }
      set(e, t, i, n, r, o, a, l, c) {
        let u = this.elements;
        return (
          (u[0] = e),
          (u[1] = n),
          (u[2] = a),
          (u[3] = t),
          (u[4] = r),
          (u[5] = l),
          (u[6] = i),
          (u[7] = o),
          (u[8] = c),
          this
        );
      }
      identity() {
        return (this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this);
      }
      copy(e) {
        let t = this.elements,
          i = e.elements;
        return (
          (t[0] = i[0]),
          (t[1] = i[1]),
          (t[2] = i[2]),
          (t[3] = i[3]),
          (t[4] = i[4]),
          (t[5] = i[5]),
          (t[6] = i[6]),
          (t[7] = i[7]),
          (t[8] = i[8]),
          this
        );
      }
      extractBasis(e, t, i) {
        return (
          e.setFromMatrix3Column(this, 0),
          t.setFromMatrix3Column(this, 1),
          i.setFromMatrix3Column(this, 2),
          this
        );
      }
      setFromMatrix4(e) {
        let t = e.elements;
        return (
          this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]),
          this
        );
      }
      multiply(e) {
        return this.multiplyMatrices(this, e);
      }
      premultiply(e) {
        return this.multiplyMatrices(e, this);
      }
      multiplyMatrices(e, t) {
        let i = e.elements,
          n = t.elements,
          r = this.elements,
          o = i[0],
          a = i[3],
          l = i[6],
          c = i[1],
          u = i[4],
          f = i[7],
          d = i[2],
          p = i[5],
          _ = i[8],
          x = n[0],
          g = n[3],
          v = n[6],
          w = n[1],
          L = n[4],
          R = n[7],
          U = n[2],
          O = n[5],
          N = n[8];
        return (
          (r[0] = o * x + a * w + l * U),
          (r[3] = o * g + a * L + l * O),
          (r[6] = o * v + a * R + l * N),
          (r[1] = c * x + u * w + f * U),
          (r[4] = c * g + u * L + f * O),
          (r[7] = c * v + u * R + f * N),
          (r[2] = d * x + p * w + _ * U),
          (r[5] = d * g + p * L + _ * O),
          (r[8] = d * v + p * R + _ * N),
          this
        );
      }
      multiplyScalar(e) {
        let t = this.elements;
        return (
          (t[0] *= e),
          (t[3] *= e),
          (t[6] *= e),
          (t[1] *= e),
          (t[4] *= e),
          (t[7] *= e),
          (t[2] *= e),
          (t[5] *= e),
          (t[8] *= e),
          this
        );
      }
      determinant() {
        let e = this.elements,
          t = e[0],
          i = e[1],
          n = e[2],
          r = e[3],
          o = e[4],
          a = e[5],
          l = e[6],
          c = e[7],
          u = e[8];
        return (
          t * o * u - t * a * c - i * r * u + i * a * l + n * r * c - n * o * l
        );
      }
      invert() {
        let e = this.elements,
          t = e[0],
          i = e[1],
          n = e[2],
          r = e[3],
          o = e[4],
          a = e[5],
          l = e[6],
          c = e[7],
          u = e[8],
          f = u * o - a * c,
          d = a * l - u * r,
          p = c * r - o * l,
          _ = t * f + i * d + n * p;
        if (_ === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let x = 1 / _;
        return (
          (e[0] = f * x),
          (e[1] = (n * c - u * i) * x),
          (e[2] = (a * i - n * o) * x),
          (e[3] = d * x),
          (e[4] = (u * t - n * l) * x),
          (e[5] = (n * r - a * t) * x),
          (e[6] = p * x),
          (e[7] = (i * l - c * t) * x),
          (e[8] = (o * t - i * r) * x),
          this
        );
      }
      transpose() {
        let e,
          t = this.elements;
        return (
          (e = t[1]),
          (t[1] = t[3]),
          (t[3] = e),
          (e = t[2]),
          (t[2] = t[6]),
          (t[6] = e),
          (e = t[5]),
          (t[5] = t[7]),
          (t[7] = e),
          this
        );
      }
      getNormalMatrix(e) {
        return this.setFromMatrix4(e).invert().transpose();
      }
      transposeIntoArray(e) {
        let t = this.elements;
        return (
          (e[0] = t[0]),
          (e[1] = t[3]),
          (e[2] = t[6]),
          (e[3] = t[1]),
          (e[4] = t[4]),
          (e[5] = t[7]),
          (e[6] = t[2]),
          (e[7] = t[5]),
          (e[8] = t[8]),
          this
        );
      }
      setUvTransform(e, t, i, n, r, o, a) {
        let l = Math.cos(r),
          c = Math.sin(r);
        return (
          this.set(
            i * l,
            i * c,
            -i * (l * o + c * a) + o + e,
            -n * c,
            n * l,
            -n * (-c * o + l * a) + a + t,
            0,
            0,
            1,
          ),
          this
        );
      }
      scale(e, t) {
        return (this.premultiply(hm.makeScale(e, t)), this);
      }
      rotate(e) {
        return (this.premultiply(hm.makeRotation(-e)), this);
      }
      translate(e, t) {
        return (this.premultiply(hm.makeTranslation(e, t)), this);
      }
      makeTranslation(e, t) {
        return (
          e.isVector2
            ? this.set(1, 0, e.x, 0, 1, e.y, 0, 0, 1)
            : this.set(1, 0, e, 0, 1, t, 0, 0, 1),
          this
        );
      }
      makeRotation(e) {
        let t = Math.cos(e),
          i = Math.sin(e);
        return (this.set(t, -i, 0, i, t, 0, 0, 0, 1), this);
      }
      makeScale(e, t) {
        return (this.set(e, 0, 0, 0, t, 0, 0, 0, 1), this);
      }
      equals(e) {
        let t = this.elements,
          i = e.elements;
        for (let n = 0; n < 9; n++) if (t[n] !== i[n]) return !1;
        return !0;
      }
      fromArray(e, t = 0) {
        for (let i = 0; i < 9; i++) this.elements[i] = e[i + t];
        return this;
      }
      toArray(e = [], t = 0) {
        let i = this.elements;
        return (
          (e[t] = i[0]),
          (e[t + 1] = i[1]),
          (e[t + 2] = i[2]),
          (e[t + 3] = i[3]),
          (e[t + 4] = i[4]),
          (e[t + 5] = i[5]),
          (e[t + 6] = i[6]),
          (e[t + 7] = i[7]),
          (e[t + 8] = i[8]),
          e
        );
      }
      clone() {
        return new this.constructor().fromArray(this.elements);
      }
    };
  bg.prototype.isMatrix3 = !0;
  var St = bg,
    hm = new St(),
    ax = new St().set(
      0.4123908,
      0.3575843,
      0.1804808,
      0.212639,
      0.7151687,
      0.0721923,
      0.0193308,
      0.1191948,
      0.9505322,
    ),
    lx = new St().set(
      3.2409699,
      -1.5373832,
      -0.4986108,
      -0.9692436,
      1.8759675,
      0.0415551,
      0.0556301,
      -0.203977,
      1.0569715,
    );
  function IT() {
    let s = {
        enabled: !0,
        workingColorSpace: qi,
        spaces: {},
        convert: function (n, r, o) {
          return (
            this.enabled === !1 ||
              r === o ||
              !r ||
              !o ||
              (this.spaces[r].transfer === Kt &&
                ((n.r = Er(n.r)), (n.g = Er(n.g)), (n.b = Er(n.b))),
              this.spaces[r].primaries !== this.spaces[o].primaries &&
                (n.applyMatrix3(this.spaces[r].toXYZ),
                n.applyMatrix3(this.spaces[o].fromXYZ)),
              this.spaces[o].transfer === Kt &&
                ((n.r = za(n.r)), (n.g = za(n.g)), (n.b = za(n.b)))),
            n
          );
        },
        workingToColorSpace: function (n, r) {
          return this.convert(n, this.workingColorSpace, r);
        },
        colorSpaceToWorking: function (n, r) {
          return this.convert(n, r, this.workingColorSpace);
        },
        getPrimaries: function (n) {
          return this.spaces[n].primaries;
        },
        getTransfer: function (n) {
          return n === Lr ? dc : this.spaces[n].transfer;
        },
        getToneMappingMode: function (n) {
          return (
            this.spaces[n].outputColorSpaceConfig.toneMappingMode || 'standard'
          );
        },
        getLuminanceCoefficients: function (n, r = this.workingColorSpace) {
          return n.fromArray(this.spaces[r].luminanceCoefficients);
        },
        define: function (n) {
          Object.assign(this.spaces, n);
        },
        _getMatrix: function (n, r, o) {
          return n.copy(this.spaces[r].toXYZ).multiply(this.spaces[o].fromXYZ);
        },
        _getDrawingBufferColorSpace: function (n) {
          return this.spaces[n].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function (n = this.workingColorSpace) {
          return this.spaces[n].workingColorSpaceConfig.unpackColorSpace;
        },
        fromWorkingColorSpace: function (n, r) {
          return (
            Iu(
              'ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().',
            ),
            s.workingToColorSpace(n, r)
          );
        },
        toWorkingColorSpace: function (n, r) {
          return (
            Iu(
              'ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().',
            ),
            s.colorSpaceToWorking(n, r)
          );
        },
      },
      e = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06],
      t = [0.2126, 0.7152, 0.0722],
      i = [0.3127, 0.329];
    return (
      s.define({
        [qi]: {
          primaries: e,
          whitePoint: i,
          transfer: dc,
          toXYZ: ax,
          fromXYZ: lx,
          luminanceCoefficients: t,
          workingColorSpaceConfig: { unpackColorSpace: zt },
          outputColorSpaceConfig: { drawingBufferColorSpace: zt },
        },
        [zt]: {
          primaries: e,
          whitePoint: i,
          transfer: Kt,
          toXYZ: ax,
          fromXYZ: lx,
          luminanceCoefficients: t,
          outputColorSpaceConfig: { drawingBufferColorSpace: zt },
        },
      }),
      s
    );
  }
  var Ct = IT();
  function Er(s) {
    return s < 0.04045
      ? s * 0.0773993808
      : Math.pow(s * 0.9478672986 + 0.0521327014, 2.4);
  }
  function za(s) {
    return s < 0.0031308 ? s * 12.92 : 1.055 * Math.pow(s, 0.41666) - 0.055;
  }
  var Aa,
    Du = class {
      static getDataURL(e, t = 'image/png') {
        if (/^data:/i.test(e.src) || typeof HTMLCanvasElement == 'undefined')
          return e.src;
        let i;
        if (e instanceof HTMLCanvasElement) i = e;
        else {
          (Aa === void 0 && (Aa = Wa('canvas')),
            (Aa.width = e.width),
            (Aa.height = e.height));
          let n = Aa.getContext('2d');
          (e instanceof ImageData
            ? n.putImageData(e, 0, 0)
            : n.drawImage(e, 0, 0, e.width, e.height),
            (i = Aa));
        }
        return i.toDataURL(t);
      }
      static sRGBToLinear(e) {
        if (
          (typeof HTMLImageElement != 'undefined' &&
            e instanceof HTMLImageElement) ||
          (typeof HTMLCanvasElement != 'undefined' &&
            e instanceof HTMLCanvasElement) ||
          (typeof ImageBitmap != 'undefined' && e instanceof ImageBitmap)
        ) {
          let t = Wa('canvas');
          ((t.width = e.width), (t.height = e.height));
          let i = t.getContext('2d');
          i.drawImage(e, 0, 0, e.width, e.height);
          let n = i.getImageData(0, 0, e.width, e.height),
            r = n.data;
          for (let o = 0; o < r.length; o++) r[o] = Er(r[o] / 255) * 255;
          return (i.putImageData(n, 0, 0), t);
        } else if (e.data) {
          let t = e.data.slice(0);
          for (let i = 0; i < t.length; i++)
            t instanceof Uint8Array || t instanceof Uint8ClampedArray
              ? (t[i] = Math.floor(Er(t[i] / 255) * 255))
              : (t[i] = Er(t[i]));
          return { data: t, width: e.width, height: e.height };
        } else
          return (
            it(
              'ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.',
            ),
            e
          );
      }
    },
    DT = 0,
    Ya = class {
      constructor(e = null) {
        ((this.isSource = !0),
          Object.defineProperty(this, 'id', { value: DT++ }),
          (this.uuid = bs()),
          (this.data = e),
          (this.dataReady = !0),
          (this.version = 0));
      }
      getSize(e) {
        let t = this.data;
        return (
          typeof HTMLVideoElement != 'undefined' &&
          t instanceof HTMLVideoElement
            ? e.set(t.videoWidth, t.videoHeight, 0)
            : typeof VideoFrame != 'undefined' && t instanceof VideoFrame
              ? e.set(t.displayWidth, t.displayHeight, 0)
              : t !== null
                ? e.set(t.width, t.height, t.depth || 0)
                : e.set(0, 0, 0),
          e
        );
      }
      set needsUpdate(e) {
        e === !0 && this.version++;
      }
      toJSON(e) {
        let t = e === void 0 || typeof e == 'string';
        if (!t && e.images[this.uuid] !== void 0) return e.images[this.uuid];
        let i = { uuid: this.uuid, url: '' },
          n = this.data;
        if (n !== null) {
          let r;
          if (Array.isArray(n)) {
            r = [];
            for (let o = 0, a = n.length; o < a; o++)
              n[o].isDataTexture ? r.push(um(n[o].image)) : r.push(um(n[o]));
          } else r = um(n);
          i.url = r;
        }
        return (t || (e.images[this.uuid] = i), i);
      }
    };
  function um(s) {
    return (typeof HTMLImageElement != 'undefined' &&
      s instanceof HTMLImageElement) ||
      (typeof HTMLCanvasElement != 'undefined' &&
        s instanceof HTMLCanvasElement) ||
      (typeof ImageBitmap != 'undefined' && s instanceof ImageBitmap)
      ? Du.getDataURL(s)
      : s.data
        ? {
            data: Array.from(s.data),
            width: s.width,
            height: s.height,
            type: s.data.constructor.name,
          }
        : (it('Texture: Unable to serialize Texture.'), {});
  }
  var OT = 0,
    dm = new te(),
    Li = class s extends Es {
      constructor(
        e = s.DEFAULT_IMAGE,
        t = s.DEFAULT_MAPPING,
        i = ns,
        n = ns,
        r = Si,
        o = As,
        a = Yn,
        l = Ln,
        c = s.DEFAULT_ANISOTROPY,
        u = Lr,
      ) {
        (super(),
          (this.isTexture = !0),
          Object.defineProperty(this, 'id', { value: OT++ }),
          (this.uuid = bs()),
          (this.name = ''),
          (this.source = new Ya(e)),
          (this.mipmaps = []),
          (this.mapping = t),
          (this.channel = 0),
          (this.wrapS = i),
          (this.wrapT = n),
          (this.magFilter = r),
          (this.minFilter = o),
          (this.anisotropy = c),
          (this.format = a),
          (this.internalFormat = null),
          (this.type = l),
          (this.offset = new et(0, 0)),
          (this.repeat = new et(1, 1)),
          (this.center = new et(0, 0)),
          (this.rotation = 0),
          (this.matrixAutoUpdate = !0),
          (this.matrix = new St()),
          (this.generateMipmaps = !0),
          (this.premultiplyAlpha = !1),
          (this.flipY = !0),
          (this.unpackAlignment = 4),
          (this.colorSpace = u),
          (this.userData = {}),
          (this.updateRanges = []),
          (this.version = 0),
          (this.onUpdate = null),
          (this.renderTarget = null),
          (this.isRenderTargetTexture = !1),
          (this.isArrayTexture = !!(e && e.depth && e.depth > 1)),
          (this.pmremVersion = 0),
          (this.normalized = !1));
      }
      get width() {
        return this.source.getSize(dm).x;
      }
      get height() {
        return this.source.getSize(dm).y;
      }
      get depth() {
        return this.source.getSize(dm).z;
      }
      get image() {
        return this.source.data;
      }
      set image(e) {
        this.source.data = e;
      }
      updateMatrix() {
        this.matrix.setUvTransform(
          this.offset.x,
          this.offset.y,
          this.repeat.x,
          this.repeat.y,
          this.rotation,
          this.center.x,
          this.center.y,
        );
      }
      addUpdateRange(e, t) {
        this.updateRanges.push({ start: e, count: t });
      }
      clearUpdateRanges() {
        this.updateRanges.length = 0;
      }
      clone() {
        return new this.constructor().copy(this);
      }
      copy(e) {
        return (
          (this.name = e.name),
          (this.source = e.source),
          (this.mipmaps = e.mipmaps.slice(0)),
          (this.mapping = e.mapping),
          (this.channel = e.channel),
          (this.wrapS = e.wrapS),
          (this.wrapT = e.wrapT),
          (this.magFilter = e.magFilter),
          (this.minFilter = e.minFilter),
          (this.anisotropy = e.anisotropy),
          (this.format = e.format),
          (this.internalFormat = e.internalFormat),
          (this.type = e.type),
          (this.normalized = e.normalized),
          this.offset.copy(e.offset),
          this.repeat.copy(e.repeat),
          this.center.copy(e.center),
          (this.rotation = e.rotation),
          (this.matrixAutoUpdate = e.matrixAutoUpdate),
          this.matrix.copy(e.matrix),
          (this.generateMipmaps = e.generateMipmaps),
          (this.premultiplyAlpha = e.premultiplyAlpha),
          (this.flipY = e.flipY),
          (this.unpackAlignment = e.unpackAlignment),
          (this.colorSpace = e.colorSpace),
          (this.renderTarget = e.renderTarget),
          (this.isRenderTargetTexture = e.isRenderTargetTexture),
          (this.isArrayTexture = e.isArrayTexture),
          (this.userData = JSON.parse(JSON.stringify(e.userData))),
          (this.needsUpdate = !0),
          this
        );
      }
      setValues(e) {
        for (let t in e) {
          let i = e[t];
          if (i === void 0) {
            it(`Texture.setValues(): parameter '${t}' has value of undefined.`);
            continue;
          }
          let n = this[t];
          if (n === void 0) {
            it(`Texture.setValues(): property '${t}' does not exist.`);
            continue;
          }
          (n && i && n.isVector2 && i.isVector2) ||
          (n && i && n.isVector3 && i.isVector3) ||
          (n && i && n.isMatrix3 && i.isMatrix3)
            ? n.copy(i)
            : (this[t] = i);
        }
      }
      toJSON(e) {
        let t = e === void 0 || typeof e == 'string';
        if (!t && e.textures[this.uuid] !== void 0)
          return e.textures[this.uuid];
        let i = {
          metadata: {
            version: 4.7,
            type: 'Texture',
            generator: 'Texture.toJSON',
          },
          uuid: this.uuid,
          name: this.name,
          image: this.source.toJSON(e).uuid,
          mapping: this.mapping,
          channel: this.channel,
          repeat: [this.repeat.x, this.repeat.y],
          offset: [this.offset.x, this.offset.y],
          center: [this.center.x, this.center.y],
          rotation: this.rotation,
          wrap: [this.wrapS, this.wrapT],
          format: this.format,
          internalFormat: this.internalFormat,
          type: this.type,
          normalized: this.normalized,
          colorSpace: this.colorSpace,
          minFilter: this.minFilter,
          magFilter: this.magFilter,
          anisotropy: this.anisotropy,
          flipY: this.flipY,
          generateMipmaps: this.generateMipmaps,
          premultiplyAlpha: this.premultiplyAlpha,
          unpackAlignment: this.unpackAlignment,
        };
        return (
          Object.keys(this.userData).length > 0 && (i.userData = this.userData),
          t || (e.textures[this.uuid] = i),
          i
        );
      }
      dispose() {
        this.dispatchEvent({ type: 'dispose' });
      }
      transformUv(e) {
        if (this.mapping !== rg) return e;
        if ((e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1))
          switch (this.wrapS) {
            case Qr:
              e.x = e.x - Math.floor(e.x);
              break;
            case ns:
              e.x = e.x < 0 ? 0 : 1;
              break;
            case Va:
              Math.abs(Math.floor(e.x) % 2) === 1
                ? (e.x = Math.ceil(e.x) - e.x)
                : (e.x = e.x - Math.floor(e.x));
              break;
          }
        if (e.y < 0 || e.y > 1)
          switch (this.wrapT) {
            case Qr:
              e.y = e.y - Math.floor(e.y);
              break;
            case ns:
              e.y = e.y < 0 ? 0 : 1;
              break;
            case Va:
              Math.abs(Math.floor(e.y) % 2) === 1
                ? (e.y = Math.ceil(e.y) - e.y)
                : (e.y = e.y - Math.floor(e.y));
              break;
          }
        return (this.flipY && (e.y = 1 - e.y), e);
      }
      set needsUpdate(e) {
        e === !0 && (this.version++, (this.source.needsUpdate = !0));
      }
      set needsPMREMUpdate(e) {
        e === !0 && this.pmremVersion++;
      }
    };
  Li.DEFAULT_IMAGE = null;
  Li.DEFAULT_MAPPING = rg;
  Li.DEFAULT_ANISOTROPY = 1;
  var Sg = class Sg {
    constructor(e = 0, t = 0, i = 0, n = 1) {
      ((this.x = e), (this.y = t), (this.z = i), (this.w = n));
    }
    get width() {
      return this.z;
    }
    set width(e) {
      this.z = e;
    }
    get height() {
      return this.w;
    }
    set height(e) {
      this.w = e;
    }
    set(e, t, i, n) {
      return ((this.x = e), (this.y = t), (this.z = i), (this.w = n), this);
    }
    setScalar(e) {
      return ((this.x = e), (this.y = e), (this.z = e), (this.w = e), this);
    }
    setX(e) {
      return ((this.x = e), this);
    }
    setY(e) {
      return ((this.y = e), this);
    }
    setZ(e) {
      return ((this.z = e), this);
    }
    setW(e) {
      return ((this.w = e), this);
    }
    setComponent(e, t) {
      switch (e) {
        case 0:
          this.x = t;
          break;
        case 1:
          this.y = t;
          break;
        case 2:
          this.z = t;
          break;
        case 3:
          this.w = t;
          break;
        default:
          throw new Error('index is out of range: ' + e);
      }
      return this;
    }
    getComponent(e) {
      switch (e) {
        case 0:
          return this.x;
        case 1:
          return this.y;
        case 2:
          return this.z;
        case 3:
          return this.w;
        default:
          throw new Error('index is out of range: ' + e);
      }
    }
    clone() {
      return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(e) {
      return (
        (this.x = e.x),
        (this.y = e.y),
        (this.z = e.z),
        (this.w = e.w !== void 0 ? e.w : 1),
        this
      );
    }
    add(e) {
      return (
        (this.x += e.x),
        (this.y += e.y),
        (this.z += e.z),
        (this.w += e.w),
        this
      );
    }
    addScalar(e) {
      return ((this.x += e), (this.y += e), (this.z += e), (this.w += e), this);
    }
    addVectors(e, t) {
      return (
        (this.x = e.x + t.x),
        (this.y = e.y + t.y),
        (this.z = e.z + t.z),
        (this.w = e.w + t.w),
        this
      );
    }
    addScaledVector(e, t) {
      return (
        (this.x += e.x * t),
        (this.y += e.y * t),
        (this.z += e.z * t),
        (this.w += e.w * t),
        this
      );
    }
    sub(e) {
      return (
        (this.x -= e.x),
        (this.y -= e.y),
        (this.z -= e.z),
        (this.w -= e.w),
        this
      );
    }
    subScalar(e) {
      return ((this.x -= e), (this.y -= e), (this.z -= e), (this.w -= e), this);
    }
    subVectors(e, t) {
      return (
        (this.x = e.x - t.x),
        (this.y = e.y - t.y),
        (this.z = e.z - t.z),
        (this.w = e.w - t.w),
        this
      );
    }
    multiply(e) {
      return (
        (this.x *= e.x),
        (this.y *= e.y),
        (this.z *= e.z),
        (this.w *= e.w),
        this
      );
    }
    multiplyScalar(e) {
      return ((this.x *= e), (this.y *= e), (this.z *= e), (this.w *= e), this);
    }
    applyMatrix4(e) {
      let t = this.x,
        i = this.y,
        n = this.z,
        r = this.w,
        o = e.elements;
      return (
        (this.x = o[0] * t + o[4] * i + o[8] * n + o[12] * r),
        (this.y = o[1] * t + o[5] * i + o[9] * n + o[13] * r),
        (this.z = o[2] * t + o[6] * i + o[10] * n + o[14] * r),
        (this.w = o[3] * t + o[7] * i + o[11] * n + o[15] * r),
        this
      );
    }
    divide(e) {
      return (
        (this.x /= e.x),
        (this.y /= e.y),
        (this.z /= e.z),
        (this.w /= e.w),
        this
      );
    }
    divideScalar(e) {
      return this.multiplyScalar(1 / e);
    }
    setAxisAngleFromQuaternion(e) {
      this.w = 2 * Math.acos(e.w);
      let t = Math.sqrt(1 - e.w * e.w);
      return (
        t < 1e-4
          ? ((this.x = 1), (this.y = 0), (this.z = 0))
          : ((this.x = e.x / t), (this.y = e.y / t), (this.z = e.z / t)),
        this
      );
    }
    setAxisAngleFromRotationMatrix(e) {
      let t,
        i,
        n,
        r,
        l = e.elements,
        c = l[0],
        u = l[4],
        f = l[8],
        d = l[1],
        p = l[5],
        _ = l[9],
        x = l[2],
        g = l[6],
        v = l[10];
      if (
        Math.abs(u - d) < 0.01 &&
        Math.abs(f - x) < 0.01 &&
        Math.abs(_ - g) < 0.01
      ) {
        if (
          Math.abs(u + d) < 0.1 &&
          Math.abs(f + x) < 0.1 &&
          Math.abs(_ + g) < 0.1 &&
          Math.abs(c + p + v - 3) < 0.1
        )
          return (this.set(1, 0, 0, 0), this);
        t = Math.PI;
        let L = (c + 1) / 2,
          R = (p + 1) / 2,
          U = (v + 1) / 2,
          O = (u + d) / 4,
          N = (f + x) / 4,
          M = (_ + g) / 4;
        return (
          L > R && L > U
            ? L < 0.01
              ? ((i = 0), (n = 0.707106781), (r = 0.707106781))
              : ((i = Math.sqrt(L)), (n = O / i), (r = N / i))
            : R > U
              ? R < 0.01
                ? ((i = 0.707106781), (n = 0), (r = 0.707106781))
                : ((n = Math.sqrt(R)), (i = O / n), (r = M / n))
              : U < 0.01
                ? ((i = 0.707106781), (n = 0.707106781), (r = 0))
                : ((r = Math.sqrt(U)), (i = N / r), (n = M / r)),
          this.set(i, n, r, t),
          this
        );
      }
      let w = Math.sqrt(
        (g - _) * (g - _) + (f - x) * (f - x) + (d - u) * (d - u),
      );
      return (
        Math.abs(w) < 0.001 && (w = 1),
        (this.x = (g - _) / w),
        (this.y = (f - x) / w),
        (this.z = (d - u) / w),
        (this.w = Math.acos((c + p + v - 1) / 2)),
        this
      );
    }
    setFromMatrixPosition(e) {
      let t = e.elements;
      return (
        (this.x = t[12]),
        (this.y = t[13]),
        (this.z = t[14]),
        (this.w = t[15]),
        this
      );
    }
    min(e) {
      return (
        (this.x = Math.min(this.x, e.x)),
        (this.y = Math.min(this.y, e.y)),
        (this.z = Math.min(this.z, e.z)),
        (this.w = Math.min(this.w, e.w)),
        this
      );
    }
    max(e) {
      return (
        (this.x = Math.max(this.x, e.x)),
        (this.y = Math.max(this.y, e.y)),
        (this.z = Math.max(this.z, e.z)),
        (this.w = Math.max(this.w, e.w)),
        this
      );
    }
    clamp(e, t) {
      return (
        (this.x = Dt(this.x, e.x, t.x)),
        (this.y = Dt(this.y, e.y, t.y)),
        (this.z = Dt(this.z, e.z, t.z)),
        (this.w = Dt(this.w, e.w, t.w)),
        this
      );
    }
    clampScalar(e, t) {
      return (
        (this.x = Dt(this.x, e, t)),
        (this.y = Dt(this.y, e, t)),
        (this.z = Dt(this.z, e, t)),
        (this.w = Dt(this.w, e, t)),
        this
      );
    }
    clampLength(e, t) {
      let i = this.length();
      return this.divideScalar(i || 1).multiplyScalar(Dt(i, e, t));
    }
    floor() {
      return (
        (this.x = Math.floor(this.x)),
        (this.y = Math.floor(this.y)),
        (this.z = Math.floor(this.z)),
        (this.w = Math.floor(this.w)),
        this
      );
    }
    ceil() {
      return (
        (this.x = Math.ceil(this.x)),
        (this.y = Math.ceil(this.y)),
        (this.z = Math.ceil(this.z)),
        (this.w = Math.ceil(this.w)),
        this
      );
    }
    round() {
      return (
        (this.x = Math.round(this.x)),
        (this.y = Math.round(this.y)),
        (this.z = Math.round(this.z)),
        (this.w = Math.round(this.w)),
        this
      );
    }
    roundToZero() {
      return (
        (this.x = Math.trunc(this.x)),
        (this.y = Math.trunc(this.y)),
        (this.z = Math.trunc(this.z)),
        (this.w = Math.trunc(this.w)),
        this
      );
    }
    negate() {
      return (
        (this.x = -this.x),
        (this.y = -this.y),
        (this.z = -this.z),
        (this.w = -this.w),
        this
      );
    }
    dot(e) {
      return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
    }
    lengthSq() {
      return (
        this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w
      );
    }
    length() {
      return Math.sqrt(
        this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w,
      );
    }
    manhattanLength() {
      return (
        Math.abs(this.x) +
        Math.abs(this.y) +
        Math.abs(this.z) +
        Math.abs(this.w)
      );
    }
    normalize() {
      return this.divideScalar(this.length() || 1);
    }
    setLength(e) {
      return this.normalize().multiplyScalar(e);
    }
    lerp(e, t) {
      return (
        (this.x += (e.x - this.x) * t),
        (this.y += (e.y - this.y) * t),
        (this.z += (e.z - this.z) * t),
        (this.w += (e.w - this.w) * t),
        this
      );
    }
    lerpVectors(e, t, i) {
      return (
        (this.x = e.x + (t.x - e.x) * i),
        (this.y = e.y + (t.y - e.y) * i),
        (this.z = e.z + (t.z - e.z) * i),
        (this.w = e.w + (t.w - e.w) * i),
        this
      );
    }
    equals(e) {
      return (
        e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w
      );
    }
    fromArray(e, t = 0) {
      return (
        (this.x = e[t]),
        (this.y = e[t + 1]),
        (this.z = e[t + 2]),
        (this.w = e[t + 3]),
        this
      );
    }
    toArray(e = [], t = 0) {
      return (
        (e[t] = this.x),
        (e[t + 1] = this.y),
        (e[t + 2] = this.z),
        (e[t + 3] = this.w),
        e
      );
    }
    fromBufferAttribute(e, t) {
      return (
        (this.x = e.getX(t)),
        (this.y = e.getY(t)),
        (this.z = e.getZ(t)),
        (this.w = e.getW(t)),
        this
      );
    }
    random() {
      return (
        (this.x = Math.random()),
        (this.y = Math.random()),
        (this.z = Math.random()),
        (this.w = Math.random()),
        this
      );
    }
    *[Symbol.iterator]() {
      (yield this.x, yield this.y, yield this.z, yield this.w);
    }
  };
  Sg.prototype.isVector4 = !0;
  var Qt = Sg,
    Ou = class extends Es {
      constructor(e = 1, t = 1, i = {}) {
        (super(),
          (i = Object.assign(
            {
              generateMipmaps: !1,
              internalFormat: null,
              minFilter: Si,
              depthBuffer: !0,
              stencilBuffer: !1,
              resolveDepthBuffer: !0,
              resolveStencilBuffer: !0,
              depthTexture: null,
              samples: 0,
              count: 1,
              depth: 1,
              multiview: !1,
            },
            i,
          )),
          (this.isRenderTarget = !0),
          (this.width = e),
          (this.height = t),
          (this.depth = i.depth),
          (this.scissor = new Qt(0, 0, e, t)),
          (this.scissorTest = !1),
          (this.viewport = new Qt(0, 0, e, t)),
          (this.textures = []));
        let n = { width: e, height: t, depth: i.depth },
          r = new Li(n),
          o = i.count;
        for (let a = 0; a < o; a++)
          ((this.textures[a] = r.clone()),
            (this.textures[a].isRenderTargetTexture = !0),
            (this.textures[a].renderTarget = this));
        (this._setTextureOptions(i),
          (this.depthBuffer = i.depthBuffer),
          (this.stencilBuffer = i.stencilBuffer),
          (this.resolveDepthBuffer = i.resolveDepthBuffer),
          (this.resolveStencilBuffer = i.resolveStencilBuffer),
          (this._depthTexture = null),
          (this.depthTexture = i.depthTexture),
          (this.samples = i.samples),
          (this.multiview = i.multiview));
      }
      _setTextureOptions(e = {}) {
        let t = {
          minFilter: Si,
          generateMipmaps: !1,
          flipY: !1,
          internalFormat: null,
        };
        (e.mapping !== void 0 && (t.mapping = e.mapping),
          e.wrapS !== void 0 && (t.wrapS = e.wrapS),
          e.wrapT !== void 0 && (t.wrapT = e.wrapT),
          e.wrapR !== void 0 && (t.wrapR = e.wrapR),
          e.magFilter !== void 0 && (t.magFilter = e.magFilter),
          e.minFilter !== void 0 && (t.minFilter = e.minFilter),
          e.format !== void 0 && (t.format = e.format),
          e.type !== void 0 && (t.type = e.type),
          e.anisotropy !== void 0 && (t.anisotropy = e.anisotropy),
          e.colorSpace !== void 0 && (t.colorSpace = e.colorSpace),
          e.flipY !== void 0 && (t.flipY = e.flipY),
          e.generateMipmaps !== void 0 &&
            (t.generateMipmaps = e.generateMipmaps),
          e.internalFormat !== void 0 && (t.internalFormat = e.internalFormat));
        for (let i = 0; i < this.textures.length; i++)
          this.textures[i].setValues(t);
      }
      get texture() {
        return this.textures[0];
      }
      set texture(e) {
        this.textures[0] = e;
      }
      set depthTexture(e) {
        (this._depthTexture !== null &&
          (this._depthTexture.renderTarget = null),
          e !== null && (e.renderTarget = this),
          (this._depthTexture = e));
      }
      get depthTexture() {
        return this._depthTexture;
      }
      setSize(e, t, i = 1) {
        if (this.width !== e || this.height !== t || this.depth !== i) {
          ((this.width = e), (this.height = t), (this.depth = i));
          for (let n = 0, r = this.textures.length; n < r; n++)
            ((this.textures[n].image.width = e),
              (this.textures[n].image.height = t),
              (this.textures[n].image.depth = i),
              this.textures[n].isData3DTexture !== !0 &&
                (this.textures[n].isArrayTexture =
                  this.textures[n].image.depth > 1));
          this.dispose();
        }
        (this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t));
      }
      clone() {
        return new this.constructor().copy(this);
      }
      copy(e) {
        ((this.width = e.width),
          (this.height = e.height),
          (this.depth = e.depth),
          this.scissor.copy(e.scissor),
          (this.scissorTest = e.scissorTest),
          this.viewport.copy(e.viewport),
          (this.textures.length = 0));
        for (let t = 0, i = e.textures.length; t < i; t++) {
          ((this.textures[t] = e.textures[t].clone()),
            (this.textures[t].isRenderTargetTexture = !0),
            (this.textures[t].renderTarget = this));
          let n = Object.assign({}, e.textures[t].image);
          this.textures[t].source = new Ya(n);
        }
        return (
          (this.depthBuffer = e.depthBuffer),
          (this.stencilBuffer = e.stencilBuffer),
          (this.resolveDepthBuffer = e.resolveDepthBuffer),
          (this.resolveStencilBuffer = e.resolveStencilBuffer),
          e.depthTexture !== null &&
            (this.depthTexture = e.depthTexture.clone()),
          (this.samples = e.samples),
          (this.multiview = e.multiview),
          this
        );
      }
      dispose() {
        this.dispatchEvent({ type: 'dispose' });
      }
    },
    xn = class extends Ou {
      constructor(e = 1, t = 1, i = {}) {
        (super(e, t, i), (this.isWebGLRenderTarget = !0));
      }
    },
    pc = class extends Li {
      constructor(e = null, t = 1, i = 1, n = 1) {
        (super(null),
          (this.isDataArrayTexture = !0),
          (this.image = { data: e, width: t, height: i, depth: n }),
          (this.magFilter = bi),
          (this.minFilter = bi),
          (this.wrapR = ns),
          (this.generateMipmaps = !1),
          (this.flipY = !1),
          (this.unpackAlignment = 1),
          (this.layerUpdates = new Set()));
      }
      addLayerUpdate(e) {
        this.layerUpdates.add(e);
      }
      clearLayerUpdates() {
        this.layerUpdates.clear();
      }
    };
  var Nu = class extends Li {
    constructor(e = null, t = 1, i = 1, n = 1) {
      (super(null),
        (this.isData3DTexture = !0),
        (this.image = { data: e, width: t, height: i, depth: n }),
        (this.magFilter = bi),
        (this.minFilter = bi),
        (this.wrapR = ns),
        (this.generateMipmaps = !1),
        (this.flipY = !1),
        (this.unpackAlignment = 1));
    }
  };
  var ju = class ju {
    constructor(e, t, i, n, r, o, a, l, c, u, f, d, p, _, x, g) {
      ((this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
        e !== void 0 &&
          this.set(e, t, i, n, r, o, a, l, c, u, f, d, p, _, x, g));
    }
    set(e, t, i, n, r, o, a, l, c, u, f, d, p, _, x, g) {
      let v = this.elements;
      return (
        (v[0] = e),
        (v[4] = t),
        (v[8] = i),
        (v[12] = n),
        (v[1] = r),
        (v[5] = o),
        (v[9] = a),
        (v[13] = l),
        (v[2] = c),
        (v[6] = u),
        (v[10] = f),
        (v[14] = d),
        (v[3] = p),
        (v[7] = _),
        (v[11] = x),
        (v[15] = g),
        this
      );
    }
    identity() {
      return (this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this);
    }
    clone() {
      return new ju().fromArray(this.elements);
    }
    copy(e) {
      let t = this.elements,
        i = e.elements;
      return (
        (t[0] = i[0]),
        (t[1] = i[1]),
        (t[2] = i[2]),
        (t[3] = i[3]),
        (t[4] = i[4]),
        (t[5] = i[5]),
        (t[6] = i[6]),
        (t[7] = i[7]),
        (t[8] = i[8]),
        (t[9] = i[9]),
        (t[10] = i[10]),
        (t[11] = i[11]),
        (t[12] = i[12]),
        (t[13] = i[13]),
        (t[14] = i[14]),
        (t[15] = i[15]),
        this
      );
    }
    copyPosition(e) {
      let t = this.elements,
        i = e.elements;
      return ((t[12] = i[12]), (t[13] = i[13]), (t[14] = i[14]), this);
    }
    setFromMatrix3(e) {
      let t = e.elements;
      return (
        this.set(
          t[0],
          t[3],
          t[6],
          0,
          t[1],
          t[4],
          t[7],
          0,
          t[2],
          t[5],
          t[8],
          0,
          0,
          0,
          0,
          1,
        ),
        this
      );
    }
    extractBasis(e, t, i) {
      return this.determinant() === 0
        ? (e.set(1, 0, 0), t.set(0, 1, 0), i.set(0, 0, 1), this)
        : (e.setFromMatrixColumn(this, 0),
          t.setFromMatrixColumn(this, 1),
          i.setFromMatrixColumn(this, 2),
          this);
    }
    makeBasis(e, t, i) {
      return (
        this.set(
          e.x,
          t.x,
          i.x,
          0,
          e.y,
          t.y,
          i.y,
          0,
          e.z,
          t.z,
          i.z,
          0,
          0,
          0,
          0,
          1,
        ),
        this
      );
    }
    extractRotation(e) {
      if (e.determinant() === 0) return this.identity();
      let t = this.elements,
        i = e.elements,
        n = 1 / Ra.setFromMatrixColumn(e, 0).length(),
        r = 1 / Ra.setFromMatrixColumn(e, 1).length(),
        o = 1 / Ra.setFromMatrixColumn(e, 2).length();
      return (
        (t[0] = i[0] * n),
        (t[1] = i[1] * n),
        (t[2] = i[2] * n),
        (t[3] = 0),
        (t[4] = i[4] * r),
        (t[5] = i[5] * r),
        (t[6] = i[6] * r),
        (t[7] = 0),
        (t[8] = i[8] * o),
        (t[9] = i[9] * o),
        (t[10] = i[10] * o),
        (t[11] = 0),
        (t[12] = 0),
        (t[13] = 0),
        (t[14] = 0),
        (t[15] = 1),
        this
      );
    }
    makeRotationFromEuler(e) {
      let t = this.elements,
        i = e.x,
        n = e.y,
        r = e.z,
        o = Math.cos(i),
        a = Math.sin(i),
        l = Math.cos(n),
        c = Math.sin(n),
        u = Math.cos(r),
        f = Math.sin(r);
      if (e.order === 'XYZ') {
        let d = o * u,
          p = o * f,
          _ = a * u,
          x = a * f;
        ((t[0] = l * u),
          (t[4] = -l * f),
          (t[8] = c),
          (t[1] = p + _ * c),
          (t[5] = d - x * c),
          (t[9] = -a * l),
          (t[2] = x - d * c),
          (t[6] = _ + p * c),
          (t[10] = o * l));
      } else if (e.order === 'YXZ') {
        let d = l * u,
          p = l * f,
          _ = c * u,
          x = c * f;
        ((t[0] = d + x * a),
          (t[4] = _ * a - p),
          (t[8] = o * c),
          (t[1] = o * f),
          (t[5] = o * u),
          (t[9] = -a),
          (t[2] = p * a - _),
          (t[6] = x + d * a),
          (t[10] = o * l));
      } else if (e.order === 'ZXY') {
        let d = l * u,
          p = l * f,
          _ = c * u,
          x = c * f;
        ((t[0] = d - x * a),
          (t[4] = -o * f),
          (t[8] = _ + p * a),
          (t[1] = p + _ * a),
          (t[5] = o * u),
          (t[9] = x - d * a),
          (t[2] = -o * c),
          (t[6] = a),
          (t[10] = o * l));
      } else if (e.order === 'ZYX') {
        let d = o * u,
          p = o * f,
          _ = a * u,
          x = a * f;
        ((t[0] = l * u),
          (t[4] = _ * c - p),
          (t[8] = d * c + x),
          (t[1] = l * f),
          (t[5] = x * c + d),
          (t[9] = p * c - _),
          (t[2] = -c),
          (t[6] = a * l),
          (t[10] = o * l));
      } else if (e.order === 'YZX') {
        let d = o * l,
          p = o * c,
          _ = a * l,
          x = a * c;
        ((t[0] = l * u),
          (t[4] = x - d * f),
          (t[8] = _ * f + p),
          (t[1] = f),
          (t[5] = o * u),
          (t[9] = -a * u),
          (t[2] = -c * u),
          (t[6] = p * f + _),
          (t[10] = d - x * f));
      } else if (e.order === 'XZY') {
        let d = o * l,
          p = o * c,
          _ = a * l,
          x = a * c;
        ((t[0] = l * u),
          (t[4] = -f),
          (t[8] = c * u),
          (t[1] = d * f + x),
          (t[5] = o * u),
          (t[9] = p * f - _),
          (t[2] = _ * f - p),
          (t[6] = a * u),
          (t[10] = x * f + d));
      }
      return (
        (t[3] = 0),
        (t[7] = 0),
        (t[11] = 0),
        (t[12] = 0),
        (t[13] = 0),
        (t[14] = 0),
        (t[15] = 1),
        this
      );
    }
    makeRotationFromQuaternion(e) {
      return this.compose(NT, e, FT);
    }
    lookAt(e, t, i) {
      let n = this.elements;
      return (
        Vn.subVectors(e, t),
        Vn.lengthSq() === 0 && (Vn.z = 1),
        Vn.normalize(),
        Xr.crossVectors(i, Vn),
        Xr.lengthSq() === 0 &&
          (Math.abs(i.z) === 1 ? (Vn.x += 1e-4) : (Vn.z += 1e-4),
          Vn.normalize(),
          Xr.crossVectors(i, Vn)),
        Xr.normalize(),
        Kh.crossVectors(Vn, Xr),
        (n[0] = Xr.x),
        (n[4] = Kh.x),
        (n[8] = Vn.x),
        (n[1] = Xr.y),
        (n[5] = Kh.y),
        (n[9] = Vn.y),
        (n[2] = Xr.z),
        (n[6] = Kh.z),
        (n[10] = Vn.z),
        this
      );
    }
    multiply(e) {
      return this.multiplyMatrices(this, e);
    }
    premultiply(e) {
      return this.multiplyMatrices(e, this);
    }
    multiplyMatrices(e, t) {
      let i = e.elements,
        n = t.elements,
        r = this.elements,
        o = i[0],
        a = i[4],
        l = i[8],
        c = i[12],
        u = i[1],
        f = i[5],
        d = i[9],
        p = i[13],
        _ = i[2],
        x = i[6],
        g = i[10],
        v = i[14],
        w = i[3],
        L = i[7],
        R = i[11],
        U = i[15],
        O = n[0],
        N = n[4],
        M = n[8],
        I = n[12],
        z = n[1],
        W = n[5],
        q = n[9],
        re = n[13],
        oe = n[2],
        K = n[6],
        ie = n[10],
        J = n[14],
        pe = n[3],
        Ee = n[7],
        Z = n[11],
        Ne = n[15];
      return (
        (r[0] = o * O + a * z + l * oe + c * pe),
        (r[4] = o * N + a * W + l * K + c * Ee),
        (r[8] = o * M + a * q + l * ie + c * Z),
        (r[12] = o * I + a * re + l * J + c * Ne),
        (r[1] = u * O + f * z + d * oe + p * pe),
        (r[5] = u * N + f * W + d * K + p * Ee),
        (r[9] = u * M + f * q + d * ie + p * Z),
        (r[13] = u * I + f * re + d * J + p * Ne),
        (r[2] = _ * O + x * z + g * oe + v * pe),
        (r[6] = _ * N + x * W + g * K + v * Ee),
        (r[10] = _ * M + x * q + g * ie + v * Z),
        (r[14] = _ * I + x * re + g * J + v * Ne),
        (r[3] = w * O + L * z + R * oe + U * pe),
        (r[7] = w * N + L * W + R * K + U * Ee),
        (r[11] = w * M + L * q + R * ie + U * Z),
        (r[15] = w * I + L * re + R * J + U * Ne),
        this
      );
    }
    multiplyScalar(e) {
      let t = this.elements;
      return (
        (t[0] *= e),
        (t[4] *= e),
        (t[8] *= e),
        (t[12] *= e),
        (t[1] *= e),
        (t[5] *= e),
        (t[9] *= e),
        (t[13] *= e),
        (t[2] *= e),
        (t[6] *= e),
        (t[10] *= e),
        (t[14] *= e),
        (t[3] *= e),
        (t[7] *= e),
        (t[11] *= e),
        (t[15] *= e),
        this
      );
    }
    determinant() {
      let e = this.elements,
        t = e[0],
        i = e[4],
        n = e[8],
        r = e[12],
        o = e[1],
        a = e[5],
        l = e[9],
        c = e[13],
        u = e[2],
        f = e[6],
        d = e[10],
        p = e[14],
        _ = e[3],
        x = e[7],
        g = e[11],
        v = e[15],
        w = l * p - c * d,
        L = a * p - c * f,
        R = a * d - l * f,
        U = o * p - c * u,
        O = o * d - l * u,
        N = o * f - a * u;
      return (
        t * (x * w - g * L + v * R) -
        i * (_ * w - g * U + v * O) +
        n * (_ * L - x * U + v * N) -
        r * (_ * R - x * O + g * N)
      );
    }
    transpose() {
      let e = this.elements,
        t;
      return (
        (t = e[1]),
        (e[1] = e[4]),
        (e[4] = t),
        (t = e[2]),
        (e[2] = e[8]),
        (e[8] = t),
        (t = e[6]),
        (e[6] = e[9]),
        (e[9] = t),
        (t = e[3]),
        (e[3] = e[12]),
        (e[12] = t),
        (t = e[7]),
        (e[7] = e[13]),
        (e[13] = t),
        (t = e[11]),
        (e[11] = e[14]),
        (e[14] = t),
        this
      );
    }
    setPosition(e, t, i) {
      let n = this.elements;
      return (
        e.isVector3
          ? ((n[12] = e.x), (n[13] = e.y), (n[14] = e.z))
          : ((n[12] = e), (n[13] = t), (n[14] = i)),
        this
      );
    }
    invert() {
      let e = this.elements,
        t = e[0],
        i = e[1],
        n = e[2],
        r = e[3],
        o = e[4],
        a = e[5],
        l = e[6],
        c = e[7],
        u = e[8],
        f = e[9],
        d = e[10],
        p = e[11],
        _ = e[12],
        x = e[13],
        g = e[14],
        v = e[15],
        w = t * a - i * o,
        L = t * l - n * o,
        R = t * c - r * o,
        U = i * l - n * a,
        O = i * c - r * a,
        N = n * c - r * l,
        M = u * x - f * _,
        I = u * g - d * _,
        z = u * v - p * _,
        W = f * g - d * x,
        q = f * v - p * x,
        re = d * v - p * g,
        oe = w * re - L * q + R * W + U * z - O * I + N * M;
      if (oe === 0)
        return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
      let K = 1 / oe;
      return (
        (e[0] = (a * re - l * q + c * W) * K),
        (e[1] = (n * q - i * re - r * W) * K),
        (e[2] = (x * N - g * O + v * U) * K),
        (e[3] = (d * O - f * N - p * U) * K),
        (e[4] = (l * z - o * re - c * I) * K),
        (e[5] = (t * re - n * z + r * I) * K),
        (e[6] = (g * R - _ * N - v * L) * K),
        (e[7] = (u * N - d * R + p * L) * K),
        (e[8] = (o * q - a * z + c * M) * K),
        (e[9] = (i * z - t * q - r * M) * K),
        (e[10] = (_ * O - x * R + v * w) * K),
        (e[11] = (f * R - u * O - p * w) * K),
        (e[12] = (a * I - o * W - l * M) * K),
        (e[13] = (t * W - i * I + n * M) * K),
        (e[14] = (x * L - _ * U - g * w) * K),
        (e[15] = (u * U - f * L + d * w) * K),
        this
      );
    }
    scale(e) {
      let t = this.elements,
        i = e.x,
        n = e.y,
        r = e.z;
      return (
        (t[0] *= i),
        (t[4] *= n),
        (t[8] *= r),
        (t[1] *= i),
        (t[5] *= n),
        (t[9] *= r),
        (t[2] *= i),
        (t[6] *= n),
        (t[10] *= r),
        (t[3] *= i),
        (t[7] *= n),
        (t[11] *= r),
        this
      );
    }
    getMaxScaleOnAxis() {
      let e = this.elements,
        t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2],
        i = e[4] * e[4] + e[5] * e[5] + e[6] * e[6],
        n = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
      return Math.sqrt(Math.max(t, i, n));
    }
    makeTranslation(e, t, i) {
      return (
        e.isVector3
          ? this.set(1, 0, 0, e.x, 0, 1, 0, e.y, 0, 0, 1, e.z, 0, 0, 0, 1)
          : this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, i, 0, 0, 0, 1),
        this
      );
    }
    makeRotationX(e) {
      let t = Math.cos(e),
        i = Math.sin(e);
      return (this.set(1, 0, 0, 0, 0, t, -i, 0, 0, i, t, 0, 0, 0, 0, 1), this);
    }
    makeRotationY(e) {
      let t = Math.cos(e),
        i = Math.sin(e);
      return (this.set(t, 0, i, 0, 0, 1, 0, 0, -i, 0, t, 0, 0, 0, 0, 1), this);
    }
    makeRotationZ(e) {
      let t = Math.cos(e),
        i = Math.sin(e);
      return (this.set(t, -i, 0, 0, i, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this);
    }
    makeRotationAxis(e, t) {
      let i = Math.cos(t),
        n = Math.sin(t),
        r = 1 - i,
        o = e.x,
        a = e.y,
        l = e.z,
        c = r * o,
        u = r * a;
      return (
        this.set(
          c * o + i,
          c * a - n * l,
          c * l + n * a,
          0,
          c * a + n * l,
          u * a + i,
          u * l - n * o,
          0,
          c * l - n * a,
          u * l + n * o,
          r * l * l + i,
          0,
          0,
          0,
          0,
          1,
        ),
        this
      );
    }
    makeScale(e, t, i) {
      return (this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this);
    }
    makeShear(e, t, i, n, r, o) {
      return (this.set(1, i, r, 0, e, 1, o, 0, t, n, 1, 0, 0, 0, 0, 1), this);
    }
    compose(e, t, i) {
      let n = this.elements,
        r = t._x,
        o = t._y,
        a = t._z,
        l = t._w,
        c = r + r,
        u = o + o,
        f = a + a,
        d = r * c,
        p = r * u,
        _ = r * f,
        x = o * u,
        g = o * f,
        v = a * f,
        w = l * c,
        L = l * u,
        R = l * f,
        U = i.x,
        O = i.y,
        N = i.z;
      return (
        (n[0] = (1 - (x + v)) * U),
        (n[1] = (p + R) * U),
        (n[2] = (_ - L) * U),
        (n[3] = 0),
        (n[4] = (p - R) * O),
        (n[5] = (1 - (d + v)) * O),
        (n[6] = (g + w) * O),
        (n[7] = 0),
        (n[8] = (_ + L) * N),
        (n[9] = (g - w) * N),
        (n[10] = (1 - (d + x)) * N),
        (n[11] = 0),
        (n[12] = e.x),
        (n[13] = e.y),
        (n[14] = e.z),
        (n[15] = 1),
        this
      );
    }
    decompose(e, t, i) {
      let n = this.elements;
      ((e.x = n[12]), (e.y = n[13]), (e.z = n[14]));
      let r = this.determinant();
      if (r === 0) return (i.set(1, 1, 1), t.identity(), this);
      let o = Ra.set(n[0], n[1], n[2]).length(),
        a = Ra.set(n[4], n[5], n[6]).length(),
        l = Ra.set(n[8], n[9], n[10]).length();
      (r < 0 && (o = -o), gs.copy(this));
      let c = 1 / o,
        u = 1 / a,
        f = 1 / l;
      return (
        (gs.elements[0] *= c),
        (gs.elements[1] *= c),
        (gs.elements[2] *= c),
        (gs.elements[4] *= u),
        (gs.elements[5] *= u),
        (gs.elements[6] *= u),
        (gs.elements[8] *= f),
        (gs.elements[9] *= f),
        (gs.elements[10] *= f),
        t.setFromRotationMatrix(gs),
        (i.x = o),
        (i.y = a),
        (i.z = l),
        this
      );
    }
    makePerspective(e, t, i, n, r, o, a = ys, l = !1) {
      let c = this.elements,
        u = (2 * r) / (t - e),
        f = (2 * r) / (i - n),
        d = (t + e) / (t - e),
        p = (i + n) / (i - n),
        _,
        x;
      if (l) ((_ = r / (o - r)), (x = (o * r) / (o - r)));
      else if (a === ys)
        ((_ = -(o + r) / (o - r)), (x = (-2 * o * r) / (o - r)));
      else if (a === Ga) ((_ = -o / (o - r)), (x = (-o * r) / (o - r)));
      else
        throw new Error(
          'THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + a,
        );
      return (
        (c[0] = u),
        (c[4] = 0),
        (c[8] = d),
        (c[12] = 0),
        (c[1] = 0),
        (c[5] = f),
        (c[9] = p),
        (c[13] = 0),
        (c[2] = 0),
        (c[6] = 0),
        (c[10] = _),
        (c[14] = x),
        (c[3] = 0),
        (c[7] = 0),
        (c[11] = -1),
        (c[15] = 0),
        this
      );
    }
    makeOrthographic(e, t, i, n, r, o, a = ys, l = !1) {
      let c = this.elements,
        u = 2 / (t - e),
        f = 2 / (i - n),
        d = -(t + e) / (t - e),
        p = -(i + n) / (i - n),
        _,
        x;
      if (l) ((_ = 1 / (o - r)), (x = o / (o - r)));
      else if (a === ys) ((_ = -2 / (o - r)), (x = -(o + r) / (o - r)));
      else if (a === Ga) ((_ = -1 / (o - r)), (x = -r / (o - r)));
      else
        throw new Error(
          'THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + a,
        );
      return (
        (c[0] = u),
        (c[4] = 0),
        (c[8] = 0),
        (c[12] = d),
        (c[1] = 0),
        (c[5] = f),
        (c[9] = 0),
        (c[13] = p),
        (c[2] = 0),
        (c[6] = 0),
        (c[10] = _),
        (c[14] = x),
        (c[3] = 0),
        (c[7] = 0),
        (c[11] = 0),
        (c[15] = 1),
        this
      );
    }
    equals(e) {
      let t = this.elements,
        i = e.elements;
      for (let n = 0; n < 16; n++) if (t[n] !== i[n]) return !1;
      return !0;
    }
    fromArray(e, t = 0) {
      for (let i = 0; i < 16; i++) this.elements[i] = e[i + t];
      return this;
    }
    toArray(e = [], t = 0) {
      let i = this.elements;
      return (
        (e[t] = i[0]),
        (e[t + 1] = i[1]),
        (e[t + 2] = i[2]),
        (e[t + 3] = i[3]),
        (e[t + 4] = i[4]),
        (e[t + 5] = i[5]),
        (e[t + 6] = i[6]),
        (e[t + 7] = i[7]),
        (e[t + 8] = i[8]),
        (e[t + 9] = i[9]),
        (e[t + 10] = i[10]),
        (e[t + 11] = i[11]),
        (e[t + 12] = i[12]),
        (e[t + 13] = i[13]),
        (e[t + 14] = i[14]),
        (e[t + 15] = i[15]),
        e
      );
    }
  };
  ju.prototype.isMatrix4 = !0;
  var yt = ju,
    Ra = new te(),
    gs = new yt(),
    NT = new te(0, 0, 0),
    FT = new te(1, 1, 1),
    Xr = new te(),
    Kh = new te(),
    Vn = new te(),
    cx = new yt(),
    hx = new zi(),
    Ts = class s {
      constructor(e = 0, t = 0, i = 0, n = s.DEFAULT_ORDER) {
        ((this.isEuler = !0),
          (this._x = e),
          (this._y = t),
          (this._z = i),
          (this._order = n));
      }
      get x() {
        return this._x;
      }
      set x(e) {
        ((this._x = e), this._onChangeCallback());
      }
      get y() {
        return this._y;
      }
      set y(e) {
        ((this._y = e), this._onChangeCallback());
      }
      get z() {
        return this._z;
      }
      set z(e) {
        ((this._z = e), this._onChangeCallback());
      }
      get order() {
        return this._order;
      }
      set order(e) {
        ((this._order = e), this._onChangeCallback());
      }
      set(e, t, i, n = this._order) {
        return (
          (this._x = e),
          (this._y = t),
          (this._z = i),
          (this._order = n),
          this._onChangeCallback(),
          this
        );
      }
      clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
      }
      copy(e) {
        return (
          (this._x = e._x),
          (this._y = e._y),
          (this._z = e._z),
          (this._order = e._order),
          this._onChangeCallback(),
          this
        );
      }
      setFromRotationMatrix(e, t = this._order, i = !0) {
        let n = e.elements,
          r = n[0],
          o = n[4],
          a = n[8],
          l = n[1],
          c = n[5],
          u = n[9],
          f = n[2],
          d = n[6],
          p = n[10];
        switch (t) {
          case 'XYZ':
            ((this._y = Math.asin(Dt(a, -1, 1))),
              Math.abs(a) < 0.9999999
                ? ((this._x = Math.atan2(-u, p)), (this._z = Math.atan2(-o, r)))
                : ((this._x = Math.atan2(d, c)), (this._z = 0)));
            break;
          case 'YXZ':
            ((this._x = Math.asin(-Dt(u, -1, 1))),
              Math.abs(u) < 0.9999999
                ? ((this._y = Math.atan2(a, p)), (this._z = Math.atan2(l, c)))
                : ((this._y = Math.atan2(-f, r)), (this._z = 0)));
            break;
          case 'ZXY':
            ((this._x = Math.asin(Dt(d, -1, 1))),
              Math.abs(d) < 0.9999999
                ? ((this._y = Math.atan2(-f, p)), (this._z = Math.atan2(-o, c)))
                : ((this._y = 0), (this._z = Math.atan2(l, r))));
            break;
          case 'ZYX':
            ((this._y = Math.asin(-Dt(f, -1, 1))),
              Math.abs(f) < 0.9999999
                ? ((this._x = Math.atan2(d, p)), (this._z = Math.atan2(l, r)))
                : ((this._x = 0), (this._z = Math.atan2(-o, c))));
            break;
          case 'YZX':
            ((this._z = Math.asin(Dt(l, -1, 1))),
              Math.abs(l) < 0.9999999
                ? ((this._x = Math.atan2(-u, c)), (this._y = Math.atan2(-f, r)))
                : ((this._x = 0), (this._y = Math.atan2(a, p))));
            break;
          case 'XZY':
            ((this._z = Math.asin(-Dt(o, -1, 1))),
              Math.abs(o) < 0.9999999
                ? ((this._x = Math.atan2(d, c)), (this._y = Math.atan2(a, r)))
                : ((this._x = Math.atan2(-u, p)), (this._y = 0)));
            break;
          default:
            it(
              'Euler: .setFromRotationMatrix() encountered an unknown order: ' +
                t,
            );
        }
        return ((this._order = t), i === !0 && this._onChangeCallback(), this);
      }
      setFromQuaternion(e, t, i) {
        return (
          cx.makeRotationFromQuaternion(e),
          this.setFromRotationMatrix(cx, t, i)
        );
      }
      setFromVector3(e, t = this._order) {
        return this.set(e.x, e.y, e.z, t);
      }
      reorder(e) {
        return (hx.setFromEuler(this), this.setFromQuaternion(hx, e));
      }
      equals(e) {
        return (
          e._x === this._x &&
          e._y === this._y &&
          e._z === this._z &&
          e._order === this._order
        );
      }
      fromArray(e) {
        return (
          (this._x = e[0]),
          (this._y = e[1]),
          (this._z = e[2]),
          e[3] !== void 0 && (this._order = e[3]),
          this._onChangeCallback(),
          this
        );
      }
      toArray(e = [], t = 0) {
        return (
          (e[t] = this._x),
          (e[t + 1] = this._y),
          (e[t + 2] = this._z),
          (e[t + 3] = this._order),
          e
        );
      }
      _onChange(e) {
        return ((this._onChangeCallback = e), this);
      }
      _onChangeCallback() {}
      *[Symbol.iterator]() {
        (yield this._x, yield this._y, yield this._z, yield this._order);
      }
    };
  Ts.DEFAULT_ORDER = 'XYZ';
  var mc = class {
      constructor() {
        this.mask = 1;
      }
      set(e) {
        this.mask = ((1 << e) | 0) >>> 0;
      }
      enable(e) {
        this.mask |= (1 << e) | 0;
      }
      enableAll() {
        this.mask = -1;
      }
      toggle(e) {
        this.mask ^= (1 << e) | 0;
      }
      disable(e) {
        this.mask &= ~((1 << e) | 0);
      }
      disableAll() {
        this.mask = 0;
      }
      test(e) {
        return (this.mask & e.mask) !== 0;
      }
      isEnabled(e) {
        return (this.mask & ((1 << e) | 0)) !== 0;
      }
    },
    UT = 0,
    ux = new te(),
    Ca = new zi(),
    _r = new yt(),
    $h = new te(),
    ic = new te(),
    BT = new te(),
    kT = new zi(),
    dx = new te(1, 0, 0),
    fx = new te(0, 1, 0),
    px = new te(0, 0, 1),
    mx = { type: 'added' },
    HT = { type: 'removed' },
    Pa = { type: 'childadded', child: null },
    fm = { type: 'childremoved', child: null },
    pi = class s extends Es {
      constructor() {
        (super(),
          (this.isObject3D = !0),
          Object.defineProperty(this, 'id', { value: UT++ }),
          (this.uuid = bs()),
          (this.name = ''),
          (this.type = 'Object3D'),
          (this.parent = null),
          (this.children = []),
          (this.up = s.DEFAULT_UP.clone()));
        let e = new te(),
          t = new Ts(),
          i = new zi(),
          n = new te(1, 1, 1);
        function r() {
          i.setFromEuler(t, !1);
        }
        function o() {
          t.setFromQuaternion(i, void 0, !1);
        }
        (t._onChange(r),
          i._onChange(o),
          Object.defineProperties(this, {
            position: { configurable: !0, enumerable: !0, value: e },
            rotation: { configurable: !0, enumerable: !0, value: t },
            quaternion: { configurable: !0, enumerable: !0, value: i },
            scale: { configurable: !0, enumerable: !0, value: n },
            modelViewMatrix: { value: new yt() },
            normalMatrix: { value: new St() },
          }),
          (this.matrix = new yt()),
          (this.matrixWorld = new yt()),
          (this.matrixAutoUpdate = s.DEFAULT_MATRIX_AUTO_UPDATE),
          (this.matrixWorldAutoUpdate = s.DEFAULT_MATRIX_WORLD_AUTO_UPDATE),
          (this.matrixWorldNeedsUpdate = !1),
          (this.layers = new mc()),
          (this.visible = !0),
          (this.castShadow = !1),
          (this.receiveShadow = !1),
          (this.frustumCulled = !0),
          (this.renderOrder = 0),
          (this.animations = []),
          (this.customDepthMaterial = void 0),
          (this.customDistanceMaterial = void 0),
          (this.static = !1),
          (this.userData = {}),
          (this.pivot = null));
      }
      onBeforeShadow() {}
      onAfterShadow() {}
      onBeforeRender() {}
      onAfterRender() {}
      applyMatrix4(e) {
        (this.matrixAutoUpdate && this.updateMatrix(),
          this.matrix.premultiply(e),
          this.matrix.decompose(this.position, this.quaternion, this.scale));
      }
      applyQuaternion(e) {
        return (this.quaternion.premultiply(e), this);
      }
      setRotationFromAxisAngle(e, t) {
        this.quaternion.setFromAxisAngle(e, t);
      }
      setRotationFromEuler(e) {
        this.quaternion.setFromEuler(e, !0);
      }
      setRotationFromMatrix(e) {
        this.quaternion.setFromRotationMatrix(e);
      }
      setRotationFromQuaternion(e) {
        this.quaternion.copy(e);
      }
      rotateOnAxis(e, t) {
        return (Ca.setFromAxisAngle(e, t), this.quaternion.multiply(Ca), this);
      }
      rotateOnWorldAxis(e, t) {
        return (
          Ca.setFromAxisAngle(e, t),
          this.quaternion.premultiply(Ca),
          this
        );
      }
      rotateX(e) {
        return this.rotateOnAxis(dx, e);
      }
      rotateY(e) {
        return this.rotateOnAxis(fx, e);
      }
      rotateZ(e) {
        return this.rotateOnAxis(px, e);
      }
      translateOnAxis(e, t) {
        return (
          ux.copy(e).applyQuaternion(this.quaternion),
          this.position.add(ux.multiplyScalar(t)),
          this
        );
      }
      translateX(e) {
        return this.translateOnAxis(dx, e);
      }
      translateY(e) {
        return this.translateOnAxis(fx, e);
      }
      translateZ(e) {
        return this.translateOnAxis(px, e);
      }
      localToWorld(e) {
        return (
          this.updateWorldMatrix(!0, !1),
          e.applyMatrix4(this.matrixWorld)
        );
      }
      worldToLocal(e) {
        return (
          this.updateWorldMatrix(!0, !1),
          e.applyMatrix4(_r.copy(this.matrixWorld).invert())
        );
      }
      lookAt(e, t, i) {
        e.isVector3 ? $h.copy(e) : $h.set(e, t, i);
        let n = this.parent;
        (this.updateWorldMatrix(!0, !1),
          ic.setFromMatrixPosition(this.matrixWorld),
          this.isCamera || this.isLight
            ? _r.lookAt(ic, $h, this.up)
            : _r.lookAt($h, ic, this.up),
          this.quaternion.setFromRotationMatrix(_r),
          n &&
            (_r.extractRotation(n.matrixWorld),
            Ca.setFromRotationMatrix(_r),
            this.quaternion.premultiply(Ca.invert())));
      }
      add(e) {
        if (arguments.length > 1) {
          for (let t = 0; t < arguments.length; t++) this.add(arguments[t]);
          return this;
        }
        return e === this
          ? (mt("Object3D.add: object can't be added as a child of itself.", e),
            this)
          : (e && e.isObject3D
              ? (e.removeFromParent(),
                (e.parent = this),
                this.children.push(e),
                e.dispatchEvent(mx),
                (Pa.child = e),
                this.dispatchEvent(Pa),
                (Pa.child = null))
              : mt(
                  'Object3D.add: object not an instance of THREE.Object3D.',
                  e,
                ),
            this);
      }
      remove(e) {
        if (arguments.length > 1) {
          for (let i = 0; i < arguments.length; i++) this.remove(arguments[i]);
          return this;
        }
        let t = this.children.indexOf(e);
        return (
          t !== -1 &&
            ((e.parent = null),
            this.children.splice(t, 1),
            e.dispatchEvent(HT),
            (fm.child = e),
            this.dispatchEvent(fm),
            (fm.child = null)),
          this
        );
      }
      removeFromParent() {
        let e = this.parent;
        return (e !== null && e.remove(this), this);
      }
      clear() {
        return this.remove(...this.children);
      }
      attach(e) {
        return (
          this.updateWorldMatrix(!0, !1),
          _r.copy(this.matrixWorld).invert(),
          e.parent !== null &&
            (e.parent.updateWorldMatrix(!0, !1),
            _r.multiply(e.parent.matrixWorld)),
          e.applyMatrix4(_r),
          e.removeFromParent(),
          (e.parent = this),
          this.children.push(e),
          e.updateWorldMatrix(!1, !0),
          e.dispatchEvent(mx),
          (Pa.child = e),
          this.dispatchEvent(Pa),
          (Pa.child = null),
          this
        );
      }
      getObjectById(e) {
        return this.getObjectByProperty('id', e);
      }
      getObjectByName(e) {
        return this.getObjectByProperty('name', e);
      }
      getObjectByProperty(e, t) {
        if (this[e] === t) return this;
        for (let i = 0, n = this.children.length; i < n; i++) {
          let o = this.children[i].getObjectByProperty(e, t);
          if (o !== void 0) return o;
        }
      }
      getObjectsByProperty(e, t, i = []) {
        this[e] === t && i.push(this);
        let n = this.children;
        for (let r = 0, o = n.length; r < o; r++)
          n[r].getObjectsByProperty(e, t, i);
        return i;
      }
      getWorldPosition(e) {
        return (
          this.updateWorldMatrix(!0, !1),
          e.setFromMatrixPosition(this.matrixWorld)
        );
      }
      getWorldQuaternion(e) {
        return (
          this.updateWorldMatrix(!0, !1),
          this.matrixWorld.decompose(ic, e, BT),
          e
        );
      }
      getWorldScale(e) {
        return (
          this.updateWorldMatrix(!0, !1),
          this.matrixWorld.decompose(ic, kT, e),
          e
        );
      }
      getWorldDirection(e) {
        this.updateWorldMatrix(!0, !1);
        let t = this.matrixWorld.elements;
        return e.set(t[8], t[9], t[10]).normalize();
      }
      raycast() {}
      traverse(e) {
        e(this);
        let t = this.children;
        for (let i = 0, n = t.length; i < n; i++) t[i].traverse(e);
      }
      traverseVisible(e) {
        if (this.visible === !1) return;
        e(this);
        let t = this.children;
        for (let i = 0, n = t.length; i < n; i++) t[i].traverseVisible(e);
      }
      traverseAncestors(e) {
        let t = this.parent;
        t !== null && (e(t), t.traverseAncestors(e));
      }
      updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        let e = this.pivot;
        if (e !== null) {
          let t = e.x,
            i = e.y,
            n = e.z,
            r = this.matrix.elements;
          ((r[12] += t - r[0] * t - r[4] * i - r[8] * n),
            (r[13] += i - r[1] * t - r[5] * i - r[9] * n),
            (r[14] += n - r[2] * t - r[6] * i - r[10] * n));
        }
        this.matrixWorldNeedsUpdate = !0;
      }
      updateMatrixWorld(e) {
        (this.matrixAutoUpdate && this.updateMatrix(),
          (this.matrixWorldNeedsUpdate || e) &&
            (this.matrixWorldAutoUpdate === !0 &&
              (this.parent === null
                ? this.matrixWorld.copy(this.matrix)
                : this.matrixWorld.multiplyMatrices(
                    this.parent.matrixWorld,
                    this.matrix,
                  )),
            (this.matrixWorldNeedsUpdate = !1),
            (e = !0)));
        let t = this.children;
        for (let i = 0, n = t.length; i < n; i++) t[i].updateMatrixWorld(e);
      }
      updateWorldMatrix(e, t) {
        let i = this.parent;
        if (
          (e === !0 && i !== null && i.updateWorldMatrix(!0, !1),
          this.matrixAutoUpdate && this.updateMatrix(),
          this.matrixWorldAutoUpdate === !0 &&
            (this.parent === null
              ? this.matrixWorld.copy(this.matrix)
              : this.matrixWorld.multiplyMatrices(
                  this.parent.matrixWorld,
                  this.matrix,
                )),
          t === !0)
        ) {
          let n = this.children;
          for (let r = 0, o = n.length; r < o; r++)
            n[r].updateWorldMatrix(!1, !0);
        }
      }
      toJSON(e) {
        let t = e === void 0 || typeof e == 'string',
          i = {};
        t &&
          ((e = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {},
          }),
          (i.metadata = {
            version: 4.7,
            type: 'Object',
            generator: 'Object3D.toJSON',
          }));
        let n = {};
        ((n.uuid = this.uuid),
          (n.type = this.type),
          this.name !== '' && (n.name = this.name),
          this.castShadow === !0 && (n.castShadow = !0),
          this.receiveShadow === !0 && (n.receiveShadow = !0),
          this.visible === !1 && (n.visible = !1),
          this.frustumCulled === !1 && (n.frustumCulled = !1),
          this.renderOrder !== 0 && (n.renderOrder = this.renderOrder),
          this.static !== !1 && (n.static = this.static),
          Object.keys(this.userData).length > 0 && (n.userData = this.userData),
          (n.layers = this.layers.mask),
          (n.matrix = this.matrix.toArray()),
          (n.up = this.up.toArray()),
          this.pivot !== null && (n.pivot = this.pivot.toArray()),
          this.matrixAutoUpdate === !1 && (n.matrixAutoUpdate = !1),
          this.morphTargetDictionary !== void 0 &&
            (n.morphTargetDictionary = Object.assign(
              {},
              this.morphTargetDictionary,
            )),
          this.morphTargetInfluences !== void 0 &&
            (n.morphTargetInfluences = this.morphTargetInfluences.slice()),
          this.isInstancedMesh &&
            ((n.type = 'InstancedMesh'),
            (n.count = this.count),
            (n.instanceMatrix = this.instanceMatrix.toJSON()),
            this.instanceColor !== null &&
              (n.instanceColor = this.instanceColor.toJSON())),
          this.isBatchedMesh &&
            ((n.type = 'BatchedMesh'),
            (n.perObjectFrustumCulled = this.perObjectFrustumCulled),
            (n.sortObjects = this.sortObjects),
            (n.drawRanges = this._drawRanges),
            (n.reservedRanges = this._reservedRanges),
            (n.geometryInfo = this._geometryInfo.map((a) =>
              Fi(pt({}, a), {
                boundingBox: a.boundingBox ? a.boundingBox.toJSON() : void 0,
                boundingSphere: a.boundingSphere
                  ? a.boundingSphere.toJSON()
                  : void 0,
              }),
            )),
            (n.instanceInfo = this._instanceInfo.map((a) => pt({}, a))),
            (n.availableInstanceIds = this._availableInstanceIds.slice()),
            (n.availableGeometryIds = this._availableGeometryIds.slice()),
            (n.nextIndexStart = this._nextIndexStart),
            (n.nextVertexStart = this._nextVertexStart),
            (n.geometryCount = this._geometryCount),
            (n.maxInstanceCount = this._maxInstanceCount),
            (n.maxVertexCount = this._maxVertexCount),
            (n.maxIndexCount = this._maxIndexCount),
            (n.geometryInitialized = this._geometryInitialized),
            (n.matricesTexture = this._matricesTexture.toJSON(e)),
            (n.indirectTexture = this._indirectTexture.toJSON(e)),
            this._colorsTexture !== null &&
              (n.colorsTexture = this._colorsTexture.toJSON(e)),
            this.boundingSphere !== null &&
              (n.boundingSphere = this.boundingSphere.toJSON()),
            this.boundingBox !== null &&
              (n.boundingBox = this.boundingBox.toJSON())));
        function r(a, l) {
          return (a[l.uuid] === void 0 && (a[l.uuid] = l.toJSON(e)), l.uuid);
        }
        if (this.isScene)
          (this.background &&
            (this.background.isColor
              ? (n.background = this.background.toJSON())
              : this.background.isTexture &&
                (n.background = this.background.toJSON(e).uuid)),
            this.environment &&
              this.environment.isTexture &&
              this.environment.isRenderTargetTexture !== !0 &&
              (n.environment = this.environment.toJSON(e).uuid));
        else if (this.isMesh || this.isLine || this.isPoints) {
          n.geometry = r(e.geometries, this.geometry);
          let a = this.geometry.parameters;
          if (a !== void 0 && a.shapes !== void 0) {
            let l = a.shapes;
            if (Array.isArray(l))
              for (let c = 0, u = l.length; c < u; c++) {
                let f = l[c];
                r(e.shapes, f);
              }
            else r(e.shapes, l);
          }
        }
        if (
          (this.isSkinnedMesh &&
            ((n.bindMode = this.bindMode),
            (n.bindMatrix = this.bindMatrix.toArray()),
            this.skeleton !== void 0 &&
              (r(e.skeletons, this.skeleton),
              (n.skeleton = this.skeleton.uuid))),
          this.material !== void 0)
        )
          if (Array.isArray(this.material)) {
            let a = [];
            for (let l = 0, c = this.material.length; l < c; l++)
              a.push(r(e.materials, this.material[l]));
            n.material = a;
          } else n.material = r(e.materials, this.material);
        if (this.children.length > 0) {
          n.children = [];
          for (let a = 0; a < this.children.length; a++)
            n.children.push(this.children[a].toJSON(e).object);
        }
        if (this.animations.length > 0) {
          n.animations = [];
          for (let a = 0; a < this.animations.length; a++) {
            let l = this.animations[a];
            n.animations.push(r(e.animations, l));
          }
        }
        if (t) {
          let a = o(e.geometries),
            l = o(e.materials),
            c = o(e.textures),
            u = o(e.images),
            f = o(e.shapes),
            d = o(e.skeletons),
            p = o(e.animations),
            _ = o(e.nodes);
          (a.length > 0 && (i.geometries = a),
            l.length > 0 && (i.materials = l),
            c.length > 0 && (i.textures = c),
            u.length > 0 && (i.images = u),
            f.length > 0 && (i.shapes = f),
            d.length > 0 && (i.skeletons = d),
            p.length > 0 && (i.animations = p),
            _.length > 0 && (i.nodes = _));
        }
        return ((i.object = n), i);
        function o(a) {
          let l = [];
          for (let c in a) {
            let u = a[c];
            (delete u.metadata, l.push(u));
          }
          return l;
        }
      }
      clone(e) {
        return new this.constructor().copy(this, e);
      }
      copy(e, t = !0) {
        if (
          ((this.name = e.name),
          this.up.copy(e.up),
          this.position.copy(e.position),
          (this.rotation.order = e.rotation.order),
          this.quaternion.copy(e.quaternion),
          this.scale.copy(e.scale),
          (this.pivot = e.pivot !== null ? e.pivot.clone() : null),
          this.matrix.copy(e.matrix),
          this.matrixWorld.copy(e.matrixWorld),
          (this.matrixAutoUpdate = e.matrixAutoUpdate),
          (this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate),
          (this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate),
          (this.layers.mask = e.layers.mask),
          (this.visible = e.visible),
          (this.castShadow = e.castShadow),
          (this.receiveShadow = e.receiveShadow),
          (this.frustumCulled = e.frustumCulled),
          (this.renderOrder = e.renderOrder),
          (this.static = e.static),
          (this.animations = e.animations.slice()),
          (this.userData = JSON.parse(JSON.stringify(e.userData))),
          t === !0)
        )
          for (let i = 0; i < e.children.length; i++) {
            let n = e.children[i];
            this.add(n.clone());
          }
        return this;
      }
    };
  pi.DEFAULT_UP = new te(0, 1, 0);
  pi.DEFAULT_MATRIX_AUTO_UPDATE = !0;
  pi.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
  var Ri = class extends pi {
      constructor() {
        (super(), (this.isGroup = !0), (this.type = 'Group'));
      }
    },
    zT = { type: 'move' },
    qa = class {
      constructor() {
        ((this._targetRay = null), (this._grip = null), (this._hand = null));
      }
      getHandSpace() {
        return (
          this._hand === null &&
            ((this._hand = new Ri()),
            (this._hand.matrixAutoUpdate = !1),
            (this._hand.visible = !1),
            (this._hand.joints = {}),
            (this._hand.inputState = { pinching: !1 })),
          this._hand
        );
      }
      getTargetRaySpace() {
        return (
          this._targetRay === null &&
            ((this._targetRay = new Ri()),
            (this._targetRay.matrixAutoUpdate = !1),
            (this._targetRay.visible = !1),
            (this._targetRay.hasLinearVelocity = !1),
            (this._targetRay.linearVelocity = new te()),
            (this._targetRay.hasAngularVelocity = !1),
            (this._targetRay.angularVelocity = new te())),
          this._targetRay
        );
      }
      getGripSpace() {
        return (
          this._grip === null &&
            ((this._grip = new Ri()),
            (this._grip.matrixAutoUpdate = !1),
            (this._grip.visible = !1),
            (this._grip.hasLinearVelocity = !1),
            (this._grip.linearVelocity = new te()),
            (this._grip.hasAngularVelocity = !1),
            (this._grip.angularVelocity = new te()),
            (this._grip.eventsEnabled = !1)),
          this._grip
        );
      }
      dispatchEvent(e) {
        return (
          this._targetRay !== null && this._targetRay.dispatchEvent(e),
          this._grip !== null && this._grip.dispatchEvent(e),
          this._hand !== null && this._hand.dispatchEvent(e),
          this
        );
      }
      connect(e) {
        if (e && e.hand) {
          let t = this._hand;
          if (t) for (let i of e.hand.values()) this._getHandJoint(t, i);
        }
        return (this.dispatchEvent({ type: 'connected', data: e }), this);
      }
      disconnect(e) {
        return (
          this.dispatchEvent({ type: 'disconnected', data: e }),
          this._targetRay !== null && (this._targetRay.visible = !1),
          this._grip !== null && (this._grip.visible = !1),
          this._hand !== null && (this._hand.visible = !1),
          this
        );
      }
      update(e, t, i) {
        let n = null,
          r = null,
          o = null,
          a = this._targetRay,
          l = this._grip,
          c = this._hand;
        if (e && t.session.visibilityState !== 'visible-blurred') {
          if (c && e.hand) {
            o = !0;
            for (let x of e.hand.values()) {
              let g = t.getJointPose(x, i),
                v = this._getHandJoint(c, x);
              (g !== null &&
                (v.matrix.fromArray(g.transform.matrix),
                v.matrix.decompose(v.position, v.rotation, v.scale),
                (v.matrixWorldNeedsUpdate = !0),
                (v.jointRadius = g.radius)),
                (v.visible = g !== null));
            }
            let u = c.joints['index-finger-tip'],
              f = c.joints['thumb-tip'],
              d = u.position.distanceTo(f.position),
              p = 0.02,
              _ = 0.005;
            c.inputState.pinching && d > p + _
              ? ((c.inputState.pinching = !1),
                this.dispatchEvent({
                  type: 'pinchend',
                  handedness: e.handedness,
                  target: this,
                }))
              : !c.inputState.pinching &&
                d <= p - _ &&
                ((c.inputState.pinching = !0),
                this.dispatchEvent({
                  type: 'pinchstart',
                  handedness: e.handedness,
                  target: this,
                }));
          } else
            l !== null &&
              e.gripSpace &&
              ((r = t.getPose(e.gripSpace, i)),
              r !== null &&
                (l.matrix.fromArray(r.transform.matrix),
                l.matrix.decompose(l.position, l.rotation, l.scale),
                (l.matrixWorldNeedsUpdate = !0),
                r.linearVelocity
                  ? ((l.hasLinearVelocity = !0),
                    l.linearVelocity.copy(r.linearVelocity))
                  : (l.hasLinearVelocity = !1),
                r.angularVelocity
                  ? ((l.hasAngularVelocity = !0),
                    l.angularVelocity.copy(r.angularVelocity))
                  : (l.hasAngularVelocity = !1),
                l.eventsEnabled &&
                  l.dispatchEvent({
                    type: 'gripUpdated',
                    data: e,
                    target: this,
                  })));
          a !== null &&
            ((n = t.getPose(e.targetRaySpace, i)),
            n === null && r !== null && (n = r),
            n !== null &&
              (a.matrix.fromArray(n.transform.matrix),
              a.matrix.decompose(a.position, a.rotation, a.scale),
              (a.matrixWorldNeedsUpdate = !0),
              n.linearVelocity
                ? ((a.hasLinearVelocity = !0),
                  a.linearVelocity.copy(n.linearVelocity))
                : (a.hasLinearVelocity = !1),
              n.angularVelocity
                ? ((a.hasAngularVelocity = !0),
                  a.angularVelocity.copy(n.angularVelocity))
                : (a.hasAngularVelocity = !1),
              this.dispatchEvent(zT)));
        }
        return (
          a !== null && (a.visible = n !== null),
          l !== null && (l.visible = r !== null),
          c !== null && (c.visible = o !== null),
          this
        );
      }
      _getHandJoint(e, t) {
        if (e.joints[t.jointName] === void 0) {
          let i = new Ri();
          ((i.matrixAutoUpdate = !1),
            (i.visible = !1),
            (e.joints[t.jointName] = i),
            e.add(i));
        }
        return e.joints[t.jointName];
      }
    },
    Ey = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074,
    },
    Yr = { h: 0, s: 0, l: 0 },
    jh = { h: 0, s: 0, l: 0 };
  function pm(s, e, t) {
    return (
      t < 0 && (t += 1),
      t > 1 && (t -= 1),
      t < 1 / 6
        ? s + (e - s) * 6 * t
        : t < 1 / 2
          ? e
          : t < 2 / 3
            ? s + (e - s) * 6 * (2 / 3 - t)
            : s
    );
  }
  var je = class {
      constructor(e, t, i) {
        return (
          (this.isColor = !0),
          (this.r = 1),
          (this.g = 1),
          (this.b = 1),
          this.set(e, t, i)
        );
      }
      set(e, t, i) {
        if (t === void 0 && i === void 0) {
          let n = e;
          n && n.isColor
            ? this.copy(n)
            : typeof n == 'number'
              ? this.setHex(n)
              : typeof n == 'string' && this.setStyle(n);
        } else this.setRGB(e, t, i);
        return this;
      }
      setScalar(e) {
        return ((this.r = e), (this.g = e), (this.b = e), this);
      }
      setHex(e, t = zt) {
        return (
          (e = Math.floor(e)),
          (this.r = ((e >> 16) & 255) / 255),
          (this.g = ((e >> 8) & 255) / 255),
          (this.b = (e & 255) / 255),
          Ct.colorSpaceToWorking(this, t),
          this
        );
      }
      setRGB(e, t, i, n = Ct.workingColorSpace) {
        return (
          (this.r = e),
          (this.g = t),
          (this.b = i),
          Ct.colorSpaceToWorking(this, n),
          this
        );
      }
      setHSL(e, t, i, n = Ct.workingColorSpace) {
        if (((e = pg(e, 1)), (t = Dt(t, 0, 1)), (i = Dt(i, 0, 1)), t === 0))
          this.r = this.g = this.b = i;
        else {
          let r = i <= 0.5 ? i * (1 + t) : i + t - i * t,
            o = 2 * i - r;
          ((this.r = pm(o, r, e + 1 / 3)),
            (this.g = pm(o, r, e)),
            (this.b = pm(o, r, e - 1 / 3)));
        }
        return (Ct.colorSpaceToWorking(this, n), this);
      }
      setStyle(e, t = zt) {
        function i(r) {
          r !== void 0 &&
            parseFloat(r) < 1 &&
            it('Color: Alpha component of ' + e + ' will be ignored.');
        }
        let n;
        if ((n = /^(\w+)\(([^\)]*)\)/.exec(e))) {
          let r,
            o = n[1],
            a = n[2];
          switch (o) {
            case 'rgb':
            case 'rgba':
              if (
                (r =
                  /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                    a,
                  ))
              )
                return (
                  i(r[4]),
                  this.setRGB(
                    Math.min(255, parseInt(r[1], 10)) / 255,
                    Math.min(255, parseInt(r[2], 10)) / 255,
                    Math.min(255, parseInt(r[3], 10)) / 255,
                    t,
                  )
                );
              if (
                (r =
                  /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                    a,
                  ))
              )
                return (
                  i(r[4]),
                  this.setRGB(
                    Math.min(100, parseInt(r[1], 10)) / 100,
                    Math.min(100, parseInt(r[2], 10)) / 100,
                    Math.min(100, parseInt(r[3], 10)) / 100,
                    t,
                  )
                );
              break;
            case 'hsl':
            case 'hsla':
              if (
                (r =
                  /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                    a,
                  ))
              )
                return (
                  i(r[4]),
                  this.setHSL(
                    parseFloat(r[1]) / 360,
                    parseFloat(r[2]) / 100,
                    parseFloat(r[3]) / 100,
                    t,
                  )
                );
              break;
            default:
              it('Color: Unknown color model ' + e);
          }
        } else if ((n = /^\#([A-Fa-f\d]+)$/.exec(e))) {
          let r = n[1],
            o = r.length;
          if (o === 3)
            return this.setRGB(
              parseInt(r.charAt(0), 16) / 15,
              parseInt(r.charAt(1), 16) / 15,
              parseInt(r.charAt(2), 16) / 15,
              t,
            );
          if (o === 6) return this.setHex(parseInt(r, 16), t);
          it('Color: Invalid hex color ' + e);
        } else if (e && e.length > 0) return this.setColorName(e, t);
        return this;
      }
      setColorName(e, t = zt) {
        let i = Ey[e.toLowerCase()];
        return (
          i !== void 0 ? this.setHex(i, t) : it('Color: Unknown color ' + e),
          this
        );
      }
      clone() {
        return new this.constructor(this.r, this.g, this.b);
      }
      copy(e) {
        return ((this.r = e.r), (this.g = e.g), (this.b = e.b), this);
      }
      copySRGBToLinear(e) {
        return (
          (this.r = Er(e.r)),
          (this.g = Er(e.g)),
          (this.b = Er(e.b)),
          this
        );
      }
      copyLinearToSRGB(e) {
        return (
          (this.r = za(e.r)),
          (this.g = za(e.g)),
          (this.b = za(e.b)),
          this
        );
      }
      convertSRGBToLinear() {
        return (this.copySRGBToLinear(this), this);
      }
      convertLinearToSRGB() {
        return (this.copyLinearToSRGB(this), this);
      }
      getHex(e = zt) {
        return (
          Ct.workingToColorSpace(sn.copy(this), e),
          Math.round(Dt(sn.r * 255, 0, 255)) * 65536 +
            Math.round(Dt(sn.g * 255, 0, 255)) * 256 +
            Math.round(Dt(sn.b * 255, 0, 255))
        );
      }
      getHexString(e = zt) {
        return ('000000' + this.getHex(e).toString(16)).slice(-6);
      }
      getHSL(e, t = Ct.workingColorSpace) {
        Ct.workingToColorSpace(sn.copy(this), t);
        let i = sn.r,
          n = sn.g,
          r = sn.b,
          o = Math.max(i, n, r),
          a = Math.min(i, n, r),
          l,
          c,
          u = (a + o) / 2;
        if (a === o) ((l = 0), (c = 0));
        else {
          let f = o - a;
          switch (((c = u <= 0.5 ? f / (o + a) : f / (2 - o - a)), o)) {
            case i:
              l = (n - r) / f + (n < r ? 6 : 0);
              break;
            case n:
              l = (r - i) / f + 2;
              break;
            case r:
              l = (i - n) / f + 4;
              break;
          }
          l /= 6;
        }
        return ((e.h = l), (e.s = c), (e.l = u), e);
      }
      getRGB(e, t = Ct.workingColorSpace) {
        return (
          Ct.workingToColorSpace(sn.copy(this), t),
          (e.r = sn.r),
          (e.g = sn.g),
          (e.b = sn.b),
          e
        );
      }
      getStyle(e = zt) {
        Ct.workingToColorSpace(sn.copy(this), e);
        let t = sn.r,
          i = sn.g,
          n = sn.b;
        return e !== zt
          ? `color(${e} ${t.toFixed(3)} ${i.toFixed(3)} ${n.toFixed(3)})`
          : `rgb(${Math.round(t * 255)},${Math.round(i * 255)},${Math.round(n * 255)})`;
      }
      offsetHSL(e, t, i) {
        return (this.getHSL(Yr), this.setHSL(Yr.h + e, Yr.s + t, Yr.l + i));
      }
      add(e) {
        return ((this.r += e.r), (this.g += e.g), (this.b += e.b), this);
      }
      addColors(e, t) {
        return (
          (this.r = e.r + t.r),
          (this.g = e.g + t.g),
          (this.b = e.b + t.b),
          this
        );
      }
      addScalar(e) {
        return ((this.r += e), (this.g += e), (this.b += e), this);
      }
      sub(e) {
        return (
          (this.r = Math.max(0, this.r - e.r)),
          (this.g = Math.max(0, this.g - e.g)),
          (this.b = Math.max(0, this.b - e.b)),
          this
        );
      }
      multiply(e) {
        return ((this.r *= e.r), (this.g *= e.g), (this.b *= e.b), this);
      }
      multiplyScalar(e) {
        return ((this.r *= e), (this.g *= e), (this.b *= e), this);
      }
      lerp(e, t) {
        return (
          (this.r += (e.r - this.r) * t),
          (this.g += (e.g - this.g) * t),
          (this.b += (e.b - this.b) * t),
          this
        );
      }
      lerpColors(e, t, i) {
        return (
          (this.r = e.r + (t.r - e.r) * i),
          (this.g = e.g + (t.g - e.g) * i),
          (this.b = e.b + (t.b - e.b) * i),
          this
        );
      }
      lerpHSL(e, t) {
        (this.getHSL(Yr), e.getHSL(jh));
        let i = uc(Yr.h, jh.h, t),
          n = uc(Yr.s, jh.s, t),
          r = uc(Yr.l, jh.l, t);
        return (this.setHSL(i, n, r), this);
      }
      setFromVector3(e) {
        return ((this.r = e.x), (this.g = e.y), (this.b = e.z), this);
      }
      applyMatrix3(e) {
        let t = this.r,
          i = this.g,
          n = this.b,
          r = e.elements;
        return (
          (this.r = r[0] * t + r[3] * i + r[6] * n),
          (this.g = r[1] * t + r[4] * i + r[7] * n),
          (this.b = r[2] * t + r[5] * i + r[8] * n),
          this
        );
      }
      equals(e) {
        return e.r === this.r && e.g === this.g && e.b === this.b;
      }
      fromArray(e, t = 0) {
        return (
          (this.r = e[t]),
          (this.g = e[t + 1]),
          (this.b = e[t + 2]),
          this
        );
      }
      toArray(e = [], t = 0) {
        return ((e[t] = this.r), (e[t + 1] = this.g), (e[t + 2] = this.b), e);
      }
      fromBufferAttribute(e, t) {
        return (
          (this.r = e.getX(t)),
          (this.g = e.getY(t)),
          (this.b = e.getZ(t)),
          this
        );
      }
      toJSON() {
        return this.getHex();
      }
      *[Symbol.iterator]() {
        (yield this.r, yield this.g, yield this.b);
      }
    },
    sn = new je();
  je.NAMES = Ey;
  var Wn = class extends pi {
      constructor() {
        (super(),
          (this.isScene = !0),
          (this.type = 'Scene'),
          (this.background = null),
          (this.environment = null),
          (this.fog = null),
          (this.backgroundBlurriness = 0),
          (this.backgroundIntensity = 1),
          (this.backgroundRotation = new Ts()),
          (this.environmentIntensity = 1),
          (this.environmentRotation = new Ts()),
          (this.overrideMaterial = null),
          typeof __THREE_DEVTOOLS__ != 'undefined' &&
            __THREE_DEVTOOLS__.dispatchEvent(
              new CustomEvent('observe', { detail: this }),
            ));
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          e.background !== null && (this.background = e.background.clone()),
          e.environment !== null && (this.environment = e.environment.clone()),
          e.fog !== null && (this.fog = e.fog.clone()),
          (this.backgroundBlurriness = e.backgroundBlurriness),
          (this.backgroundIntensity = e.backgroundIntensity),
          this.backgroundRotation.copy(e.backgroundRotation),
          (this.environmentIntensity = e.environmentIntensity),
          this.environmentRotation.copy(e.environmentRotation),
          e.overrideMaterial !== null &&
            (this.overrideMaterial = e.overrideMaterial.clone()),
          (this.matrixAutoUpdate = e.matrixAutoUpdate),
          this
        );
      }
      toJSON(e) {
        let t = super.toJSON(e);
        return (
          this.fog !== null && (t.object.fog = this.fog.toJSON()),
          this.backgroundBlurriness > 0 &&
            (t.object.backgroundBlurriness = this.backgroundBlurriness),
          this.backgroundIntensity !== 1 &&
            (t.object.backgroundIntensity = this.backgroundIntensity),
          (t.object.backgroundRotation = this.backgroundRotation.toArray()),
          this.environmentIntensity !== 1 &&
            (t.object.environmentIntensity = this.environmentIntensity),
          (t.object.environmentRotation = this.environmentRotation.toArray()),
          t
        );
      }
    },
    _s = new te(),
    vr = new te(),
    mm = new te(),
    xr = new te(),
    La = new te(),
    Ia = new te(),
    gx = new te(),
    gm = new te(),
    _m = new te(),
    vm = new te(),
    xm = new Qt(),
    ym = new Qt(),
    bm = new Qt(),
    jr = class s {
      constructor(e = new te(), t = new te(), i = new te()) {
        ((this.a = e), (this.b = t), (this.c = i));
      }
      static getNormal(e, t, i, n) {
        (n.subVectors(i, t), _s.subVectors(e, t), n.cross(_s));
        let r = n.lengthSq();
        return r > 0 ? n.multiplyScalar(1 / Math.sqrt(r)) : n.set(0, 0, 0);
      }
      static getBarycoord(e, t, i, n, r) {
        (_s.subVectors(n, t), vr.subVectors(i, t), mm.subVectors(e, t));
        let o = _s.dot(_s),
          a = _s.dot(vr),
          l = _s.dot(mm),
          c = vr.dot(vr),
          u = vr.dot(mm),
          f = o * c - a * a;
        if (f === 0) return (r.set(0, 0, 0), null);
        let d = 1 / f,
          p = (c * l - a * u) * d,
          _ = (o * u - a * l) * d;
        return r.set(1 - p - _, _, p);
      }
      static containsPoint(e, t, i, n) {
        return this.getBarycoord(e, t, i, n, xr) === null
          ? !1
          : xr.x >= 0 && xr.y >= 0 && xr.x + xr.y <= 1;
      }
      static getInterpolation(e, t, i, n, r, o, a, l) {
        return this.getBarycoord(e, t, i, n, xr) === null
          ? ((l.x = 0),
            (l.y = 0),
            'z' in l && (l.z = 0),
            'w' in l && (l.w = 0),
            null)
          : (l.setScalar(0),
            l.addScaledVector(r, xr.x),
            l.addScaledVector(o, xr.y),
            l.addScaledVector(a, xr.z),
            l);
      }
      static getInterpolatedAttribute(e, t, i, n, r, o) {
        return (
          xm.setScalar(0),
          ym.setScalar(0),
          bm.setScalar(0),
          xm.fromBufferAttribute(e, t),
          ym.fromBufferAttribute(e, i),
          bm.fromBufferAttribute(e, n),
          o.setScalar(0),
          o.addScaledVector(xm, r.x),
          o.addScaledVector(ym, r.y),
          o.addScaledVector(bm, r.z),
          o
        );
      }
      static isFrontFacing(e, t, i, n) {
        return (
          _s.subVectors(i, t),
          vr.subVectors(e, t),
          _s.cross(vr).dot(n) < 0
        );
      }
      set(e, t, i) {
        return (this.a.copy(e), this.b.copy(t), this.c.copy(i), this);
      }
      setFromPointsAndIndices(e, t, i, n) {
        return (this.a.copy(e[t]), this.b.copy(e[i]), this.c.copy(e[n]), this);
      }
      setFromAttributeAndIndices(e, t, i, n) {
        return (
          this.a.fromBufferAttribute(e, t),
          this.b.fromBufferAttribute(e, i),
          this.c.fromBufferAttribute(e, n),
          this
        );
      }
      clone() {
        return new this.constructor().copy(this);
      }
      copy(e) {
        return (this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this);
      }
      getArea() {
        return (
          _s.subVectors(this.c, this.b),
          vr.subVectors(this.a, this.b),
          _s.cross(vr).length() * 0.5
        );
      }
      getMidpoint(e) {
        return e
          .addVectors(this.a, this.b)
          .add(this.c)
          .multiplyScalar(1 / 3);
      }
      getNormal(e) {
        return s.getNormal(this.a, this.b, this.c, e);
      }
      getPlane(e) {
        return e.setFromCoplanarPoints(this.a, this.b, this.c);
      }
      getBarycoord(e, t) {
        return s.getBarycoord(e, this.a, this.b, this.c, t);
      }
      getInterpolation(e, t, i, n, r) {
        return s.getInterpolation(e, this.a, this.b, this.c, t, i, n, r);
      }
      containsPoint(e) {
        return s.containsPoint(e, this.a, this.b, this.c);
      }
      isFrontFacing(e) {
        return s.isFrontFacing(this.a, this.b, this.c, e);
      }
      intersectsBox(e) {
        return e.intersectsTriangle(this);
      }
      closestPointToPoint(e, t) {
        let i = this.a,
          n = this.b,
          r = this.c,
          o,
          a;
        (La.subVectors(n, i), Ia.subVectors(r, i), gm.subVectors(e, i));
        let l = La.dot(gm),
          c = Ia.dot(gm);
        if (l <= 0 && c <= 0) return t.copy(i);
        _m.subVectors(e, n);
        let u = La.dot(_m),
          f = Ia.dot(_m);
        if (u >= 0 && f <= u) return t.copy(n);
        let d = l * f - u * c;
        if (d <= 0 && l >= 0 && u <= 0)
          return ((o = l / (l - u)), t.copy(i).addScaledVector(La, o));
        vm.subVectors(e, r);
        let p = La.dot(vm),
          _ = Ia.dot(vm);
        if (_ >= 0 && p <= _) return t.copy(r);
        let x = p * c - l * _;
        if (x <= 0 && c >= 0 && _ <= 0)
          return ((a = c / (c - _)), t.copy(i).addScaledVector(Ia, a));
        let g = u * _ - p * f;
        if (g <= 0 && f - u >= 0 && p - _ >= 0)
          return (
            gx.subVectors(r, n),
            (a = (f - u) / (f - u + (p - _))),
            t.copy(n).addScaledVector(gx, a)
          );
        let v = 1 / (g + x + d);
        return (
          (o = x * v),
          (a = d * v),
          t.copy(i).addScaledVector(La, o).addScaledVector(Ia, a)
        );
      }
      equals(e) {
        return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
      }
    },
    yn = class {
      constructor(
        e = new te(1 / 0, 1 / 0, 1 / 0),
        t = new te(-1 / 0, -1 / 0, -1 / 0),
      ) {
        ((this.isBox3 = !0), (this.min = e), (this.max = t));
      }
      set(e, t) {
        return (this.min.copy(e), this.max.copy(t), this);
      }
      setFromArray(e) {
        this.makeEmpty();
        for (let t = 0, i = e.length; t < i; t += 3)
          this.expandByPoint(vs.fromArray(e, t));
        return this;
      }
      setFromBufferAttribute(e) {
        this.makeEmpty();
        for (let t = 0, i = e.count; t < i; t++)
          this.expandByPoint(vs.fromBufferAttribute(e, t));
        return this;
      }
      setFromPoints(e) {
        this.makeEmpty();
        for (let t = 0, i = e.length; t < i; t++) this.expandByPoint(e[t]);
        return this;
      }
      setFromCenterAndSize(e, t) {
        let i = vs.copy(t).multiplyScalar(0.5);
        return (this.min.copy(e).sub(i), this.max.copy(e).add(i), this);
      }
      setFromObject(e, t = !1) {
        return (this.makeEmpty(), this.expandByObject(e, t));
      }
      clone() {
        return new this.constructor().copy(this);
      }
      copy(e) {
        return (this.min.copy(e.min), this.max.copy(e.max), this);
      }
      makeEmpty() {
        return (
          (this.min.x = this.min.y = this.min.z = 1 / 0),
          (this.max.x = this.max.y = this.max.z = -1 / 0),
          this
        );
      }
      isEmpty() {
        return (
          this.max.x < this.min.x ||
          this.max.y < this.min.y ||
          this.max.z < this.min.z
        );
      }
      getCenter(e) {
        return this.isEmpty()
          ? e.set(0, 0, 0)
          : e.addVectors(this.min, this.max).multiplyScalar(0.5);
      }
      getSize(e) {
        return this.isEmpty()
          ? e.set(0, 0, 0)
          : e.subVectors(this.max, this.min);
      }
      expandByPoint(e) {
        return (this.min.min(e), this.max.max(e), this);
      }
      expandByVector(e) {
        return (this.min.sub(e), this.max.add(e), this);
      }
      expandByScalar(e) {
        return (this.min.addScalar(-e), this.max.addScalar(e), this);
      }
      expandByObject(e, t = !1) {
        e.updateWorldMatrix(!1, !1);
        let i = e.geometry;
        if (i !== void 0) {
          let r = i.getAttribute('position');
          if (t === !0 && r !== void 0 && e.isInstancedMesh !== !0)
            for (let o = 0, a = r.count; o < a; o++)
              (e.isMesh === !0
                ? e.getVertexPosition(o, vs)
                : vs.fromBufferAttribute(r, o),
                vs.applyMatrix4(e.matrixWorld),
                this.expandByPoint(vs));
          else
            (e.boundingBox !== void 0
              ? (e.boundingBox === null && e.computeBoundingBox(),
                Jh.copy(e.boundingBox))
              : (i.boundingBox === null && i.computeBoundingBox(),
                Jh.copy(i.boundingBox)),
              Jh.applyMatrix4(e.matrixWorld),
              this.union(Jh));
        }
        let n = e.children;
        for (let r = 0, o = n.length; r < o; r++) this.expandByObject(n[r], t);
        return this;
      }
      containsPoint(e) {
        return (
          e.x >= this.min.x &&
          e.x <= this.max.x &&
          e.y >= this.min.y &&
          e.y <= this.max.y &&
          e.z >= this.min.z &&
          e.z <= this.max.z
        );
      }
      containsBox(e) {
        return (
          this.min.x <= e.min.x &&
          e.max.x <= this.max.x &&
          this.min.y <= e.min.y &&
          e.max.y <= this.max.y &&
          this.min.z <= e.min.z &&
          e.max.z <= this.max.z
        );
      }
      getParameter(e, t) {
        return t.set(
          (e.x - this.min.x) / (this.max.x - this.min.x),
          (e.y - this.min.y) / (this.max.y - this.min.y),
          (e.z - this.min.z) / (this.max.z - this.min.z),
        );
      }
      intersectsBox(e) {
        return (
          e.max.x >= this.min.x &&
          e.min.x <= this.max.x &&
          e.max.y >= this.min.y &&
          e.min.y <= this.max.y &&
          e.max.z >= this.min.z &&
          e.min.z <= this.max.z
        );
      }
      intersectsSphere(e) {
        return (
          this.clampPoint(e.center, vs),
          vs.distanceToSquared(e.center) <= e.radius * e.radius
        );
      }
      intersectsPlane(e) {
        let t, i;
        return (
          e.normal.x > 0
            ? ((t = e.normal.x * this.min.x), (i = e.normal.x * this.max.x))
            : ((t = e.normal.x * this.max.x), (i = e.normal.x * this.min.x)),
          e.normal.y > 0
            ? ((t += e.normal.y * this.min.y), (i += e.normal.y * this.max.y))
            : ((t += e.normal.y * this.max.y), (i += e.normal.y * this.min.y)),
          e.normal.z > 0
            ? ((t += e.normal.z * this.min.z), (i += e.normal.z * this.max.z))
            : ((t += e.normal.z * this.max.z), (i += e.normal.z * this.min.z)),
          t <= -e.constant && i >= -e.constant
        );
      }
      intersectsTriangle(e) {
        if (this.isEmpty()) return !1;
        (this.getCenter(nc),
          Qh.subVectors(this.max, nc),
          Da.subVectors(e.a, nc),
          Oa.subVectors(e.b, nc),
          Na.subVectors(e.c, nc),
          qr.subVectors(Oa, Da),
          Zr.subVectors(Na, Oa),
          Bo.subVectors(Da, Na));
        let t = [
          0,
          -qr.z,
          qr.y,
          0,
          -Zr.z,
          Zr.y,
          0,
          -Bo.z,
          Bo.y,
          qr.z,
          0,
          -qr.x,
          Zr.z,
          0,
          -Zr.x,
          Bo.z,
          0,
          -Bo.x,
          -qr.y,
          qr.x,
          0,
          -Zr.y,
          Zr.x,
          0,
          -Bo.y,
          Bo.x,
          0,
        ];
        return !Sm(t, Da, Oa, Na, Qh) ||
          ((t = [1, 0, 0, 0, 1, 0, 0, 0, 1]), !Sm(t, Da, Oa, Na, Qh))
          ? !1
          : (eu.crossVectors(qr, Zr),
            (t = [eu.x, eu.y, eu.z]),
            Sm(t, Da, Oa, Na, Qh));
      }
      clampPoint(e, t) {
        return t.copy(e).clamp(this.min, this.max);
      }
      distanceToPoint(e) {
        return this.clampPoint(e, vs).distanceTo(e);
      }
      getBoundingSphere(e) {
        return (
          this.isEmpty()
            ? e.makeEmpty()
            : (this.getCenter(e.center),
              (e.radius = this.getSize(vs).length() * 0.5)),
          e
        );
      }
      intersect(e) {
        return (
          this.min.max(e.min),
          this.max.min(e.max),
          this.isEmpty() && this.makeEmpty(),
          this
        );
      }
      union(e) {
        return (this.min.min(e.min), this.max.max(e.max), this);
      }
      applyMatrix4(e) {
        return this.isEmpty()
          ? this
          : (yr[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e),
            yr[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e),
            yr[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e),
            yr[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e),
            yr[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e),
            yr[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e),
            yr[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e),
            yr[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e),
            this.setFromPoints(yr),
            this);
      }
      translate(e) {
        return (this.min.add(e), this.max.add(e), this);
      }
      equals(e) {
        return e.min.equals(this.min) && e.max.equals(this.max);
      }
      toJSON() {
        return { min: this.min.toArray(), max: this.max.toArray() };
      }
      fromJSON(e) {
        return (this.min.fromArray(e.min), this.max.fromArray(e.max), this);
      }
    },
    yr = [
      new te(),
      new te(),
      new te(),
      new te(),
      new te(),
      new te(),
      new te(),
      new te(),
    ],
    vs = new te(),
    Jh = new yn(),
    Da = new te(),
    Oa = new te(),
    Na = new te(),
    qr = new te(),
    Zr = new te(),
    Bo = new te(),
    nc = new te(),
    Qh = new te(),
    eu = new te(),
    ko = new te();
  function Sm(s, e, t, i, n) {
    for (let r = 0, o = s.length - 3; r <= o; r += 3) {
      ko.fromArray(s, r);
      let a =
          n.x * Math.abs(ko.x) + n.y * Math.abs(ko.y) + n.z * Math.abs(ko.z),
        l = e.dot(ko),
        c = t.dot(ko),
        u = i.dot(ko);
      if (Math.max(-Math.max(l, c, u), Math.min(l, c, u)) > a) return !1;
    }
    return !0;
  }
  var Ai = new te(),
    tu = new et(),
    VT = 0,
    fi = class extends Es {
      constructor(e, t, i = !1) {
        if ((super(), Array.isArray(e)))
          throw new TypeError(
            'THREE.BufferAttribute: array should be a Typed Array.',
          );
        ((this.isBufferAttribute = !0),
          Object.defineProperty(this, 'id', { value: VT++ }),
          (this.name = ''),
          (this.array = e),
          (this.itemSize = t),
          (this.count = e !== void 0 ? e.length / t : 0),
          (this.normalized = i),
          (this.usage = Lu),
          (this.updateRanges = []),
          (this.gpuType = Xn),
          (this.version = 0));
      }
      onUploadCallback() {}
      set needsUpdate(e) {
        e === !0 && this.version++;
      }
      setUsage(e) {
        return ((this.usage = e), this);
      }
      addUpdateRange(e, t) {
        this.updateRanges.push({ start: e, count: t });
      }
      clearUpdateRanges() {
        this.updateRanges.length = 0;
      }
      copy(e) {
        return (
          (this.name = e.name),
          (this.array = new e.array.constructor(e.array)),
          (this.itemSize = e.itemSize),
          (this.count = e.count),
          (this.normalized = e.normalized),
          (this.usage = e.usage),
          (this.gpuType = e.gpuType),
          this
        );
      }
      copyAt(e, t, i) {
        ((e *= this.itemSize), (i *= t.itemSize));
        for (let n = 0, r = this.itemSize; n < r; n++)
          this.array[e + n] = t.array[i + n];
        return this;
      }
      copyArray(e) {
        return (this.array.set(e), this);
      }
      applyMatrix3(e) {
        if (this.itemSize === 2)
          for (let t = 0, i = this.count; t < i; t++)
            (tu.fromBufferAttribute(this, t),
              tu.applyMatrix3(e),
              this.setXY(t, tu.x, tu.y));
        else if (this.itemSize === 3)
          for (let t = 0, i = this.count; t < i; t++)
            (Ai.fromBufferAttribute(this, t),
              Ai.applyMatrix3(e),
              this.setXYZ(t, Ai.x, Ai.y, Ai.z));
        return this;
      }
      applyMatrix4(e) {
        for (let t = 0, i = this.count; t < i; t++)
          (Ai.fromBufferAttribute(this, t),
            Ai.applyMatrix4(e),
            this.setXYZ(t, Ai.x, Ai.y, Ai.z));
        return this;
      }
      applyNormalMatrix(e) {
        for (let t = 0, i = this.count; t < i; t++)
          (Ai.fromBufferAttribute(this, t),
            Ai.applyNormalMatrix(e),
            this.setXYZ(t, Ai.x, Ai.y, Ai.z));
        return this;
      }
      transformDirection(e) {
        for (let t = 0, i = this.count; t < i; t++)
          (Ai.fromBufferAttribute(this, t),
            Ai.transformDirection(e),
            this.setXYZ(t, Ai.x, Ai.y, Ai.z));
        return this;
      }
      set(e, t = 0) {
        return (this.array.set(e, t), this);
      }
      getComponent(e, t) {
        let i = this.array[e * this.itemSize + t];
        return (this.normalized && (i = xs(i, this.array)), i);
      }
      setComponent(e, t, i) {
        return (
          this.normalized && (i = jt(i, this.array)),
          (this.array[e * this.itemSize + t] = i),
          this
        );
      }
      getX(e) {
        let t = this.array[e * this.itemSize];
        return (this.normalized && (t = xs(t, this.array)), t);
      }
      setX(e, t) {
        return (
          this.normalized && (t = jt(t, this.array)),
          (this.array[e * this.itemSize] = t),
          this
        );
      }
      getY(e) {
        let t = this.array[e * this.itemSize + 1];
        return (this.normalized && (t = xs(t, this.array)), t);
      }
      setY(e, t) {
        return (
          this.normalized && (t = jt(t, this.array)),
          (this.array[e * this.itemSize + 1] = t),
          this
        );
      }
      getZ(e) {
        let t = this.array[e * this.itemSize + 2];
        return (this.normalized && (t = xs(t, this.array)), t);
      }
      setZ(e, t) {
        return (
          this.normalized && (t = jt(t, this.array)),
          (this.array[e * this.itemSize + 2] = t),
          this
        );
      }
      getW(e) {
        let t = this.array[e * this.itemSize + 3];
        return (this.normalized && (t = xs(t, this.array)), t);
      }
      setW(e, t) {
        return (
          this.normalized && (t = jt(t, this.array)),
          (this.array[e * this.itemSize + 3] = t),
          this
        );
      }
      setXY(e, t, i) {
        return (
          (e *= this.itemSize),
          this.normalized && ((t = jt(t, this.array)), (i = jt(i, this.array))),
          (this.array[e + 0] = t),
          (this.array[e + 1] = i),
          this
        );
      }
      setXYZ(e, t, i, n) {
        return (
          (e *= this.itemSize),
          this.normalized &&
            ((t = jt(t, this.array)),
            (i = jt(i, this.array)),
            (n = jt(n, this.array))),
          (this.array[e + 0] = t),
          (this.array[e + 1] = i),
          (this.array[e + 2] = n),
          this
        );
      }
      setXYZW(e, t, i, n, r) {
        return (
          (e *= this.itemSize),
          this.normalized &&
            ((t = jt(t, this.array)),
            (i = jt(i, this.array)),
            (n = jt(n, this.array)),
            (r = jt(r, this.array))),
          (this.array[e + 0] = t),
          (this.array[e + 1] = i),
          (this.array[e + 2] = n),
          (this.array[e + 3] = r),
          this
        );
      }
      onUpload(e) {
        return ((this.onUploadCallback = e), this);
      }
      clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
      }
      toJSON() {
        let e = {
          itemSize: this.itemSize,
          type: this.array.constructor.name,
          array: Array.from(this.array),
          normalized: this.normalized,
        };
        return (
          this.name !== '' && (e.name = this.name),
          this.usage !== Lu && (e.usage = this.usage),
          e
        );
      }
      dispose() {
        this.dispatchEvent({ type: 'dispose' });
      }
    };
  var gc = class extends fi {
    constructor(e, t, i) {
      super(new Uint16Array(e), t, i);
    }
  };
  var _c = class extends fi {
    constructor(e, t, i) {
      super(new Uint32Array(e), t, i);
    }
  };
  var Hi = class extends fi {
      constructor(e, t, i) {
        super(new Float32Array(e), t, i);
      }
    },
    GT = new yn(),
    sc = new te(),
    Em = new te(),
    An = class {
      constructor(e = new te(), t = -1) {
        ((this.isSphere = !0), (this.center = e), (this.radius = t));
      }
      set(e, t) {
        return (this.center.copy(e), (this.radius = t), this);
      }
      setFromPoints(e, t) {
        let i = this.center;
        t !== void 0 ? i.copy(t) : GT.setFromPoints(e).getCenter(i);
        let n = 0;
        for (let r = 0, o = e.length; r < o; r++)
          n = Math.max(n, i.distanceToSquared(e[r]));
        return ((this.radius = Math.sqrt(n)), this);
      }
      copy(e) {
        return (this.center.copy(e.center), (this.radius = e.radius), this);
      }
      isEmpty() {
        return this.radius < 0;
      }
      makeEmpty() {
        return (this.center.set(0, 0, 0), (this.radius = -1), this);
      }
      containsPoint(e) {
        return e.distanceToSquared(this.center) <= this.radius * this.radius;
      }
      distanceToPoint(e) {
        return e.distanceTo(this.center) - this.radius;
      }
      intersectsSphere(e) {
        let t = this.radius + e.radius;
        return e.center.distanceToSquared(this.center) <= t * t;
      }
      intersectsBox(e) {
        return e.intersectsSphere(this);
      }
      intersectsPlane(e) {
        return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
      }
      clampPoint(e, t) {
        let i = this.center.distanceToSquared(e);
        return (
          t.copy(e),
          i > this.radius * this.radius &&
            (t.sub(this.center).normalize(),
            t.multiplyScalar(this.radius).add(this.center)),
          t
        );
      }
      getBoundingBox(e) {
        return this.isEmpty()
          ? (e.makeEmpty(), e)
          : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
      }
      applyMatrix4(e) {
        return (
          this.center.applyMatrix4(e),
          (this.radius = this.radius * e.getMaxScaleOnAxis()),
          this
        );
      }
      translate(e) {
        return (this.center.add(e), this);
      }
      expandByPoint(e) {
        if (this.isEmpty())
          return (this.center.copy(e), (this.radius = 0), this);
        sc.subVectors(e, this.center);
        let t = sc.lengthSq();
        if (t > this.radius * this.radius) {
          let i = Math.sqrt(t),
            n = (i - this.radius) * 0.5;
          (this.center.addScaledVector(sc, n / i), (this.radius += n));
        }
        return this;
      }
      union(e) {
        return e.isEmpty()
          ? this
          : this.isEmpty()
            ? (this.copy(e), this)
            : (this.center.equals(e.center) === !0
                ? (this.radius = Math.max(this.radius, e.radius))
                : (Em.subVectors(e.center, this.center).setLength(e.radius),
                  this.expandByPoint(sc.copy(e.center).add(Em)),
                  this.expandByPoint(sc.copy(e.center).sub(Em))),
              this);
      }
      equals(e) {
        return e.center.equals(this.center) && e.radius === this.radius;
      }
      clone() {
        return new this.constructor().copy(this);
      }
      toJSON() {
        return { radius: this.radius, center: this.center.toArray() };
      }
      fromJSON(e) {
        return (
          (this.radius = e.radius),
          this.center.fromArray(e.center),
          this
        );
      }
    },
    WT = 0,
    ts = new yt(),
    Tm = new pi(),
    Fa = new te(),
    Gn = new yn(),
    rc = new yn(),
    ki = new te(),
    Vi = class s extends Es {
      constructor() {
        (super(),
          (this.isBufferGeometry = !0),
          Object.defineProperty(this, 'id', { value: WT++ }),
          (this.uuid = bs()),
          (this.name = ''),
          (this.type = 'BufferGeometry'),
          (this.index = null),
          (this.indirect = null),
          (this.indirectOffset = 0),
          (this.attributes = {}),
          (this.morphAttributes = {}),
          (this.morphTargetsRelative = !1),
          (this.groups = []),
          (this.boundingBox = null),
          (this.boundingSphere = null),
          (this.drawRange = { start: 0, count: 1 / 0 }),
          (this.userData = {}));
      }
      getIndex() {
        return this.index;
      }
      setIndex(e) {
        return (
          Array.isArray(e)
            ? (this.index = new (pT(e) ? _c : gc)(e, 1))
            : (this.index = e),
          this
        );
      }
      setIndirect(e, t = 0) {
        return ((this.indirect = e), (this.indirectOffset = t), this);
      }
      getIndirect() {
        return this.indirect;
      }
      getAttribute(e) {
        return this.attributes[e];
      }
      setAttribute(e, t) {
        return ((this.attributes[e] = t), this);
      }
      deleteAttribute(e) {
        return (delete this.attributes[e], this);
      }
      hasAttribute(e) {
        return this.attributes[e] !== void 0;
      }
      addGroup(e, t, i = 0) {
        this.groups.push({ start: e, count: t, materialIndex: i });
      }
      clearGroups() {
        this.groups = [];
      }
      setDrawRange(e, t) {
        ((this.drawRange.start = e), (this.drawRange.count = t));
      }
      applyMatrix4(e) {
        let t = this.attributes.position;
        t !== void 0 && (t.applyMatrix4(e), (t.needsUpdate = !0));
        let i = this.attributes.normal;
        if (i !== void 0) {
          let r = new St().getNormalMatrix(e);
          (i.applyNormalMatrix(r), (i.needsUpdate = !0));
        }
        let n = this.attributes.tangent;
        return (
          n !== void 0 && (n.transformDirection(e), (n.needsUpdate = !0)),
          this.boundingBox !== null && this.computeBoundingBox(),
          this.boundingSphere !== null && this.computeBoundingSphere(),
          this
        );
      }
      applyQuaternion(e) {
        return (ts.makeRotationFromQuaternion(e), this.applyMatrix4(ts), this);
      }
      rotateX(e) {
        return (ts.makeRotationX(e), this.applyMatrix4(ts), this);
      }
      rotateY(e) {
        return (ts.makeRotationY(e), this.applyMatrix4(ts), this);
      }
      rotateZ(e) {
        return (ts.makeRotationZ(e), this.applyMatrix4(ts), this);
      }
      translate(e, t, i) {
        return (ts.makeTranslation(e, t, i), this.applyMatrix4(ts), this);
      }
      scale(e, t, i) {
        return (ts.makeScale(e, t, i), this.applyMatrix4(ts), this);
      }
      lookAt(e) {
        return (
          Tm.lookAt(e),
          Tm.updateMatrix(),
          this.applyMatrix4(Tm.matrix),
          this
        );
      }
      center() {
        return (
          this.computeBoundingBox(),
          this.boundingBox.getCenter(Fa).negate(),
          this.translate(Fa.x, Fa.y, Fa.z),
          this
        );
      }
      setFromPoints(e) {
        let t = this.getAttribute('position');
        if (t === void 0) {
          let i = [];
          for (let n = 0, r = e.length; n < r; n++) {
            let o = e[n];
            i.push(o.x, o.y, o.z || 0);
          }
          this.setAttribute('position', new Hi(i, 3));
        } else {
          let i = Math.min(e.length, t.count);
          for (let n = 0; n < i; n++) {
            let r = e[n];
            t.setXYZ(n, r.x, r.y, r.z || 0);
          }
          (e.length > t.count &&
            it(
              'BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.',
            ),
            (t.needsUpdate = !0));
        }
        return this;
      }
      computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new yn());
        let e = this.attributes.position,
          t = this.morphAttributes.position;
        if (e && e.isGLBufferAttribute) {
          (mt(
            'BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.',
            this,
          ),
            this.boundingBox.set(
              new te(-1 / 0, -1 / 0, -1 / 0),
              new te(1 / 0, 1 / 0, 1 / 0),
            ));
          return;
        }
        if (e !== void 0) {
          if ((this.boundingBox.setFromBufferAttribute(e), t))
            for (let i = 0, n = t.length; i < n; i++) {
              let r = t[i];
              (Gn.setFromBufferAttribute(r),
                this.morphTargetsRelative
                  ? (ki.addVectors(this.boundingBox.min, Gn.min),
                    this.boundingBox.expandByPoint(ki),
                    ki.addVectors(this.boundingBox.max, Gn.max),
                    this.boundingBox.expandByPoint(ki))
                  : (this.boundingBox.expandByPoint(Gn.min),
                    this.boundingBox.expandByPoint(Gn.max)));
            }
        } else this.boundingBox.makeEmpty();
        (isNaN(this.boundingBox.min.x) ||
          isNaN(this.boundingBox.min.y) ||
          isNaN(this.boundingBox.min.z)) &&
          mt(
            'BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.',
            this,
          );
      }
      computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new An());
        let e = this.attributes.position,
          t = this.morphAttributes.position;
        if (e && e.isGLBufferAttribute) {
          (mt(
            'BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.',
            this,
          ),
            this.boundingSphere.set(new te(), 1 / 0));
          return;
        }
        if (e) {
          let i = this.boundingSphere.center;
          if ((Gn.setFromBufferAttribute(e), t))
            for (let r = 0, o = t.length; r < o; r++) {
              let a = t[r];
              (rc.setFromBufferAttribute(a),
                this.morphTargetsRelative
                  ? (ki.addVectors(Gn.min, rc.min),
                    Gn.expandByPoint(ki),
                    ki.addVectors(Gn.max, rc.max),
                    Gn.expandByPoint(ki))
                  : (Gn.expandByPoint(rc.min), Gn.expandByPoint(rc.max)));
            }
          Gn.getCenter(i);
          let n = 0;
          for (let r = 0, o = e.count; r < o; r++)
            (ki.fromBufferAttribute(e, r),
              (n = Math.max(n, i.distanceToSquared(ki))));
          if (t)
            for (let r = 0, o = t.length; r < o; r++) {
              let a = t[r],
                l = this.morphTargetsRelative;
              for (let c = 0, u = a.count; c < u; c++)
                (ki.fromBufferAttribute(a, c),
                  l && (Fa.fromBufferAttribute(e, c), ki.add(Fa)),
                  (n = Math.max(n, i.distanceToSquared(ki))));
            }
          ((this.boundingSphere.radius = Math.sqrt(n)),
            isNaN(this.boundingSphere.radius) &&
              mt(
                'BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.',
                this,
              ));
        }
      }
      computeTangents() {
        let e = this.index,
          t = this.attributes;
        if (
          e === null ||
          t.position === void 0 ||
          t.normal === void 0 ||
          t.uv === void 0
        ) {
          mt(
            'BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)',
          );
          return;
        }
        let i = t.position,
          n = t.normal,
          r = t.uv;
        this.hasAttribute('tangent') === !1 &&
          this.setAttribute(
            'tangent',
            new fi(new Float32Array(4 * i.count), 4),
          );
        let o = this.getAttribute('tangent'),
          a = [],
          l = [];
        for (let M = 0; M < i.count; M++)
          ((a[M] = new te()), (l[M] = new te()));
        let c = new te(),
          u = new te(),
          f = new te(),
          d = new et(),
          p = new et(),
          _ = new et(),
          x = new te(),
          g = new te();
        function v(M, I, z) {
          (c.fromBufferAttribute(i, M),
            u.fromBufferAttribute(i, I),
            f.fromBufferAttribute(i, z),
            d.fromBufferAttribute(r, M),
            p.fromBufferAttribute(r, I),
            _.fromBufferAttribute(r, z),
            u.sub(c),
            f.sub(c),
            p.sub(d),
            _.sub(d));
          let W = 1 / (p.x * _.y - _.x * p.y);
          isFinite(W) &&
            (x
              .copy(u)
              .multiplyScalar(_.y)
              .addScaledVector(f, -p.y)
              .multiplyScalar(W),
            g
              .copy(f)
              .multiplyScalar(p.x)
              .addScaledVector(u, -_.x)
              .multiplyScalar(W),
            a[M].add(x),
            a[I].add(x),
            a[z].add(x),
            l[M].add(g),
            l[I].add(g),
            l[z].add(g));
        }
        let w = this.groups;
        w.length === 0 && (w = [{ start: 0, count: e.count }]);
        for (let M = 0, I = w.length; M < I; ++M) {
          let z = w[M],
            W = z.start,
            q = z.count;
          for (let re = W, oe = W + q; re < oe; re += 3)
            v(e.getX(re + 0), e.getX(re + 1), e.getX(re + 2));
        }
        let L = new te(),
          R = new te(),
          U = new te(),
          O = new te();
        function N(M) {
          (U.fromBufferAttribute(n, M), O.copy(U));
          let I = a[M];
          (L.copy(I),
            L.sub(U.multiplyScalar(U.dot(I))).normalize(),
            R.crossVectors(O, I));
          let W = R.dot(l[M]) < 0 ? -1 : 1;
          o.setXYZW(M, L.x, L.y, L.z, W);
        }
        for (let M = 0, I = w.length; M < I; ++M) {
          let z = w[M],
            W = z.start,
            q = z.count;
          for (let re = W, oe = W + q; re < oe; re += 3)
            (N(e.getX(re + 0)), N(e.getX(re + 1)), N(e.getX(re + 2)));
        }
      }
      computeVertexNormals() {
        let e = this.index,
          t = this.getAttribute('position');
        if (t !== void 0) {
          let i = this.getAttribute('normal');
          if (i === void 0)
            ((i = new fi(new Float32Array(t.count * 3), 3)),
              this.setAttribute('normal', i));
          else for (let d = 0, p = i.count; d < p; d++) i.setXYZ(d, 0, 0, 0);
          let n = new te(),
            r = new te(),
            o = new te(),
            a = new te(),
            l = new te(),
            c = new te(),
            u = new te(),
            f = new te();
          if (e)
            for (let d = 0, p = e.count; d < p; d += 3) {
              let _ = e.getX(d + 0),
                x = e.getX(d + 1),
                g = e.getX(d + 2);
              (n.fromBufferAttribute(t, _),
                r.fromBufferAttribute(t, x),
                o.fromBufferAttribute(t, g),
                u.subVectors(o, r),
                f.subVectors(n, r),
                u.cross(f),
                a.fromBufferAttribute(i, _),
                l.fromBufferAttribute(i, x),
                c.fromBufferAttribute(i, g),
                a.add(u),
                l.add(u),
                c.add(u),
                i.setXYZ(_, a.x, a.y, a.z),
                i.setXYZ(x, l.x, l.y, l.z),
                i.setXYZ(g, c.x, c.y, c.z));
            }
          else
            for (let d = 0, p = t.count; d < p; d += 3)
              (n.fromBufferAttribute(t, d + 0),
                r.fromBufferAttribute(t, d + 1),
                o.fromBufferAttribute(t, d + 2),
                u.subVectors(o, r),
                f.subVectors(n, r),
                u.cross(f),
                i.setXYZ(d + 0, u.x, u.y, u.z),
                i.setXYZ(d + 1, u.x, u.y, u.z),
                i.setXYZ(d + 2, u.x, u.y, u.z));
          (this.normalizeNormals(), (i.needsUpdate = !0));
        }
      }
      normalizeNormals() {
        let e = this.attributes.normal;
        for (let t = 0, i = e.count; t < i; t++)
          (ki.fromBufferAttribute(e, t),
            ki.normalize(),
            e.setXYZ(t, ki.x, ki.y, ki.z));
      }
      toNonIndexed() {
        function e(a, l) {
          let c = a.array,
            u = a.itemSize,
            f = a.normalized,
            d = new c.constructor(l.length * u),
            p = 0,
            _ = 0;
          for (let x = 0, g = l.length; x < g; x++) {
            a.isInterleavedBufferAttribute
              ? (p = l[x] * a.data.stride + a.offset)
              : (p = l[x] * u);
            for (let v = 0; v < u; v++) d[_++] = c[p++];
          }
          return new fi(d, u, f);
        }
        if (this.index === null)
          return (
            it(
              'BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.',
            ),
            this
          );
        let t = new s(),
          i = this.index.array,
          n = this.attributes;
        for (let a in n) {
          let l = n[a],
            c = e(l, i);
          t.setAttribute(a, c);
        }
        let r = this.morphAttributes;
        for (let a in r) {
          let l = [],
            c = r[a];
          for (let u = 0, f = c.length; u < f; u++) {
            let d = c[u],
              p = e(d, i);
            l.push(p);
          }
          t.morphAttributes[a] = l;
        }
        t.morphTargetsRelative = this.morphTargetsRelative;
        let o = this.groups;
        for (let a = 0, l = o.length; a < l; a++) {
          let c = o[a];
          t.addGroup(c.start, c.count, c.materialIndex);
        }
        return t;
      }
      toJSON() {
        let e = {
          metadata: {
            version: 4.7,
            type: 'BufferGeometry',
            generator: 'BufferGeometry.toJSON',
          },
        };
        if (
          ((e.uuid = this.uuid),
          (e.type = this.type),
          this.name !== '' && (e.name = this.name),
          Object.keys(this.userData).length > 0 && (e.userData = this.userData),
          this.parameters !== void 0)
        ) {
          let l = this.parameters;
          for (let c in l) l[c] !== void 0 && (e[c] = l[c]);
          return e;
        }
        e.data = { attributes: {} };
        let t = this.index;
        t !== null &&
          (e.data.index = {
            type: t.array.constructor.name,
            array: Array.prototype.slice.call(t.array),
          });
        let i = this.attributes;
        for (let l in i) {
          let c = i[l];
          e.data.attributes[l] = c.toJSON(e.data);
        }
        let n = {},
          r = !1;
        for (let l in this.morphAttributes) {
          let c = this.morphAttributes[l],
            u = [];
          for (let f = 0, d = c.length; f < d; f++) {
            let p = c[f];
            u.push(p.toJSON(e.data));
          }
          u.length > 0 && ((n[l] = u), (r = !0));
        }
        r &&
          ((e.data.morphAttributes = n),
          (e.data.morphTargetsRelative = this.morphTargetsRelative));
        let o = this.groups;
        o.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(o)));
        let a = this.boundingSphere;
        return (a !== null && (e.data.boundingSphere = a.toJSON()), e);
      }
      clone() {
        return new this.constructor().copy(this);
      }
      copy(e) {
        ((this.index = null),
          (this.attributes = {}),
          (this.morphAttributes = {}),
          (this.groups = []),
          (this.boundingBox = null),
          (this.boundingSphere = null));
        let t = {};
        this.name = e.name;
        let i = e.index;
        i !== null && this.setIndex(i.clone());
        let n = e.attributes;
        for (let c in n) {
          let u = n[c];
          this.setAttribute(c, u.clone(t));
        }
        let r = e.morphAttributes;
        for (let c in r) {
          let u = [],
            f = r[c];
          for (let d = 0, p = f.length; d < p; d++) u.push(f[d].clone(t));
          this.morphAttributes[c] = u;
        }
        this.morphTargetsRelative = e.morphTargetsRelative;
        let o = e.groups;
        for (let c = 0, u = o.length; c < u; c++) {
          let f = o[c];
          this.addGroup(f.start, f.count, f.materialIndex);
        }
        let a = e.boundingBox;
        a !== null && (this.boundingBox = a.clone());
        let l = e.boundingSphere;
        return (
          l !== null && (this.boundingSphere = l.clone()),
          (this.drawRange.start = e.drawRange.start),
          (this.drawRange.count = e.drawRange.count),
          (this.userData = e.userData),
          this
        );
      }
      dispose() {
        this.dispatchEvent({ type: 'dispose' });
      }
    },
    eo = class {
      constructor(e, t) {
        ((this.isInterleavedBuffer = !0),
          (this.array = e),
          (this.stride = t),
          (this.count = e !== void 0 ? e.length / t : 0),
          (this.usage = Lu),
          (this.updateRanges = []),
          (this.version = 0),
          (this.uuid = bs()));
      }
      onUploadCallback() {}
      set needsUpdate(e) {
        e === !0 && this.version++;
      }
      setUsage(e) {
        return ((this.usage = e), this);
      }
      addUpdateRange(e, t) {
        this.updateRanges.push({ start: e, count: t });
      }
      clearUpdateRanges() {
        this.updateRanges.length = 0;
      }
      copy(e) {
        return (
          (this.array = new e.array.constructor(e.array)),
          (this.count = e.count),
          (this.stride = e.stride),
          (this.usage = e.usage),
          this
        );
      }
      copyAt(e, t, i) {
        ((e *= this.stride), (i *= t.stride));
        for (let n = 0, r = this.stride; n < r; n++)
          this.array[e + n] = t.array[i + n];
        return this;
      }
      set(e, t = 0) {
        return (this.array.set(e, t), this);
      }
      clone(e) {
        (e.arrayBuffers === void 0 && (e.arrayBuffers = {}),
          this.array.buffer._uuid === void 0 &&
            (this.array.buffer._uuid = bs()),
          e.arrayBuffers[this.array.buffer._uuid] === void 0 &&
            (e.arrayBuffers[this.array.buffer._uuid] =
              this.array.slice(0).buffer));
        let t = new this.array.constructor(
            e.arrayBuffers[this.array.buffer._uuid],
          ),
          i = new this.constructor(t, this.stride);
        return (i.setUsage(this.usage), i);
      }
      onUpload(e) {
        return ((this.onUploadCallback = e), this);
      }
      toJSON(e) {
        return (
          e.arrayBuffers === void 0 && (e.arrayBuffers = {}),
          this.array.buffer._uuid === void 0 &&
            (this.array.buffer._uuid = bs()),
          e.arrayBuffers[this.array.buffer._uuid] === void 0 &&
            (e.arrayBuffers[this.array.buffer._uuid] = Array.from(
              new Uint32Array(this.array.buffer),
            )),
          {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride,
          }
        );
      }
    },
    vn = new te(),
    to = class s {
      constructor(e, t, i, n = !1) {
        ((this.isInterleavedBufferAttribute = !0),
          (this.name = ''),
          (this.data = e),
          (this.itemSize = t),
          (this.offset = i),
          (this.normalized = n));
      }
      get count() {
        return this.data.count;
      }
      get array() {
        return this.data.array;
      }
      set needsUpdate(e) {
        this.data.needsUpdate = e;
      }
      applyMatrix4(e) {
        for (let t = 0, i = this.data.count; t < i; t++)
          (vn.fromBufferAttribute(this, t),
            vn.applyMatrix4(e),
            this.setXYZ(t, vn.x, vn.y, vn.z));
        return this;
      }
      applyNormalMatrix(e) {
        for (let t = 0, i = this.count; t < i; t++)
          (vn.fromBufferAttribute(this, t),
            vn.applyNormalMatrix(e),
            this.setXYZ(t, vn.x, vn.y, vn.z));
        return this;
      }
      transformDirection(e) {
        for (let t = 0, i = this.count; t < i; t++)
          (vn.fromBufferAttribute(this, t),
            vn.transformDirection(e),
            this.setXYZ(t, vn.x, vn.y, vn.z));
        return this;
      }
      getComponent(e, t) {
        let i = this.array[e * this.data.stride + this.offset + t];
        return (this.normalized && (i = xs(i, this.array)), i);
      }
      setComponent(e, t, i) {
        return (
          this.normalized && (i = jt(i, this.array)),
          (this.data.array[e * this.data.stride + this.offset + t] = i),
          this
        );
      }
      setX(e, t) {
        return (
          this.normalized && (t = jt(t, this.array)),
          (this.data.array[e * this.data.stride + this.offset] = t),
          this
        );
      }
      setY(e, t) {
        return (
          this.normalized && (t = jt(t, this.array)),
          (this.data.array[e * this.data.stride + this.offset + 1] = t),
          this
        );
      }
      setZ(e, t) {
        return (
          this.normalized && (t = jt(t, this.array)),
          (this.data.array[e * this.data.stride + this.offset + 2] = t),
          this
        );
      }
      setW(e, t) {
        return (
          this.normalized && (t = jt(t, this.array)),
          (this.data.array[e * this.data.stride + this.offset + 3] = t),
          this
        );
      }
      getX(e) {
        let t = this.data.array[e * this.data.stride + this.offset];
        return (this.normalized && (t = xs(t, this.array)), t);
      }
      getY(e) {
        let t = this.data.array[e * this.data.stride + this.offset + 1];
        return (this.normalized && (t = xs(t, this.array)), t);
      }
      getZ(e) {
        let t = this.data.array[e * this.data.stride + this.offset + 2];
        return (this.normalized && (t = xs(t, this.array)), t);
      }
      getW(e) {
        let t = this.data.array[e * this.data.stride + this.offset + 3];
        return (this.normalized && (t = xs(t, this.array)), t);
      }
      setXY(e, t, i) {
        return (
          (e = e * this.data.stride + this.offset),
          this.normalized && ((t = jt(t, this.array)), (i = jt(i, this.array))),
          (this.data.array[e + 0] = t),
          (this.data.array[e + 1] = i),
          this
        );
      }
      setXYZ(e, t, i, n) {
        return (
          (e = e * this.data.stride + this.offset),
          this.normalized &&
            ((t = jt(t, this.array)),
            (i = jt(i, this.array)),
            (n = jt(n, this.array))),
          (this.data.array[e + 0] = t),
          (this.data.array[e + 1] = i),
          (this.data.array[e + 2] = n),
          this
        );
      }
      setXYZW(e, t, i, n, r) {
        return (
          (e = e * this.data.stride + this.offset),
          this.normalized &&
            ((t = jt(t, this.array)),
            (i = jt(i, this.array)),
            (n = jt(n, this.array)),
            (r = jt(r, this.array))),
          (this.data.array[e + 0] = t),
          (this.data.array[e + 1] = i),
          (this.data.array[e + 2] = n),
          (this.data.array[e + 3] = r),
          this
        );
      }
      clone(e) {
        if (e === void 0) {
          fc(
            'InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.',
          );
          let t = [];
          for (let i = 0; i < this.count; i++) {
            let n = i * this.data.stride + this.offset;
            for (let r = 0; r < this.itemSize; r++)
              t.push(this.data.array[n + r]);
          }
          return new fi(
            new this.array.constructor(t),
            this.itemSize,
            this.normalized,
          );
        } else
          return (
            e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}),
            e.interleavedBuffers[this.data.uuid] === void 0 &&
              (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)),
            new s(
              e.interleavedBuffers[this.data.uuid],
              this.itemSize,
              this.offset,
              this.normalized,
            )
          );
      }
      toJSON(e) {
        if (e === void 0) {
          fc(
            'InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.',
          );
          let t = [];
          for (let i = 0; i < this.count; i++) {
            let n = i * this.data.stride + this.offset;
            for (let r = 0; r < this.itemSize; r++)
              t.push(this.data.array[n + r]);
          }
          return {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: t,
            normalized: this.normalized,
          };
        } else
          return (
            e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}),
            e.interleavedBuffers[this.data.uuid] === void 0 &&
              (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)),
            {
              isInterleavedBufferAttribute: !0,
              itemSize: this.itemSize,
              data: this.data.uuid,
              offset: this.offset,
              normalized: this.normalized,
            }
          );
      }
    },
    XT = 0,
    Rn = class extends Es {
      constructor() {
        (super(),
          (this.isMaterial = !0),
          Object.defineProperty(this, 'id', { value: XT++ }),
          (this.uuid = bs()),
          (this.name = ''),
          (this.type = 'Material'),
          (this.blending = Go),
          (this.side = Ss),
          (this.vertexColors = !1),
          (this.opacity = 1),
          (this.transparent = !1),
          (this.alphaHash = !1),
          (this.blendSrc = Su),
          (this.blendDst = Eu),
          (this.blendEquation = Jr),
          (this.blendSrcAlpha = null),
          (this.blendDstAlpha = null),
          (this.blendEquationAlpha = null),
          (this.blendColor = new je(0, 0, 0)),
          (this.blendAlpha = 0),
          (this.depthFunc = Wo),
          (this.depthTest = !0),
          (this.depthWrite = !0),
          (this.stencilWriteMask = 255),
          (this.stencilFunc = Hm),
          (this.stencilRef = 0),
          (this.stencilFuncMask = 255),
          (this.stencilFail = Vo),
          (this.stencilZFail = Vo),
          (this.stencilZPass = Vo),
          (this.stencilWrite = !1),
          (this.clippingPlanes = null),
          (this.clipIntersection = !1),
          (this.clipShadows = !1),
          (this.shadowSide = null),
          (this.colorWrite = !0),
          (this.precision = null),
          (this.polygonOffset = !1),
          (this.polygonOffsetFactor = 0),
          (this.polygonOffsetUnits = 0),
          (this.dithering = !1),
          (this.alphaToCoverage = !1),
          (this.premultipliedAlpha = !1),
          (this.forceSinglePass = !1),
          (this.allowOverride = !0),
          (this.visible = !0),
          (this.toneMapped = !0),
          (this.userData = {}),
          (this.version = 0),
          (this._alphaTest = 0));
      }
      get alphaTest() {
        return this._alphaTest;
      }
      set alphaTest(e) {
        (this._alphaTest > 0 != e > 0 && this.version++, (this._alphaTest = e));
      }
      onBeforeRender() {}
      onBeforeCompile() {}
      customProgramCacheKey() {
        return this.onBeforeCompile.toString();
      }
      setValues(e) {
        if (e !== void 0)
          for (let t in e) {
            let i = e[t];
            if (i === void 0) {
              it(`Material: parameter '${t}' has value of undefined.`);
              continue;
            }
            let n = this[t];
            if (n === void 0) {
              it(`Material: '${t}' is not a property of THREE.${this.type}.`);
              continue;
            }
            n && n.isColor
              ? n.set(i)
              : n && n.isVector3 && i && i.isVector3
                ? n.copy(i)
                : (this[t] = i);
          }
      }
      toJSON(e) {
        let t = e === void 0 || typeof e == 'string';
        t && (e = { textures: {}, images: {} });
        let i = {
          metadata: {
            version: 4.7,
            type: 'Material',
            generator: 'Material.toJSON',
          },
        };
        ((i.uuid = this.uuid),
          (i.type = this.type),
          this.name !== '' && (i.name = this.name),
          this.color && this.color.isColor && (i.color = this.color.getHex()),
          this.roughness !== void 0 && (i.roughness = this.roughness),
          this.metalness !== void 0 && (i.metalness = this.metalness),
          this.sheen !== void 0 && (i.sheen = this.sheen),
          this.sheenColor &&
            this.sheenColor.isColor &&
            (i.sheenColor = this.sheenColor.getHex()),
          this.sheenRoughness !== void 0 &&
            (i.sheenRoughness = this.sheenRoughness),
          this.emissive &&
            this.emissive.isColor &&
            (i.emissive = this.emissive.getHex()),
          this.emissiveIntensity !== void 0 &&
            this.emissiveIntensity !== 1 &&
            (i.emissiveIntensity = this.emissiveIntensity),
          this.specular &&
            this.specular.isColor &&
            (i.specular = this.specular.getHex()),
          this.specularIntensity !== void 0 &&
            (i.specularIntensity = this.specularIntensity),
          this.specularColor &&
            this.specularColor.isColor &&
            (i.specularColor = this.specularColor.getHex()),
          this.shininess !== void 0 && (i.shininess = this.shininess),
          this.clearcoat !== void 0 && (i.clearcoat = this.clearcoat),
          this.clearcoatRoughness !== void 0 &&
            (i.clearcoatRoughness = this.clearcoatRoughness),
          this.clearcoatMap &&
            this.clearcoatMap.isTexture &&
            (i.clearcoatMap = this.clearcoatMap.toJSON(e).uuid),
          this.clearcoatRoughnessMap &&
            this.clearcoatRoughnessMap.isTexture &&
            (i.clearcoatRoughnessMap =
              this.clearcoatRoughnessMap.toJSON(e).uuid),
          this.clearcoatNormalMap &&
            this.clearcoatNormalMap.isTexture &&
            ((i.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid),
            (i.clearcoatNormalScale = this.clearcoatNormalScale.toArray())),
          this.sheenColorMap &&
            this.sheenColorMap.isTexture &&
            (i.sheenColorMap = this.sheenColorMap.toJSON(e).uuid),
          this.sheenRoughnessMap &&
            this.sheenRoughnessMap.isTexture &&
            (i.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(e).uuid),
          this.dispersion !== void 0 && (i.dispersion = this.dispersion),
          this.iridescence !== void 0 && (i.iridescence = this.iridescence),
          this.iridescenceIOR !== void 0 &&
            (i.iridescenceIOR = this.iridescenceIOR),
          this.iridescenceThicknessRange !== void 0 &&
            (i.iridescenceThicknessRange = this.iridescenceThicknessRange),
          this.iridescenceMap &&
            this.iridescenceMap.isTexture &&
            (i.iridescenceMap = this.iridescenceMap.toJSON(e).uuid),
          this.iridescenceThicknessMap &&
            this.iridescenceThicknessMap.isTexture &&
            (i.iridescenceThicknessMap =
              this.iridescenceThicknessMap.toJSON(e).uuid),
          this.anisotropy !== void 0 && (i.anisotropy = this.anisotropy),
          this.anisotropyRotation !== void 0 &&
            (i.anisotropyRotation = this.anisotropyRotation),
          this.anisotropyMap &&
            this.anisotropyMap.isTexture &&
            (i.anisotropyMap = this.anisotropyMap.toJSON(e).uuid),
          this.map && this.map.isTexture && (i.map = this.map.toJSON(e).uuid),
          this.matcap &&
            this.matcap.isTexture &&
            (i.matcap = this.matcap.toJSON(e).uuid),
          this.alphaMap &&
            this.alphaMap.isTexture &&
            (i.alphaMap = this.alphaMap.toJSON(e).uuid),
          this.lightMap &&
            this.lightMap.isTexture &&
            ((i.lightMap = this.lightMap.toJSON(e).uuid),
            (i.lightMapIntensity = this.lightMapIntensity)),
          this.aoMap &&
            this.aoMap.isTexture &&
            ((i.aoMap = this.aoMap.toJSON(e).uuid),
            (i.aoMapIntensity = this.aoMapIntensity)),
          this.bumpMap &&
            this.bumpMap.isTexture &&
            ((i.bumpMap = this.bumpMap.toJSON(e).uuid),
            (i.bumpScale = this.bumpScale)),
          this.normalMap &&
            this.normalMap.isTexture &&
            ((i.normalMap = this.normalMap.toJSON(e).uuid),
            (i.normalMapType = this.normalMapType),
            (i.normalScale = this.normalScale.toArray())),
          this.displacementMap &&
            this.displacementMap.isTexture &&
            ((i.displacementMap = this.displacementMap.toJSON(e).uuid),
            (i.displacementScale = this.displacementScale),
            (i.displacementBias = this.displacementBias)),
          this.roughnessMap &&
            this.roughnessMap.isTexture &&
            (i.roughnessMap = this.roughnessMap.toJSON(e).uuid),
          this.metalnessMap &&
            this.metalnessMap.isTexture &&
            (i.metalnessMap = this.metalnessMap.toJSON(e).uuid),
          this.emissiveMap &&
            this.emissiveMap.isTexture &&
            (i.emissiveMap = this.emissiveMap.toJSON(e).uuid),
          this.specularMap &&
            this.specularMap.isTexture &&
            (i.specularMap = this.specularMap.toJSON(e).uuid),
          this.specularIntensityMap &&
            this.specularIntensityMap.isTexture &&
            (i.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid),
          this.specularColorMap &&
            this.specularColorMap.isTexture &&
            (i.specularColorMap = this.specularColorMap.toJSON(e).uuid),
          this.envMap &&
            this.envMap.isTexture &&
            ((i.envMap = this.envMap.toJSON(e).uuid),
            this.combine !== void 0 && (i.combine = this.combine)),
          this.envMapRotation !== void 0 &&
            (i.envMapRotation = this.envMapRotation.toArray()),
          this.envMapIntensity !== void 0 &&
            (i.envMapIntensity = this.envMapIntensity),
          this.reflectivity !== void 0 && (i.reflectivity = this.reflectivity),
          this.refractionRatio !== void 0 &&
            (i.refractionRatio = this.refractionRatio),
          this.gradientMap &&
            this.gradientMap.isTexture &&
            (i.gradientMap = this.gradientMap.toJSON(e).uuid),
          this.transmission !== void 0 && (i.transmission = this.transmission),
          this.transmissionMap &&
            this.transmissionMap.isTexture &&
            (i.transmissionMap = this.transmissionMap.toJSON(e).uuid),
          this.thickness !== void 0 && (i.thickness = this.thickness),
          this.thicknessMap &&
            this.thicknessMap.isTexture &&
            (i.thicknessMap = this.thicknessMap.toJSON(e).uuid),
          this.attenuationDistance !== void 0 &&
            this.attenuationDistance !== 1 / 0 &&
            (i.attenuationDistance = this.attenuationDistance),
          this.attenuationColor !== void 0 &&
            (i.attenuationColor = this.attenuationColor.getHex()),
          this.size !== void 0 && (i.size = this.size),
          this.shadowSide !== null && (i.shadowSide = this.shadowSide),
          this.sizeAttenuation !== void 0 &&
            (i.sizeAttenuation = this.sizeAttenuation),
          this.blending !== Go && (i.blending = this.blending),
          this.side !== Ss && (i.side = this.side),
          this.vertexColors === !0 && (i.vertexColors = !0),
          this.opacity < 1 && (i.opacity = this.opacity),
          this.transparent === !0 && (i.transparent = !0),
          this.blendSrc !== Su && (i.blendSrc = this.blendSrc),
          this.blendDst !== Eu && (i.blendDst = this.blendDst),
          this.blendEquation !== Jr && (i.blendEquation = this.blendEquation),
          this.blendSrcAlpha !== null && (i.blendSrcAlpha = this.blendSrcAlpha),
          this.blendDstAlpha !== null && (i.blendDstAlpha = this.blendDstAlpha),
          this.blendEquationAlpha !== null &&
            (i.blendEquationAlpha = this.blendEquationAlpha),
          this.blendColor &&
            this.blendColor.isColor &&
            (i.blendColor = this.blendColor.getHex()),
          this.blendAlpha !== 0 && (i.blendAlpha = this.blendAlpha),
          this.depthFunc !== Wo && (i.depthFunc = this.depthFunc),
          this.depthTest === !1 && (i.depthTest = this.depthTest),
          this.depthWrite === !1 && (i.depthWrite = this.depthWrite),
          this.colorWrite === !1 && (i.colorWrite = this.colorWrite),
          this.stencilWriteMask !== 255 &&
            (i.stencilWriteMask = this.stencilWriteMask),
          this.stencilFunc !== Hm && (i.stencilFunc = this.stencilFunc),
          this.stencilRef !== 0 && (i.stencilRef = this.stencilRef),
          this.stencilFuncMask !== 255 &&
            (i.stencilFuncMask = this.stencilFuncMask),
          this.stencilFail !== Vo && (i.stencilFail = this.stencilFail),
          this.stencilZFail !== Vo && (i.stencilZFail = this.stencilZFail),
          this.stencilZPass !== Vo && (i.stencilZPass = this.stencilZPass),
          this.stencilWrite === !0 && (i.stencilWrite = this.stencilWrite),
          this.rotation !== void 0 &&
            this.rotation !== 0 &&
            (i.rotation = this.rotation),
          this.polygonOffset === !0 && (i.polygonOffset = !0),
          this.polygonOffsetFactor !== 0 &&
            (i.polygonOffsetFactor = this.polygonOffsetFactor),
          this.polygonOffsetUnits !== 0 &&
            (i.polygonOffsetUnits = this.polygonOffsetUnits),
          this.linewidth !== void 0 &&
            this.linewidth !== 1 &&
            (i.linewidth = this.linewidth),
          this.dashSize !== void 0 && (i.dashSize = this.dashSize),
          this.gapSize !== void 0 && (i.gapSize = this.gapSize),
          this.scale !== void 0 && (i.scale = this.scale),
          this.dithering === !0 && (i.dithering = !0),
          this.alphaTest > 0 && (i.alphaTest = this.alphaTest),
          this.alphaHash === !0 && (i.alphaHash = !0),
          this.alphaToCoverage === !0 && (i.alphaToCoverage = !0),
          this.premultipliedAlpha === !0 && (i.premultipliedAlpha = !0),
          this.forceSinglePass === !0 && (i.forceSinglePass = !0),
          this.allowOverride === !1 && (i.allowOverride = !1),
          this.wireframe === !0 && (i.wireframe = !0),
          this.wireframeLinewidth > 1 &&
            (i.wireframeLinewidth = this.wireframeLinewidth),
          this.wireframeLinecap !== 'round' &&
            (i.wireframeLinecap = this.wireframeLinecap),
          this.wireframeLinejoin !== 'round' &&
            (i.wireframeLinejoin = this.wireframeLinejoin),
          this.flatShading === !0 && (i.flatShading = !0),
          this.visible === !1 && (i.visible = !1),
          this.toneMapped === !1 && (i.toneMapped = !1),
          this.fog === !1 && (i.fog = !1),
          Object.keys(this.userData).length > 0 &&
            (i.userData = this.userData));
        function n(r) {
          let o = [];
          for (let a in r) {
            let l = r[a];
            (delete l.metadata, o.push(l));
          }
          return o;
        }
        if (t) {
          let r = n(e.textures),
            o = n(e.images);
          (r.length > 0 && (i.textures = r), o.length > 0 && (i.images = o));
        }
        return i;
      }
      clone() {
        return new this.constructor().copy(this);
      }
      copy(e) {
        ((this.name = e.name),
          (this.blending = e.blending),
          (this.side = e.side),
          (this.vertexColors = e.vertexColors),
          (this.opacity = e.opacity),
          (this.transparent = e.transparent),
          (this.blendSrc = e.blendSrc),
          (this.blendDst = e.blendDst),
          (this.blendEquation = e.blendEquation),
          (this.blendSrcAlpha = e.blendSrcAlpha),
          (this.blendDstAlpha = e.blendDstAlpha),
          (this.blendEquationAlpha = e.blendEquationAlpha),
          this.blendColor.copy(e.blendColor),
          (this.blendAlpha = e.blendAlpha),
          (this.depthFunc = e.depthFunc),
          (this.depthTest = e.depthTest),
          (this.depthWrite = e.depthWrite),
          (this.stencilWriteMask = e.stencilWriteMask),
          (this.stencilFunc = e.stencilFunc),
          (this.stencilRef = e.stencilRef),
          (this.stencilFuncMask = e.stencilFuncMask),
          (this.stencilFail = e.stencilFail),
          (this.stencilZFail = e.stencilZFail),
          (this.stencilZPass = e.stencilZPass),
          (this.stencilWrite = e.stencilWrite));
        let t = e.clippingPlanes,
          i = null;
        if (t !== null) {
          let n = t.length;
          i = new Array(n);
          for (let r = 0; r !== n; ++r) i[r] = t[r].clone();
        }
        return (
          (this.clippingPlanes = i),
          (this.clipIntersection = e.clipIntersection),
          (this.clipShadows = e.clipShadows),
          (this.shadowSide = e.shadowSide),
          (this.colorWrite = e.colorWrite),
          (this.precision = e.precision),
          (this.polygonOffset = e.polygonOffset),
          (this.polygonOffsetFactor = e.polygonOffsetFactor),
          (this.polygonOffsetUnits = e.polygonOffsetUnits),
          (this.dithering = e.dithering),
          (this.alphaTest = e.alphaTest),
          (this.alphaHash = e.alphaHash),
          (this.alphaToCoverage = e.alphaToCoverage),
          (this.premultipliedAlpha = e.premultipliedAlpha),
          (this.forceSinglePass = e.forceSinglePass),
          (this.allowOverride = e.allowOverride),
          (this.visible = e.visible),
          (this.toneMapped = e.toneMapped),
          (this.userData = JSON.parse(JSON.stringify(e.userData))),
          this
        );
      }
      dispose() {
        this.dispatchEvent({ type: 'dispose' });
      }
      set needsUpdate(e) {
        e === !0 && this.version++;
      }
    };
  var br = new te(),
    Mm = new te(),
    iu = new te(),
    Kr = new te(),
    wm = new te(),
    nu = new te(),
    Am = new te(),
    Tr = class {
      constructor(e = new te(), t = new te(0, 0, -1)) {
        ((this.origin = e), (this.direction = t));
      }
      set(e, t) {
        return (this.origin.copy(e), this.direction.copy(t), this);
      }
      copy(e) {
        return (
          this.origin.copy(e.origin),
          this.direction.copy(e.direction),
          this
        );
      }
      at(e, t) {
        return t.copy(this.origin).addScaledVector(this.direction, e);
      }
      lookAt(e) {
        return (this.direction.copy(e).sub(this.origin).normalize(), this);
      }
      recast(e) {
        return (this.origin.copy(this.at(e, br)), this);
      }
      closestPointToPoint(e, t) {
        t.subVectors(e, this.origin);
        let i = t.dot(this.direction);
        return i < 0
          ? t.copy(this.origin)
          : t.copy(this.origin).addScaledVector(this.direction, i);
      }
      distanceToPoint(e) {
        return Math.sqrt(this.distanceSqToPoint(e));
      }
      distanceSqToPoint(e) {
        let t = br.subVectors(e, this.origin).dot(this.direction);
        return t < 0
          ? this.origin.distanceToSquared(e)
          : (br.copy(this.origin).addScaledVector(this.direction, t),
            br.distanceToSquared(e));
      }
      distanceSqToSegment(e, t, i, n) {
        (Mm.copy(e).add(t).multiplyScalar(0.5),
          iu.copy(t).sub(e).normalize(),
          Kr.copy(this.origin).sub(Mm));
        let r = e.distanceTo(t) * 0.5,
          o = -this.direction.dot(iu),
          a = Kr.dot(this.direction),
          l = -Kr.dot(iu),
          c = Kr.lengthSq(),
          u = Math.abs(1 - o * o),
          f,
          d,
          p,
          _;
        if (u > 0)
          if (((f = o * l - a), (d = o * a - l), (_ = r * u), f >= 0))
            if (d >= -_)
              if (d <= _) {
                let x = 1 / u;
                ((f *= x),
                  (d *= x),
                  (p = f * (f + o * d + 2 * a) + d * (o * f + d + 2 * l) + c));
              } else
                ((d = r),
                  (f = Math.max(0, -(o * d + a))),
                  (p = -f * f + d * (d + 2 * l) + c));
            else
              ((d = -r),
                (f = Math.max(0, -(o * d + a))),
                (p = -f * f + d * (d + 2 * l) + c));
          else
            d <= -_
              ? ((f = Math.max(0, -(-o * r + a))),
                (d = f > 0 ? -r : Math.min(Math.max(-r, -l), r)),
                (p = -f * f + d * (d + 2 * l) + c))
              : d <= _
                ? ((f = 0),
                  (d = Math.min(Math.max(-r, -l), r)),
                  (p = d * (d + 2 * l) + c))
                : ((f = Math.max(0, -(o * r + a))),
                  (d = f > 0 ? r : Math.min(Math.max(-r, -l), r)),
                  (p = -f * f + d * (d + 2 * l) + c));
        else
          ((d = o > 0 ? -r : r),
            (f = Math.max(0, -(o * d + a))),
            (p = -f * f + d * (d + 2 * l) + c));
        return (
          i && i.copy(this.origin).addScaledVector(this.direction, f),
          n && n.copy(Mm).addScaledVector(iu, d),
          p
        );
      }
      intersectSphere(e, t) {
        br.subVectors(e.center, this.origin);
        let i = br.dot(this.direction),
          n = br.dot(br) - i * i,
          r = e.radius * e.radius;
        if (n > r) return null;
        let o = Math.sqrt(r - n),
          a = i - o,
          l = i + o;
        return l < 0 ? null : a < 0 ? this.at(l, t) : this.at(a, t);
      }
      intersectsSphere(e) {
        return e.radius < 0
          ? !1
          : this.distanceSqToPoint(e.center) <= e.radius * e.radius;
      }
      distanceToPlane(e) {
        let t = e.normal.dot(this.direction);
        if (t === 0) return e.distanceToPoint(this.origin) === 0 ? 0 : null;
        let i = -(this.origin.dot(e.normal) + e.constant) / t;
        return i >= 0 ? i : null;
      }
      intersectPlane(e, t) {
        let i = this.distanceToPlane(e);
        return i === null ? null : this.at(i, t);
      }
      intersectsPlane(e) {
        let t = e.distanceToPoint(this.origin);
        return t === 0 || e.normal.dot(this.direction) * t < 0;
      }
      intersectBox(e, t) {
        let i,
          n,
          r,
          o,
          a,
          l,
          c = 1 / this.direction.x,
          u = 1 / this.direction.y,
          f = 1 / this.direction.z,
          d = this.origin;
        return (
          c >= 0
            ? ((i = (e.min.x - d.x) * c), (n = (e.max.x - d.x) * c))
            : ((i = (e.max.x - d.x) * c), (n = (e.min.x - d.x) * c)),
          u >= 0
            ? ((r = (e.min.y - d.y) * u), (o = (e.max.y - d.y) * u))
            : ((r = (e.max.y - d.y) * u), (o = (e.min.y - d.y) * u)),
          i > o ||
          r > n ||
          ((r > i || isNaN(i)) && (i = r),
          (o < n || isNaN(n)) && (n = o),
          f >= 0
            ? ((a = (e.min.z - d.z) * f), (l = (e.max.z - d.z) * f))
            : ((a = (e.max.z - d.z) * f), (l = (e.min.z - d.z) * f)),
          i > l || a > n) ||
          ((a > i || i !== i) && (i = a), (l < n || n !== n) && (n = l), n < 0)
            ? null
            : this.at(i >= 0 ? i : n, t)
        );
      }
      intersectsBox(e) {
        return this.intersectBox(e, br) !== null;
      }
      intersectTriangle(e, t, i, n, r) {
        (wm.subVectors(t, e), nu.subVectors(i, e), Am.crossVectors(wm, nu));
        let o = this.direction.dot(Am),
          a;
        if (o > 0) {
          if (n) return null;
          a = 1;
        } else if (o < 0) ((a = -1), (o = -o));
        else return null;
        Kr.subVectors(this.origin, e);
        let l = a * this.direction.dot(nu.crossVectors(Kr, nu));
        if (l < 0) return null;
        let c = a * this.direction.dot(wm.cross(Kr));
        if (c < 0 || l + c > o) return null;
        let u = -a * Kr.dot(Am);
        return u < 0 ? null : this.at(u / o, r);
      }
      applyMatrix4(e) {
        return (
          this.origin.applyMatrix4(e),
          this.direction.transformDirection(e),
          this
        );
      }
      equals(e) {
        return (
          e.origin.equals(this.origin) && e.direction.equals(this.direction)
        );
      }
      clone() {
        return new this.constructor().copy(this);
      }
    },
    rn = class extends Rn {
      constructor(e) {
        (super(),
          (this.isMeshBasicMaterial = !0),
          (this.type = 'MeshBasicMaterial'),
          (this.color = new je(16777215)),
          (this.map = null),
          (this.lightMap = null),
          (this.lightMapIntensity = 1),
          (this.aoMap = null),
          (this.aoMapIntensity = 1),
          (this.specularMap = null),
          (this.alphaMap = null),
          (this.envMap = null),
          (this.envMapRotation = new Ts()),
          (this.combine = jm),
          (this.reflectivity = 1),
          (this.refractionRatio = 0.98),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          (this.wireframeLinecap = 'round'),
          (this.wireframeLinejoin = 'round'),
          (this.fog = !0),
          this.setValues(e));
      }
      copy(e) {
        return (
          super.copy(e),
          this.color.copy(e.color),
          (this.map = e.map),
          (this.lightMap = e.lightMap),
          (this.lightMapIntensity = e.lightMapIntensity),
          (this.aoMap = e.aoMap),
          (this.aoMapIntensity = e.aoMapIntensity),
          (this.specularMap = e.specularMap),
          (this.alphaMap = e.alphaMap),
          (this.envMap = e.envMap),
          this.envMapRotation.copy(e.envMapRotation),
          (this.combine = e.combine),
          (this.reflectivity = e.reflectivity),
          (this.refractionRatio = e.refractionRatio),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          (this.wireframeLinecap = e.wireframeLinecap),
          (this.wireframeLinejoin = e.wireframeLinejoin),
          (this.fog = e.fog),
          this
        );
      }
    },
    _x = new yt(),
    Ho = new Tr(),
    su = new An(),
    vx = new te(),
    ru = new te(),
    ou = new te(),
    au = new te(),
    Rm = new te(),
    lu = new te(),
    xx = new te(),
    cu = new te(),
    ri = class extends pi {
      constructor(e = new Vi(), t = new rn()) {
        (super(),
          (this.isMesh = !0),
          (this.type = 'Mesh'),
          (this.geometry = e),
          (this.material = t),
          (this.morphTargetDictionary = void 0),
          (this.morphTargetInfluences = void 0),
          (this.count = 1),
          this.updateMorphTargets());
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          e.morphTargetInfluences !== void 0 &&
            (this.morphTargetInfluences = e.morphTargetInfluences.slice()),
          e.morphTargetDictionary !== void 0 &&
            (this.morphTargetDictionary = Object.assign(
              {},
              e.morphTargetDictionary,
            )),
          (this.material = Array.isArray(e.material)
            ? e.material.slice()
            : e.material),
          (this.geometry = e.geometry),
          this
        );
      }
      updateMorphTargets() {
        let t = this.geometry.morphAttributes,
          i = Object.keys(t);
        if (i.length > 0) {
          let n = t[i[0]];
          if (n !== void 0) {
            ((this.morphTargetInfluences = []),
              (this.morphTargetDictionary = {}));
            for (let r = 0, o = n.length; r < o; r++) {
              let a = n[r].name || String(r);
              (this.morphTargetInfluences.push(0),
                (this.morphTargetDictionary[a] = r));
            }
          }
        }
      }
      getVertexPosition(e, t) {
        let i = this.geometry,
          n = i.attributes.position,
          r = i.morphAttributes.position,
          o = i.morphTargetsRelative;
        t.fromBufferAttribute(n, e);
        let a = this.morphTargetInfluences;
        if (r && a) {
          lu.set(0, 0, 0);
          for (let l = 0, c = r.length; l < c; l++) {
            let u = a[l],
              f = r[l];
            u !== 0 &&
              (Rm.fromBufferAttribute(f, e),
              o ? lu.addScaledVector(Rm, u) : lu.addScaledVector(Rm.sub(t), u));
          }
          t.add(lu);
        }
        return t;
      }
      raycast(e, t) {
        let i = this.geometry,
          n = this.material,
          r = this.matrixWorld;
        n !== void 0 &&
          (i.boundingSphere === null && i.computeBoundingSphere(),
          su.copy(i.boundingSphere),
          su.applyMatrix4(r),
          Ho.copy(e.ray).recast(e.near),
          !(
            su.containsPoint(Ho.origin) === !1 &&
            (Ho.intersectSphere(su, vx) === null ||
              Ho.origin.distanceToSquared(vx) > Zi(e.far - e.near, 2))
          ) &&
            (_x.copy(r).invert(),
            Ho.copy(e.ray).applyMatrix4(_x),
            !(
              i.boundingBox !== null && Ho.intersectsBox(i.boundingBox) === !1
            ) && this._computeIntersections(e, t, Ho)));
      }
      _computeIntersections(e, t, i) {
        let n,
          r = this.geometry,
          o = this.material,
          a = r.index,
          l = r.attributes.position,
          c = r.attributes.uv,
          u = r.attributes.uv1,
          f = r.attributes.normal,
          d = r.groups,
          p = r.drawRange;
        if (a !== null)
          if (Array.isArray(o))
            for (let _ = 0, x = d.length; _ < x; _++) {
              let g = d[_],
                v = o[g.materialIndex],
                w = Math.max(g.start, p.start),
                L = Math.min(
                  a.count,
                  Math.min(g.start + g.count, p.start + p.count),
                );
              for (let R = w, U = L; R < U; R += 3) {
                let O = a.getX(R),
                  N = a.getX(R + 1),
                  M = a.getX(R + 2);
                ((n = hu(this, v, e, i, c, u, f, O, N, M)),
                  n &&
                    ((n.faceIndex = Math.floor(R / 3)),
                    (n.face.materialIndex = g.materialIndex),
                    t.push(n)));
              }
            }
          else {
            let _ = Math.max(0, p.start),
              x = Math.min(a.count, p.start + p.count);
            for (let g = _, v = x; g < v; g += 3) {
              let w = a.getX(g),
                L = a.getX(g + 1),
                R = a.getX(g + 2);
              ((n = hu(this, o, e, i, c, u, f, w, L, R)),
                n && ((n.faceIndex = Math.floor(g / 3)), t.push(n)));
            }
          }
        else if (l !== void 0)
          if (Array.isArray(o))
            for (let _ = 0, x = d.length; _ < x; _++) {
              let g = d[_],
                v = o[g.materialIndex],
                w = Math.max(g.start, p.start),
                L = Math.min(
                  l.count,
                  Math.min(g.start + g.count, p.start + p.count),
                );
              for (let R = w, U = L; R < U; R += 3) {
                let O = R,
                  N = R + 1,
                  M = R + 2;
                ((n = hu(this, v, e, i, c, u, f, O, N, M)),
                  n &&
                    ((n.faceIndex = Math.floor(R / 3)),
                    (n.face.materialIndex = g.materialIndex),
                    t.push(n)));
              }
            }
          else {
            let _ = Math.max(0, p.start),
              x = Math.min(l.count, p.start + p.count);
            for (let g = _, v = x; g < v; g += 3) {
              let w = g,
                L = g + 1,
                R = g + 2;
              ((n = hu(this, o, e, i, c, u, f, w, L, R)),
                n && ((n.faceIndex = Math.floor(g / 3)), t.push(n)));
            }
          }
      }
    };
  function YT(s, e, t, i, n, r, o, a) {
    let l;
    if (
      (e.side === bn
        ? (l = i.intersectTriangle(o, r, n, !0, a))
        : (l = i.intersectTriangle(n, r, o, e.side === Ss, a)),
      l === null)
    )
      return null;
    (cu.copy(a), cu.applyMatrix4(s.matrixWorld));
    let c = t.ray.origin.distanceTo(cu);
    return c < t.near || c > t.far
      ? null
      : { distance: c, point: cu.clone(), object: s };
  }
  function hu(s, e, t, i, n, r, o, a, l, c) {
    (s.getVertexPosition(a, ru),
      s.getVertexPosition(l, ou),
      s.getVertexPosition(c, au));
    let u = YT(s, e, t, i, ru, ou, au, xx);
    if (u) {
      let f = new te();
      (jr.getBarycoord(xx, ru, ou, au, f),
        n && (u.uv = jr.getInterpolatedAttribute(n, a, l, c, f, new et())),
        r && (u.uv1 = jr.getInterpolatedAttribute(r, a, l, c, f, new et())),
        o &&
          ((u.normal = jr.getInterpolatedAttribute(o, a, l, c, f, new te())),
          u.normal.dot(i.direction) > 0 && u.normal.multiplyScalar(-1)));
      let d = { a, b: l, c, normal: new te(), materialIndex: 0 };
      (jr.getNormal(ru, ou, au, d.normal), (u.face = d), (u.barycoord = f));
    }
    return u;
  }
  var oc = new Qt(),
    yx = new Qt(),
    bx = new Qt(),
    qT = new Qt(),
    Sx = new yt(),
    uu = new te(),
    Cm = new An(),
    Ex = new yt(),
    Pm = new Tr(),
    vc = class extends ri {
      constructor(e, t) {
        (super(e, t),
          (this.isSkinnedMesh = !0),
          (this.type = 'SkinnedMesh'),
          (this.bindMode = Nm),
          (this.bindMatrix = new yt()),
          (this.bindMatrixInverse = new yt()),
          (this.boundingBox = null),
          (this.boundingSphere = null));
      }
      computeBoundingBox() {
        let e = this.geometry;
        (this.boundingBox === null && (this.boundingBox = new yn()),
          this.boundingBox.makeEmpty());
        let t = e.getAttribute('position');
        for (let i = 0; i < t.count; i++)
          (this.getVertexPosition(i, uu), this.boundingBox.expandByPoint(uu));
      }
      computeBoundingSphere() {
        let e = this.geometry;
        (this.boundingSphere === null && (this.boundingSphere = new An()),
          this.boundingSphere.makeEmpty());
        let t = e.getAttribute('position');
        for (let i = 0; i < t.count; i++)
          (this.getVertexPosition(i, uu),
            this.boundingSphere.expandByPoint(uu));
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          (this.bindMode = e.bindMode),
          this.bindMatrix.copy(e.bindMatrix),
          this.bindMatrixInverse.copy(e.bindMatrixInverse),
          (this.skeleton = e.skeleton),
          e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()),
          e.boundingSphere !== null &&
            (this.boundingSphere = e.boundingSphere.clone()),
          this
        );
      }
      raycast(e, t) {
        let i = this.material,
          n = this.matrixWorld;
        i !== void 0 &&
          (this.boundingSphere === null && this.computeBoundingSphere(),
          Cm.copy(this.boundingSphere),
          Cm.applyMatrix4(n),
          e.ray.intersectsSphere(Cm) !== !1 &&
            (Ex.copy(n).invert(),
            Pm.copy(e.ray).applyMatrix4(Ex),
            !(
              this.boundingBox !== null &&
              Pm.intersectsBox(this.boundingBox) === !1
            ) && this._computeIntersections(e, t, Pm)));
      }
      getVertexPosition(e, t) {
        return (
          super.getVertexPosition(e, t),
          this.applyBoneTransform(e, t),
          t
        );
      }
      bind(e, t) {
        ((this.skeleton = e),
          t === void 0 &&
            (this.updateMatrixWorld(!0),
            this.skeleton.calculateInverses(),
            (t = this.matrixWorld)),
          this.bindMatrix.copy(t),
          this.bindMatrixInverse.copy(t).invert());
      }
      pose() {
        this.skeleton.pose();
      }
      normalizeSkinWeights() {
        let e = new Qt(),
          t = this.geometry.attributes.skinWeight;
        for (let i = 0, n = t.count; i < n; i++) {
          e.fromBufferAttribute(t, i);
          let r = 1 / e.manhattanLength();
          (r !== 1 / 0 ? e.multiplyScalar(r) : e.set(1, 0, 0, 0),
            t.setXYZW(i, e.x, e.y, e.z, e.w));
        }
      }
      updateMatrixWorld(e) {
        (super.updateMatrixWorld(e),
          this.bindMode === Nm
            ? this.bindMatrixInverse.copy(this.matrixWorld).invert()
            : this.bindMode === cy
              ? this.bindMatrixInverse.copy(this.bindMatrix).invert()
              : it('SkinnedMesh: Unrecognized bindMode: ' + this.bindMode));
      }
      applyBoneTransform(e, t) {
        let i = this.skeleton,
          n = this.geometry;
        (yx.fromBufferAttribute(n.attributes.skinIndex, e),
          bx.fromBufferAttribute(n.attributes.skinWeight, e),
          t.isVector4
            ? (oc.copy(t), t.set(0, 0, 0, 0))
            : (oc.set(...t, 1), t.set(0, 0, 0)),
          oc.applyMatrix4(this.bindMatrix));
        for (let r = 0; r < 4; r++) {
          let o = bx.getComponent(r);
          if (o !== 0) {
            let a = yx.getComponent(r);
            (Sx.multiplyMatrices(i.bones[a].matrixWorld, i.boneInverses[a]),
              t.addScaledVector(qT.copy(oc).applyMatrix4(Sx), o));
          }
        }
        return (
          t.isVector4 && (t.w = oc.w),
          t.applyMatrix4(this.bindMatrixInverse)
        );
      }
    },
    Za = class extends pi {
      constructor() {
        (super(), (this.isBone = !0), (this.type = 'Bone'));
      }
    },
    Ka = class extends Li {
      constructor(e = null, t = 1, i = 1, n, r, o, a, l, c = bi, u = bi, f, d) {
        (super(null, o, a, l, c, u, n, r, f, d),
          (this.isDataTexture = !0),
          (this.image = { data: e, width: t, height: i }),
          (this.generateMipmaps = !1),
          (this.flipY = !1),
          (this.unpackAlignment = 1));
      }
    },
    Tx = new yt(),
    ZT = new yt(),
    xc = class s {
      constructor(e = [], t = []) {
        ((this.uuid = bs()),
          (this.bones = e.slice(0)),
          (this.boneInverses = t),
          (this.boneMatrices = null),
          (this.previousBoneMatrices = null),
          (this.boneTexture = null),
          this.init());
      }
      init() {
        let e = this.bones,
          t = this.boneInverses;
        if (
          ((this.boneMatrices = new Float32Array(e.length * 16)),
          t.length === 0)
        )
          this.calculateInverses();
        else if (e.length !== t.length) {
          (it(
            'Skeleton: Number of inverse bone matrices does not match amount of bones.',
          ),
            (this.boneInverses = []));
          for (let i = 0, n = this.bones.length; i < n; i++)
            this.boneInverses.push(new yt());
        }
      }
      calculateInverses() {
        this.boneInverses.length = 0;
        for (let e = 0, t = this.bones.length; e < t; e++) {
          let i = new yt();
          (this.bones[e] && i.copy(this.bones[e].matrixWorld).invert(),
            this.boneInverses.push(i));
        }
      }
      pose() {
        for (let e = 0, t = this.bones.length; e < t; e++) {
          let i = this.bones[e];
          i && i.matrixWorld.copy(this.boneInverses[e]).invert();
        }
        for (let e = 0, t = this.bones.length; e < t; e++) {
          let i = this.bones[e];
          i &&
            (i.parent && i.parent.isBone
              ? (i.matrix.copy(i.parent.matrixWorld).invert(),
                i.matrix.multiply(i.matrixWorld))
              : i.matrix.copy(i.matrixWorld),
            i.matrix.decompose(i.position, i.quaternion, i.scale));
        }
      }
      update() {
        let e = this.bones,
          t = this.boneInverses,
          i = this.boneMatrices,
          n = this.boneTexture;
        for (let r = 0, o = e.length; r < o; r++) {
          let a = e[r] ? e[r].matrixWorld : ZT;
          (Tx.multiplyMatrices(a, t[r]), Tx.toArray(i, r * 16));
        }
        n !== null && (n.needsUpdate = !0);
      }
      clone() {
        return new s(this.bones, this.boneInverses);
      }
      computeBoneTexture() {
        let e = Math.sqrt(this.bones.length * 4);
        ((e = Math.ceil(e / 4) * 4), (e = Math.max(e, 4)));
        let t = new Float32Array(e * e * 4);
        t.set(this.boneMatrices);
        let i = new Ka(t, e, e, Yn, Xn);
        return (
          (i.needsUpdate = !0),
          (this.boneMatrices = t),
          (this.boneTexture = i),
          this
        );
      }
      getBoneByName(e) {
        for (let t = 0, i = this.bones.length; t < i; t++) {
          let n = this.bones[t];
          if (n.name === e) return n;
        }
      }
      dispose() {
        this.boneTexture !== null &&
          (this.boneTexture.dispose(), (this.boneTexture = null));
      }
      fromJSON(e, t) {
        this.uuid = e.uuid;
        for (let i = 0, n = e.bones.length; i < n; i++) {
          let r = e.bones[i],
            o = t[r];
          (o === void 0 &&
            (it('Skeleton: No bone found with UUID:', r), (o = new Za())),
            this.bones.push(o),
            this.boneInverses.push(new yt().fromArray(e.boneInverses[i])));
        }
        return (this.init(), this);
      }
      toJSON() {
        let e = {
          metadata: {
            version: 4.7,
            type: 'Skeleton',
            generator: 'Skeleton.toJSON',
          },
          bones: [],
          boneInverses: [],
        };
        e.uuid = this.uuid;
        let t = this.bones,
          i = this.boneInverses;
        for (let n = 0, r = t.length; n < r; n++) {
          let o = t[n];
          e.bones.push(o.uuid);
          let a = i[n];
          e.boneInverses.push(a.toArray());
        }
        return e;
      }
    },
    io = class extends fi {
      constructor(e, t, i, n = 1) {
        (super(e, t, i),
          (this.isInstancedBufferAttribute = !0),
          (this.meshPerAttribute = n));
      }
      copy(e) {
        return (
          super.copy(e),
          (this.meshPerAttribute = e.meshPerAttribute),
          this
        );
      }
      toJSON() {
        let e = super.toJSON();
        return (
          (e.meshPerAttribute = this.meshPerAttribute),
          (e.isInstancedBufferAttribute = !0),
          e
        );
      }
    },
    Ua = new yt(),
    Mx = new yt(),
    du = [],
    wx = new yn(),
    KT = new yt(),
    ac = new ri(),
    lc = new An(),
    yc = class extends ri {
      constructor(e, t, i) {
        (super(e, t),
          (this.isInstancedMesh = !0),
          (this.instanceMatrix = new io(new Float32Array(i * 16), 16)),
          (this.previousInstanceMatrix = null),
          (this.instanceColor = null),
          (this.morphTexture = null),
          (this.count = i),
          (this.boundingBox = null),
          (this.boundingSphere = null));
        for (let n = 0; n < i; n++) this.setMatrixAt(n, KT);
      }
      computeBoundingBox() {
        let e = this.geometry,
          t = this.count;
        (this.boundingBox === null && (this.boundingBox = new yn()),
          e.boundingBox === null && e.computeBoundingBox(),
          this.boundingBox.makeEmpty());
        for (let i = 0; i < t; i++)
          (this.getMatrixAt(i, Ua),
            wx.copy(e.boundingBox).applyMatrix4(Ua),
            this.boundingBox.union(wx));
      }
      computeBoundingSphere() {
        let e = this.geometry,
          t = this.count;
        (this.boundingSphere === null && (this.boundingSphere = new An()),
          e.boundingSphere === null && e.computeBoundingSphere(),
          this.boundingSphere.makeEmpty());
        for (let i = 0; i < t; i++)
          (this.getMatrixAt(i, Ua),
            lc.copy(e.boundingSphere).applyMatrix4(Ua),
            this.boundingSphere.union(lc));
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          this.instanceMatrix.copy(e.instanceMatrix),
          e.previousInstanceMatrix !== null &&
            (this.previousInstanceMatrix = e.previousInstanceMatrix.clone()),
          e.morphTexture !== null &&
            (this.morphTexture = e.morphTexture.clone()),
          e.instanceColor !== null &&
            (this.instanceColor = e.instanceColor.clone()),
          (this.count = e.count),
          e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()),
          e.boundingSphere !== null &&
            (this.boundingSphere = e.boundingSphere.clone()),
          this
        );
      }
      getColorAt(e, t) {
        return this.instanceColor === null
          ? t.setRGB(1, 1, 1)
          : t.fromArray(this.instanceColor.array, e * 3);
      }
      getMatrixAt(e, t) {
        return t.fromArray(this.instanceMatrix.array, e * 16);
      }
      getMorphAt(e, t) {
        let i = t.morphTargetInfluences,
          n = this.morphTexture.source.data.data,
          r = i.length + 1,
          o = e * r + 1;
        for (let a = 0; a < i.length; a++) i[a] = n[o + a];
      }
      raycast(e, t) {
        let i = this.matrixWorld,
          n = this.count;
        if (
          ((ac.geometry = this.geometry),
          (ac.material = this.material),
          ac.material !== void 0 &&
            (this.boundingSphere === null && this.computeBoundingSphere(),
            lc.copy(this.boundingSphere),
            lc.applyMatrix4(i),
            e.ray.intersectsSphere(lc) !== !1))
        )
          for (let r = 0; r < n; r++) {
            (this.getMatrixAt(r, Ua),
              Mx.multiplyMatrices(i, Ua),
              (ac.matrixWorld = Mx),
              ac.raycast(e, du));
            for (let o = 0, a = du.length; o < a; o++) {
              let l = du[o];
              ((l.instanceId = r), (l.object = this), t.push(l));
            }
            du.length = 0;
          }
      }
      setColorAt(e, t) {
        return (
          this.instanceColor === null &&
            (this.instanceColor = new io(
              new Float32Array(this.instanceMatrix.count * 3).fill(1),
              3,
            )),
          t.toArray(this.instanceColor.array, e * 3),
          this
        );
      }
      setMatrixAt(e, t) {
        return (t.toArray(this.instanceMatrix.array, e * 16), this);
      }
      setMorphAt(e, t) {
        let i = t.morphTargetInfluences,
          n = i.length + 1;
        this.morphTexture === null &&
          (this.morphTexture = new Ka(
            new Float32Array(n * this.count),
            n,
            this.count,
            nd,
            Xn,
          ));
        let r = this.morphTexture.source.data.data,
          o = 0;
        for (let c = 0; c < i.length; c++) o += i[c];
        let a = this.geometry.morphTargetsRelative ? 1 : 1 - o,
          l = n * e;
        return ((r[l] = a), r.set(i, l + 1), this);
      }
      updateMorphTargets() {}
      dispose() {
        (this.dispatchEvent({ type: 'dispose' }),
          this.morphTexture !== null &&
            (this.morphTexture.dispose(), (this.morphTexture = null)));
      }
    },
    Lm = new te(),
    $T = new te(),
    jT = new St(),
    is = class {
      constructor(e = new te(1, 0, 0), t = 0) {
        ((this.isPlane = !0), (this.normal = e), (this.constant = t));
      }
      set(e, t) {
        return (this.normal.copy(e), (this.constant = t), this);
      }
      setComponents(e, t, i, n) {
        return (this.normal.set(e, t, i), (this.constant = n), this);
      }
      setFromNormalAndCoplanarPoint(e, t) {
        return (
          this.normal.copy(e),
          (this.constant = -t.dot(this.normal)),
          this
        );
      }
      setFromCoplanarPoints(e, t, i) {
        let n = Lm.subVectors(i, t).cross($T.subVectors(e, t)).normalize();
        return (this.setFromNormalAndCoplanarPoint(n, e), this);
      }
      copy(e) {
        return (this.normal.copy(e.normal), (this.constant = e.constant), this);
      }
      normalize() {
        let e = 1 / this.normal.length();
        return (this.normal.multiplyScalar(e), (this.constant *= e), this);
      }
      negate() {
        return ((this.constant *= -1), this.normal.negate(), this);
      }
      distanceToPoint(e) {
        return this.normal.dot(e) + this.constant;
      }
      distanceToSphere(e) {
        return this.distanceToPoint(e.center) - e.radius;
      }
      projectPoint(e, t) {
        return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
      }
      intersectLine(e, t, i = !0) {
        let n = e.delta(Lm),
          r = this.normal.dot(n);
        if (r === 0)
          return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
        let o = -(e.start.dot(this.normal) + this.constant) / r;
        return i === !0 && (o < 0 || o > 1)
          ? null
          : t.copy(e.start).addScaledVector(n, o);
      }
      intersectsLine(e) {
        let t = this.distanceToPoint(e.start),
          i = this.distanceToPoint(e.end);
        return (t < 0 && i > 0) || (i < 0 && t > 0);
      }
      intersectsBox(e) {
        return e.intersectsPlane(this);
      }
      intersectsSphere(e) {
        return e.intersectsPlane(this);
      }
      coplanarPoint(e) {
        return e.copy(this.normal).multiplyScalar(-this.constant);
      }
      applyMatrix4(e, t) {
        let i = t || jT.getNormalMatrix(e),
          n = this.coplanarPoint(Lm).applyMatrix4(e),
          r = this.normal.applyMatrix3(i).normalize();
        return ((this.constant = -n.dot(r)), this);
      }
      translate(e) {
        return ((this.constant -= e.dot(this.normal)), this);
      }
      equals(e) {
        return e.normal.equals(this.normal) && e.constant === this.constant;
      }
      clone() {
        return new this.constructor().copy(this);
      }
    },
    zo = new An(),
    JT = new et(0.5, 0.5),
    fu = new te(),
    $a = class {
      constructor(
        e = new is(),
        t = new is(),
        i = new is(),
        n = new is(),
        r = new is(),
        o = new is(),
      ) {
        this.planes = [e, t, i, n, r, o];
      }
      set(e, t, i, n, r, o) {
        let a = this.planes;
        return (
          a[0].copy(e),
          a[1].copy(t),
          a[2].copy(i),
          a[3].copy(n),
          a[4].copy(r),
          a[5].copy(o),
          this
        );
      }
      copy(e) {
        let t = this.planes;
        for (let i = 0; i < 6; i++) t[i].copy(e.planes[i]);
        return this;
      }
      setFromProjectionMatrix(e, t = ys, i = !1) {
        let n = this.planes,
          r = e.elements,
          o = r[0],
          a = r[1],
          l = r[2],
          c = r[3],
          u = r[4],
          f = r[5],
          d = r[6],
          p = r[7],
          _ = r[8],
          x = r[9],
          g = r[10],
          v = r[11],
          w = r[12],
          L = r[13],
          R = r[14],
          U = r[15];
        if (
          (n[0].setComponents(c - o, p - u, v - _, U - w).normalize(),
          n[1].setComponents(c + o, p + u, v + _, U + w).normalize(),
          n[2].setComponents(c + a, p + f, v + x, U + L).normalize(),
          n[3].setComponents(c - a, p - f, v - x, U - L).normalize(),
          i)
        )
          (n[4].setComponents(l, d, g, R).normalize(),
            n[5].setComponents(c - l, p - d, v - g, U - R).normalize());
        else if (
          (n[4].setComponents(c - l, p - d, v - g, U - R).normalize(), t === ys)
        )
          n[5].setComponents(c + l, p + d, v + g, U + R).normalize();
        else if (t === Ga) n[5].setComponents(l, d, g, R).normalize();
        else
          throw new Error(
            'THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' +
              t,
          );
        return this;
      }
      intersectsObject(e) {
        if (e.boundingSphere !== void 0)
          (e.boundingSphere === null && e.computeBoundingSphere(),
            zo.copy(e.boundingSphere).applyMatrix4(e.matrixWorld));
        else {
          let t = e.geometry;
          (t.boundingSphere === null && t.computeBoundingSphere(),
            zo.copy(t.boundingSphere).applyMatrix4(e.matrixWorld));
        }
        return this.intersectsSphere(zo);
      }
      intersectsSprite(e) {
        zo.center.set(0, 0, 0);
        let t = JT.distanceTo(e.center);
        return (
          (zo.radius = 0.7071067811865476 + t),
          zo.applyMatrix4(e.matrixWorld),
          this.intersectsSphere(zo)
        );
      }
      intersectsSphere(e) {
        let t = this.planes,
          i = e.center,
          n = -e.radius;
        for (let r = 0; r < 6; r++) if (t[r].distanceToPoint(i) < n) return !1;
        return !0;
      }
      intersectsBox(e) {
        let t = this.planes;
        for (let i = 0; i < 6; i++) {
          let n = t[i];
          if (
            ((fu.x = n.normal.x > 0 ? e.max.x : e.min.x),
            (fu.y = n.normal.y > 0 ? e.max.y : e.min.y),
            (fu.z = n.normal.z > 0 ? e.max.z : e.min.z),
            n.distanceToPoint(fu) < 0)
          )
            return !1;
        }
        return !0;
      }
      containsPoint(e) {
        let t = this.planes;
        for (let i = 0; i < 6; i++) if (t[i].distanceToPoint(e) < 0) return !1;
        return !0;
      }
      clone() {
        return new this.constructor().copy(this);
      }
    };
  var ja = class extends Rn {
      constructor(e) {
        (super(),
          (this.isLineBasicMaterial = !0),
          (this.type = 'LineBasicMaterial'),
          (this.color = new je(16777215)),
          (this.map = null),
          (this.linewidth = 1),
          (this.linecap = 'round'),
          (this.linejoin = 'round'),
          (this.fog = !0),
          this.setValues(e));
      }
      copy(e) {
        return (
          super.copy(e),
          this.color.copy(e.color),
          (this.map = e.map),
          (this.linewidth = e.linewidth),
          (this.linecap = e.linecap),
          (this.linejoin = e.linejoin),
          (this.fog = e.fog),
          this
        );
      }
    },
    Fu = new te(),
    Uu = new te(),
    Ax = new yt(),
    cc = new Tr(),
    pu = new An(),
    Im = new te(),
    Rx = new te(),
    Zo = class extends pi {
      constructor(e = new Vi(), t = new ja()) {
        (super(),
          (this.isLine = !0),
          (this.type = 'Line'),
          (this.geometry = e),
          (this.material = t),
          (this.morphTargetDictionary = void 0),
          (this.morphTargetInfluences = void 0),
          this.updateMorphTargets());
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          (this.material = Array.isArray(e.material)
            ? e.material.slice()
            : e.material),
          (this.geometry = e.geometry),
          this
        );
      }
      computeLineDistances() {
        let e = this.geometry;
        if (e.index === null) {
          let t = e.attributes.position,
            i = [0];
          for (let n = 1, r = t.count; n < r; n++)
            (Fu.fromBufferAttribute(t, n - 1),
              Uu.fromBufferAttribute(t, n),
              (i[n] = i[n - 1]),
              (i[n] += Fu.distanceTo(Uu)));
          e.setAttribute('lineDistance', new Hi(i, 1));
        } else
          it(
            'Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.',
          );
        return this;
      }
      raycast(e, t) {
        let i = this.geometry,
          n = this.matrixWorld,
          r = e.params.Line.threshold,
          o = i.drawRange;
        if (
          (i.boundingSphere === null && i.computeBoundingSphere(),
          pu.copy(i.boundingSphere),
          pu.applyMatrix4(n),
          (pu.radius += r),
          e.ray.intersectsSphere(pu) === !1)
        )
          return;
        (Ax.copy(n).invert(), cc.copy(e.ray).applyMatrix4(Ax));
        let a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
          l = a * a,
          c = this.isLineSegments ? 2 : 1,
          u = i.index,
          d = i.attributes.position;
        if (u !== null) {
          let p = Math.max(0, o.start),
            _ = Math.min(u.count, o.start + o.count);
          for (let x = p, g = _ - 1; x < g; x += c) {
            let v = u.getX(x),
              w = u.getX(x + 1),
              L = mu(this, e, cc, l, v, w, x);
            L && t.push(L);
          }
          if (this.isLineLoop) {
            let x = u.getX(_ - 1),
              g = u.getX(p),
              v = mu(this, e, cc, l, x, g, _ - 1);
            v && t.push(v);
          }
        } else {
          let p = Math.max(0, o.start),
            _ = Math.min(d.count, o.start + o.count);
          for (let x = p, g = _ - 1; x < g; x += c) {
            let v = mu(this, e, cc, l, x, x + 1, x);
            v && t.push(v);
          }
          if (this.isLineLoop) {
            let x = mu(this, e, cc, l, _ - 1, p, _ - 1);
            x && t.push(x);
          }
        }
      }
      updateMorphTargets() {
        let t = this.geometry.morphAttributes,
          i = Object.keys(t);
        if (i.length > 0) {
          let n = t[i[0]];
          if (n !== void 0) {
            ((this.morphTargetInfluences = []),
              (this.morphTargetDictionary = {}));
            for (let r = 0, o = n.length; r < o; r++) {
              let a = n[r].name || String(r);
              (this.morphTargetInfluences.push(0),
                (this.morphTargetDictionary[a] = r));
            }
          }
        }
      }
    };
  function mu(s, e, t, i, n, r, o) {
    let a = s.geometry.attributes.position;
    if (
      (Fu.fromBufferAttribute(a, n),
      Uu.fromBufferAttribute(a, r),
      t.distanceSqToSegment(Fu, Uu, Im, Rx) > i)
    )
      return;
    Im.applyMatrix4(s.matrixWorld);
    let c = e.ray.origin.distanceTo(Im);
    if (!(c < e.near || c > e.far))
      return {
        distance: c,
        point: Rx.clone().applyMatrix4(s.matrixWorld),
        index: o,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: s,
      };
  }
  var Cx = new te(),
    Px = new te(),
    bc = class extends Zo {
      constructor(e, t) {
        (super(e, t), (this.isLineSegments = !0), (this.type = 'LineSegments'));
      }
      computeLineDistances() {
        let e = this.geometry;
        if (e.index === null) {
          let t = e.attributes.position,
            i = [];
          for (let n = 0, r = t.count; n < r; n += 2)
            (Cx.fromBufferAttribute(t, n),
              Px.fromBufferAttribute(t, n + 1),
              (i[n] = n === 0 ? 0 : i[n - 1]),
              (i[n + 1] = i[n] + Cx.distanceTo(Px)));
          e.setAttribute('lineDistance', new Hi(i, 1));
        } else
          it(
            'LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.',
          );
        return this;
      }
    },
    Sc = class extends Zo {
      constructor(e, t) {
        (super(e, t), (this.isLineLoop = !0), (this.type = 'LineLoop'));
      }
    },
    Ja = class extends Rn {
      constructor(e) {
        (super(),
          (this.isPointsMaterial = !0),
          (this.type = 'PointsMaterial'),
          (this.color = new je(16777215)),
          (this.map = null),
          (this.alphaMap = null),
          (this.size = 1),
          (this.sizeAttenuation = !0),
          (this.fog = !0),
          this.setValues(e));
      }
      copy(e) {
        return (
          super.copy(e),
          this.color.copy(e.color),
          (this.map = e.map),
          (this.alphaMap = e.alphaMap),
          (this.size = e.size),
          (this.sizeAttenuation = e.sizeAttenuation),
          (this.fog = e.fog),
          this
        );
      }
    },
    Lx = new yt(),
    zm = new Tr(),
    gu = new An(),
    _u = new te(),
    Ec = class extends pi {
      constructor(e = new Vi(), t = new Ja()) {
        (super(),
          (this.isPoints = !0),
          (this.type = 'Points'),
          (this.geometry = e),
          (this.material = t),
          (this.morphTargetDictionary = void 0),
          (this.morphTargetInfluences = void 0),
          this.updateMorphTargets());
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          (this.material = Array.isArray(e.material)
            ? e.material.slice()
            : e.material),
          (this.geometry = e.geometry),
          this
        );
      }
      raycast(e, t) {
        let i = this.geometry,
          n = this.matrixWorld,
          r = e.params.Points.threshold,
          o = i.drawRange;
        if (
          (i.boundingSphere === null && i.computeBoundingSphere(),
          gu.copy(i.boundingSphere),
          gu.applyMatrix4(n),
          (gu.radius += r),
          e.ray.intersectsSphere(gu) === !1)
        )
          return;
        (Lx.copy(n).invert(), zm.copy(e.ray).applyMatrix4(Lx));
        let a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
          l = a * a,
          c = i.index,
          f = i.attributes.position;
        if (c !== null) {
          let d = Math.max(0, o.start),
            p = Math.min(c.count, o.start + o.count);
          for (let _ = d, x = p; _ < x; _++) {
            let g = c.getX(_);
            (_u.fromBufferAttribute(f, g), Ix(_u, g, l, n, e, t, this));
          }
        } else {
          let d = Math.max(0, o.start),
            p = Math.min(f.count, o.start + o.count);
          for (let _ = d, x = p; _ < x; _++)
            (_u.fromBufferAttribute(f, _), Ix(_u, _, l, n, e, t, this));
        }
      }
      updateMorphTargets() {
        let t = this.geometry.morphAttributes,
          i = Object.keys(t);
        if (i.length > 0) {
          let n = t[i[0]];
          if (n !== void 0) {
            ((this.morphTargetInfluences = []),
              (this.morphTargetDictionary = {}));
            for (let r = 0, o = n.length; r < o; r++) {
              let a = n[r].name || String(r);
              (this.morphTargetInfluences.push(0),
                (this.morphTargetDictionary[a] = r));
            }
          }
        }
      }
    };
  function Ix(s, e, t, i, n, r, o) {
    let a = zm.distanceSqToPoint(s);
    if (a < t) {
      let l = new te();
      (zm.closestPointToPoint(s, l), l.applyMatrix4(i));
      let c = n.ray.origin.distanceTo(l);
      if (c < n.near || c > n.far) return;
      r.push({
        distance: c,
        distanceToRay: Math.sqrt(a),
        point: l,
        index: e,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: o,
      });
    }
  }
  var Tc = class extends Li {
      constructor(e = [], t = oo, i, n, r, o, a, l, c, u) {
        (super(e, t, i, n, r, o, a, l, c, u),
          (this.isCubeTexture = !0),
          (this.flipY = !1));
      }
      get images() {
        return this.image;
      }
      set images(e) {
        this.image = e;
      }
    },
    Mc = class extends Li {
      constructor(e, t, i, n, r, o, a, l, c) {
        (super(e, t, i, n, r, o, a, l, c),
          (this.isCanvasTexture = !0),
          (this.needsUpdate = !0));
      }
    };
  var Mr = class extends Li {
      constructor(e, t, i = Rs, n, r, o, a = bi, l = bi, c, u = qs, f = 1) {
        if (u !== qs && u !== ao)
          throw new Error(
            'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat',
          );
        let d = { width: e, height: t, depth: f };
        (super(d, n, r, o, a, l, u, i, c),
          (this.isDepthTexture = !0),
          (this.flipY = !1),
          (this.generateMipmaps = !1),
          (this.compareFunction = null));
      }
      copy(e) {
        return (
          super.copy(e),
          (this.source = new Ya(Object.assign({}, e.image))),
          (this.compareFunction = e.compareFunction),
          this
        );
      }
      toJSON(e) {
        let t = super.toJSON(e);
        return (
          this.compareFunction !== null &&
            (t.compareFunction = this.compareFunction),
          t
        );
      }
    },
    Bu = class extends Mr {
      constructor(e, t = Rs, i = oo, n, r, o = bi, a = bi, l, c = qs) {
        let u = { width: e, height: e, depth: 1 },
          f = [u, u, u, u, u, u];
        (super(e, e, t, i, n, r, o, a, l, c),
          (this.image = f),
          (this.isCubeDepthTexture = !0),
          (this.isCubeTexture = !0));
      }
      get images() {
        return this.image;
      }
      set images(e) {
        this.image = e;
      }
    },
    wc = class extends Li {
      constructor(e = null) {
        (super(), (this.sourceTexture = e), (this.isExternalTexture = !0));
      }
      copy(e) {
        return (super.copy(e), (this.sourceTexture = e.sourceTexture), this);
      }
    },
    Qa = class s extends Vi {
      constructor(e = 1, t = 1, i = 1, n = 1, r = 1, o = 1) {
        (super(),
          (this.type = 'BoxGeometry'),
          (this.parameters = {
            width: e,
            height: t,
            depth: i,
            widthSegments: n,
            heightSegments: r,
            depthSegments: o,
          }));
        let a = this;
        ((n = Math.floor(n)), (r = Math.floor(r)), (o = Math.floor(o)));
        let l = [],
          c = [],
          u = [],
          f = [],
          d = 0,
          p = 0;
        (_('z', 'y', 'x', -1, -1, i, t, e, o, r, 0),
          _('z', 'y', 'x', 1, -1, i, t, -e, o, r, 1),
          _('x', 'z', 'y', 1, 1, e, i, t, n, o, 2),
          _('x', 'z', 'y', 1, -1, e, i, -t, n, o, 3),
          _('x', 'y', 'z', 1, -1, e, t, i, n, r, 4),
          _('x', 'y', 'z', -1, -1, e, t, -i, n, r, 5),
          this.setIndex(l),
          this.setAttribute('position', new Hi(c, 3)),
          this.setAttribute('normal', new Hi(u, 3)),
          this.setAttribute('uv', new Hi(f, 2)));
        function _(x, g, v, w, L, R, U, O, N, M, I) {
          let z = R / N,
            W = U / M,
            q = R / 2,
            re = U / 2,
            oe = O / 2,
            K = N + 1,
            ie = M + 1,
            J = 0,
            pe = 0,
            Ee = new te();
          for (let Z = 0; Z < ie; Z++) {
            let Ne = Z * W - re;
            for (let Be = 0; Be < K; Be++) {
              let ht = Be * z - q;
              ((Ee[x] = ht * w),
                (Ee[g] = Ne * L),
                (Ee[v] = oe),
                c.push(Ee.x, Ee.y, Ee.z),
                (Ee[x] = 0),
                (Ee[g] = 0),
                (Ee[v] = O > 0 ? 1 : -1),
                u.push(Ee.x, Ee.y, Ee.z),
                f.push(Be / N),
                f.push(1 - Z / M),
                (J += 1));
            }
          }
          for (let Z = 0; Z < M; Z++)
            for (let Ne = 0; Ne < N; Ne++) {
              let Be = d + Ne + K * Z,
                ht = d + Ne + K * (Z + 1),
                ot = d + (Ne + 1) + K * (Z + 1),
                tt = d + (Ne + 1) + K * Z;
              (l.push(Be, ht, tt), l.push(ht, ot, tt), (pe += 6));
            }
          (a.addGroup(p, pe, I), (p += pe), (d += J));
        }
      }
      copy(e) {
        return (
          super.copy(e),
          (this.parameters = Object.assign({}, e.parameters)),
          this
        );
      }
      static fromJSON(e) {
        return new s(
          e.width,
          e.height,
          e.depth,
          e.widthSegments,
          e.heightSegments,
          e.depthSegments,
        );
      }
    };
  var Ac = class s extends Vi {
    constructor(
      e = 1,
      t = 1,
      i = 1,
      n = 32,
      r = 1,
      o = !1,
      a = 0,
      l = Math.PI * 2,
    ) {
      (super(),
        (this.type = 'CylinderGeometry'),
        (this.parameters = {
          radiusTop: e,
          radiusBottom: t,
          height: i,
          radialSegments: n,
          heightSegments: r,
          openEnded: o,
          thetaStart: a,
          thetaLength: l,
        }));
      let c = this;
      ((n = Math.floor(n)), (r = Math.floor(r)));
      let u = [],
        f = [],
        d = [],
        p = [],
        _ = 0,
        x = [],
        g = i / 2,
        v = 0;
      (w(),
        o === !1 && (e > 0 && L(!0), t > 0 && L(!1)),
        this.setIndex(u),
        this.setAttribute('position', new Hi(f, 3)),
        this.setAttribute('normal', new Hi(d, 3)),
        this.setAttribute('uv', new Hi(p, 2)));
      function w() {
        let R = new te(),
          U = new te(),
          O = 0,
          N = (t - e) / i;
        for (let M = 0; M <= r; M++) {
          let I = [],
            z = M / r,
            W = z * (t - e) + e;
          for (let q = 0; q <= n; q++) {
            let re = q / n,
              oe = re * l + a,
              K = Math.sin(oe),
              ie = Math.cos(oe);
            ((U.x = W * K),
              (U.y = -z * i + g),
              (U.z = W * ie),
              f.push(U.x, U.y, U.z),
              R.set(K, N, ie).normalize(),
              d.push(R.x, R.y, R.z),
              p.push(re, 1 - z),
              I.push(_++));
          }
          x.push(I);
        }
        for (let M = 0; M < n; M++)
          for (let I = 0; I < r; I++) {
            let z = x[I][M],
              W = x[I + 1][M],
              q = x[I + 1][M + 1],
              re = x[I][M + 1];
            ((e > 0 || I !== 0) && (u.push(z, W, re), (O += 3)),
              (t > 0 || I !== r - 1) && (u.push(W, q, re), (O += 3)));
          }
        (c.addGroup(v, O, 0), (v += O));
      }
      function L(R) {
        let U = _,
          O = new et(),
          N = new te(),
          M = 0,
          I = R === !0 ? e : t,
          z = R === !0 ? 1 : -1;
        for (let q = 1; q <= n; q++)
          (f.push(0, g * z, 0), d.push(0, z, 0), p.push(0.5, 0.5), _++);
        let W = _;
        for (let q = 0; q <= n; q++) {
          let oe = (q / n) * l + a,
            K = Math.cos(oe),
            ie = Math.sin(oe);
          ((N.x = I * ie),
            (N.y = g * z),
            (N.z = I * K),
            f.push(N.x, N.y, N.z),
            d.push(0, z, 0),
            (O.x = K * 0.5 + 0.5),
            (O.y = ie * 0.5 * z + 0.5),
            p.push(O.x, O.y),
            _++);
        }
        for (let q = 0; q < n; q++) {
          let re = U + q,
            oe = W + q;
          (R === !0 ? u.push(oe, oe + 1, re) : u.push(oe + 1, oe, re),
            (M += 3));
        }
        (c.addGroup(v, M, R === !0 ? 1 : 2), (v += M));
      }
    }
    copy(e) {
      return (
        super.copy(e),
        (this.parameters = Object.assign({}, e.parameters)),
        this
      );
    }
    static fromJSON(e) {
      return new s(
        e.radiusTop,
        e.radiusBottom,
        e.height,
        e.radialSegments,
        e.heightSegments,
        e.openEnded,
        e.thetaStart,
        e.thetaLength,
      );
    }
  };
  var ss = class s extends Vi {
    constructor(e = 1, t = 1, i = 1, n = 1) {
      (super(),
        (this.type = 'PlaneGeometry'),
        (this.parameters = {
          width: e,
          height: t,
          widthSegments: i,
          heightSegments: n,
        }));
      let r = e / 2,
        o = t / 2,
        a = Math.floor(i),
        l = Math.floor(n),
        c = a + 1,
        u = l + 1,
        f = e / a,
        d = t / l,
        p = [],
        _ = [],
        x = [],
        g = [];
      for (let v = 0; v < u; v++) {
        let w = v * d - o;
        for (let L = 0; L < c; L++) {
          let R = L * f - r;
          (_.push(R, -w, 0), x.push(0, 0, 1), g.push(L / a), g.push(1 - v / l));
        }
      }
      for (let v = 0; v < l; v++)
        for (let w = 0; w < a; w++) {
          let L = w + c * v,
            R = w + c * (v + 1),
            U = w + 1 + c * (v + 1),
            O = w + 1 + c * v;
          (p.push(L, R, O), p.push(R, U, O));
        }
      (this.setIndex(p),
        this.setAttribute('position', new Hi(_, 3)),
        this.setAttribute('normal', new Hi(x, 3)),
        this.setAttribute('uv', new Hi(g, 2)));
    }
    copy(e) {
      return (
        super.copy(e),
        (this.parameters = Object.assign({}, e.parameters)),
        this
      );
    }
    static fromJSON(e) {
      return new s(e.width, e.height, e.widthSegments, e.heightSegments);
    }
  };
  function ea(s) {
    let e = {};
    for (let t in s) {
      e[t] = {};
      for (let i in s[t]) {
        let n = s[t][i];
        if (Dx(n))
          n.isRenderTargetTexture
            ? (it(
                'UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().',
              ),
              (e[t][i] = null))
            : (e[t][i] = n.clone());
        else if (Array.isArray(n))
          if (Dx(n[0])) {
            let r = [];
            for (let o = 0, a = n.length; o < a; o++) r[o] = n[o].clone();
            e[t][i] = r;
          } else e[t][i] = n.slice();
        else e[t][i] = n;
      }
    }
    return e;
  }
  function on(s) {
    let e = {};
    for (let t = 0; t < s.length; t++) {
      let i = ea(s[t]);
      for (let n in i) e[n] = i[n];
    }
    return e;
  }
  function Dx(s) {
    return (
      s &&
      (s.isColor ||
        s.isMatrix3 ||
        s.isMatrix4 ||
        s.isVector2 ||
        s.isVector3 ||
        s.isVector4 ||
        s.isTexture ||
        s.isQuaternion)
    );
  }
  function QT(s) {
    let e = [];
    for (let t = 0; t < s.length; t++) e.push(s[t].clone());
    return e;
  }
  function mg(s) {
    let e = s.getRenderTarget();
    return e === null
      ? s.outputColorSpace
      : e.isXRRenderTarget === !0
        ? e.texture.colorSpace
        : Ct.workingColorSpace;
  }
  var Ty = { clone: ea, merge: on },
    eM = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`,
    tM = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`,
    vi = class extends Rn {
      constructor(e) {
        (super(),
          (this.isShaderMaterial = !0),
          (this.type = 'ShaderMaterial'),
          (this.defines = {}),
          (this.uniforms = {}),
          (this.uniformsGroups = []),
          (this.vertexShader = eM),
          (this.fragmentShader = tM),
          (this.linewidth = 1),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          (this.fog = !1),
          (this.lights = !1),
          (this.clipping = !1),
          (this.forceSinglePass = !0),
          (this.extensions = { clipCullDistance: !1, multiDraw: !1 }),
          (this.defaultAttributeValues = {
            color: [1, 1, 1],
            uv: [0, 0],
            uv1: [0, 0],
          }),
          (this.index0AttributeName = void 0),
          (this.uniformsNeedUpdate = !1),
          (this.glslVersion = null),
          e !== void 0 && this.setValues(e));
      }
      copy(e) {
        return (
          super.copy(e),
          (this.fragmentShader = e.fragmentShader),
          (this.vertexShader = e.vertexShader),
          (this.uniforms = ea(e.uniforms)),
          (this.uniformsGroups = QT(e.uniformsGroups)),
          (this.defines = Object.assign({}, e.defines)),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          (this.fog = e.fog),
          (this.lights = e.lights),
          (this.clipping = e.clipping),
          (this.extensions = Object.assign({}, e.extensions)),
          (this.glslVersion = e.glslVersion),
          (this.defaultAttributeValues = Object.assign(
            {},
            e.defaultAttributeValues,
          )),
          (this.index0AttributeName = e.index0AttributeName),
          (this.uniformsNeedUpdate = e.uniformsNeedUpdate),
          this
        );
      }
      toJSON(e) {
        let t = super.toJSON(e);
        ((t.glslVersion = this.glslVersion), (t.uniforms = {}));
        for (let n in this.uniforms) {
          let o = this.uniforms[n].value;
          o && o.isTexture
            ? (t.uniforms[n] = { type: 't', value: o.toJSON(e).uuid })
            : o && o.isColor
              ? (t.uniforms[n] = { type: 'c', value: o.getHex() })
              : o && o.isVector2
                ? (t.uniforms[n] = { type: 'v2', value: o.toArray() })
                : o && o.isVector3
                  ? (t.uniforms[n] = { type: 'v3', value: o.toArray() })
                  : o && o.isVector4
                    ? (t.uniforms[n] = { type: 'v4', value: o.toArray() })
                    : o && o.isMatrix3
                      ? (t.uniforms[n] = { type: 'm3', value: o.toArray() })
                      : o && o.isMatrix4
                        ? (t.uniforms[n] = { type: 'm4', value: o.toArray() })
                        : (t.uniforms[n] = { value: o });
        }
        (Object.keys(this.defines).length > 0 && (t.defines = this.defines),
          (t.vertexShader = this.vertexShader),
          (t.fragmentShader = this.fragmentShader),
          (t.lights = this.lights),
          (t.clipping = this.clipping));
        let i = {};
        for (let n in this.extensions) this.extensions[n] === !0 && (i[n] = !0);
        return (Object.keys(i).length > 0 && (t.extensions = i), t);
      }
    },
    ku = class extends vi {
      constructor(e) {
        (super(e),
          (this.isRawShaderMaterial = !0),
          (this.type = 'RawShaderMaterial'));
      }
    },
    Ko = class extends Rn {
      constructor(e) {
        (super(),
          (this.isMeshStandardMaterial = !0),
          (this.type = 'MeshStandardMaterial'),
          (this.defines = { STANDARD: '' }),
          (this.color = new je(16777215)),
          (this.roughness = 1),
          (this.metalness = 0),
          (this.map = null),
          (this.lightMap = null),
          (this.lightMapIntensity = 1),
          (this.aoMap = null),
          (this.aoMapIntensity = 1),
          (this.emissive = new je(0)),
          (this.emissiveIntensity = 1),
          (this.emissiveMap = null),
          (this.bumpMap = null),
          (this.bumpScale = 1),
          (this.normalMap = null),
          (this.normalMapType = Ud),
          (this.normalScale = new et(1, 1)),
          (this.displacementMap = null),
          (this.displacementScale = 1),
          (this.displacementBias = 0),
          (this.roughnessMap = null),
          (this.metalnessMap = null),
          (this.alphaMap = null),
          (this.envMap = null),
          (this.envMapRotation = new Ts()),
          (this.envMapIntensity = 1),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          (this.wireframeLinecap = 'round'),
          (this.wireframeLinejoin = 'round'),
          (this.flatShading = !1),
          (this.fog = !0),
          this.setValues(e));
      }
      copy(e) {
        return (
          super.copy(e),
          (this.defines = { STANDARD: '' }),
          this.color.copy(e.color),
          (this.roughness = e.roughness),
          (this.metalness = e.metalness),
          (this.map = e.map),
          (this.lightMap = e.lightMap),
          (this.lightMapIntensity = e.lightMapIntensity),
          (this.aoMap = e.aoMap),
          (this.aoMapIntensity = e.aoMapIntensity),
          this.emissive.copy(e.emissive),
          (this.emissiveMap = e.emissiveMap),
          (this.emissiveIntensity = e.emissiveIntensity),
          (this.bumpMap = e.bumpMap),
          (this.bumpScale = e.bumpScale),
          (this.normalMap = e.normalMap),
          (this.normalMapType = e.normalMapType),
          this.normalScale.copy(e.normalScale),
          (this.displacementMap = e.displacementMap),
          (this.displacementScale = e.displacementScale),
          (this.displacementBias = e.displacementBias),
          (this.roughnessMap = e.roughnessMap),
          (this.metalnessMap = e.metalnessMap),
          (this.alphaMap = e.alphaMap),
          (this.envMap = e.envMap),
          this.envMapRotation.copy(e.envMapRotation),
          (this.envMapIntensity = e.envMapIntensity),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          (this.wireframeLinecap = e.wireframeLinecap),
          (this.wireframeLinejoin = e.wireframeLinejoin),
          (this.flatShading = e.flatShading),
          (this.fog = e.fog),
          this
        );
      }
    },
    Cn = class extends Ko {
      constructor(e) {
        (super(),
          (this.isMeshPhysicalMaterial = !0),
          (this.defines = { STANDARD: '', PHYSICAL: '' }),
          (this.type = 'MeshPhysicalMaterial'),
          (this.anisotropyRotation = 0),
          (this.anisotropyMap = null),
          (this.clearcoatMap = null),
          (this.clearcoatRoughness = 0),
          (this.clearcoatRoughnessMap = null),
          (this.clearcoatNormalScale = new et(1, 1)),
          (this.clearcoatNormalMap = null),
          (this.ior = 1.5),
          Object.defineProperty(this, 'reflectivity', {
            get: function () {
              return Dt((2.5 * (this.ior - 1)) / (this.ior + 1), 0, 1);
            },
            set: function (t) {
              this.ior = (1 + 0.4 * t) / (1 - 0.4 * t);
            },
          }),
          (this.iridescenceMap = null),
          (this.iridescenceIOR = 1.3),
          (this.iridescenceThicknessRange = [100, 400]),
          (this.iridescenceThicknessMap = null),
          (this.sheenColor = new je(0)),
          (this.sheenColorMap = null),
          (this.sheenRoughness = 1),
          (this.sheenRoughnessMap = null),
          (this.transmissionMap = null),
          (this.thickness = 0),
          (this.thicknessMap = null),
          (this.attenuationDistance = 1 / 0),
          (this.attenuationColor = new je(1, 1, 1)),
          (this.specularIntensity = 1),
          (this.specularIntensityMap = null),
          (this.specularColor = new je(1, 1, 1)),
          (this.specularColorMap = null),
          (this._anisotropy = 0),
          (this._clearcoat = 0),
          (this._dispersion = 0),
          (this._iridescence = 0),
          (this._sheen = 0),
          (this._transmission = 0),
          this.setValues(e));
      }
      get anisotropy() {
        return this._anisotropy;
      }
      set anisotropy(e) {
        (this._anisotropy > 0 != e > 0 && this.version++,
          (this._anisotropy = e));
      }
      get clearcoat() {
        return this._clearcoat;
      }
      set clearcoat(e) {
        (this._clearcoat > 0 != e > 0 && this.version++, (this._clearcoat = e));
      }
      get iridescence() {
        return this._iridescence;
      }
      set iridescence(e) {
        (this._iridescence > 0 != e > 0 && this.version++,
          (this._iridescence = e));
      }
      get dispersion() {
        return this._dispersion;
      }
      set dispersion(e) {
        (this._dispersion > 0 != e > 0 && this.version++,
          (this._dispersion = e));
      }
      get sheen() {
        return this._sheen;
      }
      set sheen(e) {
        (this._sheen > 0 != e > 0 && this.version++, (this._sheen = e));
      }
      get transmission() {
        return this._transmission;
      }
      set transmission(e) {
        (this._transmission > 0 != e > 0 && this.version++,
          (this._transmission = e));
      }
      copy(e) {
        return (
          super.copy(e),
          (this.defines = { STANDARD: '', PHYSICAL: '' }),
          (this.anisotropy = e.anisotropy),
          (this.anisotropyRotation = e.anisotropyRotation),
          (this.anisotropyMap = e.anisotropyMap),
          (this.clearcoat = e.clearcoat),
          (this.clearcoatMap = e.clearcoatMap),
          (this.clearcoatRoughness = e.clearcoatRoughness),
          (this.clearcoatRoughnessMap = e.clearcoatRoughnessMap),
          (this.clearcoatNormalMap = e.clearcoatNormalMap),
          this.clearcoatNormalScale.copy(e.clearcoatNormalScale),
          (this.dispersion = e.dispersion),
          (this.ior = e.ior),
          (this.iridescence = e.iridescence),
          (this.iridescenceMap = e.iridescenceMap),
          (this.iridescenceIOR = e.iridescenceIOR),
          (this.iridescenceThicknessRange = [...e.iridescenceThicknessRange]),
          (this.iridescenceThicknessMap = e.iridescenceThicknessMap),
          (this.sheen = e.sheen),
          this.sheenColor.copy(e.sheenColor),
          (this.sheenColorMap = e.sheenColorMap),
          (this.sheenRoughness = e.sheenRoughness),
          (this.sheenRoughnessMap = e.sheenRoughnessMap),
          (this.transmission = e.transmission),
          (this.transmissionMap = e.transmissionMap),
          (this.thickness = e.thickness),
          (this.thicknessMap = e.thicknessMap),
          (this.attenuationDistance = e.attenuationDistance),
          this.attenuationColor.copy(e.attenuationColor),
          (this.specularIntensity = e.specularIntensity),
          (this.specularIntensityMap = e.specularIntensityMap),
          this.specularColor.copy(e.specularColor),
          (this.specularColorMap = e.specularColorMap),
          this
        );
      }
    };
  var Hu = class extends Rn {
      constructor(e) {
        (super(),
          (this.isMeshDepthMaterial = !0),
          (this.type = 'MeshDepthMaterial'),
          (this.depthPacking = uy),
          (this.map = null),
          (this.alphaMap = null),
          (this.displacementMap = null),
          (this.displacementScale = 1),
          (this.displacementBias = 0),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          this.setValues(e));
      }
      copy(e) {
        return (
          super.copy(e),
          (this.depthPacking = e.depthPacking),
          (this.map = e.map),
          (this.alphaMap = e.alphaMap),
          (this.displacementMap = e.displacementMap),
          (this.displacementScale = e.displacementScale),
          (this.displacementBias = e.displacementBias),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          this
        );
      }
    },
    zu = class extends Rn {
      constructor(e) {
        (super(),
          (this.isMeshDistanceMaterial = !0),
          (this.type = 'MeshDistanceMaterial'),
          (this.map = null),
          (this.alphaMap = null),
          (this.displacementMap = null),
          (this.displacementScale = 1),
          (this.displacementBias = 0),
          this.setValues(e));
      }
      copy(e) {
        return (
          super.copy(e),
          (this.map = e.map),
          (this.alphaMap = e.alphaMap),
          (this.displacementMap = e.displacementMap),
          (this.displacementScale = e.displacementScale),
          (this.displacementBias = e.displacementBias),
          this
        );
      }
    };
  function vu(s, e) {
    return !s || s.constructor === e
      ? s
      : typeof e.BYTES_PER_ELEMENT == 'number'
        ? new e(s)
        : Array.prototype.slice.call(s);
  }
  function iM(s) {
    function e(n, r) {
      return s[n] - s[r];
    }
    let t = s.length,
      i = new Array(t);
    for (let n = 0; n !== t; ++n) i[n] = n;
    return (i.sort(e), i);
  }
  function Ox(s, e, t) {
    let i = s.length,
      n = new s.constructor(i);
    for (let r = 0, o = 0; o !== i; ++r) {
      let a = t[r] * e;
      for (let l = 0; l !== e; ++l) n[o++] = s[a + l];
    }
    return n;
  }
  function My(s, e, t, i) {
    let n = 1,
      r = s[0];
    for (; r !== void 0 && r[i] === void 0; ) r = s[n++];
    if (r === void 0) return;
    let o = r[i];
    if (o !== void 0)
      if (Array.isArray(o))
        do
          ((o = r[i]),
            o !== void 0 && (e.push(r.time), t.push(...o)),
            (r = s[n++]));
        while (r !== void 0);
      else if (o.toArray !== void 0)
        do
          ((o = r[i]),
            o !== void 0 && (e.push(r.time), o.toArray(t, t.length)),
            (r = s[n++]));
        while (r !== void 0);
      else
        do
          ((o = r[i]),
            o !== void 0 && (e.push(r.time), t.push(o)),
            (r = s[n++]));
        while (r !== void 0);
  }
  var Zs = class {
      constructor(e, t, i, n) {
        ((this.parameterPositions = e),
          (this._cachedIndex = 0),
          (this.resultBuffer = n !== void 0 ? n : new t.constructor(i)),
          (this.sampleValues = t),
          (this.valueSize = i),
          (this.settings = null),
          (this.DefaultSettings_ = {}));
      }
      evaluate(e) {
        let t = this.parameterPositions,
          i = this._cachedIndex,
          n = t[i],
          r = t[i - 1];
        i: {
          e: {
            let o;
            t: {
              n: if (!(e < n)) {
                for (let a = i + 2; ; ) {
                  if (n === void 0) {
                    if (e < r) break n;
                    return (
                      (i = t.length),
                      (this._cachedIndex = i),
                      this.copySampleValue_(i - 1)
                    );
                  }
                  if (i === a) break;
                  if (((r = n), (n = t[++i]), e < n)) break e;
                }
                o = t.length;
                break t;
              }
              if (!(e >= r)) {
                let a = t[1];
                e < a && ((i = 2), (r = a));
                for (let l = i - 2; ; ) {
                  if (r === void 0)
                    return ((this._cachedIndex = 0), this.copySampleValue_(0));
                  if (i === l) break;
                  if (((n = r), (r = t[--i - 1]), e >= r)) break e;
                }
                ((o = i), (i = 0));
                break t;
              }
              break i;
            }
            for (; i < o; ) {
              let a = (i + o) >>> 1;
              e < t[a] ? (o = a) : (i = a + 1);
            }
            if (((n = t[i]), (r = t[i - 1]), r === void 0))
              return ((this._cachedIndex = 0), this.copySampleValue_(0));
            if (n === void 0)
              return (
                (i = t.length),
                (this._cachedIndex = i),
                this.copySampleValue_(i - 1)
              );
          }
          ((this._cachedIndex = i), this.intervalChanged_(i, r, n));
        }
        return this.interpolate_(i, r, e, n);
      }
      getSettings_() {
        return this.settings || this.DefaultSettings_;
      }
      copySampleValue_(e) {
        let t = this.resultBuffer,
          i = this.sampleValues,
          n = this.valueSize,
          r = e * n;
        for (let o = 0; o !== n; ++o) t[o] = i[r + o];
        return t;
      }
      interpolate_() {
        throw new Error('call to abstract method');
      }
      intervalChanged_() {}
    },
    Vu = class extends Zs {
      constructor(e, t, i, n) {
        (super(e, t, i, n),
          (this._weightPrev = -0),
          (this._offsetPrev = -0),
          (this._weightNext = -0),
          (this._offsetNext = -0),
          (this.DefaultSettings_ = { endingStart: Um, endingEnd: Um }));
      }
      intervalChanged_(e, t, i) {
        let n = this.parameterPositions,
          r = e - 2,
          o = e + 1,
          a = n[r],
          l = n[o];
        if (a === void 0)
          switch (this.getSettings_().endingStart) {
            case Bm:
              ((r = e), (a = 2 * t - i));
              break;
            case km:
              ((r = n.length - 2), (a = t + n[r] - n[r + 1]));
              break;
            default:
              ((r = e), (a = i));
          }
        if (l === void 0)
          switch (this.getSettings_().endingEnd) {
            case Bm:
              ((o = e), (l = 2 * i - t));
              break;
            case km:
              ((o = 1), (l = i + n[1] - n[0]));
              break;
            default:
              ((o = e - 1), (l = t));
          }
        let c = (i - t) * 0.5,
          u = this.valueSize;
        ((this._weightPrev = c / (t - a)),
          (this._weightNext = c / (l - i)),
          (this._offsetPrev = r * u),
          (this._offsetNext = o * u));
      }
      interpolate_(e, t, i, n) {
        let r = this.resultBuffer,
          o = this.sampleValues,
          a = this.valueSize,
          l = e * a,
          c = l - a,
          u = this._offsetPrev,
          f = this._offsetNext,
          d = this._weightPrev,
          p = this._weightNext,
          _ = (i - t) / (n - t),
          x = _ * _,
          g = x * _,
          v = -d * g + 2 * d * x - d * _,
          w = (1 + d) * g + (-1.5 - 2 * d) * x + (-0.5 + d) * _ + 1,
          L = (-1 - p) * g + (1.5 + p) * x + 0.5 * _,
          R = p * g - p * x;
        for (let U = 0; U !== a; ++U)
          r[U] = v * o[u + U] + w * o[c + U] + L * o[l + U] + R * o[f + U];
        return r;
      }
    },
    Gu = class extends Zs {
      constructor(e, t, i, n) {
        super(e, t, i, n);
      }
      interpolate_(e, t, i, n) {
        let r = this.resultBuffer,
          o = this.sampleValues,
          a = this.valueSize,
          l = e * a,
          c = l - a,
          u = (i - t) / (n - t),
          f = 1 - u;
        for (let d = 0; d !== a; ++d) r[d] = o[c + d] * f + o[l + d] * u;
        return r;
      }
    },
    Wu = class extends Zs {
      constructor(e, t, i, n) {
        super(e, t, i, n);
      }
      interpolate_(e) {
        return this.copySampleValue_(e - 1);
      }
    },
    Xu = class extends Zs {
      interpolate_(e, t, i, n) {
        let r = this.resultBuffer,
          o = this.sampleValues,
          a = this.valueSize,
          l = e * a,
          c = l - a,
          u = this.settings || this.DefaultSettings_,
          f = u.inTangents,
          d = u.outTangents;
        if (!f || !d) {
          let x = (i - t) / (n - t),
            g = 1 - x;
          for (let v = 0; v !== a; ++v) r[v] = o[c + v] * g + o[l + v] * x;
          return r;
        }
        let p = a * 2,
          _ = e - 1;
        for (let x = 0; x !== a; ++x) {
          let g = o[c + x],
            v = o[l + x],
            w = _ * p + x * 2,
            L = d[w],
            R = d[w + 1],
            U = e * p + x * 2,
            O = f[U],
            N = f[U + 1],
            M = (i - t) / (n - t),
            I,
            z,
            W,
            q,
            re;
          for (let oe = 0; oe < 8; oe++) {
            ((I = M * M), (z = I * M), (W = 1 - M), (q = W * W), (re = q * W));
            let ie = re * t + 3 * q * M * L + 3 * W * I * O + z * n - i;
            if (Math.abs(ie) < 1e-10) break;
            let J = 3 * q * (L - t) + 6 * W * M * (O - L) + 3 * I * (n - O);
            if (Math.abs(J) < 1e-10) break;
            ((M = M - ie / J), (M = Math.max(0, Math.min(1, M))));
          }
          r[x] = re * g + 3 * q * M * R + 3 * W * I * N + z * v;
        }
        return r;
      }
    },
    Pn = class {
      constructor(e, t, i, n) {
        if (e === void 0)
          throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (t === void 0 || t.length === 0)
          throw new Error(
            'THREE.KeyframeTrack: no keyframes in track named ' + e,
          );
        ((this.name = e),
          (this.times = vu(t, this.TimeBufferType)),
          (this.values = vu(i, this.ValueBufferType)),
          this.setInterpolation(n || this.DefaultInterpolation));
      }
      static toJSON(e) {
        let t = e.constructor,
          i;
        if (t.toJSON !== this.toJSON) i = t.toJSON(e);
        else {
          i = {
            name: e.name,
            times: vu(e.times, Array),
            values: vu(e.values, Array),
          };
          let n = e.getInterpolation();
          n !== e.DefaultInterpolation && (i.interpolation = n);
        }
        return ((i.type = e.ValueTypeName), i);
      }
      InterpolantFactoryMethodDiscrete(e) {
        return new Wu(this.times, this.values, this.getValueSize(), e);
      }
      InterpolantFactoryMethodLinear(e) {
        return new Gu(this.times, this.values, this.getValueSize(), e);
      }
      InterpolantFactoryMethodSmooth(e) {
        return new Vu(this.times, this.values, this.getValueSize(), e);
      }
      InterpolantFactoryMethodBezier(e) {
        let t = new Xu(this.times, this.values, this.getValueSize(), e);
        return (this.settings && (t.settings = this.settings), t);
      }
      setInterpolation(e) {
        let t;
        switch (e) {
          case Xo:
            t = this.InterpolantFactoryMethodDiscrete;
            break;
          case Yo:
            t = this.InterpolantFactoryMethodLinear;
            break;
          case bu:
            t = this.InterpolantFactoryMethodSmooth;
            break;
          case Fm:
            t = this.InterpolantFactoryMethodBezier;
            break;
        }
        if (t === void 0) {
          let i =
            'unsupported interpolation for ' +
            this.ValueTypeName +
            ' keyframe track named ' +
            this.name;
          if (this.createInterpolant === void 0)
            if (e !== this.DefaultInterpolation)
              this.setInterpolation(this.DefaultInterpolation);
            else throw new Error(i);
          return (it('KeyframeTrack:', i), this);
        }
        return ((this.createInterpolant = t), this);
      }
      getInterpolation() {
        switch (this.createInterpolant) {
          case this.InterpolantFactoryMethodDiscrete:
            return Xo;
          case this.InterpolantFactoryMethodLinear:
            return Yo;
          case this.InterpolantFactoryMethodSmooth:
            return bu;
          case this.InterpolantFactoryMethodBezier:
            return Fm;
        }
      }
      getValueSize() {
        return this.values.length / this.times.length;
      }
      shift(e) {
        if (e !== 0) {
          let t = this.times;
          for (let i = 0, n = t.length; i !== n; ++i) t[i] += e;
        }
        return this;
      }
      scale(e) {
        if (e !== 1) {
          let t = this.times;
          for (let i = 0, n = t.length; i !== n; ++i) t[i] *= e;
        }
        return this;
      }
      trim(e, t) {
        let i = this.times,
          n = i.length,
          r = 0,
          o = n - 1;
        for (; r !== n && i[r] < e; ) ++r;
        for (; o !== -1 && i[o] > t; ) --o;
        if ((++o, r !== 0 || o !== n)) {
          r >= o && ((o = Math.max(o, 1)), (r = o - 1));
          let a = this.getValueSize();
          ((this.times = i.slice(r, o)),
            (this.values = this.values.slice(r * a, o * a)));
        }
        return this;
      }
      validate() {
        let e = !0,
          t = this.getValueSize();
        t - Math.floor(t) !== 0 &&
          (mt('KeyframeTrack: Invalid value size in track.', this), (e = !1));
        let i = this.times,
          n = this.values,
          r = i.length;
        r === 0 && (mt('KeyframeTrack: Track is empty.', this), (e = !1));
        let o = null;
        for (let a = 0; a !== r; a++) {
          let l = i[a];
          if (typeof l == 'number' && isNaN(l)) {
            (mt('KeyframeTrack: Time is not a valid number.', this, a, l),
              (e = !1));
            break;
          }
          if (o !== null && o > l) {
            (mt('KeyframeTrack: Out of order keys.', this, a, l, o), (e = !1));
            break;
          }
          o = l;
        }
        if (n !== void 0 && mT(n))
          for (let a = 0, l = n.length; a !== l; ++a) {
            let c = n[a];
            if (isNaN(c)) {
              (mt('KeyframeTrack: Value is not a valid number.', this, a, c),
                (e = !1));
              break;
            }
          }
        return e;
      }
      optimize() {
        let e = this.times.slice(),
          t = this.values.slice(),
          i = this.getValueSize(),
          n = this.getInterpolation() === bu,
          r = e.length - 1,
          o = 1;
        for (let a = 1; a < r; ++a) {
          let l = !1,
            c = e[a],
            u = e[a + 1];
          if (c !== u && (a !== 1 || c !== e[0]))
            if (n) l = !0;
            else {
              let f = a * i,
                d = f - i,
                p = f + i;
              for (let _ = 0; _ !== i; ++_) {
                let x = t[f + _];
                if (x !== t[d + _] || x !== t[p + _]) {
                  l = !0;
                  break;
                }
              }
            }
          if (l) {
            if (a !== o) {
              e[o] = e[a];
              let f = a * i,
                d = o * i;
              for (let p = 0; p !== i; ++p) t[d + p] = t[f + p];
            }
            ++o;
          }
        }
        if (r > 0) {
          e[o] = e[r];
          for (let a = r * i, l = o * i, c = 0; c !== i; ++c)
            t[l + c] = t[a + c];
          ++o;
        }
        return (
          o !== e.length
            ? ((this.times = e.slice(0, o)), (this.values = t.slice(0, o * i)))
            : ((this.times = e), (this.values = t)),
          this
        );
      }
      clone() {
        let e = this.times.slice(),
          t = this.values.slice(),
          i = this.constructor,
          n = new i(this.name, e, t);
        return ((n.createInterpolant = this.createInterpolant), n);
      }
    };
  Pn.prototype.ValueTypeName = '';
  Pn.prototype.TimeBufferType = Float32Array;
  Pn.prototype.ValueBufferType = Float32Array;
  Pn.prototype.DefaultInterpolation = Yo;
  var wr = class extends Pn {
    constructor(e, t, i) {
      super(e, t, i);
    }
  };
  wr.prototype.ValueTypeName = 'bool';
  wr.prototype.ValueBufferType = Array;
  wr.prototype.DefaultInterpolation = Xo;
  wr.prototype.InterpolantFactoryMethodLinear = void 0;
  wr.prototype.InterpolantFactoryMethodSmooth = void 0;
  var Rc = class extends Pn {
    constructor(e, t, i, n) {
      super(e, t, i, n);
    }
  };
  Rc.prototype.ValueTypeName = 'color';
  var Ks = class extends Pn {
    constructor(e, t, i, n) {
      super(e, t, i, n);
    }
  };
  Ks.prototype.ValueTypeName = 'number';
  var Yu = class extends Zs {
      constructor(e, t, i, n) {
        super(e, t, i, n);
      }
      interpolate_(e, t, i, n) {
        let r = this.resultBuffer,
          o = this.sampleValues,
          a = this.valueSize,
          l = (i - t) / (n - t),
          c = e * a;
        for (let u = c + a; c !== u; c += 4)
          zi.slerpFlat(r, 0, o, c - a, o, c, l);
        return r;
      }
    },
    $s = class extends Pn {
      constructor(e, t, i, n) {
        super(e, t, i, n);
      }
      InterpolantFactoryMethodLinear(e) {
        return new Yu(this.times, this.values, this.getValueSize(), e);
      }
    };
  $s.prototype.ValueTypeName = 'quaternion';
  $s.prototype.InterpolantFactoryMethodSmooth = void 0;
  var Ar = class extends Pn {
    constructor(e, t, i) {
      super(e, t, i);
    }
  };
  Ar.prototype.ValueTypeName = 'string';
  Ar.prototype.ValueBufferType = Array;
  Ar.prototype.DefaultInterpolation = Xo;
  Ar.prototype.InterpolantFactoryMethodLinear = void 0;
  Ar.prototype.InterpolantFactoryMethodSmooth = void 0;
  var js = class extends Pn {
    constructor(e, t, i, n) {
      super(e, t, i, n);
    }
  };
  js.prototype.ValueTypeName = 'vector';
  var Cc = class {
    constructor(e = '', t = -1, i = [], n = hy) {
      ((this.name = e),
        (this.tracks = i),
        (this.duration = t),
        (this.blendMode = n),
        (this.uuid = bs()),
        (this.userData = {}),
        this.duration < 0 && this.resetDuration());
    }
    static parse(e) {
      let t = [],
        i = e.tracks,
        n = 1 / (e.fps || 1);
      for (let o = 0, a = i.length; o !== a; ++o) t.push(sM(i[o]).scale(n));
      let r = new this(e.name, e.duration, t, e.blendMode);
      return (
        (r.uuid = e.uuid),
        (r.userData = JSON.parse(e.userData || '{}')),
        r
      );
    }
    static toJSON(e) {
      let t = [],
        i = e.tracks,
        n = {
          name: e.name,
          duration: e.duration,
          tracks: t,
          uuid: e.uuid,
          blendMode: e.blendMode,
          userData: JSON.stringify(e.userData),
        };
      for (let r = 0, o = i.length; r !== o; ++r) t.push(Pn.toJSON(i[r]));
      return n;
    }
    static CreateFromMorphTargetSequence(e, t, i, n) {
      let r = t.length,
        o = [];
      for (let a = 0; a < r; a++) {
        let l = [],
          c = [];
        (l.push((a + r - 1) % r, a, (a + 1) % r), c.push(0, 1, 0));
        let u = iM(l);
        ((l = Ox(l, 1, u)),
          (c = Ox(c, 1, u)),
          !n && l[0] === 0 && (l.push(r), c.push(c[0])),
          o.push(
            new Ks('.morphTargetInfluences[' + t[a].name + ']', l, c).scale(
              1 / i,
            ),
          ));
      }
      return new this(e, -1, o);
    }
    static findByName(e, t) {
      let i = e;
      if (!Array.isArray(e)) {
        let n = e;
        i = (n.geometry && n.geometry.animations) || n.animations;
      }
      for (let n = 0; n < i.length; n++) if (i[n].name === t) return i[n];
      return null;
    }
    static CreateClipsFromMorphTargetSequences(e, t, i) {
      let n = {},
        r = /^([\w-]*?)([\d]+)$/;
      for (let a = 0, l = e.length; a < l; a++) {
        let c = e[a],
          u = c.name.match(r);
        if (u && u.length > 1) {
          let f = u[1],
            d = n[f];
          (d || (n[f] = d = []), d.push(c));
        }
      }
      let o = [];
      for (let a in n)
        o.push(this.CreateFromMorphTargetSequence(a, n[a], t, i));
      return o;
    }
    static parseAnimation(e, t) {
      if (
        (it(
          'AnimationClip: parseAnimation() is deprecated and will be removed with r185',
        ),
        !e)
      )
        return (mt('AnimationClip: No animation in JSONLoader data.'), null);
      let i = function (f, d, p, _, x) {
          if (p.length !== 0) {
            let g = [],
              v = [];
            (My(p, g, v, _), g.length !== 0 && x.push(new f(d, g, v)));
          }
        },
        n = [],
        r = e.name || 'default',
        o = e.fps || 30,
        a = e.blendMode,
        l = e.length || -1,
        c = e.hierarchy || [];
      for (let f = 0; f < c.length; f++) {
        let d = c[f].keys;
        if (!(!d || d.length === 0))
          if (d[0].morphTargets) {
            let p = {},
              _;
            for (_ = 0; _ < d.length; _++)
              if (d[_].morphTargets)
                for (let x = 0; x < d[_].morphTargets.length; x++)
                  p[d[_].morphTargets[x]] = -1;
            for (let x in p) {
              let g = [],
                v = [];
              for (let w = 0; w !== d[_].morphTargets.length; ++w) {
                let L = d[_];
                (g.push(L.time), v.push(L.morphTarget === x ? 1 : 0));
              }
              n.push(new Ks('.morphTargetInfluence[' + x + ']', g, v));
            }
            l = p.length * o;
          } else {
            let p = '.bones[' + t[f].name + ']';
            (i(js, p + '.position', d, 'pos', n),
              i($s, p + '.quaternion', d, 'rot', n),
              i(js, p + '.scale', d, 'scl', n));
          }
      }
      return n.length === 0 ? null : new this(r, l, n, a);
    }
    resetDuration() {
      let e = this.tracks,
        t = 0;
      for (let i = 0, n = e.length; i !== n; ++i) {
        let r = this.tracks[i];
        t = Math.max(t, r.times[r.times.length - 1]);
      }
      return ((this.duration = t), this);
    }
    trim() {
      for (let e = 0; e < this.tracks.length; e++)
        this.tracks[e].trim(0, this.duration);
      return this;
    }
    validate() {
      let e = !0;
      for (let t = 0; t < this.tracks.length; t++)
        e = e && this.tracks[t].validate();
      return e;
    }
    optimize() {
      for (let e = 0; e < this.tracks.length; e++) this.tracks[e].optimize();
      return this;
    }
    clone() {
      let e = [];
      for (let i = 0; i < this.tracks.length; i++)
        e.push(this.tracks[i].clone());
      let t = new this.constructor(this.name, this.duration, e, this.blendMode);
      return ((t.userData = JSON.parse(JSON.stringify(this.userData))), t);
    }
    toJSON() {
      return this.constructor.toJSON(this);
    }
  };
  function nM(s) {
    switch (s.toLowerCase()) {
      case 'scalar':
      case 'double':
      case 'float':
      case 'number':
      case 'integer':
        return Ks;
      case 'vector':
      case 'vector2':
      case 'vector3':
      case 'vector4':
        return js;
      case 'color':
        return Rc;
      case 'quaternion':
        return $s;
      case 'bool':
      case 'boolean':
        return wr;
      case 'string':
        return Ar;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + s);
  }
  function sM(s) {
    if (s.type === void 0)
      throw new Error(
        'THREE.KeyframeTrack: track type undefined, can not parse',
      );
    let e = nM(s.type);
    if (s.times === void 0) {
      let t = [],
        i = [];
      (My(s.keys, t, i, 'value'), (s.times = t), (s.values = i));
    }
    return e.parse !== void 0
      ? e.parse(s)
      : new e(s.name, s.times, s.values, s.interpolation);
  }
  var Ys = {
    enabled: !1,
    files: {},
    add: function (s, e) {
      this.enabled !== !1 && (Nx(s) || (this.files[s] = e));
    },
    get: function (s) {
      if (this.enabled !== !1 && !Nx(s)) return this.files[s];
    },
    remove: function (s) {
      delete this.files[s];
    },
    clear: function () {
      this.files = {};
    },
  };
  function Nx(s) {
    try {
      let e = s.slice(s.indexOf(':') + 1);
      return new URL(e).protocol === 'blob:';
    } catch (e) {
      return !1;
    }
  }
  var qu = class {
      constructor(e, t, i) {
        let n = this,
          r = !1,
          o = 0,
          a = 0,
          l,
          c = [];
        ((this.onStart = void 0),
          (this.onLoad = e),
          (this.onProgress = t),
          (this.onError = i),
          (this._abortController = null),
          (this.itemStart = function (u) {
            (a++,
              r === !1 && n.onStart !== void 0 && n.onStart(u, o, a),
              (r = !0));
          }),
          (this.itemEnd = function (u) {
            (o++,
              n.onProgress !== void 0 && n.onProgress(u, o, a),
              o === a && ((r = !1), n.onLoad !== void 0 && n.onLoad()));
          }),
          (this.itemError = function (u) {
            n.onError !== void 0 && n.onError(u);
          }),
          (this.resolveURL = function (u) {
            return l ? l(u) : u;
          }),
          (this.setURLModifier = function (u) {
            return ((l = u), this);
          }),
          (this.addHandler = function (u, f) {
            return (c.push(u, f), this);
          }),
          (this.removeHandler = function (u) {
            let f = c.indexOf(u);
            return (f !== -1 && c.splice(f, 2), this);
          }),
          (this.getHandler = function (u) {
            for (let f = 0, d = c.length; f < d; f += 2) {
              let p = c[f],
                _ = c[f + 1];
              if ((p.global && (p.lastIndex = 0), p.test(u))) return _;
            }
            return null;
          }),
          (this.abort = function () {
            return (
              this.abortController.abort(),
              (this._abortController = null),
              this
            );
          }));
      }
      get abortController() {
        return (
          this._abortController ||
            (this._abortController = new AbortController()),
          this._abortController
        );
      }
    },
    wy = new qu(),
    rs = class {
      constructor(e) {
        ((this.manager = e !== void 0 ? e : wy),
          (this.crossOrigin = 'anonymous'),
          (this.withCredentials = !1),
          (this.path = ''),
          (this.resourcePath = ''),
          (this.requestHeader = {}),
          typeof __THREE_DEVTOOLS__ != 'undefined' &&
            __THREE_DEVTOOLS__.dispatchEvent(
              new CustomEvent('observe', { detail: this }),
            ));
      }
      load() {}
      loadAsync(e, t) {
        let i = this;
        return new Promise(function (n, r) {
          i.load(e, n, t, r);
        });
      }
      parse() {}
      setCrossOrigin(e) {
        return ((this.crossOrigin = e), this);
      }
      setWithCredentials(e) {
        return ((this.withCredentials = e), this);
      }
      setPath(e) {
        return ((this.path = e), this);
      }
      setResourcePath(e) {
        return ((this.resourcePath = e), this);
      }
      setRequestHeader(e) {
        return ((this.requestHeader = e), this);
      }
      abort() {
        return this;
      }
    };
  rs.DEFAULT_MATERIAL_NAME = '__DEFAULT';
  var Sr = {},
    Vm = class extends Error {
      constructor(e, t) {
        (super(e), (this.response = t));
      }
    },
    Rr = class extends rs {
      constructor(e) {
        (super(e),
          (this.mimeType = ''),
          (this.responseType = ''),
          (this._abortController = new AbortController()));
      }
      load(e, t, i, n) {
        (e === void 0 && (e = ''),
          this.path !== void 0 && (e = this.path + e),
          (e = this.manager.resolveURL(e)));
        let r = Ys.get(`file:${e}`);
        if (r !== void 0) {
          (this.manager.itemStart(e),
            setTimeout(() => {
              (t && t(r), this.manager.itemEnd(e));
            }, 0));
          return;
        }
        if (Sr[e] !== void 0) {
          Sr[e].push({ onLoad: t, onProgress: i, onError: n });
          return;
        }
        ((Sr[e] = []), Sr[e].push({ onLoad: t, onProgress: i, onError: n }));
        let o = new Request(e, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin',
            signal:
              typeof AbortSignal.any == 'function'
                ? AbortSignal.any([
                    this._abortController.signal,
                    this.manager.abortController.signal,
                  ])
                : this._abortController.signal,
          }),
          a = this.mimeType,
          l = this.responseType;
        (fetch(o)
          .then((c) => {
            if (c.status === 200 || c.status === 0) {
              if (
                (c.status === 0 && it('FileLoader: HTTP Status 0 received.'),
                typeof ReadableStream == 'undefined' ||
                  c.body === void 0 ||
                  c.body.getReader === void 0)
              )
                return c;
              let u = Sr[e],
                f = c.body.getReader(),
                d =
                  c.headers.get('X-File-Size') ||
                  c.headers.get('Content-Length'),
                p = d ? parseInt(d) : 0,
                _ = p !== 0,
                x = 0,
                g = new ReadableStream({
                  start(v) {
                    w();
                    function w() {
                      f.read().then(
                        ({ done: L, value: R }) => {
                          if (L) v.close();
                          else {
                            x += R.byteLength;
                            let U = new ProgressEvent('progress', {
                              lengthComputable: _,
                              loaded: x,
                              total: p,
                            });
                            for (let O = 0, N = u.length; O < N; O++) {
                              let M = u[O];
                              M.onProgress && M.onProgress(U);
                            }
                            (v.enqueue(R), w());
                          }
                        },
                        (L) => {
                          v.error(L);
                        },
                      );
                    }
                  },
                });
              return new Response(g);
            } else
              throw new Vm(
                `fetch for "${c.url}" responded with ${c.status}: ${c.statusText}`,
                c,
              );
          })
          .then((c) => {
            switch (l) {
              case 'arraybuffer':
                return c.arrayBuffer();
              case 'blob':
                return c.blob();
              case 'document':
                return c
                  .text()
                  .then((u) => new DOMParser().parseFromString(u, a));
              case 'json':
                return c.json();
              default:
                if (a === '') return c.text();
                {
                  let f = /charset="?([^;"\s]*)"?/i.exec(a),
                    d = f && f[1] ? f[1].toLowerCase() : void 0,
                    p = new TextDecoder(d);
                  return c.arrayBuffer().then((_) => p.decode(_));
                }
            }
          })
          .then((c) => {
            Ys.add(`file:${e}`, c);
            let u = Sr[e];
            delete Sr[e];
            for (let f = 0, d = u.length; f < d; f++) {
              let p = u[f];
              p.onLoad && p.onLoad(c);
            }
          })
          .catch((c) => {
            let u = Sr[e];
            if (u === void 0) throw (this.manager.itemError(e), c);
            delete Sr[e];
            for (let f = 0, d = u.length; f < d; f++) {
              let p = u[f];
              p.onError && p.onError(c);
            }
            this.manager.itemError(e);
          })
          .finally(() => {
            this.manager.itemEnd(e);
          }),
          this.manager.itemStart(e));
      }
      setResponseType(e) {
        return ((this.responseType = e), this);
      }
      setMimeType(e) {
        return ((this.mimeType = e), this);
      }
      abort() {
        return (
          this._abortController.abort(),
          (this._abortController = new AbortController()),
          this
        );
      }
    };
  var Ba = new WeakMap(),
    Zu = class extends rs {
      constructor(e) {
        super(e);
      }
      load(e, t, i, n) {
        (this.path !== void 0 && (e = this.path + e),
          (e = this.manager.resolveURL(e)));
        let r = this,
          o = Ys.get(`image:${e}`);
        if (o !== void 0) {
          if (o.complete === !0)
            (r.manager.itemStart(e),
              setTimeout(function () {
                (t && t(o), r.manager.itemEnd(e));
              }, 0));
          else {
            let f = Ba.get(o);
            (f === void 0 && ((f = []), Ba.set(o, f)),
              f.push({ onLoad: t, onError: n }));
          }
          return o;
        }
        let a = Wa('img');
        function l() {
          (u(), t && t(this));
          let f = Ba.get(this) || [];
          for (let d = 0; d < f.length; d++) {
            let p = f[d];
            p.onLoad && p.onLoad(this);
          }
          (Ba.delete(this), r.manager.itemEnd(e));
        }
        function c(f) {
          (u(), n && n(f), Ys.remove(`image:${e}`));
          let d = Ba.get(this) || [];
          for (let p = 0; p < d.length; p++) {
            let _ = d[p];
            _.onError && _.onError(f);
          }
          (Ba.delete(this), r.manager.itemError(e), r.manager.itemEnd(e));
        }
        function u() {
          (a.removeEventListener('load', l, !1),
            a.removeEventListener('error', c, !1));
        }
        return (
          a.addEventListener('load', l, !1),
          a.addEventListener('error', c, !1),
          e.slice(0, 5) !== 'data:' &&
            this.crossOrigin !== void 0 &&
            (a.crossOrigin = this.crossOrigin),
          Ys.add(`image:${e}`, a),
          r.manager.itemStart(e),
          (a.src = e),
          a
        );
      }
    };
  var $o = class extends rs {
      constructor(e) {
        super(e);
      }
      load(e, t, i, n) {
        let r = new Li(),
          o = new Zu(this.manager);
        return (
          o.setCrossOrigin(this.crossOrigin),
          o.setPath(this.path),
          o.load(
            e,
            function (a) {
              ((r.image = a), (r.needsUpdate = !0), t !== void 0 && t(r));
            },
            i,
            n,
          ),
          r
        );
      }
    },
    jo = class extends pi {
      constructor(e, t = 1) {
        (super(),
          (this.isLight = !0),
          (this.type = 'Light'),
          (this.color = new je(e)),
          (this.intensity = t));
      }
      dispose() {
        this.dispatchEvent({ type: 'dispose' });
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          this.color.copy(e.color),
          (this.intensity = e.intensity),
          this
        );
      }
      toJSON(e) {
        let t = super.toJSON(e);
        return (
          (t.object.color = this.color.getHex()),
          (t.object.intensity = this.intensity),
          t
        );
      }
    };
  var Dm = new yt(),
    Fx = new te(),
    Ux = new te(),
    Pc = class {
      constructor(e) {
        ((this.camera = e),
          (this.intensity = 1),
          (this.bias = 0),
          (this.biasNode = null),
          (this.normalBias = 0),
          (this.radius = 1),
          (this.blurSamples = 8),
          (this.mapSize = new et(512, 512)),
          (this.mapType = Ln),
          (this.map = null),
          (this.mapPass = null),
          (this.matrix = new yt()),
          (this.autoUpdate = !0),
          (this.needsUpdate = !1),
          (this._frustum = new $a()),
          (this._frameExtents = new et(1, 1)),
          (this._viewportCount = 1),
          (this._viewports = [new Qt(0, 0, 1, 1)]));
      }
      getViewportCount() {
        return this._viewportCount;
      }
      getFrustum() {
        return this._frustum;
      }
      updateMatrices(e) {
        let t = this.camera,
          i = this.matrix;
        (Fx.setFromMatrixPosition(e.matrixWorld),
          t.position.copy(Fx),
          Ux.setFromMatrixPosition(e.target.matrixWorld),
          t.lookAt(Ux),
          t.updateMatrixWorld(),
          Dm.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse),
          this._frustum.setFromProjectionMatrix(
            Dm,
            t.coordinateSystem,
            t.reversedDepth,
          ),
          t.coordinateSystem === Ga || t.reversedDepth
            ? i.set(0.5, 0, 0, 0.5, 0, 0.5, 0, 0.5, 0, 0, 1, 0, 0, 0, 0, 1)
            : i.set(0.5, 0, 0, 0.5, 0, 0.5, 0, 0.5, 0, 0, 0.5, 0.5, 0, 0, 0, 1),
          i.multiply(Dm));
      }
      getViewport(e) {
        return this._viewports[e];
      }
      getFrameExtents() {
        return this._frameExtents;
      }
      dispose() {
        (this.map && this.map.dispose(),
          this.mapPass && this.mapPass.dispose());
      }
      copy(e) {
        return (
          (this.camera = e.camera.clone()),
          (this.intensity = e.intensity),
          (this.bias = e.bias),
          (this.radius = e.radius),
          (this.autoUpdate = e.autoUpdate),
          (this.needsUpdate = e.needsUpdate),
          (this.normalBias = e.normalBias),
          (this.blurSamples = e.blurSamples),
          this.mapSize.copy(e.mapSize),
          (this.biasNode = e.biasNode),
          this
        );
      }
      clone() {
        return new this.constructor().copy(this);
      }
      toJSON() {
        let e = {};
        return (
          this.intensity !== 1 && (e.intensity = this.intensity),
          this.bias !== 0 && (e.bias = this.bias),
          this.normalBias !== 0 && (e.normalBias = this.normalBias),
          this.radius !== 1 && (e.radius = this.radius),
          (this.mapSize.x !== 512 || this.mapSize.y !== 512) &&
            (e.mapSize = this.mapSize.toArray()),
          (e.camera = this.camera.toJSON(!1).object),
          delete e.camera.matrix,
          e
        );
      }
    },
    xu = new te(),
    yu = new zi(),
    Xs = new te(),
    Ms = class extends pi {
      constructor() {
        (super(),
          (this.isCamera = !0),
          (this.type = 'Camera'),
          (this.matrixWorldInverse = new yt()),
          (this.projectionMatrix = new yt()),
          (this.projectionMatrixInverse = new yt()),
          (this.coordinateSystem = ys),
          (this._reversedDepth = !1));
      }
      get reversedDepth() {
        return this._reversedDepth;
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          this.matrixWorldInverse.copy(e.matrixWorldInverse),
          this.projectionMatrix.copy(e.projectionMatrix),
          this.projectionMatrixInverse.copy(e.projectionMatrixInverse),
          (this.coordinateSystem = e.coordinateSystem),
          this
        );
      }
      getWorldDirection(e) {
        return super.getWorldDirection(e).negate();
      }
      updateMatrixWorld(e) {
        (super.updateMatrixWorld(e),
          this.matrixWorld.decompose(xu, yu, Xs),
          Xs.x === 1 && Xs.y === 1 && Xs.z === 1
            ? this.matrixWorldInverse.copy(this.matrixWorld).invert()
            : this.matrixWorldInverse
                .compose(xu, yu, Xs.set(1, 1, 1))
                .invert());
      }
      updateWorldMatrix(e, t) {
        (super.updateWorldMatrix(e, t),
          this.matrixWorld.decompose(xu, yu, Xs),
          Xs.x === 1 && Xs.y === 1 && Xs.z === 1
            ? this.matrixWorldInverse.copy(this.matrixWorld).invert()
            : this.matrixWorldInverse
                .compose(xu, yu, Xs.set(1, 1, 1))
                .invert());
      }
      clone() {
        return new this.constructor().copy(this);
      }
    },
    $r = new te(),
    Bx = new et(),
    kx = new et(),
    di = class extends Ms {
      constructor(e = 50, t = 1, i = 0.1, n = 2e3) {
        (super(),
          (this.isPerspectiveCamera = !0),
          (this.type = 'PerspectiveCamera'),
          (this.fov = e),
          (this.zoom = 1),
          (this.near = i),
          (this.far = n),
          (this.focus = 10),
          (this.aspect = t),
          (this.view = null),
          (this.filmGauge = 35),
          (this.filmOffset = 0),
          this.updateProjectionMatrix());
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          (this.fov = e.fov),
          (this.zoom = e.zoom),
          (this.near = e.near),
          (this.far = e.far),
          (this.focus = e.focus),
          (this.aspect = e.aspect),
          (this.view = e.view === null ? null : Object.assign({}, e.view)),
          (this.filmGauge = e.filmGauge),
          (this.filmOffset = e.filmOffset),
          this
        );
      }
      setFocalLength(e) {
        let t = (0.5 * this.getFilmHeight()) / e;
        ((this.fov = qo * 2 * Math.atan(t)), this.updateProjectionMatrix());
      }
      getFocalLength() {
        let e = Math.tan(hc * 0.5 * this.fov);
        return (0.5 * this.getFilmHeight()) / e;
      }
      getEffectiveFOV() {
        return qo * 2 * Math.atan(Math.tan(hc * 0.5 * this.fov) / this.zoom);
      }
      getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
      }
      getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
      }
      getViewBounds(e, t, i) {
        ($r.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse),
          t.set($r.x, $r.y).multiplyScalar(-e / $r.z),
          $r.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse),
          i.set($r.x, $r.y).multiplyScalar(-e / $r.z));
      }
      getViewSize(e, t) {
        return (this.getViewBounds(e, Bx, kx), t.subVectors(kx, Bx));
      }
      setViewOffset(e, t, i, n, r, o) {
        ((this.aspect = e / t),
          this.view === null &&
            (this.view = {
              enabled: !0,
              fullWidth: 1,
              fullHeight: 1,
              offsetX: 0,
              offsetY: 0,
              width: 1,
              height: 1,
            }),
          (this.view.enabled = !0),
          (this.view.fullWidth = e),
          (this.view.fullHeight = t),
          (this.view.offsetX = i),
          (this.view.offsetY = n),
          (this.view.width = r),
          (this.view.height = o),
          this.updateProjectionMatrix());
      }
      clearViewOffset() {
        (this.view !== null && (this.view.enabled = !1),
          this.updateProjectionMatrix());
      }
      updateProjectionMatrix() {
        let e = this.near,
          t = (e * Math.tan(hc * 0.5 * this.fov)) / this.zoom,
          i = 2 * t,
          n = this.aspect * i,
          r = -0.5 * n,
          o = this.view;
        if (this.view !== null && this.view.enabled) {
          let l = o.fullWidth,
            c = o.fullHeight;
          ((r += (o.offsetX * n) / l),
            (t -= (o.offsetY * i) / c),
            (n *= o.width / l),
            (i *= o.height / c));
        }
        let a = this.filmOffset;
        (a !== 0 && (r += (e * a) / this.getFilmWidth()),
          this.projectionMatrix.makePerspective(
            r,
            r + n,
            t,
            t - i,
            e,
            this.far,
            this.coordinateSystem,
            this.reversedDepth,
          ),
          this.projectionMatrixInverse.copy(this.projectionMatrix).invert());
      }
      toJSON(e) {
        let t = super.toJSON(e);
        return (
          (t.object.fov = this.fov),
          (t.object.zoom = this.zoom),
          (t.object.near = this.near),
          (t.object.far = this.far),
          (t.object.focus = this.focus),
          (t.object.aspect = this.aspect),
          this.view !== null && (t.object.view = Object.assign({}, this.view)),
          (t.object.filmGauge = this.filmGauge),
          (t.object.filmOffset = this.filmOffset),
          t
        );
      }
    },
    Gm = class extends Pc {
      constructor() {
        (super(new di(50, 1, 0.5, 500)),
          (this.isSpotLightShadow = !0),
          (this.focus = 1),
          (this.aspect = 1));
      }
      updateMatrices(e) {
        let t = this.camera,
          i = qo * 2 * e.angle * this.focus,
          n = (this.mapSize.width / this.mapSize.height) * this.aspect,
          r = e.distance || t.far;
        ((i !== t.fov || n !== t.aspect || r !== t.far) &&
          ((t.fov = i),
          (t.aspect = n),
          (t.far = r),
          t.updateProjectionMatrix()),
          super.updateMatrices(e));
      }
      copy(e) {
        return (super.copy(e), (this.focus = e.focus), this);
      }
    },
    Lc = class extends jo {
      constructor(e, t, i = 0, n = Math.PI / 3, r = 0, o = 2) {
        (super(e, t),
          (this.isSpotLight = !0),
          (this.type = 'SpotLight'),
          this.position.copy(pi.DEFAULT_UP),
          this.updateMatrix(),
          (this.target = new pi()),
          (this.distance = i),
          (this.angle = n),
          (this.penumbra = r),
          (this.decay = o),
          (this.map = null),
          (this.shadow = new Gm()));
      }
      get power() {
        return this.intensity * Math.PI;
      }
      set power(e) {
        this.intensity = e / Math.PI;
      }
      dispose() {
        (super.dispose(), this.shadow.dispose());
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          (this.distance = e.distance),
          (this.angle = e.angle),
          (this.penumbra = e.penumbra),
          (this.decay = e.decay),
          (this.target = e.target.clone()),
          (this.map = e.map),
          (this.shadow = e.shadow.clone()),
          this
        );
      }
      toJSON(e) {
        let t = super.toJSON(e);
        return (
          (t.object.distance = this.distance),
          (t.object.angle = this.angle),
          (t.object.decay = this.decay),
          (t.object.penumbra = this.penumbra),
          (t.object.target = this.target.uuid),
          this.map &&
            this.map.isTexture &&
            (t.object.map = this.map.toJSON(e).uuid),
          (t.object.shadow = this.shadow.toJSON()),
          t
        );
      }
    },
    Wm = class extends Pc {
      constructor() {
        (super(new di(90, 1, 0.5, 500)), (this.isPointLightShadow = !0));
      }
    },
    Ic = class extends jo {
      constructor(e, t, i = 0, n = 2) {
        (super(e, t),
          (this.isPointLight = !0),
          (this.type = 'PointLight'),
          (this.distance = i),
          (this.decay = n),
          (this.shadow = new Wm()));
      }
      get power() {
        return this.intensity * 4 * Math.PI;
      }
      set power(e) {
        this.intensity = e / (4 * Math.PI);
      }
      dispose() {
        (super.dispose(), this.shadow.dispose());
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          (this.distance = e.distance),
          (this.decay = e.decay),
          (this.shadow = e.shadow.clone()),
          this
        );
      }
      toJSON(e) {
        let t = super.toJSON(e);
        return (
          (t.object.distance = this.distance),
          (t.object.decay = this.decay),
          (t.object.shadow = this.shadow.toJSON()),
          t
        );
      }
    },
    no = class extends Ms {
      constructor(e = -1, t = 1, i = 1, n = -1, r = 0.1, o = 2e3) {
        (super(),
          (this.isOrthographicCamera = !0),
          (this.type = 'OrthographicCamera'),
          (this.zoom = 1),
          (this.view = null),
          (this.left = e),
          (this.right = t),
          (this.top = i),
          (this.bottom = n),
          (this.near = r),
          (this.far = o),
          this.updateProjectionMatrix());
      }
      copy(e, t) {
        return (
          super.copy(e, t),
          (this.left = e.left),
          (this.right = e.right),
          (this.top = e.top),
          (this.bottom = e.bottom),
          (this.near = e.near),
          (this.far = e.far),
          (this.zoom = e.zoom),
          (this.view = e.view === null ? null : Object.assign({}, e.view)),
          this
        );
      }
      setViewOffset(e, t, i, n, r, o) {
        (this.view === null &&
          (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1,
          }),
          (this.view.enabled = !0),
          (this.view.fullWidth = e),
          (this.view.fullHeight = t),
          (this.view.offsetX = i),
          (this.view.offsetY = n),
          (this.view.width = r),
          (this.view.height = o),
          this.updateProjectionMatrix());
      }
      clearViewOffset() {
        (this.view !== null && (this.view.enabled = !1),
          this.updateProjectionMatrix());
      }
      updateProjectionMatrix() {
        let e = (this.right - this.left) / (2 * this.zoom),
          t = (this.top - this.bottom) / (2 * this.zoom),
          i = (this.right + this.left) / 2,
          n = (this.top + this.bottom) / 2,
          r = i - e,
          o = i + e,
          a = n + t,
          l = n - t;
        if (this.view !== null && this.view.enabled) {
          let c = (this.right - this.left) / this.view.fullWidth / this.zoom,
            u = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
          ((r += c * this.view.offsetX),
            (o = r + c * this.view.width),
            (a -= u * this.view.offsetY),
            (l = a - u * this.view.height));
        }
        (this.projectionMatrix.makeOrthographic(
          r,
          o,
          a,
          l,
          this.near,
          this.far,
          this.coordinateSystem,
          this.reversedDepth,
        ),
          this.projectionMatrixInverse.copy(this.projectionMatrix).invert());
      }
      toJSON(e) {
        let t = super.toJSON(e);
        return (
          (t.object.zoom = this.zoom),
          (t.object.left = this.left),
          (t.object.right = this.right),
          (t.object.top = this.top),
          (t.object.bottom = this.bottom),
          (t.object.near = this.near),
          (t.object.far = this.far),
          this.view !== null && (t.object.view = Object.assign({}, this.view)),
          t
        );
      }
    },
    Xm = class extends Pc {
      constructor() {
        (super(new no(-5, 5, 5, -5, 0.5, 500)),
          (this.isDirectionalLightShadow = !0));
      }
    },
    Js = class extends jo {
      constructor(e, t) {
        (super(e, t),
          (this.isDirectionalLight = !0),
          (this.type = 'DirectionalLight'),
          this.position.copy(pi.DEFAULT_UP),
          this.updateMatrix(),
          (this.target = new pi()),
          (this.shadow = new Xm()));
      }
      dispose() {
        (super.dispose(), this.shadow.dispose());
      }
      copy(e) {
        return (
          super.copy(e),
          (this.target = e.target.clone()),
          (this.shadow = e.shadow.clone()),
          this
        );
      }
      toJSON(e) {
        let t = super.toJSON(e);
        return (
          (t.object.shadow = this.shadow.toJSON()),
          (t.object.target = this.target.uuid),
          t
        );
      }
    },
    el = class extends jo {
      constructor(e, t) {
        (super(e, t), (this.isAmbientLight = !0), (this.type = 'AmbientLight'));
      }
    };
  var Cr = class {
    static extractUrlBase(e) {
      let t = e.lastIndexOf('/');
      return t === -1 ? './' : e.slice(0, t + 1);
    }
    static resolveURL(e, t) {
      return typeof e != 'string' || e === ''
        ? ''
        : (/^https?:\/\//i.test(t) &&
            /^\//.test(e) &&
            (t = t.replace(/(^https?:\/\/[^\/]+).*/i, '$1')),
          /^(https?:)?\/\//i.test(e) ||
          /^data:.*,.*$/i.test(e) ||
          /^blob:.*$/i.test(e)
            ? e
            : t + e);
    }
  };
  var Om = new WeakMap(),
    Dc = class extends rs {
      constructor(e) {
        (super(e),
          (this.isImageBitmapLoader = !0),
          typeof createImageBitmap == 'undefined' &&
            it('ImageBitmapLoader: createImageBitmap() not supported.'),
          typeof fetch == 'undefined' &&
            it('ImageBitmapLoader: fetch() not supported.'),
          (this.options = { premultiplyAlpha: 'none' }),
          (this._abortController = new AbortController()));
      }
      setOptions(e) {
        return ((this.options = e), this);
      }
      load(e, t, i, n) {
        (e === void 0 && (e = ''),
          this.path !== void 0 && (e = this.path + e),
          (e = this.manager.resolveURL(e)));
        let r = this,
          o = Ys.get(`image-bitmap:${e}`);
        if (o !== void 0) {
          if ((r.manager.itemStart(e), o.then)) {
            o.then((c) => {
              Om.has(o) === !0
                ? (n && n(Om.get(o)),
                  r.manager.itemError(e),
                  r.manager.itemEnd(e))
                : (t && t(c), r.manager.itemEnd(e));
            });
            return;
          }
          setTimeout(function () {
            (t && t(o), r.manager.itemEnd(e));
          }, 0);
          return;
        }
        let a = {};
        ((a.credentials =
          this.crossOrigin === 'anonymous' ? 'same-origin' : 'include'),
          (a.headers = this.requestHeader),
          (a.signal =
            typeof AbortSignal.any == 'function'
              ? AbortSignal.any([
                  this._abortController.signal,
                  this.manager.abortController.signal,
                ])
              : this._abortController.signal));
        let l = fetch(e, a)
          .then(function (c) {
            return c.blob();
          })
          .then(function (c) {
            return createImageBitmap(
              c,
              Object.assign(r.options, { colorSpaceConversion: 'none' }),
            );
          })
          .then(function (c) {
            (Ys.add(`image-bitmap:${e}`, c), t && t(c), r.manager.itemEnd(e));
          })
          .catch(function (c) {
            (n && n(c),
              Om.set(l, c),
              Ys.remove(`image-bitmap:${e}`),
              r.manager.itemError(e),
              r.manager.itemEnd(e));
          });
        (Ys.add(`image-bitmap:${e}`, l), r.manager.itemStart(e));
      }
      abort() {
        return (
          this._abortController.abort(),
          (this._abortController = new AbortController()),
          this
        );
      }
    };
  var ka = -90,
    Ha = 1,
    Ku = class extends pi {
      constructor(e, t, i) {
        (super(),
          (this.type = 'CubeCamera'),
          (this.renderTarget = i),
          (this.coordinateSystem = null),
          (this.activeMipmapLevel = 0));
        let n = new di(ka, Ha, e, t);
        ((n.layers = this.layers), this.add(n));
        let r = new di(ka, Ha, e, t);
        ((r.layers = this.layers), this.add(r));
        let o = new di(ka, Ha, e, t);
        ((o.layers = this.layers), this.add(o));
        let a = new di(ka, Ha, e, t);
        ((a.layers = this.layers), this.add(a));
        let l = new di(ka, Ha, e, t);
        ((l.layers = this.layers), this.add(l));
        let c = new di(ka, Ha, e, t);
        ((c.layers = this.layers), this.add(c));
      }
      updateCoordinateSystem() {
        let e = this.coordinateSystem,
          t = this.children.concat(),
          [i, n, r, o, a, l] = t;
        for (let c of t) this.remove(c);
        if (e === ys)
          (i.up.set(0, 1, 0),
            i.lookAt(1, 0, 0),
            n.up.set(0, 1, 0),
            n.lookAt(-1, 0, 0),
            r.up.set(0, 0, -1),
            r.lookAt(0, 1, 0),
            o.up.set(0, 0, 1),
            o.lookAt(0, -1, 0),
            a.up.set(0, 1, 0),
            a.lookAt(0, 0, 1),
            l.up.set(0, 1, 0),
            l.lookAt(0, 0, -1));
        else if (e === Ga)
          (i.up.set(0, -1, 0),
            i.lookAt(-1, 0, 0),
            n.up.set(0, -1, 0),
            n.lookAt(1, 0, 0),
            r.up.set(0, 0, 1),
            r.lookAt(0, 1, 0),
            o.up.set(0, 0, -1),
            o.lookAt(0, -1, 0),
            a.up.set(0, -1, 0),
            a.lookAt(0, 0, 1),
            l.up.set(0, -1, 0),
            l.lookAt(0, 0, -1));
        else
          throw new Error(
            'THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' +
              e,
          );
        for (let c of t) (this.add(c), c.updateMatrixWorld());
      }
      update(e, t) {
        this.parent === null && this.updateMatrixWorld();
        let { renderTarget: i, activeMipmapLevel: n } = this;
        this.coordinateSystem !== e.coordinateSystem &&
          ((this.coordinateSystem = e.coordinateSystem),
          this.updateCoordinateSystem());
        let [r, o, a, l, c, u] = this.children,
          f = e.getRenderTarget(),
          d = e.getActiveCubeFace(),
          p = e.getActiveMipmapLevel(),
          _ = e.xr.enabled;
        e.xr.enabled = !1;
        let x = i.texture.generateMipmaps;
        i.texture.generateMipmaps = !1;
        let g = !1;
        (e.isWebGLRenderer === !0
          ? (g = e.state.buffers.depth.getReversed())
          : (g = e.reversedDepthBuffer),
          e.setRenderTarget(i, 0, n),
          g && e.autoClear === !1 && e.clearDepth(),
          e.render(t, r),
          e.setRenderTarget(i, 1, n),
          g && e.autoClear === !1 && e.clearDepth(),
          e.render(t, o),
          e.setRenderTarget(i, 2, n),
          g && e.autoClear === !1 && e.clearDepth(),
          e.render(t, a),
          e.setRenderTarget(i, 3, n),
          g && e.autoClear === !1 && e.clearDepth(),
          e.render(t, l),
          e.setRenderTarget(i, 4, n),
          g && e.autoClear === !1 && e.clearDepth(),
          e.render(t, c),
          (i.texture.generateMipmaps = x),
          e.setRenderTarget(i, 5, n),
          g && e.autoClear === !1 && e.clearDepth(),
          e.render(t, u),
          e.setRenderTarget(f, d, p),
          (e.xr.enabled = _),
          (i.texture.needsPMREMUpdate = !0));
      }
    },
    $u = class extends di {
      constructor(e = []) {
        (super(),
          (this.isArrayCamera = !0),
          (this.isMultiViewCamera = !1),
          (this.cameras = e));
      }
    };
  var gg = '\\[\\]\\.:\\/',
    rM = new RegExp('[' + gg + ']', 'g'),
    _g = '[^' + gg + ']',
    oM = '[^' + gg.replace('\\.', '') + ']',
    aM = /((?:WC+[\/:])*)/.source.replace('WC', _g),
    lM = /(WCOD+)?/.source.replace('WCOD', oM),
    cM = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', _g),
    hM = /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', _g),
    uM = new RegExp('^' + aM + lM + cM + hM + '$'),
    dM = ['material', 'materials', 'bones', 'map'],
    Ym = class {
      constructor(e, t, i) {
        let n = i || si.parseTrackName(t);
        ((this._targetGroup = e), (this._bindings = e.subscribe_(t, n)));
      }
      getValue(e, t) {
        this.bind();
        let i = this._targetGroup.nCachedObjects_,
          n = this._bindings[i];
        n !== void 0 && n.getValue(e, t);
      }
      setValue(e, t) {
        let i = this._bindings;
        for (
          let n = this._targetGroup.nCachedObjects_, r = i.length;
          n !== r;
          ++n
        )
          i[n].setValue(e, t);
      }
      bind() {
        let e = this._bindings;
        for (
          let t = this._targetGroup.nCachedObjects_, i = e.length;
          t !== i;
          ++t
        )
          e[t].bind();
      }
      unbind() {
        let e = this._bindings;
        for (
          let t = this._targetGroup.nCachedObjects_, i = e.length;
          t !== i;
          ++t
        )
          e[t].unbind();
      }
    },
    si = class s {
      constructor(e, t, i) {
        ((this.path = t),
          (this.parsedPath = i || s.parseTrackName(t)),
          (this.node = s.findNode(e, this.parsedPath.nodeName)),
          (this.rootNode = e),
          (this.getValue = this._getValue_unbound),
          (this.setValue = this._setValue_unbound));
      }
      static create(e, t, i) {
        return e && e.isAnimationObjectGroup
          ? new s.Composite(e, t, i)
          : new s(e, t, i);
      }
      static sanitizeNodeName(e) {
        return e.replace(/\s/g, '_').replace(rM, '');
      }
      static parseTrackName(e) {
        let t = uM.exec(e);
        if (t === null)
          throw new Error('PropertyBinding: Cannot parse trackName: ' + e);
        let i = {
            nodeName: t[2],
            objectName: t[3],
            objectIndex: t[4],
            propertyName: t[5],
            propertyIndex: t[6],
          },
          n = i.nodeName && i.nodeName.lastIndexOf('.');
        if (n !== void 0 && n !== -1) {
          let r = i.nodeName.substring(n + 1);
          dM.indexOf(r) !== -1 &&
            ((i.nodeName = i.nodeName.substring(0, n)), (i.objectName = r));
        }
        if (i.propertyName === null || i.propertyName.length === 0)
          throw new Error(
            'PropertyBinding: can not parse propertyName from trackName: ' + e,
          );
        return i;
      }
      static findNode(e, t) {
        if (
          t === void 0 ||
          t === '' ||
          t === '.' ||
          t === -1 ||
          t === e.name ||
          t === e.uuid
        )
          return e;
        if (e.skeleton) {
          let i = e.skeleton.getBoneByName(t);
          if (i !== void 0) return i;
        }
        if (e.children) {
          let i = function (r) {
              for (let o = 0; o < r.length; o++) {
                let a = r[o];
                if (a.name === t || a.uuid === t) return a;
                let l = i(a.children);
                if (l) return l;
              }
              return null;
            },
            n = i(e.children);
          if (n) return n;
        }
        return null;
      }
      _getValue_unavailable() {}
      _setValue_unavailable() {}
      _getValue_direct(e, t) {
        e[t] = this.targetObject[this.propertyName];
      }
      _getValue_array(e, t) {
        let i = this.resolvedProperty;
        for (let n = 0, r = i.length; n !== r; ++n) e[t++] = i[n];
      }
      _getValue_arrayElement(e, t) {
        e[t] = this.resolvedProperty[this.propertyIndex];
      }
      _getValue_toArray(e, t) {
        this.resolvedProperty.toArray(e, t);
      }
      _setValue_direct(e, t) {
        this.targetObject[this.propertyName] = e[t];
      }
      _setValue_direct_setNeedsUpdate(e, t) {
        ((this.targetObject[this.propertyName] = e[t]),
          (this.targetObject.needsUpdate = !0));
      }
      _setValue_direct_setMatrixWorldNeedsUpdate(e, t) {
        ((this.targetObject[this.propertyName] = e[t]),
          (this.targetObject.matrixWorldNeedsUpdate = !0));
      }
      _setValue_array(e, t) {
        let i = this.resolvedProperty;
        for (let n = 0, r = i.length; n !== r; ++n) i[n] = e[t++];
      }
      _setValue_array_setNeedsUpdate(e, t) {
        let i = this.resolvedProperty;
        for (let n = 0, r = i.length; n !== r; ++n) i[n] = e[t++];
        this.targetObject.needsUpdate = !0;
      }
      _setValue_array_setMatrixWorldNeedsUpdate(e, t) {
        let i = this.resolvedProperty;
        for (let n = 0, r = i.length; n !== r; ++n) i[n] = e[t++];
        this.targetObject.matrixWorldNeedsUpdate = !0;
      }
      _setValue_arrayElement(e, t) {
        this.resolvedProperty[this.propertyIndex] = e[t];
      }
      _setValue_arrayElement_setNeedsUpdate(e, t) {
        ((this.resolvedProperty[this.propertyIndex] = e[t]),
          (this.targetObject.needsUpdate = !0));
      }
      _setValue_arrayElement_setMatrixWorldNeedsUpdate(e, t) {
        ((this.resolvedProperty[this.propertyIndex] = e[t]),
          (this.targetObject.matrixWorldNeedsUpdate = !0));
      }
      _setValue_fromArray(e, t) {
        this.resolvedProperty.fromArray(e, t);
      }
      _setValue_fromArray_setNeedsUpdate(e, t) {
        (this.resolvedProperty.fromArray(e, t),
          (this.targetObject.needsUpdate = !0));
      }
      _setValue_fromArray_setMatrixWorldNeedsUpdate(e, t) {
        (this.resolvedProperty.fromArray(e, t),
          (this.targetObject.matrixWorldNeedsUpdate = !0));
      }
      _getValue_unbound(e, t) {
        (this.bind(), this.getValue(e, t));
      }
      _setValue_unbound(e, t) {
        (this.bind(), this.setValue(e, t));
      }
      bind() {
        let e = this.node,
          t = this.parsedPath,
          i = t.objectName,
          n = t.propertyName,
          r = t.propertyIndex;
        if (
          (e || ((e = s.findNode(this.rootNode, t.nodeName)), (this.node = e)),
          (this.getValue = this._getValue_unavailable),
          (this.setValue = this._setValue_unavailable),
          !e)
        ) {
          it(
            'PropertyBinding: No target node found for track: ' +
              this.path +
              '.',
          );
          return;
        }
        if (i) {
          let c = t.objectIndex;
          switch (i) {
            case 'materials':
              if (!e.material) {
                mt(
                  'PropertyBinding: Can not bind to material as node does not have a material.',
                  this,
                );
                return;
              }
              if (!e.material.materials) {
                mt(
                  'PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.',
                  this,
                );
                return;
              }
              e = e.material.materials;
              break;
            case 'bones':
              if (!e.skeleton) {
                mt(
                  'PropertyBinding: Can not bind to bones as node does not have a skeleton.',
                  this,
                );
                return;
              }
              e = e.skeleton.bones;
              for (let u = 0; u < e.length; u++)
                if (e[u].name === c) {
                  c = u;
                  break;
                }
              break;
            case 'map':
              if ('map' in e) {
                e = e.map;
                break;
              }
              if (!e.material) {
                mt(
                  'PropertyBinding: Can not bind to material as node does not have a material.',
                  this,
                );
                return;
              }
              if (!e.material.map) {
                mt(
                  'PropertyBinding: Can not bind to material.map as node.material does not have a map.',
                  this,
                );
                return;
              }
              e = e.material.map;
              break;
            default:
              if (e[i] === void 0) {
                mt(
                  'PropertyBinding: Can not bind to objectName of node undefined.',
                  this,
                );
                return;
              }
              e = e[i];
          }
          if (c !== void 0) {
            if (e[c] === void 0) {
              mt(
                'PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.',
                this,
                e,
              );
              return;
            }
            e = e[c];
          }
        }
        let o = e[n];
        if (o === void 0) {
          let c = t.nodeName;
          mt(
            'PropertyBinding: Trying to update property for track: ' +
              c +
              '.' +
              n +
              " but it wasn't found.",
            e,
          );
          return;
        }
        let a = this.Versioning.None;
        ((this.targetObject = e),
          e.isMaterial === !0
            ? (a = this.Versioning.NeedsUpdate)
            : e.isObject3D === !0 &&
              (a = this.Versioning.MatrixWorldNeedsUpdate));
        let l = this.BindingType.Direct;
        if (r !== void 0) {
          if (n === 'morphTargetInfluences') {
            if (!e.geometry) {
              mt(
                'PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.',
                this,
              );
              return;
            }
            if (!e.geometry.morphAttributes) {
              mt(
                'PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.',
                this,
              );
              return;
            }
            e.morphTargetDictionary[r] !== void 0 &&
              (r = e.morphTargetDictionary[r]);
          }
          ((l = this.BindingType.ArrayElement),
            (this.resolvedProperty = o),
            (this.propertyIndex = r));
        } else
          o.fromArray !== void 0 && o.toArray !== void 0
            ? ((l = this.BindingType.HasFromToArray),
              (this.resolvedProperty = o))
            : Array.isArray(o)
              ? ((l = this.BindingType.EntireArray),
                (this.resolvedProperty = o))
              : (this.propertyName = n);
        ((this.getValue = this.GetterByBindingType[l]),
          (this.setValue = this.SetterByBindingTypeAndVersioning[l][a]));
      }
      unbind() {
        ((this.node = null),
          (this.getValue = this._getValue_unbound),
          (this.setValue = this._setValue_unbound));
      }
    };
  si.Composite = Ym;
  si.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3,
  };
  si.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2,
  };
  si.prototype.GetterByBindingType = [
    si.prototype._getValue_direct,
    si.prototype._getValue_array,
    si.prototype._getValue_arrayElement,
    si.prototype._getValue_toArray,
  ];
  si.prototype.SetterByBindingTypeAndVersioning = [
    [
      si.prototype._setValue_direct,
      si.prototype._setValue_direct_setNeedsUpdate,
      si.prototype._setValue_direct_setMatrixWorldNeedsUpdate,
    ],
    [
      si.prototype._setValue_array,
      si.prototype._setValue_array_setNeedsUpdate,
      si.prototype._setValue_array_setMatrixWorldNeedsUpdate,
    ],
    [
      si.prototype._setValue_arrayElement,
      si.prototype._setValue_arrayElement_setNeedsUpdate,
      si.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate,
    ],
    [
      si.prototype._setValue_fromArray,
      si.prototype._setValue_fromArray_setNeedsUpdate,
      si.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate,
    ],
  ];
  var qL = new Float32Array(1);
  var Pr = class {
    constructor(e = 1, t = 0, i = 0) {
      ((this.radius = e), (this.phi = t), (this.theta = i));
    }
    set(e, t, i) {
      return ((this.radius = e), (this.phi = t), (this.theta = i), this);
    }
    copy(e) {
      return (
        (this.radius = e.radius),
        (this.phi = e.phi),
        (this.theta = e.theta),
        this
      );
    }
    makeSafe() {
      return ((this.phi = Dt(this.phi, 1e-6, Math.PI - 1e-6)), this);
    }
    setFromVector3(e) {
      return this.setFromCartesianCoords(e.x, e.y, e.z);
    }
    setFromCartesianCoords(e, t, i) {
      return (
        (this.radius = Math.sqrt(e * e + t * t + i * i)),
        this.radius === 0
          ? ((this.theta = 0), (this.phi = 0))
          : ((this.theta = Math.atan2(e, i)),
            (this.phi = Math.acos(Dt(t / this.radius, -1, 1)))),
        this
      );
    }
    clone() {
      return new this.constructor().copy(this);
    }
  };
  var Eg = class Eg {
    constructor(e, t, i, n) {
      ((this.elements = [1, 0, 0, 1]), e !== void 0 && this.set(e, t, i, n));
    }
    identity() {
      return (this.set(1, 0, 0, 1), this);
    }
    fromArray(e, t = 0) {
      for (let i = 0; i < 4; i++) this.elements[i] = e[i + t];
      return this;
    }
    set(e, t, i, n) {
      let r = this.elements;
      return ((r[0] = e), (r[2] = t), (r[1] = i), (r[3] = n), this);
    }
  };
  Eg.prototype.isMatrix2 = !0;
  var qm = Eg;
  var Oc = class extends Es {
    constructor(e, t = null) {
      (super(),
        (this.object = e),
        (this.domElement = t),
        (this.enabled = !0),
        (this.state = -1),
        (this.keys = {}),
        (this.mouseButtons = { LEFT: null, MIDDLE: null, RIGHT: null }),
        (this.touches = { ONE: null, TWO: null }));
    }
    connect(e) {
      if (e === void 0) {
        it('Controls: connect() now requires an element.');
        return;
      }
      (this.domElement !== null && this.disconnect(), (this.domElement = e));
    }
    disconnect() {}
    dispose() {}
    update() {}
  };
  function vg(s, e, t, i) {
    let n = fM(i);
    switch (t) {
      case hg:
        return s * e;
      case nd:
        return ((s * e) / n.components) * n.byteLength;
      case sd:
        return ((s * e) / n.components) * n.byteLength;
      case lo:
        return ((s * e * 2) / n.components) * n.byteLength;
      case rd:
        return ((s * e * 2) / n.components) * n.byteLength;
      case ug:
        return ((s * e * 3) / n.components) * n.byteLength;
      case Yn:
        return ((s * e * 4) / n.components) * n.byteLength;
      case od:
        return ((s * e * 4) / n.components) * n.byteLength;
      case Bc:
      case kc:
        return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 8;
      case Hc:
      case zc:
        return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 16;
      case ld:
      case hd:
        return (Math.max(s, 16) * Math.max(e, 8)) / 4;
      case ad:
      case cd:
        return (Math.max(s, 8) * Math.max(e, 8)) / 2;
      case ud:
      case dd:
      case pd:
      case md:
        return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 8;
      case fd:
      case Vc:
      case gd:
        return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 16;
      case _d:
        return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 16;
      case vd:
        return Math.floor((s + 4) / 5) * Math.floor((e + 3) / 4) * 16;
      case xd:
        return Math.floor((s + 4) / 5) * Math.floor((e + 4) / 5) * 16;
      case yd:
        return Math.floor((s + 5) / 6) * Math.floor((e + 4) / 5) * 16;
      case bd:
        return Math.floor((s + 5) / 6) * Math.floor((e + 5) / 6) * 16;
      case Sd:
        return Math.floor((s + 7) / 8) * Math.floor((e + 4) / 5) * 16;
      case Ed:
        return Math.floor((s + 7) / 8) * Math.floor((e + 5) / 6) * 16;
      case Td:
        return Math.floor((s + 7) / 8) * Math.floor((e + 7) / 8) * 16;
      case Md:
        return Math.floor((s + 9) / 10) * Math.floor((e + 4) / 5) * 16;
      case wd:
        return Math.floor((s + 9) / 10) * Math.floor((e + 5) / 6) * 16;
      case Ad:
        return Math.floor((s + 9) / 10) * Math.floor((e + 7) / 8) * 16;
      case Rd:
        return Math.floor((s + 9) / 10) * Math.floor((e + 9) / 10) * 16;
      case Cd:
        return Math.floor((s + 11) / 12) * Math.floor((e + 9) / 10) * 16;
      case Pd:
        return Math.floor((s + 11) / 12) * Math.floor((e + 11) / 12) * 16;
      case Ld:
      case Id:
      case Dd:
        return Math.ceil(s / 4) * Math.ceil(e / 4) * 16;
      case Od:
      case Nd:
        return Math.ceil(s / 4) * Math.ceil(e / 4) * 8;
      case Gc:
      case Fd:
        return Math.ceil(s / 4) * Math.ceil(e / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${t} format.`);
  }
  function fM(s) {
    switch (s) {
      case Ln:
      case og:
        return { byteLength: 1, components: 1 };
      case sl:
      case ag:
      case er:
        return { byteLength: 2, components: 1 };
      case td:
      case id:
        return { byteLength: 2, components: 4 };
      case Rs:
      case ed:
      case Xn:
        return { byteLength: 4, components: 1 };
      case lg:
      case cg:
        return { byteLength: 4, components: 3 };
    }
    throw new Error(`Unknown texture type ${s}.`);
  }
  typeof __THREE_DEVTOOLS__ != 'undefined' &&
    __THREE_DEVTOOLS__.dispatchEvent(
      new CustomEvent('register', { detail: { revision: '184' } }),
    );
  typeof window != 'undefined' &&
    (window.__THREE__
      ? it('WARNING: Multiple instances of Three.js being imported.')
      : (window.__THREE__ = '184'));
  function Ky() {
    let s = null,
      e = !1,
      t = null,
      i = null;
    function n(r, o) {
      (t(r, o), (i = s.requestAnimationFrame(n)));
    }
    return {
      start: function () {
        e !== !0 &&
          t !== null &&
          s !== null &&
          ((i = s.requestAnimationFrame(n)), (e = !0));
      },
      stop: function () {
        (s !== null && s.cancelAnimationFrame(i), (e = !1));
      },
      setAnimationLoop: function (r) {
        t = r;
      },
      setContext: function (r) {
        s = r;
      },
    };
  }
  function mM(s) {
    let e = new WeakMap();
    function t(a, l) {
      let c = a.array,
        u = a.usage,
        f = c.byteLength,
        d = s.createBuffer();
      (s.bindBuffer(l, d), s.bufferData(l, c, u), a.onUploadCallback());
      let p;
      if (c instanceof Float32Array) p = s.FLOAT;
      else if (typeof Float16Array != 'undefined' && c instanceof Float16Array)
        p = s.HALF_FLOAT;
      else if (c instanceof Uint16Array)
        a.isFloat16BufferAttribute
          ? (p = s.HALF_FLOAT)
          : (p = s.UNSIGNED_SHORT);
      else if (c instanceof Int16Array) p = s.SHORT;
      else if (c instanceof Uint32Array) p = s.UNSIGNED_INT;
      else if (c instanceof Int32Array) p = s.INT;
      else if (c instanceof Int8Array) p = s.BYTE;
      else if (c instanceof Uint8Array) p = s.UNSIGNED_BYTE;
      else if (c instanceof Uint8ClampedArray) p = s.UNSIGNED_BYTE;
      else
        throw new Error(
          'THREE.WebGLAttributes: Unsupported buffer data format: ' + c,
        );
      return {
        buffer: d,
        type: p,
        bytesPerElement: c.BYTES_PER_ELEMENT,
        version: a.version,
        size: f,
      };
    }
    function i(a, l, c) {
      let u = l.array,
        f = l.updateRanges;
      if ((s.bindBuffer(c, a), f.length === 0)) s.bufferSubData(c, 0, u);
      else {
        f.sort((p, _) => p.start - _.start);
        let d = 0;
        for (let p = 1; p < f.length; p++) {
          let _ = f[d],
            x = f[p];
          x.start <= _.start + _.count + 1
            ? (_.count = Math.max(_.count, x.start + x.count - _.start))
            : (++d, (f[d] = x));
        }
        f.length = d + 1;
        for (let p = 0, _ = f.length; p < _; p++) {
          let x = f[p];
          s.bufferSubData(
            c,
            x.start * u.BYTES_PER_ELEMENT,
            u,
            x.start,
            x.count,
          );
        }
        l.clearUpdateRanges();
      }
      l.onUploadCallback();
    }
    function n(a) {
      return (a.isInterleavedBufferAttribute && (a = a.data), e.get(a));
    }
    function r(a) {
      a.isInterleavedBufferAttribute && (a = a.data);
      let l = e.get(a);
      l && (s.deleteBuffer(l.buffer), e.delete(a));
    }
    function o(a, l) {
      if (
        (a.isInterleavedBufferAttribute && (a = a.data), a.isGLBufferAttribute)
      ) {
        let u = e.get(a);
        (!u || u.version < a.version) &&
          e.set(a, {
            buffer: a.buffer,
            type: a.type,
            bytesPerElement: a.elementSize,
            version: a.version,
          });
        return;
      }
      let c = e.get(a);
      if (c === void 0) e.set(a, t(a, l));
      else if (c.version < a.version) {
        if (c.size !== a.array.byteLength)
          throw new Error(
            "THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.",
          );
        (i(c.buffer, a, l), (c.version = a.version));
      }
    }
    return { get: n, remove: r, update: o };
  }
  var gM = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`,
    _M = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`,
    vM = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`,
    xM = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`,
    yM = `#ifdef USE_ALPHATEST
	#ifdef ALPHA_TO_COVERAGE
	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;
	#else
	if ( diffuseColor.a < alphaTest ) discard;
	#endif
#endif`,
    bM = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`,
    SM = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`,
    EM = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`,
    TM = `#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif
	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {
		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
	float getIndirectIndex( const in int i ) {
		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );
	}
#endif
#ifdef USE_BATCHING_COLOR
	uniform sampler2D batchingColorTexture;
	vec4 getBatchingColor( const in float i ) {
		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 );
	}
#endif`,
    MM = `#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif`,
    wM = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`,
    AM = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`,
    RM = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`,
    CM = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`,
    PM = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`,
    LM = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#ifdef ALPHA_TO_COVERAGE
		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			if ( clipOpacity == 0.0 ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			float unionClipOpacity = 1.0;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			}
			#pragma unroll_loop_end
			clipOpacity *= 1.0 - unionClipOpacity;
		#endif
		diffuseColor.a *= clipOpacity;
		if ( diffuseColor.a == 0.0 ) discard;
	#else
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			bool clipped = true;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
			}
			#pragma unroll_loop_end
			if ( clipped ) discard;
		#endif
	#endif
#endif`,
    IM = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`,
    DM = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`,
    OM = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`,
    NM = `#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#endif`,
    FM = `#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#endif`,
    UM = `#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	varying vec4 vColor;
#endif`,
    BM = `#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	vColor = vec4( 1.0 );
#endif
#ifdef USE_COLOR_ALPHA
	vColor *= color;
#elif defined( USE_COLOR )
	vColor.rgb *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.rgb *= instanceColor.rgb;
#endif
#ifdef USE_BATCHING_COLOR
	vColor *= getBatchingColor( getIndirectIndex( gl_DrawID ) );
#endif`,
    kM = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`,
    HM = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`,
    zM = `vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT
	vec3 transformedTangent = objectTangent;
#endif
#ifdef USE_BATCHING
	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = bm * transformedTangent;
	#endif
#endif
#ifdef USE_INSTANCING
	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = im * transformedTangent;
	#endif
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`,
    VM = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`,
    GM = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`,
    WM = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE
		emissiveColor = sRGBTransferEOTF( emissiveColor );
	#endif
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`,
    XM = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`,
    YM = 'gl_FragColor = linearToOutputTexel( gl_FragColor );',
    qM = `vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferEOTF( in vec4 value ) {
	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`,
    ZM = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, envMapRotation * reflectVec );
		#ifdef ENVMAP_BLENDING_MULTIPLY
			outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
		#elif defined( ENVMAP_BLENDING_MIX )
			outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
		#elif defined( ENVMAP_BLENDING_ADD )
			outgoingLight += envColor.xyz * specularStrength * reflectivity;
		#endif
	#endif
#endif`,
    KM = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform mat3 envMapRotation;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
#endif`,
    $M = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`,
    jM = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`,
    JM = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`,
    QM = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`,
    ew = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`,
    tw = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`,
    iw = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`,
    nw = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`,
    sw = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`,
    rw = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`,
    ow = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`,
    aw = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
	if ( cutoffDistance > 0.0 ) {
		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
	}
	return distanceFalloff;
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif
#include <lightprobes_pars_fragment>`,
    lw = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`,
    cw = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`,
    hw = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`,
    uw = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`,
    dw = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`,
    fw = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );
material.metalness = metalnessFactor;
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;
	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = vec3( 0.04 );
	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_DISPERSION
	material.dispersion = dispersion;
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;
#endif`,
    pw = `uniform sampler2D dfgLUT;
struct PhysicalMaterial {
	vec3 diffuseColor;
	vec3 diffuseContribution;
	vec3 specularColor;
	vec3 specularColorBlended;
	float roughness;
	float metalness;
	float specularF90;
	float dispersion;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
		vec3 iridescenceFresnelDielectric;
		vec3 iridescenceFresnelMetallic;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		return 0.5 / max( gv + gl, EPSILON );
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColorBlended;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transpose( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float rInv = 1.0 / ( roughness + 0.1 );
	float a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;
	float b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;
	float DG = exp( a * dotNV + b );
	return saturate( DG );
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
vec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 dfgV = texture2D( dfgLUT, vec2( material.roughness, dotNV ) ).rg;
	vec2 dfgL = texture2D( dfgLUT, vec2( material.roughness, dotNL ) ).rg;
	vec3 FssEss_V = material.specularColorBlended * dfgV.x + material.specularF90 * dfgV.y;
	vec3 FssEss_L = material.specularColorBlended * dfgL.x + material.specularF90 * dfgL.y;
	float Ess_V = dfgV.x + dfgV.y;
	float Ess_L = dfgL.x + dfgL.y;
	float Ems_V = 1.0 - Ess_V;
	float Ems_L = 1.0 - Ess_L;
	vec3 Favg = material.specularColorBlended + ( 1.0 - material.specularColorBlended ) * 0.047619;
	vec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg + EPSILON );
	float compensationFactor = Ems_V * Ems_L;
	vec3 multiScatter = Fms * compensationFactor;
	return singleScatter + multiScatter;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColorBlended * t2.x + ( material.specularF90 - material.specularColorBlended ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
		#ifdef USE_CLEARCOAT
			vec3 Ncc = geometryClearcoatNormal;
			vec2 uvClearcoat = LTC_Uv( Ncc, viewDir, material.clearcoatRoughness );
			vec4 t1Clearcoat = texture2D( ltc_1, uvClearcoat );
			vec4 t2Clearcoat = texture2D( ltc_2, uvClearcoat );
			mat3 mInvClearcoat = mat3(
				vec3( t1Clearcoat.x, 0, t1Clearcoat.y ),
				vec3(             0, 1,             0 ),
				vec3( t1Clearcoat.z, 0, t1Clearcoat.w )
			);
			vec3 fresnelClearcoat = material.clearcoatF0 * t2Clearcoat.x + ( material.clearcoatF90 - material.clearcoatF0 ) * t2Clearcoat.y;
			clearcoatSpecularDirect += lightColor * fresnelClearcoat * LTC_Evaluate( Ncc, viewDir, position, mInvClearcoat, rectCoords );
		#endif
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
 
 		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
 
 		float sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
 		float sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );
 
 		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );
 
 		irradiance *= sheenEnergyComp;
 
 	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution );
	#ifdef USE_SHEEN
		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;
		diffuse *= sheenEnergyComp;
	#endif
	reflectedLight.indirectDiffuse += diffuse;
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;
 	#endif
	vec3 singleScatteringDielectric = vec3( 0.0 );
	vec3 multiScatteringDielectric = vec3( 0.0 );
	vec3 singleScatteringMetallic = vec3( 0.0 );
	vec3 multiScatteringMetallic = vec3( 0.0 );
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnelDielectric, material.roughness, singleScatteringDielectric, multiScatteringDielectric );
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceFresnelMetallic, material.roughness, singleScatteringMetallic, multiScatteringMetallic );
	#else
		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScatteringDielectric, multiScatteringDielectric );
		computeMultiscattering( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.roughness, singleScatteringMetallic, multiScatteringMetallic );
	#endif
	vec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );
	vec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );
	vec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;
	vec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	vec3 indirectSpecular = radiance * singleScattering;
	indirectSpecular += multiScattering * cosineWeightedIrradiance;
	vec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;
	#ifdef USE_SHEEN
		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;
		indirectSpecular *= sheenEnergyComp;
		indirectDiffuse *= sheenEnergyComp;
	#endif
	reflectedLight.indirectSpecular += indirectSpecular;
	reflectedLight.indirectDiffuse += indirectDiffuse;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`,
    mw = `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );
		material.iridescenceFresnel = mix( material.iridescenceFresnelDielectric, material.iridescenceFresnelMetallic, material.metalness );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
	#ifdef USE_LIGHT_PROBES_GRID
		vec3 probeWorldPos = ( ( vec4( geometryPosition, 1.0 ) - viewMatrix[ 3 ] ) * viewMatrix ).xyz;
		vec3 probeWorldNormal = inverseTransformDirection( geometryNormal, viewMatrix );
		irradiance += getLightProbeGridIrradiance( probeWorldPos, probeWorldNormal );
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`,
    gw = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( ENVMAP_TYPE_CUBE_UV )
		#if defined( STANDARD ) || defined( LAMBERT ) || defined( PHONG )
			iblIrradiance += getIBLIrradiance( geometryNormal );
		#endif
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`,
    _w = `#if defined( RE_IndirectDiffuse )
	#if defined( LAMBERT ) || defined( PHONG )
		irradiance += iblIrradiance;
	#endif
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`,
    vw = `#ifdef USE_LIGHT_PROBES_GRID
uniform highp sampler3D probesSH;
uniform vec3 probesMin;
uniform vec3 probesMax;
uniform vec3 probesResolution;
vec3 getLightProbeGridIrradiance( vec3 worldPos, vec3 worldNormal ) {
	vec3 res = probesResolution;
	vec3 gridRange = probesMax - probesMin;
	vec3 resMinusOne = res - 1.0;
	vec3 probeSpacing = gridRange / resMinusOne;
	vec3 samplePos = worldPos + worldNormal * probeSpacing * 0.5;
	vec3 uvw = clamp( ( samplePos - probesMin ) / gridRange, 0.0, 1.0 );
	uvw = uvw * resMinusOne / res + 0.5 / res;
	float nz          = res.z;
	float paddedSlices = nz + 2.0;
	float atlasDepth  = 7.0 * paddedSlices;
	float uvZBase     = uvw.z * nz + 1.0;
	vec4 s0 = texture( probesSH, vec3( uvw.xy, ( uvZBase                       ) / atlasDepth ) );
	vec4 s1 = texture( probesSH, vec3( uvw.xy, ( uvZBase +       paddedSlices   ) / atlasDepth ) );
	vec4 s2 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 2.0 * paddedSlices   ) / atlasDepth ) );
	vec4 s3 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 3.0 * paddedSlices   ) / atlasDepth ) );
	vec4 s4 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 4.0 * paddedSlices   ) / atlasDepth ) );
	vec4 s5 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 5.0 * paddedSlices   ) / atlasDepth ) );
	vec4 s6 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 6.0 * paddedSlices   ) / atlasDepth ) );
	vec3 c0 = s0.xyz;
	vec3 c1 = vec3( s0.w, s1.xy );
	vec3 c2 = vec3( s1.zw, s2.x );
	vec3 c3 = s2.yzw;
	vec3 c4 = s3.xyz;
	vec3 c5 = vec3( s3.w, s4.xy );
	vec3 c6 = vec3( s4.zw, s5.x );
	vec3 c7 = s5.yzw;
	vec3 c8 = s6.xyz;
	float x = worldNormal.x, y = worldNormal.y, z = worldNormal.z;
	vec3 result = c0 * 0.886227;
	result += c1 * 2.0 * 0.511664 * y;
	result += c2 * 2.0 * 0.511664 * z;
	result += c3 * 2.0 * 0.511664 * x;
	result += c4 * 2.0 * 0.429043 * x * y;
	result += c5 * 2.0 * 0.429043 * y * z;
	result += c6 * ( 0.743125 * z * z - 0.247708 );
	result += c7 * 2.0 * 0.429043 * x * z;
	result += c8 * 0.429043 * ( x * x - y * y );
	return max( result, vec3( 0.0 ) );
}
#endif`,
    xw = `#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`,
    yw = `#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`,
    bw = `#ifdef USE_LOGARITHMIC_DEPTH_BUFFER
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`,
    Sw = `#ifdef USE_LOGARITHMIC_DEPTH_BUFFER
	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
#endif`,
    Ew = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`,
    Tw = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`,
    Mw = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`,
    ww = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`,
    Aw = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`,
    Rw = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`,
    Cw = `#ifdef USE_INSTANCING_MORPH
	float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;
	}
#endif`,
    Pw = `#if defined( USE_MORPHCOLORS )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`,
    Lw = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
	}
#endif`,
    Iw = `#ifdef USE_MORPHTARGETS
	#ifndef USE_INSTANCING_MORPH
		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	#endif
	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;
	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;
		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );
	}
#endif`,
    Dw = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
	}
#endif`,
    Ow = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`,
    Nw = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#if defined( USE_PACKED_NORMALMAP )
		mapN = vec3( mapN.xy, sqrt( saturate( 1.0 - dot( mapN.xy, mapN.xy ) ) ) );
	#endif
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`,
    Fw = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`,
    Uw = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`,
    Bw = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`,
    kw = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`,
    Hw = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`,
    zw = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`,
    Vw = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`,
    Gw = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`,
    Ww = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`,
    Xw = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;
const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );
const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );
vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}
vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}
vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}
float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}
float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}
vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	#ifdef USE_REVERSED_DEPTH_BUFFER
	
		return depth * ( far - near ) - far;
	#else
		return depth * ( near - far ) - near;
	#endif
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	
	#ifdef USE_REVERSED_DEPTH_BUFFER
		return ( near * far ) / ( ( near - far ) * depth - near );
	#else
		return ( near * far ) / ( ( far - near ) * depth - far );
	#endif
}`,
    Yw = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`,
    qw = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_BATCHING
	mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`,
    Zw = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`,
    Kw = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`,
    $w = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`,
    jw = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`,
    Jw = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		#else
			uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		#endif
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		#else
			uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		#endif
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		#elif defined( SHADOWMAP_TYPE_BASIC )
			uniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		#endif
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	#if defined( SHADOWMAP_TYPE_PCF )
		float interleavedGradientNoise( vec2 position ) {
			return fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );
		}
		vec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {
			const float goldenAngle = 2.399963229728653;
			float r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );
			float theta = float( sampleIndex ) * goldenAngle + phi;
			return vec2( cos( theta ), sin( theta ) ) * r;
		}
	#endif
	#if defined( SHADOWMAP_TYPE_PCF )
		float getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			shadowCoord.z += shadowBias;
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
				float radius = shadowRadius * texelSize.x;
				float phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;
				shadow = (
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )
				) * 0.2;
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#elif defined( SHADOWMAP_TYPE_VSM )
		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			#ifdef USE_REVERSED_DEPTH_BUFFER
				shadowCoord.z -= shadowBias;
			#else
				shadowCoord.z += shadowBias;
			#endif
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				vec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;
				float mean = distribution.x;
				float variance = distribution.y * distribution.y;
				#ifdef USE_REVERSED_DEPTH_BUFFER
					float hard_shadow = step( mean, shadowCoord.z );
				#else
					float hard_shadow = step( shadowCoord.z, mean );
				#endif
				
				if ( hard_shadow == 1.0 ) {
					shadow = 1.0;
				} else {
					variance = max( variance, 0.0000001 );
					float d = shadowCoord.z - mean;
					float p_max = variance / ( variance + d * d );
					p_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );
					shadow = max( hard_shadow, p_max );
				}
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#else
		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			#ifdef USE_REVERSED_DEPTH_BUFFER
				shadowCoord.z -= shadowBias;
			#else
				shadowCoord.z += shadowBias;
			#endif
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				float depth = texture2D( shadowMap, shadowCoord.xy ).r;
				#ifdef USE_REVERSED_DEPTH_BUFFER
					shadow = step( depth, shadowCoord.z );
				#else
					shadow = step( shadowCoord.z, depth );
				#endif
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	#if defined( SHADOWMAP_TYPE_PCF )
	float getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		vec3 bd3D = normalize( lightToPosition );
		vec3 absVec = abs( lightToPosition );
		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );
		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {
			#ifdef USE_REVERSED_DEPTH_BUFFER
				float dp = ( shadowCameraNear * ( shadowCameraFar - viewSpaceZ ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );
				dp -= shadowBias;
			#else
				float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );
				dp += shadowBias;
			#endif
			float texelSize = shadowRadius / shadowMapSize.x;
			vec3 absDir = abs( bd3D );
			vec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );
			tangent = normalize( cross( bd3D, tangent ) );
			vec3 bitangent = cross( bd3D, tangent );
			float phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;
			vec2 sample0 = vogelDiskSample( 0, 5, phi );
			vec2 sample1 = vogelDiskSample( 1, 5, phi );
			vec2 sample2 = vogelDiskSample( 2, 5, phi );
			vec2 sample3 = vogelDiskSample( 3, 5, phi );
			vec2 sample4 = vogelDiskSample( 4, 5, phi );
			shadow = (
				texture( shadowMap, vec4( bd3D + ( tangent * sample0.x + bitangent * sample0.y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * sample1.x + bitangent * sample1.y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * sample2.x + bitangent * sample2.y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * sample3.x + bitangent * sample3.y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * sample4.x + bitangent * sample4.y ) * texelSize, dp ) )
			) * 0.2;
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	#elif defined( SHADOWMAP_TYPE_BASIC )
	float getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		vec3 absVec = abs( lightToPosition );
		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );
		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {
			float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );
			dp += shadowBias;
			vec3 bd3D = normalize( lightToPosition );
			float depth = textureCube( shadowMap, bd3D ).r;
			#ifdef USE_REVERSED_DEPTH_BUFFER
				depth = 1.0 - depth;
			#endif
			shadow = step( dp, depth );
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	#endif
	#endif
#endif`,
    Qw = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`,
    eA = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	#ifdef HAS_NORMAL
		vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	#else
		vec3 shadowWorldNormal = vec3( 0.0 );
	#endif
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`,
    tA = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`,
    iA = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`,
    nA = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	mat4 getBoneMatrix( const in float i ) {
		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
#endif`,
    sA = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`,
    rA = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`,
    oA = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`,
    aA = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`,
    lA = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`,
    cA = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 CineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);
const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);
vec3 agxDefaultContrastApprox( vec3 x ) {
	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;
	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;
}
vec3 AgXToneMapping( vec3 color ) {
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);
	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;
	color *= toneMappingExposure;
	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;
	color = AgXInsetMatrix * color;
	color = max( color, 1e-10 );	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );
	color = clamp( color, 0.0, 1.0 );
	color = agxDefaultContrastApprox( color );
	color = AgXOutsetMatrix * color;
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );
	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;
	color = clamp( color, 0.0, 1.0 );
	return color;
}
vec3 NeutralToneMapping( vec3 color ) {
	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;
	color *= toneMappingExposure;
	float x = min( color.r, min( color.g, color.b ) );
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max( color.r, max( color.g, color.b ) );
	if ( peak < StartCompression ) return color;
	float d = 1. - StartCompression;
	float newPeak = 1. - d * d / ( peak + d - StartCompression );
	color *= newPeak / peak;
	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
	return mix( color, vec3( newPeak ), g );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`,
    hA = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`,
    uA = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec4 transmittedLight;
		vec3 transmittance;
		#ifdef USE_DISPERSION
			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );
			for ( int i = 0; i < 3; i ++ ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;
				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];
			}
			transmittedLight.a /= 3.0;
		#else
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		#endif
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`,
    dA = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`,
    fA = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`,
    pA = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`,
    mA = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_BATCHING
		worldPosition = batchingMatrix * worldPosition;
	#endif
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`,
    gA = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`,
    _A = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
    vA = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`,
    xA = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, backgroundRotation * vWorldDirection );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
    yA = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`,
    bA = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
    SA = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`,
    EA = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	#ifdef USE_REVERSED_DEPTH_BUFFER
		float fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];
	#else
		float fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;
	#endif
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#elif DEPTH_PACKING == 3202
		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );
	#elif DEPTH_PACKING == 3203
		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );
	#endif
}`,
    TA = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`,
    MA = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );
}`,
    wA = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`,
    AA = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
    RA = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`,
    CA = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
    PA = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`,
    LA = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
    IA = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
    DA = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
    OA = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`,
    NA = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
    FA = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`,
    UA = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`,
    BA = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
    kA = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
    HA = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`,
    zA = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_DISPERSION
	uniform float dispersion;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
 
		outgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;
 
 	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
    VA = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
    GA = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
    WA = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`,
    XA = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
    YA = `#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
    qA = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
    ZA = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix[ 3 ];
	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`,
    KA = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`,
    Pt = {
      alphahash_fragment: gM,
      alphahash_pars_fragment: _M,
      alphamap_fragment: vM,
      alphamap_pars_fragment: xM,
      alphatest_fragment: yM,
      alphatest_pars_fragment: bM,
      aomap_fragment: SM,
      aomap_pars_fragment: EM,
      batching_pars_vertex: TM,
      batching_vertex: MM,
      begin_vertex: wM,
      beginnormal_vertex: AM,
      bsdfs: RM,
      iridescence_fragment: CM,
      bumpmap_pars_fragment: PM,
      clipping_planes_fragment: LM,
      clipping_planes_pars_fragment: IM,
      clipping_planes_pars_vertex: DM,
      clipping_planes_vertex: OM,
      color_fragment: NM,
      color_pars_fragment: FM,
      color_pars_vertex: UM,
      color_vertex: BM,
      common: kM,
      cube_uv_reflection_fragment: HM,
      defaultnormal_vertex: zM,
      displacementmap_pars_vertex: VM,
      displacementmap_vertex: GM,
      emissivemap_fragment: WM,
      emissivemap_pars_fragment: XM,
      colorspace_fragment: YM,
      colorspace_pars_fragment: qM,
      envmap_fragment: ZM,
      envmap_common_pars_fragment: KM,
      envmap_pars_fragment: $M,
      envmap_pars_vertex: jM,
      envmap_physical_pars_fragment: lw,
      envmap_vertex: JM,
      fog_vertex: QM,
      fog_pars_vertex: ew,
      fog_fragment: tw,
      fog_pars_fragment: iw,
      gradientmap_pars_fragment: nw,
      lightmap_pars_fragment: sw,
      lights_lambert_fragment: rw,
      lights_lambert_pars_fragment: ow,
      lights_pars_begin: aw,
      lights_toon_fragment: cw,
      lights_toon_pars_fragment: hw,
      lights_phong_fragment: uw,
      lights_phong_pars_fragment: dw,
      lights_physical_fragment: fw,
      lights_physical_pars_fragment: pw,
      lights_fragment_begin: mw,
      lights_fragment_maps: gw,
      lights_fragment_end: _w,
      lightprobes_pars_fragment: vw,
      logdepthbuf_fragment: xw,
      logdepthbuf_pars_fragment: yw,
      logdepthbuf_pars_vertex: bw,
      logdepthbuf_vertex: Sw,
      map_fragment: Ew,
      map_pars_fragment: Tw,
      map_particle_fragment: Mw,
      map_particle_pars_fragment: ww,
      metalnessmap_fragment: Aw,
      metalnessmap_pars_fragment: Rw,
      morphinstance_vertex: Cw,
      morphcolor_vertex: Pw,
      morphnormal_vertex: Lw,
      morphtarget_pars_vertex: Iw,
      morphtarget_vertex: Dw,
      normal_fragment_begin: Ow,
      normal_fragment_maps: Nw,
      normal_pars_fragment: Fw,
      normal_pars_vertex: Uw,
      normal_vertex: Bw,
      normalmap_pars_fragment: kw,
      clearcoat_normal_fragment_begin: Hw,
      clearcoat_normal_fragment_maps: zw,
      clearcoat_pars_fragment: Vw,
      iridescence_pars_fragment: Gw,
      opaque_fragment: Ww,
      packing: Xw,
      premultiplied_alpha_fragment: Yw,
      project_vertex: qw,
      dithering_fragment: Zw,
      dithering_pars_fragment: Kw,
      roughnessmap_fragment: $w,
      roughnessmap_pars_fragment: jw,
      shadowmap_pars_fragment: Jw,
      shadowmap_pars_vertex: Qw,
      shadowmap_vertex: eA,
      shadowmask_pars_fragment: tA,
      skinbase_vertex: iA,
      skinning_pars_vertex: nA,
      skinning_vertex: sA,
      skinnormal_vertex: rA,
      specularmap_fragment: oA,
      specularmap_pars_fragment: aA,
      tonemapping_fragment: lA,
      tonemapping_pars_fragment: cA,
      transmission_fragment: hA,
      transmission_pars_fragment: uA,
      uv_pars_fragment: dA,
      uv_pars_vertex: fA,
      uv_vertex: pA,
      worldpos_vertex: mA,
      background_vert: gA,
      background_frag: _A,
      backgroundCube_vert: vA,
      backgroundCube_frag: xA,
      cube_vert: yA,
      cube_frag: bA,
      depth_vert: SA,
      depth_frag: EA,
      distance_vert: TA,
      distance_frag: MA,
      equirect_vert: wA,
      equirect_frag: AA,
      linedashed_vert: RA,
      linedashed_frag: CA,
      meshbasic_vert: PA,
      meshbasic_frag: LA,
      meshlambert_vert: IA,
      meshlambert_frag: DA,
      meshmatcap_vert: OA,
      meshmatcap_frag: NA,
      meshnormal_vert: FA,
      meshnormal_frag: UA,
      meshphong_vert: BA,
      meshphong_frag: kA,
      meshphysical_vert: HA,
      meshphysical_frag: zA,
      meshtoon_vert: VA,
      meshtoon_frag: GA,
      points_vert: WA,
      points_frag: XA,
      shadow_vert: YA,
      shadow_frag: qA,
      sprite_vert: ZA,
      sprite_frag: KA,
    },
    We = {
      common: {
        diffuse: { value: new je(16777215) },
        opacity: { value: 1 },
        map: { value: null },
        mapTransform: { value: new St() },
        alphaMap: { value: null },
        alphaMapTransform: { value: new St() },
        alphaTest: { value: 0 },
      },
      specularmap: {
        specularMap: { value: null },
        specularMapTransform: { value: new St() },
      },
      envmap: {
        envMap: { value: null },
        envMapRotation: { value: new St() },
        reflectivity: { value: 1 },
        ior: { value: 1.5 },
        refractionRatio: { value: 0.98 },
        dfgLUT: { value: null },
      },
      aomap: {
        aoMap: { value: null },
        aoMapIntensity: { value: 1 },
        aoMapTransform: { value: new St() },
      },
      lightmap: {
        lightMap: { value: null },
        lightMapIntensity: { value: 1 },
        lightMapTransform: { value: new St() },
      },
      bumpmap: {
        bumpMap: { value: null },
        bumpMapTransform: { value: new St() },
        bumpScale: { value: 1 },
      },
      normalmap: {
        normalMap: { value: null },
        normalMapTransform: { value: new St() },
        normalScale: { value: new et(1, 1) },
      },
      displacementmap: {
        displacementMap: { value: null },
        displacementMapTransform: { value: new St() },
        displacementScale: { value: 1 },
        displacementBias: { value: 0 },
      },
      emissivemap: {
        emissiveMap: { value: null },
        emissiveMapTransform: { value: new St() },
      },
      metalnessmap: {
        metalnessMap: { value: null },
        metalnessMapTransform: { value: new St() },
      },
      roughnessmap: {
        roughnessMap: { value: null },
        roughnessMapTransform: { value: new St() },
      },
      gradientmap: { gradientMap: { value: null } },
      fog: {
        fogDensity: { value: 25e-5 },
        fogNear: { value: 1 },
        fogFar: { value: 2e3 },
        fogColor: { value: new je(16777215) },
      },
      lights: {
        ambientLightColor: { value: [] },
        lightProbe: { value: [] },
        directionalLights: {
          value: [],
          properties: { direction: {}, color: {} },
        },
        directionalLightShadows: {
          value: [],
          properties: {
            shadowIntensity: 1,
            shadowBias: {},
            shadowNormalBias: {},
            shadowRadius: {},
            shadowMapSize: {},
          },
        },
        directionalShadowMatrix: { value: [] },
        spotLights: {
          value: [],
          properties: {
            color: {},
            position: {},
            direction: {},
            distance: {},
            coneCos: {},
            penumbraCos: {},
            decay: {},
          },
        },
        spotLightShadows: {
          value: [],
          properties: {
            shadowIntensity: 1,
            shadowBias: {},
            shadowNormalBias: {},
            shadowRadius: {},
            shadowMapSize: {},
          },
        },
        spotLightMap: { value: [] },
        spotLightMatrix: { value: [] },
        pointLights: {
          value: [],
          properties: { color: {}, position: {}, decay: {}, distance: {} },
        },
        pointLightShadows: {
          value: [],
          properties: {
            shadowIntensity: 1,
            shadowBias: {},
            shadowNormalBias: {},
            shadowRadius: {},
            shadowMapSize: {},
            shadowCameraNear: {},
            shadowCameraFar: {},
          },
        },
        pointShadowMatrix: { value: [] },
        hemisphereLights: {
          value: [],
          properties: { direction: {}, skyColor: {}, groundColor: {} },
        },
        rectAreaLights: {
          value: [],
          properties: { color: {}, position: {}, width: {}, height: {} },
        },
        ltc_1: { value: null },
        ltc_2: { value: null },
        probesSH: { value: null },
        probesMin: { value: new te() },
        probesMax: { value: new te() },
        probesResolution: { value: new te() },
      },
      points: {
        diffuse: { value: new je(16777215) },
        opacity: { value: 1 },
        size: { value: 1 },
        scale: { value: 1 },
        map: { value: null },
        alphaMap: { value: null },
        alphaMapTransform: { value: new St() },
        alphaTest: { value: 0 },
        uvTransform: { value: new St() },
      },
      sprite: {
        diffuse: { value: new je(16777215) },
        opacity: { value: 1 },
        center: { value: new et(0.5, 0.5) },
        rotation: { value: 0 },
        map: { value: null },
        mapTransform: { value: new St() },
        alphaMap: { value: null },
        alphaMapTransform: { value: new St() },
        alphaTest: { value: 0 },
      },
    },
    ir = {
      basic: {
        uniforms: on([
          We.common,
          We.specularmap,
          We.envmap,
          We.aomap,
          We.lightmap,
          We.fog,
        ]),
        vertexShader: Pt.meshbasic_vert,
        fragmentShader: Pt.meshbasic_frag,
      },
      lambert: {
        uniforms: on([
          We.common,
          We.specularmap,
          We.envmap,
          We.aomap,
          We.lightmap,
          We.emissivemap,
          We.bumpmap,
          We.normalmap,
          We.displacementmap,
          We.fog,
          We.lights,
          { emissive: { value: new je(0) }, envMapIntensity: { value: 1 } },
        ]),
        vertexShader: Pt.meshlambert_vert,
        fragmentShader: Pt.meshlambert_frag,
      },
      phong: {
        uniforms: on([
          We.common,
          We.specularmap,
          We.envmap,
          We.aomap,
          We.lightmap,
          We.emissivemap,
          We.bumpmap,
          We.normalmap,
          We.displacementmap,
          We.fog,
          We.lights,
          {
            emissive: { value: new je(0) },
            specular: { value: new je(1118481) },
            shininess: { value: 30 },
            envMapIntensity: { value: 1 },
          },
        ]),
        vertexShader: Pt.meshphong_vert,
        fragmentShader: Pt.meshphong_frag,
      },
      standard: {
        uniforms: on([
          We.common,
          We.envmap,
          We.aomap,
          We.lightmap,
          We.emissivemap,
          We.bumpmap,
          We.normalmap,
          We.displacementmap,
          We.roughnessmap,
          We.metalnessmap,
          We.fog,
          We.lights,
          {
            emissive: { value: new je(0) },
            roughness: { value: 1 },
            metalness: { value: 0 },
            envMapIntensity: { value: 1 },
          },
        ]),
        vertexShader: Pt.meshphysical_vert,
        fragmentShader: Pt.meshphysical_frag,
      },
      toon: {
        uniforms: on([
          We.common,
          We.aomap,
          We.lightmap,
          We.emissivemap,
          We.bumpmap,
          We.normalmap,
          We.displacementmap,
          We.gradientmap,
          We.fog,
          We.lights,
          { emissive: { value: new je(0) } },
        ]),
        vertexShader: Pt.meshtoon_vert,
        fragmentShader: Pt.meshtoon_frag,
      },
      matcap: {
        uniforms: on([
          We.common,
          We.bumpmap,
          We.normalmap,
          We.displacementmap,
          We.fog,
          { matcap: { value: null } },
        ]),
        vertexShader: Pt.meshmatcap_vert,
        fragmentShader: Pt.meshmatcap_frag,
      },
      points: {
        uniforms: on([We.points, We.fog]),
        vertexShader: Pt.points_vert,
        fragmentShader: Pt.points_frag,
      },
      dashed: {
        uniforms: on([
          We.common,
          We.fog,
          {
            scale: { value: 1 },
            dashSize: { value: 1 },
            totalSize: { value: 2 },
          },
        ]),
        vertexShader: Pt.linedashed_vert,
        fragmentShader: Pt.linedashed_frag,
      },
      depth: {
        uniforms: on([We.common, We.displacementmap]),
        vertexShader: Pt.depth_vert,
        fragmentShader: Pt.depth_frag,
      },
      normal: {
        uniforms: on([
          We.common,
          We.bumpmap,
          We.normalmap,
          We.displacementmap,
          { opacity: { value: 1 } },
        ]),
        vertexShader: Pt.meshnormal_vert,
        fragmentShader: Pt.meshnormal_frag,
      },
      sprite: {
        uniforms: on([We.sprite, We.fog]),
        vertexShader: Pt.sprite_vert,
        fragmentShader: Pt.sprite_frag,
      },
      background: {
        uniforms: {
          uvTransform: { value: new St() },
          t2D: { value: null },
          backgroundIntensity: { value: 1 },
        },
        vertexShader: Pt.background_vert,
        fragmentShader: Pt.background_frag,
      },
      backgroundCube: {
        uniforms: {
          envMap: { value: null },
          backgroundBlurriness: { value: 0 },
          backgroundIntensity: { value: 1 },
          backgroundRotation: { value: new St() },
        },
        vertexShader: Pt.backgroundCube_vert,
        fragmentShader: Pt.backgroundCube_frag,
      },
      cube: {
        uniforms: {
          tCube: { value: null },
          tFlip: { value: -1 },
          opacity: { value: 1 },
        },
        vertexShader: Pt.cube_vert,
        fragmentShader: Pt.cube_frag,
      },
      equirect: {
        uniforms: { tEquirect: { value: null } },
        vertexShader: Pt.equirect_vert,
        fragmentShader: Pt.equirect_frag,
      },
      distance: {
        uniforms: on([
          We.common,
          We.displacementmap,
          {
            referencePosition: { value: new te() },
            nearDistance: { value: 1 },
            farDistance: { value: 1e3 },
          },
        ]),
        vertexShader: Pt.distance_vert,
        fragmentShader: Pt.distance_frag,
      },
      shadow: {
        uniforms: on([
          We.lights,
          We.fog,
          { color: { value: new je(0) }, opacity: { value: 1 } },
        ]),
        vertexShader: Pt.shadow_vert,
        fragmentShader: Pt.shadow_frag,
      },
    };
  ir.physical = {
    uniforms: on([
      ir.standard.uniforms,
      {
        clearcoat: { value: 0 },
        clearcoatMap: { value: null },
        clearcoatMapTransform: { value: new St() },
        clearcoatNormalMap: { value: null },
        clearcoatNormalMapTransform: { value: new St() },
        clearcoatNormalScale: { value: new et(1, 1) },
        clearcoatRoughness: { value: 0 },
        clearcoatRoughnessMap: { value: null },
        clearcoatRoughnessMapTransform: { value: new St() },
        dispersion: { value: 0 },
        iridescence: { value: 0 },
        iridescenceMap: { value: null },
        iridescenceMapTransform: { value: new St() },
        iridescenceIOR: { value: 1.3 },
        iridescenceThicknessMinimum: { value: 100 },
        iridescenceThicknessMaximum: { value: 400 },
        iridescenceThicknessMap: { value: null },
        iridescenceThicknessMapTransform: { value: new St() },
        sheen: { value: 0 },
        sheenColor: { value: new je(0) },
        sheenColorMap: { value: null },
        sheenColorMapTransform: { value: new St() },
        sheenRoughness: { value: 1 },
        sheenRoughnessMap: { value: null },
        sheenRoughnessMapTransform: { value: new St() },
        transmission: { value: 0 },
        transmissionMap: { value: null },
        transmissionMapTransform: { value: new St() },
        transmissionSamplerSize: { value: new et() },
        transmissionSamplerMap: { value: null },
        thickness: { value: 0 },
        thicknessMap: { value: null },
        thicknessMapTransform: { value: new St() },
        attenuationDistance: { value: 0 },
        attenuationColor: { value: new je(0) },
        specularColor: { value: new je(1, 1, 1) },
        specularColorMap: { value: null },
        specularColorMapTransform: { value: new St() },
        specularIntensity: { value: 1 },
        specularIntensityMap: { value: null },
        specularIntensityMapTransform: { value: new St() },
        anisotropyVector: { value: new et() },
        anisotropyMap: { value: null },
        anisotropyMapTransform: { value: new St() },
      },
    ]),
    vertexShader: Pt.meshphysical_vert,
    fragmentShader: Pt.meshphysical_frag,
  };
  var Hd = { r: 0, b: 0, g: 0 },
    $A = new yt(),
    $y = new St();
  $y.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
  function jA(s, e, t, i, n, r) {
    let o = new je(0),
      a = n === !0 ? 0 : 1,
      l,
      c,
      u = null,
      f = 0,
      d = null;
    function p(w) {
      let L = w.isScene === !0 ? w.background : null;
      if (L && L.isTexture) {
        let R = w.backgroundBlurriness > 0;
        L = e.get(L, R);
      }
      return L;
    }
    function _(w) {
      let L = !1,
        R = p(w);
      R === null ? g(o, a) : R && R.isColor && (g(R, 1), (L = !0));
      let U = s.xr.getEnvironmentBlendMode();
      (U === 'additive'
        ? t.buffers.color.setClear(0, 0, 0, 1, r)
        : U === 'alpha-blend' && t.buffers.color.setClear(0, 0, 0, 0, r),
        (s.autoClear || L) &&
          (t.buffers.depth.setTest(!0),
          t.buffers.depth.setMask(!0),
          t.buffers.color.setMask(!0),
          s.clear(s.autoClearColor, s.autoClearDepth, s.autoClearStencil)));
    }
    function x(w, L) {
      let R = p(L);
      R && (R.isCubeTexture || R.mapping === Uc)
        ? (c === void 0 &&
            ((c = new ri(
              new Qa(1, 1, 1),
              new vi({
                name: 'BackgroundCubeMaterial',
                uniforms: ea(ir.backgroundCube.uniforms),
                vertexShader: ir.backgroundCube.vertexShader,
                fragmentShader: ir.backgroundCube.fragmentShader,
                side: bn,
                depthTest: !1,
                depthWrite: !1,
                fog: !1,
                allowOverride: !1,
              }),
            )),
            c.geometry.deleteAttribute('normal'),
            c.geometry.deleteAttribute('uv'),
            (c.onBeforeRender = function (U, O, N) {
              this.matrixWorld.copyPosition(N.matrixWorld);
            }),
            Object.defineProperty(c.material, 'envMap', {
              get: function () {
                return this.uniforms.envMap.value;
              },
            }),
            i.update(c)),
          (c.material.uniforms.envMap.value = R),
          (c.material.uniforms.backgroundBlurriness.value =
            L.backgroundBlurriness),
          (c.material.uniforms.backgroundIntensity.value =
            L.backgroundIntensity),
          c.material.uniforms.backgroundRotation.value
            .setFromMatrix4($A.makeRotationFromEuler(L.backgroundRotation))
            .transpose(),
          R.isCubeTexture &&
            R.isRenderTargetTexture === !1 &&
            c.material.uniforms.backgroundRotation.value.premultiply($y),
          (c.material.toneMapped = Ct.getTransfer(R.colorSpace) !== Kt),
          (u !== R || f !== R.version || d !== s.toneMapping) &&
            ((c.material.needsUpdate = !0),
            (u = R),
            (f = R.version),
            (d = s.toneMapping)),
          c.layers.enableAll(),
          w.unshift(c, c.geometry, c.material, 0, 0, null))
        : R &&
          R.isTexture &&
          (l === void 0 &&
            ((l = new ri(
              new ss(2, 2),
              new vi({
                name: 'BackgroundMaterial',
                uniforms: ea(ir.background.uniforms),
                vertexShader: ir.background.vertexShader,
                fragmentShader: ir.background.fragmentShader,
                side: Ss,
                depthTest: !1,
                depthWrite: !1,
                fog: !1,
                allowOverride: !1,
              }),
            )),
            l.geometry.deleteAttribute('normal'),
            Object.defineProperty(l.material, 'map', {
              get: function () {
                return this.uniforms.t2D.value;
              },
            }),
            i.update(l)),
          (l.material.uniforms.t2D.value = R),
          (l.material.uniforms.backgroundIntensity.value =
            L.backgroundIntensity),
          (l.material.toneMapped = Ct.getTransfer(R.colorSpace) !== Kt),
          R.matrixAutoUpdate === !0 && R.updateMatrix(),
          l.material.uniforms.uvTransform.value.copy(R.matrix),
          (u !== R || f !== R.version || d !== s.toneMapping) &&
            ((l.material.needsUpdate = !0),
            (u = R),
            (f = R.version),
            (d = s.toneMapping)),
          l.layers.enableAll(),
          w.unshift(l, l.geometry, l.material, 0, 0, null));
    }
    function g(w, L) {
      (w.getRGB(Hd, mg(s)), t.buffers.color.setClear(Hd.r, Hd.g, Hd.b, L, r));
    }
    function v() {
      (c !== void 0 &&
        (c.geometry.dispose(), c.material.dispose(), (c = void 0)),
        l !== void 0 &&
          (l.geometry.dispose(), l.material.dispose(), (l = void 0)));
    }
    return {
      getClearColor: function () {
        return o;
      },
      setClearColor: function (w, L = 1) {
        (o.set(w), (a = L), g(o, a));
      },
      getClearAlpha: function () {
        return a;
      },
      setClearAlpha: function (w) {
        ((a = w), g(o, a));
      },
      render: _,
      addToRenderList: x,
      dispose: v,
    };
  }
  function JA(s, e) {
    let t = s.getParameter(s.MAX_VERTEX_ATTRIBS),
      i = {},
      n = d(null),
      r = n,
      o = !1;
    function a(W, q, re, oe, K) {
      let ie = !1,
        J = f(W, oe, re, q);
      (r !== J && ((r = J), c(r.object)),
        (ie = p(W, oe, re, K)),
        ie && _(W, oe, re, K),
        K !== null && e.update(K, s.ELEMENT_ARRAY_BUFFER),
        (ie || o) &&
          ((o = !1),
          R(W, q, re, oe),
          K !== null && s.bindBuffer(s.ELEMENT_ARRAY_BUFFER, e.get(K).buffer)));
    }
    function l() {
      return s.createVertexArray();
    }
    function c(W) {
      return s.bindVertexArray(W);
    }
    function u(W) {
      return s.deleteVertexArray(W);
    }
    function f(W, q, re, oe) {
      let K = oe.wireframe === !0,
        ie = i[q.id];
      ie === void 0 && ((ie = {}), (i[q.id] = ie));
      let J = W.isInstancedMesh === !0 ? W.id : 0,
        pe = ie[J];
      pe === void 0 && ((pe = {}), (ie[J] = pe));
      let Ee = pe[re.id];
      Ee === void 0 && ((Ee = {}), (pe[re.id] = Ee));
      let Z = Ee[K];
      return (Z === void 0 && ((Z = d(l())), (Ee[K] = Z)), Z);
    }
    function d(W) {
      let q = [],
        re = [],
        oe = [];
      for (let K = 0; K < t; K++) ((q[K] = 0), (re[K] = 0), (oe[K] = 0));
      return {
        geometry: null,
        program: null,
        wireframe: !1,
        newAttributes: q,
        enabledAttributes: re,
        attributeDivisors: oe,
        object: W,
        attributes: {},
        index: null,
      };
    }
    function p(W, q, re, oe) {
      let K = r.attributes,
        ie = q.attributes,
        J = 0,
        pe = re.getAttributes();
      for (let Ee in pe)
        if (pe[Ee].location >= 0) {
          let Ne = K[Ee],
            Be = ie[Ee];
          if (
            (Be === void 0 &&
              (Ee === 'instanceMatrix' &&
                W.instanceMatrix &&
                (Be = W.instanceMatrix),
              Ee === 'instanceColor' &&
                W.instanceColor &&
                (Be = W.instanceColor)),
            Ne === void 0 || Ne.attribute !== Be || (Be && Ne.data !== Be.data))
          )
            return !0;
          J++;
        }
      return r.attributesNum !== J || r.index !== oe;
    }
    function _(W, q, re, oe) {
      let K = {},
        ie = q.attributes,
        J = 0,
        pe = re.getAttributes();
      for (let Ee in pe)
        if (pe[Ee].location >= 0) {
          let Ne = ie[Ee];
          Ne === void 0 &&
            (Ee === 'instanceMatrix' &&
              W.instanceMatrix &&
              (Ne = W.instanceMatrix),
            Ee === 'instanceColor' &&
              W.instanceColor &&
              (Ne = W.instanceColor));
          let Be = {};
          ((Be.attribute = Ne),
            Ne && Ne.data && (Be.data = Ne.data),
            (K[Ee] = Be),
            J++);
        }
      ((r.attributes = K), (r.attributesNum = J), (r.index = oe));
    }
    function x() {
      let W = r.newAttributes;
      for (let q = 0, re = W.length; q < re; q++) W[q] = 0;
    }
    function g(W) {
      v(W, 0);
    }
    function v(W, q) {
      let re = r.newAttributes,
        oe = r.enabledAttributes,
        K = r.attributeDivisors;
      ((re[W] = 1),
        oe[W] === 0 && (s.enableVertexAttribArray(W), (oe[W] = 1)),
        K[W] !== q && (s.vertexAttribDivisor(W, q), (K[W] = q)));
    }
    function w() {
      let W = r.newAttributes,
        q = r.enabledAttributes;
      for (let re = 0, oe = q.length; re < oe; re++)
        q[re] !== W[re] && (s.disableVertexAttribArray(re), (q[re] = 0));
    }
    function L(W, q, re, oe, K, ie, J) {
      J === !0
        ? s.vertexAttribIPointer(W, q, re, K, ie)
        : s.vertexAttribPointer(W, q, re, oe, K, ie);
    }
    function R(W, q, re, oe) {
      x();
      let K = oe.attributes,
        ie = re.getAttributes(),
        J = q.defaultAttributeValues;
      for (let pe in ie) {
        let Ee = ie[pe];
        if (Ee.location >= 0) {
          let Z = K[pe];
          if (
            (Z === void 0 &&
              (pe === 'instanceMatrix' &&
                W.instanceMatrix &&
                (Z = W.instanceMatrix),
              pe === 'instanceColor' &&
                W.instanceColor &&
                (Z = W.instanceColor)),
            Z !== void 0)
          ) {
            let Ne = Z.normalized,
              Be = Z.itemSize,
              ht = e.get(Z);
            if (ht === void 0) continue;
            let ot = ht.buffer,
              tt = ht.type,
              ve = ht.bytesPerElement,
              Pe = tt === s.INT || tt === s.UNSIGNED_INT || Z.gpuType === ed;
            if (Z.isInterleavedBufferAttribute) {
              let Ae = Z.data,
                Ze = Ae.stride,
                nt = Z.offset;
              if (Ae.isInstancedInterleavedBuffer) {
                for (let Le = 0; Le < Ee.locationSize; Le++)
                  v(Ee.location + Le, Ae.meshPerAttribute);
                W.isInstancedMesh !== !0 &&
                  oe._maxInstanceCount === void 0 &&
                  (oe._maxInstanceCount = Ae.meshPerAttribute * Ae.count);
              } else
                for (let Le = 0; Le < Ee.locationSize; Le++)
                  g(Ee.location + Le);
              s.bindBuffer(s.ARRAY_BUFFER, ot);
              for (let Le = 0; Le < Ee.locationSize; Le++)
                L(
                  Ee.location + Le,
                  Be / Ee.locationSize,
                  tt,
                  Ne,
                  Ze * ve,
                  (nt + (Be / Ee.locationSize) * Le) * ve,
                  Pe,
                );
            } else {
              if (Z.isInstancedBufferAttribute) {
                for (let Ae = 0; Ae < Ee.locationSize; Ae++)
                  v(Ee.location + Ae, Z.meshPerAttribute);
                W.isInstancedMesh !== !0 &&
                  oe._maxInstanceCount === void 0 &&
                  (oe._maxInstanceCount = Z.meshPerAttribute * Z.count);
              } else
                for (let Ae = 0; Ae < Ee.locationSize; Ae++)
                  g(Ee.location + Ae);
              s.bindBuffer(s.ARRAY_BUFFER, ot);
              for (let Ae = 0; Ae < Ee.locationSize; Ae++)
                L(
                  Ee.location + Ae,
                  Be / Ee.locationSize,
                  tt,
                  Ne,
                  Be * ve,
                  (Be / Ee.locationSize) * Ae * ve,
                  Pe,
                );
            }
          } else if (J !== void 0) {
            let Ne = J[pe];
            if (Ne !== void 0)
              switch (Ne.length) {
                case 2:
                  s.vertexAttrib2fv(Ee.location, Ne);
                  break;
                case 3:
                  s.vertexAttrib3fv(Ee.location, Ne);
                  break;
                case 4:
                  s.vertexAttrib4fv(Ee.location, Ne);
                  break;
                default:
                  s.vertexAttrib1fv(Ee.location, Ne);
              }
          }
        }
      }
      w();
    }
    function U() {
      I();
      for (let W in i) {
        let q = i[W];
        for (let re in q) {
          let oe = q[re];
          for (let K in oe) {
            let ie = oe[K];
            for (let J in ie) (u(ie[J].object), delete ie[J]);
            delete oe[K];
          }
        }
        delete i[W];
      }
    }
    function O(W) {
      if (i[W.id] === void 0) return;
      let q = i[W.id];
      for (let re in q) {
        let oe = q[re];
        for (let K in oe) {
          let ie = oe[K];
          for (let J in ie) (u(ie[J].object), delete ie[J]);
          delete oe[K];
        }
      }
      delete i[W.id];
    }
    function N(W) {
      for (let q in i) {
        let re = i[q];
        for (let oe in re) {
          let K = re[oe];
          if (K[W.id] === void 0) continue;
          let ie = K[W.id];
          for (let J in ie) (u(ie[J].object), delete ie[J]);
          delete K[W.id];
        }
      }
    }
    function M(W) {
      for (let q in i) {
        let re = i[q],
          oe = W.isInstancedMesh === !0 ? W.id : 0,
          K = re[oe];
        if (K !== void 0) {
          for (let ie in K) {
            let J = K[ie];
            for (let pe in J) (u(J[pe].object), delete J[pe]);
            delete K[ie];
          }
          (delete re[oe], Object.keys(re).length === 0 && delete i[q]);
        }
      }
    }
    function I() {
      (z(), (o = !0), r !== n && ((r = n), c(r.object)));
    }
    function z() {
      ((n.geometry = null), (n.program = null), (n.wireframe = !1));
    }
    return {
      setup: a,
      reset: I,
      resetDefaultState: z,
      dispose: U,
      releaseStatesOfGeometry: O,
      releaseStatesOfObject: M,
      releaseStatesOfProgram: N,
      initAttributes: x,
      enableAttribute: g,
      disableUnusedAttributes: w,
    };
  }
  function QA(s, e, t) {
    let i;
    function n(l) {
      i = l;
    }
    function r(l, c) {
      (s.drawArrays(i, l, c), t.update(c, i, 1));
    }
    function o(l, c, u) {
      u !== 0 && (s.drawArraysInstanced(i, l, c, u), t.update(c, i, u));
    }
    function a(l, c, u) {
      if (u === 0) return;
      e.get('WEBGL_multi_draw').multiDrawArraysWEBGL(i, l, 0, c, 0, u);
      let d = 0;
      for (let p = 0; p < u; p++) d += c[p];
      t.update(d, i, 1);
    }
    ((this.setMode = n),
      (this.render = r),
      (this.renderInstances = o),
      (this.renderMultiDraw = a));
  }
  function e1(s, e, t, i) {
    let n;
    function r() {
      if (n !== void 0) return n;
      if (e.has('EXT_texture_filter_anisotropic') === !0) {
        let N = e.get('EXT_texture_filter_anisotropic');
        n = s.getParameter(N.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
      } else n = 0;
      return n;
    }
    function o(N) {
      return !(
        N !== Yn &&
        i.convert(N) !== s.getParameter(s.IMPLEMENTATION_COLOR_READ_FORMAT)
      );
    }
    function a(N) {
      let M =
        N === er &&
        (e.has('EXT_color_buffer_half_float') ||
          e.has('EXT_color_buffer_float'));
      return !(
        N !== Ln &&
        i.convert(N) !== s.getParameter(s.IMPLEMENTATION_COLOR_READ_TYPE) &&
        N !== Xn &&
        !M
      );
    }
    function l(N) {
      if (N === 'highp') {
        if (
          s.getShaderPrecisionFormat(s.VERTEX_SHADER, s.HIGH_FLOAT).precision >
            0 &&
          s.getShaderPrecisionFormat(s.FRAGMENT_SHADER, s.HIGH_FLOAT)
            .precision > 0
        )
          return 'highp';
        N = 'mediump';
      }
      return N === 'mediump' &&
        s.getShaderPrecisionFormat(s.VERTEX_SHADER, s.MEDIUM_FLOAT).precision >
          0 &&
        s.getShaderPrecisionFormat(s.FRAGMENT_SHADER, s.MEDIUM_FLOAT)
          .precision > 0
        ? 'mediump'
        : 'lowp';
    }
    let c = t.precision !== void 0 ? t.precision : 'highp',
      u = l(c);
    u !== c &&
      (it('WebGLRenderer:', c, 'not supported, using', u, 'instead.'), (c = u));
    let f = t.logarithmicDepthBuffer === !0,
      d = t.reversedDepthBuffer === !0 && e.has('EXT_clip_control');
    t.reversedDepthBuffer === !0 &&
      d === !1 &&
      it(
        'WebGLRenderer: Unable to use reversed depth buffer due to missing EXT_clip_control extension. Fallback to default depth buffer.',
      );
    let p = s.getParameter(s.MAX_TEXTURE_IMAGE_UNITS),
      _ = s.getParameter(s.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
      x = s.getParameter(s.MAX_TEXTURE_SIZE),
      g = s.getParameter(s.MAX_CUBE_MAP_TEXTURE_SIZE),
      v = s.getParameter(s.MAX_VERTEX_ATTRIBS),
      w = s.getParameter(s.MAX_VERTEX_UNIFORM_VECTORS),
      L = s.getParameter(s.MAX_VARYING_VECTORS),
      R = s.getParameter(s.MAX_FRAGMENT_UNIFORM_VECTORS),
      U = s.getParameter(s.MAX_SAMPLES),
      O = s.getParameter(s.SAMPLES);
    return {
      isWebGL2: !0,
      getMaxAnisotropy: r,
      getMaxPrecision: l,
      textureFormatReadable: o,
      textureTypeReadable: a,
      precision: c,
      logarithmicDepthBuffer: f,
      reversedDepthBuffer: d,
      maxTextures: p,
      maxVertexTextures: _,
      maxTextureSize: x,
      maxCubemapSize: g,
      maxAttributes: v,
      maxVertexUniforms: w,
      maxVaryings: L,
      maxFragmentUniforms: R,
      maxSamples: U,
      samples: O,
    };
  }
  function t1(s) {
    let e = this,
      t = null,
      i = 0,
      n = !1,
      r = !1,
      o = new is(),
      a = new St(),
      l = { value: null, needsUpdate: !1 };
    ((this.uniform = l),
      (this.numPlanes = 0),
      (this.numIntersection = 0),
      (this.init = function (f, d) {
        let p = f.length !== 0 || d || i !== 0 || n;
        return ((n = d), (i = f.length), p);
      }),
      (this.beginShadows = function () {
        ((r = !0), u(null));
      }),
      (this.endShadows = function () {
        r = !1;
      }),
      (this.setGlobalState = function (f, d) {
        t = u(f, d, 0);
      }),
      (this.setState = function (f, d, p) {
        let _ = f.clippingPlanes,
          x = f.clipIntersection,
          g = f.clipShadows,
          v = s.get(f);
        if (!n || _ === null || _.length === 0 || (r && !g)) r ? u(null) : c();
        else {
          let w = r ? 0 : i,
            L = w * 4,
            R = v.clippingState || null;
          ((l.value = R), (R = u(_, d, L, p)));
          for (let U = 0; U !== L; ++U) R[U] = t[U];
          ((v.clippingState = R),
            (this.numIntersection = x ? this.numPlanes : 0),
            (this.numPlanes += w));
        }
      }));
    function c() {
      (l.value !== t && ((l.value = t), (l.needsUpdate = i > 0)),
        (e.numPlanes = i),
        (e.numIntersection = 0));
    }
    function u(f, d, p, _) {
      let x = f !== null ? f.length : 0,
        g = null;
      if (x !== 0) {
        if (((g = l.value), _ !== !0 || g === null)) {
          let v = p + x * 4,
            w = d.matrixWorldInverse;
          (a.getNormalMatrix(w),
            (g === null || g.length < v) && (g = new Float32Array(v)));
          for (let L = 0, R = p; L !== x; ++L, R += 4)
            (o.copy(f[L]).applyMatrix4(w, a),
              o.normal.toArray(g, R),
              (g[R + 3] = o.constant));
        }
        ((l.value = g), (l.needsUpdate = !0));
      }
      return ((e.numPlanes = x), (e.numIntersection = 0), g);
    }
  }
  var co = 4,
    Ay = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582],
    ta = 20,
    i1 = 256,
    Xc = new no(),
    Ry = new je(),
    Tg = null,
    Mg = 0,
    wg = 0,
    Ag = !1,
    n1 = new te(),
    cl = class {
      constructor(e) {
        ((this._renderer = e),
          (this._pingPongRenderTarget = null),
          (this._lodMax = 0),
          (this._cubeSize = 0),
          (this._sizeLods = []),
          (this._sigmas = []),
          (this._lodMeshes = []),
          (this._backgroundBox = null),
          (this._cubemapMaterial = null),
          (this._equirectMaterial = null),
          (this._blurMaterial = null),
          (this._ggxMaterial = null));
      }
      fromScene(e, t = 0, i = 0.1, n = 100, r = {}) {
        let { size: o = 256, position: a = n1 } = r;
        ((Tg = this._renderer.getRenderTarget()),
          (Mg = this._renderer.getActiveCubeFace()),
          (wg = this._renderer.getActiveMipmapLevel()),
          (Ag = this._renderer.xr.enabled),
          (this._renderer.xr.enabled = !1),
          this._setSize(o));
        let l = this._allocateTargets();
        return (
          (l.depthBuffer = !0),
          this._sceneToCubeUV(e, i, n, l, a),
          t > 0 && this._blur(l, 0, 0, t),
          this._applyPMREM(l),
          this._cleanup(l),
          l
        );
      }
      fromEquirectangular(e, t = null) {
        return this._fromTexture(e, t);
      }
      fromCubemap(e, t = null) {
        return this._fromTexture(e, t);
      }
      compileCubemapShader() {
        this._cubemapMaterial === null &&
          ((this._cubemapMaterial = Ly()),
          this._compileMaterial(this._cubemapMaterial));
      }
      compileEquirectangularShader() {
        this._equirectMaterial === null &&
          ((this._equirectMaterial = Py()),
          this._compileMaterial(this._equirectMaterial));
      }
      dispose() {
        (this._dispose(),
          this._cubemapMaterial !== null && this._cubemapMaterial.dispose(),
          this._equirectMaterial !== null && this._equirectMaterial.dispose(),
          this._backgroundBox !== null &&
            (this._backgroundBox.geometry.dispose(),
            this._backgroundBox.material.dispose()));
      }
      _setSize(e) {
        ((this._lodMax = Math.floor(Math.log2(e))),
          (this._cubeSize = Math.pow(2, this._lodMax)));
      }
      _dispose() {
        (this._blurMaterial !== null && this._blurMaterial.dispose(),
          this._ggxMaterial !== null && this._ggxMaterial.dispose(),
          this._pingPongRenderTarget !== null &&
            this._pingPongRenderTarget.dispose());
        for (let e = 0; e < this._lodMeshes.length; e++)
          this._lodMeshes[e].geometry.dispose();
      }
      _cleanup(e) {
        (this._renderer.setRenderTarget(Tg, Mg, wg),
          (this._renderer.xr.enabled = Ag),
          (e.scissorTest = !1),
          al(e, 0, 0, e.width, e.height));
      }
      _fromTexture(e, t) {
        (e.mapping === oo || e.mapping === Jo
          ? this._setSize(
              e.image.length === 0
                ? 16
                : e.image[0].width || e.image[0].image.width,
            )
          : this._setSize(e.image.width / 4),
          (Tg = this._renderer.getRenderTarget()),
          (Mg = this._renderer.getActiveCubeFace()),
          (wg = this._renderer.getActiveMipmapLevel()),
          (Ag = this._renderer.xr.enabled),
          (this._renderer.xr.enabled = !1));
        let i = t || this._allocateTargets();
        return (
          this._textureToCubeUV(e, i),
          this._applyPMREM(i),
          this._cleanup(i),
          i
        );
      }
      _allocateTargets() {
        let e = 3 * Math.max(this._cubeSize, 112),
          t = 4 * this._cubeSize,
          i = {
            magFilter: Si,
            minFilter: Si,
            generateMipmaps: !1,
            type: er,
            format: Yn,
            colorSpace: qi,
            depthBuffer: !1,
          },
          n = Cy(e, t, i);
        if (
          this._pingPongRenderTarget === null ||
          this._pingPongRenderTarget.width !== e ||
          this._pingPongRenderTarget.height !== t
        ) {
          (this._pingPongRenderTarget !== null && this._dispose(),
            (this._pingPongRenderTarget = Cy(e, t, i)));
          let { _lodMax: r } = this;
          (({
            lodMeshes: this._lodMeshes,
            sizeLods: this._sizeLods,
            sigmas: this._sigmas,
          } = s1(r)),
            (this._blurMaterial = o1(r, e, t)),
            (this._ggxMaterial = r1(r, e, t)));
        }
        return n;
      }
      _compileMaterial(e) {
        let t = new ri(new Vi(), e);
        this._renderer.compile(t, Xc);
      }
      _sceneToCubeUV(e, t, i, n, r) {
        let l = new di(90, 1, t, i),
          c = [1, -1, 1, 1, 1, 1],
          u = [1, 1, 1, -1, -1, -1],
          f = this._renderer,
          d = f.autoClear,
          p = f.toneMapping;
        (f.getClearColor(Ry),
          (f.toneMapping = ws),
          (f.autoClear = !1),
          f.state.buffers.depth.getReversed() &&
            (f.setRenderTarget(n), f.clearDepth(), f.setRenderTarget(null)),
          this._backgroundBox === null &&
            (this._backgroundBox = new ri(
              new Qa(),
              new rn({
                name: 'PMREM.Background',
                side: bn,
                depthWrite: !1,
                depthTest: !1,
              }),
            )));
        let x = this._backgroundBox,
          g = x.material,
          v = !1,
          w = e.background;
        w
          ? w.isColor && (g.color.copy(w), (e.background = null), (v = !0))
          : (g.color.copy(Ry), (v = !0));
        for (let L = 0; L < 6; L++) {
          let R = L % 3;
          R === 0
            ? (l.up.set(0, c[L], 0),
              l.position.set(r.x, r.y, r.z),
              l.lookAt(r.x + u[L], r.y, r.z))
            : R === 1
              ? (l.up.set(0, 0, c[L]),
                l.position.set(r.x, r.y, r.z),
                l.lookAt(r.x, r.y + u[L], r.z))
              : (l.up.set(0, c[L], 0),
                l.position.set(r.x, r.y, r.z),
                l.lookAt(r.x, r.y, r.z + u[L]));
          let U = this._cubeSize;
          (al(n, R * U, L > 2 ? U : 0, U, U),
            f.setRenderTarget(n),
            v && f.render(x, l),
            f.render(e, l));
        }
        ((f.toneMapping = p), (f.autoClear = d), (e.background = w));
      }
      _textureToCubeUV(e, t) {
        let i = this._renderer,
          n = e.mapping === oo || e.mapping === Jo;
        n
          ? (this._cubemapMaterial === null && (this._cubemapMaterial = Ly()),
            (this._cubemapMaterial.uniforms.flipEnvMap.value =
              e.isRenderTargetTexture === !1 ? -1 : 1))
          : this._equirectMaterial === null && (this._equirectMaterial = Py());
        let r = n ? this._cubemapMaterial : this._equirectMaterial,
          o = this._lodMeshes[0];
        o.material = r;
        let a = r.uniforms;
        a.envMap.value = e;
        let l = this._cubeSize;
        (al(t, 0, 0, 3 * l, 2 * l), i.setRenderTarget(t), i.render(o, Xc));
      }
      _applyPMREM(e) {
        let t = this._renderer,
          i = t.autoClear;
        t.autoClear = !1;
        let n = this._lodMeshes.length;
        for (let r = 1; r < n; r++) this._applyGGXFilter(e, r - 1, r);
        t.autoClear = i;
      }
      _applyGGXFilter(e, t, i) {
        let n = this._renderer,
          r = this._pingPongRenderTarget,
          o = this._ggxMaterial,
          a = this._lodMeshes[i];
        a.material = o;
        let l = o.uniforms,
          c = i / (this._lodMeshes.length - 1),
          u = t / (this._lodMeshes.length - 1),
          f = Math.sqrt(c * c - u * u),
          d = 0 + c * 1.25,
          p = f * d,
          { _lodMax: _ } = this,
          x = this._sizeLods[i],
          g = 3 * x * (i > _ - co ? i - _ + co : 0),
          v = 4 * (this._cubeSize - x);
        ((l.envMap.value = e.texture),
          (l.roughness.value = p),
          (l.mipInt.value = _ - t),
          al(r, g, v, 3 * x, 2 * x),
          n.setRenderTarget(r),
          n.render(a, Xc),
          (l.envMap.value = r.texture),
          (l.roughness.value = 0),
          (l.mipInt.value = _ - i),
          al(e, g, v, 3 * x, 2 * x),
          n.setRenderTarget(e),
          n.render(a, Xc));
      }
      _blur(e, t, i, n, r) {
        let o = this._pingPongRenderTarget;
        (this._halfBlur(e, o, t, i, n, 'latitudinal', r),
          this._halfBlur(o, e, i, i, n, 'longitudinal', r));
      }
      _halfBlur(e, t, i, n, r, o, a) {
        let l = this._renderer,
          c = this._blurMaterial;
        o !== 'latitudinal' &&
          o !== 'longitudinal' &&
          mt('blur direction must be either latitudinal or longitudinal!');
        let u = 3,
          f = this._lodMeshes[n];
        f.material = c;
        let d = c.uniforms,
          p = this._sizeLods[i] - 1,
          _ = isFinite(r) ? Math.PI / (2 * p) : (2 * Math.PI) / (2 * ta - 1),
          x = r / _,
          g = isFinite(r) ? 1 + Math.floor(u * x) : ta;
        g > ta &&
          it(
            `sigmaRadians, ${r}, is too large and will clip, as it requested ${g} samples when the maximum is set to ${ta}`,
          );
        let v = [],
          w = 0;
        for (let N = 0; N < ta; ++N) {
          let M = N / x,
            I = Math.exp((-M * M) / 2);
          (v.push(I), N === 0 ? (w += I) : N < g && (w += 2 * I));
        }
        for (let N = 0; N < v.length; N++) v[N] = v[N] / w;
        ((d.envMap.value = e.texture),
          (d.samples.value = g),
          (d.weights.value = v),
          (d.latitudinal.value = o === 'latitudinal'),
          a && (d.poleAxis.value = a));
        let { _lodMax: L } = this;
        ((d.dTheta.value = _), (d.mipInt.value = L - i));
        let R = this._sizeLods[n],
          U = 3 * R * (n > L - co ? n - L + co : 0),
          O = 4 * (this._cubeSize - R);
        (al(t, U, O, 3 * R, 2 * R), l.setRenderTarget(t), l.render(f, Xc));
      }
    };
  function s1(s) {
    let e = [],
      t = [],
      i = [],
      n = s,
      r = s - co + 1 + Ay.length;
    for (let o = 0; o < r; o++) {
      let a = Math.pow(2, n);
      e.push(a);
      let l = 1 / a;
      (o > s - co ? (l = Ay[o - s + co - 1]) : o === 0 && (l = 0), t.push(l));
      let c = 1 / (a - 2),
        u = -c,
        f = 1 + c,
        d = [u, u, f, u, f, f, u, u, f, f, u, f],
        p = 6,
        _ = 6,
        x = 3,
        g = 2,
        v = 1,
        w = new Float32Array(x * _ * p),
        L = new Float32Array(g * _ * p),
        R = new Float32Array(v * _ * p);
      for (let O = 0; O < p; O++) {
        let N = ((O % 3) * 2) / 3 - 1,
          M = O > 2 ? 0 : -1,
          I = [
            N,
            M,
            0,
            N + 2 / 3,
            M,
            0,
            N + 2 / 3,
            M + 1,
            0,
            N,
            M,
            0,
            N + 2 / 3,
            M + 1,
            0,
            N,
            M + 1,
            0,
          ];
        (w.set(I, x * _ * O), L.set(d, g * _ * O));
        let z = [O, O, O, O, O, O];
        R.set(z, v * _ * O);
      }
      let U = new Vi();
      (U.setAttribute('position', new fi(w, x)),
        U.setAttribute('uv', new fi(L, g)),
        U.setAttribute('faceIndex', new fi(R, v)),
        i.push(new ri(U, null)),
        n > co && n--);
    }
    return { lodMeshes: i, sizeLods: e, sigmas: t };
  }
  function Cy(s, e, t) {
    let i = new xn(s, e, t);
    return (
      (i.texture.mapping = Uc),
      (i.texture.name = 'PMREM.cubeUv'),
      (i.scissorTest = !0),
      i
    );
  }
  function al(s, e, t, i, n) {
    (s.viewport.set(e, t, i, n), s.scissor.set(e, t, i, n));
  }
  function r1(s, e, t) {
    return new vi({
      name: 'PMREMGGXConvolution',
      defines: {
        GGX_SAMPLES: i1,
        CUBEUV_TEXEL_WIDTH: 1 / e,
        CUBEUV_TEXEL_HEIGHT: 1 / t,
        CUBEUV_MAX_MIP: `${s}.0`,
      },
      uniforms: {
        envMap: { value: null },
        roughness: { value: 0 },
        mipInt: { value: 0 },
      },
      vertexShader: Gd(),
      fragmentShader: `

			precision highp float;
			precision highp int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform float roughness;
			uniform float mipInt;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			#define PI 3.14159265359

			// Van der Corput radical inverse
			float radicalInverse_VdC(uint bits) {
				bits = (bits << 16u) | (bits >> 16u);
				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
				return float(bits) * 2.3283064365386963e-10; // / 0x100000000
			}

			// Hammersley sequence
			vec2 hammersley(uint i, uint N) {
				return vec2(float(i) / float(N), radicalInverse_VdC(i));
			}

			// GGX VNDF importance sampling (Eric Heitz 2018)
			// "Sampling the GGX Distribution of Visible Normals"
			// https://jcgt.org/published/0007/04/01/
			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {
				float alpha = roughness * roughness;

				// Section 4.1: Orthonormal basis
				vec3 T1 = vec3(1.0, 0.0, 0.0);
				vec3 T2 = cross(V, T1);

				// Section 4.2: Parameterization of projected area
				float r = sqrt(Xi.x);
				float phi = 2.0 * PI * Xi.y;
				float t1 = r * cos(phi);
				float t2 = r * sin(phi);
				float s = 0.5 * (1.0 + V.z);
				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;

				// Section 4.3: Reprojection onto hemisphere
				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * V;

				// Section 3.4: Transform back to ellipsoid configuration
				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));
			}

			void main() {
				vec3 N = normalize(vOutputDirection);
				vec3 V = N; // Assume view direction equals normal for pre-filtering

				vec3 prefilteredColor = vec3(0.0);
				float totalWeight = 0.0;

				// For very low roughness, just sample the environment directly
				if (roughness < 0.001) {
					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);
					return;
				}

				// Tangent space basis for VNDF sampling
				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);
				vec3 tangent = normalize(cross(up, N));
				vec3 bitangent = cross(N, tangent);

				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {
					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));

					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)
					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);

					// Transform H back to world space
					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);
					vec3 L = normalize(2.0 * dot(V, H) * H - V);

					float NdotL = max(dot(N, L), 0.0);

					if(NdotL > 0.0) {
						// Sample environment at fixed mip level
						// VNDF importance sampling handles the distribution filtering
						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);

						// Weight by NdotL for the split-sum approximation
						// VNDF PDF naturally accounts for the visible microfacet distribution
						prefilteredColor += sampleColor * NdotL;
						totalWeight += NdotL;
					}
				}

				if (totalWeight > 0.0) {
					prefilteredColor = prefilteredColor / totalWeight;
				}

				gl_FragColor = vec4(prefilteredColor, 1.0);
			}
		`,
      blending: Qs,
      depthTest: !1,
      depthWrite: !1,
    });
  }
  function o1(s, e, t) {
    let i = new Float32Array(ta),
      n = new te(0, 1, 0);
    return new vi({
      name: 'SphericalGaussianBlur',
      defines: {
        n: ta,
        CUBEUV_TEXEL_WIDTH: 1 / e,
        CUBEUV_TEXEL_HEIGHT: 1 / t,
        CUBEUV_MAX_MIP: `${s}.0`,
      },
      uniforms: {
        envMap: { value: null },
        samples: { value: 1 },
        weights: { value: i },
        latitudinal: { value: !1 },
        dTheta: { value: 0 },
        mipInt: { value: 0 },
        poleAxis: { value: n },
      },
      vertexShader: Gd(),
      fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
      blending: Qs,
      depthTest: !1,
      depthWrite: !1,
    });
  }
  function Py() {
    return new vi({
      name: 'EquirectangularToCubeUV',
      uniforms: { envMap: { value: null } },
      vertexShader: Gd(),
      fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
      blending: Qs,
      depthTest: !1,
      depthWrite: !1,
    });
  }
  function Ly() {
    return new vi({
      name: 'CubemapToCubeUV',
      uniforms: { envMap: { value: null }, flipEnvMap: { value: -1 } },
      vertexShader: Gd(),
      fragmentShader: `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
      blending: Qs,
      depthTest: !1,
      depthWrite: !1,
    });
  }
  function Gd() {
    return `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
  }
  var Vd = class extends xn {
    constructor(e = 1, t = {}) {
      (super(e, e, t), (this.isWebGLCubeRenderTarget = !0));
      let i = { width: e, height: e, depth: 1 },
        n = [i, i, i, i, i, i];
      ((this.texture = new Tc(n)),
        this._setTextureOptions(t),
        (this.texture.isRenderTargetTexture = !0));
    }
    fromEquirectangularTexture(e, t) {
      ((this.texture.type = t.type),
        (this.texture.colorSpace = t.colorSpace),
        (this.texture.generateMipmaps = t.generateMipmaps),
        (this.texture.minFilter = t.minFilter),
        (this.texture.magFilter = t.magFilter));
      let i = {
          uniforms: { tEquirect: { value: null } },
          vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
          fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`,
        },
        n = new Qa(5, 5, 5),
        r = new vi({
          name: 'CubemapFromEquirect',
          uniforms: ea(i.uniforms),
          vertexShader: i.vertexShader,
          fragmentShader: i.fragmentShader,
          side: bn,
          blending: Qs,
        });
      r.uniforms.tEquirect.value = t;
      let o = new ri(n, r),
        a = t.minFilter;
      return (
        t.minFilter === As && (t.minFilter = Si),
        new Ku(1, 10, this).update(e, o),
        (t.minFilter = a),
        o.geometry.dispose(),
        o.material.dispose(),
        this
      );
    }
    clear(e, t = !0, i = !0, n = !0) {
      let r = e.getRenderTarget();
      for (let o = 0; o < 6; o++)
        (e.setRenderTarget(this, o), e.clear(t, i, n));
      e.setRenderTarget(r);
    }
  };
  function a1(s) {
    let e = new WeakMap(),
      t = new WeakMap(),
      i = null;
    function n(d, p = !1) {
      return d == null ? null : p ? o(d) : r(d);
    }
    function r(d) {
      if (d && d.isTexture) {
        let p = d.mapping;
        if (p === il || p === Ju)
          if (e.has(d)) {
            let _ = e.get(d).texture;
            return a(_, d.mapping);
          } else {
            let _ = d.image;
            if (_ && _.height > 0) {
              let x = new Vd(_.height);
              return (
                x.fromEquirectangularTexture(s, d),
                e.set(d, x),
                d.addEventListener('dispose', c),
                a(x.texture, d.mapping)
              );
            } else return null;
          }
      }
      return d;
    }
    function o(d) {
      if (d && d.isTexture) {
        let p = d.mapping,
          _ = p === il || p === Ju,
          x = p === oo || p === Jo;
        if (_ || x) {
          let g = t.get(d),
            v = g !== void 0 ? g.texture.pmremVersion : 0;
          if (d.isRenderTargetTexture && d.pmremVersion !== v)
            return (
              i === null && (i = new cl(s)),
              (g = _ ? i.fromEquirectangular(d, g) : i.fromCubemap(d, g)),
              (g.texture.pmremVersion = d.pmremVersion),
              t.set(d, g),
              g.texture
            );
          if (g !== void 0) return g.texture;
          {
            let w = d.image;
            return (_ && w && w.height > 0) || (x && w && l(w))
              ? (i === null && (i = new cl(s)),
                (g = _ ? i.fromEquirectangular(d) : i.fromCubemap(d)),
                (g.texture.pmremVersion = d.pmremVersion),
                t.set(d, g),
                d.addEventListener('dispose', u),
                g.texture)
              : null;
          }
        }
      }
      return d;
    }
    function a(d, p) {
      return (p === il ? (d.mapping = oo) : p === Ju && (d.mapping = Jo), d);
    }
    function l(d) {
      let p = 0,
        _ = 6;
      for (let x = 0; x < _; x++) d[x] !== void 0 && p++;
      return p === _;
    }
    function c(d) {
      let p = d.target;
      p.removeEventListener('dispose', c);
      let _ = e.get(p);
      _ !== void 0 && (e.delete(p), _.dispose());
    }
    function u(d) {
      let p = d.target;
      p.removeEventListener('dispose', u);
      let _ = t.get(p);
      _ !== void 0 && (t.delete(p), _.dispose());
    }
    function f() {
      ((e = new WeakMap()),
        (t = new WeakMap()),
        i !== null && (i.dispose(), (i = null)));
    }
    return { get: n, dispose: f };
  }
  function l1(s) {
    let e = {};
    function t(i) {
      if (e[i] !== void 0) return e[i];
      let n = s.getExtension(i);
      return ((e[i] = n), n);
    }
    return {
      has: function (i) {
        return t(i) !== null;
      },
      init: function () {
        (t('EXT_color_buffer_float'),
          t('WEBGL_clip_cull_distance'),
          t('OES_texture_float_linear'),
          t('EXT_color_buffer_half_float'),
          t('WEBGL_multisampled_render_to_texture'),
          t('WEBGL_render_shared_exponent'));
      },
      get: function (i) {
        let n = t(i);
        return (
          n === null && Iu('WebGLRenderer: ' + i + ' extension not supported.'),
          n
        );
      },
    };
  }
  function c1(s, e, t, i) {
    let n = {},
      r = new WeakMap();
    function o(f) {
      let d = f.target;
      d.index !== null && e.remove(d.index);
      for (let _ in d.attributes) e.remove(d.attributes[_]);
      (d.removeEventListener('dispose', o), delete n[d.id]);
      let p = r.get(d);
      (p && (e.remove(p), r.delete(d)),
        i.releaseStatesOfGeometry(d),
        d.isInstancedBufferGeometry === !0 && delete d._maxInstanceCount,
        t.memory.geometries--);
    }
    function a(f, d) {
      return (
        n[d.id] === !0 ||
          (d.addEventListener('dispose', o),
          (n[d.id] = !0),
          t.memory.geometries++),
        d
      );
    }
    function l(f) {
      let d = f.attributes;
      for (let p in d) e.update(d[p], s.ARRAY_BUFFER);
    }
    function c(f) {
      let d = [],
        p = f.index,
        _ = f.attributes.position,
        x = 0;
      if (_ === void 0) return;
      if (p !== null) {
        let w = p.array;
        x = p.version;
        for (let L = 0, R = w.length; L < R; L += 3) {
          let U = w[L + 0],
            O = w[L + 1],
            N = w[L + 2];
          d.push(U, O, O, N, N, U);
        }
      } else {
        let w = _.array;
        x = _.version;
        for (let L = 0, R = w.length / 3 - 1; L < R; L += 3) {
          let U = L + 0,
            O = L + 1,
            N = L + 2;
          d.push(U, O, O, N, N, U);
        }
      }
      let g = new (_.count >= 65535 ? _c : gc)(d, 1);
      g.version = x;
      let v = r.get(f);
      (v && e.remove(v), r.set(f, g));
    }
    function u(f) {
      let d = r.get(f);
      if (d) {
        let p = f.index;
        p !== null && d.version < p.version && c(f);
      } else c(f);
      return r.get(f);
    }
    return { get: a, update: l, getWireframeAttribute: u };
  }
  function h1(s, e, t) {
    let i;
    function n(f) {
      i = f;
    }
    let r, o;
    function a(f) {
      ((r = f.type), (o = f.bytesPerElement));
    }
    function l(f, d) {
      (s.drawElements(i, d, r, f * o), t.update(d, i, 1));
    }
    function c(f, d, p) {
      p !== 0 &&
        (s.drawElementsInstanced(i, d, r, f * o, p), t.update(d, i, p));
    }
    function u(f, d, p) {
      if (p === 0) return;
      e.get('WEBGL_multi_draw').multiDrawElementsWEBGL(i, d, 0, r, f, 0, p);
      let x = 0;
      for (let g = 0; g < p; g++) x += d[g];
      t.update(x, i, 1);
    }
    ((this.setMode = n),
      (this.setIndex = a),
      (this.render = l),
      (this.renderInstances = c),
      (this.renderMultiDraw = u));
  }
  function u1(s) {
    let e = { geometries: 0, textures: 0 },
      t = { frame: 0, calls: 0, triangles: 0, points: 0, lines: 0 };
    function i(r, o, a) {
      switch ((t.calls++, o)) {
        case s.TRIANGLES:
          t.triangles += a * (r / 3);
          break;
        case s.LINES:
          t.lines += a * (r / 2);
          break;
        case s.LINE_STRIP:
          t.lines += a * (r - 1);
          break;
        case s.LINE_LOOP:
          t.lines += a * r;
          break;
        case s.POINTS:
          t.points += a * r;
          break;
        default:
          mt('WebGLInfo: Unknown draw mode:', o);
          break;
      }
    }
    function n() {
      ((t.calls = 0), (t.triangles = 0), (t.points = 0), (t.lines = 0));
    }
    return {
      memory: e,
      render: t,
      programs: null,
      autoReset: !0,
      reset: n,
      update: i,
    };
  }
  function d1(s, e, t) {
    let i = new WeakMap(),
      n = new Qt();
    function r(o, a, l) {
      let c = o.morphTargetInfluences,
        u =
          a.morphAttributes.position ||
          a.morphAttributes.normal ||
          a.morphAttributes.color,
        f = u !== void 0 ? u.length : 0,
        d = i.get(a);
      if (d === void 0 || d.count !== f) {
        let z = function () {
          (M.dispose(), i.delete(a), a.removeEventListener('dispose', z));
        };
        var p = z;
        d !== void 0 && d.texture.dispose();
        let _ = a.morphAttributes.position !== void 0,
          x = a.morphAttributes.normal !== void 0,
          g = a.morphAttributes.color !== void 0,
          v = a.morphAttributes.position || [],
          w = a.morphAttributes.normal || [],
          L = a.morphAttributes.color || [],
          R = 0;
        (_ === !0 && (R = 1), x === !0 && (R = 2), g === !0 && (R = 3));
        let U = a.attributes.position.count * R,
          O = 1;
        U > e.maxTextureSize &&
          ((O = Math.ceil(U / e.maxTextureSize)), (U = e.maxTextureSize));
        let N = new Float32Array(U * O * 4 * f),
          M = new pc(N, U, O, f);
        ((M.type = Xn), (M.needsUpdate = !0));
        let I = R * 4;
        for (let W = 0; W < f; W++) {
          let q = v[W],
            re = w[W],
            oe = L[W],
            K = U * O * 4 * W;
          for (let ie = 0; ie < q.count; ie++) {
            let J = ie * I;
            (_ === !0 &&
              (n.fromBufferAttribute(q, ie),
              (N[K + J + 0] = n.x),
              (N[K + J + 1] = n.y),
              (N[K + J + 2] = n.z),
              (N[K + J + 3] = 0)),
              x === !0 &&
                (n.fromBufferAttribute(re, ie),
                (N[K + J + 4] = n.x),
                (N[K + J + 5] = n.y),
                (N[K + J + 6] = n.z),
                (N[K + J + 7] = 0)),
              g === !0 &&
                (n.fromBufferAttribute(oe, ie),
                (N[K + J + 8] = n.x),
                (N[K + J + 9] = n.y),
                (N[K + J + 10] = n.z),
                (N[K + J + 11] = oe.itemSize === 4 ? n.w : 1)));
          }
        }
        ((d = { count: f, texture: M, size: new et(U, O) }),
          i.set(a, d),
          a.addEventListener('dispose', z));
      }
      if (o.isInstancedMesh === !0 && o.morphTexture !== null)
        l.getUniforms().setValue(s, 'morphTexture', o.morphTexture, t);
      else {
        let _ = 0;
        for (let g = 0; g < c.length; g++) _ += c[g];
        let x = a.morphTargetsRelative ? 1 : 1 - _;
        (l.getUniforms().setValue(s, 'morphTargetBaseInfluence', x),
          l.getUniforms().setValue(s, 'morphTargetInfluences', c));
      }
      (l.getUniforms().setValue(s, 'morphTargetsTexture', d.texture, t),
        l.getUniforms().setValue(s, 'morphTargetsTextureSize', d.size));
    }
    return { update: r };
  }
  function f1(s, e, t, i, n) {
    let r = new WeakMap();
    function o(c) {
      let u = n.render.frame,
        f = c.geometry,
        d = e.get(c, f);
      if (
        (r.get(d) !== u && (e.update(d), r.set(d, u)),
        c.isInstancedMesh &&
          (c.hasEventListener('dispose', l) === !1 &&
            c.addEventListener('dispose', l),
          r.get(c) !== u &&
            (t.update(c.instanceMatrix, s.ARRAY_BUFFER),
            c.instanceColor !== null &&
              t.update(c.instanceColor, s.ARRAY_BUFFER),
            r.set(c, u))),
        c.isSkinnedMesh)
      ) {
        let p = c.skeleton;
        r.get(p) !== u && (p.update(), r.set(p, u));
      }
      return d;
    }
    function a() {
      r = new WeakMap();
    }
    function l(c) {
      let u = c.target;
      (u.removeEventListener('dispose', l),
        i.releaseStatesOfObject(u),
        t.remove(u.instanceMatrix),
        u.instanceColor !== null && t.remove(u.instanceColor));
    }
    return { update: o, dispose: a };
  }
  var p1 = {
    [Jm]: 'LINEAR_TONE_MAPPING',
    [Qm]: 'REINHARD_TONE_MAPPING',
    [eg]: 'CINEON_TONE_MAPPING',
    [tg]: 'ACES_FILMIC_TONE_MAPPING',
    [ng]: 'AGX_TONE_MAPPING',
    [sg]: 'NEUTRAL_TONE_MAPPING',
    [ig]: 'CUSTOM_TONE_MAPPING',
  };
  function m1(s, e, t, i, n) {
    let r = new xn(e, t, {
        type: s,
        depthBuffer: i,
        stencilBuffer: n,
        depthTexture: i ? new Mr(e, t) : void 0,
      }),
      o = new xn(e, t, { type: er, depthBuffer: !1, stencilBuffer: !1 }),
      a = new Vi();
    (a.setAttribute('position', new Hi([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3)),
      a.setAttribute('uv', new Hi([0, 2, 0, 0, 2, 0], 2)));
    let l = new ku({
        uniforms: { tDiffuse: { value: null } },
        vertexShader: `
			precision highp float;

			uniform mat4 modelViewMatrix;
			uniform mat4 projectionMatrix;

			attribute vec3 position;
			attribute vec2 uv;

			varying vec2 vUv;

			void main() {
				vUv = uv;
				gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
			}`,
        fragmentShader: `
			precision highp float;

			uniform sampler2D tDiffuse;

			varying vec2 vUv;

			#include <tonemapping_pars_fragment>
			#include <colorspace_pars_fragment>

			void main() {
				gl_FragColor = texture2D( tDiffuse, vUv );

				#ifdef LINEAR_TONE_MAPPING
					gl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );
				#elif defined( REINHARD_TONE_MAPPING )
					gl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );
				#elif defined( CINEON_TONE_MAPPING )
					gl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );
				#elif defined( ACES_FILMIC_TONE_MAPPING )
					gl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );
				#elif defined( AGX_TONE_MAPPING )
					gl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );
				#elif defined( NEUTRAL_TONE_MAPPING )
					gl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );
				#elif defined( CUSTOM_TONE_MAPPING )
					gl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );
				#endif

				#ifdef SRGB_TRANSFER
					gl_FragColor = sRGBTransferOETF( gl_FragColor );
				#endif
			}`,
        depthTest: !1,
        depthWrite: !1,
      }),
      c = new ri(a, l),
      u = new no(-1, 1, 1, -1, 0, 1),
      f = null,
      d = null,
      p = !1,
      _,
      x = null,
      g = [],
      v = !1;
    ((this.setSize = function (w, L) {
      (r.setSize(w, L), o.setSize(w, L));
      for (let R = 0; R < g.length; R++) {
        let U = g[R];
        U.setSize && U.setSize(w, L);
      }
    }),
      (this.setEffects = function (w) {
        ((g = w), (v = g.length > 0 && g[0].isRenderPass === !0));
        let L = r.width,
          R = r.height;
        for (let U = 0; U < g.length; U++) {
          let O = g[U];
          O.setSize && O.setSize(L, R);
        }
      }),
      (this.begin = function (w, L) {
        if (p || (w.toneMapping === ws && g.length === 0)) return !1;
        if (((x = L), L !== null)) {
          let R = L.width,
            U = L.height;
          (r.width !== R || r.height !== U) && this.setSize(R, U);
        }
        return (
          v === !1 && w.setRenderTarget(r),
          (_ = w.toneMapping),
          (w.toneMapping = ws),
          !0
        );
      }),
      (this.hasRenderPass = function () {
        return v;
      }),
      (this.end = function (w, L) {
        ((w.toneMapping = _), (p = !0));
        let R = r,
          U = o;
        for (let O = 0; O < g.length; O++) {
          let N = g[O];
          if (N.enabled !== !1 && (N.render(w, U, R, L), N.needsSwap !== !1)) {
            let M = R;
            ((R = U), (U = M));
          }
        }
        if (f !== w.outputColorSpace || d !== w.toneMapping) {
          ((f = w.outputColorSpace),
            (d = w.toneMapping),
            (l.defines = {}),
            Ct.getTransfer(f) === Kt && (l.defines.SRGB_TRANSFER = ''));
          let O = p1[d];
          (O && (l.defines[O] = ''), (l.needsUpdate = !0));
        }
        ((l.uniforms.tDiffuse.value = R.texture),
          w.setRenderTarget(x),
          w.render(c, u),
          (x = null),
          (p = !1));
      }),
      (this.isCompositing = function () {
        return p;
      }),
      (this.dispose = function () {
        (r.depthTexture && r.depthTexture.dispose(),
          r.dispose(),
          o.dispose(),
          a.dispose(),
          l.dispose());
      }));
  }
  var jy = new Li(),
    Pg = new Mr(1, 1),
    Jy = new pc(),
    Qy = new Nu(),
    eb = new Tc(),
    Iy = [],
    Dy = [],
    Oy = new Float32Array(16),
    Ny = new Float32Array(9),
    Fy = new Float32Array(4);
  function ul(s, e, t) {
    let i = s[0];
    if (i <= 0 || i > 0) return s;
    let n = e * t,
      r = Iy[n];
    if ((r === void 0 && ((r = new Float32Array(n)), (Iy[n] = r)), e !== 0)) {
      i.toArray(r, 0);
      for (let o = 1, a = 0; o !== e; ++o) ((a += t), s[o].toArray(r, a));
    }
    return r;
  }
  function Ii(s, e) {
    if (s.length !== e.length) return !1;
    for (let t = 0, i = s.length; t < i; t++) if (s[t] !== e[t]) return !1;
    return !0;
  }
  function Di(s, e) {
    for (let t = 0, i = e.length; t < i; t++) s[t] = e[t];
  }
  function Wd(s, e) {
    let t = Dy[e];
    t === void 0 && ((t = new Int32Array(e)), (Dy[e] = t));
    for (let i = 0; i !== e; ++i) t[i] = s.allocateTextureUnit();
    return t;
  }
  function g1(s, e) {
    let t = this.cache;
    t[0] !== e && (s.uniform1f(this.addr, e), (t[0] = e));
  }
  function _1(s, e) {
    let t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y) &&
        (s.uniform2f(this.addr, e.x, e.y), (t[0] = e.x), (t[1] = e.y));
    else {
      if (Ii(t, e)) return;
      (s.uniform2fv(this.addr, e), Di(t, e));
    }
  }
  function v1(s, e) {
    let t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) &&
        (s.uniform3f(this.addr, e.x, e.y, e.z),
        (t[0] = e.x),
        (t[1] = e.y),
        (t[2] = e.z));
    else if (e.r !== void 0)
      (t[0] !== e.r || t[1] !== e.g || t[2] !== e.b) &&
        (s.uniform3f(this.addr, e.r, e.g, e.b),
        (t[0] = e.r),
        (t[1] = e.g),
        (t[2] = e.b));
    else {
      if (Ii(t, e)) return;
      (s.uniform3fv(this.addr, e), Di(t, e));
    }
  }
  function x1(s, e) {
    let t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) &&
        (s.uniform4f(this.addr, e.x, e.y, e.z, e.w),
        (t[0] = e.x),
        (t[1] = e.y),
        (t[2] = e.z),
        (t[3] = e.w));
    else {
      if (Ii(t, e)) return;
      (s.uniform4fv(this.addr, e), Di(t, e));
    }
  }
  function y1(s, e) {
    let t = this.cache,
      i = e.elements;
    if (i === void 0) {
      if (Ii(t, e)) return;
      (s.uniformMatrix2fv(this.addr, !1, e), Di(t, e));
    } else {
      if (Ii(t, i)) return;
      (Fy.set(i), s.uniformMatrix2fv(this.addr, !1, Fy), Di(t, i));
    }
  }
  function b1(s, e) {
    let t = this.cache,
      i = e.elements;
    if (i === void 0) {
      if (Ii(t, e)) return;
      (s.uniformMatrix3fv(this.addr, !1, e), Di(t, e));
    } else {
      if (Ii(t, i)) return;
      (Ny.set(i), s.uniformMatrix3fv(this.addr, !1, Ny), Di(t, i));
    }
  }
  function S1(s, e) {
    let t = this.cache,
      i = e.elements;
    if (i === void 0) {
      if (Ii(t, e)) return;
      (s.uniformMatrix4fv(this.addr, !1, e), Di(t, e));
    } else {
      if (Ii(t, i)) return;
      (Oy.set(i), s.uniformMatrix4fv(this.addr, !1, Oy), Di(t, i));
    }
  }
  function E1(s, e) {
    let t = this.cache;
    t[0] !== e && (s.uniform1i(this.addr, e), (t[0] = e));
  }
  function T1(s, e) {
    let t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y) &&
        (s.uniform2i(this.addr, e.x, e.y), (t[0] = e.x), (t[1] = e.y));
    else {
      if (Ii(t, e)) return;
      (s.uniform2iv(this.addr, e), Di(t, e));
    }
  }
  function M1(s, e) {
    let t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) &&
        (s.uniform3i(this.addr, e.x, e.y, e.z),
        (t[0] = e.x),
        (t[1] = e.y),
        (t[2] = e.z));
    else {
      if (Ii(t, e)) return;
      (s.uniform3iv(this.addr, e), Di(t, e));
    }
  }
  function w1(s, e) {
    let t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) &&
        (s.uniform4i(this.addr, e.x, e.y, e.z, e.w),
        (t[0] = e.x),
        (t[1] = e.y),
        (t[2] = e.z),
        (t[3] = e.w));
    else {
      if (Ii(t, e)) return;
      (s.uniform4iv(this.addr, e), Di(t, e));
    }
  }
  function A1(s, e) {
    let t = this.cache;
    t[0] !== e && (s.uniform1ui(this.addr, e), (t[0] = e));
  }
  function R1(s, e) {
    let t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y) &&
        (s.uniform2ui(this.addr, e.x, e.y), (t[0] = e.x), (t[1] = e.y));
    else {
      if (Ii(t, e)) return;
      (s.uniform2uiv(this.addr, e), Di(t, e));
    }
  }
  function C1(s, e) {
    let t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) &&
        (s.uniform3ui(this.addr, e.x, e.y, e.z),
        (t[0] = e.x),
        (t[1] = e.y),
        (t[2] = e.z));
    else {
      if (Ii(t, e)) return;
      (s.uniform3uiv(this.addr, e), Di(t, e));
    }
  }
  function P1(s, e) {
    let t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) &&
        (s.uniform4ui(this.addr, e.x, e.y, e.z, e.w),
        (t[0] = e.x),
        (t[1] = e.y),
        (t[2] = e.z),
        (t[3] = e.w));
    else {
      if (Ii(t, e)) return;
      (s.uniform4uiv(this.addr, e), Di(t, e));
    }
  }
  function L1(s, e, t) {
    let i = this.cache,
      n = t.allocateTextureUnit();
    i[0] !== n && (s.uniform1i(this.addr, n), (i[0] = n));
    let r;
    (this.type === s.SAMPLER_2D_SHADOW
      ? ((Pg.compareFunction = t.isReversedDepthBuffer() ? kd : Bd), (r = Pg))
      : (r = jy),
      t.setTexture2D(e || r, n));
  }
  function I1(s, e, t) {
    let i = this.cache,
      n = t.allocateTextureUnit();
    (i[0] !== n && (s.uniform1i(this.addr, n), (i[0] = n)),
      t.setTexture3D(e || Qy, n));
  }
  function D1(s, e, t) {
    let i = this.cache,
      n = t.allocateTextureUnit();
    (i[0] !== n && (s.uniform1i(this.addr, n), (i[0] = n)),
      t.setTextureCube(e || eb, n));
  }
  function O1(s, e, t) {
    let i = this.cache,
      n = t.allocateTextureUnit();
    (i[0] !== n && (s.uniform1i(this.addr, n), (i[0] = n)),
      t.setTexture2DArray(e || Jy, n));
  }
  function N1(s) {
    switch (s) {
      case 5126:
        return g1;
      case 35664:
        return _1;
      case 35665:
        return v1;
      case 35666:
        return x1;
      case 35674:
        return y1;
      case 35675:
        return b1;
      case 35676:
        return S1;
      case 5124:
      case 35670:
        return E1;
      case 35667:
      case 35671:
        return T1;
      case 35668:
      case 35672:
        return M1;
      case 35669:
      case 35673:
        return w1;
      case 5125:
        return A1;
      case 36294:
        return R1;
      case 36295:
        return C1;
      case 36296:
        return P1;
      case 35678:
      case 36198:
      case 36298:
      case 36306:
      case 35682:
        return L1;
      case 35679:
      case 36299:
      case 36307:
        return I1;
      case 35680:
      case 36300:
      case 36308:
      case 36293:
        return D1;
      case 36289:
      case 36303:
      case 36311:
      case 36292:
        return O1;
    }
  }
  function F1(s, e) {
    s.uniform1fv(this.addr, e);
  }
  function U1(s, e) {
    let t = ul(e, this.size, 2);
    s.uniform2fv(this.addr, t);
  }
  function B1(s, e) {
    let t = ul(e, this.size, 3);
    s.uniform3fv(this.addr, t);
  }
  function k1(s, e) {
    let t = ul(e, this.size, 4);
    s.uniform4fv(this.addr, t);
  }
  function H1(s, e) {
    let t = ul(e, this.size, 4);
    s.uniformMatrix2fv(this.addr, !1, t);
  }
  function z1(s, e) {
    let t = ul(e, this.size, 9);
    s.uniformMatrix3fv(this.addr, !1, t);
  }
  function V1(s, e) {
    let t = ul(e, this.size, 16);
    s.uniformMatrix4fv(this.addr, !1, t);
  }
  function G1(s, e) {
    s.uniform1iv(this.addr, e);
  }
  function W1(s, e) {
    s.uniform2iv(this.addr, e);
  }
  function X1(s, e) {
    s.uniform3iv(this.addr, e);
  }
  function Y1(s, e) {
    s.uniform4iv(this.addr, e);
  }
  function q1(s, e) {
    s.uniform1uiv(this.addr, e);
  }
  function Z1(s, e) {
    s.uniform2uiv(this.addr, e);
  }
  function K1(s, e) {
    s.uniform3uiv(this.addr, e);
  }
  function $1(s, e) {
    s.uniform4uiv(this.addr, e);
  }
  function j1(s, e, t) {
    let i = this.cache,
      n = e.length,
      r = Wd(t, n);
    Ii(i, r) || (s.uniform1iv(this.addr, r), Di(i, r));
    let o;
    this.type === s.SAMPLER_2D_SHADOW ? (o = Pg) : (o = jy);
    for (let a = 0; a !== n; ++a) t.setTexture2D(e[a] || o, r[a]);
  }
  function J1(s, e, t) {
    let i = this.cache,
      n = e.length,
      r = Wd(t, n);
    Ii(i, r) || (s.uniform1iv(this.addr, r), Di(i, r));
    for (let o = 0; o !== n; ++o) t.setTexture3D(e[o] || Qy, r[o]);
  }
  function Q1(s, e, t) {
    let i = this.cache,
      n = e.length,
      r = Wd(t, n);
    Ii(i, r) || (s.uniform1iv(this.addr, r), Di(i, r));
    for (let o = 0; o !== n; ++o) t.setTextureCube(e[o] || eb, r[o]);
  }
  function eR(s, e, t) {
    let i = this.cache,
      n = e.length,
      r = Wd(t, n);
    Ii(i, r) || (s.uniform1iv(this.addr, r), Di(i, r));
    for (let o = 0; o !== n; ++o) t.setTexture2DArray(e[o] || Jy, r[o]);
  }
  function tR(s) {
    switch (s) {
      case 5126:
        return F1;
      case 35664:
        return U1;
      case 35665:
        return B1;
      case 35666:
        return k1;
      case 35674:
        return H1;
      case 35675:
        return z1;
      case 35676:
        return V1;
      case 5124:
      case 35670:
        return G1;
      case 35667:
      case 35671:
        return W1;
      case 35668:
      case 35672:
        return X1;
      case 35669:
      case 35673:
        return Y1;
      case 5125:
        return q1;
      case 36294:
        return Z1;
      case 36295:
        return K1;
      case 36296:
        return $1;
      case 35678:
      case 36198:
      case 36298:
      case 36306:
      case 35682:
        return j1;
      case 35679:
      case 36299:
      case 36307:
        return J1;
      case 35680:
      case 36300:
      case 36308:
      case 36293:
        return Q1;
      case 36289:
      case 36303:
      case 36311:
      case 36292:
        return eR;
    }
  }
  var Lg = class {
      constructor(e, t, i) {
        ((this.id = e),
          (this.addr = i),
          (this.cache = []),
          (this.type = t.type),
          (this.setValue = N1(t.type)));
      }
    },
    Ig = class {
      constructor(e, t, i) {
        ((this.id = e),
          (this.addr = i),
          (this.cache = []),
          (this.type = t.type),
          (this.size = t.size),
          (this.setValue = tR(t.type)));
      }
    },
    Dg = class {
      constructor(e) {
        ((this.id = e), (this.seq = []), (this.map = {}));
      }
      setValue(e, t, i) {
        let n = this.seq;
        for (let r = 0, o = n.length; r !== o; ++r) {
          let a = n[r];
          a.setValue(e, t[a.id], i);
        }
      }
    },
    Rg = /(\w+)(\])?(\[|\.)?/g;
  function Uy(s, e) {
    (s.seq.push(e), (s.map[e.id] = e));
  }
  function iR(s, e, t) {
    let i = s.name,
      n = i.length;
    for (Rg.lastIndex = 0; ; ) {
      let r = Rg.exec(i),
        o = Rg.lastIndex,
        a = r[1],
        l = r[2] === ']',
        c = r[3];
      if ((l && (a = a | 0), c === void 0 || (c === '[' && o + 2 === n))) {
        Uy(t, c === void 0 ? new Lg(a, s, e) : new Ig(a, s, e));
        break;
      } else {
        let f = t.map[a];
        (f === void 0 && ((f = new Dg(a)), Uy(t, f)), (t = f));
      }
    }
  }
  var ll = class {
    constructor(e, t) {
      ((this.seq = []), (this.map = {}));
      let i = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
      for (let o = 0; o < i; ++o) {
        let a = e.getActiveUniform(t, o),
          l = e.getUniformLocation(t, a.name);
        iR(a, l, this);
      }
      let n = [],
        r = [];
      for (let o of this.seq)
        o.type === e.SAMPLER_2D_SHADOW ||
        o.type === e.SAMPLER_CUBE_SHADOW ||
        o.type === e.SAMPLER_2D_ARRAY_SHADOW
          ? n.push(o)
          : r.push(o);
      n.length > 0 && (this.seq = n.concat(r));
    }
    setValue(e, t, i, n) {
      let r = this.map[t];
      r !== void 0 && r.setValue(e, i, n);
    }
    setOptional(e, t, i) {
      let n = t[i];
      n !== void 0 && this.setValue(e, i, n);
    }
    static upload(e, t, i, n) {
      for (let r = 0, o = t.length; r !== o; ++r) {
        let a = t[r],
          l = i[a.id];
        l.needsUpdate !== !1 && a.setValue(e, l.value, n);
      }
    }
    static seqWithValue(e, t) {
      let i = [];
      for (let n = 0, r = e.length; n !== r; ++n) {
        let o = e[n];
        o.id in t && i.push(o);
      }
      return i;
    }
  };
  function By(s, e, t) {
    let i = s.createShader(e);
    return (s.shaderSource(i, t), s.compileShader(i), i);
  }
  var nR = 37297,
    sR = 0;
  function rR(s, e) {
    let t = s.split(`
`),
      i = [],
      n = Math.max(e - 6, 0),
      r = Math.min(e + 6, t.length);
    for (let o = n; o < r; o++) {
      let a = o + 1;
      i.push(`${a === e ? '>' : ' '} ${a}: ${t[o]}`);
    }
    return i.join(`
`);
  }
  var ky = new St();
  function oR(s) {
    Ct._getMatrix(ky, Ct.workingColorSpace, s);
    let e = `mat3( ${ky.elements.map((t) => t.toFixed(4))} )`;
    switch (Ct.getTransfer(s)) {
      case dc:
        return [e, 'LinearTransferOETF'];
      case Kt:
        return [e, 'sRGBTransferOETF'];
      default:
        return (
          it('WebGLProgram: Unsupported color space: ', s),
          [e, 'LinearTransferOETF']
        );
    }
  }
  function Hy(s, e, t) {
    let i = s.getShaderParameter(e, s.COMPILE_STATUS),
      r = (s.getShaderInfoLog(e) || '').trim();
    if (i && r === '') return '';
    let o = /ERROR: 0:(\d+)/.exec(r);
    if (o) {
      let a = parseInt(o[1]);
      return (
        t.toUpperCase() +
        `

` +
        r +
        `

` +
        rR(s.getShaderSource(e), a)
      );
    } else return r;
  }
  function aR(s, e) {
    let t = oR(e);
    return [
      `vec4 ${s}( vec4 value ) {`,
      `	return ${t[1]}( vec4( value.rgb * ${t[0]}, value.a ) );`,
      '}',
    ].join(`
`);
  }
  var lR = {
    [Jm]: 'Linear',
    [Qm]: 'Reinhard',
    [eg]: 'Cineon',
    [tg]: 'ACESFilmic',
    [ng]: 'AgX',
    [sg]: 'Neutral',
    [ig]: 'Custom',
  };
  function cR(s, e) {
    let t = lR[e];
    return t === void 0
      ? (it('WebGLProgram: Unsupported toneMapping:', e),
        'vec3 ' + s + '( vec3 color ) { return LinearToneMapping( color ); }')
      : 'vec3 ' +
          s +
          '( vec3 color ) { return ' +
          t +
          'ToneMapping( color ); }';
  }
  var zd = new te();
  function hR() {
    Ct.getLuminanceCoefficients(zd);
    let s = zd.x.toFixed(4),
      e = zd.y.toFixed(4),
      t = zd.z.toFixed(4);
    return [
      'float luminance( const in vec3 rgb ) {',
      `	const vec3 weights = vec3( ${s}, ${e}, ${t} );`,
      '	return dot( weights, rgb );',
      '}',
    ].join(`
`);
  }
  function uR(s) {
    return [
      s.extensionClipCullDistance
        ? '#extension GL_ANGLE_clip_cull_distance : require'
        : '',
      s.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : '',
    ].filter(qc).join(`
`);
  }
  function dR(s) {
    let e = [];
    for (let t in s) {
      let i = s[t];
      i !== !1 && e.push('#define ' + t + ' ' + i);
    }
    return e.join(`
`);
  }
  function fR(s, e) {
    let t = {},
      i = s.getProgramParameter(e, s.ACTIVE_ATTRIBUTES);
    for (let n = 0; n < i; n++) {
      let r = s.getActiveAttrib(e, n),
        o = r.name,
        a = 1;
      (r.type === s.FLOAT_MAT2 && (a = 2),
        r.type === s.FLOAT_MAT3 && (a = 3),
        r.type === s.FLOAT_MAT4 && (a = 4),
        (t[o] = {
          type: r.type,
          location: s.getAttribLocation(e, o),
          locationSize: a,
        }));
    }
    return t;
  }
  function qc(s) {
    return s !== '';
  }
  function zy(s, e) {
    let t =
      e.numSpotLightShadows +
      e.numSpotLightMaps -
      e.numSpotLightShadowsWithMaps;
    return s
      .replace(/NUM_DIR_LIGHTS/g, e.numDirLights)
      .replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights)
      .replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps)
      .replace(/NUM_SPOT_LIGHT_COORDS/g, t)
      .replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights)
      .replace(/NUM_POINT_LIGHTS/g, e.numPointLights)
      .replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights)
      .replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows)
      .replace(
        /NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g,
        e.numSpotLightShadowsWithMaps,
      )
      .replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows)
      .replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
  }
  function Vy(s, e) {
    return s
      .replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes)
      .replace(
        /UNION_CLIPPING_PLANES/g,
        e.numClippingPlanes - e.numClipIntersection,
      );
  }
  var pR = /^[ \t]*#include +<([\w\d./]+)>/gm;
  function Og(s) {
    return s.replace(pR, gR);
  }
  var mR = new Map();
  function gR(s, e) {
    let t = Pt[e];
    if (t === void 0) {
      let i = mR.get(e);
      if (i !== void 0)
        ((t = Pt[i]),
          it(
            'WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.',
            e,
            i,
          ));
      else throw new Error('Can not resolve #include <' + e + '>');
    }
    return Og(t);
  }
  var _R =
    /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
  function Gy(s) {
    return s.replace(_R, vR);
  }
  function vR(s, e, t, i) {
    let n = '';
    for (let r = parseInt(e); r < parseInt(t); r++)
      n += i
        .replace(/\[\s*i\s*\]/g, '[ ' + r + ' ]')
        .replace(/UNROLLED_LOOP_INDEX/g, r);
    return n;
  }
  function Wy(s) {
    let e = `precision ${s.precision} float;
	precision ${s.precision} int;
	precision ${s.precision} sampler2D;
	precision ${s.precision} samplerCube;
	precision ${s.precision} sampler3D;
	precision ${s.precision} sampler2DArray;
	precision ${s.precision} sampler2DShadow;
	precision ${s.precision} samplerCubeShadow;
	precision ${s.precision} sampler2DArrayShadow;
	precision ${s.precision} isampler2D;
	precision ${s.precision} isampler3D;
	precision ${s.precision} isamplerCube;
	precision ${s.precision} isampler2DArray;
	precision ${s.precision} usampler2D;
	precision ${s.precision} usampler3D;
	precision ${s.precision} usamplerCube;
	precision ${s.precision} usampler2DArray;
	`;
    return (
      s.precision === 'highp'
        ? (e += `
#define HIGH_PRECISION`)
        : s.precision === 'mediump'
          ? (e += `
#define MEDIUM_PRECISION`)
          : s.precision === 'lowp' &&
            (e += `
#define LOW_PRECISION`),
      e
    );
  }
  var xR = { [Nc]: 'SHADOWMAP_TYPE_PCF', [tl]: 'SHADOWMAP_TYPE_VSM' };
  function yR(s) {
    return xR[s.shadowMapType] || 'SHADOWMAP_TYPE_BASIC';
  }
  var bR = {
    [oo]: 'ENVMAP_TYPE_CUBE',
    [Jo]: 'ENVMAP_TYPE_CUBE',
    [Uc]: 'ENVMAP_TYPE_CUBE_UV',
  };
  function SR(s) {
    return s.envMap === !1
      ? 'ENVMAP_TYPE_CUBE'
      : bR[s.envMapMode] || 'ENVMAP_TYPE_CUBE';
  }
  var ER = { [Jo]: 'ENVMAP_MODE_REFRACTION' };
  function TR(s) {
    return s.envMap === !1
      ? 'ENVMAP_MODE_REFLECTION'
      : ER[s.envMapMode] || 'ENVMAP_MODE_REFLECTION';
  }
  var MR = {
    [jm]: 'ENVMAP_BLENDING_MULTIPLY',
    [ay]: 'ENVMAP_BLENDING_MIX',
    [ly]: 'ENVMAP_BLENDING_ADD',
  };
  function wR(s) {
    return s.envMap === !1
      ? 'ENVMAP_BLENDING_NONE'
      : MR[s.combine] || 'ENVMAP_BLENDING_NONE';
  }
  function AR(s) {
    let e = s.envMapCubeUVHeight;
    if (e === null) return null;
    let t = Math.log2(e) - 2,
      i = 1 / e;
    return {
      texelWidth: 1 / (3 * Math.max(Math.pow(2, t), 112)),
      texelHeight: i,
      maxMip: t,
    };
  }
  function RR(s, e, t, i) {
    let n = s.getContext(),
      r = t.defines,
      o = t.vertexShader,
      a = t.fragmentShader,
      l = yR(t),
      c = SR(t),
      u = TR(t),
      f = wR(t),
      d = AR(t),
      p = uR(t),
      _ = dR(r),
      x = n.createProgram(),
      g,
      v,
      w = t.glslVersion
        ? '#version ' +
          t.glslVersion +
          `
`
        : '';
    (t.isRawShaderMaterial
      ? ((g = [
          '#define SHADER_TYPE ' + t.shaderType,
          '#define SHADER_NAME ' + t.shaderName,
          _,
        ].filter(qc).join(`
`)),
        g.length > 0 &&
          (g += `
`),
        (v = [
          '#define SHADER_TYPE ' + t.shaderType,
          '#define SHADER_NAME ' + t.shaderName,
          _,
        ].filter(qc).join(`
`)),
        v.length > 0 &&
          (v += `
`))
      : ((g = [
          Wy(t),
          '#define SHADER_TYPE ' + t.shaderType,
          '#define SHADER_NAME ' + t.shaderName,
          _,
          t.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
          t.batching ? '#define USE_BATCHING' : '',
          t.batchingColor ? '#define USE_BATCHING_COLOR' : '',
          t.instancing ? '#define USE_INSTANCING' : '',
          t.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
          t.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
          t.useFog && t.fog ? '#define USE_FOG' : '',
          t.useFog && t.fogExp2 ? '#define FOG_EXP2' : '',
          t.map ? '#define USE_MAP' : '',
          t.envMap ? '#define USE_ENVMAP' : '',
          t.envMap ? '#define ' + u : '',
          t.lightMap ? '#define USE_LIGHTMAP' : '',
          t.aoMap ? '#define USE_AOMAP' : '',
          t.bumpMap ? '#define USE_BUMPMAP' : '',
          t.normalMap ? '#define USE_NORMALMAP' : '',
          t.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
          t.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
          t.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
          t.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
          t.anisotropy ? '#define USE_ANISOTROPY' : '',
          t.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
          t.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
          t.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
          t.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
          t.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
          t.iridescenceThicknessMap
            ? '#define USE_IRIDESCENCE_THICKNESSMAP'
            : '',
          t.specularMap ? '#define USE_SPECULARMAP' : '',
          t.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
          t.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
          t.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
          t.metalnessMap ? '#define USE_METALNESSMAP' : '',
          t.alphaMap ? '#define USE_ALPHAMAP' : '',
          t.alphaHash ? '#define USE_ALPHAHASH' : '',
          t.transmission ? '#define USE_TRANSMISSION' : '',
          t.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
          t.thicknessMap ? '#define USE_THICKNESSMAP' : '',
          t.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
          t.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
          t.mapUv ? '#define MAP_UV ' + t.mapUv : '',
          t.alphaMapUv ? '#define ALPHAMAP_UV ' + t.alphaMapUv : '',
          t.lightMapUv ? '#define LIGHTMAP_UV ' + t.lightMapUv : '',
          t.aoMapUv ? '#define AOMAP_UV ' + t.aoMapUv : '',
          t.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + t.emissiveMapUv : '',
          t.bumpMapUv ? '#define BUMPMAP_UV ' + t.bumpMapUv : '',
          t.normalMapUv ? '#define NORMALMAP_UV ' + t.normalMapUv : '',
          t.displacementMapUv
            ? '#define DISPLACEMENTMAP_UV ' + t.displacementMapUv
            : '',
          t.metalnessMapUv ? '#define METALNESSMAP_UV ' + t.metalnessMapUv : '',
          t.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + t.roughnessMapUv : '',
          t.anisotropyMapUv
            ? '#define ANISOTROPYMAP_UV ' + t.anisotropyMapUv
            : '',
          t.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + t.clearcoatMapUv : '',
          t.clearcoatNormalMapUv
            ? '#define CLEARCOAT_NORMALMAP_UV ' + t.clearcoatNormalMapUv
            : '',
          t.clearcoatRoughnessMapUv
            ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + t.clearcoatRoughnessMapUv
            : '',
          t.iridescenceMapUv
            ? '#define IRIDESCENCEMAP_UV ' + t.iridescenceMapUv
            : '',
          t.iridescenceThicknessMapUv
            ? '#define IRIDESCENCE_THICKNESSMAP_UV ' +
              t.iridescenceThicknessMapUv
            : '',
          t.sheenColorMapUv
            ? '#define SHEEN_COLORMAP_UV ' + t.sheenColorMapUv
            : '',
          t.sheenRoughnessMapUv
            ? '#define SHEEN_ROUGHNESSMAP_UV ' + t.sheenRoughnessMapUv
            : '',
          t.specularMapUv ? '#define SPECULARMAP_UV ' + t.specularMapUv : '',
          t.specularColorMapUv
            ? '#define SPECULAR_COLORMAP_UV ' + t.specularColorMapUv
            : '',
          t.specularIntensityMapUv
            ? '#define SPECULAR_INTENSITYMAP_UV ' + t.specularIntensityMapUv
            : '',
          t.transmissionMapUv
            ? '#define TRANSMISSIONMAP_UV ' + t.transmissionMapUv
            : '',
          t.thicknessMapUv ? '#define THICKNESSMAP_UV ' + t.thicknessMapUv : '',
          t.vertexTangents && t.flatShading === !1 ? '#define USE_TANGENT' : '',
          t.vertexNormals ? '#define HAS_NORMAL' : '',
          t.vertexColors ? '#define USE_COLOR' : '',
          t.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
          t.vertexUv1s ? '#define USE_UV1' : '',
          t.vertexUv2s ? '#define USE_UV2' : '',
          t.vertexUv3s ? '#define USE_UV3' : '',
          t.pointsUvs ? '#define USE_POINTS_UV' : '',
          t.flatShading ? '#define FLAT_SHADED' : '',
          t.skinning ? '#define USE_SKINNING' : '',
          t.morphTargets ? '#define USE_MORPHTARGETS' : '',
          t.morphNormals && t.flatShading === !1
            ? '#define USE_MORPHNORMALS'
            : '',
          t.morphColors ? '#define USE_MORPHCOLORS' : '',
          t.morphTargetsCount > 0
            ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + t.morphTextureStride
            : '',
          t.morphTargetsCount > 0
            ? '#define MORPHTARGETS_COUNT ' + t.morphTargetsCount
            : '',
          t.doubleSided ? '#define DOUBLE_SIDED' : '',
          t.flipSided ? '#define FLIP_SIDED' : '',
          t.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
          t.shadowMapEnabled ? '#define ' + l : '',
          t.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
          t.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
          t.logarithmicDepthBuffer
            ? '#define USE_LOGARITHMIC_DEPTH_BUFFER'
            : '',
          t.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
          'uniform mat4 modelMatrix;',
          'uniform mat4 modelViewMatrix;',
          'uniform mat4 projectionMatrix;',
          'uniform mat4 viewMatrix;',
          'uniform mat3 normalMatrix;',
          'uniform vec3 cameraPosition;',
          'uniform bool isOrthographic;',
          '#ifdef USE_INSTANCING',
          '	attribute mat4 instanceMatrix;',
          '#endif',
          '#ifdef USE_INSTANCING_COLOR',
          '	attribute vec3 instanceColor;',
          '#endif',
          '#ifdef USE_INSTANCING_MORPH',
          '	uniform sampler2D morphTexture;',
          '#endif',
          'attribute vec3 position;',
          'attribute vec3 normal;',
          'attribute vec2 uv;',
          '#ifdef USE_UV1',
          '	attribute vec2 uv1;',
          '#endif',
          '#ifdef USE_UV2',
          '	attribute vec2 uv2;',
          '#endif',
          '#ifdef USE_UV3',
          '	attribute vec2 uv3;',
          '#endif',
          '#ifdef USE_TANGENT',
          '	attribute vec4 tangent;',
          '#endif',
          '#if defined( USE_COLOR_ALPHA )',
          '	attribute vec4 color;',
          '#elif defined( USE_COLOR )',
          '	attribute vec3 color;',
          '#endif',
          '#ifdef USE_SKINNING',
          '	attribute vec4 skinIndex;',
          '	attribute vec4 skinWeight;',
          '#endif',
          `
`,
        ].filter(qc).join(`
`)),
        (v = [
          Wy(t),
          '#define SHADER_TYPE ' + t.shaderType,
          '#define SHADER_NAME ' + t.shaderName,
          _,
          t.useFog && t.fog ? '#define USE_FOG' : '',
          t.useFog && t.fogExp2 ? '#define FOG_EXP2' : '',
          t.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
          t.map ? '#define USE_MAP' : '',
          t.matcap ? '#define USE_MATCAP' : '',
          t.envMap ? '#define USE_ENVMAP' : '',
          t.envMap ? '#define ' + c : '',
          t.envMap ? '#define ' + u : '',
          t.envMap ? '#define ' + f : '',
          d ? '#define CUBEUV_TEXEL_WIDTH ' + d.texelWidth : '',
          d ? '#define CUBEUV_TEXEL_HEIGHT ' + d.texelHeight : '',
          d ? '#define CUBEUV_MAX_MIP ' + d.maxMip + '.0' : '',
          t.lightMap ? '#define USE_LIGHTMAP' : '',
          t.aoMap ? '#define USE_AOMAP' : '',
          t.bumpMap ? '#define USE_BUMPMAP' : '',
          t.normalMap ? '#define USE_NORMALMAP' : '',
          t.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
          t.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
          t.packedNormalMap ? '#define USE_PACKED_NORMALMAP' : '',
          t.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
          t.anisotropy ? '#define USE_ANISOTROPY' : '',
          t.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
          t.clearcoat ? '#define USE_CLEARCOAT' : '',
          t.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
          t.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
          t.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
          t.dispersion ? '#define USE_DISPERSION' : '',
          t.iridescence ? '#define USE_IRIDESCENCE' : '',
          t.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
          t.iridescenceThicknessMap
            ? '#define USE_IRIDESCENCE_THICKNESSMAP'
            : '',
          t.specularMap ? '#define USE_SPECULARMAP' : '',
          t.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
          t.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
          t.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
          t.metalnessMap ? '#define USE_METALNESSMAP' : '',
          t.alphaMap ? '#define USE_ALPHAMAP' : '',
          t.alphaTest ? '#define USE_ALPHATEST' : '',
          t.alphaHash ? '#define USE_ALPHAHASH' : '',
          t.sheen ? '#define USE_SHEEN' : '',
          t.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
          t.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
          t.transmission ? '#define USE_TRANSMISSION' : '',
          t.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
          t.thicknessMap ? '#define USE_THICKNESSMAP' : '',
          t.vertexTangents && t.flatShading === !1 ? '#define USE_TANGENT' : '',
          t.vertexColors || t.instancingColor ? '#define USE_COLOR' : '',
          t.vertexAlphas || t.batchingColor ? '#define USE_COLOR_ALPHA' : '',
          t.vertexUv1s ? '#define USE_UV1' : '',
          t.vertexUv2s ? '#define USE_UV2' : '',
          t.vertexUv3s ? '#define USE_UV3' : '',
          t.pointsUvs ? '#define USE_POINTS_UV' : '',
          t.gradientMap ? '#define USE_GRADIENTMAP' : '',
          t.flatShading ? '#define FLAT_SHADED' : '',
          t.doubleSided ? '#define DOUBLE_SIDED' : '',
          t.flipSided ? '#define FLIP_SIDED' : '',
          t.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
          t.shadowMapEnabled ? '#define ' + l : '',
          t.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
          t.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
          t.numLightProbeGrids > 0 ? '#define USE_LIGHT_PROBES_GRID' : '',
          t.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
          t.decodeVideoTextureEmissive
            ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE'
            : '',
          t.logarithmicDepthBuffer
            ? '#define USE_LOGARITHMIC_DEPTH_BUFFER'
            : '',
          t.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
          'uniform mat4 viewMatrix;',
          'uniform vec3 cameraPosition;',
          'uniform bool isOrthographic;',
          t.toneMapping !== ws ? '#define TONE_MAPPING' : '',
          t.toneMapping !== ws ? Pt.tonemapping_pars_fragment : '',
          t.toneMapping !== ws ? cR('toneMapping', t.toneMapping) : '',
          t.dithering ? '#define DITHERING' : '',
          t.opaque ? '#define OPAQUE' : '',
          Pt.colorspace_pars_fragment,
          aR('linearToOutputTexel', t.outputColorSpace),
          hR(),
          t.useDepthPacking ? '#define DEPTH_PACKING ' + t.depthPacking : '',
          `
`,
        ].filter(qc).join(`
`))),
      (o = Og(o)),
      (o = zy(o, t)),
      (o = Vy(o, t)),
      (a = Og(a)),
      (a = zy(a, t)),
      (a = Vy(a, t)),
      (o = Gy(o)),
      (a = Gy(a)),
      t.isRawShaderMaterial !== !0 &&
        ((w = `#version 300 es
`),
        (g =
          [
            p,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture',
          ].join(`
`) +
          `
` +
          g),
        (v =
          [
            '#define varying in',
            t.glslVersion === fg
              ? ''
              : 'layout(location = 0) out highp vec4 pc_fragColor;',
            t.glslVersion === fg ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad',
          ].join(`
`) +
          `
` +
          v)));
    let L = w + g + o,
      R = w + v + a,
      U = By(n, n.VERTEX_SHADER, L),
      O = By(n, n.FRAGMENT_SHADER, R);
    (n.attachShader(x, U),
      n.attachShader(x, O),
      t.index0AttributeName !== void 0
        ? n.bindAttribLocation(x, 0, t.index0AttributeName)
        : t.morphTargets === !0 && n.bindAttribLocation(x, 0, 'position'),
      n.linkProgram(x));
    function N(W) {
      if (s.debug.checkShaderErrors) {
        let q = n.getProgramInfoLog(x) || '',
          re = n.getShaderInfoLog(U) || '',
          oe = n.getShaderInfoLog(O) || '',
          K = q.trim(),
          ie = re.trim(),
          J = oe.trim(),
          pe = !0,
          Ee = !0;
        if (n.getProgramParameter(x, n.LINK_STATUS) === !1)
          if (((pe = !1), typeof s.debug.onShaderError == 'function'))
            s.debug.onShaderError(n, x, U, O);
          else {
            let Z = Hy(n, U, 'vertex'),
              Ne = Hy(n, O, 'fragment');
            mt(
              'THREE.WebGLProgram: Shader Error ' +
                n.getError() +
                ' - VALIDATE_STATUS ' +
                n.getProgramParameter(x, n.VALIDATE_STATUS) +
                `

Material Name: ` +
                W.name +
                `
Material Type: ` +
                W.type +
                `

Program Info Log: ` +
                K +
                `
` +
                Z +
                `
` +
                Ne,
            );
          }
        else
          K !== ''
            ? it('WebGLProgram: Program Info Log:', K)
            : (ie === '' || J === '') && (Ee = !1);
        Ee &&
          (W.diagnostics = {
            runnable: pe,
            programLog: K,
            vertexShader: { log: ie, prefix: g },
            fragmentShader: { log: J, prefix: v },
          });
      }
      (n.deleteShader(U),
        n.deleteShader(O),
        (M = new ll(n, x)),
        (I = fR(n, x)));
    }
    let M;
    this.getUniforms = function () {
      return (M === void 0 && N(this), M);
    };
    let I;
    this.getAttributes = function () {
      return (I === void 0 && N(this), I);
    };
    let z = t.rendererExtensionParallelShaderCompile === !1;
    return (
      (this.isReady = function () {
        return (z === !1 && (z = n.getProgramParameter(x, nR)), z);
      }),
      (this.destroy = function () {
        (i.releaseStatesOfProgram(this),
          n.deleteProgram(x),
          (this.program = void 0));
      }),
      (this.type = t.shaderType),
      (this.name = t.shaderName),
      (this.id = sR++),
      (this.cacheKey = e),
      (this.usedTimes = 1),
      (this.program = x),
      (this.vertexShader = U),
      (this.fragmentShader = O),
      this
    );
  }
  var CR = 0,
    Ng = class {
      constructor() {
        ((this.shaderCache = new Map()), (this.materialCache = new Map()));
      }
      update(e) {
        let t = e.vertexShader,
          i = e.fragmentShader,
          n = this._getShaderStage(t),
          r = this._getShaderStage(i),
          o = this._getShaderCacheForMaterial(e);
        return (
          o.has(n) === !1 && (o.add(n), n.usedTimes++),
          o.has(r) === !1 && (o.add(r), r.usedTimes++),
          this
        );
      }
      remove(e) {
        let t = this.materialCache.get(e);
        for (let i of t)
          (i.usedTimes--, i.usedTimes === 0 && this.shaderCache.delete(i.code));
        return (this.materialCache.delete(e), this);
      }
      getVertexShaderID(e) {
        return this._getShaderStage(e.vertexShader).id;
      }
      getFragmentShaderID(e) {
        return this._getShaderStage(e.fragmentShader).id;
      }
      dispose() {
        (this.shaderCache.clear(), this.materialCache.clear());
      }
      _getShaderCacheForMaterial(e) {
        let t = this.materialCache,
          i = t.get(e);
        return (i === void 0 && ((i = new Set()), t.set(e, i)), i);
      }
      _getShaderStage(e) {
        let t = this.shaderCache,
          i = t.get(e);
        return (i === void 0 && ((i = new Fg(e)), t.set(e, i)), i);
      }
    },
    Fg = class {
      constructor(e) {
        ((this.id = CR++), (this.code = e), (this.usedTimes = 0));
      }
    };
  function PR(s) {
    return s === lo || s === Vc || s === Gc;
  }
  function LR(s, e, t, i, n, r) {
    let o = new mc(),
      a = new Ng(),
      l = new Set(),
      c = [],
      u = new Map(),
      f = i.logarithmicDepthBuffer,
      d = i.precision,
      p = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distance',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite',
      };
    function _(M) {
      return (l.add(M), M === 0 ? 'uv' : `uv${M}`);
    }
    function x(M, I, z, W, q, re) {
      let oe = W.fog,
        K = q.geometry,
        ie =
          M.isMeshStandardMaterial ||
          M.isMeshLambertMaterial ||
          M.isMeshPhongMaterial
            ? W.environment
            : null,
        J =
          M.isMeshStandardMaterial ||
          (M.isMeshLambertMaterial && !M.envMap) ||
          (M.isMeshPhongMaterial && !M.envMap),
        pe = e.get(M.envMap || ie, J),
        Ee = pe && pe.mapping === Uc ? pe.image.height : null,
        Z = p[M.type];
      M.precision !== null &&
        ((d = i.getMaxPrecision(M.precision)),
        d !== M.precision &&
          it(
            'WebGLProgram.getParameters:',
            M.precision,
            'not supported, using',
            d,
            'instead.',
          ));
      let Ne =
          K.morphAttributes.position ||
          K.morphAttributes.normal ||
          K.morphAttributes.color,
        Be = Ne !== void 0 ? Ne.length : 0,
        ht = 0;
      (K.morphAttributes.position !== void 0 && (ht = 1),
        K.morphAttributes.normal !== void 0 && (ht = 2),
        K.morphAttributes.color !== void 0 && (ht = 3));
      let ot, tt, ve, Pe;
      if (Z) {
        let S = ir[Z];
        ((ot = S.vertexShader), (tt = S.fragmentShader));
      } else
        ((ot = M.vertexShader),
          (tt = M.fragmentShader),
          a.update(M),
          (ve = a.getVertexShaderID(M)),
          (Pe = a.getFragmentShaderID(M)));
      let Ae = s.getRenderTarget(),
        Ze = s.state.buffers.depth.getReversed(),
        nt = q.isInstancedMesh === !0,
        Le = q.isBatchedMesh === !0,
        At = !!M.map,
        Ke = !!M.matcap,
        ut = !!pe,
        Tt = !!M.aoMap,
        at = !!M.lightMap,
        ue = !!M.bumpMap,
        Rt = !!M.normalMap,
        ti = !!M.displacementMap,
        ee = !!M.emissiveMap,
        xt = !!M.metalnessMap,
        _t = !!M.roughnessMap,
        Ut = M.anisotropy > 0,
        Ue = M.clearcoat > 0,
        bt = M.dispersion > 0,
        H = M.iridescence > 0,
        C = M.sheen > 0,
        se = M.transmission > 0,
        _e = Ut && !!M.anisotropyMap,
        we = Ue && !!M.clearcoatMap,
        Oe = Ue && !!M.clearcoatNormalMap,
        Re = Ue && !!M.clearcoatRoughnessMap,
        ge = H && !!M.iridescenceMap,
        be = H && !!M.iridescenceThicknessMap,
        ke = C && !!M.sheenColorMap,
        Ve = C && !!M.sheenRoughnessMap,
        Te = !!M.specularMap,
        Ie = !!M.specularColorMap,
        Fe = !!M.specularIntensityMap,
        rt = se && !!M.transmissionMap,
        vt = se && !!M.thicknessMap,
        j = !!M.gradientMap,
        Ce = !!M.alphaMap,
        ye = M.alphaTest > 0,
        D = !!M.alphaHash,
        h = !!M.extensions,
        m = ws;
      M.toneMapped &&
        (Ae === null || Ae.isXRRenderTarget === !0) &&
        (m = s.toneMapping);
      let b = {
        shaderID: Z,
        shaderType: M.type,
        shaderName: M.name,
        vertexShader: ot,
        fragmentShader: tt,
        defines: M.defines,
        customVertexShaderID: ve,
        customFragmentShaderID: Pe,
        isRawShaderMaterial: M.isRawShaderMaterial === !0,
        glslVersion: M.glslVersion,
        precision: d,
        batching: Le,
        batchingColor: Le && q._colorsTexture !== null,
        instancing: nt,
        instancingColor: nt && q.instanceColor !== null,
        instancingMorph: nt && q.morphTexture !== null,
        outputColorSpace:
          Ae === null
            ? s.outputColorSpace
            : Ae.isXRRenderTarget === !0
              ? Ae.texture.colorSpace
              : Ct.workingColorSpace,
        alphaToCoverage: !!M.alphaToCoverage,
        map: At,
        matcap: Ke,
        envMap: ut,
        envMapMode: ut && pe.mapping,
        envMapCubeUVHeight: Ee,
        aoMap: Tt,
        lightMap: at,
        bumpMap: ue,
        normalMap: Rt,
        displacementMap: ti,
        emissiveMap: ee,
        normalMapObjectSpace: Rt && M.normalMapType === dy,
        normalMapTangentSpace: Rt && M.normalMapType === Ud,
        packedNormalMap: Rt && M.normalMapType === Ud && PR(M.normalMap.format),
        metalnessMap: xt,
        roughnessMap: _t,
        anisotropy: Ut,
        anisotropyMap: _e,
        clearcoat: Ue,
        clearcoatMap: we,
        clearcoatNormalMap: Oe,
        clearcoatRoughnessMap: Re,
        dispersion: bt,
        iridescence: H,
        iridescenceMap: ge,
        iridescenceThicknessMap: be,
        sheen: C,
        sheenColorMap: ke,
        sheenRoughnessMap: Ve,
        specularMap: Te,
        specularColorMap: Ie,
        specularIntensityMap: Fe,
        transmission: se,
        transmissionMap: rt,
        thicknessMap: vt,
        gradientMap: j,
        opaque:
          M.transparent === !1 && M.blending === Go && M.alphaToCoverage === !1,
        alphaMap: Ce,
        alphaTest: ye,
        alphaHash: D,
        combine: M.combine,
        mapUv: At && _(M.map.channel),
        aoMapUv: Tt && _(M.aoMap.channel),
        lightMapUv: at && _(M.lightMap.channel),
        bumpMapUv: ue && _(M.bumpMap.channel),
        normalMapUv: Rt && _(M.normalMap.channel),
        displacementMapUv: ti && _(M.displacementMap.channel),
        emissiveMapUv: ee && _(M.emissiveMap.channel),
        metalnessMapUv: xt && _(M.metalnessMap.channel),
        roughnessMapUv: _t && _(M.roughnessMap.channel),
        anisotropyMapUv: _e && _(M.anisotropyMap.channel),
        clearcoatMapUv: we && _(M.clearcoatMap.channel),
        clearcoatNormalMapUv: Oe && _(M.clearcoatNormalMap.channel),
        clearcoatRoughnessMapUv: Re && _(M.clearcoatRoughnessMap.channel),
        iridescenceMapUv: ge && _(M.iridescenceMap.channel),
        iridescenceThicknessMapUv: be && _(M.iridescenceThicknessMap.channel),
        sheenColorMapUv: ke && _(M.sheenColorMap.channel),
        sheenRoughnessMapUv: Ve && _(M.sheenRoughnessMap.channel),
        specularMapUv: Te && _(M.specularMap.channel),
        specularColorMapUv: Ie && _(M.specularColorMap.channel),
        specularIntensityMapUv: Fe && _(M.specularIntensityMap.channel),
        transmissionMapUv: rt && _(M.transmissionMap.channel),
        thicknessMapUv: vt && _(M.thicknessMap.channel),
        alphaMapUv: Ce && _(M.alphaMap.channel),
        vertexTangents: !!K.attributes.tangent && (Rt || Ut),
        vertexNormals: !!K.attributes.normal,
        vertexColors: M.vertexColors,
        vertexAlphas:
          M.vertexColors === !0 &&
          !!K.attributes.color &&
          K.attributes.color.itemSize === 4,
        pointsUvs: q.isPoints === !0 && !!K.attributes.uv && (At || Ce),
        fog: !!oe,
        useFog: M.fog === !0,
        fogExp2: !!oe && oe.isFogExp2,
        flatShading:
          M.wireframe === !1 &&
          (M.flatShading === !0 ||
            (K.attributes.normal === void 0 &&
              Rt === !1 &&
              (M.isMeshLambertMaterial ||
                M.isMeshPhongMaterial ||
                M.isMeshStandardMaterial ||
                M.isMeshPhysicalMaterial))),
        sizeAttenuation: M.sizeAttenuation === !0,
        logarithmicDepthBuffer: f,
        reversedDepthBuffer: Ze,
        skinning: q.isSkinnedMesh === !0,
        morphTargets: K.morphAttributes.position !== void 0,
        morphNormals: K.morphAttributes.normal !== void 0,
        morphColors: K.morphAttributes.color !== void 0,
        morphTargetsCount: Be,
        morphTextureStride: ht,
        numDirLights: I.directional.length,
        numPointLights: I.point.length,
        numSpotLights: I.spot.length,
        numSpotLightMaps: I.spotLightMap.length,
        numRectAreaLights: I.rectArea.length,
        numHemiLights: I.hemi.length,
        numDirLightShadows: I.directionalShadowMap.length,
        numPointLightShadows: I.pointShadowMap.length,
        numSpotLightShadows: I.spotShadowMap.length,
        numSpotLightShadowsWithMaps: I.numSpotLightShadowsWithMaps,
        numLightProbes: I.numLightProbes,
        numLightProbeGrids: re.length,
        numClippingPlanes: r.numPlanes,
        numClipIntersection: r.numIntersection,
        dithering: M.dithering,
        shadowMapEnabled: s.shadowMap.enabled && z.length > 0,
        shadowMapType: s.shadowMap.type,
        toneMapping: m,
        decodeVideoTexture:
          At &&
          M.map.isVideoTexture === !0 &&
          Ct.getTransfer(M.map.colorSpace) === Kt,
        decodeVideoTextureEmissive:
          ee &&
          M.emissiveMap.isVideoTexture === !0 &&
          Ct.getTransfer(M.emissiveMap.colorSpace) === Kt,
        premultipliedAlpha: M.premultipliedAlpha,
        doubleSided: M.side === Gi,
        flipSided: M.side === bn,
        useDepthPacking: M.depthPacking >= 0,
        depthPacking: M.depthPacking || 0,
        index0AttributeName: M.index0AttributeName,
        extensionClipCullDistance:
          h &&
          M.extensions.clipCullDistance === !0 &&
          t.has('WEBGL_clip_cull_distance'),
        extensionMultiDraw:
          ((h && M.extensions.multiDraw === !0) || Le) &&
          t.has('WEBGL_multi_draw'),
        rendererExtensionParallelShaderCompile: t.has(
          'KHR_parallel_shader_compile',
        ),
        customProgramCacheKey: M.customProgramCacheKey(),
      };
      return (
        (b.vertexUv1s = l.has(1)),
        (b.vertexUv2s = l.has(2)),
        (b.vertexUv3s = l.has(3)),
        l.clear(),
        b
      );
    }
    function g(M) {
      let I = [];
      if (
        (M.shaderID
          ? I.push(M.shaderID)
          : (I.push(M.customVertexShaderID), I.push(M.customFragmentShaderID)),
        M.defines !== void 0)
      )
        for (let z in M.defines) (I.push(z), I.push(M.defines[z]));
      return (
        M.isRawShaderMaterial === !1 &&
          (v(I, M), w(I, M), I.push(s.outputColorSpace)),
        I.push(M.customProgramCacheKey),
        I.join()
      );
    }
    function v(M, I) {
      (M.push(I.precision),
        M.push(I.outputColorSpace),
        M.push(I.envMapMode),
        M.push(I.envMapCubeUVHeight),
        M.push(I.mapUv),
        M.push(I.alphaMapUv),
        M.push(I.lightMapUv),
        M.push(I.aoMapUv),
        M.push(I.bumpMapUv),
        M.push(I.normalMapUv),
        M.push(I.displacementMapUv),
        M.push(I.emissiveMapUv),
        M.push(I.metalnessMapUv),
        M.push(I.roughnessMapUv),
        M.push(I.anisotropyMapUv),
        M.push(I.clearcoatMapUv),
        M.push(I.clearcoatNormalMapUv),
        M.push(I.clearcoatRoughnessMapUv),
        M.push(I.iridescenceMapUv),
        M.push(I.iridescenceThicknessMapUv),
        M.push(I.sheenColorMapUv),
        M.push(I.sheenRoughnessMapUv),
        M.push(I.specularMapUv),
        M.push(I.specularColorMapUv),
        M.push(I.specularIntensityMapUv),
        M.push(I.transmissionMapUv),
        M.push(I.thicknessMapUv),
        M.push(I.combine),
        M.push(I.fogExp2),
        M.push(I.sizeAttenuation),
        M.push(I.morphTargetsCount),
        M.push(I.morphAttributeCount),
        M.push(I.numDirLights),
        M.push(I.numPointLights),
        M.push(I.numSpotLights),
        M.push(I.numSpotLightMaps),
        M.push(I.numHemiLights),
        M.push(I.numRectAreaLights),
        M.push(I.numDirLightShadows),
        M.push(I.numPointLightShadows),
        M.push(I.numSpotLightShadows),
        M.push(I.numSpotLightShadowsWithMaps),
        M.push(I.numLightProbes),
        M.push(I.shadowMapType),
        M.push(I.toneMapping),
        M.push(I.numClippingPlanes),
        M.push(I.numClipIntersection),
        M.push(I.depthPacking));
    }
    function w(M, I) {
      (o.disableAll(),
        I.instancing && o.enable(0),
        I.instancingColor && o.enable(1),
        I.instancingMorph && o.enable(2),
        I.matcap && o.enable(3),
        I.envMap && o.enable(4),
        I.normalMapObjectSpace && o.enable(5),
        I.normalMapTangentSpace && o.enable(6),
        I.clearcoat && o.enable(7),
        I.iridescence && o.enable(8),
        I.alphaTest && o.enable(9),
        I.vertexColors && o.enable(10),
        I.vertexAlphas && o.enable(11),
        I.vertexUv1s && o.enable(12),
        I.vertexUv2s && o.enable(13),
        I.vertexUv3s && o.enable(14),
        I.vertexTangents && o.enable(15),
        I.anisotropy && o.enable(16),
        I.alphaHash && o.enable(17),
        I.batching && o.enable(18),
        I.dispersion && o.enable(19),
        I.batchingColor && o.enable(20),
        I.gradientMap && o.enable(21),
        I.packedNormalMap && o.enable(22),
        I.vertexNormals && o.enable(23),
        M.push(o.mask),
        o.disableAll(),
        I.fog && o.enable(0),
        I.useFog && o.enable(1),
        I.flatShading && o.enable(2),
        I.logarithmicDepthBuffer && o.enable(3),
        I.reversedDepthBuffer && o.enable(4),
        I.skinning && o.enable(5),
        I.morphTargets && o.enable(6),
        I.morphNormals && o.enable(7),
        I.morphColors && o.enable(8),
        I.premultipliedAlpha && o.enable(9),
        I.shadowMapEnabled && o.enable(10),
        I.doubleSided && o.enable(11),
        I.flipSided && o.enable(12),
        I.useDepthPacking && o.enable(13),
        I.dithering && o.enable(14),
        I.transmission && o.enable(15),
        I.sheen && o.enable(16),
        I.opaque && o.enable(17),
        I.pointsUvs && o.enable(18),
        I.decodeVideoTexture && o.enable(19),
        I.decodeVideoTextureEmissive && o.enable(20),
        I.alphaToCoverage && o.enable(21),
        I.numLightProbeGrids > 0 && o.enable(22),
        M.push(o.mask));
    }
    function L(M) {
      let I = p[M.type],
        z;
      if (I) {
        let W = ir[I];
        z = Ty.clone(W.uniforms);
      } else z = M.uniforms;
      return z;
    }
    function R(M, I) {
      let z = u.get(I);
      return (
        z !== void 0
          ? ++z.usedTimes
          : ((z = new RR(s, I, M, n)), c.push(z), u.set(I, z)),
        z
      );
    }
    function U(M) {
      if (--M.usedTimes === 0) {
        let I = c.indexOf(M);
        ((c[I] = c[c.length - 1]), c.pop(), u.delete(M.cacheKey), M.destroy());
      }
    }
    function O(M) {
      a.remove(M);
    }
    function N() {
      a.dispose();
    }
    return {
      getParameters: x,
      getProgramCacheKey: g,
      getUniforms: L,
      acquireProgram: R,
      releaseProgram: U,
      releaseShaderCache: O,
      programs: c,
      dispose: N,
    };
  }
  function IR() {
    let s = new WeakMap();
    function e(o) {
      return s.has(o);
    }
    function t(o) {
      let a = s.get(o);
      return (a === void 0 && ((a = {}), s.set(o, a)), a);
    }
    function i(o) {
      s.delete(o);
    }
    function n(o, a, l) {
      s.get(o)[a] = l;
    }
    function r() {
      s = new WeakMap();
    }
    return { has: e, get: t, remove: i, update: n, dispose: r };
  }
  function DR(s, e) {
    return s.groupOrder !== e.groupOrder
      ? s.groupOrder - e.groupOrder
      : s.renderOrder !== e.renderOrder
        ? s.renderOrder - e.renderOrder
        : s.material.id !== e.material.id
          ? s.material.id - e.material.id
          : s.materialVariant !== e.materialVariant
            ? s.materialVariant - e.materialVariant
            : s.z !== e.z
              ? s.z - e.z
              : s.id - e.id;
  }
  function Xy(s, e) {
    return s.groupOrder !== e.groupOrder
      ? s.groupOrder - e.groupOrder
      : s.renderOrder !== e.renderOrder
        ? s.renderOrder - e.renderOrder
        : s.z !== e.z
          ? e.z - s.z
          : s.id - e.id;
  }
  function Yy() {
    let s = [],
      e = 0,
      t = [],
      i = [],
      n = [];
    function r() {
      ((e = 0), (t.length = 0), (i.length = 0), (n.length = 0));
    }
    function o(d) {
      let p = 0;
      return (d.isInstancedMesh && (p += 2), d.isSkinnedMesh && (p += 1), p);
    }
    function a(d, p, _, x, g, v) {
      let w = s[e];
      return (
        w === void 0
          ? ((w = {
              id: d.id,
              object: d,
              geometry: p,
              material: _,
              materialVariant: o(d),
              groupOrder: x,
              renderOrder: d.renderOrder,
              z: g,
              group: v,
            }),
            (s[e] = w))
          : ((w.id = d.id),
            (w.object = d),
            (w.geometry = p),
            (w.material = _),
            (w.materialVariant = o(d)),
            (w.groupOrder = x),
            (w.renderOrder = d.renderOrder),
            (w.z = g),
            (w.group = v)),
        e++,
        w
      );
    }
    function l(d, p, _, x, g, v) {
      let w = a(d, p, _, x, g, v);
      _.transmission > 0
        ? i.push(w)
        : _.transparent === !0
          ? n.push(w)
          : t.push(w);
    }
    function c(d, p, _, x, g, v) {
      let w = a(d, p, _, x, g, v);
      _.transmission > 0
        ? i.unshift(w)
        : _.transparent === !0
          ? n.unshift(w)
          : t.unshift(w);
    }
    function u(d, p) {
      (t.length > 1 && t.sort(d || DR),
        i.length > 1 && i.sort(p || Xy),
        n.length > 1 && n.sort(p || Xy));
    }
    function f() {
      for (let d = e, p = s.length; d < p; d++) {
        let _ = s[d];
        if (_.id === null) break;
        ((_.id = null),
          (_.object = null),
          (_.geometry = null),
          (_.material = null),
          (_.group = null));
      }
    }
    return {
      opaque: t,
      transmissive: i,
      transparent: n,
      init: r,
      push: l,
      unshift: c,
      finish: f,
      sort: u,
    };
  }
  function OR() {
    let s = new WeakMap();
    function e(i, n) {
      let r = s.get(i),
        o;
      return (
        r === void 0
          ? ((o = new Yy()), s.set(i, [o]))
          : n >= r.length
            ? ((o = new Yy()), r.push(o))
            : (o = r[n]),
        o
      );
    }
    function t() {
      s = new WeakMap();
    }
    return { get: e, dispose: t };
  }
  function NR() {
    let s = {};
    return {
      get: function (e) {
        if (s[e.id] !== void 0) return s[e.id];
        let t;
        switch (e.type) {
          case 'DirectionalLight':
            t = { direction: new te(), color: new je() };
            break;
          case 'SpotLight':
            t = {
              position: new te(),
              direction: new te(),
              color: new je(),
              distance: 0,
              coneCos: 0,
              penumbraCos: 0,
              decay: 0,
            };
            break;
          case 'PointLight':
            t = { position: new te(), color: new je(), distance: 0, decay: 0 };
            break;
          case 'HemisphereLight':
            t = {
              direction: new te(),
              skyColor: new je(),
              groundColor: new je(),
            };
            break;
          case 'RectAreaLight':
            t = {
              color: new je(),
              position: new te(),
              halfWidth: new te(),
              halfHeight: new te(),
            };
            break;
        }
        return ((s[e.id] = t), t);
      },
    };
  }
  function FR() {
    let s = {};
    return {
      get: function (e) {
        if (s[e.id] !== void 0) return s[e.id];
        let t;
        switch (e.type) {
          case 'DirectionalLight':
            t = {
              shadowIntensity: 1,
              shadowBias: 0,
              shadowNormalBias: 0,
              shadowRadius: 1,
              shadowMapSize: new et(),
            };
            break;
          case 'SpotLight':
            t = {
              shadowIntensity: 1,
              shadowBias: 0,
              shadowNormalBias: 0,
              shadowRadius: 1,
              shadowMapSize: new et(),
            };
            break;
          case 'PointLight':
            t = {
              shadowIntensity: 1,
              shadowBias: 0,
              shadowNormalBias: 0,
              shadowRadius: 1,
              shadowMapSize: new et(),
              shadowCameraNear: 1,
              shadowCameraFar: 1e3,
            };
            break;
        }
        return ((s[e.id] = t), t);
      },
    };
  }
  var UR = 0;
  function BR(s, e) {
    return (
      (e.castShadow ? 2 : 0) -
      (s.castShadow ? 2 : 0) +
      (e.map ? 1 : 0) -
      (s.map ? 1 : 0)
    );
  }
  function kR(s) {
    let e = new NR(),
      t = FR(),
      i = {
        version: 0,
        hash: {
          directionalLength: -1,
          pointLength: -1,
          spotLength: -1,
          rectAreaLength: -1,
          hemiLength: -1,
          numDirectionalShadows: -1,
          numPointShadows: -1,
          numSpotShadows: -1,
          numSpotMaps: -1,
          numLightProbes: -1,
        },
        ambient: [0, 0, 0],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0,
      };
    for (let c = 0; c < 9; c++) i.probe.push(new te());
    let n = new te(),
      r = new yt(),
      o = new yt();
    function a(c) {
      let u = 0,
        f = 0,
        d = 0;
      for (let I = 0; I < 9; I++) i.probe[I].set(0, 0, 0);
      let p = 0,
        _ = 0,
        x = 0,
        g = 0,
        v = 0,
        w = 0,
        L = 0,
        R = 0,
        U = 0,
        O = 0,
        N = 0;
      c.sort(BR);
      for (let I = 0, z = c.length; I < z; I++) {
        let W = c[I],
          q = W.color,
          re = W.intensity,
          oe = W.distance,
          K = null;
        if (
          (W.shadow &&
            W.shadow.map &&
            (W.shadow.map.texture.format === lo
              ? (K = W.shadow.map.texture)
              : (K = W.shadow.map.depthTexture || W.shadow.map.texture)),
          W.isAmbientLight)
        )
          ((u += q.r * re), (f += q.g * re), (d += q.b * re));
        else if (W.isLightProbe) {
          for (let ie = 0; ie < 9; ie++)
            i.probe[ie].addScaledVector(W.sh.coefficients[ie], re);
          N++;
        } else if (W.isDirectionalLight) {
          let ie = e.get(W);
          if (
            (ie.color.copy(W.color).multiplyScalar(W.intensity), W.castShadow)
          ) {
            let J = W.shadow,
              pe = t.get(W);
            ((pe.shadowIntensity = J.intensity),
              (pe.shadowBias = J.bias),
              (pe.shadowNormalBias = J.normalBias),
              (pe.shadowRadius = J.radius),
              (pe.shadowMapSize = J.mapSize),
              (i.directionalShadow[p] = pe),
              (i.directionalShadowMap[p] = K),
              (i.directionalShadowMatrix[p] = W.shadow.matrix),
              w++);
          }
          ((i.directional[p] = ie), p++);
        } else if (W.isSpotLight) {
          let ie = e.get(W);
          (ie.position.setFromMatrixPosition(W.matrixWorld),
            ie.color.copy(q).multiplyScalar(re),
            (ie.distance = oe),
            (ie.coneCos = Math.cos(W.angle)),
            (ie.penumbraCos = Math.cos(W.angle * (1 - W.penumbra))),
            (ie.decay = W.decay),
            (i.spot[x] = ie));
          let J = W.shadow;
          if (
            (W.map &&
              ((i.spotLightMap[U] = W.map),
              U++,
              J.updateMatrices(W),
              W.castShadow && O++),
            (i.spotLightMatrix[x] = J.matrix),
            W.castShadow)
          ) {
            let pe = t.get(W);
            ((pe.shadowIntensity = J.intensity),
              (pe.shadowBias = J.bias),
              (pe.shadowNormalBias = J.normalBias),
              (pe.shadowRadius = J.radius),
              (pe.shadowMapSize = J.mapSize),
              (i.spotShadow[x] = pe),
              (i.spotShadowMap[x] = K),
              R++);
          }
          x++;
        } else if (W.isRectAreaLight) {
          let ie = e.get(W);
          (ie.color.copy(q).multiplyScalar(re),
            ie.halfWidth.set(W.width * 0.5, 0, 0),
            ie.halfHeight.set(0, W.height * 0.5, 0),
            (i.rectArea[g] = ie),
            g++);
        } else if (W.isPointLight) {
          let ie = e.get(W);
          if (
            (ie.color.copy(W.color).multiplyScalar(W.intensity),
            (ie.distance = W.distance),
            (ie.decay = W.decay),
            W.castShadow)
          ) {
            let J = W.shadow,
              pe = t.get(W);
            ((pe.shadowIntensity = J.intensity),
              (pe.shadowBias = J.bias),
              (pe.shadowNormalBias = J.normalBias),
              (pe.shadowRadius = J.radius),
              (pe.shadowMapSize = J.mapSize),
              (pe.shadowCameraNear = J.camera.near),
              (pe.shadowCameraFar = J.camera.far),
              (i.pointShadow[_] = pe),
              (i.pointShadowMap[_] = K),
              (i.pointShadowMatrix[_] = W.shadow.matrix),
              L++);
          }
          ((i.point[_] = ie), _++);
        } else if (W.isHemisphereLight) {
          let ie = e.get(W);
          (ie.skyColor.copy(W.color).multiplyScalar(re),
            ie.groundColor.copy(W.groundColor).multiplyScalar(re),
            (i.hemi[v] = ie),
            v++);
        }
      }
      (g > 0 &&
        (s.has('OES_texture_float_linear') === !0
          ? ((i.rectAreaLTC1 = We.LTC_FLOAT_1),
            (i.rectAreaLTC2 = We.LTC_FLOAT_2))
          : ((i.rectAreaLTC1 = We.LTC_HALF_1),
            (i.rectAreaLTC2 = We.LTC_HALF_2))),
        (i.ambient[0] = u),
        (i.ambient[1] = f),
        (i.ambient[2] = d));
      let M = i.hash;
      (M.directionalLength !== p ||
        M.pointLength !== _ ||
        M.spotLength !== x ||
        M.rectAreaLength !== g ||
        M.hemiLength !== v ||
        M.numDirectionalShadows !== w ||
        M.numPointShadows !== L ||
        M.numSpotShadows !== R ||
        M.numSpotMaps !== U ||
        M.numLightProbes !== N) &&
        ((i.directional.length = p),
        (i.spot.length = x),
        (i.rectArea.length = g),
        (i.point.length = _),
        (i.hemi.length = v),
        (i.directionalShadow.length = w),
        (i.directionalShadowMap.length = w),
        (i.pointShadow.length = L),
        (i.pointShadowMap.length = L),
        (i.spotShadow.length = R),
        (i.spotShadowMap.length = R),
        (i.directionalShadowMatrix.length = w),
        (i.pointShadowMatrix.length = L),
        (i.spotLightMatrix.length = R + U - O),
        (i.spotLightMap.length = U),
        (i.numSpotLightShadowsWithMaps = O),
        (i.numLightProbes = N),
        (M.directionalLength = p),
        (M.pointLength = _),
        (M.spotLength = x),
        (M.rectAreaLength = g),
        (M.hemiLength = v),
        (M.numDirectionalShadows = w),
        (M.numPointShadows = L),
        (M.numSpotShadows = R),
        (M.numSpotMaps = U),
        (M.numLightProbes = N),
        (i.version = UR++));
    }
    function l(c, u) {
      let f = 0,
        d = 0,
        p = 0,
        _ = 0,
        x = 0,
        g = u.matrixWorldInverse;
      for (let v = 0, w = c.length; v < w; v++) {
        let L = c[v];
        if (L.isDirectionalLight) {
          let R = i.directional[f];
          (R.direction.setFromMatrixPosition(L.matrixWorld),
            n.setFromMatrixPosition(L.target.matrixWorld),
            R.direction.sub(n),
            R.direction.transformDirection(g),
            f++);
        } else if (L.isSpotLight) {
          let R = i.spot[p];
          (R.position.setFromMatrixPosition(L.matrixWorld),
            R.position.applyMatrix4(g),
            R.direction.setFromMatrixPosition(L.matrixWorld),
            n.setFromMatrixPosition(L.target.matrixWorld),
            R.direction.sub(n),
            R.direction.transformDirection(g),
            p++);
        } else if (L.isRectAreaLight) {
          let R = i.rectArea[_];
          (R.position.setFromMatrixPosition(L.matrixWorld),
            R.position.applyMatrix4(g),
            o.identity(),
            r.copy(L.matrixWorld),
            r.premultiply(g),
            o.extractRotation(r),
            R.halfWidth.set(L.width * 0.5, 0, 0),
            R.halfHeight.set(0, L.height * 0.5, 0),
            R.halfWidth.applyMatrix4(o),
            R.halfHeight.applyMatrix4(o),
            _++);
        } else if (L.isPointLight) {
          let R = i.point[d];
          (R.position.setFromMatrixPosition(L.matrixWorld),
            R.position.applyMatrix4(g),
            d++);
        } else if (L.isHemisphereLight) {
          let R = i.hemi[x];
          (R.direction.setFromMatrixPosition(L.matrixWorld),
            R.direction.transformDirection(g),
            x++);
        }
      }
    }
    return { setup: a, setupView: l, state: i };
  }
  function qy(s) {
    let e = new kR(s),
      t = [],
      i = [],
      n = [];
    function r(d) {
      ((f.camera = d), (t.length = 0), (i.length = 0), (n.length = 0));
    }
    function o(d) {
      t.push(d);
    }
    function a(d) {
      i.push(d);
    }
    function l(d) {
      n.push(d);
    }
    function c() {
      e.setup(t);
    }
    function u(d) {
      e.setupView(t, d);
    }
    let f = {
      lightsArray: t,
      shadowsArray: i,
      lightProbeGridArray: n,
      camera: null,
      lights: e,
      transmissionRenderTarget: {},
      textureUnits: 0,
    };
    return {
      init: r,
      state: f,
      setupLights: c,
      setupLightsView: u,
      pushLight: o,
      pushShadow: a,
      pushLightProbeGrid: l,
    };
  }
  function HR(s) {
    let e = new WeakMap();
    function t(n, r = 0) {
      let o = e.get(n),
        a;
      return (
        o === void 0
          ? ((a = new qy(s)), e.set(n, [a]))
          : r >= o.length
            ? ((a = new qy(s)), o.push(a))
            : (a = o[r]),
        a
      );
    }
    function i() {
      e = new WeakMap();
    }
    return { get: t, dispose: i };
  }
  var zR = `void main() {
	gl_Position = vec4( position, 1.0 );
}`,
    VR = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );
	gl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );
}`,
    GR = [
      new te(1, 0, 0),
      new te(-1, 0, 0),
      new te(0, 1, 0),
      new te(0, -1, 0),
      new te(0, 0, 1),
      new te(0, 0, -1),
    ],
    WR = [
      new te(0, -1, 0),
      new te(0, -1, 0),
      new te(0, 0, 1),
      new te(0, 0, -1),
      new te(0, -1, 0),
      new te(0, -1, 0),
    ],
    Zy = new yt(),
    Yc = new te(),
    Cg = new te();
  function XR(s, e, t) {
    let i = new $a(),
      n = new et(),
      r = new et(),
      o = new Qt(),
      a = new Hu(),
      l = new zu(),
      c = {},
      u = t.maxTextureSize,
      f = { [Ss]: bn, [bn]: Ss, [Gi]: Gi },
      d = new vi({
        defines: { VSM_SAMPLES: 8 },
        uniforms: {
          shadow_pass: { value: null },
          resolution: { value: new et() },
          radius: { value: 4 },
        },
        vertexShader: zR,
        fragmentShader: VR,
      }),
      p = d.clone();
    p.defines.HORIZONTAL_PASS = 1;
    let _ = new Vi();
    _.setAttribute(
      'position',
      new fi(new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]), 3),
    );
    let x = new ri(_, d),
      g = this;
    ((this.enabled = !1),
      (this.autoUpdate = !0),
      (this.needsUpdate = !1),
      (this.type = Nc));
    let v = this.type;
    this.render = function (O, N, M) {
      if (
        g.enabled === !1 ||
        (g.autoUpdate === !1 && g.needsUpdate === !1) ||
        O.length === 0
      )
        return;
      this.type === Vx &&
        (it(
          'WebGLShadowMap: PCFSoftShadowMap has been deprecated. Using PCFShadowMap instead.',
        ),
        (this.type = Nc));
      let I = s.getRenderTarget(),
        z = s.getActiveCubeFace(),
        W = s.getActiveMipmapLevel(),
        q = s.state;
      (q.setBlending(Qs),
        q.buffers.depth.getReversed() === !0
          ? q.buffers.color.setClear(0, 0, 0, 0)
          : q.buffers.color.setClear(1, 1, 1, 1),
        q.buffers.depth.setTest(!0),
        q.setScissorTest(!1));
      let re = v !== this.type;
      re &&
        N.traverse(function (oe) {
          oe.material &&
            (Array.isArray(oe.material)
              ? oe.material.forEach((K) => (K.needsUpdate = !0))
              : (oe.material.needsUpdate = !0));
        });
      for (let oe = 0, K = O.length; oe < K; oe++) {
        let ie = O[oe],
          J = ie.shadow;
        if (J === void 0) {
          it('WebGLShadowMap:', ie, 'has no shadow.');
          continue;
        }
        if (J.autoUpdate === !1 && J.needsUpdate === !1) continue;
        n.copy(J.mapSize);
        let pe = J.getFrameExtents();
        (n.multiply(pe),
          r.copy(J.mapSize),
          (n.x > u || n.y > u) &&
            (n.x > u &&
              ((r.x = Math.floor(u / pe.x)),
              (n.x = r.x * pe.x),
              (J.mapSize.x = r.x)),
            n.y > u &&
              ((r.y = Math.floor(u / pe.y)),
              (n.y = r.y * pe.y),
              (J.mapSize.y = r.y))));
        let Ee = s.state.buffers.depth.getReversed();
        if (((J.camera._reversedDepth = Ee), J.map === null || re === !0)) {
          if (
            (J.map !== null &&
              (J.map.depthTexture !== null &&
                (J.map.depthTexture.dispose(), (J.map.depthTexture = null)),
              J.map.dispose()),
            this.type === tl)
          ) {
            if (ie.isPointLight) {
              it(
                'WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.',
              );
              continue;
            }
            ((J.map = new xn(n.x, n.y, {
              format: lo,
              type: er,
              minFilter: Si,
              magFilter: Si,
              generateMipmaps: !1,
            })),
              (J.map.texture.name = ie.name + '.shadowMap'),
              (J.map.depthTexture = new Mr(n.x, n.y, Xn)),
              (J.map.depthTexture.name = ie.name + '.shadowMapDepth'),
              (J.map.depthTexture.format = qs),
              (J.map.depthTexture.compareFunction = null),
              (J.map.depthTexture.minFilter = bi),
              (J.map.depthTexture.magFilter = bi));
          } else
            (ie.isPointLight
              ? ((J.map = new Vd(n.x)), (J.map.depthTexture = new Bu(n.x, Rs)))
              : ((J.map = new xn(n.x, n.y)),
                (J.map.depthTexture = new Mr(n.x, n.y, Rs))),
              (J.map.depthTexture.name = ie.name + '.shadowMap'),
              (J.map.depthTexture.format = qs),
              this.type === Nc
                ? ((J.map.depthTexture.compareFunction = Ee ? kd : Bd),
                  (J.map.depthTexture.minFilter = Si),
                  (J.map.depthTexture.magFilter = Si))
                : ((J.map.depthTexture.compareFunction = null),
                  (J.map.depthTexture.minFilter = bi),
                  (J.map.depthTexture.magFilter = bi)));
          J.camera.updateProjectionMatrix();
        }
        let Z = J.map.isWebGLCubeRenderTarget ? 6 : 1;
        for (let Ne = 0; Ne < Z; Ne++) {
          if (J.map.isWebGLCubeRenderTarget)
            (s.setRenderTarget(J.map, Ne), s.clear());
          else {
            Ne === 0 && (s.setRenderTarget(J.map), s.clear());
            let Be = J.getViewport(Ne);
            (o.set(r.x * Be.x, r.y * Be.y, r.x * Be.z, r.y * Be.w),
              q.viewport(o));
          }
          if (ie.isPointLight) {
            let Be = J.camera,
              ht = J.matrix,
              ot = ie.distance || Be.far;
            (ot !== Be.far && ((Be.far = ot), Be.updateProjectionMatrix()),
              Yc.setFromMatrixPosition(ie.matrixWorld),
              Be.position.copy(Yc),
              Cg.copy(Be.position),
              Cg.add(GR[Ne]),
              Be.up.copy(WR[Ne]),
              Be.lookAt(Cg),
              Be.updateMatrixWorld(),
              ht.makeTranslation(-Yc.x, -Yc.y, -Yc.z),
              Zy.multiplyMatrices(Be.projectionMatrix, Be.matrixWorldInverse),
              J._frustum.setFromProjectionMatrix(
                Zy,
                Be.coordinateSystem,
                Be.reversedDepth,
              ));
          } else J.updateMatrices(ie);
          ((i = J.getFrustum()), R(N, M, J.camera, ie, this.type));
        }
        (J.isPointLightShadow !== !0 && this.type === tl && w(J, M),
          (J.needsUpdate = !1));
      }
      ((v = this.type), (g.needsUpdate = !1), s.setRenderTarget(I, z, W));
    };
    function w(O, N) {
      let M = e.update(x);
      (d.defines.VSM_SAMPLES !== O.blurSamples &&
        ((d.defines.VSM_SAMPLES = O.blurSamples),
        (p.defines.VSM_SAMPLES = O.blurSamples),
        (d.needsUpdate = !0),
        (p.needsUpdate = !0)),
        O.mapPass === null &&
          (O.mapPass = new xn(n.x, n.y, { format: lo, type: er })),
        (d.uniforms.shadow_pass.value = O.map.depthTexture),
        (d.uniforms.resolution.value = O.mapSize),
        (d.uniforms.radius.value = O.radius),
        s.setRenderTarget(O.mapPass),
        s.clear(),
        s.renderBufferDirect(N, null, M, d, x, null),
        (p.uniforms.shadow_pass.value = O.mapPass.texture),
        (p.uniforms.resolution.value = O.mapSize),
        (p.uniforms.radius.value = O.radius),
        s.setRenderTarget(O.map),
        s.clear(),
        s.renderBufferDirect(N, null, M, p, x, null));
    }
    function L(O, N, M, I) {
      let z = null,
        W =
          M.isPointLight === !0
            ? O.customDistanceMaterial
            : O.customDepthMaterial;
      if (W !== void 0) z = W;
      else if (
        ((z = M.isPointLight === !0 ? l : a),
        (s.localClippingEnabled &&
          N.clipShadows === !0 &&
          Array.isArray(N.clippingPlanes) &&
          N.clippingPlanes.length !== 0) ||
          (N.displacementMap && N.displacementScale !== 0) ||
          (N.alphaMap && N.alphaTest > 0) ||
          (N.map && N.alphaTest > 0) ||
          N.alphaToCoverage === !0)
      ) {
        let q = z.uuid,
          re = N.uuid,
          oe = c[q];
        oe === void 0 && ((oe = {}), (c[q] = oe));
        let K = oe[re];
        (K === void 0 &&
          ((K = z.clone()), (oe[re] = K), N.addEventListener('dispose', U)),
          (z = K));
      }
      if (
        ((z.visible = N.visible),
        (z.wireframe = N.wireframe),
        I === tl
          ? (z.side = N.shadowSide !== null ? N.shadowSide : N.side)
          : (z.side = N.shadowSide !== null ? N.shadowSide : f[N.side]),
        (z.alphaMap = N.alphaMap),
        (z.alphaTest = N.alphaToCoverage === !0 ? 0.5 : N.alphaTest),
        (z.map = N.map),
        (z.clipShadows = N.clipShadows),
        (z.clippingPlanes = N.clippingPlanes),
        (z.clipIntersection = N.clipIntersection),
        (z.displacementMap = N.displacementMap),
        (z.displacementScale = N.displacementScale),
        (z.displacementBias = N.displacementBias),
        (z.wireframeLinewidth = N.wireframeLinewidth),
        (z.linewidth = N.linewidth),
        M.isPointLight === !0 && z.isMeshDistanceMaterial === !0)
      ) {
        let q = s.properties.get(z);
        q.light = M;
      }
      return z;
    }
    function R(O, N, M, I, z) {
      if (O.visible === !1) return;
      if (
        O.layers.test(N.layers) &&
        (O.isMesh || O.isLine || O.isPoints) &&
        (O.castShadow || (O.receiveShadow && z === tl)) &&
        (!O.frustumCulled || i.intersectsObject(O))
      ) {
        O.modelViewMatrix.multiplyMatrices(M.matrixWorldInverse, O.matrixWorld);
        let re = e.update(O),
          oe = O.material;
        if (Array.isArray(oe)) {
          let K = re.groups;
          for (let ie = 0, J = K.length; ie < J; ie++) {
            let pe = K[ie],
              Ee = oe[pe.materialIndex];
            if (Ee && Ee.visible) {
              let Z = L(O, Ee, I, z);
              (O.onBeforeShadow(s, O, N, M, re, Z, pe),
                s.renderBufferDirect(M, null, re, Z, O, pe),
                O.onAfterShadow(s, O, N, M, re, Z, pe));
            }
          }
        } else if (oe.visible) {
          let K = L(O, oe, I, z);
          (O.onBeforeShadow(s, O, N, M, re, K, null),
            s.renderBufferDirect(M, null, re, K, O, null),
            O.onAfterShadow(s, O, N, M, re, K, null));
        }
      }
      let q = O.children;
      for (let re = 0, oe = q.length; re < oe; re++) R(q[re], N, M, I, z);
    }
    function U(O) {
      O.target.removeEventListener('dispose', U);
      for (let M in c) {
        let I = c[M],
          z = O.target.uuid;
        z in I && (I[z].dispose(), delete I[z]);
      }
    }
  }
  function YR(s, e) {
    function t() {
      let j = !1,
        Ce = new Qt(),
        ye = null,
        D = new Qt(0, 0, 0, 0);
      return {
        setMask: function (h) {
          ye !== h && !j && (s.colorMask(h, h, h, h), (ye = h));
        },
        setLocked: function (h) {
          j = h;
        },
        setClear: function (h, m, b, S, E) {
          (E === !0 && ((h *= S), (m *= S), (b *= S)),
            Ce.set(h, m, b, S),
            D.equals(Ce) === !1 && (s.clearColor(h, m, b, S), D.copy(Ce)));
        },
        reset: function () {
          ((j = !1), (ye = null), D.set(-1, 0, 0, 0));
        },
      };
    }
    function i() {
      let j = !1,
        Ce = !1,
        ye = null,
        D = null,
        h = null;
      return {
        setReversed: function (m) {
          if (Ce !== m) {
            let b = e.get('EXT_clip_control');
            (m
              ? b.clipControlEXT(b.LOWER_LEFT_EXT, b.ZERO_TO_ONE_EXT)
              : b.clipControlEXT(b.LOWER_LEFT_EXT, b.NEGATIVE_ONE_TO_ONE_EXT),
              (Ce = m));
            let S = h;
            ((h = null), this.setClear(S));
          }
        },
        getReversed: function () {
          return Ce;
        },
        setTest: function (m) {
          m ? Ae(s.DEPTH_TEST) : Ze(s.DEPTH_TEST);
        },
        setMask: function (m) {
          ye !== m && !j && (s.depthMask(m), (ye = m));
        },
        setFunc: function (m) {
          if ((Ce && (m = Sy[m]), D !== m)) {
            switch (m) {
              case Tu:
                s.depthFunc(s.NEVER);
                break;
              case Mu:
                s.depthFunc(s.ALWAYS);
                break;
              case wu:
                s.depthFunc(s.LESS);
                break;
              case Wo:
                s.depthFunc(s.LEQUAL);
                break;
              case Au:
                s.depthFunc(s.EQUAL);
                break;
              case Ru:
                s.depthFunc(s.GEQUAL);
                break;
              case Cu:
                s.depthFunc(s.GREATER);
                break;
              case Pu:
                s.depthFunc(s.NOTEQUAL);
                break;
              default:
                s.depthFunc(s.LEQUAL);
            }
            D = m;
          }
        },
        setLocked: function (m) {
          j = m;
        },
        setClear: function (m) {
          h !== m && ((h = m), Ce && (m = 1 - m), s.clearDepth(m));
        },
        reset: function () {
          ((j = !1), (ye = null), (D = null), (h = null), (Ce = !1));
        },
      };
    }
    function n() {
      let j = !1,
        Ce = null,
        ye = null,
        D = null,
        h = null,
        m = null,
        b = null,
        S = null,
        E = null;
      return {
        setTest: function (A) {
          j || (A ? Ae(s.STENCIL_TEST) : Ze(s.STENCIL_TEST));
        },
        setMask: function (A) {
          Ce !== A && !j && (s.stencilMask(A), (Ce = A));
        },
        setFunc: function (A, F, V) {
          (ye !== A || D !== F || h !== V) &&
            (s.stencilFunc(A, F, V), (ye = A), (D = F), (h = V));
        },
        setOp: function (A, F, V) {
          (m !== A || b !== F || S !== V) &&
            (s.stencilOp(A, F, V), (m = A), (b = F), (S = V));
        },
        setLocked: function (A) {
          j = A;
        },
        setClear: function (A) {
          E !== A && (s.clearStencil(A), (E = A));
        },
        reset: function () {
          ((j = !1),
            (Ce = null),
            (ye = null),
            (D = null),
            (h = null),
            (m = null),
            (b = null),
            (S = null),
            (E = null));
        },
      };
    }
    let r = new t(),
      o = new i(),
      a = new n(),
      l = new WeakMap(),
      c = new WeakMap(),
      u = {},
      f = {},
      d = {},
      p = new WeakMap(),
      _ = [],
      x = null,
      g = !1,
      v = null,
      w = null,
      L = null,
      R = null,
      U = null,
      O = null,
      N = null,
      M = new je(0, 0, 0),
      I = 0,
      z = !1,
      W = null,
      q = null,
      re = null,
      oe = null,
      K = null,
      ie = s.getParameter(s.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
      J = !1,
      pe = 0,
      Ee = s.getParameter(s.VERSION);
    Ee.indexOf('WebGL') !== -1
      ? ((pe = parseFloat(/^WebGL (\d)/.exec(Ee)[1])), (J = pe >= 1))
      : Ee.indexOf('OpenGL ES') !== -1 &&
        ((pe = parseFloat(/^OpenGL ES (\d)/.exec(Ee)[1])), (J = pe >= 2));
    let Z = null,
      Ne = {},
      Be = s.getParameter(s.SCISSOR_BOX),
      ht = s.getParameter(s.VIEWPORT),
      ot = new Qt().fromArray(Be),
      tt = new Qt().fromArray(ht);
    function ve(j, Ce, ye, D) {
      let h = new Uint8Array(4),
        m = s.createTexture();
      (s.bindTexture(j, m),
        s.texParameteri(j, s.TEXTURE_MIN_FILTER, s.NEAREST),
        s.texParameteri(j, s.TEXTURE_MAG_FILTER, s.NEAREST));
      for (let b = 0; b < ye; b++)
        j === s.TEXTURE_3D || j === s.TEXTURE_2D_ARRAY
          ? s.texImage3D(Ce, 0, s.RGBA, 1, 1, D, 0, s.RGBA, s.UNSIGNED_BYTE, h)
          : s.texImage2D(
              Ce + b,
              0,
              s.RGBA,
              1,
              1,
              0,
              s.RGBA,
              s.UNSIGNED_BYTE,
              h,
            );
      return m;
    }
    let Pe = {};
    ((Pe[s.TEXTURE_2D] = ve(s.TEXTURE_2D, s.TEXTURE_2D, 1)),
      (Pe[s.TEXTURE_CUBE_MAP] = ve(
        s.TEXTURE_CUBE_MAP,
        s.TEXTURE_CUBE_MAP_POSITIVE_X,
        6,
      )),
      (Pe[s.TEXTURE_2D_ARRAY] = ve(
        s.TEXTURE_2D_ARRAY,
        s.TEXTURE_2D_ARRAY,
        1,
        1,
      )),
      (Pe[s.TEXTURE_3D] = ve(s.TEXTURE_3D, s.TEXTURE_3D, 1, 1)),
      r.setClear(0, 0, 0, 1),
      o.setClear(1),
      a.setClear(0),
      Ae(s.DEPTH_TEST),
      o.setFunc(Wo),
      ue(!1),
      Rt(Zm),
      Ae(s.CULL_FACE),
      Tt(Qs));
    function Ae(j) {
      u[j] !== !0 && (s.enable(j), (u[j] = !0));
    }
    function Ze(j) {
      u[j] !== !1 && (s.disable(j), (u[j] = !1));
    }
    function nt(j, Ce) {
      return d[j] !== Ce
        ? (s.bindFramebuffer(j, Ce),
          (d[j] = Ce),
          j === s.DRAW_FRAMEBUFFER && (d[s.FRAMEBUFFER] = Ce),
          j === s.FRAMEBUFFER && (d[s.DRAW_FRAMEBUFFER] = Ce),
          !0)
        : !1;
    }
    function Le(j, Ce) {
      let ye = _,
        D = !1;
      if (j) {
        ((ye = p.get(Ce)), ye === void 0 && ((ye = []), p.set(Ce, ye)));
        let h = j.textures;
        if (ye.length !== h.length || ye[0] !== s.COLOR_ATTACHMENT0) {
          for (let m = 0, b = h.length; m < b; m++)
            ye[m] = s.COLOR_ATTACHMENT0 + m;
          ((ye.length = h.length), (D = !0));
        }
      } else ye[0] !== s.BACK && ((ye[0] = s.BACK), (D = !0));
      D && s.drawBuffers(ye);
    }
    function At(j) {
      return x !== j ? (s.useProgram(j), (x = j), !0) : !1;
    }
    let Ke = {
      [Jr]: s.FUNC_ADD,
      [Wx]: s.FUNC_SUBTRACT,
      [Xx]: s.FUNC_REVERSE_SUBTRACT,
    };
    ((Ke[Yx] = s.MIN), (Ke[qx] = s.MAX));
    let ut = {
      [Zx]: s.ZERO,
      [Kx]: s.ONE,
      [$x]: s.SRC_COLOR,
      [Su]: s.SRC_ALPHA,
      [iy]: s.SRC_ALPHA_SATURATE,
      [ey]: s.DST_COLOR,
      [Jx]: s.DST_ALPHA,
      [jx]: s.ONE_MINUS_SRC_COLOR,
      [Eu]: s.ONE_MINUS_SRC_ALPHA,
      [ty]: s.ONE_MINUS_DST_COLOR,
      [Qx]: s.ONE_MINUS_DST_ALPHA,
      [ny]: s.CONSTANT_COLOR,
      [sy]: s.ONE_MINUS_CONSTANT_COLOR,
      [ry]: s.CONSTANT_ALPHA,
      [oy]: s.ONE_MINUS_CONSTANT_ALPHA,
    };
    function Tt(j, Ce, ye, D, h, m, b, S, E, A) {
      if (j === Qs) {
        g === !0 && (Ze(s.BLEND), (g = !1));
        return;
      }
      if ((g === !1 && (Ae(s.BLEND), (g = !0)), j !== Gx)) {
        if (j !== v || A !== z) {
          if (
            ((w !== Jr || U !== Jr) &&
              (s.blendEquation(s.FUNC_ADD), (w = Jr), (U = Jr)),
            A)
          )
            switch (j) {
              case Go:
                s.blendFuncSeparate(
                  s.ONE,
                  s.ONE_MINUS_SRC_ALPHA,
                  s.ONE,
                  s.ONE_MINUS_SRC_ALPHA,
                );
                break;
              case Fc:
                s.blendFunc(s.ONE, s.ONE);
                break;
              case Km:
                s.blendFuncSeparate(
                  s.ZERO,
                  s.ONE_MINUS_SRC_COLOR,
                  s.ZERO,
                  s.ONE,
                );
                break;
              case $m:
                s.blendFuncSeparate(
                  s.DST_COLOR,
                  s.ONE_MINUS_SRC_ALPHA,
                  s.ZERO,
                  s.ONE,
                );
                break;
              default:
                mt('WebGLState: Invalid blending: ', j);
                break;
            }
          else
            switch (j) {
              case Go:
                s.blendFuncSeparate(
                  s.SRC_ALPHA,
                  s.ONE_MINUS_SRC_ALPHA,
                  s.ONE,
                  s.ONE_MINUS_SRC_ALPHA,
                );
                break;
              case Fc:
                s.blendFuncSeparate(s.SRC_ALPHA, s.ONE, s.ONE, s.ONE);
                break;
              case Km:
                mt(
                  'WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true',
                );
                break;
              case $m:
                mt(
                  'WebGLState: MultiplyBlending requires material.premultipliedAlpha = true',
                );
                break;
              default:
                mt('WebGLState: Invalid blending: ', j);
                break;
            }
          ((L = null),
            (R = null),
            (O = null),
            (N = null),
            M.set(0, 0, 0),
            (I = 0),
            (v = j),
            (z = A));
        }
        return;
      }
      ((h = h || Ce),
        (m = m || ye),
        (b = b || D),
        (Ce !== w || h !== U) &&
          (s.blendEquationSeparate(Ke[Ce], Ke[h]), (w = Ce), (U = h)),
        (ye !== L || D !== R || m !== O || b !== N) &&
          (s.blendFuncSeparate(ut[ye], ut[D], ut[m], ut[b]),
          (L = ye),
          (R = D),
          (O = m),
          (N = b)),
        (S.equals(M) === !1 || E !== I) &&
          (s.blendColor(S.r, S.g, S.b, E), M.copy(S), (I = E)),
        (v = j),
        (z = !1));
    }
    function at(j, Ce) {
      j.side === Gi ? Ze(s.CULL_FACE) : Ae(s.CULL_FACE);
      let ye = j.side === bn;
      (Ce && (ye = !ye),
        ue(ye),
        j.blending === Go && j.transparent === !1
          ? Tt(Qs)
          : Tt(
              j.blending,
              j.blendEquation,
              j.blendSrc,
              j.blendDst,
              j.blendEquationAlpha,
              j.blendSrcAlpha,
              j.blendDstAlpha,
              j.blendColor,
              j.blendAlpha,
              j.premultipliedAlpha,
            ),
        o.setFunc(j.depthFunc),
        o.setTest(j.depthTest),
        o.setMask(j.depthWrite),
        r.setMask(j.colorWrite));
      let D = j.stencilWrite;
      (a.setTest(D),
        D &&
          (a.setMask(j.stencilWriteMask),
          a.setFunc(j.stencilFunc, j.stencilRef, j.stencilFuncMask),
          a.setOp(j.stencilFail, j.stencilZFail, j.stencilZPass)),
        ee(j.polygonOffset, j.polygonOffsetFactor, j.polygonOffsetUnits),
        j.alphaToCoverage === !0
          ? Ae(s.SAMPLE_ALPHA_TO_COVERAGE)
          : Ze(s.SAMPLE_ALPHA_TO_COVERAGE));
    }
    function ue(j) {
      W !== j && (j ? s.frontFace(s.CW) : s.frontFace(s.CCW), (W = j));
    }
    function Rt(j) {
      (j !== Hx
        ? (Ae(s.CULL_FACE),
          j !== q &&
            (j === Zm
              ? s.cullFace(s.BACK)
              : j === zx
                ? s.cullFace(s.FRONT)
                : s.cullFace(s.FRONT_AND_BACK)))
        : Ze(s.CULL_FACE),
        (q = j));
    }
    function ti(j) {
      j !== re && (J && s.lineWidth(j), (re = j));
    }
    function ee(j, Ce, ye) {
      j
        ? (Ae(s.POLYGON_OFFSET_FILL),
          (oe !== Ce || K !== ye) &&
            ((oe = Ce),
            (K = ye),
            o.getReversed() && (Ce = -Ce),
            s.polygonOffset(Ce, ye)))
        : Ze(s.POLYGON_OFFSET_FILL);
    }
    function xt(j) {
      j ? Ae(s.SCISSOR_TEST) : Ze(s.SCISSOR_TEST);
    }
    function _t(j) {
      (j === void 0 && (j = s.TEXTURE0 + ie - 1),
        Z !== j && (s.activeTexture(j), (Z = j)));
    }
    function Ut(j, Ce, ye) {
      ye === void 0 && (Z === null ? (ye = s.TEXTURE0 + ie - 1) : (ye = Z));
      let D = Ne[ye];
      (D === void 0 && ((D = { type: void 0, texture: void 0 }), (Ne[ye] = D)),
        (D.type !== j || D.texture !== Ce) &&
          (Z !== ye && (s.activeTexture(ye), (Z = ye)),
          s.bindTexture(j, Ce || Pe[j]),
          (D.type = j),
          (D.texture = Ce)));
    }
    function Ue() {
      let j = Ne[Z];
      j !== void 0 &&
        j.type !== void 0 &&
        (s.bindTexture(j.type, null), (j.type = void 0), (j.texture = void 0));
    }
    function bt() {
      try {
        s.compressedTexImage2D(...arguments);
      } catch (j) {
        mt('WebGLState:', j);
      }
    }
    function H() {
      try {
        s.compressedTexImage3D(...arguments);
      } catch (j) {
        mt('WebGLState:', j);
      }
    }
    function C() {
      try {
        s.texSubImage2D(...arguments);
      } catch (j) {
        mt('WebGLState:', j);
      }
    }
    function se() {
      try {
        s.texSubImage3D(...arguments);
      } catch (j) {
        mt('WebGLState:', j);
      }
    }
    function _e() {
      try {
        s.compressedTexSubImage2D(...arguments);
      } catch (j) {
        mt('WebGLState:', j);
      }
    }
    function we() {
      try {
        s.compressedTexSubImage3D(...arguments);
      } catch (j) {
        mt('WebGLState:', j);
      }
    }
    function Oe() {
      try {
        s.texStorage2D(...arguments);
      } catch (j) {
        mt('WebGLState:', j);
      }
    }
    function Re() {
      try {
        s.texStorage3D(...arguments);
      } catch (j) {
        mt('WebGLState:', j);
      }
    }
    function ge() {
      try {
        s.texImage2D(...arguments);
      } catch (j) {
        mt('WebGLState:', j);
      }
    }
    function be() {
      try {
        s.texImage3D(...arguments);
      } catch (j) {
        mt('WebGLState:', j);
      }
    }
    function ke(j) {
      return f[j] !== void 0 ? f[j] : s.getParameter(j);
    }
    function Ve(j, Ce) {
      f[j] !== Ce && (s.pixelStorei(j, Ce), (f[j] = Ce));
    }
    function Te(j) {
      ot.equals(j) === !1 && (s.scissor(j.x, j.y, j.z, j.w), ot.copy(j));
    }
    function Ie(j) {
      tt.equals(j) === !1 && (s.viewport(j.x, j.y, j.z, j.w), tt.copy(j));
    }
    function Fe(j, Ce) {
      let ye = c.get(Ce);
      ye === void 0 && ((ye = new WeakMap()), c.set(Ce, ye));
      let D = ye.get(j);
      D === void 0 && ((D = s.getUniformBlockIndex(Ce, j.name)), ye.set(j, D));
    }
    function rt(j, Ce) {
      let D = c.get(Ce).get(j);
      l.get(Ce) !== D &&
        (s.uniformBlockBinding(Ce, D, j.__bindingPointIndex), l.set(Ce, D));
    }
    function vt() {
      (s.disable(s.BLEND),
        s.disable(s.CULL_FACE),
        s.disable(s.DEPTH_TEST),
        s.disable(s.POLYGON_OFFSET_FILL),
        s.disable(s.SCISSOR_TEST),
        s.disable(s.STENCIL_TEST),
        s.disable(s.SAMPLE_ALPHA_TO_COVERAGE),
        s.blendEquation(s.FUNC_ADD),
        s.blendFunc(s.ONE, s.ZERO),
        s.blendFuncSeparate(s.ONE, s.ZERO, s.ONE, s.ZERO),
        s.blendColor(0, 0, 0, 0),
        s.colorMask(!0, !0, !0, !0),
        s.clearColor(0, 0, 0, 0),
        s.depthMask(!0),
        s.depthFunc(s.LESS),
        o.setReversed(!1),
        s.clearDepth(1),
        s.stencilMask(4294967295),
        s.stencilFunc(s.ALWAYS, 0, 4294967295),
        s.stencilOp(s.KEEP, s.KEEP, s.KEEP),
        s.clearStencil(0),
        s.cullFace(s.BACK),
        s.frontFace(s.CCW),
        s.polygonOffset(0, 0),
        s.activeTexture(s.TEXTURE0),
        s.bindFramebuffer(s.FRAMEBUFFER, null),
        s.bindFramebuffer(s.DRAW_FRAMEBUFFER, null),
        s.bindFramebuffer(s.READ_FRAMEBUFFER, null),
        s.useProgram(null),
        s.lineWidth(1),
        s.scissor(0, 0, s.canvas.width, s.canvas.height),
        s.viewport(0, 0, s.canvas.width, s.canvas.height),
        s.pixelStorei(s.PACK_ALIGNMENT, 4),
        s.pixelStorei(s.UNPACK_ALIGNMENT, 4),
        s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, !1),
        s.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1),
        s.pixelStorei(
          s.UNPACK_COLORSPACE_CONVERSION_WEBGL,
          s.BROWSER_DEFAULT_WEBGL,
        ),
        s.pixelStorei(s.PACK_ROW_LENGTH, 0),
        s.pixelStorei(s.PACK_SKIP_PIXELS, 0),
        s.pixelStorei(s.PACK_SKIP_ROWS, 0),
        s.pixelStorei(s.UNPACK_ROW_LENGTH, 0),
        s.pixelStorei(s.UNPACK_IMAGE_HEIGHT, 0),
        s.pixelStorei(s.UNPACK_SKIP_PIXELS, 0),
        s.pixelStorei(s.UNPACK_SKIP_ROWS, 0),
        s.pixelStorei(s.UNPACK_SKIP_IMAGES, 0),
        (u = {}),
        (f = {}),
        (Z = null),
        (Ne = {}),
        (d = {}),
        (p = new WeakMap()),
        (_ = []),
        (x = null),
        (g = !1),
        (v = null),
        (w = null),
        (L = null),
        (R = null),
        (U = null),
        (O = null),
        (N = null),
        (M = new je(0, 0, 0)),
        (I = 0),
        (z = !1),
        (W = null),
        (q = null),
        (re = null),
        (oe = null),
        (K = null),
        ot.set(0, 0, s.canvas.width, s.canvas.height),
        tt.set(0, 0, s.canvas.width, s.canvas.height),
        r.reset(),
        o.reset(),
        a.reset());
    }
    return {
      buffers: { color: r, depth: o, stencil: a },
      enable: Ae,
      disable: Ze,
      bindFramebuffer: nt,
      drawBuffers: Le,
      useProgram: At,
      setBlending: Tt,
      setMaterial: at,
      setFlipSided: ue,
      setCullFace: Rt,
      setLineWidth: ti,
      setPolygonOffset: ee,
      setScissorTest: xt,
      activeTexture: _t,
      bindTexture: Ut,
      unbindTexture: Ue,
      compressedTexImage2D: bt,
      compressedTexImage3D: H,
      texImage2D: ge,
      texImage3D: be,
      pixelStorei: Ve,
      getParameter: ke,
      updateUBOMapping: Fe,
      uniformBlockBinding: rt,
      texStorage2D: Oe,
      texStorage3D: Re,
      texSubImage2D: C,
      texSubImage3D: se,
      compressedTexSubImage2D: _e,
      compressedTexSubImage3D: we,
      scissor: Te,
      viewport: Ie,
      reset: vt,
    };
  }
  function qR(s, e, t, i, n, r, o) {
    let a = e.has('WEBGL_multisampled_render_to_texture')
        ? e.get('WEBGL_multisampled_render_to_texture')
        : null,
      l =
        typeof navigator == 'undefined'
          ? !1
          : /OculusBrowser/g.test(navigator.userAgent),
      c = new et(),
      u = new WeakMap(),
      f = new Set(),
      d,
      p = new WeakMap(),
      _ = !1;
    try {
      _ =
        typeof OffscreenCanvas != 'undefined' &&
        new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (H) {}
    function x(H, C) {
      return _ ? new OffscreenCanvas(H, C) : Wa('canvas');
    }
    function g(H, C, se) {
      let _e = 1,
        we = bt(H);
      if (
        ((we.width > se || we.height > se) &&
          (_e = se / Math.max(we.width, we.height)),
        _e < 1)
      )
        if (
          (typeof HTMLImageElement != 'undefined' &&
            H instanceof HTMLImageElement) ||
          (typeof HTMLCanvasElement != 'undefined' &&
            H instanceof HTMLCanvasElement) ||
          (typeof ImageBitmap != 'undefined' && H instanceof ImageBitmap) ||
          (typeof VideoFrame != 'undefined' && H instanceof VideoFrame)
        ) {
          let Oe = Math.floor(_e * we.width),
            Re = Math.floor(_e * we.height);
          d === void 0 && (d = x(Oe, Re));
          let ge = C ? x(Oe, Re) : d;
          return (
            (ge.width = Oe),
            (ge.height = Re),
            ge.getContext('2d').drawImage(H, 0, 0, Oe, Re),
            it(
              'WebGLRenderer: Texture has been resized from (' +
                we.width +
                'x' +
                we.height +
                ') to (' +
                Oe +
                'x' +
                Re +
                ').',
            ),
            ge
          );
        } else
          return (
            'data' in H &&
              it(
                'WebGLRenderer: Image in DataTexture is too big (' +
                  we.width +
                  'x' +
                  we.height +
                  ').',
              ),
            H
          );
      return H;
    }
    function v(H) {
      return H.generateMipmaps;
    }
    function w(H) {
      s.generateMipmap(H);
    }
    function L(H) {
      return H.isWebGLCubeRenderTarget
        ? s.TEXTURE_CUBE_MAP
        : H.isWebGL3DRenderTarget
          ? s.TEXTURE_3D
          : H.isWebGLArrayRenderTarget || H.isCompressedArrayTexture
            ? s.TEXTURE_2D_ARRAY
            : s.TEXTURE_2D;
    }
    function R(H, C, se, _e, we, Oe = !1) {
      if (H !== null) {
        if (s[H] !== void 0) return s[H];
        it(
          "WebGLRenderer: Attempt to use non-existing WebGL internal format '" +
            H +
            "'",
        );
      }
      let Re;
      _e &&
        ((Re = e.get('EXT_texture_norm16')),
        Re ||
          it(
            'WebGLRenderer: Unable to use normalized textures without EXT_texture_norm16 extension',
          ));
      let ge = C;
      if (
        (C === s.RED &&
          (se === s.FLOAT && (ge = s.R32F),
          se === s.HALF_FLOAT && (ge = s.R16F),
          se === s.UNSIGNED_BYTE && (ge = s.R8),
          se === s.UNSIGNED_SHORT && Re && (ge = Re.R16_EXT),
          se === s.SHORT && Re && (ge = Re.R16_SNORM_EXT)),
        C === s.RED_INTEGER &&
          (se === s.UNSIGNED_BYTE && (ge = s.R8UI),
          se === s.UNSIGNED_SHORT && (ge = s.R16UI),
          se === s.UNSIGNED_INT && (ge = s.R32UI),
          se === s.BYTE && (ge = s.R8I),
          se === s.SHORT && (ge = s.R16I),
          se === s.INT && (ge = s.R32I)),
        C === s.RG &&
          (se === s.FLOAT && (ge = s.RG32F),
          se === s.HALF_FLOAT && (ge = s.RG16F),
          se === s.UNSIGNED_BYTE && (ge = s.RG8),
          se === s.UNSIGNED_SHORT && Re && (ge = Re.RG16_EXT),
          se === s.SHORT && Re && (ge = Re.RG16_SNORM_EXT)),
        C === s.RG_INTEGER &&
          (se === s.UNSIGNED_BYTE && (ge = s.RG8UI),
          se === s.UNSIGNED_SHORT && (ge = s.RG16UI),
          se === s.UNSIGNED_INT && (ge = s.RG32UI),
          se === s.BYTE && (ge = s.RG8I),
          se === s.SHORT && (ge = s.RG16I),
          se === s.INT && (ge = s.RG32I)),
        C === s.RGB_INTEGER &&
          (se === s.UNSIGNED_BYTE && (ge = s.RGB8UI),
          se === s.UNSIGNED_SHORT && (ge = s.RGB16UI),
          se === s.UNSIGNED_INT && (ge = s.RGB32UI),
          se === s.BYTE && (ge = s.RGB8I),
          se === s.SHORT && (ge = s.RGB16I),
          se === s.INT && (ge = s.RGB32I)),
        C === s.RGBA_INTEGER &&
          (se === s.UNSIGNED_BYTE && (ge = s.RGBA8UI),
          se === s.UNSIGNED_SHORT && (ge = s.RGBA16UI),
          se === s.UNSIGNED_INT && (ge = s.RGBA32UI),
          se === s.BYTE && (ge = s.RGBA8I),
          se === s.SHORT && (ge = s.RGBA16I),
          se === s.INT && (ge = s.RGBA32I)),
        C === s.RGB &&
          (se === s.UNSIGNED_SHORT && Re && (ge = Re.RGB16_EXT),
          se === s.SHORT && Re && (ge = Re.RGB16_SNORM_EXT),
          se === s.UNSIGNED_INT_5_9_9_9_REV && (ge = s.RGB9_E5),
          se === s.UNSIGNED_INT_10F_11F_11F_REV && (ge = s.R11F_G11F_B10F)),
        C === s.RGBA)
      ) {
        let be = Oe ? dc : Ct.getTransfer(we);
        (se === s.FLOAT && (ge = s.RGBA32F),
          se === s.HALF_FLOAT && (ge = s.RGBA16F),
          se === s.UNSIGNED_BYTE && (ge = be === Kt ? s.SRGB8_ALPHA8 : s.RGBA8),
          se === s.UNSIGNED_SHORT && Re && (ge = Re.RGBA16_EXT),
          se === s.SHORT && Re && (ge = Re.RGBA16_SNORM_EXT),
          se === s.UNSIGNED_SHORT_4_4_4_4 && (ge = s.RGBA4),
          se === s.UNSIGNED_SHORT_5_5_5_1 && (ge = s.RGB5_A1));
      }
      return (
        (ge === s.R16F ||
          ge === s.R32F ||
          ge === s.RG16F ||
          ge === s.RG32F ||
          ge === s.RGBA16F ||
          ge === s.RGBA32F) &&
          e.get('EXT_color_buffer_float'),
        ge
      );
    }
    function U(H, C) {
      let se;
      return (
        H
          ? C === null || C === Rs || C === rl
            ? (se = s.DEPTH24_STENCIL8)
            : C === Xn
              ? (se = s.DEPTH32F_STENCIL8)
              : C === sl &&
                ((se = s.DEPTH24_STENCIL8),
                it(
                  'DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.',
                ))
          : C === null || C === Rs || C === rl
            ? (se = s.DEPTH_COMPONENT24)
            : C === Xn
              ? (se = s.DEPTH_COMPONENT32F)
              : C === sl && (se = s.DEPTH_COMPONENT16),
        se
      );
    }
    function O(H, C) {
      return v(H) === !0 ||
        (H.isFramebufferTexture && H.minFilter !== bi && H.minFilter !== Si)
        ? Math.log2(Math.max(C.width, C.height)) + 1
        : H.mipmaps !== void 0 && H.mipmaps.length > 0
          ? H.mipmaps.length
          : H.isCompressedTexture && Array.isArray(H.image)
            ? C.mipmaps.length
            : 1;
    }
    function N(H) {
      let C = H.target;
      (C.removeEventListener('dispose', N),
        I(C),
        C.isVideoTexture && u.delete(C),
        C.isHTMLTexture && f.delete(C));
    }
    function M(H) {
      let C = H.target;
      (C.removeEventListener('dispose', M), W(C));
    }
    function I(H) {
      let C = i.get(H);
      if (C.__webglInit === void 0) return;
      let se = H.source,
        _e = p.get(se);
      if (_e) {
        let we = _e[C.__cacheKey];
        (we.usedTimes--,
          we.usedTimes === 0 && z(H),
          Object.keys(_e).length === 0 && p.delete(se));
      }
      i.remove(H);
    }
    function z(H) {
      let C = i.get(H);
      s.deleteTexture(C.__webglTexture);
      let se = H.source,
        _e = p.get(se);
      (delete _e[C.__cacheKey], o.memory.textures--);
    }
    function W(H) {
      let C = i.get(H);
      if (
        (H.depthTexture && (H.depthTexture.dispose(), i.remove(H.depthTexture)),
        H.isWebGLCubeRenderTarget)
      )
        for (let _e = 0; _e < 6; _e++) {
          if (Array.isArray(C.__webglFramebuffer[_e]))
            for (let we = 0; we < C.__webglFramebuffer[_e].length; we++)
              s.deleteFramebuffer(C.__webglFramebuffer[_e][we]);
          else s.deleteFramebuffer(C.__webglFramebuffer[_e]);
          C.__webglDepthbuffer &&
            s.deleteRenderbuffer(C.__webglDepthbuffer[_e]);
        }
      else {
        if (Array.isArray(C.__webglFramebuffer))
          for (let _e = 0; _e < C.__webglFramebuffer.length; _e++)
            s.deleteFramebuffer(C.__webglFramebuffer[_e]);
        else s.deleteFramebuffer(C.__webglFramebuffer);
        if (
          (C.__webglDepthbuffer && s.deleteRenderbuffer(C.__webglDepthbuffer),
          C.__webglMultisampledFramebuffer &&
            s.deleteFramebuffer(C.__webglMultisampledFramebuffer),
          C.__webglColorRenderbuffer)
        )
          for (let _e = 0; _e < C.__webglColorRenderbuffer.length; _e++)
            C.__webglColorRenderbuffer[_e] &&
              s.deleteRenderbuffer(C.__webglColorRenderbuffer[_e]);
        C.__webglDepthRenderbuffer &&
          s.deleteRenderbuffer(C.__webglDepthRenderbuffer);
      }
      let se = H.textures;
      for (let _e = 0, we = se.length; _e < we; _e++) {
        let Oe = i.get(se[_e]);
        (Oe.__webglTexture &&
          (s.deleteTexture(Oe.__webglTexture), o.memory.textures--),
          i.remove(se[_e]));
      }
      i.remove(H);
    }
    let q = 0;
    function re() {
      q = 0;
    }
    function oe() {
      return q;
    }
    function K(H) {
      q = H;
    }
    function ie() {
      let H = q;
      return (
        H >= n.maxTextures &&
          it(
            'WebGLTextures: Trying to use ' +
              H +
              ' texture units while this GPU supports only ' +
              n.maxTextures,
          ),
        (q += 1),
        H
      );
    }
    function J(H) {
      let C = [];
      return (
        C.push(H.wrapS),
        C.push(H.wrapT),
        C.push(H.wrapR || 0),
        C.push(H.magFilter),
        C.push(H.minFilter),
        C.push(H.anisotropy),
        C.push(H.internalFormat),
        C.push(H.format),
        C.push(H.type),
        C.push(H.generateMipmaps),
        C.push(H.premultiplyAlpha),
        C.push(H.flipY),
        C.push(H.unpackAlignment),
        C.push(H.colorSpace),
        C.join()
      );
    }
    function pe(H, C) {
      let se = i.get(H);
      if (
        (H.isVideoTexture && Ut(H),
        H.isRenderTargetTexture === !1 &&
          H.isExternalTexture !== !0 &&
          H.version > 0 &&
          se.__version !== H.version)
      ) {
        let _e = H.image;
        if (_e === null)
          it(
            'WebGLRenderer: Texture marked for update but no image data found.',
          );
        else if (_e.complete === !1)
          it(
            'WebGLRenderer: Texture marked for update but image is incomplete',
          );
        else {
          Ze(se, H, C);
          return;
        }
      } else
        H.isExternalTexture &&
          (se.__webglTexture = H.sourceTexture ? H.sourceTexture : null);
      t.bindTexture(s.TEXTURE_2D, se.__webglTexture, s.TEXTURE0 + C);
    }
    function Ee(H, C) {
      let se = i.get(H);
      if (
        H.isRenderTargetTexture === !1 &&
        H.version > 0 &&
        se.__version !== H.version
      ) {
        Ze(se, H, C);
        return;
      } else
        H.isExternalTexture &&
          (se.__webglTexture = H.sourceTexture ? H.sourceTexture : null);
      t.bindTexture(s.TEXTURE_2D_ARRAY, se.__webglTexture, s.TEXTURE0 + C);
    }
    function Z(H, C) {
      let se = i.get(H);
      if (
        H.isRenderTargetTexture === !1 &&
        H.version > 0 &&
        se.__version !== H.version
      ) {
        Ze(se, H, C);
        return;
      }
      t.bindTexture(s.TEXTURE_3D, se.__webglTexture, s.TEXTURE0 + C);
    }
    function Ne(H, C) {
      let se = i.get(H);
      if (
        H.isCubeDepthTexture !== !0 &&
        H.version > 0 &&
        se.__version !== H.version
      ) {
        nt(se, H, C);
        return;
      }
      t.bindTexture(s.TEXTURE_CUBE_MAP, se.__webglTexture, s.TEXTURE0 + C);
    }
    let Be = { [Qr]: s.REPEAT, [ns]: s.CLAMP_TO_EDGE, [Va]: s.MIRRORED_REPEAT },
      ht = {
        [bi]: s.NEAREST,
        [Qu]: s.NEAREST_MIPMAP_NEAREST,
        [Qo]: s.NEAREST_MIPMAP_LINEAR,
        [Si]: s.LINEAR,
        [nl]: s.LINEAR_MIPMAP_NEAREST,
        [As]: s.LINEAR_MIPMAP_LINEAR,
      },
      ot = {
        [fy]: s.NEVER,
        [vy]: s.ALWAYS,
        [py]: s.LESS,
        [Bd]: s.LEQUAL,
        [my]: s.EQUAL,
        [kd]: s.GEQUAL,
        [gy]: s.GREATER,
        [_y]: s.NOTEQUAL,
      };
    function tt(H, C) {
      if (
        (C.type === Xn &&
          e.has('OES_texture_float_linear') === !1 &&
          (C.magFilter === Si ||
            C.magFilter === nl ||
            C.magFilter === Qo ||
            C.magFilter === As ||
            C.minFilter === Si ||
            C.minFilter === nl ||
            C.minFilter === Qo ||
            C.minFilter === As) &&
          it(
            'WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.',
          ),
        s.texParameteri(H, s.TEXTURE_WRAP_S, Be[C.wrapS]),
        s.texParameteri(H, s.TEXTURE_WRAP_T, Be[C.wrapT]),
        (H === s.TEXTURE_3D || H === s.TEXTURE_2D_ARRAY) &&
          s.texParameteri(H, s.TEXTURE_WRAP_R, Be[C.wrapR]),
        s.texParameteri(H, s.TEXTURE_MAG_FILTER, ht[C.magFilter]),
        s.texParameteri(H, s.TEXTURE_MIN_FILTER, ht[C.minFilter]),
        C.compareFunction &&
          (s.texParameteri(H, s.TEXTURE_COMPARE_MODE, s.COMPARE_REF_TO_TEXTURE),
          s.texParameteri(H, s.TEXTURE_COMPARE_FUNC, ot[C.compareFunction])),
        e.has('EXT_texture_filter_anisotropic') === !0)
      ) {
        if (
          C.magFilter === bi ||
          (C.minFilter !== Qo && C.minFilter !== As) ||
          (C.type === Xn && e.has('OES_texture_float_linear') === !1)
        )
          return;
        if (C.anisotropy > 1 || i.get(C).__currentAnisotropy) {
          let se = e.get('EXT_texture_filter_anisotropic');
          (s.texParameterf(
            H,
            se.TEXTURE_MAX_ANISOTROPY_EXT,
            Math.min(C.anisotropy, n.getMaxAnisotropy()),
          ),
            (i.get(C).__currentAnisotropy = C.anisotropy));
        }
      }
    }
    function ve(H, C) {
      let se = !1;
      H.__webglInit === void 0 &&
        ((H.__webglInit = !0), C.addEventListener('dispose', N));
      let _e = C.source,
        we = p.get(_e);
      we === void 0 && ((we = {}), p.set(_e, we));
      let Oe = J(C);
      if (Oe !== H.__cacheKey) {
        (we[Oe] === void 0 &&
          ((we[Oe] = { texture: s.createTexture(), usedTimes: 0 }),
          o.memory.textures++,
          (se = !0)),
          we[Oe].usedTimes++);
        let Re = we[H.__cacheKey];
        (Re !== void 0 &&
          (we[H.__cacheKey].usedTimes--, Re.usedTimes === 0 && z(C)),
          (H.__cacheKey = Oe),
          (H.__webglTexture = we[Oe].texture));
      }
      return se;
    }
    function Pe(H, C, se) {
      return Math.floor(Math.floor(H / se) / C);
    }
    function Ae(H, C, se, _e) {
      let Oe = H.updateRanges;
      if (Oe.length === 0)
        t.texSubImage2D(
          s.TEXTURE_2D,
          0,
          0,
          0,
          C.width,
          C.height,
          se,
          _e,
          C.data,
        );
      else {
        Oe.sort((Ve, Te) => Ve.start - Te.start);
        let Re = 0;
        for (let Ve = 1; Ve < Oe.length; Ve++) {
          let Te = Oe[Re],
            Ie = Oe[Ve],
            Fe = Te.start + Te.count,
            rt = Pe(Ie.start, C.width, 4),
            vt = Pe(Te.start, C.width, 4);
          Ie.start <= Fe + 1 &&
          rt === vt &&
          Pe(Ie.start + Ie.count - 1, C.width, 4) === rt
            ? (Te.count = Math.max(Te.count, Ie.start + Ie.count - Te.start))
            : (++Re, (Oe[Re] = Ie));
        }
        Oe.length = Re + 1;
        let ge = t.getParameter(s.UNPACK_ROW_LENGTH),
          be = t.getParameter(s.UNPACK_SKIP_PIXELS),
          ke = t.getParameter(s.UNPACK_SKIP_ROWS);
        t.pixelStorei(s.UNPACK_ROW_LENGTH, C.width);
        for (let Ve = 0, Te = Oe.length; Ve < Te; Ve++) {
          let Ie = Oe[Ve],
            Fe = Math.floor(Ie.start / 4),
            rt = Math.ceil(Ie.count / 4),
            vt = Fe % C.width,
            j = Math.floor(Fe / C.width),
            Ce = rt,
            ye = 1;
          (t.pixelStorei(s.UNPACK_SKIP_PIXELS, vt),
            t.pixelStorei(s.UNPACK_SKIP_ROWS, j),
            t.texSubImage2D(s.TEXTURE_2D, 0, vt, j, Ce, ye, se, _e, C.data));
        }
        (H.clearUpdateRanges(),
          t.pixelStorei(s.UNPACK_ROW_LENGTH, ge),
          t.pixelStorei(s.UNPACK_SKIP_PIXELS, be),
          t.pixelStorei(s.UNPACK_SKIP_ROWS, ke));
      }
    }
    function Ze(H, C, se) {
      let _e = s.TEXTURE_2D;
      ((C.isDataArrayTexture || C.isCompressedArrayTexture) &&
        (_e = s.TEXTURE_2D_ARRAY),
        C.isData3DTexture && (_e = s.TEXTURE_3D));
      let we = ve(H, C),
        Oe = C.source;
      t.bindTexture(_e, H.__webglTexture, s.TEXTURE0 + se);
      let Re = i.get(Oe);
      if (Oe.version !== Re.__version || we === !0) {
        if (
          (t.activeTexture(s.TEXTURE0 + se),
          (typeof ImageBitmap != 'undefined' &&
            C.image instanceof ImageBitmap) === !1)
        ) {
          let ye = Ct.getPrimaries(Ct.workingColorSpace),
            D = C.colorSpace === Lr ? null : Ct.getPrimaries(C.colorSpace),
            h =
              C.colorSpace === Lr || ye === D
                ? s.NONE
                : s.BROWSER_DEFAULT_WEBGL;
          (t.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, C.flipY),
            t.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, C.premultiplyAlpha),
            t.pixelStorei(s.UNPACK_COLORSPACE_CONVERSION_WEBGL, h));
        }
        t.pixelStorei(s.UNPACK_ALIGNMENT, C.unpackAlignment);
        let be = g(C.image, !1, n.maxTextureSize);
        be = Ue(C, be);
        let ke = r.convert(C.format, C.colorSpace),
          Ve = r.convert(C.type),
          Te = R(
            C.internalFormat,
            ke,
            Ve,
            C.normalized,
            C.colorSpace,
            C.isVideoTexture,
          );
        tt(_e, C);
        let Ie,
          Fe = C.mipmaps,
          rt = C.isVideoTexture !== !0,
          vt = Re.__version === void 0 || we === !0,
          j = Oe.dataReady,
          Ce = O(C, be);
        if (C.isDepthTexture)
          ((Te = U(C.format === ao, C.type)),
            vt &&
              (rt
                ? t.texStorage2D(s.TEXTURE_2D, 1, Te, be.width, be.height)
                : t.texImage2D(
                    s.TEXTURE_2D,
                    0,
                    Te,
                    be.width,
                    be.height,
                    0,
                    ke,
                    Ve,
                    null,
                  )));
        else if (C.isDataTexture)
          if (Fe.length > 0) {
            rt &&
              vt &&
              t.texStorage2D(s.TEXTURE_2D, Ce, Te, Fe[0].width, Fe[0].height);
            for (let ye = 0, D = Fe.length; ye < D; ye++)
              ((Ie = Fe[ye]),
                rt
                  ? j &&
                    t.texSubImage2D(
                      s.TEXTURE_2D,
                      ye,
                      0,
                      0,
                      Ie.width,
                      Ie.height,
                      ke,
                      Ve,
                      Ie.data,
                    )
                  : t.texImage2D(
                      s.TEXTURE_2D,
                      ye,
                      Te,
                      Ie.width,
                      Ie.height,
                      0,
                      ke,
                      Ve,
                      Ie.data,
                    ));
            C.generateMipmaps = !1;
          } else
            rt
              ? (vt &&
                  t.texStorage2D(s.TEXTURE_2D, Ce, Te, be.width, be.height),
                j && Ae(C, be, ke, Ve))
              : t.texImage2D(
                  s.TEXTURE_2D,
                  0,
                  Te,
                  be.width,
                  be.height,
                  0,
                  ke,
                  Ve,
                  be.data,
                );
        else if (C.isCompressedTexture)
          if (C.isCompressedArrayTexture) {
            rt &&
              vt &&
              t.texStorage3D(
                s.TEXTURE_2D_ARRAY,
                Ce,
                Te,
                Fe[0].width,
                Fe[0].height,
                be.depth,
              );
            for (let ye = 0, D = Fe.length; ye < D; ye++)
              if (((Ie = Fe[ye]), C.format !== Yn))
                if (ke !== null)
                  if (rt) {
                    if (j)
                      if (C.layerUpdates.size > 0) {
                        let h = vg(Ie.width, Ie.height, C.format, C.type);
                        for (let m of C.layerUpdates) {
                          let b = Ie.data.subarray(
                            (m * h) / Ie.data.BYTES_PER_ELEMENT,
                            ((m + 1) * h) / Ie.data.BYTES_PER_ELEMENT,
                          );
                          t.compressedTexSubImage3D(
                            s.TEXTURE_2D_ARRAY,
                            ye,
                            0,
                            0,
                            m,
                            Ie.width,
                            Ie.height,
                            1,
                            ke,
                            b,
                          );
                        }
                        C.clearLayerUpdates();
                      } else
                        t.compressedTexSubImage3D(
                          s.TEXTURE_2D_ARRAY,
                          ye,
                          0,
                          0,
                          0,
                          Ie.width,
                          Ie.height,
                          be.depth,
                          ke,
                          Ie.data,
                        );
                  } else
                    t.compressedTexImage3D(
                      s.TEXTURE_2D_ARRAY,
                      ye,
                      Te,
                      Ie.width,
                      Ie.height,
                      be.depth,
                      0,
                      Ie.data,
                      0,
                      0,
                    );
                else
                  it(
                    'WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()',
                  );
              else
                rt
                  ? j &&
                    t.texSubImage3D(
                      s.TEXTURE_2D_ARRAY,
                      ye,
                      0,
                      0,
                      0,
                      Ie.width,
                      Ie.height,
                      be.depth,
                      ke,
                      Ve,
                      Ie.data,
                    )
                  : t.texImage3D(
                      s.TEXTURE_2D_ARRAY,
                      ye,
                      Te,
                      Ie.width,
                      Ie.height,
                      be.depth,
                      0,
                      ke,
                      Ve,
                      Ie.data,
                    );
          } else {
            rt &&
              vt &&
              t.texStorage2D(s.TEXTURE_2D, Ce, Te, Fe[0].width, Fe[0].height);
            for (let ye = 0, D = Fe.length; ye < D; ye++)
              ((Ie = Fe[ye]),
                C.format !== Yn
                  ? ke !== null
                    ? rt
                      ? j &&
                        t.compressedTexSubImage2D(
                          s.TEXTURE_2D,
                          ye,
                          0,
                          0,
                          Ie.width,
                          Ie.height,
                          ke,
                          Ie.data,
                        )
                      : t.compressedTexImage2D(
                          s.TEXTURE_2D,
                          ye,
                          Te,
                          Ie.width,
                          Ie.height,
                          0,
                          Ie.data,
                        )
                    : it(
                        'WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()',
                      )
                  : rt
                    ? j &&
                      t.texSubImage2D(
                        s.TEXTURE_2D,
                        ye,
                        0,
                        0,
                        Ie.width,
                        Ie.height,
                        ke,
                        Ve,
                        Ie.data,
                      )
                    : t.texImage2D(
                        s.TEXTURE_2D,
                        ye,
                        Te,
                        Ie.width,
                        Ie.height,
                        0,
                        ke,
                        Ve,
                        Ie.data,
                      ));
          }
        else if (C.isDataArrayTexture)
          if (rt) {
            if (
              (vt &&
                t.texStorage3D(
                  s.TEXTURE_2D_ARRAY,
                  Ce,
                  Te,
                  be.width,
                  be.height,
                  be.depth,
                ),
              j)
            )
              if (C.layerUpdates.size > 0) {
                let ye = vg(be.width, be.height, C.format, C.type);
                for (let D of C.layerUpdates) {
                  let h = be.data.subarray(
                    (D * ye) / be.data.BYTES_PER_ELEMENT,
                    ((D + 1) * ye) / be.data.BYTES_PER_ELEMENT,
                  );
                  t.texSubImage3D(
                    s.TEXTURE_2D_ARRAY,
                    0,
                    0,
                    0,
                    D,
                    be.width,
                    be.height,
                    1,
                    ke,
                    Ve,
                    h,
                  );
                }
                C.clearLayerUpdates();
              } else
                t.texSubImage3D(
                  s.TEXTURE_2D_ARRAY,
                  0,
                  0,
                  0,
                  0,
                  be.width,
                  be.height,
                  be.depth,
                  ke,
                  Ve,
                  be.data,
                );
          } else
            t.texImage3D(
              s.TEXTURE_2D_ARRAY,
              0,
              Te,
              be.width,
              be.height,
              be.depth,
              0,
              ke,
              Ve,
              be.data,
            );
        else if (C.isData3DTexture)
          rt
            ? (vt &&
                t.texStorage3D(
                  s.TEXTURE_3D,
                  Ce,
                  Te,
                  be.width,
                  be.height,
                  be.depth,
                ),
              j &&
                t.texSubImage3D(
                  s.TEXTURE_3D,
                  0,
                  0,
                  0,
                  0,
                  be.width,
                  be.height,
                  be.depth,
                  ke,
                  Ve,
                  be.data,
                ))
            : t.texImage3D(
                s.TEXTURE_3D,
                0,
                Te,
                be.width,
                be.height,
                be.depth,
                0,
                ke,
                Ve,
                be.data,
              );
        else if (C.isFramebufferTexture) {
          if (vt)
            if (rt) t.texStorage2D(s.TEXTURE_2D, Ce, Te, be.width, be.height);
            else {
              let ye = be.width,
                D = be.height;
              for (let h = 0; h < Ce; h++)
                (t.texImage2D(s.TEXTURE_2D, h, Te, ye, D, 0, ke, Ve, null),
                  (ye >>= 1),
                  (D >>= 1));
            }
        } else if (C.isHTMLTexture) {
          if ('texElementImage2D' in s) {
            let ye = s.canvas;
            if (
              (ye.hasAttribute('layoutsubtree') ||
                ye.setAttribute('layoutsubtree', 'true'),
              be.parentNode !== ye)
            ) {
              (ye.appendChild(be),
                f.add(C),
                (ye.onpaint = (S) => {
                  let E = S.changedElements;
                  for (let A of f) E.includes(A.image) && (A.needsUpdate = !0);
                }),
                ye.requestPaint());
              return;
            }
            let D = 0,
              h = s.RGBA,
              m = s.RGBA,
              b = s.UNSIGNED_BYTE;
            (s.texElementImage2D(s.TEXTURE_2D, D, h, m, b, be),
              s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, s.LINEAR),
              s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE),
              s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE));
          }
        } else if (Fe.length > 0) {
          if (rt && vt) {
            let ye = bt(Fe[0]);
            t.texStorage2D(s.TEXTURE_2D, Ce, Te, ye.width, ye.height);
          }
          for (let ye = 0, D = Fe.length; ye < D; ye++)
            ((Ie = Fe[ye]),
              rt
                ? j && t.texSubImage2D(s.TEXTURE_2D, ye, 0, 0, ke, Ve, Ie)
                : t.texImage2D(s.TEXTURE_2D, ye, Te, ke, Ve, Ie));
          C.generateMipmaps = !1;
        } else if (rt) {
          if (vt) {
            let ye = bt(be);
            t.texStorage2D(s.TEXTURE_2D, Ce, Te, ye.width, ye.height);
          }
          j && t.texSubImage2D(s.TEXTURE_2D, 0, 0, 0, ke, Ve, be);
        } else t.texImage2D(s.TEXTURE_2D, 0, Te, ke, Ve, be);
        (v(C) && w(_e),
          (Re.__version = Oe.version),
          C.onUpdate && C.onUpdate(C));
      }
      H.__version = C.version;
    }
    function nt(H, C, se) {
      if (C.image.length !== 6) return;
      let _e = ve(H, C),
        we = C.source;
      t.bindTexture(s.TEXTURE_CUBE_MAP, H.__webglTexture, s.TEXTURE0 + se);
      let Oe = i.get(we);
      if (we.version !== Oe.__version || _e === !0) {
        t.activeTexture(s.TEXTURE0 + se);
        let Re = Ct.getPrimaries(Ct.workingColorSpace),
          ge = C.colorSpace === Lr ? null : Ct.getPrimaries(C.colorSpace),
          be =
            C.colorSpace === Lr || Re === ge ? s.NONE : s.BROWSER_DEFAULT_WEBGL;
        (t.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, C.flipY),
          t.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, C.premultiplyAlpha),
          t.pixelStorei(s.UNPACK_ALIGNMENT, C.unpackAlignment),
          t.pixelStorei(s.UNPACK_COLORSPACE_CONVERSION_WEBGL, be));
        let ke = C.isCompressedTexture || C.image[0].isCompressedTexture,
          Ve = C.image[0] && C.image[0].isDataTexture,
          Te = [];
        for (let m = 0; m < 6; m++)
          (!ke && !Ve
            ? (Te[m] = g(C.image[m], !0, n.maxCubemapSize))
            : (Te[m] = Ve ? C.image[m].image : C.image[m]),
            (Te[m] = Ue(C, Te[m])));
        let Ie = Te[0],
          Fe = r.convert(C.format, C.colorSpace),
          rt = r.convert(C.type),
          vt = R(C.internalFormat, Fe, rt, C.normalized, C.colorSpace),
          j = C.isVideoTexture !== !0,
          Ce = Oe.__version === void 0 || _e === !0,
          ye = we.dataReady,
          D = O(C, Ie);
        tt(s.TEXTURE_CUBE_MAP, C);
        let h;
        if (ke) {
          j &&
            Ce &&
            t.texStorage2D(s.TEXTURE_CUBE_MAP, D, vt, Ie.width, Ie.height);
          for (let m = 0; m < 6; m++) {
            h = Te[m].mipmaps;
            for (let b = 0; b < h.length; b++) {
              let S = h[b];
              C.format !== Yn
                ? Fe !== null
                  ? j
                    ? ye &&
                      t.compressedTexSubImage2D(
                        s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                        b,
                        0,
                        0,
                        S.width,
                        S.height,
                        Fe,
                        S.data,
                      )
                    : t.compressedTexImage2D(
                        s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                        b,
                        vt,
                        S.width,
                        S.height,
                        0,
                        S.data,
                      )
                  : it(
                      'WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()',
                    )
                : j
                  ? ye &&
                    t.texSubImage2D(
                      s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                      b,
                      0,
                      0,
                      S.width,
                      S.height,
                      Fe,
                      rt,
                      S.data,
                    )
                  : t.texImage2D(
                      s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                      b,
                      vt,
                      S.width,
                      S.height,
                      0,
                      Fe,
                      rt,
                      S.data,
                    );
            }
          }
        } else {
          if (((h = C.mipmaps), j && Ce)) {
            h.length > 0 && D++;
            let m = bt(Te[0]);
            t.texStorage2D(s.TEXTURE_CUBE_MAP, D, vt, m.width, m.height);
          }
          for (let m = 0; m < 6; m++)
            if (Ve) {
              j
                ? ye &&
                  t.texSubImage2D(
                    s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                    0,
                    0,
                    0,
                    Te[m].width,
                    Te[m].height,
                    Fe,
                    rt,
                    Te[m].data,
                  )
                : t.texImage2D(
                    s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                    0,
                    vt,
                    Te[m].width,
                    Te[m].height,
                    0,
                    Fe,
                    rt,
                    Te[m].data,
                  );
              for (let b = 0; b < h.length; b++) {
                let E = h[b].image[m].image;
                j
                  ? ye &&
                    t.texSubImage2D(
                      s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                      b + 1,
                      0,
                      0,
                      E.width,
                      E.height,
                      Fe,
                      rt,
                      E.data,
                    )
                  : t.texImage2D(
                      s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                      b + 1,
                      vt,
                      E.width,
                      E.height,
                      0,
                      Fe,
                      rt,
                      E.data,
                    );
              }
            } else {
              j
                ? ye &&
                  t.texSubImage2D(
                    s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                    0,
                    0,
                    0,
                    Fe,
                    rt,
                    Te[m],
                  )
                : t.texImage2D(
                    s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                    0,
                    vt,
                    Fe,
                    rt,
                    Te[m],
                  );
              for (let b = 0; b < h.length; b++) {
                let S = h[b];
                j
                  ? ye &&
                    t.texSubImage2D(
                      s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                      b + 1,
                      0,
                      0,
                      Fe,
                      rt,
                      S.image[m],
                    )
                  : t.texImage2D(
                      s.TEXTURE_CUBE_MAP_POSITIVE_X + m,
                      b + 1,
                      vt,
                      Fe,
                      rt,
                      S.image[m],
                    );
              }
            }
        }
        (v(C) && w(s.TEXTURE_CUBE_MAP),
          (Oe.__version = we.version),
          C.onUpdate && C.onUpdate(C));
      }
      H.__version = C.version;
    }
    function Le(H, C, se, _e, we, Oe) {
      let Re = r.convert(se.format, se.colorSpace),
        ge = r.convert(se.type),
        be = R(se.internalFormat, Re, ge, se.normalized, se.colorSpace),
        ke = i.get(C),
        Ve = i.get(se);
      if (((Ve.__renderTarget = C), !ke.__hasExternalTextures)) {
        let Te = Math.max(1, C.width >> Oe),
          Ie = Math.max(1, C.height >> Oe);
        we === s.TEXTURE_3D || we === s.TEXTURE_2D_ARRAY
          ? t.texImage3D(we, Oe, be, Te, Ie, C.depth, 0, Re, ge, null)
          : t.texImage2D(we, Oe, be, Te, Ie, 0, Re, ge, null);
      }
      (t.bindFramebuffer(s.FRAMEBUFFER, H),
        _t(C)
          ? a.framebufferTexture2DMultisampleEXT(
              s.FRAMEBUFFER,
              _e,
              we,
              Ve.__webglTexture,
              0,
              xt(C),
            )
          : (we === s.TEXTURE_2D ||
              (we >= s.TEXTURE_CUBE_MAP_POSITIVE_X &&
                we <= s.TEXTURE_CUBE_MAP_NEGATIVE_Z)) &&
            s.framebufferTexture2D(
              s.FRAMEBUFFER,
              _e,
              we,
              Ve.__webglTexture,
              Oe,
            ),
        t.bindFramebuffer(s.FRAMEBUFFER, null));
    }
    function At(H, C, se) {
      if ((s.bindRenderbuffer(s.RENDERBUFFER, H), C.depthBuffer)) {
        let _e = C.depthTexture,
          we = _e && _e.isDepthTexture ? _e.type : null,
          Oe = U(C.stencilBuffer, we),
          Re = C.stencilBuffer
            ? s.DEPTH_STENCIL_ATTACHMENT
            : s.DEPTH_ATTACHMENT;
        (_t(C)
          ? a.renderbufferStorageMultisampleEXT(
              s.RENDERBUFFER,
              xt(C),
              Oe,
              C.width,
              C.height,
            )
          : se
            ? s.renderbufferStorageMultisample(
                s.RENDERBUFFER,
                xt(C),
                Oe,
                C.width,
                C.height,
              )
            : s.renderbufferStorage(s.RENDERBUFFER, Oe, C.width, C.height),
          s.framebufferRenderbuffer(s.FRAMEBUFFER, Re, s.RENDERBUFFER, H));
      } else {
        let _e = C.textures;
        for (let we = 0; we < _e.length; we++) {
          let Oe = _e[we],
            Re = r.convert(Oe.format, Oe.colorSpace),
            ge = r.convert(Oe.type),
            be = R(Oe.internalFormat, Re, ge, Oe.normalized, Oe.colorSpace);
          _t(C)
            ? a.renderbufferStorageMultisampleEXT(
                s.RENDERBUFFER,
                xt(C),
                be,
                C.width,
                C.height,
              )
            : se
              ? s.renderbufferStorageMultisample(
                  s.RENDERBUFFER,
                  xt(C),
                  be,
                  C.width,
                  C.height,
                )
              : s.renderbufferStorage(s.RENDERBUFFER, be, C.width, C.height);
        }
      }
      s.bindRenderbuffer(s.RENDERBUFFER, null);
    }
    function Ke(H, C, se) {
      let _e = C.isWebGLCubeRenderTarget === !0;
      if (
        (t.bindFramebuffer(s.FRAMEBUFFER, H),
        !(C.depthTexture && C.depthTexture.isDepthTexture))
      )
        throw new Error(
          'renderTarget.depthTexture must be an instance of THREE.DepthTexture',
        );
      let we = i.get(C.depthTexture);
      if (
        ((we.__renderTarget = C),
        (!we.__webglTexture ||
          C.depthTexture.image.width !== C.width ||
          C.depthTexture.image.height !== C.height) &&
          ((C.depthTexture.image.width = C.width),
          (C.depthTexture.image.height = C.height),
          (C.depthTexture.needsUpdate = !0)),
        _e)
      ) {
        if (
          (we.__webglInit === void 0 &&
            ((we.__webglInit = !0),
            C.depthTexture.addEventListener('dispose', N)),
          we.__webglTexture === void 0)
        ) {
          ((we.__webglTexture = s.createTexture()),
            t.bindTexture(s.TEXTURE_CUBE_MAP, we.__webglTexture),
            tt(s.TEXTURE_CUBE_MAP, C.depthTexture));
          let ke = r.convert(C.depthTexture.format),
            Ve = r.convert(C.depthTexture.type),
            Te;
          C.depthTexture.format === qs
            ? (Te = s.DEPTH_COMPONENT24)
            : C.depthTexture.format === ao && (Te = s.DEPTH24_STENCIL8);
          for (let Ie = 0; Ie < 6; Ie++)
            s.texImage2D(
              s.TEXTURE_CUBE_MAP_POSITIVE_X + Ie,
              0,
              Te,
              C.width,
              C.height,
              0,
              ke,
              Ve,
              null,
            );
        }
      } else pe(C.depthTexture, 0);
      let Oe = we.__webglTexture,
        Re = xt(C),
        ge = _e ? s.TEXTURE_CUBE_MAP_POSITIVE_X + se : s.TEXTURE_2D,
        be =
          C.depthTexture.format === ao
            ? s.DEPTH_STENCIL_ATTACHMENT
            : s.DEPTH_ATTACHMENT;
      if (C.depthTexture.format === qs)
        _t(C)
          ? a.framebufferTexture2DMultisampleEXT(
              s.FRAMEBUFFER,
              be,
              ge,
              Oe,
              0,
              Re,
            )
          : s.framebufferTexture2D(s.FRAMEBUFFER, be, ge, Oe, 0);
      else if (C.depthTexture.format === ao)
        _t(C)
          ? a.framebufferTexture2DMultisampleEXT(
              s.FRAMEBUFFER,
              be,
              ge,
              Oe,
              0,
              Re,
            )
          : s.framebufferTexture2D(s.FRAMEBUFFER, be, ge, Oe, 0);
      else throw new Error('Unknown depthTexture format');
    }
    function ut(H) {
      let C = i.get(H),
        se = H.isWebGLCubeRenderTarget === !0;
      if (C.__boundDepthTexture !== H.depthTexture) {
        let _e = H.depthTexture;
        if ((C.__depthDisposeCallback && C.__depthDisposeCallback(), _e)) {
          let we = () => {
            (delete C.__boundDepthTexture,
              delete C.__depthDisposeCallback,
              _e.removeEventListener('dispose', we));
          };
          (_e.addEventListener('dispose', we), (C.__depthDisposeCallback = we));
        }
        C.__boundDepthTexture = _e;
      }
      if (H.depthTexture && !C.__autoAllocateDepthBuffer)
        if (se)
          for (let _e = 0; _e < 6; _e++) Ke(C.__webglFramebuffer[_e], H, _e);
        else {
          let _e = H.texture.mipmaps;
          _e && _e.length > 0
            ? Ke(C.__webglFramebuffer[0], H, 0)
            : Ke(C.__webglFramebuffer, H, 0);
        }
      else if (se) {
        C.__webglDepthbuffer = [];
        for (let _e = 0; _e < 6; _e++)
          if (
            (t.bindFramebuffer(s.FRAMEBUFFER, C.__webglFramebuffer[_e]),
            C.__webglDepthbuffer[_e] === void 0)
          )
            ((C.__webglDepthbuffer[_e] = s.createRenderbuffer()),
              At(C.__webglDepthbuffer[_e], H, !1));
          else {
            let we = H.stencilBuffer
                ? s.DEPTH_STENCIL_ATTACHMENT
                : s.DEPTH_ATTACHMENT,
              Oe = C.__webglDepthbuffer[_e];
            (s.bindRenderbuffer(s.RENDERBUFFER, Oe),
              s.framebufferRenderbuffer(s.FRAMEBUFFER, we, s.RENDERBUFFER, Oe));
          }
      } else {
        let _e = H.texture.mipmaps;
        if (
          (_e && _e.length > 0
            ? t.bindFramebuffer(s.FRAMEBUFFER, C.__webglFramebuffer[0])
            : t.bindFramebuffer(s.FRAMEBUFFER, C.__webglFramebuffer),
          C.__webglDepthbuffer === void 0)
        )
          ((C.__webglDepthbuffer = s.createRenderbuffer()),
            At(C.__webglDepthbuffer, H, !1));
        else {
          let we = H.stencilBuffer
              ? s.DEPTH_STENCIL_ATTACHMENT
              : s.DEPTH_ATTACHMENT,
            Oe = C.__webglDepthbuffer;
          (s.bindRenderbuffer(s.RENDERBUFFER, Oe),
            s.framebufferRenderbuffer(s.FRAMEBUFFER, we, s.RENDERBUFFER, Oe));
        }
      }
      t.bindFramebuffer(s.FRAMEBUFFER, null);
    }
    function Tt(H, C, se) {
      let _e = i.get(H);
      (C !== void 0 &&
        Le(
          _e.__webglFramebuffer,
          H,
          H.texture,
          s.COLOR_ATTACHMENT0,
          s.TEXTURE_2D,
          0,
        ),
        se !== void 0 && ut(H));
    }
    function at(H) {
      let C = H.texture,
        se = i.get(H),
        _e = i.get(C);
      H.addEventListener('dispose', M);
      let we = H.textures,
        Oe = H.isWebGLCubeRenderTarget === !0,
        Re = we.length > 1;
      if (
        (Re ||
          (_e.__webglTexture === void 0 &&
            (_e.__webglTexture = s.createTexture()),
          (_e.__version = C.version),
          o.memory.textures++),
        Oe)
      ) {
        se.__webglFramebuffer = [];
        for (let ge = 0; ge < 6; ge++)
          if (C.mipmaps && C.mipmaps.length > 0) {
            se.__webglFramebuffer[ge] = [];
            for (let be = 0; be < C.mipmaps.length; be++)
              se.__webglFramebuffer[ge][be] = s.createFramebuffer();
          } else se.__webglFramebuffer[ge] = s.createFramebuffer();
      } else {
        if (C.mipmaps && C.mipmaps.length > 0) {
          se.__webglFramebuffer = [];
          for (let ge = 0; ge < C.mipmaps.length; ge++)
            se.__webglFramebuffer[ge] = s.createFramebuffer();
        } else se.__webglFramebuffer = s.createFramebuffer();
        if (Re)
          for (let ge = 0, be = we.length; ge < be; ge++) {
            let ke = i.get(we[ge]);
            ke.__webglTexture === void 0 &&
              ((ke.__webglTexture = s.createTexture()), o.memory.textures++);
          }
        if (H.samples > 0 && _t(H) === !1) {
          ((se.__webglMultisampledFramebuffer = s.createFramebuffer()),
            (se.__webglColorRenderbuffer = []),
            t.bindFramebuffer(
              s.FRAMEBUFFER,
              se.__webglMultisampledFramebuffer,
            ));
          for (let ge = 0; ge < we.length; ge++) {
            let be = we[ge];
            ((se.__webglColorRenderbuffer[ge] = s.createRenderbuffer()),
              s.bindRenderbuffer(
                s.RENDERBUFFER,
                se.__webglColorRenderbuffer[ge],
              ));
            let ke = r.convert(be.format, be.colorSpace),
              Ve = r.convert(be.type),
              Te = R(
                be.internalFormat,
                ke,
                Ve,
                be.normalized,
                be.colorSpace,
                H.isXRRenderTarget === !0,
              ),
              Ie = xt(H);
            (s.renderbufferStorageMultisample(
              s.RENDERBUFFER,
              Ie,
              Te,
              H.width,
              H.height,
            ),
              s.framebufferRenderbuffer(
                s.FRAMEBUFFER,
                s.COLOR_ATTACHMENT0 + ge,
                s.RENDERBUFFER,
                se.__webglColorRenderbuffer[ge],
              ));
          }
          (s.bindRenderbuffer(s.RENDERBUFFER, null),
            H.depthBuffer &&
              ((se.__webglDepthRenderbuffer = s.createRenderbuffer()),
              At(se.__webglDepthRenderbuffer, H, !0)),
            t.bindFramebuffer(s.FRAMEBUFFER, null));
        }
      }
      if (Oe) {
        (t.bindTexture(s.TEXTURE_CUBE_MAP, _e.__webglTexture),
          tt(s.TEXTURE_CUBE_MAP, C));
        for (let ge = 0; ge < 6; ge++)
          if (C.mipmaps && C.mipmaps.length > 0)
            for (let be = 0; be < C.mipmaps.length; be++)
              Le(
                se.__webglFramebuffer[ge][be],
                H,
                C,
                s.COLOR_ATTACHMENT0,
                s.TEXTURE_CUBE_MAP_POSITIVE_X + ge,
                be,
              );
          else
            Le(
              se.__webglFramebuffer[ge],
              H,
              C,
              s.COLOR_ATTACHMENT0,
              s.TEXTURE_CUBE_MAP_POSITIVE_X + ge,
              0,
            );
        (v(C) && w(s.TEXTURE_CUBE_MAP), t.unbindTexture());
      } else if (Re) {
        for (let ge = 0, be = we.length; ge < be; ge++) {
          let ke = we[ge],
            Ve = i.get(ke),
            Te = s.TEXTURE_2D;
          ((H.isWebGL3DRenderTarget || H.isWebGLArrayRenderTarget) &&
            (Te = H.isWebGL3DRenderTarget ? s.TEXTURE_3D : s.TEXTURE_2D_ARRAY),
            t.bindTexture(Te, Ve.__webglTexture),
            tt(Te, ke),
            Le(se.__webglFramebuffer, H, ke, s.COLOR_ATTACHMENT0 + ge, Te, 0),
            v(ke) && w(Te));
        }
        t.unbindTexture();
      } else {
        let ge = s.TEXTURE_2D;
        if (
          ((H.isWebGL3DRenderTarget || H.isWebGLArrayRenderTarget) &&
            (ge = H.isWebGL3DRenderTarget ? s.TEXTURE_3D : s.TEXTURE_2D_ARRAY),
          t.bindTexture(ge, _e.__webglTexture),
          tt(ge, C),
          C.mipmaps && C.mipmaps.length > 0)
        )
          for (let be = 0; be < C.mipmaps.length; be++)
            Le(se.__webglFramebuffer[be], H, C, s.COLOR_ATTACHMENT0, ge, be);
        else Le(se.__webglFramebuffer, H, C, s.COLOR_ATTACHMENT0, ge, 0);
        (v(C) && w(ge), t.unbindTexture());
      }
      H.depthBuffer && ut(H);
    }
    function ue(H) {
      let C = H.textures;
      for (let se = 0, _e = C.length; se < _e; se++) {
        let we = C[se];
        if (v(we)) {
          let Oe = L(H),
            Re = i.get(we).__webglTexture;
          (t.bindTexture(Oe, Re), w(Oe), t.unbindTexture());
        }
      }
    }
    let Rt = [],
      ti = [];
    function ee(H) {
      if (H.samples > 0) {
        if (_t(H) === !1) {
          let C = H.textures,
            se = H.width,
            _e = H.height,
            we = s.COLOR_BUFFER_BIT,
            Oe = H.stencilBuffer
              ? s.DEPTH_STENCIL_ATTACHMENT
              : s.DEPTH_ATTACHMENT,
            Re = i.get(H),
            ge = C.length > 1;
          if (ge)
            for (let ke = 0; ke < C.length; ke++)
              (t.bindFramebuffer(
                s.FRAMEBUFFER,
                Re.__webglMultisampledFramebuffer,
              ),
                s.framebufferRenderbuffer(
                  s.FRAMEBUFFER,
                  s.COLOR_ATTACHMENT0 + ke,
                  s.RENDERBUFFER,
                  null,
                ),
                t.bindFramebuffer(s.FRAMEBUFFER, Re.__webglFramebuffer),
                s.framebufferTexture2D(
                  s.DRAW_FRAMEBUFFER,
                  s.COLOR_ATTACHMENT0 + ke,
                  s.TEXTURE_2D,
                  null,
                  0,
                ));
          t.bindFramebuffer(
            s.READ_FRAMEBUFFER,
            Re.__webglMultisampledFramebuffer,
          );
          let be = H.texture.mipmaps;
          be && be.length > 0
            ? t.bindFramebuffer(s.DRAW_FRAMEBUFFER, Re.__webglFramebuffer[0])
            : t.bindFramebuffer(s.DRAW_FRAMEBUFFER, Re.__webglFramebuffer);
          for (let ke = 0; ke < C.length; ke++) {
            if (
              (H.resolveDepthBuffer &&
                (H.depthBuffer && (we |= s.DEPTH_BUFFER_BIT),
                H.stencilBuffer &&
                  H.resolveStencilBuffer &&
                  (we |= s.STENCIL_BUFFER_BIT)),
              ge)
            ) {
              s.framebufferRenderbuffer(
                s.READ_FRAMEBUFFER,
                s.COLOR_ATTACHMENT0,
                s.RENDERBUFFER,
                Re.__webglColorRenderbuffer[ke],
              );
              let Ve = i.get(C[ke]).__webglTexture;
              s.framebufferTexture2D(
                s.DRAW_FRAMEBUFFER,
                s.COLOR_ATTACHMENT0,
                s.TEXTURE_2D,
                Ve,
                0,
              );
            }
            (s.blitFramebuffer(0, 0, se, _e, 0, 0, se, _e, we, s.NEAREST),
              l === !0 &&
                ((Rt.length = 0),
                (ti.length = 0),
                Rt.push(s.COLOR_ATTACHMENT0 + ke),
                H.depthBuffer &&
                  H.resolveDepthBuffer === !1 &&
                  (Rt.push(Oe),
                  ti.push(Oe),
                  s.invalidateFramebuffer(s.DRAW_FRAMEBUFFER, ti)),
                s.invalidateFramebuffer(s.READ_FRAMEBUFFER, Rt)));
          }
          if (
            (t.bindFramebuffer(s.READ_FRAMEBUFFER, null),
            t.bindFramebuffer(s.DRAW_FRAMEBUFFER, null),
            ge)
          )
            for (let ke = 0; ke < C.length; ke++) {
              (t.bindFramebuffer(
                s.FRAMEBUFFER,
                Re.__webglMultisampledFramebuffer,
              ),
                s.framebufferRenderbuffer(
                  s.FRAMEBUFFER,
                  s.COLOR_ATTACHMENT0 + ke,
                  s.RENDERBUFFER,
                  Re.__webglColorRenderbuffer[ke],
                ));
              let Ve = i.get(C[ke]).__webglTexture;
              (t.bindFramebuffer(s.FRAMEBUFFER, Re.__webglFramebuffer),
                s.framebufferTexture2D(
                  s.DRAW_FRAMEBUFFER,
                  s.COLOR_ATTACHMENT0 + ke,
                  s.TEXTURE_2D,
                  Ve,
                  0,
                ));
            }
          t.bindFramebuffer(
            s.DRAW_FRAMEBUFFER,
            Re.__webglMultisampledFramebuffer,
          );
        } else if (H.depthBuffer && H.resolveDepthBuffer === !1 && l) {
          let C = H.stencilBuffer
            ? s.DEPTH_STENCIL_ATTACHMENT
            : s.DEPTH_ATTACHMENT;
          s.invalidateFramebuffer(s.DRAW_FRAMEBUFFER, [C]);
        }
      }
    }
    function xt(H) {
      return Math.min(n.maxSamples, H.samples);
    }
    function _t(H) {
      let C = i.get(H);
      return (
        H.samples > 0 &&
        e.has('WEBGL_multisampled_render_to_texture') === !0 &&
        C.__useRenderToTexture !== !1
      );
    }
    function Ut(H) {
      let C = o.render.frame;
      u.get(H) !== C && (u.set(H, C), H.update());
    }
    function Ue(H, C) {
      let se = H.colorSpace,
        _e = H.format,
        we = H.type;
      return (
        H.isCompressedTexture === !0 ||
          H.isVideoTexture === !0 ||
          (se !== qi &&
            se !== Lr &&
            (Ct.getTransfer(se) === Kt
              ? (_e !== Yn || we !== Ln) &&
                it(
                  'WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.',
                )
              : mt('WebGLTextures: Unsupported texture color space:', se))),
        C
      );
    }
    function bt(H) {
      return (
        typeof HTMLImageElement != 'undefined' && H instanceof HTMLImageElement
          ? ((c.width = H.naturalWidth || H.width),
            (c.height = H.naturalHeight || H.height))
          : typeof VideoFrame != 'undefined' && H instanceof VideoFrame
            ? ((c.width = H.displayWidth), (c.height = H.displayHeight))
            : ((c.width = H.width), (c.height = H.height)),
        c
      );
    }
    ((this.allocateTextureUnit = ie),
      (this.resetTextureUnits = re),
      (this.getTextureUnits = oe),
      (this.setTextureUnits = K),
      (this.setTexture2D = pe),
      (this.setTexture2DArray = Ee),
      (this.setTexture3D = Z),
      (this.setTextureCube = Ne),
      (this.rebindTextures = Tt),
      (this.setupRenderTarget = at),
      (this.updateRenderTargetMipmap = ue),
      (this.updateMultisampleRenderTarget = ee),
      (this.setupDepthRenderbuffer = ut),
      (this.setupFrameBufferTexture = Le),
      (this.useMultisampledRTT = _t),
      (this.isReversedDepthBuffer = function () {
        return t.buffers.depth.getReversed();
      }));
  }
  function ZR(s, e) {
    function t(i, n = Lr) {
      let r,
        o = Ct.getTransfer(n);
      if (i === Ln) return s.UNSIGNED_BYTE;
      if (i === td) return s.UNSIGNED_SHORT_4_4_4_4;
      if (i === id) return s.UNSIGNED_SHORT_5_5_5_1;
      if (i === lg) return s.UNSIGNED_INT_5_9_9_9_REV;
      if (i === cg) return s.UNSIGNED_INT_10F_11F_11F_REV;
      if (i === og) return s.BYTE;
      if (i === ag) return s.SHORT;
      if (i === sl) return s.UNSIGNED_SHORT;
      if (i === ed) return s.INT;
      if (i === Rs) return s.UNSIGNED_INT;
      if (i === Xn) return s.FLOAT;
      if (i === er) return s.HALF_FLOAT;
      if (i === hg) return s.ALPHA;
      if (i === ug) return s.RGB;
      if (i === Yn) return s.RGBA;
      if (i === qs) return s.DEPTH_COMPONENT;
      if (i === ao) return s.DEPTH_STENCIL;
      if (i === nd) return s.RED;
      if (i === sd) return s.RED_INTEGER;
      if (i === lo) return s.RG;
      if (i === rd) return s.RG_INTEGER;
      if (i === od) return s.RGBA_INTEGER;
      if (i === Bc || i === kc || i === Hc || i === zc)
        if (o === Kt)
          if (((r = e.get('WEBGL_compressed_texture_s3tc_srgb')), r !== null)) {
            if (i === Bc) return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;
            if (i === kc) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
            if (i === Hc) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
            if (i === zc) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
          } else return null;
        else if (((r = e.get('WEBGL_compressed_texture_s3tc')), r !== null)) {
          if (i === Bc) return r.COMPRESSED_RGB_S3TC_DXT1_EXT;
          if (i === kc) return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;
          if (i === Hc) return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;
          if (i === zc) return r.COMPRESSED_RGBA_S3TC_DXT5_EXT;
        } else return null;
      if (i === ad || i === ld || i === cd || i === hd)
        if (((r = e.get('WEBGL_compressed_texture_pvrtc')), r !== null)) {
          if (i === ad) return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
          if (i === ld) return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
          if (i === cd) return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
          if (i === hd) return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
        } else return null;
      if (
        i === ud ||
        i === dd ||
        i === fd ||
        i === pd ||
        i === md ||
        i === Vc ||
        i === gd
      )
        if (((r = e.get('WEBGL_compressed_texture_etc')), r !== null)) {
          if (i === ud || i === dd)
            return o === Kt ? r.COMPRESSED_SRGB8_ETC2 : r.COMPRESSED_RGB8_ETC2;
          if (i === fd)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC
              : r.COMPRESSED_RGBA8_ETC2_EAC;
          if (i === pd) return r.COMPRESSED_R11_EAC;
          if (i === md) return r.COMPRESSED_SIGNED_R11_EAC;
          if (i === Vc) return r.COMPRESSED_RG11_EAC;
          if (i === gd) return r.COMPRESSED_SIGNED_RG11_EAC;
        } else return null;
      if (
        i === _d ||
        i === vd ||
        i === xd ||
        i === yd ||
        i === bd ||
        i === Sd ||
        i === Ed ||
        i === Td ||
        i === Md ||
        i === wd ||
        i === Ad ||
        i === Rd ||
        i === Cd ||
        i === Pd
      )
        if (((r = e.get('WEBGL_compressed_texture_astc')), r !== null)) {
          if (i === _d)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR
              : r.COMPRESSED_RGBA_ASTC_4x4_KHR;
          if (i === vd)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR
              : r.COMPRESSED_RGBA_ASTC_5x4_KHR;
          if (i === xd)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR
              : r.COMPRESSED_RGBA_ASTC_5x5_KHR;
          if (i === yd)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR
              : r.COMPRESSED_RGBA_ASTC_6x5_KHR;
          if (i === bd)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR
              : r.COMPRESSED_RGBA_ASTC_6x6_KHR;
          if (i === Sd)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR
              : r.COMPRESSED_RGBA_ASTC_8x5_KHR;
          if (i === Ed)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR
              : r.COMPRESSED_RGBA_ASTC_8x6_KHR;
          if (i === Td)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR
              : r.COMPRESSED_RGBA_ASTC_8x8_KHR;
          if (i === Md)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR
              : r.COMPRESSED_RGBA_ASTC_10x5_KHR;
          if (i === wd)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR
              : r.COMPRESSED_RGBA_ASTC_10x6_KHR;
          if (i === Ad)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR
              : r.COMPRESSED_RGBA_ASTC_10x8_KHR;
          if (i === Rd)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR
              : r.COMPRESSED_RGBA_ASTC_10x10_KHR;
          if (i === Cd)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR
              : r.COMPRESSED_RGBA_ASTC_12x10_KHR;
          if (i === Pd)
            return o === Kt
              ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR
              : r.COMPRESSED_RGBA_ASTC_12x12_KHR;
        } else return null;
      if (i === Ld || i === Id || i === Dd)
        if (((r = e.get('EXT_texture_compression_bptc')), r !== null)) {
          if (i === Ld)
            return o === Kt
              ? r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
              : r.COMPRESSED_RGBA_BPTC_UNORM_EXT;
          if (i === Id) return r.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
          if (i === Dd) return r.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
        } else return null;
      if (i === Od || i === Nd || i === Gc || i === Fd)
        if (((r = e.get('EXT_texture_compression_rgtc')), r !== null)) {
          if (i === Od) return r.COMPRESSED_RED_RGTC1_EXT;
          if (i === Nd) return r.COMPRESSED_SIGNED_RED_RGTC1_EXT;
          if (i === Gc) return r.COMPRESSED_RED_GREEN_RGTC2_EXT;
          if (i === Fd) return r.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
        } else return null;
      return i === rl ? s.UNSIGNED_INT_24_8 : s[i] !== void 0 ? s[i] : null;
    }
    return { convert: t };
  }
  var KR = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`,
    $R = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`,
    Ug = class {
      constructor() {
        ((this.texture = null),
          (this.mesh = null),
          (this.depthNear = 0),
          (this.depthFar = 0));
      }
      init(e, t) {
        if (this.texture === null) {
          let i = new wc(e.texture);
          ((e.depthNear !== t.depthNear || e.depthFar !== t.depthFar) &&
            ((this.depthNear = e.depthNear), (this.depthFar = e.depthFar)),
            (this.texture = i));
        }
      }
      getMesh(e) {
        if (this.texture !== null && this.mesh === null) {
          let t = e.cameras[0].viewport,
            i = new vi({
              vertexShader: KR,
              fragmentShader: $R,
              uniforms: {
                depthColor: { value: this.texture },
                depthWidth: { value: t.z },
                depthHeight: { value: t.w },
              },
            });
          this.mesh = new ri(new ss(20, 20), i);
        }
        return this.mesh;
      }
      reset() {
        ((this.texture = null), (this.mesh = null));
      }
      getDepthTexture() {
        return this.texture;
      }
    },
    Bg = class extends Es {
      constructor(e, t) {
        super();
        let i = this,
          n = null,
          r = 1,
          o = null,
          a = 'local-floor',
          l = 1,
          c = null,
          u = null,
          f = null,
          d = null,
          p = null,
          _ = null,
          x = typeof XRWebGLBinding != 'undefined',
          g = new Ug(),
          v = {},
          w = t.getContextAttributes(),
          L = null,
          R = null,
          U = [],
          O = [],
          N = new et(),
          M = null,
          I = new di();
        I.viewport = new Qt();
        let z = new di();
        z.viewport = new Qt();
        let W = [I, z],
          q = new $u(),
          re = null,
          oe = null;
        ((this.cameraAutoUpdate = !0),
          (this.enabled = !1),
          (this.isPresenting = !1),
          (this.getController = function (ve) {
            let Pe = U[ve];
            return (
              Pe === void 0 && ((Pe = new qa()), (U[ve] = Pe)),
              Pe.getTargetRaySpace()
            );
          }),
          (this.getControllerGrip = function (ve) {
            let Pe = U[ve];
            return (
              Pe === void 0 && ((Pe = new qa()), (U[ve] = Pe)),
              Pe.getGripSpace()
            );
          }),
          (this.getHand = function (ve) {
            let Pe = U[ve];
            return (
              Pe === void 0 && ((Pe = new qa()), (U[ve] = Pe)),
              Pe.getHandSpace()
            );
          }));
        function K(ve) {
          let Pe = O.indexOf(ve.inputSource);
          if (Pe === -1) return;
          let Ae = U[Pe];
          Ae !== void 0 &&
            (Ae.update(ve.inputSource, ve.frame, c || o),
            Ae.dispatchEvent({ type: ve.type, data: ve.inputSource }));
        }
        function ie() {
          (n.removeEventListener('select', K),
            n.removeEventListener('selectstart', K),
            n.removeEventListener('selectend', K),
            n.removeEventListener('squeeze', K),
            n.removeEventListener('squeezestart', K),
            n.removeEventListener('squeezeend', K),
            n.removeEventListener('end', ie),
            n.removeEventListener('inputsourceschange', J));
          for (let ve = 0; ve < U.length; ve++) {
            let Pe = O[ve];
            Pe !== null && ((O[ve] = null), U[ve].disconnect(Pe));
          }
          ((re = null), (oe = null), g.reset());
          for (let ve in v) delete v[ve];
          (e.setRenderTarget(L),
            (p = null),
            (d = null),
            (f = null),
            (n = null),
            (R = null),
            tt.stop(),
            (i.isPresenting = !1),
            e.setPixelRatio(M),
            e.setSize(N.width, N.height, !1),
            i.dispatchEvent({ type: 'sessionend' }));
        }
        ((this.setFramebufferScaleFactor = function (ve) {
          ((r = ve),
            i.isPresenting === !0 &&
              it(
                'WebXRManager: Cannot change framebuffer scale while presenting.',
              ));
        }),
          (this.setReferenceSpaceType = function (ve) {
            ((a = ve),
              i.isPresenting === !0 &&
                it(
                  'WebXRManager: Cannot change reference space type while presenting.',
                ));
          }),
          (this.getReferenceSpace = function () {
            return c || o;
          }),
          (this.setReferenceSpace = function (ve) {
            c = ve;
          }),
          (this.getBaseLayer = function () {
            return d !== null ? d : p;
          }),
          (this.getBinding = function () {
            return (f === null && x && (f = new XRWebGLBinding(n, t)), f);
          }),
          (this.getFrame = function () {
            return _;
          }),
          (this.getSession = function () {
            return n;
          }),
          (this.setSession = function (ve) {
            return Ns(this, null, function* () {
              if (((n = ve), n !== null)) {
                if (
                  ((L = e.getRenderTarget()),
                  n.addEventListener('select', K),
                  n.addEventListener('selectstart', K),
                  n.addEventListener('selectend', K),
                  n.addEventListener('squeeze', K),
                  n.addEventListener('squeezestart', K),
                  n.addEventListener('squeezeend', K),
                  n.addEventListener('end', ie),
                  n.addEventListener('inputsourceschange', J),
                  w.xrCompatible !== !0 && (yield t.makeXRCompatible()),
                  (M = e.getPixelRatio()),
                  e.getSize(N),
                  x && 'createProjectionLayer' in XRWebGLBinding.prototype)
                ) {
                  let Ae = null,
                    Ze = null,
                    nt = null;
                  w.depth &&
                    ((nt = w.stencil
                      ? t.DEPTH24_STENCIL8
                      : t.DEPTH_COMPONENT24),
                    (Ae = w.stencil ? ao : qs),
                    (Ze = w.stencil ? rl : Rs));
                  let Le = {
                    colorFormat: t.RGBA8,
                    depthFormat: nt,
                    scaleFactor: r,
                  };
                  ((f = this.getBinding()),
                    (d = f.createProjectionLayer(Le)),
                    n.updateRenderState({ layers: [d] }),
                    e.setPixelRatio(1),
                    e.setSize(d.textureWidth, d.textureHeight, !1),
                    (R = new xn(d.textureWidth, d.textureHeight, {
                      format: Yn,
                      type: Ln,
                      depthTexture: new Mr(
                        d.textureWidth,
                        d.textureHeight,
                        Ze,
                        void 0,
                        void 0,
                        void 0,
                        void 0,
                        void 0,
                        void 0,
                        Ae,
                      ),
                      stencilBuffer: w.stencil,
                      colorSpace: e.outputColorSpace,
                      samples: w.antialias ? 4 : 0,
                      resolveDepthBuffer: d.ignoreDepthValues === !1,
                      resolveStencilBuffer: d.ignoreDepthValues === !1,
                    })));
                } else {
                  let Ae = {
                    antialias: w.antialias,
                    alpha: !0,
                    depth: w.depth,
                    stencil: w.stencil,
                    framebufferScaleFactor: r,
                  };
                  ((p = new XRWebGLLayer(n, t, Ae)),
                    n.updateRenderState({ baseLayer: p }),
                    e.setPixelRatio(1),
                    e.setSize(p.framebufferWidth, p.framebufferHeight, !1),
                    (R = new xn(p.framebufferWidth, p.framebufferHeight, {
                      format: Yn,
                      type: Ln,
                      colorSpace: e.outputColorSpace,
                      stencilBuffer: w.stencil,
                      resolveDepthBuffer: p.ignoreDepthValues === !1,
                      resolveStencilBuffer: p.ignoreDepthValues === !1,
                    })));
                }
                ((R.isXRRenderTarget = !0),
                  this.setFoveation(l),
                  (c = null),
                  (o = yield n.requestReferenceSpace(a)),
                  tt.setContext(n),
                  tt.start(),
                  (i.isPresenting = !0),
                  i.dispatchEvent({ type: 'sessionstart' }));
              }
            });
          }),
          (this.getEnvironmentBlendMode = function () {
            if (n !== null) return n.environmentBlendMode;
          }),
          (this.getDepthTexture = function () {
            return g.getDepthTexture();
          }));
        function J(ve) {
          for (let Pe = 0; Pe < ve.removed.length; Pe++) {
            let Ae = ve.removed[Pe],
              Ze = O.indexOf(Ae);
            Ze >= 0 && ((O[Ze] = null), U[Ze].disconnect(Ae));
          }
          for (let Pe = 0; Pe < ve.added.length; Pe++) {
            let Ae = ve.added[Pe],
              Ze = O.indexOf(Ae);
            if (Ze === -1) {
              for (let Le = 0; Le < U.length; Le++)
                if (Le >= O.length) {
                  (O.push(Ae), (Ze = Le));
                  break;
                } else if (O[Le] === null) {
                  ((O[Le] = Ae), (Ze = Le));
                  break;
                }
              if (Ze === -1) break;
            }
            let nt = U[Ze];
            nt && nt.connect(Ae);
          }
        }
        let pe = new te(),
          Ee = new te();
        function Z(ve, Pe, Ae) {
          (pe.setFromMatrixPosition(Pe.matrixWorld),
            Ee.setFromMatrixPosition(Ae.matrixWorld));
          let Ze = pe.distanceTo(Ee),
            nt = Pe.projectionMatrix.elements,
            Le = Ae.projectionMatrix.elements,
            At = nt[14] / (nt[10] - 1),
            Ke = nt[14] / (nt[10] + 1),
            ut = (nt[9] + 1) / nt[5],
            Tt = (nt[9] - 1) / nt[5],
            at = (nt[8] - 1) / nt[0],
            ue = (Le[8] + 1) / Le[0],
            Rt = At * at,
            ti = At * ue,
            ee = Ze / (-at + ue),
            xt = ee * -at;
          if (
            (Pe.matrixWorld.decompose(ve.position, ve.quaternion, ve.scale),
            ve.translateX(xt),
            ve.translateZ(ee),
            ve.matrixWorld.compose(ve.position, ve.quaternion, ve.scale),
            ve.matrixWorldInverse.copy(ve.matrixWorld).invert(),
            nt[10] === -1)
          )
            (ve.projectionMatrix.copy(Pe.projectionMatrix),
              ve.projectionMatrixInverse.copy(Pe.projectionMatrixInverse));
          else {
            let _t = At + ee,
              Ut = Ke + ee,
              Ue = Rt - xt,
              bt = ti + (Ze - xt),
              H = ((ut * Ke) / Ut) * _t,
              C = ((Tt * Ke) / Ut) * _t;
            (ve.projectionMatrix.makePerspective(Ue, bt, H, C, _t, Ut),
              ve.projectionMatrixInverse.copy(ve.projectionMatrix).invert());
          }
        }
        function Ne(ve, Pe) {
          (Pe === null
            ? ve.matrixWorld.copy(ve.matrix)
            : ve.matrixWorld.multiplyMatrices(Pe.matrixWorld, ve.matrix),
            ve.matrixWorldInverse.copy(ve.matrixWorld).invert());
        }
        this.updateCamera = function (ve) {
          if (n === null) return;
          let Pe = ve.near,
            Ae = ve.far;
          (g.texture !== null &&
            (g.depthNear > 0 && (Pe = g.depthNear),
            g.depthFar > 0 && (Ae = g.depthFar)),
            (q.near = z.near = I.near = Pe),
            (q.far = z.far = I.far = Ae),
            (re !== q.near || oe !== q.far) &&
              (n.updateRenderState({ depthNear: q.near, depthFar: q.far }),
              (re = q.near),
              (oe = q.far)),
            (q.layers.mask = ve.layers.mask | 6),
            (I.layers.mask = q.layers.mask & -5),
            (z.layers.mask = q.layers.mask & -3));
          let Ze = ve.parent,
            nt = q.cameras;
          Ne(q, Ze);
          for (let Le = 0; Le < nt.length; Le++) Ne(nt[Le], Ze);
          (nt.length === 2
            ? Z(q, I, z)
            : q.projectionMatrix.copy(I.projectionMatrix),
            Be(ve, q, Ze));
        };
        function Be(ve, Pe, Ae) {
          (Ae === null
            ? ve.matrix.copy(Pe.matrixWorld)
            : (ve.matrix.copy(Ae.matrixWorld),
              ve.matrix.invert(),
              ve.matrix.multiply(Pe.matrixWorld)),
            ve.matrix.decompose(ve.position, ve.quaternion, ve.scale),
            ve.updateMatrixWorld(!0),
            ve.projectionMatrix.copy(Pe.projectionMatrix),
            ve.projectionMatrixInverse.copy(Pe.projectionMatrixInverse),
            ve.isPerspectiveCamera &&
              ((ve.fov =
                qo * 2 * Math.atan(1 / ve.projectionMatrix.elements[5])),
              (ve.zoom = 1)));
        }
        ((this.getCamera = function () {
          return q;
        }),
          (this.getFoveation = function () {
            if (!(d === null && p === null)) return l;
          }),
          (this.setFoveation = function (ve) {
            ((l = ve),
              d !== null && (d.fixedFoveation = ve),
              p !== null &&
                p.fixedFoveation !== void 0 &&
                (p.fixedFoveation = ve));
          }),
          (this.hasDepthSensing = function () {
            return g.texture !== null;
          }),
          (this.getDepthSensingMesh = function () {
            return g.getMesh(q);
          }),
          (this.getCameraTexture = function (ve) {
            return v[ve];
          }));
        let ht = null;
        function ot(ve, Pe) {
          if (((u = Pe.getViewerPose(c || o)), (_ = Pe), u !== null)) {
            let Ae = u.views;
            p !== null &&
              (e.setRenderTargetFramebuffer(R, p.framebuffer),
              e.setRenderTarget(R));
            let Ze = !1;
            Ae.length !== q.cameras.length &&
              ((q.cameras.length = 0), (Ze = !0));
            for (let Ke = 0; Ke < Ae.length; Ke++) {
              let ut = Ae[Ke],
                Tt = null;
              if (p !== null) Tt = p.getViewport(ut);
              else {
                let ue = f.getViewSubImage(d, ut);
                ((Tt = ue.viewport),
                  Ke === 0 &&
                    (e.setRenderTargetTextures(
                      R,
                      ue.colorTexture,
                      ue.depthStencilTexture,
                    ),
                    e.setRenderTarget(R)));
              }
              let at = W[Ke];
              (at === void 0 &&
                ((at = new di()),
                at.layers.enable(Ke),
                (at.viewport = new Qt()),
                (W[Ke] = at)),
                at.matrix.fromArray(ut.transform.matrix),
                at.matrix.decompose(at.position, at.quaternion, at.scale),
                at.projectionMatrix.fromArray(ut.projectionMatrix),
                at.projectionMatrixInverse.copy(at.projectionMatrix).invert(),
                at.viewport.set(Tt.x, Tt.y, Tt.width, Tt.height),
                Ke === 0 &&
                  (q.matrix.copy(at.matrix),
                  q.matrix.decompose(q.position, q.quaternion, q.scale)),
                Ze === !0 && q.cameras.push(at));
            }
            let nt = n.enabledFeatures;
            if (
              nt &&
              nt.includes('depth-sensing') &&
              n.depthUsage == 'gpu-optimized' &&
              x
            ) {
              f = i.getBinding();
              let Ke = f.getDepthInformation(Ae[0]);
              Ke && Ke.isValid && Ke.texture && g.init(Ke, n.renderState);
            }
            if (nt && nt.includes('camera-access') && x) {
              (e.state.unbindTexture(), (f = i.getBinding()));
              for (let Ke = 0; Ke < Ae.length; Ke++) {
                let ut = Ae[Ke].camera;
                if (ut) {
                  let Tt = v[ut];
                  Tt || ((Tt = new wc()), (v[ut] = Tt));
                  let at = f.getCameraImage(ut);
                  Tt.sourceTexture = at;
                }
              }
            }
          }
          for (let Ae = 0; Ae < U.length; Ae++) {
            let Ze = O[Ae],
              nt = U[Ae];
            Ze !== null && nt !== void 0 && nt.update(Ze, Pe, c || o);
          }
          (ht && ht(ve, Pe),
            Pe.detectedPlanes &&
              i.dispatchEvent({ type: 'planesdetected', data: Pe }),
            (_ = null));
        }
        let tt = new Ky();
        (tt.setAnimationLoop(ot),
          (this.setAnimationLoop = function (ve) {
            ht = ve;
          }),
          (this.dispose = function () {}));
      }
    },
    jR = new yt(),
    tb = new St();
  tb.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
  function JR(s, e) {
    function t(g, v) {
      (g.matrixAutoUpdate === !0 && g.updateMatrix(), v.value.copy(g.matrix));
    }
    function i(g, v) {
      (v.color.getRGB(g.fogColor.value, mg(s)),
        v.isFog
          ? ((g.fogNear.value = v.near), (g.fogFar.value = v.far))
          : v.isFogExp2 && (g.fogDensity.value = v.density));
    }
    function n(g, v, w, L, R) {
      v.isNodeMaterial
        ? (v.uniformsNeedUpdate = !1)
        : v.isMeshBasicMaterial
          ? r(g, v)
          : v.isMeshLambertMaterial
            ? (r(g, v),
              v.envMap && (g.envMapIntensity.value = v.envMapIntensity))
            : v.isMeshToonMaterial
              ? (r(g, v), f(g, v))
              : v.isMeshPhongMaterial
                ? (r(g, v),
                  u(g, v),
                  v.envMap && (g.envMapIntensity.value = v.envMapIntensity))
                : v.isMeshStandardMaterial
                  ? (r(g, v), d(g, v), v.isMeshPhysicalMaterial && p(g, v, R))
                  : v.isMeshMatcapMaterial
                    ? (r(g, v), _(g, v))
                    : v.isMeshDepthMaterial
                      ? r(g, v)
                      : v.isMeshDistanceMaterial
                        ? (r(g, v), x(g, v))
                        : v.isMeshNormalMaterial
                          ? r(g, v)
                          : v.isLineBasicMaterial
                            ? (o(g, v), v.isLineDashedMaterial && a(g, v))
                            : v.isPointsMaterial
                              ? l(g, v, w, L)
                              : v.isSpriteMaterial
                                ? c(g, v)
                                : v.isShadowMaterial
                                  ? (g.color.value.copy(v.color),
                                    (g.opacity.value = v.opacity))
                                  : v.isShaderMaterial &&
                                    (v.uniformsNeedUpdate = !1);
    }
    function r(g, v) {
      ((g.opacity.value = v.opacity),
        v.color && g.diffuse.value.copy(v.color),
        v.emissive &&
          g.emissive.value.copy(v.emissive).multiplyScalar(v.emissiveIntensity),
        v.map && ((g.map.value = v.map), t(v.map, g.mapTransform)),
        v.alphaMap &&
          ((g.alphaMap.value = v.alphaMap), t(v.alphaMap, g.alphaMapTransform)),
        v.bumpMap &&
          ((g.bumpMap.value = v.bumpMap),
          t(v.bumpMap, g.bumpMapTransform),
          (g.bumpScale.value = v.bumpScale),
          v.side === bn && (g.bumpScale.value *= -1)),
        v.normalMap &&
          ((g.normalMap.value = v.normalMap),
          t(v.normalMap, g.normalMapTransform),
          g.normalScale.value.copy(v.normalScale),
          v.side === bn && g.normalScale.value.negate()),
        v.displacementMap &&
          ((g.displacementMap.value = v.displacementMap),
          t(v.displacementMap, g.displacementMapTransform),
          (g.displacementScale.value = v.displacementScale),
          (g.displacementBias.value = v.displacementBias)),
        v.emissiveMap &&
          ((g.emissiveMap.value = v.emissiveMap),
          t(v.emissiveMap, g.emissiveMapTransform)),
        v.specularMap &&
          ((g.specularMap.value = v.specularMap),
          t(v.specularMap, g.specularMapTransform)),
        v.alphaTest > 0 && (g.alphaTest.value = v.alphaTest));
      let w = e.get(v),
        L = w.envMap,
        R = w.envMapRotation;
      (L &&
        ((g.envMap.value = L),
        g.envMapRotation.value
          .setFromMatrix4(jR.makeRotationFromEuler(R))
          .transpose(),
        L.isCubeTexture &&
          L.isRenderTargetTexture === !1 &&
          g.envMapRotation.value.premultiply(tb),
        (g.reflectivity.value = v.reflectivity),
        (g.ior.value = v.ior),
        (g.refractionRatio.value = v.refractionRatio)),
        v.lightMap &&
          ((g.lightMap.value = v.lightMap),
          (g.lightMapIntensity.value = v.lightMapIntensity),
          t(v.lightMap, g.lightMapTransform)),
        v.aoMap &&
          ((g.aoMap.value = v.aoMap),
          (g.aoMapIntensity.value = v.aoMapIntensity),
          t(v.aoMap, g.aoMapTransform)));
    }
    function o(g, v) {
      (g.diffuse.value.copy(v.color),
        (g.opacity.value = v.opacity),
        v.map && ((g.map.value = v.map), t(v.map, g.mapTransform)));
    }
    function a(g, v) {
      ((g.dashSize.value = v.dashSize),
        (g.totalSize.value = v.dashSize + v.gapSize),
        (g.scale.value = v.scale));
    }
    function l(g, v, w, L) {
      (g.diffuse.value.copy(v.color),
        (g.opacity.value = v.opacity),
        (g.size.value = v.size * w),
        (g.scale.value = L * 0.5),
        v.map && ((g.map.value = v.map), t(v.map, g.uvTransform)),
        v.alphaMap &&
          ((g.alphaMap.value = v.alphaMap), t(v.alphaMap, g.alphaMapTransform)),
        v.alphaTest > 0 && (g.alphaTest.value = v.alphaTest));
    }
    function c(g, v) {
      (g.diffuse.value.copy(v.color),
        (g.opacity.value = v.opacity),
        (g.rotation.value = v.rotation),
        v.map && ((g.map.value = v.map), t(v.map, g.mapTransform)),
        v.alphaMap &&
          ((g.alphaMap.value = v.alphaMap), t(v.alphaMap, g.alphaMapTransform)),
        v.alphaTest > 0 && (g.alphaTest.value = v.alphaTest));
    }
    function u(g, v) {
      (g.specular.value.copy(v.specular),
        (g.shininess.value = Math.max(v.shininess, 1e-4)));
    }
    function f(g, v) {
      v.gradientMap && (g.gradientMap.value = v.gradientMap);
    }
    function d(g, v) {
      ((g.metalness.value = v.metalness),
        v.metalnessMap &&
          ((g.metalnessMap.value = v.metalnessMap),
          t(v.metalnessMap, g.metalnessMapTransform)),
        (g.roughness.value = v.roughness),
        v.roughnessMap &&
          ((g.roughnessMap.value = v.roughnessMap),
          t(v.roughnessMap, g.roughnessMapTransform)),
        v.envMap && (g.envMapIntensity.value = v.envMapIntensity));
    }
    function p(g, v, w) {
      ((g.ior.value = v.ior),
        v.sheen > 0 &&
          (g.sheenColor.value.copy(v.sheenColor).multiplyScalar(v.sheen),
          (g.sheenRoughness.value = v.sheenRoughness),
          v.sheenColorMap &&
            ((g.sheenColorMap.value = v.sheenColorMap),
            t(v.sheenColorMap, g.sheenColorMapTransform)),
          v.sheenRoughnessMap &&
            ((g.sheenRoughnessMap.value = v.sheenRoughnessMap),
            t(v.sheenRoughnessMap, g.sheenRoughnessMapTransform))),
        v.clearcoat > 0 &&
          ((g.clearcoat.value = v.clearcoat),
          (g.clearcoatRoughness.value = v.clearcoatRoughness),
          v.clearcoatMap &&
            ((g.clearcoatMap.value = v.clearcoatMap),
            t(v.clearcoatMap, g.clearcoatMapTransform)),
          v.clearcoatRoughnessMap &&
            ((g.clearcoatRoughnessMap.value = v.clearcoatRoughnessMap),
            t(v.clearcoatRoughnessMap, g.clearcoatRoughnessMapTransform)),
          v.clearcoatNormalMap &&
            ((g.clearcoatNormalMap.value = v.clearcoatNormalMap),
            t(v.clearcoatNormalMap, g.clearcoatNormalMapTransform),
            g.clearcoatNormalScale.value.copy(v.clearcoatNormalScale),
            v.side === bn && g.clearcoatNormalScale.value.negate())),
        v.dispersion > 0 && (g.dispersion.value = v.dispersion),
        v.iridescence > 0 &&
          ((g.iridescence.value = v.iridescence),
          (g.iridescenceIOR.value = v.iridescenceIOR),
          (g.iridescenceThicknessMinimum.value =
            v.iridescenceThicknessRange[0]),
          (g.iridescenceThicknessMaximum.value =
            v.iridescenceThicknessRange[1]),
          v.iridescenceMap &&
            ((g.iridescenceMap.value = v.iridescenceMap),
            t(v.iridescenceMap, g.iridescenceMapTransform)),
          v.iridescenceThicknessMap &&
            ((g.iridescenceThicknessMap.value = v.iridescenceThicknessMap),
            t(v.iridescenceThicknessMap, g.iridescenceThicknessMapTransform))),
        v.transmission > 0 &&
          ((g.transmission.value = v.transmission),
          (g.transmissionSamplerMap.value = w.texture),
          g.transmissionSamplerSize.value.set(w.width, w.height),
          v.transmissionMap &&
            ((g.transmissionMap.value = v.transmissionMap),
            t(v.transmissionMap, g.transmissionMapTransform)),
          (g.thickness.value = v.thickness),
          v.thicknessMap &&
            ((g.thicknessMap.value = v.thicknessMap),
            t(v.thicknessMap, g.thicknessMapTransform)),
          (g.attenuationDistance.value = v.attenuationDistance),
          g.attenuationColor.value.copy(v.attenuationColor)),
        v.anisotropy > 0 &&
          (g.anisotropyVector.value.set(
            v.anisotropy * Math.cos(v.anisotropyRotation),
            v.anisotropy * Math.sin(v.anisotropyRotation),
          ),
          v.anisotropyMap &&
            ((g.anisotropyMap.value = v.anisotropyMap),
            t(v.anisotropyMap, g.anisotropyMapTransform))),
        (g.specularIntensity.value = v.specularIntensity),
        g.specularColor.value.copy(v.specularColor),
        v.specularColorMap &&
          ((g.specularColorMap.value = v.specularColorMap),
          t(v.specularColorMap, g.specularColorMapTransform)),
        v.specularIntensityMap &&
          ((g.specularIntensityMap.value = v.specularIntensityMap),
          t(v.specularIntensityMap, g.specularIntensityMapTransform)));
    }
    function _(g, v) {
      v.matcap && (g.matcap.value = v.matcap);
    }
    function x(g, v) {
      let w = e.get(v).light;
      (g.referencePosition.value.setFromMatrixPosition(w.matrixWorld),
        (g.nearDistance.value = w.shadow.camera.near),
        (g.farDistance.value = w.shadow.camera.far));
    }
    return { refreshFogUniforms: i, refreshMaterialUniforms: n };
  }
  function QR(s, e, t, i) {
    let n = {},
      r = {},
      o = [],
      a = s.getParameter(s.MAX_UNIFORM_BUFFER_BINDINGS);
    function l(w, L) {
      let R = L.program;
      i.uniformBlockBinding(w, R);
    }
    function c(w, L) {
      let R = n[w.id];
      R === void 0 &&
        (_(w), (R = u(w)), (n[w.id] = R), w.addEventListener('dispose', g));
      let U = L.program;
      i.updateUBOMapping(w, U);
      let O = e.render.frame;
      r[w.id] !== O && (d(w), (r[w.id] = O));
    }
    function u(w) {
      let L = f();
      w.__bindingPointIndex = L;
      let R = s.createBuffer(),
        U = w.__size,
        O = w.usage;
      return (
        s.bindBuffer(s.UNIFORM_BUFFER, R),
        s.bufferData(s.UNIFORM_BUFFER, U, O),
        s.bindBuffer(s.UNIFORM_BUFFER, null),
        s.bindBufferBase(s.UNIFORM_BUFFER, L, R),
        R
      );
    }
    function f() {
      for (let w = 0; w < a; w++)
        if (o.indexOf(w) === -1) return (o.push(w), w);
      return (
        mt(
          'WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.',
        ),
        0
      );
    }
    function d(w) {
      let L = n[w.id],
        R = w.uniforms,
        U = w.__cache;
      s.bindBuffer(s.UNIFORM_BUFFER, L);
      for (let O = 0, N = R.length; O < N; O++) {
        let M = Array.isArray(R[O]) ? R[O] : [R[O]];
        for (let I = 0, z = M.length; I < z; I++) {
          let W = M[I];
          if (p(W, O, I, U) === !0) {
            let q = W.__offset,
              re = Array.isArray(W.value) ? W.value : [W.value],
              oe = 0;
            for (let K = 0; K < re.length; K++) {
              let ie = re[K],
                J = x(ie);
              typeof ie == 'number' || typeof ie == 'boolean'
                ? ((W.__data[0] = ie),
                  s.bufferSubData(s.UNIFORM_BUFFER, q + oe, W.__data))
                : ie.isMatrix3
                  ? ((W.__data[0] = ie.elements[0]),
                    (W.__data[1] = ie.elements[1]),
                    (W.__data[2] = ie.elements[2]),
                    (W.__data[3] = 0),
                    (W.__data[4] = ie.elements[3]),
                    (W.__data[5] = ie.elements[4]),
                    (W.__data[6] = ie.elements[5]),
                    (W.__data[7] = 0),
                    (W.__data[8] = ie.elements[6]),
                    (W.__data[9] = ie.elements[7]),
                    (W.__data[10] = ie.elements[8]),
                    (W.__data[11] = 0))
                  : ArrayBuffer.isView(ie)
                    ? W.__data.set(
                        new ie.constructor(
                          ie.buffer,
                          ie.byteOffset,
                          W.__data.length,
                        ),
                      )
                    : (ie.toArray(W.__data, oe),
                      (oe += J.storage / Float32Array.BYTES_PER_ELEMENT));
            }
            s.bufferSubData(s.UNIFORM_BUFFER, q, W.__data);
          }
        }
      }
      s.bindBuffer(s.UNIFORM_BUFFER, null);
    }
    function p(w, L, R, U) {
      let O = w.value,
        N = L + '_' + R;
      if (U[N] === void 0)
        return (
          typeof O == 'number' || typeof O == 'boolean'
            ? (U[N] = O)
            : ArrayBuffer.isView(O)
              ? (U[N] = O.slice())
              : (U[N] = O.clone()),
          !0
        );
      {
        let M = U[N];
        if (typeof O == 'number' || typeof O == 'boolean') {
          if (M !== O) return ((U[N] = O), !0);
        } else {
          if (ArrayBuffer.isView(O)) return !0;
          if (M.equals(O) === !1) return (M.copy(O), !0);
        }
      }
      return !1;
    }
    function _(w) {
      let L = w.uniforms,
        R = 0,
        U = 16;
      for (let N = 0, M = L.length; N < M; N++) {
        let I = Array.isArray(L[N]) ? L[N] : [L[N]];
        for (let z = 0, W = I.length; z < W; z++) {
          let q = I[z],
            re = Array.isArray(q.value) ? q.value : [q.value];
          for (let oe = 0, K = re.length; oe < K; oe++) {
            let ie = re[oe],
              J = x(ie),
              pe = R % U,
              Ee = pe % J.boundary,
              Z = pe + Ee;
            ((R += Ee),
              Z !== 0 && U - Z < J.storage && (R += U - Z),
              (q.__data = new Float32Array(
                J.storage / Float32Array.BYTES_PER_ELEMENT,
              )),
              (q.__offset = R),
              (R += J.storage));
          }
        }
      }
      let O = R % U;
      return (O > 0 && (R += U - O), (w.__size = R), (w.__cache = {}), this);
    }
    function x(w) {
      let L = { boundary: 0, storage: 0 };
      return (
        typeof w == 'number' || typeof w == 'boolean'
          ? ((L.boundary = 4), (L.storage = 4))
          : w.isVector2
            ? ((L.boundary = 8), (L.storage = 8))
            : w.isVector3 || w.isColor
              ? ((L.boundary = 16), (L.storage = 12))
              : w.isVector4
                ? ((L.boundary = 16), (L.storage = 16))
                : w.isMatrix3
                  ? ((L.boundary = 48), (L.storage = 48))
                  : w.isMatrix4
                    ? ((L.boundary = 64), (L.storage = 64))
                    : w.isTexture
                      ? it(
                          'WebGLRenderer: Texture samplers can not be part of an uniforms group.',
                        )
                      : ArrayBuffer.isView(w)
                        ? ((L.boundary = 16), (L.storage = w.byteLength))
                        : it(
                            'WebGLRenderer: Unsupported uniform value type.',
                            w,
                          ),
        L
      );
    }
    function g(w) {
      let L = w.target;
      L.removeEventListener('dispose', g);
      let R = o.indexOf(L.__bindingPointIndex);
      (o.splice(R, 1), s.deleteBuffer(n[L.id]), delete n[L.id], delete r[L.id]);
    }
    function v() {
      for (let w in n) s.deleteBuffer(n[w]);
      ((o = []), (n = {}), (r = {}));
    }
    return { bind: l, update: c, dispose: v };
  }
  var eC = new Uint16Array([
      12469, 15057, 12620, 14925, 13266, 14620, 13807, 14376, 14323, 13990,
      14545, 13625, 14713, 13328, 14840, 12882, 14931, 12528, 14996, 12233,
      15039, 11829, 15066, 11525, 15080, 11295, 15085, 10976, 15082, 10705,
      15073, 10495, 13880, 14564, 13898, 14542, 13977, 14430, 14158, 14124,
      14393, 13732, 14556, 13410, 14702, 12996, 14814, 12596, 14891, 12291,
      14937, 11834, 14957, 11489, 14958, 11194, 14943, 10803, 14921, 10506,
      14893, 10278, 14858, 9960, 14484, 14039, 14487, 14025, 14499, 13941,
      14524, 13740, 14574, 13468, 14654, 13106, 14743, 12678, 14818, 12344,
      14867, 11893, 14889, 11509, 14893, 11180, 14881, 10751, 14852, 10428,
      14812, 10128, 14765, 9754, 14712, 9466, 14764, 13480, 14764, 13475, 14766,
      13440, 14766, 13347, 14769, 13070, 14786, 12713, 14816, 12387, 14844,
      11957, 14860, 11549, 14868, 11215, 14855, 10751, 14825, 10403, 14782,
      10044, 14729, 9651, 14666, 9352, 14599, 9029, 14967, 12835, 14966, 12831,
      14963, 12804, 14954, 12723, 14936, 12564, 14917, 12347, 14900, 11958,
      14886, 11569, 14878, 11247, 14859, 10765, 14828, 10401, 14784, 10011,
      14727, 9600, 14660, 9289, 14586, 8893, 14508, 8533, 15111, 12234, 15110,
      12234, 15104, 12216, 15092, 12156, 15067, 12010, 15028, 11776, 14981,
      11500, 14942, 11205, 14902, 10752, 14861, 10393, 14812, 9991, 14752, 9570,
      14682, 9252, 14603, 8808, 14519, 8445, 14431, 8145, 15209, 11449, 15208,
      11451, 15202, 11451, 15190, 11438, 15163, 11384, 15117, 11274, 15055,
      10979, 14994, 10648, 14932, 10343, 14871, 9936, 14803, 9532, 14729, 9218,
      14645, 8742, 14556, 8381, 14461, 8020, 14365, 7603, 15273, 10603, 15272,
      10607, 15267, 10619, 15256, 10631, 15231, 10614, 15182, 10535, 15118,
      10389, 15042, 10167, 14963, 9787, 14883, 9447, 14800, 9115, 14710, 8665,
      14615, 8318, 14514, 7911, 14411, 7507, 14279, 7198, 15314, 9675, 15313,
      9683, 15309, 9712, 15298, 9759, 15277, 9797, 15229, 9773, 15166, 9668,
      15084, 9487, 14995, 9274, 14898, 8910, 14800, 8539, 14697, 8234, 14590,
      7790, 14479, 7409, 14367, 7067, 14178, 6621, 15337, 8619, 15337, 8631,
      15333, 8677, 15325, 8769, 15305, 8871, 15264, 8940, 15202, 8909, 15119,
      8775, 15022, 8565, 14916, 8328, 14804, 8009, 14688, 7614, 14569, 7287,
      14448, 6888, 14321, 6483, 14088, 6171, 15350, 7402, 15350, 7419, 15347,
      7480, 15340, 7613, 15322, 7804, 15287, 7973, 15229, 8057, 15148, 8012,
      15046, 7846, 14933, 7611, 14810, 7357, 14682, 7069, 14552, 6656, 14421,
      6316, 14251, 5948, 14007, 5528, 15356, 5942, 15356, 5977, 15353, 6119,
      15348, 6294, 15332, 6551, 15302, 6824, 15249, 7044, 15171, 7122, 15070,
      7050, 14949, 6861, 14818, 6611, 14679, 6349, 14538, 6067, 14398, 5651,
      14189, 5311, 13935, 4958, 15359, 4123, 15359, 4153, 15356, 4296, 15353,
      4646, 15338, 5160, 15311, 5508, 15263, 5829, 15188, 6042, 15088, 6094,
      14966, 6001, 14826, 5796, 14678, 5543, 14527, 5287, 14377, 4985, 14133,
      4586, 13869, 4257, 15360, 1563, 15360, 1642, 15358, 2076, 15354, 2636,
      15341, 3350, 15317, 4019, 15273, 4429, 15203, 4732, 15105, 4911, 14981,
      4932, 14836, 4818, 14679, 4621, 14517, 4386, 14359, 4156, 14083, 3795,
      13808, 3437, 15360, 122, 15360, 137, 15358, 285, 15355, 636, 15344, 1274,
      15322, 2177, 15281, 2765, 15215, 3223, 15120, 3451, 14995, 3569, 14846,
      3567, 14681, 3466, 14511, 3305, 14344, 3121, 14037, 2800, 13753, 2467,
      15360, 0, 15360, 1, 15359, 21, 15355, 89, 15346, 253, 15325, 479, 15287,
      796, 15225, 1148, 15133, 1492, 15008, 1749, 14856, 1882, 14685, 1886,
      14506, 1783, 14324, 1608, 13996, 1398, 13702, 1183,
    ]),
    tr = null;
  function tC() {
    return (
      tr === null &&
        ((tr = new Ka(eC, 16, 16, lo, er)),
        (tr.name = 'DFG_LUT'),
        (tr.minFilter = Si),
        (tr.magFilter = Si),
        (tr.wrapS = ns),
        (tr.wrapT = ns),
        (tr.generateMipmaps = !1),
        (tr.needsUpdate = !0)),
      tr
    );
  }
  var hl = class {
    constructor(e = {}) {
      let {
        canvas: t = xy(),
        context: i = null,
        depth: n = !0,
        stencil: r = !1,
        alpha: o = !1,
        antialias: a = !1,
        premultipliedAlpha: l = !0,
        preserveDrawingBuffer: c = !1,
        powerPreference: u = 'default',
        failIfMajorPerformanceCaveat: f = !1,
        reversedDepthBuffer: d = !1,
        outputBufferType: p = Ln,
      } = e;
      this.isWebGLRenderer = !0;
      let _;
      if (i !== null) {
        if (
          typeof WebGLRenderingContext != 'undefined' &&
          i instanceof WebGLRenderingContext
        )
          throw new Error(
            'THREE.WebGLRenderer: WebGL 1 is not supported since r163.',
          );
        _ = i.getContextAttributes().alpha;
      } else _ = o;
      let x = p,
        g = new Set([od, rd, sd]),
        v = new Set([Ln, Rs, sl, rl, td, id]),
        w = new Uint32Array(4),
        L = new Int32Array(4),
        R = new te(),
        U = null,
        O = null,
        N = [],
        M = [],
        I = null;
      ((this.domElement = t),
        (this.debug = { checkShaderErrors: !0, onShaderError: null }),
        (this.autoClear = !0),
        (this.autoClearColor = !0),
        (this.autoClearDepth = !0),
        (this.autoClearStencil = !0),
        (this.sortObjects = !0),
        (this.clippingPlanes = []),
        (this.localClippingEnabled = !1),
        (this.toneMapping = ws),
        (this.toneMappingExposure = 1),
        (this.transmissionResolutionScale = 1));
      let z = this,
        W = !1,
        q = null;
      this._outputColorSpace = zt;
      let re = 0,
        oe = 0,
        K = null,
        ie = -1,
        J = null,
        pe = new Qt(),
        Ee = new Qt(),
        Z = null,
        Ne = new je(0),
        Be = 0,
        ht = t.width,
        ot = t.height,
        tt = 1,
        ve = null,
        Pe = null,
        Ae = new Qt(0, 0, ht, ot),
        Ze = new Qt(0, 0, ht, ot),
        nt = !1,
        Le = new $a(),
        At = !1,
        Ke = !1,
        ut = new yt(),
        Tt = new te(),
        at = new Qt(),
        ue = {
          background: null,
          fog: null,
          environment: null,
          overrideMaterial: null,
          isScene: !0,
        },
        Rt = !1;
      function ti() {
        return K === null ? tt : 1;
      }
      let ee = i;
      function xt(P, T) {
        return t.getContext(P, T);
      }
      try {
        let P = {
          alpha: !0,
          depth: n,
          stencil: r,
          antialias: a,
          premultipliedAlpha: l,
          preserveDrawingBuffer: c,
          powerPreference: u,
          failIfMajorPerformanceCaveat: f,
        };
        if (
          ('setAttribute' in t &&
            t.setAttribute('data-engine', `three.js r${'184'}`),
          t.addEventListener('webglcontextlost', m, !1),
          t.addEventListener('webglcontextrestored', b, !1),
          t.addEventListener('webglcontextcreationerror', S, !1),
          ee === null)
        ) {
          let T = 'webgl2';
          if (((ee = xt(T, P)), ee === null))
            throw xt(T)
              ? new Error(
                  'Error creating WebGL context with your selected attributes.',
                )
              : new Error('Error creating WebGL context.');
        }
      } catch (P) {
        throw (mt('WebGLRenderer: ' + P.message), P);
      }
      let _t,
        Ut,
        Ue,
        bt,
        H,
        C,
        se,
        _e,
        we,
        Oe,
        Re,
        ge,
        be,
        ke,
        Ve,
        Te,
        Ie,
        Fe,
        rt,
        vt,
        j,
        Ce,
        ye;
      function D() {
        ((_t = new l1(ee)),
          _t.init(),
          (j = new ZR(ee, _t)),
          (Ut = new e1(ee, _t, e, j)),
          (Ue = new YR(ee, _t)),
          Ut.reversedDepthBuffer && d && Ue.buffers.depth.setReversed(!0),
          (bt = new u1(ee)),
          (H = new IR()),
          (C = new qR(ee, _t, Ue, H, Ut, j, bt)),
          (se = new a1(z)),
          (_e = new mM(ee)),
          (Ce = new JA(ee, _e)),
          (we = new c1(ee, _e, bt, Ce)),
          (Oe = new f1(ee, we, _e, Ce, bt)),
          (Fe = new d1(ee, Ut, C)),
          (Ve = new t1(H)),
          (Re = new LR(z, se, _t, Ut, Ce, Ve)),
          (ge = new JR(z, H)),
          (be = new OR()),
          (ke = new HR(_t)),
          (Ie = new jA(z, se, Ue, Oe, _, l)),
          (Te = new XR(z, Oe, Ut)),
          (ye = new QR(ee, bt, Ut, Ue)),
          (rt = new QA(ee, _t, bt)),
          (vt = new h1(ee, _t, bt)),
          (bt.programs = Re.programs),
          (z.capabilities = Ut),
          (z.extensions = _t),
          (z.properties = H),
          (z.renderLists = be),
          (z.shadowMap = Te),
          (z.state = Ue),
          (z.info = bt));
      }
      (D(), x !== Ln && (I = new m1(x, t.width, t.height, n, r)));
      let h = new Bg(z, ee);
      ((this.xr = h),
        (this.getContext = function () {
          return ee;
        }),
        (this.getContextAttributes = function () {
          return ee.getContextAttributes();
        }),
        (this.forceContextLoss = function () {
          let P = _t.get('WEBGL_lose_context');
          P && P.loseContext();
        }),
        (this.forceContextRestore = function () {
          let P = _t.get('WEBGL_lose_context');
          P && P.restoreContext();
        }),
        (this.getPixelRatio = function () {
          return tt;
        }),
        (this.setPixelRatio = function (P) {
          P !== void 0 && ((tt = P), this.setSize(ht, ot, !1));
        }),
        (this.getSize = function (P) {
          return P.set(ht, ot);
        }),
        (this.setSize = function (P, T, k = !0) {
          if (h.isPresenting) {
            it(
              "WebGLRenderer: Can't change size while VR device is presenting.",
            );
            return;
          }
          ((ht = P),
            (ot = T),
            (t.width = Math.floor(P * tt)),
            (t.height = Math.floor(T * tt)),
            k === !0 &&
              ((t.style.width = P + 'px'), (t.style.height = T + 'px')),
            I !== null && I.setSize(t.width, t.height),
            this.setViewport(0, 0, P, T));
        }),
        (this.getDrawingBufferSize = function (P) {
          return P.set(ht * tt, ot * tt).floor();
        }),
        (this.setDrawingBufferSize = function (P, T, k) {
          ((ht = P),
            (ot = T),
            (tt = k),
            (t.width = Math.floor(P * k)),
            (t.height = Math.floor(T * k)),
            this.setViewport(0, 0, P, T));
        }),
        (this.setEffects = function (P) {
          if (x === Ln) {
            mt(
              'THREE.WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.',
            );
            return;
          }
          if (P) {
            for (let T = 0; T < P.length; T++)
              if (P[T].isOutputPass === !0) {
                it(
                  'THREE.WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.',
                );
                break;
              }
          }
          I.setEffects(P || []);
        }),
        (this.getCurrentViewport = function (P) {
          return P.copy(pe);
        }),
        (this.getViewport = function (P) {
          return P.copy(Ae);
        }),
        (this.setViewport = function (P, T, k, G) {
          (P.isVector4 ? Ae.set(P.x, P.y, P.z, P.w) : Ae.set(P, T, k, G),
            Ue.viewport(pe.copy(Ae).multiplyScalar(tt).round()));
        }),
        (this.getScissor = function (P) {
          return P.copy(Ze);
        }),
        (this.setScissor = function (P, T, k, G) {
          (P.isVector4 ? Ze.set(P.x, P.y, P.z, P.w) : Ze.set(P, T, k, G),
            Ue.scissor(Ee.copy(Ze).multiplyScalar(tt).round()));
        }),
        (this.getScissorTest = function () {
          return nt;
        }),
        (this.setScissorTest = function (P) {
          Ue.setScissorTest((nt = P));
        }),
        (this.setOpaqueSort = function (P) {
          ve = P;
        }),
        (this.setTransparentSort = function (P) {
          Pe = P;
        }),
        (this.getClearColor = function (P) {
          return P.copy(Ie.getClearColor());
        }),
        (this.setClearColor = function () {
          Ie.setClearColor(...arguments);
        }),
        (this.getClearAlpha = function () {
          return Ie.getClearAlpha();
        }),
        (this.setClearAlpha = function () {
          Ie.setClearAlpha(...arguments);
        }),
        (this.clear = function (P = !0, T = !0, k = !0) {
          let G = 0;
          if (P) {
            let B = !1;
            if (K !== null) {
              let ae = K.texture.format;
              B = g.has(ae);
            }
            if (B) {
              let ae = K.texture.type,
                ne = v.has(ae),
                Q = Ie.getClearColor(),
                ce = Ie.getClearAlpha(),
                he = Q.r,
                He = Q.g,
                qe = Q.b;
              ne
                ? ((w[0] = he),
                  (w[1] = He),
                  (w[2] = qe),
                  (w[3] = ce),
                  ee.clearBufferuiv(ee.COLOR, 0, w))
                : ((L[0] = he),
                  (L[1] = He),
                  (L[2] = qe),
                  (L[3] = ce),
                  ee.clearBufferiv(ee.COLOR, 0, L));
            } else G |= ee.COLOR_BUFFER_BIT;
          }
          (T &&
            ((G |= ee.DEPTH_BUFFER_BIT), this.state.buffers.depth.setMask(!0)),
            k &&
              ((G |= ee.STENCIL_BUFFER_BIT),
              this.state.buffers.stencil.setMask(4294967295)),
            G !== 0 && ee.clear(G));
        }),
        (this.clearColor = function () {
          this.clear(!0, !1, !1);
        }),
        (this.clearDepth = function () {
          this.clear(!1, !0, !1);
        }),
        (this.clearStencil = function () {
          this.clear(!1, !1, !0);
        }),
        (this.setNodesHandler = function (P) {
          (P.setRenderer(this), (q = P));
        }),
        (this.dispose = function () {
          (t.removeEventListener('webglcontextlost', m, !1),
            t.removeEventListener('webglcontextrestored', b, !1),
            t.removeEventListener('webglcontextcreationerror', S, !1),
            Ie.dispose(),
            be.dispose(),
            ke.dispose(),
            H.dispose(),
            se.dispose(),
            Oe.dispose(),
            Ce.dispose(),
            ye.dispose(),
            Re.dispose(),
            h.dispose(),
            h.removeEventListener('sessionstart', $),
            h.removeEventListener('sessionend', le),
            xe.stop());
        }));
      function m(P) {
        (P.preventDefault(), fc('WebGLRenderer: Context Lost.'), (W = !0));
      }
      function b() {
        (fc('WebGLRenderer: Context Restored.'), (W = !1));
        let P = bt.autoReset,
          T = Te.enabled,
          k = Te.autoUpdate,
          G = Te.needsUpdate,
          B = Te.type;
        (D(),
          (bt.autoReset = P),
          (Te.enabled = T),
          (Te.autoUpdate = k),
          (Te.needsUpdate = G),
          (Te.type = B));
      }
      function S(P) {
        mt(
          'WebGLRenderer: A WebGL context could not be created. Reason: ',
          P.statusMessage,
        );
      }
      function E(P) {
        let T = P.target;
        (T.removeEventListener('dispose', E), A(T));
      }
      function A(P) {
        (F(P), H.remove(P));
      }
      function F(P) {
        let T = H.get(P).programs;
        T !== void 0 &&
          (T.forEach(function (k) {
            Re.releaseProgram(k);
          }),
          P.isShaderMaterial && Re.releaseShaderCache(P));
      }
      this.renderBufferDirect = function (P, T, k, G, B, ae) {
        T === null && (T = ue);
        let ne = B.isMesh && B.matrixWorld.determinant() < 0,
          Q = st(P, T, k, G, B);
        Ue.setMaterial(G, ne);
        let ce = k.index,
          he = 1;
        if (G.wireframe === !0) {
          if (((ce = we.getWireframeAttribute(k)), ce === void 0)) return;
          he = 2;
        }
        let He = k.drawRange,
          qe = k.attributes.position,
          Xe = He.start * he,
          Mt = (He.start + He.count) * he;
        (ae !== null &&
          ((Xe = Math.max(Xe, ae.start * he)),
          (Mt = Math.min(Mt, (ae.start + ae.count) * he))),
          ce !== null
            ? ((Xe = Math.max(Xe, 0)), (Mt = Math.min(Mt, ce.count)))
            : qe != null &&
              ((Xe = Math.max(Xe, 0)), (Mt = Math.min(Mt, qe.count))));
        let Yt = Mt - Xe;
        if (Yt < 0 || Yt === 1 / 0) return;
        Ce.setup(B, G, Q, k, ce);
        let Jt,
          kt = rt;
        if (
          (ce !== null && ((Jt = _e.get(ce)), (kt = vt), kt.setIndex(Jt)),
          B.isMesh)
        )
          G.wireframe === !0
            ? (Ue.setLineWidth(G.wireframeLinewidth * ti()),
              kt.setMode(ee.LINES))
            : kt.setMode(ee.TRIANGLES);
        else if (B.isLine) {
          let Ti = G.linewidth;
          (Ti === void 0 && (Ti = 1),
            Ue.setLineWidth(Ti * ti()),
            B.isLineSegments
              ? kt.setMode(ee.LINES)
              : B.isLineLoop
                ? kt.setMode(ee.LINE_LOOP)
                : kt.setMode(ee.LINE_STRIP));
        } else
          B.isPoints
            ? kt.setMode(ee.POINTS)
            : B.isSprite && kt.setMode(ee.TRIANGLES);
        if (B.isBatchedMesh)
          if (_t.get('WEBGL_multi_draw'))
            kt.renderMultiDraw(
              B._multiDrawStarts,
              B._multiDrawCounts,
              B._multiDrawCount,
            );
          else {
            let Ti = B._multiDrawStarts,
              $e = B._multiDrawCounts,
              an = B._multiDrawCount,
              Bt = ce ? _e.get(ce).bytesPerElement : 1,
              ln = H.get(G).currentProgram.getUniforms();
            for (let Ni = 0; Ni < an; Ni++)
              (ln.setValue(ee, '_gl_DrawID', Ni),
                kt.render(Ti[Ni] / Bt, $e[Ni]));
          }
        else if (B.isInstancedMesh) kt.renderInstances(Xe, Yt, B.count);
        else if (k.isInstancedBufferGeometry) {
          let Ti = k._maxInstanceCount !== void 0 ? k._maxInstanceCount : 1 / 0,
            $e = Math.min(k.instanceCount, Ti);
          kt.renderInstances(Xe, Yt, $e);
        } else kt.render(Xe, Yt);
      };
      function V(P, T, k) {
        P.transparent === !0 && P.side === Gi && P.forceSinglePass === !1
          ? ((P.side = bn),
            (P.needsUpdate = !0),
            De(P, T, k),
            (P.side = Ss),
            (P.needsUpdate = !0),
            De(P, T, k),
            (P.side = Gi))
          : De(P, T, k);
      }
      ((this.compile = function (P, T, k = null) {
        (k === null && (k = P),
          (O = ke.get(k)),
          O.init(T),
          M.push(O),
          k.traverseVisible(function (B) {
            B.isLight &&
              B.layers.test(T.layers) &&
              (O.pushLight(B), B.castShadow && O.pushShadow(B));
          }),
          P !== k &&
            P.traverseVisible(function (B) {
              B.isLight &&
                B.layers.test(T.layers) &&
                (O.pushLight(B), B.castShadow && O.pushShadow(B));
            }),
          O.setupLights());
        let G = new Set();
        return (
          P.traverse(function (B) {
            if (!(B.isMesh || B.isPoints || B.isLine || B.isSprite)) return;
            let ae = B.material;
            if (ae)
              if (Array.isArray(ae))
                for (let ne = 0; ne < ae.length; ne++) {
                  let Q = ae[ne];
                  (V(Q, k, B), G.add(Q));
                }
              else (V(ae, k, B), G.add(ae));
          }),
          (O = M.pop()),
          G
        );
      }),
        (this.compileAsync = function (P, T, k = null) {
          let G = this.compile(P, T, k);
          return new Promise((B) => {
            function ae() {
              if (
                (G.forEach(function (ne) {
                  H.get(ne).currentProgram.isReady() && G.delete(ne);
                }),
                G.size === 0)
              ) {
                B(P);
                return;
              }
              setTimeout(ae, 10);
            }
            _t.get('KHR_parallel_shader_compile') !== null
              ? ae()
              : setTimeout(ae, 10);
          });
        }));
      let Y = null;
      function X(P) {
        Y && Y(P);
      }
      function $() {
        xe.stop();
      }
      function le() {
        xe.start();
      }
      let xe = new Ky();
      (xe.setAnimationLoop(X),
        typeof self != 'undefined' && xe.setContext(self),
        (this.setAnimationLoop = function (P) {
          ((Y = P), h.setAnimationLoop(P), P === null ? xe.stop() : xe.start());
        }),
        h.addEventListener('sessionstart', $),
        h.addEventListener('sessionend', le),
        (this.render = function (P, T) {
          if (T !== void 0 && T.isCamera !== !0) {
            mt(
              'WebGLRenderer.render: camera is not an instance of THREE.Camera.',
            );
            return;
          }
          if (W === !0) return;
          q !== null && q.renderStart(P, T);
          let k = h.enabled === !0 && h.isPresenting === !0,
            G = I !== null && (K === null || k) && I.begin(z, K);
          if (
            (P.matrixWorldAutoUpdate === !0 && P.updateMatrixWorld(),
            T.parent === null &&
              T.matrixWorldAutoUpdate === !0 &&
              T.updateMatrixWorld(),
            h.enabled === !0 &&
              h.isPresenting === !0 &&
              (I === null || I.isCompositing() === !1) &&
              (h.cameraAutoUpdate === !0 && h.updateCamera(T),
              (T = h.getCamera())),
            P.isScene === !0 && P.onBeforeRender(z, P, T, K),
            (O = ke.get(P, M.length)),
            O.init(T),
            (O.state.textureUnits = C.getTextureUnits()),
            M.push(O),
            ut.multiplyMatrices(T.projectionMatrix, T.matrixWorldInverse),
            Le.setFromProjectionMatrix(ut, ys, T.reversedDepth),
            (Ke = this.localClippingEnabled),
            (At = Ve.init(this.clippingPlanes, Ke)),
            (U = be.get(P, N.length)),
            U.init(),
            N.push(U),
            h.enabled === !0 && h.isPresenting === !0)
          ) {
            let ne = z.xr.getDepthSensingMesh();
            ne !== null && fe(ne, T, -1 / 0, z.sortObjects);
          }
          (fe(P, T, 0, z.sortObjects),
            U.finish(),
            z.sortObjects === !0 && U.sort(ve, Pe),
            (Rt =
              h.enabled === !1 ||
              h.isPresenting === !1 ||
              h.hasDepthSensing() === !1),
            Rt && Ie.addToRenderList(U, P),
            this.info.render.frame++,
            At === !0 && Ve.beginShadows());
          let B = O.state.shadowsArray;
          if (
            (Te.render(B, P, T),
            At === !0 && Ve.endShadows(),
            this.info.autoReset === !0 && this.info.reset(),
            (G && I.hasRenderPass()) === !1)
          ) {
            let ne = U.opaque,
              Q = U.transmissive;
            if ((O.setupLights(), T.isArrayCamera)) {
              let ce = T.cameras;
              if (Q.length > 0)
                for (let he = 0, He = ce.length; he < He; he++) {
                  let qe = ce[he];
                  Me(ne, Q, P, qe);
                }
              Rt && Ie.render(P);
              for (let he = 0, He = ce.length; he < He; he++) {
                let qe = ce[he];
                Se(U, P, qe, qe.viewport);
              }
            } else
              (Q.length > 0 && Me(ne, Q, P, T),
                Rt && Ie.render(P),
                Se(U, P, T));
          }
          (K !== null &&
            oe === 0 &&
            (C.updateMultisampleRenderTarget(K), C.updateRenderTargetMipmap(K)),
            G && I.end(z),
            P.isScene === !0 && P.onAfterRender(z, P, T),
            Ce.resetDefaultState(),
            (ie = -1),
            (J = null),
            M.pop(),
            M.length > 0
              ? ((O = M[M.length - 1]),
                C.setTextureUnits(O.state.textureUnits),
                At === !0 &&
                  Ve.setGlobalState(z.clippingPlanes, O.state.camera))
              : (O = null),
            N.pop(),
            N.length > 0 ? (U = N[N.length - 1]) : (U = null),
            q !== null && q.renderEnd());
        }));
      function fe(P, T, k, G) {
        if (P.visible === !1) return;
        if (P.layers.test(T.layers)) {
          if (P.isGroup) k = P.renderOrder;
          else if (P.isLOD) P.autoUpdate === !0 && P.update(T);
          else if (P.isLightProbeGrid) O.pushLightProbeGrid(P);
          else if (P.isLight) (O.pushLight(P), P.castShadow && O.pushShadow(P));
          else if (P.isSprite) {
            if (!P.frustumCulled || Le.intersectsSprite(P)) {
              G && at.setFromMatrixPosition(P.matrixWorld).applyMatrix4(ut);
              let ne = Oe.update(P),
                Q = P.material;
              Q.visible && U.push(P, ne, Q, k, at.z, null);
            }
          } else if (
            (P.isMesh || P.isLine || P.isPoints) &&
            (!P.frustumCulled || Le.intersectsObject(P))
          ) {
            let ne = Oe.update(P),
              Q = P.material;
            if (
              (G &&
                (P.boundingSphere !== void 0
                  ? (P.boundingSphere === null && P.computeBoundingSphere(),
                    at.copy(P.boundingSphere.center))
                  : (ne.boundingSphere === null && ne.computeBoundingSphere(),
                    at.copy(ne.boundingSphere.center)),
                at.applyMatrix4(P.matrixWorld).applyMatrix4(ut)),
              Array.isArray(Q))
            ) {
              let ce = ne.groups;
              for (let he = 0, He = ce.length; he < He; he++) {
                let qe = ce[he],
                  Xe = Q[qe.materialIndex];
                Xe && Xe.visible && U.push(P, ne, Xe, k, at.z, qe);
              }
            } else Q.visible && U.push(P, ne, Q, k, at.z, null);
          }
        }
        let ae = P.children;
        for (let ne = 0, Q = ae.length; ne < Q; ne++) fe(ae[ne], T, k, G);
      }
      function Se(P, T, k, G) {
        let { opaque: B, transmissive: ae, transparent: ne } = P;
        (O.setupLightsView(k),
          At === !0 && Ve.setGlobalState(z.clippingPlanes, k),
          G && Ue.viewport(pe.copy(G)),
          B.length > 0 && de(B, T, k),
          ae.length > 0 && de(ae, T, k),
          ne.length > 0 && de(ne, T, k),
          Ue.buffers.depth.setTest(!0),
          Ue.buffers.depth.setMask(!0),
          Ue.buffers.color.setMask(!0),
          Ue.setPolygonOffset(!1));
      }
      function Me(P, T, k, G) {
        if ((k.isScene === !0 ? k.overrideMaterial : null) !== null) return;
        if (O.state.transmissionRenderTarget[G.id] === void 0) {
          let Xe =
            _t.has('EXT_color_buffer_half_float') ||
            _t.has('EXT_color_buffer_float');
          O.state.transmissionRenderTarget[G.id] = new xn(1, 1, {
            generateMipmaps: !0,
            type: Xe ? er : Ln,
            minFilter: As,
            samples: Math.max(4, Ut.samples),
            stencilBuffer: r,
            resolveDepthBuffer: !1,
            resolveStencilBuffer: !1,
            colorSpace: Ct.workingColorSpace,
          });
        }
        let ae = O.state.transmissionRenderTarget[G.id],
          ne = G.viewport || pe;
        ae.setSize(
          ne.z * z.transmissionResolutionScale,
          ne.w * z.transmissionResolutionScale,
        );
        let Q = z.getRenderTarget(),
          ce = z.getActiveCubeFace(),
          he = z.getActiveMipmapLevel();
        (z.setRenderTarget(ae),
          z.getClearColor(Ne),
          (Be = z.getClearAlpha()),
          Be < 1 && z.setClearColor(16777215, 0.5),
          z.clear(),
          Rt && Ie.render(k));
        let He = z.toneMapping;
        z.toneMapping = ws;
        let qe = G.viewport;
        if (
          (G.viewport !== void 0 && (G.viewport = void 0),
          O.setupLightsView(G),
          At === !0 && Ve.setGlobalState(z.clippingPlanes, G),
          de(P, k, G),
          C.updateMultisampleRenderTarget(ae),
          C.updateRenderTargetMipmap(ae),
          _t.has('WEBGL_multisampled_render_to_texture') === !1)
        ) {
          let Xe = !1;
          for (let Mt = 0, Yt = T.length; Mt < Yt; Mt++) {
            let Jt = T[Mt],
              { object: kt, geometry: Ti, material: $e, group: an } = Jt;
            if ($e.side === Gi && kt.layers.test(G.layers)) {
              let Bt = $e.side;
              (($e.side = bn),
                ($e.needsUpdate = !0),
                me(kt, k, G, Ti, $e, an),
                ($e.side = Bt),
                ($e.needsUpdate = !0),
                (Xe = !0));
            }
          }
          Xe === !0 &&
            (C.updateMultisampleRenderTarget(ae),
            C.updateRenderTargetMipmap(ae));
        }
        (z.setRenderTarget(Q, ce, he),
          z.setClearColor(Ne, Be),
          qe !== void 0 && (G.viewport = qe),
          (z.toneMapping = He));
      }
      function de(P, T, k) {
        let G = T.isScene === !0 ? T.overrideMaterial : null;
        for (let B = 0, ae = P.length; B < ae; B++) {
          let ne = P[B],
            { object: Q, geometry: ce, group: he } = ne,
            He = ne.material;
          (He.allowOverride === !0 && G !== null && (He = G),
            Q.layers.test(k.layers) && me(Q, T, k, ce, He, he));
        }
      }
      function me(P, T, k, G, B, ae) {
        (P.onBeforeRender(z, T, k, G, B, ae),
          P.modelViewMatrix.multiplyMatrices(
            k.matrixWorldInverse,
            P.matrixWorld,
          ),
          P.normalMatrix.getNormalMatrix(P.modelViewMatrix),
          B.onBeforeRender(z, T, k, G, P, ae),
          B.transparent === !0 && B.side === Gi && B.forceSinglePass === !1
            ? ((B.side = bn),
              (B.needsUpdate = !0),
              z.renderBufferDirect(k, T, G, B, P, ae),
              (B.side = Ss),
              (B.needsUpdate = !0),
              z.renderBufferDirect(k, T, G, B, P, ae),
              (B.side = Gi))
            : z.renderBufferDirect(k, T, G, B, P, ae),
          P.onAfterRender(z, T, k, G, B, ae));
      }
      function De(P, T, k) {
        T.isScene !== !0 && (T = ue);
        let G = H.get(P),
          B = O.state.lights,
          ae = O.state.shadowsArray,
          ne = B.state.version,
          Q = Re.getParameters(
            P,
            B.state,
            ae,
            T,
            k,
            O.state.lightProbeGridArray,
          ),
          ce = Re.getProgramCacheKey(Q),
          he = G.programs;
        ((G.environment =
          P.isMeshStandardMaterial ||
          P.isMeshLambertMaterial ||
          P.isMeshPhongMaterial
            ? T.environment
            : null),
          (G.fog = T.fog));
        let He =
          P.isMeshStandardMaterial ||
          (P.isMeshLambertMaterial && !P.envMap) ||
          (P.isMeshPhongMaterial && !P.envMap);
        ((G.envMap = se.get(P.envMap || G.environment, He)),
          (G.envMapRotation =
            G.environment !== null && P.envMap === null
              ? T.environmentRotation
              : P.envMapRotation),
          he === void 0 &&
            (P.addEventListener('dispose', E),
            (he = new Map()),
            (G.programs = he)));
        let qe = he.get(ce);
        if (qe !== void 0) {
          if (G.currentProgram === qe && G.lightsStateVersion === ne)
            return (ze(P, Q), qe);
        } else
          ((Q.uniforms = Re.getUniforms(P)),
            q !== null && P.isNodeMaterial && q.build(P, k, Q),
            P.onBeforeCompile(Q, z),
            (qe = Re.acquireProgram(Q, ce)),
            he.set(ce, qe),
            (G.uniforms = Q.uniforms));
        let Xe = G.uniforms;
        return (
          ((!P.isShaderMaterial && !P.isRawShaderMaterial) ||
            P.clipping === !0) &&
            (Xe.clippingPlanes = Ve.uniform),
          ze(P, Q),
          (G.needsLights = dt(P)),
          (G.lightsStateVersion = ne),
          G.needsLights &&
            ((Xe.ambientLightColor.value = B.state.ambient),
            (Xe.lightProbe.value = B.state.probe),
            (Xe.directionalLights.value = B.state.directional),
            (Xe.directionalLightShadows.value = B.state.directionalShadow),
            (Xe.spotLights.value = B.state.spot),
            (Xe.spotLightShadows.value = B.state.spotShadow),
            (Xe.rectAreaLights.value = B.state.rectArea),
            (Xe.ltc_1.value = B.state.rectAreaLTC1),
            (Xe.ltc_2.value = B.state.rectAreaLTC2),
            (Xe.pointLights.value = B.state.point),
            (Xe.pointLightShadows.value = B.state.pointShadow),
            (Xe.hemisphereLights.value = B.state.hemi),
            (Xe.directionalShadowMatrix.value =
              B.state.directionalShadowMatrix),
            (Xe.spotLightMatrix.value = B.state.spotLightMatrix),
            (Xe.spotLightMap.value = B.state.spotLightMap),
            (Xe.pointShadowMatrix.value = B.state.pointShadowMatrix)),
          (G.lightProbeGrid = O.state.lightProbeGridArray.length > 0),
          (G.currentProgram = qe),
          (G.uniformsList = null),
          qe
        );
      }
      function Ge(P) {
        if (P.uniformsList === null) {
          let T = P.currentProgram.getUniforms();
          P.uniformsList = ll.seqWithValue(T.seq, P.uniforms);
        }
        return P.uniformsList;
      }
      function ze(P, T) {
        let k = H.get(P);
        ((k.outputColorSpace = T.outputColorSpace),
          (k.batching = T.batching),
          (k.batchingColor = T.batchingColor),
          (k.instancing = T.instancing),
          (k.instancingColor = T.instancingColor),
          (k.instancingMorph = T.instancingMorph),
          (k.skinning = T.skinning),
          (k.morphTargets = T.morphTargets),
          (k.morphNormals = T.morphNormals),
          (k.morphColors = T.morphColors),
          (k.morphTargetsCount = T.morphTargetsCount),
          (k.numClippingPlanes = T.numClippingPlanes),
          (k.numIntersection = T.numClipIntersection),
          (k.vertexAlphas = T.vertexAlphas),
          (k.vertexTangents = T.vertexTangents),
          (k.toneMapping = T.toneMapping));
      }
      function lt(P, T) {
        if (P.length === 0) return null;
        if (P.length === 1) return P[0].texture !== null ? P[0] : null;
        R.setFromMatrixPosition(T.matrixWorld);
        for (let k = 0, G = P.length; k < G; k++) {
          let B = P[k];
          if (B.texture !== null && B.boundingBox.containsPoint(R)) return B;
        }
        return null;
      }
      function st(P, T, k, G, B) {
        (T.isScene !== !0 && (T = ue), C.resetTextureUnits());
        let ae = T.fog,
          ne =
            G.isMeshStandardMaterial ||
            G.isMeshLambertMaterial ||
            G.isMeshPhongMaterial
              ? T.environment
              : null,
          Q =
            K === null
              ? z.outputColorSpace
              : K.isXRRenderTarget === !0
                ? K.texture.colorSpace
                : Ct.workingColorSpace,
          ce =
            G.isMeshStandardMaterial ||
            (G.isMeshLambertMaterial && !G.envMap) ||
            (G.isMeshPhongMaterial && !G.envMap),
          he = se.get(G.envMap || ne, ce),
          He =
            G.vertexColors === !0 &&
            !!k.attributes.color &&
            k.attributes.color.itemSize === 4,
          qe = !!k.attributes.tangent && (!!G.normalMap || G.anisotropy > 0),
          Xe = !!k.morphAttributes.position,
          Mt = !!k.morphAttributes.normal,
          Yt = !!k.morphAttributes.color,
          Jt = ws;
        G.toneMapped &&
          (K === null || K.isXRRenderTarget === !0) &&
          (Jt = z.toneMapping);
        let kt =
            k.morphAttributes.position ||
            k.morphAttributes.normal ||
            k.morphAttributes.color,
          Ti = kt !== void 0 ? kt.length : 0,
          $e = H.get(G),
          an = O.state.lights;
        if (At === !0 && (Ke === !0 || P !== J)) {
          let qt = P === J && G.id === ie;
          Ve.setState(G, P, qt);
        }
        let Bt = !1;
        G.version === $e.__version
          ? (($e.needsLights && $e.lightsStateVersion !== an.state.version) ||
              $e.outputColorSpace !== Q ||
              (B.isBatchedMesh && $e.batching === !1) ||
              (!B.isBatchedMesh && $e.batching === !0) ||
              (B.isBatchedMesh &&
                $e.batchingColor === !0 &&
                B.colorTexture === null) ||
              (B.isBatchedMesh &&
                $e.batchingColor === !1 &&
                B.colorTexture !== null) ||
              (B.isInstancedMesh && $e.instancing === !1) ||
              (!B.isInstancedMesh && $e.instancing === !0) ||
              (B.isSkinnedMesh && $e.skinning === !1) ||
              (!B.isSkinnedMesh && $e.skinning === !0) ||
              (B.isInstancedMesh &&
                $e.instancingColor === !0 &&
                B.instanceColor === null) ||
              (B.isInstancedMesh &&
                $e.instancingColor === !1 &&
                B.instanceColor !== null) ||
              (B.isInstancedMesh &&
                $e.instancingMorph === !0 &&
                B.morphTexture === null) ||
              (B.isInstancedMesh &&
                $e.instancingMorph === !1 &&
                B.morphTexture !== null) ||
              $e.envMap !== he ||
              (G.fog === !0 && $e.fog !== ae) ||
              ($e.numClippingPlanes !== void 0 &&
                ($e.numClippingPlanes !== Ve.numPlanes ||
                  $e.numIntersection !== Ve.numIntersection)) ||
              $e.vertexAlphas !== He ||
              $e.vertexTangents !== qe ||
              $e.morphTargets !== Xe ||
              $e.morphNormals !== Mt ||
              $e.morphColors !== Yt ||
              $e.toneMapping !== Jt ||
              $e.morphTargetsCount !== Ti ||
              !!$e.lightProbeGrid != O.state.lightProbeGridArray.length > 0) &&
            (Bt = !0)
          : ((Bt = !0), ($e.__version = G.version));
        let ln = $e.currentProgram;
        Bt === !0 &&
          ((ln = De(G, T, B)),
          q && G.isNodeMaterial && q.onUpdateProgram(G, ln, $e));
        let Ni = !1,
          cn = !1,
          us = !1,
          Wt = ln.getUniforms(),
          oi = $e.uniforms;
        if (
          (Ue.useProgram(ln.program) && ((Ni = !0), (cn = !0), (us = !0)),
          G.id !== ie && ((ie = G.id), (cn = !0)),
          $e.needsLights)
        ) {
          let qt = lt(O.state.lightProbeGridArray, B);
          $e.lightProbeGrid !== qt && (($e.lightProbeGrid = qt), (cn = !0));
        }
        if (Ni || J !== P) {
          (Ue.buffers.depth.getReversed() &&
            P.reversedDepth !== !0 &&
            ((P._reversedDepth = !0), P.updateProjectionMatrix()),
            Wt.setValue(ee, 'projectionMatrix', P.projectionMatrix),
            Wt.setValue(ee, 'viewMatrix', P.matrixWorldInverse));
          let Os = Wt.map.cameraPosition;
          (Os !== void 0 &&
            Os.setValue(ee, Tt.setFromMatrixPosition(P.matrixWorld)),
            Ut.logarithmicDepthBuffer &&
              Wt.setValue(
                ee,
                'logDepthBufFC',
                2 / (Math.log(P.far + 1) / Math.LN2),
              ),
            (G.isMeshPhongMaterial ||
              G.isMeshToonMaterial ||
              G.isMeshLambertMaterial ||
              G.isMeshBasicMaterial ||
              G.isMeshStandardMaterial ||
              G.isShaderMaterial) &&
              Wt.setValue(ee, 'isOrthographic', P.isOrthographicCamera === !0),
            J !== P && ((J = P), (cn = !0), (us = !0)));
        }
        if (
          ($e.needsLights &&
            (an.state.directionalShadowMap.length > 0 &&
              Wt.setValue(
                ee,
                'directionalShadowMap',
                an.state.directionalShadowMap,
                C,
              ),
            an.state.spotShadowMap.length > 0 &&
              Wt.setValue(ee, 'spotShadowMap', an.state.spotShadowMap, C),
            an.state.pointShadowMap.length > 0 &&
              Wt.setValue(ee, 'pointShadowMap', an.state.pointShadowMap, C)),
          B.isSkinnedMesh)
        ) {
          (Wt.setOptional(ee, B, 'bindMatrix'),
            Wt.setOptional(ee, B, 'bindMatrixInverse'));
          let qt = B.skeleton;
          qt &&
            (qt.boneTexture === null && qt.computeBoneTexture(),
            Wt.setValue(ee, 'boneTexture', qt.boneTexture, C));
        }
        B.isBatchedMesh &&
          (Wt.setOptional(ee, B, 'batchingTexture'),
          Wt.setValue(ee, 'batchingTexture', B._matricesTexture, C),
          Wt.setOptional(ee, B, 'batchingIdTexture'),
          Wt.setValue(ee, 'batchingIdTexture', B._indirectTexture, C),
          Wt.setOptional(ee, B, 'batchingColorTexture'),
          B._colorsTexture !== null &&
            Wt.setValue(ee, 'batchingColorTexture', B._colorsTexture, C));
        let ds = k.morphAttributes;
        if (
          ((ds.position !== void 0 ||
            ds.normal !== void 0 ||
            ds.color !== void 0) &&
            Fe.update(B, k, ln),
          (cn || $e.receiveShadow !== B.receiveShadow) &&
            (($e.receiveShadow = B.receiveShadow),
            Wt.setValue(ee, 'receiveShadow', B.receiveShadow)),
          (G.isMeshStandardMaterial ||
            G.isMeshLambertMaterial ||
            G.isMeshPhongMaterial) &&
            G.envMap === null &&
            T.environment !== null &&
            (oi.envMapIntensity.value = T.environmentIntensity),
          oi.dfgLUT !== void 0 && (oi.dfgLUT.value = tC()),
          cn)
        ) {
          if (
            (Wt.setValue(ee, 'toneMappingExposure', z.toneMappingExposure),
            $e.needsLights && ft(oi, us),
            ae && G.fog === !0 && ge.refreshFogUniforms(oi, ae),
            ge.refreshMaterialUniforms(
              oi,
              G,
              tt,
              ot,
              O.state.transmissionRenderTarget[P.id],
            ),
            $e.needsLights && $e.lightProbeGrid)
          ) {
            let qt = $e.lightProbeGrid;
            ((oi.probesSH.value = qt.texture),
              oi.probesMin.value.copy(qt.boundingBox.min),
              oi.probesMax.value.copy(qt.boundingBox.max),
              oi.probesResolution.value.copy(qt.resolution));
          }
          ll.upload(ee, Ge($e), oi, C);
        }
        if (
          (G.isShaderMaterial &&
            G.uniformsNeedUpdate === !0 &&
            (ll.upload(ee, Ge($e), oi, C), (G.uniformsNeedUpdate = !1)),
          G.isSpriteMaterial && Wt.setValue(ee, 'center', B.center),
          Wt.setValue(ee, 'modelViewMatrix', B.modelViewMatrix),
          Wt.setValue(ee, 'normalMatrix', B.normalMatrix),
          Wt.setValue(ee, 'modelMatrix', B.matrixWorld),
          G.uniformsGroups !== void 0)
        ) {
          let qt = G.uniformsGroups;
          for (let Os = 0, sr = qt.length; Os < sr; Os++) {
            let vl = qt[Os];
            (ye.update(vl, ln), ye.bind(vl, ln));
          }
        }
        return ln;
      }
      function ft(P, T) {
        ((P.ambientLightColor.needsUpdate = T),
          (P.lightProbe.needsUpdate = T),
          (P.directionalLights.needsUpdate = T),
          (P.directionalLightShadows.needsUpdate = T),
          (P.pointLights.needsUpdate = T),
          (P.pointLightShadows.needsUpdate = T),
          (P.spotLights.needsUpdate = T),
          (P.spotLightShadows.needsUpdate = T),
          (P.rectAreaLights.needsUpdate = T),
          (P.hemisphereLights.needsUpdate = T));
      }
      function dt(P) {
        return (
          P.isMeshLambertMaterial ||
          P.isMeshToonMaterial ||
          P.isMeshPhongMaterial ||
          P.isMeshStandardMaterial ||
          P.isShadowMaterial ||
          (P.isShaderMaterial && P.lights === !0)
        );
      }
      ((this.getActiveCubeFace = function () {
        return re;
      }),
        (this.getActiveMipmapLevel = function () {
          return oe;
        }),
        (this.getRenderTarget = function () {
          return K;
        }),
        (this.setRenderTargetTextures = function (P, T, k) {
          let G = H.get(P);
          ((G.__autoAllocateDepthBuffer = P.resolveDepthBuffer === !1),
            G.__autoAllocateDepthBuffer === !1 && (G.__useRenderToTexture = !1),
            (H.get(P.texture).__webglTexture = T),
            (H.get(P.depthTexture).__webglTexture = G.__autoAllocateDepthBuffer
              ? void 0
              : k),
            (G.__hasExternalTextures = !0));
        }),
        (this.setRenderTargetFramebuffer = function (P, T) {
          let k = H.get(P);
          ((k.__webglFramebuffer = T),
            (k.__useDefaultFramebuffer = T === void 0));
        }));
      let gt = ee.createFramebuffer();
      ((this.setRenderTarget = function (P, T = 0, k = 0) {
        ((K = P), (re = T), (oe = k));
        let G = null,
          B = !1,
          ae = !1;
        if (P) {
          let Q = H.get(P);
          if (Q.__useDefaultFramebuffer !== void 0) {
            (Ue.bindFramebuffer(ee.FRAMEBUFFER, Q.__webglFramebuffer),
              pe.copy(P.viewport),
              Ee.copy(P.scissor),
              (Z = P.scissorTest),
              Ue.viewport(pe),
              Ue.scissor(Ee),
              Ue.setScissorTest(Z),
              (ie = -1));
            return;
          } else if (Q.__webglFramebuffer === void 0) C.setupRenderTarget(P);
          else if (Q.__hasExternalTextures)
            C.rebindTextures(
              P,
              H.get(P.texture).__webglTexture,
              H.get(P.depthTexture).__webglTexture,
            );
          else if (P.depthBuffer) {
            let He = P.depthTexture;
            if (Q.__boundDepthTexture !== He) {
              if (
                He !== null &&
                H.has(He) &&
                (P.width !== He.image.width || P.height !== He.image.height)
              )
                throw new Error(
                  'WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.',
                );
              C.setupDepthRenderbuffer(P);
            }
          }
          let ce = P.texture;
          (ce.isData3DTexture ||
            ce.isDataArrayTexture ||
            ce.isCompressedArrayTexture) &&
            (ae = !0);
          let he = H.get(P).__webglFramebuffer;
          (P.isWebGLCubeRenderTarget
            ? (Array.isArray(he[T]) ? (G = he[T][k]) : (G = he[T]), (B = !0))
            : P.samples > 0 && C.useMultisampledRTT(P) === !1
              ? (G = H.get(P).__webglMultisampledFramebuffer)
              : Array.isArray(he)
                ? (G = he[k])
                : (G = he),
            pe.copy(P.viewport),
            Ee.copy(P.scissor),
            (Z = P.scissorTest));
        } else
          (pe.copy(Ae).multiplyScalar(tt).floor(),
            Ee.copy(Ze).multiplyScalar(tt).floor(),
            (Z = nt));
        if (
          (k !== 0 && (G = gt),
          Ue.bindFramebuffer(ee.FRAMEBUFFER, G) && Ue.drawBuffers(P, G),
          Ue.viewport(pe),
          Ue.scissor(Ee),
          Ue.setScissorTest(Z),
          B)
        ) {
          let Q = H.get(P.texture);
          ee.framebufferTexture2D(
            ee.FRAMEBUFFER,
            ee.COLOR_ATTACHMENT0,
            ee.TEXTURE_CUBE_MAP_POSITIVE_X + T,
            Q.__webglTexture,
            k,
          );
        } else if (ae) {
          let Q = T;
          for (let ce = 0; ce < P.textures.length; ce++) {
            let he = H.get(P.textures[ce]);
            ee.framebufferTextureLayer(
              ee.FRAMEBUFFER,
              ee.COLOR_ATTACHMENT0 + ce,
              he.__webglTexture,
              k,
              Q,
            );
          }
        } else if (P !== null && k !== 0) {
          let Q = H.get(P.texture);
          ee.framebufferTexture2D(
            ee.FRAMEBUFFER,
            ee.COLOR_ATTACHMENT0,
            ee.TEXTURE_2D,
            Q.__webglTexture,
            k,
          );
        }
        ie = -1;
      }),
        (this.readRenderTargetPixels = function (P, T, k, G, B, ae, ne, Q = 0) {
          if (!(P && P.isWebGLRenderTarget)) {
            mt(
              'WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.',
            );
            return;
          }
          let ce = H.get(P).__webglFramebuffer;
          if (
            (P.isWebGLCubeRenderTarget && ne !== void 0 && (ce = ce[ne]), ce)
          ) {
            Ue.bindFramebuffer(ee.FRAMEBUFFER, ce);
            try {
              let he = P.textures[Q],
                He = he.format,
                qe = he.type;
              if (
                (P.textures.length > 1 &&
                  ee.readBuffer(ee.COLOR_ATTACHMENT0 + Q),
                !Ut.textureFormatReadable(He))
              ) {
                mt(
                  'WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.',
                );
                return;
              }
              if (!Ut.textureTypeReadable(qe)) {
                mt(
                  'WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.',
                );
                return;
              }
              T >= 0 &&
                T <= P.width - G &&
                k >= 0 &&
                k <= P.height - B &&
                ee.readPixels(T, k, G, B, j.convert(He), j.convert(qe), ae);
            } finally {
              let he = K !== null ? H.get(K).__webglFramebuffer : null;
              Ue.bindFramebuffer(ee.FRAMEBUFFER, he);
            }
          }
        }),
        (this.readRenderTargetPixelsAsync = function (
          P,
          T,
          k,
          G,
          B,
          ae,
          ne,
          Q = 0,
        ) {
          return Ns(this, null, function* () {
            if (!(P && P.isWebGLRenderTarget))
              throw new Error(
                'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.',
              );
            let ce = H.get(P).__webglFramebuffer;
            if (
              (P.isWebGLCubeRenderTarget && ne !== void 0 && (ce = ce[ne]), ce)
            )
              if (T >= 0 && T <= P.width - G && k >= 0 && k <= P.height - B) {
                Ue.bindFramebuffer(ee.FRAMEBUFFER, ce);
                let he = P.textures[Q],
                  He = he.format,
                  qe = he.type;
                if (
                  (P.textures.length > 1 &&
                    ee.readBuffer(ee.COLOR_ATTACHMENT0 + Q),
                  !Ut.textureFormatReadable(He))
                )
                  throw new Error(
                    'THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.',
                  );
                if (!Ut.textureTypeReadable(qe))
                  throw new Error(
                    'THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.',
                  );
                let Xe = ee.createBuffer();
                (ee.bindBuffer(ee.PIXEL_PACK_BUFFER, Xe),
                  ee.bufferData(
                    ee.PIXEL_PACK_BUFFER,
                    ae.byteLength,
                    ee.STREAM_READ,
                  ),
                  ee.readPixels(T, k, G, B, j.convert(He), j.convert(qe), 0));
                let Mt = K !== null ? H.get(K).__webglFramebuffer : null;
                Ue.bindFramebuffer(ee.FRAMEBUFFER, Mt);
                let Yt = ee.fenceSync(ee.SYNC_GPU_COMMANDS_COMPLETE, 0);
                return (
                  ee.flush(),
                  yield by(ee, Yt, 4),
                  ee.bindBuffer(ee.PIXEL_PACK_BUFFER, Xe),
                  ee.getBufferSubData(ee.PIXEL_PACK_BUFFER, 0, ae),
                  ee.deleteBuffer(Xe),
                  ee.deleteSync(Yt),
                  ae
                );
              } else
                throw new Error(
                  'THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.',
                );
          });
        }),
        (this.copyFramebufferToTexture = function (P, T = null, k = 0) {
          let G = Math.pow(2, -k),
            B = Math.floor(P.image.width * G),
            ae = Math.floor(P.image.height * G),
            ne = T !== null ? T.x : 0,
            Q = T !== null ? T.y : 0;
          (C.setTexture2D(P, 0),
            ee.copyTexSubImage2D(ee.TEXTURE_2D, k, 0, 0, ne, Q, B, ae),
            Ue.unbindTexture());
        }));
      let Gt = ee.createFramebuffer(),
        Ot = ee.createFramebuffer();
      ((this.copyTextureToTexture = function (
        P,
        T,
        k = null,
        G = null,
        B = 0,
        ae = 0,
      ) {
        let ne,
          Q,
          ce,
          he,
          He,
          qe,
          Xe,
          Mt,
          Yt,
          Jt = P.isCompressedTexture ? P.mipmaps[ae] : P.image;
        if (k !== null)
          ((ne = k.max.x - k.min.x),
            (Q = k.max.y - k.min.y),
            (ce = k.isBox3 ? k.max.z - k.min.z : 1),
            (he = k.min.x),
            (He = k.min.y),
            (qe = k.isBox3 ? k.min.z : 0));
        else {
          let oi = Math.pow(2, -B);
          ((ne = Math.floor(Jt.width * oi)),
            (Q = Math.floor(Jt.height * oi)),
            P.isDataArrayTexture
              ? (ce = Jt.depth)
              : P.isData3DTexture
                ? (ce = Math.floor(Jt.depth * oi))
                : (ce = 1),
            (he = 0),
            (He = 0),
            (qe = 0));
        }
        G !== null
          ? ((Xe = G.x), (Mt = G.y), (Yt = G.z))
          : ((Xe = 0), (Mt = 0), (Yt = 0));
        let kt = j.convert(T.format),
          Ti = j.convert(T.type),
          $e;
        (T.isData3DTexture
          ? (C.setTexture3D(T, 0), ($e = ee.TEXTURE_3D))
          : T.isDataArrayTexture || T.isCompressedArrayTexture
            ? (C.setTexture2DArray(T, 0), ($e = ee.TEXTURE_2D_ARRAY))
            : (C.setTexture2D(T, 0), ($e = ee.TEXTURE_2D)),
          Ue.activeTexture(ee.TEXTURE0),
          Ue.pixelStorei(ee.UNPACK_FLIP_Y_WEBGL, T.flipY),
          Ue.pixelStorei(ee.UNPACK_PREMULTIPLY_ALPHA_WEBGL, T.premultiplyAlpha),
          Ue.pixelStorei(ee.UNPACK_ALIGNMENT, T.unpackAlignment));
        let an = Ue.getParameter(ee.UNPACK_ROW_LENGTH),
          Bt = Ue.getParameter(ee.UNPACK_IMAGE_HEIGHT),
          ln = Ue.getParameter(ee.UNPACK_SKIP_PIXELS),
          Ni = Ue.getParameter(ee.UNPACK_SKIP_ROWS),
          cn = Ue.getParameter(ee.UNPACK_SKIP_IMAGES);
        (Ue.pixelStorei(ee.UNPACK_ROW_LENGTH, Jt.width),
          Ue.pixelStorei(ee.UNPACK_IMAGE_HEIGHT, Jt.height),
          Ue.pixelStorei(ee.UNPACK_SKIP_PIXELS, he),
          Ue.pixelStorei(ee.UNPACK_SKIP_ROWS, He),
          Ue.pixelStorei(ee.UNPACK_SKIP_IMAGES, qe));
        let us = P.isDataArrayTexture || P.isData3DTexture,
          Wt = T.isDataArrayTexture || T.isData3DTexture;
        if (P.isDepthTexture) {
          let oi = H.get(P),
            ds = H.get(T),
            qt = H.get(oi.__renderTarget),
            Os = H.get(ds.__renderTarget);
          (Ue.bindFramebuffer(ee.READ_FRAMEBUFFER, qt.__webglFramebuffer),
            Ue.bindFramebuffer(ee.DRAW_FRAMEBUFFER, Os.__webglFramebuffer));
          for (let sr = 0; sr < ce; sr++)
            (us &&
              (ee.framebufferTextureLayer(
                ee.READ_FRAMEBUFFER,
                ee.COLOR_ATTACHMENT0,
                H.get(P).__webglTexture,
                B,
                qe + sr,
              ),
              ee.framebufferTextureLayer(
                ee.DRAW_FRAMEBUFFER,
                ee.COLOR_ATTACHMENT0,
                H.get(T).__webglTexture,
                ae,
                Yt + sr,
              )),
              ee.blitFramebuffer(
                he,
                He,
                ne,
                Q,
                Xe,
                Mt,
                ne,
                Q,
                ee.DEPTH_BUFFER_BIT,
                ee.NEAREST,
              ));
          (Ue.bindFramebuffer(ee.READ_FRAMEBUFFER, null),
            Ue.bindFramebuffer(ee.DRAW_FRAMEBUFFER, null));
        } else if (B !== 0 || P.isRenderTargetTexture || H.has(P)) {
          let oi = H.get(P),
            ds = H.get(T);
          (Ue.bindFramebuffer(ee.READ_FRAMEBUFFER, Gt),
            Ue.bindFramebuffer(ee.DRAW_FRAMEBUFFER, Ot));
          for (let qt = 0; qt < ce; qt++)
            (us
              ? ee.framebufferTextureLayer(
                  ee.READ_FRAMEBUFFER,
                  ee.COLOR_ATTACHMENT0,
                  oi.__webglTexture,
                  B,
                  qe + qt,
                )
              : ee.framebufferTexture2D(
                  ee.READ_FRAMEBUFFER,
                  ee.COLOR_ATTACHMENT0,
                  ee.TEXTURE_2D,
                  oi.__webglTexture,
                  B,
                ),
              Wt
                ? ee.framebufferTextureLayer(
                    ee.DRAW_FRAMEBUFFER,
                    ee.COLOR_ATTACHMENT0,
                    ds.__webglTexture,
                    ae,
                    Yt + qt,
                  )
                : ee.framebufferTexture2D(
                    ee.DRAW_FRAMEBUFFER,
                    ee.COLOR_ATTACHMENT0,
                    ee.TEXTURE_2D,
                    ds.__webglTexture,
                    ae,
                  ),
              B !== 0
                ? ee.blitFramebuffer(
                    he,
                    He,
                    ne,
                    Q,
                    Xe,
                    Mt,
                    ne,
                    Q,
                    ee.COLOR_BUFFER_BIT,
                    ee.NEAREST,
                  )
                : Wt
                  ? ee.copyTexSubImage3D($e, ae, Xe, Mt, Yt + qt, he, He, ne, Q)
                  : ee.copyTexSubImage2D($e, ae, Xe, Mt, he, He, ne, Q));
          (Ue.bindFramebuffer(ee.READ_FRAMEBUFFER, null),
            Ue.bindFramebuffer(ee.DRAW_FRAMEBUFFER, null));
        } else
          Wt
            ? P.isDataTexture || P.isData3DTexture
              ? ee.texSubImage3D($e, ae, Xe, Mt, Yt, ne, Q, ce, kt, Ti, Jt.data)
              : T.isCompressedArrayTexture
                ? ee.compressedTexSubImage3D(
                    $e,
                    ae,
                    Xe,
                    Mt,
                    Yt,
                    ne,
                    Q,
                    ce,
                    kt,
                    Jt.data,
                  )
                : ee.texSubImage3D($e, ae, Xe, Mt, Yt, ne, Q, ce, kt, Ti, Jt)
            : P.isDataTexture
              ? ee.texSubImage2D(
                  ee.TEXTURE_2D,
                  ae,
                  Xe,
                  Mt,
                  ne,
                  Q,
                  kt,
                  Ti,
                  Jt.data,
                )
              : P.isCompressedTexture
                ? ee.compressedTexSubImage2D(
                    ee.TEXTURE_2D,
                    ae,
                    Xe,
                    Mt,
                    Jt.width,
                    Jt.height,
                    kt,
                    Jt.data,
                  )
                : ee.texSubImage2D(
                    ee.TEXTURE_2D,
                    ae,
                    Xe,
                    Mt,
                    ne,
                    Q,
                    kt,
                    Ti,
                    Jt,
                  );
        (Ue.pixelStorei(ee.UNPACK_ROW_LENGTH, an),
          Ue.pixelStorei(ee.UNPACK_IMAGE_HEIGHT, Bt),
          Ue.pixelStorei(ee.UNPACK_SKIP_PIXELS, ln),
          Ue.pixelStorei(ee.UNPACK_SKIP_ROWS, Ni),
          Ue.pixelStorei(ee.UNPACK_SKIP_IMAGES, cn),
          ae === 0 && T.generateMipmaps && ee.generateMipmap($e),
          Ue.unbindTexture());
      }),
        (this.initRenderTarget = function (P) {
          H.get(P).__webglFramebuffer === void 0 && C.setupRenderTarget(P);
        }),
        (this.initTexture = function (P) {
          (P.isCubeTexture
            ? C.setTextureCube(P, 0)
            : P.isData3DTexture
              ? C.setTexture3D(P, 0)
              : P.isDataArrayTexture || P.isCompressedArrayTexture
                ? C.setTexture2DArray(P, 0)
                : C.setTexture2D(P, 0),
            Ue.unbindTexture());
        }),
        (this.resetState = function () {
          ((re = 0), (oe = 0), (K = null), Ue.reset(), Ce.reset());
        }),
        typeof __THREE_DEVTOOLS__ != 'undefined' &&
          __THREE_DEVTOOLS__.dispatchEvent(
            new CustomEvent('observe', { detail: this }),
          ));
    }
    get coordinateSystem() {
      return ys;
    }
    get outputColorSpace() {
      return this._outputColorSpace;
    }
    set outputColorSpace(e) {
      this._outputColorSpace = e;
      let t = this.getContext();
      ((t.drawingBufferColorSpace = Ct._getDrawingBufferColorSpace(e)),
        (t.unpackColorSpace = Ct._getUnpackColorSpace()));
    }
  };
  var iC = 6,
    nC = 10,
    ib = 0.06,
    Xd = class {
      constructor(e) {
        y(this, 'group');
        y(this, 'capable');
        y(this, 'started', !1);
        y(this, 'targetX', 0);
        y(this, 'targetY', 0);
        y(this, 'currentX', 0);
        y(this, 'currentY', 0);
        y(this, 'start', () => {
          this.started = !0;
        });
        y(this, 'update', () => {
          !this.capable ||
            !this.started ||
            ((this.currentX += (this.targetX - this.currentX) * ib),
            (this.currentY += (this.targetY - this.currentY) * ib),
            (this.group.rotation.y = Vt.degToRad(this.currentX * nC)),
            (this.group.rotation.x = Vt.degToRad(this.currentY * iC)));
        });
        ((this.group = e),
          (this.capable = window.matchMedia(
            '(hover: hover) and (pointer: fine)',
          ).matches),
          this.capable &&
            window.addEventListener(
              'pointermove',
              (t) => {
                ((this.targetX = (t.clientX / window.innerWidth) * 2 - 1),
                  (this.targetY = (t.clientY / window.innerHeight) * 2 - 1));
              },
              { passive: !0 },
            ));
      }
    };
  function kg(s, e) {
    if (e === dg) return s;
    if (e === ol || e === Wc) {
      let t = s.getIndex();
      if (t === null) {
        let o = [],
          a = s.getAttribute('position');
        if (a !== void 0) {
          for (let l = 0; l < a.count; l++) o.push(l);
          (s.setIndex(o), (t = s.getIndex()));
        } else return s;
      }
      let i = t.count - 2,
        n = [];
      if (e === ol)
        for (let o = 1; o <= i; o++)
          (n.push(t.getX(0)), n.push(t.getX(o)), n.push(t.getX(o + 1)));
      else
        for (let o = 0; o < i; o++)
          o % 2 === 0
            ? (n.push(t.getX(o)), n.push(t.getX(o + 1)), n.push(t.getX(o + 2)))
            : (n.push(t.getX(o + 2)), n.push(t.getX(o + 1)), n.push(t.getX(o)));
      n.length / 3;
      let r = s.clone();
      return (r.setIndex(n), r.clearGroups(), r);
    } else return s;
  }
  function nb(s) {
    let e = new Map(),
      t = new Map(),
      i = s.clone();
    return (
      sb(s, i, function (n, r) {
        (e.set(r, n), t.set(n, r));
      }),
      i.traverse(function (n) {
        if (!n.isSkinnedMesh) return;
        let r = n,
          o = e.get(n),
          a = o.skeleton.bones;
        ((r.skeleton = o.skeleton.clone()),
          r.bindMatrix.copy(o.bindMatrix),
          (r.skeleton.bones = a.map(function (l) {
            return t.get(l);
          })),
          r.bind(r.skeleton, r.bindMatrix));
      }),
      i
    );
  }
  function sb(s, e, t) {
    t(s, e);
    for (let i = 0; i < s.children.length; i++)
      sb(s.children[i], e.children[i], t);
  }
  var Yd = class extends rs {
    constructor(e) {
      (super(e),
        (this.dracoLoader = null),
        (this.ktx2Loader = null),
        (this.meshoptDecoder = null),
        (this.pluginCallbacks = []),
        this.register(function (t) {
          return new Yg(t);
        }),
        this.register(function (t) {
          return new qg(t);
        }),
        this.register(function (t) {
          return new i_(t);
        }),
        this.register(function (t) {
          return new n_(t);
        }),
        this.register(function (t) {
          return new s_(t);
        }),
        this.register(function (t) {
          return new Kg(t);
        }),
        this.register(function (t) {
          return new $g(t);
        }),
        this.register(function (t) {
          return new jg(t);
        }),
        this.register(function (t) {
          return new Jg(t);
        }),
        this.register(function (t) {
          return new Xg(t);
        }),
        this.register(function (t) {
          return new Qg(t);
        }),
        this.register(function (t) {
          return new Zg(t);
        }),
        this.register(function (t) {
          return new t_(t);
        }),
        this.register(function (t) {
          return new e_(t);
        }),
        this.register(function (t) {
          return new Gg(t);
        }),
        this.register(function (t) {
          return new qd(t, Ft.EXT_MESHOPT_COMPRESSION);
        }),
        this.register(function (t) {
          return new qd(t, Ft.KHR_MESHOPT_COMPRESSION);
        }),
        this.register(function (t) {
          return new r_(t);
        }));
    }
    load(e, t, i, n) {
      let r = this,
        o;
      if (this.resourcePath !== '') o = this.resourcePath;
      else if (this.path !== '') {
        let c = Cr.extractUrlBase(e);
        o = Cr.resolveURL(c, this.path);
      } else o = Cr.extractUrlBase(e);
      this.manager.itemStart(e);
      let a = function (c) {
          (n && n(c), r.manager.itemError(e), r.manager.itemEnd(e));
        },
        l = new Rr(this.manager);
      (l.setPath(this.path),
        l.setResponseType('arraybuffer'),
        l.setRequestHeader(this.requestHeader),
        l.setWithCredentials(this.withCredentials),
        l.load(
          e,
          function (c) {
            try {
              r.parse(
                c,
                o,
                function (u) {
                  (t(u), r.manager.itemEnd(e));
                },
                a,
              );
            } catch (u) {
              a(u);
            }
          },
          i,
          a,
        ));
    }
    setDRACOLoader(e) {
      return ((this.dracoLoader = e), this);
    }
    setKTX2Loader(e) {
      return ((this.ktx2Loader = e), this);
    }
    setMeshoptDecoder(e) {
      return ((this.meshoptDecoder = e), this);
    }
    register(e) {
      return (
        this.pluginCallbacks.indexOf(e) === -1 && this.pluginCallbacks.push(e),
        this
      );
    }
    unregister(e) {
      return (
        this.pluginCallbacks.indexOf(e) !== -1 &&
          this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e), 1),
        this
      );
    }
    parse(e, t, i, n) {
      let r,
        o = {},
        a = {},
        l = new TextDecoder();
      if (typeof e == 'string') r = JSON.parse(e);
      else if (e instanceof ArrayBuffer)
        if (l.decode(new Uint8Array(e, 0, 4)) === cb) {
          try {
            o[Ft.KHR_BINARY_GLTF] = new o_(e);
          } catch (f) {
            n && n(f);
            return;
          }
          r = JSON.parse(o[Ft.KHR_BINARY_GLTF].content);
        } else r = JSON.parse(l.decode(e));
      else r = e;
      if (r.asset === void 0 || r.asset.version[0] < 2) {
        n &&
          n(
            new Error(
              'THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.',
            ),
          );
        return;
      }
      let c = new f_(r, {
        path: t || this.resourcePath || '',
        crossOrigin: this.crossOrigin,
        requestHeader: this.requestHeader,
        manager: this.manager,
        ktx2Loader: this.ktx2Loader,
        meshoptDecoder: this.meshoptDecoder,
      });
      c.fileLoader.setRequestHeader(this.requestHeader);
      for (let u = 0; u < this.pluginCallbacks.length; u++) {
        let f = this.pluginCallbacks[u](c);
        (f.name, (a[f.name] = f), (o[f.name] = !0));
      }
      if (r.extensionsUsed)
        for (let u = 0; u < r.extensionsUsed.length; ++u) {
          let f = r.extensionsUsed[u],
            d = r.extensionsRequired || [];
          switch (f) {
            case Ft.KHR_MATERIALS_UNLIT:
              o[f] = new Wg();
              break;
            case Ft.KHR_DRACO_MESH_COMPRESSION:
              o[f] = new a_(r, this.dracoLoader);
              break;
            case Ft.KHR_TEXTURE_TRANSFORM:
              o[f] = new l_();
              break;
            case Ft.KHR_MESH_QUANTIZATION:
              o[f] = new c_();
              break;
            default:
              d.indexOf(f) >= 0 && a[f];
          }
        }
      (c.setExtensions(o), c.setPlugins(a), c.parse(i, n));
    }
    parseAsync(e, t) {
      let i = this;
      return new Promise(function (n, r) {
        i.parse(e, t, n, r);
      });
    }
  };
  function sC() {
    let s = {};
    return {
      get: function (e) {
        return s[e];
      },
      add: function (e, t) {
        s[e] = t;
      },
      remove: function (e) {
        delete s[e];
      },
      removeAll: function () {
        s = {};
      },
    };
  }
  function Ei(s, e, t) {
    let i = s.json.materials[e];
    return i.extensions && i.extensions[t] ? i.extensions[t] : null;
  }
  var Ft = {
      KHR_BINARY_GLTF: 'KHR_binary_glTF',
      KHR_DRACO_MESH_COMPRESSION: 'KHR_draco_mesh_compression',
      KHR_LIGHTS_PUNCTUAL: 'KHR_lights_punctual',
      KHR_MATERIALS_CLEARCOAT: 'KHR_materials_clearcoat',
      KHR_MATERIALS_DISPERSION: 'KHR_materials_dispersion',
      KHR_MATERIALS_IOR: 'KHR_materials_ior',
      KHR_MATERIALS_SHEEN: 'KHR_materials_sheen',
      KHR_MATERIALS_SPECULAR: 'KHR_materials_specular',
      KHR_MATERIALS_TRANSMISSION: 'KHR_materials_transmission',
      KHR_MATERIALS_IRIDESCENCE: 'KHR_materials_iridescence',
      KHR_MATERIALS_ANISOTROPY: 'KHR_materials_anisotropy',
      KHR_MATERIALS_UNLIT: 'KHR_materials_unlit',
      KHR_MATERIALS_VOLUME: 'KHR_materials_volume',
      KHR_TEXTURE_BASISU: 'KHR_texture_basisu',
      KHR_TEXTURE_TRANSFORM: 'KHR_texture_transform',
      KHR_MESH_QUANTIZATION: 'KHR_mesh_quantization',
      KHR_MATERIALS_EMISSIVE_STRENGTH: 'KHR_materials_emissive_strength',
      EXT_MATERIALS_BUMP: 'EXT_materials_bump',
      EXT_TEXTURE_WEBP: 'EXT_texture_webp',
      EXT_TEXTURE_AVIF: 'EXT_texture_avif',
      EXT_MESHOPT_COMPRESSION: 'EXT_meshopt_compression',
      KHR_MESHOPT_COMPRESSION: 'KHR_meshopt_compression',
      EXT_MESH_GPU_INSTANCING: 'EXT_mesh_gpu_instancing',
    },
    Gg = class {
      constructor(e) {
        ((this.parser = e),
          (this.name = Ft.KHR_LIGHTS_PUNCTUAL),
          (this.cache = { refs: {}, uses: {} }));
      }
      _markDefs() {
        let e = this.parser,
          t = this.parser.json.nodes || [];
        for (let i = 0, n = t.length; i < n; i++) {
          let r = t[i];
          r.extensions &&
            r.extensions[this.name] &&
            r.extensions[this.name].light !== void 0 &&
            e._addNodeRef(this.cache, r.extensions[this.name].light);
        }
      }
      _loadLight(e) {
        let t = this.parser,
          i = 'light:' + e,
          n = t.cache.get(i);
        if (n) return n;
        let r = t.json,
          l = (((r.extensions && r.extensions[this.name]) || {}).lights || [])[
            e
          ],
          c,
          u = new je(16777215);
        l.color !== void 0 && u.setRGB(l.color[0], l.color[1], l.color[2], qi);
        let f = l.range !== void 0 ? l.range : 0;
        switch (l.type) {
          case 'directional':
            ((c = new Js(u)), c.target.position.set(0, 0, -1), c.add(c.target));
            break;
          case 'point':
            ((c = new Ic(u)), (c.distance = f));
            break;
          case 'spot':
            ((c = new Lc(u)),
              (c.distance = f),
              (l.spot = l.spot || {}),
              (l.spot.innerConeAngle =
                l.spot.innerConeAngle !== void 0 ? l.spot.innerConeAngle : 0),
              (l.spot.outerConeAngle =
                l.spot.outerConeAngle !== void 0
                  ? l.spot.outerConeAngle
                  : Math.PI / 4),
              (c.angle = l.spot.outerConeAngle),
              (c.penumbra = 1 - l.spot.innerConeAngle / l.spot.outerConeAngle),
              c.target.position.set(0, 0, -1),
              c.add(c.target));
            break;
          default:
            throw new Error(
              'THREE.GLTFLoader: Unexpected light type: ' + l.type,
            );
        }
        return (
          c.position.set(0, 0, 0),
          nr(c, l),
          l.intensity !== void 0 && (c.intensity = l.intensity),
          (c.name = t.createUniqueName(l.name || 'light_' + e)),
          (n = Promise.resolve(c)),
          t.cache.add(i, n),
          n
        );
      }
      getDependency(e, t) {
        if (e === 'light') return this._loadLight(t);
      }
      createNodeAttachment(e) {
        let t = this,
          i = this.parser,
          r = i.json.nodes[e],
          a = ((r.extensions && r.extensions[this.name]) || {}).light;
        return a === void 0
          ? null
          : this._loadLight(a).then(function (l) {
              return i._getNodeRef(t.cache, a, l);
            });
      }
    },
    Wg = class {
      constructor() {
        this.name = Ft.KHR_MATERIALS_UNLIT;
      }
      getMaterialType() {
        return rn;
      }
      extendParams(e, t, i) {
        let n = [];
        ((e.color = new je(1, 1, 1)), (e.opacity = 1));
        let r = t.pbrMetallicRoughness;
        if (r) {
          if (Array.isArray(r.baseColorFactor)) {
            let o = r.baseColorFactor;
            (e.color.setRGB(o[0], o[1], o[2], qi), (e.opacity = o[3]));
          }
          r.baseColorTexture !== void 0 &&
            n.push(i.assignTexture(e, 'map', r.baseColorTexture, zt));
        }
        return Promise.all(n);
      }
    },
    Xg = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.KHR_MATERIALS_EMISSIVE_STRENGTH));
      }
      extendMaterialParams(e, t) {
        let i = Ei(this.parser, e, this.name);
        return (
          i === null ||
            (i.emissiveStrength !== void 0 &&
              (t.emissiveIntensity = i.emissiveStrength)),
          Promise.resolve()
        );
      }
    },
    Yg = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.KHR_MATERIALS_CLEARCOAT));
      }
      getMaterialType(e) {
        return Ei(this.parser, e, this.name) !== null ? Cn : null;
      }
      extendMaterialParams(e, t) {
        let i = Ei(this.parser, e, this.name);
        if (i === null) return Promise.resolve();
        let n = [];
        if (
          (i.clearcoatFactor !== void 0 && (t.clearcoat = i.clearcoatFactor),
          i.clearcoatTexture !== void 0 &&
            n.push(
              this.parser.assignTexture(t, 'clearcoatMap', i.clearcoatTexture),
            ),
          i.clearcoatRoughnessFactor !== void 0 &&
            (t.clearcoatRoughness = i.clearcoatRoughnessFactor),
          i.clearcoatRoughnessTexture !== void 0 &&
            n.push(
              this.parser.assignTexture(
                t,
                'clearcoatRoughnessMap',
                i.clearcoatRoughnessTexture,
              ),
            ),
          i.clearcoatNormalTexture !== void 0 &&
            (n.push(
              this.parser.assignTexture(
                t,
                'clearcoatNormalMap',
                i.clearcoatNormalTexture,
              ),
            ),
            i.clearcoatNormalTexture.scale !== void 0))
        ) {
          let r = i.clearcoatNormalTexture.scale;
          t.clearcoatNormalScale = new et(r, r);
        }
        return Promise.all(n);
      }
    },
    qg = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.KHR_MATERIALS_DISPERSION));
      }
      getMaterialType(e) {
        return Ei(this.parser, e, this.name) !== null ? Cn : null;
      }
      extendMaterialParams(e, t) {
        let i = Ei(this.parser, e, this.name);
        return (
          i === null ||
            (t.dispersion = i.dispersion !== void 0 ? i.dispersion : 0),
          Promise.resolve()
        );
      }
    },
    Zg = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.KHR_MATERIALS_IRIDESCENCE));
      }
      getMaterialType(e) {
        return Ei(this.parser, e, this.name) !== null ? Cn : null;
      }
      extendMaterialParams(e, t) {
        let i = Ei(this.parser, e, this.name);
        if (i === null) return Promise.resolve();
        let n = [];
        return (
          i.iridescenceFactor !== void 0 &&
            (t.iridescence = i.iridescenceFactor),
          i.iridescenceTexture !== void 0 &&
            n.push(
              this.parser.assignTexture(
                t,
                'iridescenceMap',
                i.iridescenceTexture,
              ),
            ),
          i.iridescenceIor !== void 0 && (t.iridescenceIOR = i.iridescenceIor),
          t.iridescenceThicknessRange === void 0 &&
            (t.iridescenceThicknessRange = [100, 400]),
          i.iridescenceThicknessMinimum !== void 0 &&
            (t.iridescenceThicknessRange[0] = i.iridescenceThicknessMinimum),
          i.iridescenceThicknessMaximum !== void 0 &&
            (t.iridescenceThicknessRange[1] = i.iridescenceThicknessMaximum),
          i.iridescenceThicknessTexture !== void 0 &&
            n.push(
              this.parser.assignTexture(
                t,
                'iridescenceThicknessMap',
                i.iridescenceThicknessTexture,
              ),
            ),
          Promise.all(n)
        );
      }
    },
    Kg = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.KHR_MATERIALS_SHEEN));
      }
      getMaterialType(e) {
        return Ei(this.parser, e, this.name) !== null ? Cn : null;
      }
      extendMaterialParams(e, t) {
        let i = Ei(this.parser, e, this.name);
        if (i === null) return Promise.resolve();
        let n = [];
        if (
          ((t.sheenColor = new je(0, 0, 0)),
          (t.sheenRoughness = 0),
          (t.sheen = 1),
          i.sheenColorFactor !== void 0)
        ) {
          let r = i.sheenColorFactor;
          t.sheenColor.setRGB(r[0], r[1], r[2], qi);
        }
        return (
          i.sheenRoughnessFactor !== void 0 &&
            (t.sheenRoughness = i.sheenRoughnessFactor),
          i.sheenColorTexture !== void 0 &&
            n.push(
              this.parser.assignTexture(
                t,
                'sheenColorMap',
                i.sheenColorTexture,
                zt,
              ),
            ),
          i.sheenRoughnessTexture !== void 0 &&
            n.push(
              this.parser.assignTexture(
                t,
                'sheenRoughnessMap',
                i.sheenRoughnessTexture,
              ),
            ),
          Promise.all(n)
        );
      }
    },
    $g = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.KHR_MATERIALS_TRANSMISSION));
      }
      getMaterialType(e) {
        return Ei(this.parser, e, this.name) !== null ? Cn : null;
      }
      extendMaterialParams(e, t) {
        let i = Ei(this.parser, e, this.name);
        if (i === null) return Promise.resolve();
        let n = [];
        return (
          i.transmissionFactor !== void 0 &&
            (t.transmission = i.transmissionFactor),
          i.transmissionTexture !== void 0 &&
            n.push(
              this.parser.assignTexture(
                t,
                'transmissionMap',
                i.transmissionTexture,
              ),
            ),
          Promise.all(n)
        );
      }
    },
    jg = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.KHR_MATERIALS_VOLUME));
      }
      getMaterialType(e) {
        return Ei(this.parser, e, this.name) !== null ? Cn : null;
      }
      extendMaterialParams(e, t) {
        let i = Ei(this.parser, e, this.name);
        if (i === null) return Promise.resolve();
        let n = [];
        ((t.thickness = i.thicknessFactor !== void 0 ? i.thicknessFactor : 0),
          i.thicknessTexture !== void 0 &&
            n.push(
              this.parser.assignTexture(t, 'thicknessMap', i.thicknessTexture),
            ),
          (t.attenuationDistance = i.attenuationDistance || 1 / 0));
        let r = i.attenuationColor || [1, 1, 1];
        return (
          (t.attenuationColor = new je().setRGB(r[0], r[1], r[2], qi)),
          Promise.all(n)
        );
      }
    },
    Jg = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.KHR_MATERIALS_IOR));
      }
      getMaterialType(e) {
        return Ei(this.parser, e, this.name) !== null ? Cn : null;
      }
      extendMaterialParams(e, t) {
        let i = Ei(this.parser, e, this.name);
        return (
          i === null ||
            ((t.ior = i.ior !== void 0 ? i.ior : 1.5),
            t.ior === 0 && (t.ior = 1e3)),
          Promise.resolve()
        );
      }
    },
    Qg = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.KHR_MATERIALS_SPECULAR));
      }
      getMaterialType(e) {
        return Ei(this.parser, e, this.name) !== null ? Cn : null;
      }
      extendMaterialParams(e, t) {
        let i = Ei(this.parser, e, this.name);
        if (i === null) return Promise.resolve();
        let n = [];
        ((t.specularIntensity =
          i.specularFactor !== void 0 ? i.specularFactor : 1),
          i.specularTexture !== void 0 &&
            n.push(
              this.parser.assignTexture(
                t,
                'specularIntensityMap',
                i.specularTexture,
              ),
            ));
        let r = i.specularColorFactor || [1, 1, 1];
        return (
          (t.specularColor = new je().setRGB(r[0], r[1], r[2], qi)),
          i.specularColorTexture !== void 0 &&
            n.push(
              this.parser.assignTexture(
                t,
                'specularColorMap',
                i.specularColorTexture,
                zt,
              ),
            ),
          Promise.all(n)
        );
      }
    },
    e_ = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.EXT_MATERIALS_BUMP));
      }
      getMaterialType(e) {
        return Ei(this.parser, e, this.name) !== null ? Cn : null;
      }
      extendMaterialParams(e, t) {
        let i = Ei(this.parser, e, this.name);
        if (i === null) return Promise.resolve();
        let n = [];
        return (
          (t.bumpScale = i.bumpFactor !== void 0 ? i.bumpFactor : 1),
          i.bumpTexture !== void 0 &&
            n.push(this.parser.assignTexture(t, 'bumpMap', i.bumpTexture)),
          Promise.all(n)
        );
      }
    },
    t_ = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.KHR_MATERIALS_ANISOTROPY));
      }
      getMaterialType(e) {
        return Ei(this.parser, e, this.name) !== null ? Cn : null;
      }
      extendMaterialParams(e, t) {
        let i = Ei(this.parser, e, this.name);
        if (i === null) return Promise.resolve();
        let n = [];
        return (
          i.anisotropyStrength !== void 0 &&
            (t.anisotropy = i.anisotropyStrength),
          i.anisotropyRotation !== void 0 &&
            (t.anisotropyRotation = i.anisotropyRotation),
          i.anisotropyTexture !== void 0 &&
            n.push(
              this.parser.assignTexture(
                t,
                'anisotropyMap',
                i.anisotropyTexture,
              ),
            ),
          Promise.all(n)
        );
      }
    },
    i_ = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.KHR_TEXTURE_BASISU));
      }
      loadTexture(e) {
        let t = this.parser,
          i = t.json,
          n = i.textures[e];
        if (!n.extensions || !n.extensions[this.name]) return null;
        let r = n.extensions[this.name],
          o = t.options.ktx2Loader;
        if (!o) {
          if (
            i.extensionsRequired &&
            i.extensionsRequired.indexOf(this.name) >= 0
          )
            throw new Error(
              'THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures',
            );
          return null;
        }
        return t.loadTextureImage(e, r.source, o);
      }
    },
    n_ = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.EXT_TEXTURE_WEBP));
      }
      loadTexture(e) {
        let t = this.name,
          i = this.parser,
          n = i.json,
          r = n.textures[e];
        if (!r.extensions || !r.extensions[t]) return null;
        let o = r.extensions[t],
          a = n.images[o.source],
          l = i.textureLoader;
        if (a.uri) {
          let c = i.options.manager.getHandler(a.uri);
          c !== null && (l = c);
        }
        return i.loadTextureImage(e, o.source, l);
      }
    },
    s_ = class {
      constructor(e) {
        ((this.parser = e), (this.name = Ft.EXT_TEXTURE_AVIF));
      }
      loadTexture(e) {
        let t = this.name,
          i = this.parser,
          n = i.json,
          r = n.textures[e];
        if (!r.extensions || !r.extensions[t]) return null;
        let o = r.extensions[t],
          a = n.images[o.source],
          l = i.textureLoader;
        if (a.uri) {
          let c = i.options.manager.getHandler(a.uri);
          c !== null && (l = c);
        }
        return i.loadTextureImage(e, o.source, l);
      }
    },
    qd = class {
      constructor(e, t) {
        ((this.name = t), (this.parser = e));
      }
      loadBufferView(e) {
        let t = this.parser.json,
          i = t.bufferViews[e];
        if (i.extensions && i.extensions[this.name]) {
          let n = i.extensions[this.name],
            r = this.parser.getDependency('buffer', n.buffer),
            o = this.parser.options.meshoptDecoder;
          if (!o || !o.supported) {
            if (
              t.extensionsRequired &&
              t.extensionsRequired.indexOf(this.name) >= 0
            )
              throw new Error(
                'THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files',
              );
            return null;
          }
          return r.then(function (a) {
            let l = n.byteOffset || 0,
              c = n.byteLength || 0,
              u = n.count,
              f = n.byteStride,
              d = new Uint8Array(a, l, c);
            return o.decodeGltfBufferAsync
              ? o
                  .decodeGltfBufferAsync(u, f, d, n.mode, n.filter)
                  .then(function (p) {
                    return p.buffer;
                  })
              : o.ready.then(function () {
                  let p = new ArrayBuffer(u * f);
                  return (
                    o.decodeGltfBuffer(
                      new Uint8Array(p),
                      u,
                      f,
                      d,
                      n.mode,
                      n.filter,
                    ),
                    p
                  );
                });
          });
        } else return null;
      }
    },
    r_ = class {
      constructor(e) {
        ((this.name = Ft.EXT_MESH_GPU_INSTANCING), (this.parser = e));
      }
      createNodeMesh(e) {
        let t = this.parser.json,
          i = t.nodes[e];
        if (!i.extensions || !i.extensions[this.name] || i.mesh === void 0)
          return null;
        let n = t.meshes[i.mesh];
        for (let c of n.primitives)
          if (
            c.mode !== os.TRIANGLES &&
            c.mode !== os.TRIANGLE_STRIP &&
            c.mode !== os.TRIANGLE_FAN &&
            c.mode !== void 0
          )
            return null;
        let o = i.extensions[this.name].attributes,
          a = [],
          l = {};
        for (let c in o)
          a.push(
            this.parser
              .getDependency('accessor', o[c])
              .then((u) => ((l[c] = u), l[c])),
          );
        return a.length < 1
          ? null
          : (a.push(this.parser.createNodeMesh(e)),
            Promise.all(a).then((c) => {
              let u = c.pop(),
                f = u.isGroup ? u.children : [u],
                d = c[0].count,
                p = [];
              for (let _ of f) {
                let x = new yt(),
                  g = new te(),
                  v = new zi(),
                  w = new te(1, 1, 1),
                  L = new yc(_.geometry, _.material, d);
                for (let R = 0; R < d; R++)
                  (l.TRANSLATION && g.fromBufferAttribute(l.TRANSLATION, R),
                    l.ROTATION && v.fromBufferAttribute(l.ROTATION, R),
                    l.SCALE && w.fromBufferAttribute(l.SCALE, R),
                    L.setMatrixAt(R, x.compose(g, v, w)));
                for (let R in l)
                  if (R === '_COLOR_0') {
                    let U = l[R];
                    L.instanceColor = new io(U.array, U.itemSize, U.normalized);
                  } else
                    R !== 'TRANSLATION' &&
                      R !== 'ROTATION' &&
                      R !== 'SCALE' &&
                      _.geometry.setAttribute(R, l[R]);
                (pi.prototype.copy.call(L, _),
                  this.parser.assignFinalMaterial(L),
                  p.push(L));
              }
              return u.isGroup ? (u.clear(), u.add(...p), u) : p[0];
            }));
      }
    },
    cb = 'glTF',
    Zc = 12,
    rb = { JSON: 1313821514, BIN: 5130562 },
    o_ = class {
      constructor(e) {
        ((this.name = Ft.KHR_BINARY_GLTF),
          (this.content = null),
          (this.body = null));
        let t = new DataView(e, 0, Zc),
          i = new TextDecoder();
        if (
          ((this.header = {
            magic: i.decode(new Uint8Array(e.slice(0, 4))),
            version: t.getUint32(4, !0),
            length: t.getUint32(8, !0),
          }),
          this.header.magic !== cb)
        )
          throw new Error('THREE.GLTFLoader: Unsupported glTF-Binary header.');
        if (this.header.version < 2)
          throw new Error('THREE.GLTFLoader: Legacy binary file detected.');
        let n = this.header.length - Zc,
          r = new DataView(e, Zc),
          o = 0;
        for (; o < n; ) {
          let a = r.getUint32(o, !0);
          o += 4;
          let l = r.getUint32(o, !0);
          if (((o += 4), l === rb.JSON)) {
            let c = new Uint8Array(e, Zc + o, a);
            this.content = i.decode(c);
          } else if (l === rb.BIN) {
            let c = Zc + o;
            this.body = e.slice(c, c + a);
          }
          o += a;
        }
        if (this.content === null)
          throw new Error('THREE.GLTFLoader: JSON content not found.');
      }
    },
    a_ = class {
      constructor(e, t) {
        if (!t)
          throw new Error(
            'THREE.GLTFLoader: No DRACOLoader instance provided.',
          );
        ((this.name = Ft.KHR_DRACO_MESH_COMPRESSION),
          (this.json = e),
          (this.dracoLoader = t),
          this.dracoLoader.preload());
      }
      decodePrimitive(e, t) {
        let i = this.json,
          n = this.dracoLoader,
          r = e.extensions[this.name].bufferView,
          o = e.extensions[this.name].attributes,
          a = {},
          l = {},
          c = {};
        for (let u in o) {
          let f = u_[u] || u.toLowerCase();
          a[f] = o[u];
        }
        for (let u in e.attributes) {
          let f = u_[u] || u.toLowerCase();
          if (o[u] !== void 0) {
            let d = i.accessors[e.attributes[u]],
              p = dl[d.componentType];
            ((c[f] = p.name), (l[f] = d.normalized === !0));
          }
        }
        return t.getDependency('bufferView', r).then(function (u) {
          return new Promise(function (f, d) {
            n.decodeDracoFile(
              u,
              function (p) {
                for (let _ in p.attributes) {
                  let x = p.attributes[_],
                    g = l[_];
                  g !== void 0 && (x.normalized = g);
                }
                f(p);
              },
              a,
              c,
              qi,
              d,
            );
          });
        });
      }
    },
    l_ = class {
      constructor() {
        this.name = Ft.KHR_TEXTURE_TRANSFORM;
      }
      extendTexture(e, t) {
        return (
          ((t.texCoord === void 0 || t.texCoord === e.channel) &&
            t.offset === void 0 &&
            t.rotation === void 0 &&
            t.scale === void 0) ||
            ((e = e.clone()),
            t.texCoord !== void 0 && (e.channel = t.texCoord),
            t.offset !== void 0 && e.offset.fromArray(t.offset),
            t.rotation !== void 0 && (e.rotation = t.rotation),
            t.scale !== void 0 && e.repeat.fromArray(t.scale),
            (e.needsUpdate = !0)),
          e
        );
      }
    },
    c_ = class {
      constructor() {
        this.name = Ft.KHR_MESH_QUANTIZATION;
      }
    },
    Zd = class extends Zs {
      constructor(e, t, i, n) {
        super(e, t, i, n);
      }
      copySampleValue_(e) {
        let t = this.resultBuffer,
          i = this.sampleValues,
          n = this.valueSize,
          r = e * n * 3 + n;
        for (let o = 0; o !== n; o++) t[o] = i[r + o];
        return t;
      }
      interpolate_(e, t, i, n) {
        let r = this.resultBuffer,
          o = this.sampleValues,
          a = this.valueSize,
          l = a * 2,
          c = a * 3,
          u = n - t,
          f = (i - t) / u,
          d = f * f,
          p = d * f,
          _ = e * c,
          x = _ - c,
          g = -2 * p + 3 * d,
          v = p - d,
          w = 1 - g,
          L = v - d + f;
        for (let R = 0; R !== a; R++) {
          let U = o[x + R + a],
            O = o[x + R + l] * u,
            N = o[_ + R + a],
            M = o[_ + R] * u;
          r[R] = w * U + L * O + g * N + v * M;
        }
        return r;
      }
    },
    rC = new zi(),
    h_ = class extends Zd {
      interpolate_(e, t, i, n) {
        let r = super.interpolate_(e, t, i, n);
        return (rC.fromArray(r).normalize().toArray(r), r);
      }
    },
    os = {
      FLOAT: 5126,
      FLOAT_MAT3: 35675,
      FLOAT_MAT4: 35676,
      FLOAT_VEC2: 35664,
      FLOAT_VEC3: 35665,
      FLOAT_VEC4: 35666,
      LINEAR: 9729,
      REPEAT: 10497,
      SAMPLER_2D: 35678,
      POINTS: 0,
      LINES: 1,
      LINE_LOOP: 2,
      LINE_STRIP: 3,
      TRIANGLES: 4,
      TRIANGLE_STRIP: 5,
      TRIANGLE_FAN: 6,
      UNSIGNED_BYTE: 5121,
      UNSIGNED_SHORT: 5123,
    },
    dl = {
      5120: Int8Array,
      5121: Uint8Array,
      5122: Int16Array,
      5123: Uint16Array,
      5125: Uint32Array,
      5126: Float32Array,
    },
    ob = { 9728: bi, 9729: Si, 9984: Qu, 9985: nl, 9986: Qo, 9987: As },
    ab = { 33071: ns, 33648: Va, 10497: Qr },
    Hg = { SCALAR: 1, VEC2: 2, VEC3: 3, VEC4: 4, MAT2: 4, MAT3: 9, MAT4: 16 },
    u_ = {
      POSITION: 'position',
      NORMAL: 'normal',
      TANGENT: 'tangent',
      TEXCOORD_0: 'uv',
      TEXCOORD_1: 'uv1',
      TEXCOORD_2: 'uv2',
      TEXCOORD_3: 'uv3',
      COLOR_0: 'color',
      WEIGHTS_0: 'skinWeight',
      JOINTS_0: 'skinIndex',
    },
    ho = {
      scale: 'scale',
      translation: 'position',
      rotation: 'quaternion',
      weights: 'morphTargetInfluences',
    },
    oC = { CUBICSPLINE: void 0, LINEAR: Yo, STEP: Xo },
    zg = { OPAQUE: 'OPAQUE', MASK: 'MASK', BLEND: 'BLEND' };
  function aC(s) {
    return (
      s.DefaultMaterial === void 0 &&
        (s.DefaultMaterial = new Ko({
          color: 16777215,
          emissive: 0,
          metalness: 1,
          roughness: 1,
          transparent: !1,
          depthTest: !0,
          side: Ss,
        })),
      s.DefaultMaterial
    );
  }
  function ia(s, e, t) {
    for (let i in t.extensions)
      s[i] === void 0 &&
        ((e.userData.gltfExtensions = e.userData.gltfExtensions || {}),
        (e.userData.gltfExtensions[i] = t.extensions[i]));
  }
  function nr(s, e) {
    e.extras !== void 0 &&
      typeof e.extras == 'object' &&
      Object.assign(s.userData, e.extras);
  }
  function lC(s, e, t) {
    let i = !1,
      n = !1,
      r = !1;
    for (let c = 0, u = e.length; c < u; c++) {
      let f = e[c];
      if (
        (f.POSITION !== void 0 && (i = !0),
        f.NORMAL !== void 0 && (n = !0),
        f.COLOR_0 !== void 0 && (r = !0),
        i && n && r)
      )
        break;
    }
    if (!i && !n && !r) return Promise.resolve(s);
    let o = [],
      a = [],
      l = [];
    for (let c = 0, u = e.length; c < u; c++) {
      let f = e[c];
      if (i) {
        let d =
          f.POSITION !== void 0
            ? t.getDependency('accessor', f.POSITION)
            : s.attributes.position;
        o.push(d);
      }
      if (n) {
        let d =
          f.NORMAL !== void 0
            ? t.getDependency('accessor', f.NORMAL)
            : s.attributes.normal;
        a.push(d);
      }
      if (r) {
        let d =
          f.COLOR_0 !== void 0
            ? t.getDependency('accessor', f.COLOR_0)
            : s.attributes.color;
        l.push(d);
      }
    }
    return Promise.all([Promise.all(o), Promise.all(a), Promise.all(l)]).then(
      function (c) {
        let u = c[0],
          f = c[1],
          d = c[2];
        return (
          i && (s.morphAttributes.position = u),
          n && (s.morphAttributes.normal = f),
          r && (s.morphAttributes.color = d),
          (s.morphTargetsRelative = !0),
          s
        );
      },
    );
  }
  function cC(s, e) {
    if ((s.updateMorphTargets(), e.weights !== void 0))
      for (let t = 0, i = e.weights.length; t < i; t++)
        s.morphTargetInfluences[t] = e.weights[t];
    if (e.extras && Array.isArray(e.extras.targetNames)) {
      let t = e.extras.targetNames;
      if (s.morphTargetInfluences.length === t.length) {
        s.morphTargetDictionary = {};
        for (let i = 0, n = t.length; i < n; i++)
          s.morphTargetDictionary[t[i]] = i;
      }
    }
  }
  function hC(s) {
    let e,
      t = s.extensions && s.extensions[Ft.KHR_DRACO_MESH_COMPRESSION];
    if (
      (t
        ? (e =
            'draco:' + t.bufferView + ':' + t.indices + ':' + Vg(t.attributes))
        : (e = s.indices + ':' + Vg(s.attributes) + ':' + s.mode),
      s.targets !== void 0)
    )
      for (let i = 0, n = s.targets.length; i < n; i++)
        e += ':' + Vg(s.targets[i]);
    return e;
  }
  function Vg(s) {
    let e = '',
      t = Object.keys(s).sort();
    for (let i = 0, n = t.length; i < n; i++) e += t[i] + ':' + s[t[i]] + ';';
    return e;
  }
  function d_(s) {
    switch (s) {
      case Int8Array:
        return 1 / 127;
      case Uint8Array:
        return 1 / 255;
      case Int16Array:
        return 1 / 32767;
      case Uint16Array:
        return 1 / 65535;
      default:
        throw new Error(
          'THREE.GLTFLoader: Unsupported normalized accessor component type.',
        );
    }
  }
  function uC(s) {
    return s.search(/\.jpe?g($|\?)/i) > 0 ||
      s.search(/^data\:image\/jpeg/) === 0
      ? 'image/jpeg'
      : s.search(/\.webp($|\?)/i) > 0 || s.search(/^data\:image\/webp/) === 0
        ? 'image/webp'
        : s.search(/\.ktx2($|\?)/i) > 0 || s.search(/^data\:image\/ktx2/) === 0
          ? 'image/ktx2'
          : 'image/png';
  }
  var dC = new yt(),
    f_ = class {
      constructor(e = {}, t = {}) {
        ((this.json = e),
          (this.extensions = {}),
          (this.plugins = {}),
          (this.options = t),
          (this.cache = new sC()),
          (this.associations = new Map()),
          (this.primitiveCache = {}),
          (this.nodeCache = {}),
          (this.meshCache = { refs: {}, uses: {} }),
          (this.cameraCache = { refs: {}, uses: {} }),
          (this.lightCache = { refs: {}, uses: {} }),
          (this.sourceCache = {}),
          (this.textureCache = {}),
          (this.nodeNamesUsed = {}));
        let i = !1,
          n = -1,
          r = !1,
          o = -1;
        if (
          typeof navigator != 'undefined' &&
          typeof navigator.userAgent != 'undefined'
        ) {
          let a = navigator.userAgent;
          i = /^((?!chrome|android).)*safari/i.test(a) === !0;
          let l = a.match(/Version\/(\d+)/);
          ((n = i && l ? parseInt(l[1], 10) : -1),
            (r = a.indexOf('Firefox') > -1),
            (o = r ? a.match(/Firefox\/([0-9]+)\./)[1] : -1));
        }
        (typeof createImageBitmap == 'undefined' ||
        (i && n < 17) ||
        (r && o < 98)
          ? (this.textureLoader = new $o(this.options.manager))
          : (this.textureLoader = new Dc(this.options.manager)),
          this.textureLoader.setCrossOrigin(this.options.crossOrigin),
          this.textureLoader.setRequestHeader(this.options.requestHeader),
          (this.fileLoader = new Rr(this.options.manager)),
          this.fileLoader.setResponseType('arraybuffer'),
          this.options.crossOrigin === 'use-credentials' &&
            this.fileLoader.setWithCredentials(!0));
      }
      setExtensions(e) {
        this.extensions = e;
      }
      setPlugins(e) {
        this.plugins = e;
      }
      parse(e, t) {
        let i = this,
          n = this.json,
          r = this.extensions;
        (this.cache.removeAll(),
          (this.nodeCache = {}),
          this._invokeAll(function (o) {
            return o._markDefs && o._markDefs();
          }),
          Promise.all(
            this._invokeAll(function (o) {
              return o.beforeRoot && o.beforeRoot();
            }),
          )
            .then(function () {
              return Promise.all([
                i.getDependencies('scene'),
                i.getDependencies('animation'),
                i.getDependencies('camera'),
              ]);
            })
            .then(function (o) {
              let a = {
                scene: o[0][n.scene || 0],
                scenes: o[0],
                animations: o[1],
                cameras: o[2],
                asset: n.asset,
                parser: i,
                userData: {},
              };
              return (
                ia(r, a, n),
                nr(a, n),
                Promise.all(
                  i._invokeAll(function (l) {
                    return l.afterRoot && l.afterRoot(a);
                  }),
                ).then(function () {
                  for (let l of a.scenes) l.updateMatrixWorld();
                  e(a);
                })
              );
            })
            .catch(t));
      }
      _markDefs() {
        let e = this.json.nodes || [],
          t = this.json.skins || [],
          i = this.json.meshes || [];
        for (let n = 0, r = t.length; n < r; n++) {
          let o = t[n].joints;
          for (let a = 0, l = o.length; a < l; a++) e[o[a]].isBone = !0;
        }
        for (let n = 0, r = e.length; n < r; n++) {
          let o = e[n];
          (o.mesh !== void 0 &&
            (this._addNodeRef(this.meshCache, o.mesh),
            o.skin !== void 0 && (i[o.mesh].isSkinnedMesh = !0)),
            o.camera !== void 0 &&
              this._addNodeRef(this.cameraCache, o.camera));
        }
      }
      _addNodeRef(e, t) {
        t !== void 0 &&
          (e.refs[t] === void 0 && (e.refs[t] = e.uses[t] = 0), e.refs[t]++);
      }
      _getNodeRef(e, t, i) {
        if (e.refs[t] <= 1) return i;
        let n = i.clone(),
          r = (o, a) => {
            let l = this.associations.get(o);
            l != null && this.associations.set(a, l);
            for (let [c, u] of o.children.entries()) r(u, a.children[c]);
          };
        return (r(i, n), (n.name += '_instance_' + e.uses[t]++), n);
      }
      _invokeOne(e) {
        let t = Object.values(this.plugins);
        t.push(this);
        for (let i = 0; i < t.length; i++) {
          let n = e(t[i]);
          if (n) return n;
        }
        return null;
      }
      _invokeAll(e) {
        let t = Object.values(this.plugins);
        t.unshift(this);
        let i = [];
        for (let n = 0; n < t.length; n++) {
          let r = e(t[n]);
          r && i.push(r);
        }
        return i;
      }
      getDependency(e, t) {
        let i = e + ':' + t,
          n = this.cache.get(i);
        if (!n) {
          switch (e) {
            case 'scene':
              n = this.loadScene(t);
              break;
            case 'node':
              n = this._invokeOne(function (r) {
                return r.loadNode && r.loadNode(t);
              });
              break;
            case 'mesh':
              n = this._invokeOne(function (r) {
                return r.loadMesh && r.loadMesh(t);
              });
              break;
            case 'accessor':
              n = this.loadAccessor(t);
              break;
            case 'bufferView':
              n = this._invokeOne(function (r) {
                return r.loadBufferView && r.loadBufferView(t);
              });
              break;
            case 'buffer':
              n = this.loadBuffer(t);
              break;
            case 'material':
              n = this._invokeOne(function (r) {
                return r.loadMaterial && r.loadMaterial(t);
              });
              break;
            case 'texture':
              n = this._invokeOne(function (r) {
                return r.loadTexture && r.loadTexture(t);
              });
              break;
            case 'skin':
              n = this.loadSkin(t);
              break;
            case 'animation':
              n = this._invokeOne(function (r) {
                return r.loadAnimation && r.loadAnimation(t);
              });
              break;
            case 'camera':
              n = this.loadCamera(t);
              break;
            default:
              if (
                ((n = this._invokeOne(function (r) {
                  return r != this && r.getDependency && r.getDependency(e, t);
                })),
                !n)
              )
                throw new Error('Unknown type: ' + e);
              break;
          }
          this.cache.add(i, n);
        }
        return n;
      }
      getDependencies(e) {
        let t = this.cache.get(e);
        if (!t) {
          let i = this,
            n = this.json[e + (e === 'mesh' ? 'es' : 's')] || [];
          ((t = Promise.all(
            n.map(function (r, o) {
              return i.getDependency(e, o);
            }),
          )),
            this.cache.add(e, t));
        }
        return t;
      }
      loadBuffer(e) {
        let t = this.json.buffers[e],
          i = this.fileLoader;
        if (t.type && t.type !== 'arraybuffer')
          throw new Error(
            'THREE.GLTFLoader: ' + t.type + ' buffer type is not supported.',
          );
        if (t.uri === void 0 && e === 0)
          return Promise.resolve(this.extensions[Ft.KHR_BINARY_GLTF].body);
        let n = this.options;
        return new Promise(function (r, o) {
          i.load(Cr.resolveURL(t.uri, n.path), r, void 0, function () {
            o(
              new Error(
                'THREE.GLTFLoader: Failed to load buffer "' + t.uri + '".',
              ),
            );
          });
        });
      }
      loadBufferView(e) {
        let t = this.json.bufferViews[e];
        return this.getDependency('buffer', t.buffer).then(function (i) {
          let n = t.byteLength || 0,
            r = t.byteOffset || 0;
          return i.slice(r, r + n);
        });
      }
      loadAccessor(e) {
        let t = this,
          i = this.json,
          n = this.json.accessors[e];
        if (n.bufferView === void 0 && n.sparse === void 0) {
          let o = Hg[n.type],
            a = dl[n.componentType],
            l = n.normalized === !0,
            c = new a(n.count * o);
          return Promise.resolve(new fi(c, o, l));
        }
        let r = [];
        return (
          n.bufferView !== void 0
            ? r.push(this.getDependency('bufferView', n.bufferView))
            : r.push(null),
          n.sparse !== void 0 &&
            (r.push(
              this.getDependency('bufferView', n.sparse.indices.bufferView),
            ),
            r.push(
              this.getDependency('bufferView', n.sparse.values.bufferView),
            )),
          Promise.all(r).then(function (o) {
            let a = o[0],
              l = Hg[n.type],
              c = dl[n.componentType],
              u = c.BYTES_PER_ELEMENT,
              f = u * l,
              d = n.byteOffset || 0,
              p =
                n.bufferView !== void 0
                  ? i.bufferViews[n.bufferView].byteStride
                  : void 0,
              _ = n.normalized === !0,
              x,
              g;
            if (p && p !== f) {
              let v = Math.floor(d / p),
                w =
                  'InterleavedBuffer:' +
                  n.bufferView +
                  ':' +
                  n.componentType +
                  ':' +
                  v +
                  ':' +
                  n.count,
                L = t.cache.get(w);
              (L ||
                ((x = new c(a, v * p, (n.count * p) / u)),
                (L = new eo(x, p / u)),
                t.cache.add(w, L)),
                (g = new to(L, l, (d % p) / u, _)));
            } else
              (a === null
                ? (x = new c(n.count * l))
                : (x = new c(a, d, n.count * l)),
                (g = new fi(x, l, _)));
            if (n.sparse !== void 0) {
              let v = Hg.SCALAR,
                w = dl[n.sparse.indices.componentType],
                L = n.sparse.indices.byteOffset || 0,
                R = n.sparse.values.byteOffset || 0,
                U = new w(o[1], L, n.sparse.count * v),
                O = new c(o[2], R, n.sparse.count * l);
              (a !== null &&
                (g = new fi(g.array.slice(), g.itemSize, g.normalized)),
                (g.normalized = !1));
              for (let N = 0, M = U.length; N < M; N++) {
                let I = U[N];
                if (
                  (g.setX(I, O[N * l]),
                  l >= 2 && g.setY(I, O[N * l + 1]),
                  l >= 3 && g.setZ(I, O[N * l + 2]),
                  l >= 4 && g.setW(I, O[N * l + 3]),
                  l >= 5)
                )
                  throw new Error(
                    'THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.',
                  );
              }
              g.normalized = _;
            }
            return g;
          })
        );
      }
      loadTexture(e) {
        let t = this.json,
          i = this.options,
          r = t.textures[e].source,
          o = t.images[r],
          a = this.textureLoader;
        if (o.uri) {
          let l = i.manager.getHandler(o.uri);
          l !== null && (a = l);
        }
        return this.loadTextureImage(e, r, a);
      }
      loadTextureImage(e, t, i) {
        let n = this,
          r = this.json,
          o = r.textures[e],
          a = r.images[t],
          l = (a.uri || a.bufferView) + ':' + o.sampler;
        if (this.textureCache[l]) return this.textureCache[l];
        let c = this.loadImageSource(t, i)
          .then(function (u) {
            ((u.flipY = !1),
              (u.name = o.name || a.name || ''),
              u.name === '' &&
                typeof a.uri == 'string' &&
                a.uri.startsWith('data:image/') === !1 &&
                (u.name = a.uri));
            let d = (r.samplers || {})[o.sampler] || {};
            return (
              (u.magFilter = ob[d.magFilter] || Si),
              (u.minFilter = ob[d.minFilter] || As),
              (u.wrapS = ab[d.wrapS] || Qr),
              (u.wrapT = ab[d.wrapT] || Qr),
              (u.generateMipmaps =
                !u.isCompressedTexture &&
                u.minFilter !== bi &&
                u.minFilter !== Si),
              n.associations.set(u, { textures: e }),
              u
            );
          })
          .catch(function () {
            return null;
          });
        return ((this.textureCache[l] = c), c);
      }
      loadImageSource(e, t) {
        let i = this,
          n = this.json,
          r = this.options;
        if (this.sourceCache[e] !== void 0)
          return this.sourceCache[e].then((f) => f.clone());
        let o = n.images[e],
          a = self.URL || self.webkitURL,
          l = o.uri || '',
          c = !1;
        if (o.bufferView !== void 0)
          l = i.getDependency('bufferView', o.bufferView).then(function (f) {
            c = !0;
            let d = new Blob([f], { type: o.mimeType });
            return ((l = a.createObjectURL(d)), l);
          });
        else if (o.uri === void 0)
          throw new Error(
            'THREE.GLTFLoader: Image ' + e + ' is missing URI and bufferView',
          );
        let u = Promise.resolve(l)
          .then(function (f) {
            return new Promise(function (d, p) {
              let _ = d;
              (t.isImageBitmapLoader === !0 &&
                (_ = function (x) {
                  let g = new Li(x);
                  ((g.needsUpdate = !0), d(g));
                }),
                t.load(Cr.resolveURL(f, r.path), _, void 0, p));
            });
          })
          .then(function (f) {
            return (
              c === !0 && a.revokeObjectURL(l),
              nr(f, o),
              (f.userData.mimeType = o.mimeType || uC(o.uri)),
              f
            );
          })
          .catch(function (f) {
            throw f;
          });
        return ((this.sourceCache[e] = u), u);
      }
      assignTexture(e, t, i, n) {
        let r = this;
        return this.getDependency('texture', i.index).then(function (o) {
          if (!o) return null;
          if (
            (i.texCoord !== void 0 &&
              i.texCoord > 0 &&
              ((o = o.clone()), (o.channel = i.texCoord)),
            r.extensions[Ft.KHR_TEXTURE_TRANSFORM])
          ) {
            let a =
              i.extensions !== void 0
                ? i.extensions[Ft.KHR_TEXTURE_TRANSFORM]
                : void 0;
            if (a) {
              let l = r.associations.get(o);
              ((o = r.extensions[Ft.KHR_TEXTURE_TRANSFORM].extendTexture(o, a)),
                r.associations.set(o, l));
            }
          }
          return (n !== void 0 && (o.colorSpace = n), (e[t] = o), o);
        });
      }
      assignFinalMaterial(e) {
        let t = e.geometry,
          i = e.material,
          n = t.attributes.tangent === void 0,
          r = t.attributes.color !== void 0,
          o = t.attributes.normal === void 0;
        if (e.isPoints) {
          let a = 'PointsMaterial:' + i.uuid,
            l = this.cache.get(a);
          (l ||
            ((l = new Ja()),
            Rn.prototype.copy.call(l, i),
            l.color.copy(i.color),
            (l.map = i.map),
            (l.sizeAttenuation = !1),
            this.cache.add(a, l)),
            (i = l));
        } else if (e.isLine) {
          let a = 'LineBasicMaterial:' + i.uuid,
            l = this.cache.get(a);
          (l ||
            ((l = new ja()),
            Rn.prototype.copy.call(l, i),
            l.color.copy(i.color),
            (l.map = i.map),
            this.cache.add(a, l)),
            (i = l));
        }
        if (n || r || o) {
          let a = 'ClonedMaterial:' + i.uuid + ':';
          (n && (a += 'derivative-tangents:'),
            r && (a += 'vertex-colors:'),
            o && (a += 'flat-shading:'));
          let l = this.cache.get(a);
          (l ||
            ((l = i.clone()),
            r && (l.vertexColors = !0),
            o && (l.flatShading = !0),
            n &&
              (l.normalScale && (l.normalScale.y *= -1),
              l.clearcoatNormalScale && (l.clearcoatNormalScale.y *= -1)),
            this.cache.add(a, l),
            this.associations.set(l, this.associations.get(i))),
            (i = l));
        }
        e.material = i;
      }
      getMaterialType() {
        return Ko;
      }
      loadMaterial(e) {
        let t = this,
          i = this.json,
          n = this.extensions,
          r = i.materials[e],
          o,
          a = {},
          l = r.extensions || {},
          c = [];
        if (l[Ft.KHR_MATERIALS_UNLIT]) {
          let f = n[Ft.KHR_MATERIALS_UNLIT];
          ((o = f.getMaterialType()), c.push(f.extendParams(a, r, t)));
        } else {
          let f = r.pbrMetallicRoughness || {};
          if (
            ((a.color = new je(1, 1, 1)),
            (a.opacity = 1),
            Array.isArray(f.baseColorFactor))
          ) {
            let d = f.baseColorFactor;
            (a.color.setRGB(d[0], d[1], d[2], qi), (a.opacity = d[3]));
          }
          (f.baseColorTexture !== void 0 &&
            c.push(t.assignTexture(a, 'map', f.baseColorTexture, zt)),
            (a.metalness = f.metallicFactor !== void 0 ? f.metallicFactor : 1),
            (a.roughness =
              f.roughnessFactor !== void 0 ? f.roughnessFactor : 1),
            f.metallicRoughnessTexture !== void 0 &&
              (c.push(
                t.assignTexture(a, 'metalnessMap', f.metallicRoughnessTexture),
              ),
              c.push(
                t.assignTexture(a, 'roughnessMap', f.metallicRoughnessTexture),
              )),
            (o = this._invokeOne(function (d) {
              return d.getMaterialType && d.getMaterialType(e);
            })),
            c.push(
              Promise.all(
                this._invokeAll(function (d) {
                  return d.extendMaterialParams && d.extendMaterialParams(e, a);
                }),
              ),
            ));
        }
        r.doubleSided === !0 && (a.side = Gi);
        let u = r.alphaMode || zg.OPAQUE;
        if (
          (u === zg.BLEND
            ? ((a.transparent = !0), (a.depthWrite = !1))
            : ((a.transparent = !1),
              u === zg.MASK &&
                (a.alphaTest = r.alphaCutoff !== void 0 ? r.alphaCutoff : 0.5)),
          r.normalTexture !== void 0 &&
            o !== rn &&
            (c.push(t.assignTexture(a, 'normalMap', r.normalTexture)),
            (a.normalScale = new et(1, 1)),
            r.normalTexture.scale !== void 0))
        ) {
          let f = r.normalTexture.scale;
          a.normalScale.set(f, f);
        }
        if (
          (r.occlusionTexture !== void 0 &&
            o !== rn &&
            (c.push(t.assignTexture(a, 'aoMap', r.occlusionTexture)),
            r.occlusionTexture.strength !== void 0 &&
              (a.aoMapIntensity = r.occlusionTexture.strength)),
          r.emissiveFactor !== void 0 && o !== rn)
        ) {
          let f = r.emissiveFactor;
          a.emissive = new je().setRGB(f[0], f[1], f[2], qi);
        }
        return (
          r.emissiveTexture !== void 0 &&
            o !== rn &&
            c.push(t.assignTexture(a, 'emissiveMap', r.emissiveTexture, zt)),
          Promise.all(c).then(function () {
            let f = new o(a);
            return (
              r.name && (f.name = r.name),
              nr(f, r),
              t.associations.set(f, { materials: e }),
              r.extensions && ia(n, f, r),
              f
            );
          })
        );
      }
      createUniqueName(e) {
        let t = si.sanitizeNodeName(e || '');
        return t in this.nodeNamesUsed
          ? t + '_' + ++this.nodeNamesUsed[t]
          : ((this.nodeNamesUsed[t] = 0), t);
      }
      loadGeometries(e) {
        let t = this,
          i = this.extensions,
          n = this.primitiveCache;
        function r(a) {
          return i[Ft.KHR_DRACO_MESH_COMPRESSION]
            .decodePrimitive(a, t)
            .then(function (l) {
              return lb(l, a, t);
            });
        }
        let o = [];
        for (let a = 0, l = e.length; a < l; a++) {
          let c = e[a],
            u = hC(c),
            f = n[u];
          if (f) o.push(f.promise);
          else {
            let d;
            (c.extensions && c.extensions[Ft.KHR_DRACO_MESH_COMPRESSION]
              ? (d = r(c))
              : (d = lb(new Vi(), c, t)),
              (n[u] = { primitive: c, promise: d }),
              o.push(d));
          }
        }
        return Promise.all(o);
      }
      loadMesh(e) {
        let t = this,
          i = this.json,
          n = this.extensions,
          r = i.meshes[e],
          o = r.primitives,
          a = [];
        for (let l = 0, c = o.length; l < c; l++) {
          let u =
            o[l].material === void 0
              ? aC(this.cache)
              : this.getDependency('material', o[l].material);
          a.push(u);
        }
        return (
          a.push(t.loadGeometries(o)),
          Promise.all(a).then(function (l) {
            let c = l.slice(0, l.length - 1),
              u = l[l.length - 1],
              f = [];
            for (let p = 0, _ = u.length; p < _; p++) {
              let x = u[p],
                g = o[p],
                v,
                w = c[p];
              if (
                g.mode === os.TRIANGLES ||
                g.mode === os.TRIANGLE_STRIP ||
                g.mode === os.TRIANGLE_FAN ||
                g.mode === void 0
              )
                ((v = r.isSkinnedMesh === !0 ? new vc(x, w) : new ri(x, w)),
                  v.isSkinnedMesh === !0 && v.normalizeSkinWeights(),
                  g.mode === os.TRIANGLE_STRIP
                    ? (v.geometry = kg(v.geometry, Wc))
                    : g.mode === os.TRIANGLE_FAN &&
                      (v.geometry = kg(v.geometry, ol)));
              else if (g.mode === os.LINES) v = new bc(x, w);
              else if (g.mode === os.LINE_STRIP) v = new Zo(x, w);
              else if (g.mode === os.LINE_LOOP) v = new Sc(x, w);
              else if (g.mode === os.POINTS) v = new Ec(x, w);
              else
                throw new Error(
                  'THREE.GLTFLoader: Primitive mode unsupported: ' + g.mode,
                );
              (Object.keys(v.geometry.morphAttributes).length > 0 && cC(v, r),
                (v.name = t.createUniqueName(r.name || 'mesh_' + e)),
                nr(v, r),
                g.extensions && ia(n, v, g),
                t.assignFinalMaterial(v),
                f.push(v));
            }
            for (let p = 0, _ = f.length; p < _; p++)
              t.associations.set(f[p], { meshes: e, primitives: p });
            if (f.length === 1) return (r.extensions && ia(n, f[0], r), f[0]);
            let d = new Ri();
            (r.extensions && ia(n, d, r), t.associations.set(d, { meshes: e }));
            for (let p = 0, _ = f.length; p < _; p++) d.add(f[p]);
            return d;
          })
        );
      }
      loadCamera(e) {
        let t,
          i = this.json.cameras[e],
          n = i[i.type];
        if (n)
          return (
            i.type === 'perspective'
              ? (t = new di(
                  Vt.radToDeg(n.yfov),
                  n.aspectRatio || 1,
                  n.znear || 1,
                  n.zfar || 2e6,
                ))
              : i.type === 'orthographic' &&
                (t = new no(-n.xmag, n.xmag, n.ymag, -n.ymag, n.znear, n.zfar)),
            i.name && (t.name = this.createUniqueName(i.name)),
            nr(t, i),
            Promise.resolve(t)
          );
      }
      loadSkin(e) {
        let t = this.json.skins[e],
          i = [];
        for (let n = 0, r = t.joints.length; n < r; n++)
          i.push(this._loadNodeShallow(t.joints[n]));
        return (
          t.inverseBindMatrices !== void 0
            ? i.push(this.getDependency('accessor', t.inverseBindMatrices))
            : i.push(null),
          Promise.all(i).then(function (n) {
            let r = n.pop(),
              o = n,
              a = [],
              l = [];
            for (let c = 0, u = o.length; c < u; c++) {
              let f = o[c];
              if (f) {
                a.push(f);
                let d = new yt();
                (r !== null && d.fromArray(r.array, c * 16), l.push(d));
              }
            }
            return new xc(a, l);
          })
        );
      }
      loadAnimation(e) {
        let t = this.json,
          i = this,
          n = t.animations[e],
          r = n.name ? n.name : 'animation_' + e,
          o = [],
          a = [],
          l = [],
          c = [],
          u = [];
        for (let f = 0, d = n.channels.length; f < d; f++) {
          let p = n.channels[f],
            _ = n.samplers[p.sampler],
            x = p.target,
            g = x.node,
            v = n.parameters !== void 0 ? n.parameters[_.input] : _.input,
            w = n.parameters !== void 0 ? n.parameters[_.output] : _.output;
          x.node !== void 0 &&
            (o.push(this.getDependency('node', g)),
            a.push(this.getDependency('accessor', v)),
            l.push(this.getDependency('accessor', w)),
            c.push(_),
            u.push(x));
        }
        return Promise.all([
          Promise.all(o),
          Promise.all(a),
          Promise.all(l),
          Promise.all(c),
          Promise.all(u),
        ]).then(function (f) {
          let d = f[0],
            p = f[1],
            _ = f[2],
            x = f[3],
            g = f[4],
            v = [];
          for (let L = 0, R = d.length; L < R; L++) {
            let U = d[L],
              O = p[L],
              N = _[L],
              M = x[L],
              I = g[L];
            if (U === void 0) continue;
            U.updateMatrix && U.updateMatrix();
            let z = i._createAnimationTracks(U, O, N, M, I);
            if (z) for (let W = 0; W < z.length; W++) v.push(z[W]);
          }
          let w = new Cc(r, void 0, v);
          return (nr(w, n), w);
        });
      }
      createNodeMesh(e) {
        let t = this.json,
          i = this,
          n = t.nodes[e];
        return n.mesh === void 0
          ? null
          : i.getDependency('mesh', n.mesh).then(function (r) {
              let o = i._getNodeRef(i.meshCache, n.mesh, r);
              return (
                n.weights !== void 0 &&
                  o.traverse(function (a) {
                    if (a.isMesh)
                      for (let l = 0, c = n.weights.length; l < c; l++)
                        a.morphTargetInfluences[l] = n.weights[l];
                  }),
                o
              );
            });
      }
      loadNode(e) {
        let t = this.json,
          i = this,
          n = t.nodes[e],
          r = i._loadNodeShallow(e),
          o = [],
          a = n.children || [];
        for (let c = 0, u = a.length; c < u; c++)
          o.push(i.getDependency('node', a[c]));
        let l =
          n.skin === void 0
            ? Promise.resolve(null)
            : i.getDependency('skin', n.skin);
        return Promise.all([r, Promise.all(o), l]).then(function (c) {
          let u = c[0],
            f = c[1],
            d = c[2];
          d !== null &&
            u.traverse(function (p) {
              p.isSkinnedMesh && p.bind(d, dC);
            });
          for (let p = 0, _ = f.length; p < _; p++) u.add(f[p]);
          if (u.userData.pivot !== void 0 && f.length > 0) {
            let p = u.userData.pivot,
              _ = f[0];
            ((u.pivot = new te().fromArray(p)),
              (u.position.x -= p[0]),
              (u.position.y -= p[1]),
              (u.position.z -= p[2]),
              _.position.set(0, 0, 0),
              delete u.userData.pivot);
          }
          return u;
        });
      }
      _loadNodeShallow(e) {
        let t = this.json,
          i = this.extensions,
          n = this;
        if (this.nodeCache[e] !== void 0) return this.nodeCache[e];
        let r = t.nodes[e],
          o = r.name ? n.createUniqueName(r.name) : '',
          a = [],
          l = n._invokeOne(function (c) {
            return c.createNodeMesh && c.createNodeMesh(e);
          });
        return (
          l && a.push(l),
          r.camera !== void 0 &&
            a.push(
              n.getDependency('camera', r.camera).then(function (c) {
                return n._getNodeRef(n.cameraCache, r.camera, c);
              }),
            ),
          n
            ._invokeAll(function (c) {
              return c.createNodeAttachment && c.createNodeAttachment(e);
            })
            .forEach(function (c) {
              a.push(c);
            }),
          (this.nodeCache[e] = Promise.all(a).then(function (c) {
            let u;
            if (
              (r.isBone === !0
                ? (u = new Za())
                : c.length > 1
                  ? (u = new Ri())
                  : c.length === 1
                    ? (u = c[0])
                    : (u = new pi()),
              u !== c[0])
            )
              for (let f = 0, d = c.length; f < d; f++) u.add(c[f]);
            if (
              (r.name && ((u.userData.name = r.name), (u.name = o)),
              nr(u, r),
              r.extensions && ia(i, u, r),
              r.matrix !== void 0)
            ) {
              let f = new yt();
              (f.fromArray(r.matrix), u.applyMatrix4(f));
            } else
              (r.translation !== void 0 && u.position.fromArray(r.translation),
                r.rotation !== void 0 && u.quaternion.fromArray(r.rotation),
                r.scale !== void 0 && u.scale.fromArray(r.scale));
            if (!n.associations.has(u)) n.associations.set(u, {});
            else if (r.mesh !== void 0 && n.meshCache.refs[r.mesh] > 1) {
              let f = n.associations.get(u);
              n.associations.set(u, pt({}, f));
            }
            return ((n.associations.get(u).nodes = e), u);
          })),
          this.nodeCache[e]
        );
      }
      loadScene(e) {
        let t = this.extensions,
          i = this.json.scenes[e],
          n = this,
          r = new Ri();
        (i.name && (r.name = n.createUniqueName(i.name)),
          nr(r, i),
          i.extensions && ia(t, r, i));
        let o = i.nodes || [],
          a = [];
        for (let l = 0, c = o.length; l < c; l++)
          a.push(n.getDependency('node', o[l]));
        return Promise.all(a).then(function (l) {
          for (let u = 0, f = l.length; u < f; u++) {
            let d = l[u];
            d.parent !== null ? r.add(nb(d)) : r.add(d);
          }
          let c = (u) => {
            let f = new Map();
            for (let [d, p] of n.associations)
              (d instanceof Rn || d instanceof Li) && f.set(d, p);
            return (
              u.traverse((d) => {
                let p = n.associations.get(d);
                p != null && f.set(d, p);
              }),
              f
            );
          };
          return ((n.associations = c(r)), r);
        });
      }
      _createAnimationTracks(e, t, i, n, r) {
        let o = [],
          a = e.name ? e.name : e.uuid,
          l = [];
        function c(p) {
          p.morphTargetInfluences && l.push(p.name ? p.name : p.uuid);
        }
        ho[r.path] === ho.weights
          ? (c(e), e.isGroup && e.children.forEach(c))
          : l.push(a);
        let u;
        switch (ho[r.path]) {
          case ho.weights:
            u = Ks;
            break;
          case ho.rotation:
            u = $s;
            break;
          case ho.translation:
          case ho.scale:
            u = js;
            break;
          default:
            switch (i.itemSize) {
              case 1:
                u = Ks;
                break;
              case 2:
              case 3:
              default:
                u = js;
                break;
            }
            break;
        }
        let f = n.interpolation !== void 0 ? oC[n.interpolation] : Yo,
          d = this._getArrayFromAccessor(i);
        for (let p = 0, _ = l.length; p < _; p++) {
          let x = new u(l[p] + '.' + ho[r.path], t.array, d, f);
          (n.interpolation === 'CUBICSPLINE' &&
            this._createCubicSplineTrackInterpolant(x),
            o.push(x));
        }
        return o;
      }
      _getArrayFromAccessor(e) {
        let t = e.array;
        if (e.normalized) {
          let i = d_(t.constructor),
            n = new Float32Array(t.length);
          for (let r = 0, o = t.length; r < o; r++) n[r] = t[r] * i;
          t = n;
        }
        return t;
      }
      _createCubicSplineTrackInterpolant(e) {
        ((e.createInterpolant = function (i) {
          let n = this instanceof $s ? h_ : Zd;
          return new n(this.times, this.values, this.getValueSize() / 3, i);
        }),
          (e.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0));
      }
    };
  function fC(s, e, t) {
    let i = e.attributes,
      n = new yn();
    if (i.POSITION !== void 0) {
      let a = t.json.accessors[i.POSITION],
        l = a.min,
        c = a.max;
      if (l !== void 0 && c !== void 0) {
        if (
          (n.set(new te(l[0], l[1], l[2]), new te(c[0], c[1], c[2])),
          a.normalized)
        ) {
          let u = d_(dl[a.componentType]);
          (n.min.multiplyScalar(u), n.max.multiplyScalar(u));
        }
      } else return;
    } else return;
    let r = e.targets;
    if (r !== void 0) {
      let a = new te(),
        l = new te();
      for (let c = 0, u = r.length; c < u; c++) {
        let f = r[c];
        if (f.POSITION !== void 0) {
          let d = t.json.accessors[f.POSITION],
            p = d.min,
            _ = d.max;
          if (p !== void 0 && _ !== void 0) {
            if (
              (l.setX(Math.max(Math.abs(p[0]), Math.abs(_[0]))),
              l.setY(Math.max(Math.abs(p[1]), Math.abs(_[1]))),
              l.setZ(Math.max(Math.abs(p[2]), Math.abs(_[2]))),
              d.normalized)
            ) {
              let x = d_(dl[d.componentType]);
              l.multiplyScalar(x);
            }
            a.max(l);
          }
        }
      }
      n.expandByVector(a);
    }
    s.boundingBox = n;
    let o = new An();
    (n.getCenter(o.center),
      (o.radius = n.min.distanceTo(n.max) / 2),
      (s.boundingSphere = o));
  }
  function lb(s, e, t) {
    let i = e.attributes,
      n = [];
    function r(o, a) {
      return t.getDependency('accessor', o).then(function (l) {
        s.setAttribute(a, l);
      });
    }
    for (let o in i) {
      let a = u_[o] || o.toLowerCase();
      a in s.attributes || n.push(r(i[o], a));
    }
    if (e.indices !== void 0 && !s.index) {
      let o = t.getDependency('accessor', e.indices).then(function (a) {
        s.setIndex(a);
      });
      n.push(o);
    }
    return (
      Ct.workingColorSpace !== qi && 'COLOR_0' in i,
      nr(s, e),
      fC(s, e, t),
      Promise.all(n).then(function () {
        return e.targets !== void 0 ? lC(s, e.targets, t) : s;
      })
    );
  }
  var p_ = new WeakMap(),
    Kd = class extends rs {
      constructor(e) {
        (super(e),
          (this.decoderPath = ''),
          (this.decoderConfig = {}),
          (this.decoderBinary = null),
          (this.decoderPending = null),
          (this.workerLimit = 4),
          (this.workerPool = []),
          (this.workerNextTaskID = 1),
          (this.workerSourceURL = ''),
          (this.defaultAttributeIDs = {
            position: 'POSITION',
            normal: 'NORMAL',
            color: 'COLOR',
            uv: 'TEX_COORD',
          }),
          (this.defaultAttributeTypes = {
            position: 'Float32Array',
            normal: 'Float32Array',
            color: 'Float32Array',
            uv: 'Float32Array',
          }));
      }
      setDecoderPath(e) {
        return ((this.decoderPath = e), this);
      }
      setDecoderConfig(e) {
        return ((this.decoderConfig = e), this);
      }
      setWorkerLimit(e) {
        return ((this.workerLimit = e), this);
      }
      load(e, t, i, n) {
        let r = new Rr(this.manager);
        (r.setPath(this.path),
          r.setResponseType('arraybuffer'),
          r.setRequestHeader(this.requestHeader),
          r.setWithCredentials(this.withCredentials),
          r.load(
            e,
            (o) => {
              this.parse(o, t, n);
            },
            i,
            n,
          ));
      }
      parse(e, t, i = () => {}) {
        this.decodeDracoFile(e, t, null, null, zt, i).catch(i);
      }
      decodeDracoFile(e, t, i, n, r = qi, o = () => {}) {
        let a = {
          attributeIDs: i || this.defaultAttributeIDs,
          attributeTypes: n || this.defaultAttributeTypes,
          useUniqueIDs: !!i,
          vertexColorSpace: r,
        };
        return this.decodeGeometry(e, a).then(t).catch(o);
      }
      decodeGeometry(e, t) {
        let i = JSON.stringify(t);
        if (p_.has(e)) {
          let l = p_.get(e);
          if (l.key === i) return l.promise;
          if (e.byteLength === 0)
            throw new Error(
              'THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.',
            );
        }
        let n,
          r = this.workerNextTaskID++,
          o = e.byteLength,
          a = this._getWorker(r, o)
            .then(
              (l) => (
                (n = l),
                new Promise((c, u) => {
                  ((n._callbacks[r] = { resolve: c, reject: u }),
                    n.postMessage(
                      { type: 'decode', id: r, taskConfig: t, buffer: e },
                      [e],
                    ));
                })
              ),
            )
            .then((l) => this._createGeometry(l.geometry));
        return (
          a
            .catch(() => !0)
            .then(() => {
              n && r && this._releaseTask(n, r);
            }),
          p_.set(e, { key: i, promise: a }),
          a
        );
      }
      _createGeometry(e) {
        let t = new Vi();
        e.index && t.setIndex(new fi(e.index.array, 1));
        for (let i = 0; i < e.attributes.length; i++) {
          let {
              name: n,
              array: r,
              itemSize: o,
              stride: a,
              vertexColorSpace: l,
            } = e.attributes[i],
            c;
          if (o === a) c = new fi(r, o);
          else {
            let u = new eo(r, a);
            c = new to(u, o, 0);
          }
          (n === 'color' &&
            (this._assignVertexColorSpace(c, l),
            (c.normalized = !(r instanceof Float32Array))),
            t.setAttribute(n, c));
        }
        return t;
      }
      _assignVertexColorSpace(e, t) {
        if (t !== zt) return;
        let i = new je();
        for (let n = 0, r = e.count; n < r; n++)
          (i.fromBufferAttribute(e, n),
            Ct.colorSpaceToWorking(i, zt),
            e.setXYZ(n, i.r, i.g, i.b));
      }
      _loadLibrary(e, t) {
        let i = new Rr(this.manager);
        return (
          i.setPath(this.decoderPath),
          i.setResponseType(t),
          i.setWithCredentials(this.withCredentials),
          new Promise((n, r) => {
            i.load(e, n, void 0, r);
          })
        );
      }
      preload() {
        return (this._initDecoder(), this);
      }
      _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        let e =
            typeof WebAssembly != 'object' || this.decoderConfig.type === 'js',
          t = [];
        return (
          e
            ? t.push(this._loadLibrary('hdjf9-3d-draco-draco_decoder.js', 'text'))
            : (t.push(this._loadLibrary('hdjf9-3d-draco-draco_wasm_wrapper.js', 'text')),
              t.push(this._loadLibrary('hdjf9-3d-draco-draco_decoder.wasm', 'arraybuffer'))),
          (this.decoderPending = Promise.all(t).then((i) => {
            let n = i[0];
            e || (this.decoderConfig.wasmBinary = i[1]);
            let r = pC.toString(),
              o = [
                '/* draco decoder */',
                n,
                '',
                '/* worker */',
                r.substring(r.indexOf('{') + 1, r.lastIndexOf('}')),
              ].join(`
`);
            this.workerSourceURL = URL.createObjectURL(new Blob([o]));
          })),
          this.decoderPending
        );
      }
      _getWorker(e, t) {
        return this._initDecoder().then(() => {
          if (this.workerPool.length < this.workerLimit) {
            let n = new Worker(this.workerSourceURL);
            ((n._callbacks = {}),
              (n._taskCosts = {}),
              (n._taskLoad = 0),
              n.postMessage({
                type: 'init',
                decoderConfig: this.decoderConfig,
              }),
              (n.onmessage = function (r) {
                let o = r.data;
                switch (o.type) {
                  case 'decode':
                    n._callbacks[o.id].resolve(o);
                    break;
                  case 'error':
                    n._callbacks[o.id].reject(o);
                    break;
                  default:
                }
              }),
              this.workerPool.push(n));
          } else
            this.workerPool.sort(function (n, r) {
              return n._taskLoad > r._taskLoad ? -1 : 1;
            });
          let i = this.workerPool[this.workerPool.length - 1];
          return ((i._taskCosts[e] = t), (i._taskLoad += t), i);
        });
      }
      _releaseTask(e, t) {
        ((e._taskLoad -= e._taskCosts[t]),
          delete e._callbacks[t],
          delete e._taskCosts[t]);
      }
      debug() {}
      dispose() {
        for (let e = 0; e < this.workerPool.length; ++e)
          this.workerPool[e].terminate();
        return (
          (this.workerPool.length = 0),
          this.workerSourceURL !== '' &&
            URL.revokeObjectURL(this.workerSourceURL),
          this
        );
      }
    };
  function pC() {
    let s, e;
    onmessage = function (o) {
      let a = o.data;
      switch (a.type) {
        case 'init':
          ((s = a.decoderConfig),
            (e = new Promise(function (u) {
              ((s.onModuleLoaded = function (f) {
                u({ draco: f });
              }),
                DracoDecoderModule(s));
            })));
          break;
        case 'decode':
          let l = a.buffer,
            c = a.taskConfig;
          e.then((u) => {
            let f = u.draco,
              d = new f.Decoder();
            try {
              let p = t(f, d, new Int8Array(l), c),
                _ = p.attributes.map((x) => x.array.buffer);
              (p.index && _.push(p.index.array.buffer),
                self.postMessage({ type: 'decode', id: a.id, geometry: p }, _));
            } catch (p) {
              self.postMessage({ type: 'error', id: a.id, error: p.message });
            } finally {
              f.destroy(d);
            }
          });
          break;
      }
    };
    function t(o, a, l, c) {
      let u = c.attributeIDs,
        f = c.attributeTypes,
        d,
        p,
        _ = a.GetEncodedGeometryType(l);
      if (_ === o.TRIANGULAR_MESH)
        ((d = new o.Mesh()), (p = a.DecodeArrayToMesh(l, l.byteLength, d)));
      else if (_ === o.POINT_CLOUD)
        ((d = new o.PointCloud()),
          (p = a.DecodeArrayToPointCloud(l, l.byteLength, d)));
      else throw new Error('THREE.DRACOLoader: Unexpected geometry type.');
      if (!p.ok() || d.ptr === 0)
        throw new Error('THREE.DRACOLoader: Decoding failed: ' + p.error_msg());
      let x = { index: null, attributes: [] };
      for (let g in u) {
        let v = self[f[g]],
          w,
          L;
        if (c.useUniqueIDs) ((L = u[g]), (w = a.GetAttributeByUniqueId(d, L)));
        else {
          if (((L = a.GetAttributeId(d, o[u[g]])), L === -1)) continue;
          w = a.GetAttribute(d, L);
        }
        let R = n(o, a, d, g, v, w);
        (g === 'color' && (R.vertexColorSpace = c.vertexColorSpace),
          x.attributes.push(R));
      }
      return (
        _ === o.TRIANGULAR_MESH && (x.index = i(o, a, d)),
        o.destroy(d),
        x
      );
    }
    function i(o, a, l) {
      let u = l.num_faces() * 3,
        f = u * 4,
        d = o._malloc(f);
      a.GetTrianglesUInt32Array(l, f, d);
      let p = new Uint32Array(o.HEAPF32.buffer, d, u).slice();
      return (o._free(d), { array: p, itemSize: 1 });
    }
    function n(o, a, l, c, u, f) {
      let d = l.num_points(),
        p = f.num_components(),
        _ = r(o, u),
        x = p * u.BYTES_PER_ELEMENT,
        g = Math.ceil(x / 4) * 4,
        v = g / u.BYTES_PER_ELEMENT,
        w = d * x,
        L = d * g,
        R = o._malloc(w);
      a.GetAttributeDataArrayForAllPoints(l, f, _, w, R);
      let U = new u(o.HEAPF32.buffer, R, w / u.BYTES_PER_ELEMENT),
        O;
      if (x === g) O = U.slice();
      else {
        O = new u(L / u.BYTES_PER_ELEMENT);
        let N = 0;
        for (let M = 0, I = U.length; M < I; M++) {
          for (let z = 0; z < p; z++) O[N + z] = U[M * p + z];
          N += v;
        }
      }
      return (
        o._free(R),
        { name: c, count: d, itemSize: p, array: O, stride: v }
      );
    }
    function r(o, a) {
      switch (a) {
        case Float32Array:
          return o.DT_FLOAT32;
        case Int8Array:
          return o.DT_INT8;
        case Int16Array:
          return o.DT_INT16;
        case Int32Array:
          return o.DT_INT32;
        case Uint8Array:
          return o.DT_UINT8;
        case Uint16Array:
          return o.DT_UINT16;
        case Uint32Array:
          return o.DT_UINT32;
      }
    }
  }
  var mC = 0.539,
    gC = 1.5,
    _C = 1.25,
    hb = 2560,
    vC = 844,
    Ps = 900,
    g_ = 1,
    as = () => {
      let s = window.innerWidth;
      if (s >= 1440) {
        let e = Math.min(s / 1440, _C);
        return s >= hb ? e * (s / hb) : e;
      }
      return s >= 960
        ? 1
        : s >= 390
          ? Math.min(s / 390, gC)
          : Math.max(mC, s / 390);
    },
    jd = (s) => (2 * s.position.z * Math.tan(Vt.degToRad(s.fov) / 2)) / s.zoom,
    __ = () => {
      let s = document.createElement('div');
      ((s.style.cssText =
        'position:fixed;top:0;left:0;width:0;height:100lvh;visibility:hidden;pointer-events:none'),
        document.body.appendChild(s));
      let e = s.getBoundingClientRect().height;
      return (s.remove(), e > 0 ? e : window.innerHeight);
    },
    Jd = () => {
      if (!Xt()) return 1;
      let s = window.innerHeight;
      return s > 0 ? vC / s : 1;
    },
    xC = 1.2,
    ub = () => {
      if (Xt()) return 1;
      let s = window.innerHeight,
        e = Ps * xC;
      return s > e ? e / s : 1;
    },
    Qd = () => as() * Jd() * ub(),
    Ls = (s, e, t) => (2 * e * t * Math.tan(Vt.degToRad(s) / 2)) / Qd(),
    pl = (s, e, t) => (s.camZ1Px * (t / s.designVh) * Qd()) / e,
    yC = (s, e) => {
      ((s.uniforms.uMatteT = e.uMatteT),
        (s.uniforms.uMatteAlbedo = e.uMatteAlbedo),
        (s.fragmentShader = `uniform float uMatteT;
uniform float uMatteAlbedo;
${s.fragmentShader}`.replace(
          '#include <map_fragment>',
          `#include <map_fragment>
	diffuseColor.rgb = mix(diffuseColor.rgb, vec3(uMatteAlbedo), uMatteT);`,
        )));
    },
    bC = (s, e, t, i, n) => {
      let r = s;
      if (!r.isMeshStandardMaterial) {
        let c = s.clone();
        return ((c.side = Gi), c);
      }
      let o = r.onBeforeCompile,
        a = r.customProgramCacheKey.bind(r),
        l = r.clone();
      return (
        (l.transparent = !0),
        (l.depthWrite = !1),
        (l.side = Gi),
        (l.opacity = i),
        (l.roughness = Math.min(1, l.roughness + n)),
        (l.onBeforeCompile = (c, u) => {
          (o.call(l, c, u),
            (c.uniforms.uReflFloorY = { value: e }),
            (c.uniforms.uReflFade = { value: t }),
            (c.vertexShader = `varying vec3 vReflWorldPos;
${c.vertexShader}`.replace(
              '#include <begin_vertex>',
              `#include <begin_vertex>
	vReflWorldPos = (modelMatrix * vec4(transformed, 1.0)).xyz;`,
            )),
            (c.fragmentShader = `uniform float uReflFloorY;
uniform float uReflFade;
varying vec3 vReflWorldPos;
${c.fragmentShader}`.replace(
              '#include <dithering_fragment>',
              `#include <dithering_fragment>
	float reflFade = clamp((vReflWorldPos.y - (uReflFloorY - uReflFade)) / uReflFade, 0.0, 1.0);
	gl_FragColor.a *= reflFade;`,
            )));
        }),
        (l.customProgramCacheKey = () => `product-reflection-fade:${a()}`),
        l
      );
    },
    SC = (s) => {
      let e = 0;
      return {
        get t() {
          return e;
        },
        set t(t) {
          ((e = t), s(t));
        },
      };
    },
    $d = class {
      constructor(e) {
        y(this, 'config');
        y(this, 'scene');
        y(this, 'camera');
        y(this, 'reflectionCamera');
        y(this, 'modelGroup', new Ri());
        y(this, 'spinGroup', new Ri());
        y(this, 'cursorGroup', new Ri());
        y(this, 'ambient');
        y(this, 'directional');
        y(this, 'videoLight');
        y(this, 'accentLight1');
        y(this, 'accentLight2');
        y(this, 'accentLight3');
        y(
          this,
          'lookChannel',
          SC((e) => this.setMatteLook(e)),
        );
        y(this, 'baseCameraZ', 80);
        y(this, 'modelHalfHeight', 0.5);
        y(this, 'modelHalfWidth', 0.5);
        y(this, 'modelHalfDepth', 0.5);
        y(this, 'ledGlowStrength', 0);
        y(this, 'envTexture', null);
        y(this, 'envVideo', null);
        y(this, 'envFade', { value: 1 });
        y(this, 'envFadeTarget', 1);
        y(this, 'envFadeTween', null);
        y(this, 'envHold', !1);
        y(this, 'envCanvas', null);
        y(this, 'envCtx', null);
        y(this, 'envRT', null);
        y(this, 'avgCanvas', null);
        y(this, 'avgCtx', null);
        y(this, 'modelRoot', null);
        y(this, 'modelMaxDim', 1);
        y(this, 'ledMaterials', null);
        y(this, 'ledOriginals', []);
        y(this, 'ledFixedWhite', []);
        y(this, 'ledFixedWhiteColor', new je(1, 1, 1));
        y(this, 'ledTween', null);
        y(this, 'ledScratchColor', new je());
        y(this, 'ledOverrideBaseColor', new je(0));
        y(this, 'matteMaterials', []);
        y(this, 'matteCacheRoot', null);
        y(this, 'matteLive');
        y(this, 'matteUniforms', {
          uMatteT: { value: 0 },
          uMatteAlbedo: { value: 0 },
        });
        y(this, 'reflectionGroup', null);
        y(this, 'reflectionContent', null);
        y(this, 'floorMaskScratch', new te());
        y(this, 'prevReflProj', new yt());
        y(this, 'prevReflQuat', new zi());
        y(this, 'prevReflDist', NaN);
        y(this, 'applyConfig', (e) => {
          ((this.config = e),
            this.applyLightSettings(),
            (this.camera.fov = e.camera.fov),
            this.camera.updateProjectionMatrix(),
            this.recomputeBaseCameraZ(),
            (this.camera.position.z = this.baseCameraZ),
            this.applyEnvMapIntensity(),
            this.applyMatteParams(e.matteLook));
        });
        y(this, 'setMatteLook', (e) => {
          let t = Vt.clamp(e, 0, 1);
          this.matteUniforms.uMatteT.value = t;
          let {
              metalnessScale: i,
              roughnessAdd: n,
              surfaceFullAt: r,
            } = this.matteLive,
            { lerp: o } = Vt,
            a = r > 0 ? Math.min(1, t / r) : 1;
          this.matteMaterials.forEach((l) => {
            let { mat: c, metalness: u, roughness: f } = l;
            ((c.metalness = o(u, u * i, a)),
              (c.roughness = o(f, Math.min(1, f + n), a)));
          });
        });
        y(this, 'setMatteLookParams', (e) => {
          this.applyMatteParams(pt(pt({}, this.matteLive), e));
        });
        y(
          this,
          'loadModel',
          () =>
            new Promise((e, t) => {
              let i = new Yd(),
                n = new Kd();
              (n.setDecoderPath(this.config.dracoPath),
                n.preload(),
                i.setDRACOLoader(n),
                i.load(
                  this.config.glbUrl,
                  (r) => {
                    let o = r.scene,
                      a = new yn().setFromObject(o),
                      l = a.getSize(new te()),
                      c = a.getCenter(new te());
                    (o.position.sub(c),
                      this.cursorGroup.add(o),
                      (this.modelRoot = o),
                      this.prepareMatteMaterials(),
                      this.setMatteLook(this.matteLook),
                      this.applyEnvMapIntensity(),
                      (this.modelMaxDim = Math.max(l.x, l.y, l.z)),
                      (this.modelHalfHeight = l.y / 2),
                      (this.modelHalfWidth = l.x / 2),
                      (this.modelHalfDepth = l.z / 2),
                      this.recomputeBaseCameraZ(),
                      (this.camera.position.z = this.baseCameraZ),
                      n.dispose(),
                      e());
                  },
                  void 0,
                  (r) => {
                    (n.dispose(), t(r));
                  },
                ));
            }),
        );
        y(this, 'setupEnvironment', (e) => {
          let t = document.createElement('canvas');
          ((t.width = 256), (t.height = 128));
          let i = t.getContext('2d');
          if (!i) return;
          let n = new Mc(t);
          ((n.colorSpace = zt), (n.mapping = il));
          let r = document.createElement('canvas');
          ((r.width = 1), (r.height = 1));
          let o = r.getContext('2d', { willReadFrequently: !0 });
          ((this.envVideo = e),
            (this.envCanvas = t),
            (this.envCtx = i),
            (this.envTexture = n),
            (this.avgCanvas = r),
            (this.avgCtx = o));
        });
        y(this, 'updateEnvVisibility', () => {
          var t;
          if (this.envHold) return;
          let e = this.envVideo && !this.envVideo.paused ? 1 : 0;
          e !== this.envFadeTarget &&
            ((this.envFadeTarget = e),
            (t = this.envFadeTween) == null || t.kill(),
            (this.envFadeTween = Et.to(this.envFade, {
              value: e,
              duration: this.config.envMap.visibilityFadeDuration,
              ease: 'none',
              onUpdate: () => {
                ((this.scene.environmentIntensity = this.envFade.value),
                  (this.videoLight.intensity =
                    this.config.envMap.lightIntensity * this.envFade.value));
              },
            })));
        });
        y(this, 'setEnvHold', (e) => {
          var t;
          ((this.envHold = e),
            (t = this.envFadeTween) == null || t.kill(),
            (this.envFadeTween = null),
            e &&
              ((this.scene.environmentIntensity = 0),
              (this.videoLight.intensity = 0)),
            (this.envFade.value = 0),
            (this.envFadeTarget = 0));
        });
        y(this, 'updateEnvironment', (e) => {
          if (
            !(
              !this.envTexture ||
              !this.envVideo ||
              !this.envCanvas ||
              !this.envCtx
            ) &&
            !(this.envVideo.readyState < 2) &&
            !(this.envVideo.paused && this.envRT)
          ) {
            if (
              (this.envCtx.drawImage(
                this.envVideo,
                0,
                0,
                this.envCanvas.width,
                this.envCanvas.height,
              ),
              (this.envTexture.needsUpdate = !0),
              this.avgCanvas && this.avgCtx)
            ) {
              this.avgCtx.drawImage(this.envVideo, 0, 0, 1, 1);
              let [t, i, n] = this.avgCtx.getImageData(0, 0, 1, 1).data,
                r = Math.max(t, i, n, 1);
              this.videoLight.color.setRGB(t / r, i / r, n / r, zt);
            }
            ((this.envRT = e.fromEquirectangular(this.envTexture, this.envRT)),
              (this.scene.environment = this.envRT.texture));
          }
        });
        y(this, 'onResize', (e, t) => {
          e === 0 ||
            t === 0 ||
            ((this.camera.aspect = e / t),
            this.camera.updateProjectionMatrix());
        });
        y(this, 'applyBaseZoom', () => {
          ((this.camera.zoom = as() * Jd() * ub()),
            this.camera.updateProjectionMatrix());
        });
        y(this, 'setReflectionVisible', (e) => {
          (e && this.buildReflection(),
            this.reflectionGroup && (this.reflectionGroup.visible = e));
        });
        y(this, 'setModelVisible', (e) => {
          this.modelGroup.visible = e;
        });
        y(this, 'syncReflectionCamera', () => {
          let e = this.camera,
            t = this.reflectionCamera;
          ((t.fov = e.fov),
            (t.aspect = e.aspect),
            (t.near = e.near),
            (t.far = e.far),
            (t.zoom = e.zoom),
            t.position.set(0, 0, e.position.length() || this.baseCameraZ),
            t.up.set(0, 1, 0),
            t.lookAt(0, 0, 0));
          let { view: i } = e;
          (i != null && i.enabled
            ? t.setViewOffset(
                i.fullWidth,
                i.fullHeight,
                i.offsetX,
                i.offsetY,
                i.width,
                i.height,
              )
            : t.clearViewOffset(),
            t.updateProjectionMatrix(),
            t.updateMatrixWorld(),
            this.reflectionContent &&
              (this.reflectionContent.quaternion.copy(e.quaternion).invert(),
              this.reflectionContent.updateMatrixWorld()));
        });
        y(this, 'consumeReflectionDirty', () => {
          let e = this.reflectionCamera,
            t = this.camera.quaternion,
            i = e.position.z,
            n =
              Number.isNaN(this.prevReflDist) ||
              this.prevReflDist !== i ||
              !this.prevReflProj.equals(e.projectionMatrix) ||
              !this.prevReflQuat.equals(t);
          return (
            n &&
              (this.prevReflProj.copy(e.projectionMatrix),
              this.prevReflQuat.copy(t),
              (this.prevReflDist = i)),
            n
          );
        });
        y(this, 'invalidateReflection', () => {
          this.prevReflDist = NaN;
        });
        y(this, 'computeFloorMask', () => {
          let { reflection: e } = this.config.viewer,
            t = -this.modelHalfHeight + e.floorOffset,
            i = this.modelHalfHeight * 2 * e.fadeScale,
            n = this.reflectionCamera,
            r = this.floorMaskScratch;
          r.set(0, t, 0).project(n);
          let o = r.x * 0.5 + 0.5,
            a = r.y * 0.5 + 0.5;
          r.set(0, t - i, 0).project(n);
          let l = r.y * 0.5 + 0.5;
          r.set(this.modelHalfWidth, t, 0).project(n);
          let c = r.x * 0.5 + 0.5;
          return {
            cx: o,
            cy: (a + l) * 0.5,
            rx: Math.max(0.02, Math.abs(c - o) * e.footprintScale),
            ry: Math.max(0.02, Math.abs(a - l) * 0.5 * e.footprintScale),
          };
        });
        y(this, 'setLedColor', (e, t = 0, i = !1) => {
          var d;
          if (
            !this.modelRoot ||
            (this.ledMaterials || this.cacheLedMaterials(), !this.ledMaterials)
          )
            return;
          let n = this.ledMaterials,
            r = (p, _) =>
              i && this.ledFixedWhite[_] ? this.ledFixedWhiteColor : p;
          ((d = this.ledTween) == null || d.kill(), (this.ledTween = null));
          let o = e === null ? 0 : 1;
          if (t <= 0) {
            let p = e === null ? null : this.ledScratchColor.setStyle(e, zt);
            (n.forEach((_, x) => {
              let g = _;
              if (p === null) {
                let v = this.ledOriginals[x];
                (g.color.copy(v.color),
                  g.emissive.copy(v.emissive),
                  (g.emissiveIntensity = v.emissiveIntensity));
              } else
                (g.color.copy(this.ledOverrideBaseColor),
                  g.emissive.copy(r(p, x)),
                  (g.emissiveIntensity =
                    this.config.ledMaterial.emissiveIntensity));
            }),
              (this.ledGlowStrength = o));
            return;
          }
          let a = e === null ? null : new je().setStyle(e, zt),
            l = this.ledOriginals.map((p, _) =>
              a === null
                ? {
                    color: p.color,
                    emissive: p.emissive,
                    intensity: p.emissiveIntensity,
                  }
                : {
                    color: this.ledOverrideBaseColor,
                    emissive: r(a, _),
                    intensity: this.config.ledMaterial.emissiveIntensity,
                  },
            ),
            c = n.map((p) => ({
              color: p.color.clone(),
              emissive: p.emissive.clone(),
              intensity: p.emissiveIntensity,
            })),
            u = this.ledGlowStrength,
            f = { t: 0 };
          this.ledTween = Et.to(f, {
            t: 1,
            duration: t,
            ease: 'power2.out',
            onUpdate: () => {
              (n.forEach((p, _) => {
                let x = p;
                (x.color.lerpColors(c[_].color, l[_].color, f.t),
                  x.emissive.lerpColors(c[_].emissive, l[_].emissive, f.t),
                  (x.emissiveIntensity =
                    c[_].intensity + (l[_].intensity - c[_].intensity) * f.t));
              }),
                (this.ledGlowStrength = u + (o - u) * f.t));
            },
          });
        });
        y(this, 'fadeLedEmissiveOut', (e) => {
          var o;
          if (!this.ledMaterials) return;
          let t = this.ledMaterials;
          if (((o = this.ledTween) == null || o.kill(), e <= 0)) {
            (t.forEach((a) => {
              let l = a;
              l.emissiveIntensity = 0;
            }),
              (this.ledGlowStrength = 0));
            return;
          }
          let i = t.map((a) => a.emissiveIntensity),
            n = this.ledGlowStrength,
            r = { t: 0 };
          this.ledTween = Et.to(r, {
            t: 1,
            duration: e,
            ease: 'power2.out',
            onUpdate: () => {
              (t.forEach((a, l) => {
                let c = a;
                c.emissiveIntensity = i[l] * (1 - r.t);
              }),
                (this.ledGlowStrength = n * (1 - r.t)));
            },
          });
        });
        y(this, 'applyLightSettings', () => {
          let { lights: e, envMap: t } = this.config,
            i = zt;
          (this.ambient.color.setHex(e.ambientColor, i),
            (this.ambient.intensity = e.ambientIntensity),
            this.directional.color.setHex(e.directionalColor, i),
            (this.directional.intensity = e.directionalIntensity),
            this.directional.position.set(...e.directionalPosition),
            (this.videoLight.intensity = t.lightIntensity),
            this.accentLight1.color.setHex(e.accent1.color, i),
            (this.accentLight1.intensity = e.accent1.intensity),
            this.accentLight1.position.set(...e.accent1.position),
            this.accentLight2.color.setHex(e.accent2.color, i),
            (this.accentLight2.intensity = e.accent2.intensity),
            this.accentLight2.position.set(...e.accent2.position),
            this.accentLight3.color.setHex(e.accent3.color, i),
            (this.accentLight3.intensity = e.accent3.intensity),
            this.accentLight3.position.set(...e.accent3.position));
        });
        y(this, 'recomputeBaseCameraZ', () => {
          let e = this.camera.fov * (Math.PI / 180);
          this.baseCameraZ =
            Math.abs(this.modelMaxDim / 2 / Math.tan(e / 2)) *
            this.config.camera.fitScale;
        });
        y(this, 'applyEnvMapIntensity', () => {
          let { intensity: e } = this.config.envMap,
            t = (i) => {
              i &&
                i.traverse((n) => {
                  let r = n;
                  if (!r.isMesh) return;
                  (Array.isArray(r.material)
                    ? r.material
                    : [r.material]
                  ).forEach((a) => {
                    let l = a;
                    l.isMeshStandardMaterial && (l.envMapIntensity = e);
                  });
                });
            };
          (t(this.modelRoot), t(this.reflectionGroup));
        });
        y(this, 'cacheLedMaterials', () => {
          var r;
          let { name: e, fixedWhiteMeshes: t } = this.config.ledMaterial,
            i = [];
          ((this.ledOriginals = []), (this.ledFixedWhite = []));
          let n = (o, a) => {
            (i.push(o),
              this.ledFixedWhite.push(a),
              this.ledOriginals.push({
                color: o.color.clone(),
                emissive: o.emissive.clone(),
                emissiveIntensity: o.emissiveIntensity,
              }));
          };
          ((r = this.modelRoot) == null ||
            r.traverse((o) => {
              let a = o;
              if (!a.isMesh) return;
              let l = t.includes(a.name);
              (Array.isArray(a.material) ? a.material : [a.material]).forEach(
                (u, f) => {
                  let d = u;
                  if (!(!d.isMeshStandardMaterial || d.name !== e)) {
                    if ((a.layers.enable(g_), l)) {
                      let p = d.clone();
                      (Array.isArray(a.material)
                        ? (a.material[f] = p)
                        : (a.material = p),
                        n(p, !0));
                      return;
                    }
                    i.includes(d) || n(d, !1);
                  }
                },
              );
            }),
            (this.ledMaterials = i));
        });
        y(this, 'applyMatteParams', (e) => {
          ((this.matteLive = e),
            (this.matteUniforms.uMatteAlbedo.value = e.albedo),
            this.setMatteLook(this.matteLook));
        });
        y(this, 'prepareMatteMaterials', () => {
          if (!this.modelRoot || this.matteCacheRoot === this.modelRoot) return;
          let { targets: e } = this.matteLive,
            t = [],
            i = new Set();
          (this.modelRoot.traverse((n) => {
            let r = n;
            if (!r.isMesh) return;
            (Array.isArray(r.material) ? r.material : [r.material]).forEach(
              (a) => {
                let l = a;
                !l.isMeshStandardMaterial ||
                  i.has(l) ||
                  (e.includes(l.name) &&
                    (i.add(l),
                    (l.onBeforeCompile = (c) => {
                      yC(c, this.matteUniforms);
                    }),
                    (l.customProgramCacheKey = () => 'product-matte'),
                    (l.needsUpdate = !0),
                    t.push({
                      mat: l,
                      metalness: l.metalness,
                      roughness: l.roughness,
                    })));
              },
            );
          }),
            (this.matteMaterials = t),
            (this.matteCacheRoot = this.modelRoot));
        });
        y(this, 'buildReflection', () => {
          if (this.reflectionGroup || !this.modelRoot) return;
          let { reflection: e } = this.config.viewer,
            t = -this.modelHalfHeight + e.floorOffset,
            i = Math.max(1e-6, this.modelHalfHeight * 2 * e.fadeScale),
            n = this.modelRoot.clone(!0),
            r = [];
          (n.traverse((c) => {
            (c.isLight || c.isCamera) && r.push(c);
          }),
            r.forEach((c) => c.removeFromParent()));
          let o = (c) => {
            let u = bC(c, t, i, e.opacity, e.blur),
              f = this.matteMaterials.find((d) => d.mat === c);
            return (
              f &&
                this.matteMaterials.push({
                  mat: u,
                  metalness: f.metalness,
                  roughness: Math.min(1, f.roughness + e.blur),
                }),
              u
            );
          };
          (n.traverse((c) => {
            let u = c;
            u.isMesh &&
              ((u.material = Array.isArray(u.material)
                ? u.material.map(o)
                : o(u.material)),
              (u.castShadow = !1),
              (u.receiveShadow = !1));
          }),
            this.setMatteLook(this.matteLook));
          let a = new Ri();
          a.add(n);
          let l = new Ri();
          (l.add(a),
            l.scale.set(1, -1, 1),
            (l.position.y = 2 * t),
            (l.visible = !1),
            (this.reflectionGroup = l),
            (this.reflectionContent = a),
            this.scene.add(l));
        });
        ((this.config = e),
          (this.matteLive = pt({}, e.matteLook)),
          (this.matteUniforms.uMatteAlbedo.value = this.matteLive.albedo));
        let { camera: t } = e;
        ((this.scene = new Wn()),
          (this.camera = new di(
            t.fov,
            window.innerWidth / window.innerHeight,
            t.near,
            t.far,
          )),
          (this.camera.position.z = this.baseCameraZ),
          (this.reflectionCamera = new di(
            t.fov,
            window.innerWidth / window.innerHeight,
            t.near,
            t.far,
          )),
          (this.ambient = new el(16777215, 1)),
          (this.directional = new Js(16777215, 1)),
          (this.videoLight = new el(0, 0)),
          (this.accentLight1 = new Js(16777215, 0)),
          (this.accentLight2 = new Js(16777215, 0)),
          (this.accentLight3 = new Js(16777215, 0)),
          this.applyLightSettings(),
          this.modelGroup.add(this.spinGroup),
          this.spinGroup.add(this.cursorGroup),
          this.scene.add(
            this.ambient,
            this.directional,
            this.videoLight,
            this.accentLight1,
            this.accentLight2,
            this.accentLight3,
            this.modelGroup,
          ));
      }
      get hasReflection() {
        return this.reflectionGroup !== null;
      }
      get matteLook() {
        return this.matteUniforms.uMatteT.value;
      }
      get matteParams() {
        return this.matteLive;
      }
    };
  var Is = (s, e) => {
      let t = (e.camZ1Px * Qd()) / (e.designVh * e.maxRatio);
      return Math.max(s, t);
    },
    nf = (s, e) => {
      var d, p, _, x;
      let t = s.steps.bluetooth,
        i = t == null ? void 0 : t.fitHeight,
        n = window.innerHeight;
      if (!t || !i || n === 0) return null;
      let { camera: r, baseCameraZ: o } = e,
        a = Is((p = (d = t.pose) == null ? void 0 : d.camZ) != null ? p : 1, i),
        l = pl(i, a, n),
        c = Ls(r.fov, o, a),
        u =
          (((x = (_ = t.pose) == null ? void 0 : _.py) != null ? x : 0) / c) *
          n;
      return n / 2 + l / 2 - u - $v;
    },
    sf = (s, e) => {
      var d, p, _, x;
      let t = s.steps.cta,
        i = t == null ? void 0 : t.fitHeight,
        n = window.innerHeight;
      if (!t || !i || n === 0) return null;
      let { camera: r, baseCameraZ: o } = e,
        a = Is((p = (d = t.pose) == null ? void 0 : d.camZ) != null ? p : 1, i),
        l = pl(i, a, n),
        c = Ls(r.fov, o, a),
        u =
          (((x = (_ = t.pose) == null ? void 0 : _.py) != null ? x : 0) / c) *
          n;
      return n / 2 + l / 2 - u + jv * as();
    },
    ef = (s) => {
      let e = s == null ? void 0 : s.getTween();
      return !!(e && e.isActive());
    },
    tf = class {
      constructor(e, t) {
        y(this, 'scene3d');
        y(this, 'canvasElm');
        y(this, 'triggers', []);
        y(this, 'timelines', []);
        y(this, 'builtFits', []);
        y(this, 'isEnabled', !0);
        y(this, 'applyInitial', (e) => {
          var i;
          this.builtFits = [];
          let { pose: t } = e.initial;
          if (t.camZ !== void 0 && e.initial.fitHeight !== void 0) {
            let n = e.initial.fitHeight,
              r = Is(t.camZ, n);
            (this.builtFits.push({ camZ: t.camZ, fit: n, fitted: r }),
              (t = Fi(pt({}, t), { camZ: r })));
          }
          (this.applyPose(t),
            (this.scene3d.spinGroup.rotation.y = Vt.degToRad(
              (i = e.initial.spinY) != null ? i : 0,
            )),
            Et.set(this.canvasElm, { opacity: e.initial.opacity }),
            (this.scene3d.lookChannel.t = 0));
        });
        y(this, 'build', (e) => {
          this.isEnabled = !0;
          let t = e.initial.pose.camZ,
            i =
              e.initial.pose.camZ !== void 0 && e.initial.fitHeight !== void 0
                ? Is(e.initial.pose.camZ, e.initial.fitHeight)
                : e.initial.pose.camZ,
            n = new je(e.lights.ambientColor),
            r = new je(e.lights.directionalColor),
            o = e.lights.directionalIntensity,
            a = [e.lights.accent1, e.lights.accent2, e.lights.accent3],
            l = 0;
          Object.values(e.steps).forEach((c) => {
            // Removed Shopify sections must not create viewport-wide fallback
            // triggers that overwrite the current section's model pose.
            const triggerElement = document.querySelector(`[${c.trigger}]`);
            if (!triggerElement) return;
            var L, R, U, O, N, M;
            let u =
                c.opacity !== void 0 &&
                !c.pose &&
                c.spinY === void 0 &&
                c.scaleFrom === void 0 &&
                c.light === void 0 &&
                c.directionalIntensity === void 0,
              f = c.end === am,
              d = c.end === lm,
              { endTrigger: p } = c,
              _ = c.end;
            f
              ? ((p = ct.bluetoothText),
                (_ = () => {
                  var I;
                  return `bottom ${(I = nf(e, this.scene3d)) != null ? I : 0}px`;
                }))
              : d &&
                ((p = ct.ctaContents),
                (_ = () => {
                  var I;
                  return `top ${(I = sf(e, this.scene3d)) != null ? I : 0}px`;
                }));
            const endTriggerElement = p
              ? document.querySelector(`[${p}]`)
              : null;
            if (p && !endTriggerElement) return;
            let x = Et.timeline({
                scrollTrigger: Fi(
                  pt(
                    { trigger: triggerElement },
                    endTriggerElement ? { endTrigger: endTriggerElement } : {},
                  ),
                  { start: c.start, end: _, scrub: u ? !0 : e.scrub },
                ),
              }),
              { pose: g } = c;
            if (
              (g == null ? void 0 : g.camZ) !== void 0 &&
              c.fitHeight !== void 0
            ) {
              let I = Is(g.camZ, c.fitHeight);
              (this.builtFits.push({
                camZ: g.camZ,
                fit: c.fitHeight,
                fitted: I,
              }),
                (g = Fi(pt({}, g), { camZ: I })));
            }
            let { poseFrom: v } = c;
            ((v == null ? void 0 : v.camZ) !== void 0 &&
              (i !== void 0 && v.camZ === t
                ? (v = Fi(pt({}, v), { camZ: i }))
                : (g == null ? void 0 : g.camZ) !== void 0 &&
                  v.camZ === ((L = c.pose) == null ? void 0 : L.camZ) &&
                  (v = Fi(pt({}, v), { camZ: g.camZ }))),
              ((R = c.pose) == null ? void 0 : R.camZ) !== void 0 &&
                ((t = c.pose.camZ), (i = g == null ? void 0 : g.camZ)));
            let w = (U = c.poseEase) != null ? U : 'power2.inOut';
            if (
              (g && this.addPoseTweens(x, g, v, c.scaleFrom !== void 0, w),
              c.spinY !== void 0)
            ) {
              let I = { y: Vt.degToRad(c.spinY), immediateRender: !1, ease: w };
              c.spinYFrom !== void 0
                ? x.fromTo(
                    this.scene3d.spinGroup.rotation,
                    { y: Vt.degToRad(c.spinYFrom) },
                    I,
                    0,
                  )
                : x.to(this.scene3d.spinGroup.rotation, I, 0);
            }
            if (c.scaleFrom !== void 0) {
              let I =
                  (N = (O = c.pose) == null ? void 0 : O.scale) != null ? N : 1,
                z = c.scaleFrom;
              x.fromTo(
                this.scene3d.modelGroup.scale,
                { x: z, y: z, z },
                { x: I, y: I, z: I, immediateRender: !1, ease: 'power2.out' },
                0,
              );
            }
            if (
              (c.opacity !== void 0 &&
                x.to(
                  this.canvasElm,
                  {
                    opacity: c.opacity,
                    immediateRender: !1,
                    ease: (M = c.opacityEase) != null ? M : 'none',
                  },
                  0,
                ),
              c.light !== void 0)
            ) {
              let I = new je(c.light),
                z = {
                  r: I.r,
                  g: I.g,
                  b: I.b,
                  immediateRender: !1,
                  ease: 'none',
                };
              (x.fromTo(
                this.scene3d.ambient.color,
                { r: n.r, g: n.g, b: n.b },
                pt({}, z),
                0,
              ),
                x.fromTo(
                  this.scene3d.directional.color,
                  { r: r.r, g: r.g, b: r.b },
                  pt({}, z),
                  0,
                ),
                (n = I),
                (r = I));
            }
            (c.directionalIntensity !== void 0 &&
              (x.fromTo(
                this.scene3d.directional,
                { intensity: o },
                {
                  intensity: c.directionalIntensity,
                  immediateRender: !1,
                  ease: 'none',
                },
                0,
              ),
              (o = c.directionalIntensity)),
              [
                [this.scene3d.accentLight1, c.accent1, 0],
                [this.scene3d.accentLight2, c.accent2, 1],
                [this.scene3d.accentLight3, c.accent3, 2],
              ].forEach(([I, z, W]) => {
                if (z !== void 0) {
                  let q = a[W],
                    re = new je(z.color),
                    oe = new je(q.color);
                  (x.fromTo(
                    I,
                    { intensity: q.intensity },
                    {
                      intensity: z.intensity,
                      immediateRender: !1,
                      ease: 'none',
                    },
                    0,
                  ),
                    x.fromTo(
                      I.position,
                      { x: q.position[0], y: q.position[1], z: q.position[2] },
                      {
                        x: z.position[0],
                        y: z.position[1],
                        z: z.position[2],
                        immediateRender: !1,
                        ease: 'none',
                      },
                      0,
                    ),
                    x.fromTo(
                      I.color,
                      { r: oe.r, g: oe.g, b: oe.b },
                      {
                        r: re.r,
                        g: re.g,
                        b: re.b,
                        immediateRender: !1,
                        ease: 'none',
                      },
                      0,
                    ),
                    (a[W] = z));
                }
              }),
              c.look !== void 0 &&
                (x.fromTo(
                  this.scene3d.lookChannel,
                  { t: l },
                  { t: c.look, immediateRender: !1, ease: 'none' },
                  0,
                ),
                (l = c.look)),
              this.timelines.push(x),
              x.scrollTrigger && this.triggers.push(x.scrollTrigger));
          });
        });
        y(
          this,
          'hasFrozenDesync',
          () =>
            this.isEnabled &&
            this.timelines.some((e) => {
              let t = e.scrollTrigger;
              if (!t) return !1;
              let i = t.progress;
              return (i === 0 || i === 1) && e.totalProgress() !== i && !ef(t);
            }),
        );
        y(
          this,
          'hasActiveTail',
          () =>
            this.isEnabled && this.timelines.some((e) => ef(e.scrollTrigger)),
        );
        y(
          this,
          'hasBoundaryTail',
          () =>
            this.isEnabled &&
            this.timelines.some((e) => {
              let t = e.scrollTrigger;
              return !!(t && ef(t) && (t.progress === 0 || t.progress === 1));
            }),
        );
        y(this, 'clear', () => {
          (this.triggers.forEach((e) => e.kill()),
            this.timelines.forEach((e) => e.kill()),
            (this.triggers = []),
            (this.timelines = []));
        });
        y(this, 'disable', () => {
          ((this.isEnabled = !1), this.triggers.forEach((e) => e.disable(!1)));
        });
        y(this, 'enable', () => {
          ((this.isEnabled = !0), this.triggers.forEach((e) => e.enable()));
        });
        y(this, 'resync', (e, t) => {
          (this.clear(),
            this.applyInitial(e),
            this.build(e),
            this.triggers.forEach((i) => i.refresh()),
            Et.ticker.add(() => {
              t == null || t();
            }, !0));
        });
        y(this, 'isFitStale', () =>
          this.builtFits.some(
            (e) => Math.abs(Is(e.camZ, e.fit) - e.fitted) / e.fitted > 0.005,
          ),
        );
        y(this, 'renderOwnerLast', () => {
          if (!this.isEnabled) return;
          let e = !1;
          (this.timelines.forEach((t) => {
            ef(t.scrollTrigger) && (e = !0);
          }),
            e &&
              this.timelines.forEach((t) => {
                let i = t.scrollTrigger;
                !i || i.progress === 0 || t.render(t.totalTime(), !0, !0);
              }));
        });
        y(this, 'applyPose', (e) => {
          let { modelGroup: t, camera: i, baseCameraZ: n } = this.scene3d,
            r = Vt.degToRad;
          (e.rx !== void 0 && (t.rotation.x = r(e.rx)),
            e.ry !== void 0 && (t.rotation.y = r(e.ry)),
            e.rz !== void 0 && (t.rotation.z = r(e.rz)),
            e.px !== void 0 && (t.position.x = e.px),
            e.py !== void 0 && (t.position.y = e.py),
            e.pz !== void 0 && (t.position.z = e.pz),
            e.scale !== void 0 && t.scale.setScalar(e.scale),
            e.camZ !== void 0 && (i.position.z = n * e.camZ));
        });
        y(this, 'addPoseTweens', (e, t, i, n = !1, r = 'power2.inOut') => {
          let { modelGroup: o, camera: a, baseCameraZ: l } = this.scene3d,
            c = Vt.degToRad,
            u = { immediateRender: !1, ease: r },
            f = (g, v, w) => {
              Object.keys(v).length &&
                (Object.keys(w).length
                  ? e.fromTo(g, w, pt(pt({}, v), u), 0)
                  : e.to(g, pt(pt({}, v), u), 0));
            },
            d = {},
            p = {};
          ([
            ['rx', 'x'],
            ['ry', 'y'],
            ['rz', 'z'],
          ].forEach(([g, v]) => {
            (t[g] !== void 0 && (d[v] = c(t[g])),
              (i == null ? void 0 : i[g]) !== void 0 && (p[v] = c(i[g])));
          }),
            f(o.rotation, d, p));
          let _ = {},
            x = {};
          if (
            ([
              ['px', 'x'],
              ['py', 'y'],
              ['pz', 'z'],
            ].forEach(([g, v]) => {
              (t[g] !== void 0 && (_[v] = t[g]),
                (i == null ? void 0 : i[g]) !== void 0 && (x[v] = i[g]));
            }),
            f(o.position, _, x),
            !n && t.scale !== void 0)
          ) {
            let g = t.scale,
              v = i == null ? void 0 : i.scale;
            f(
              o.scale,
              { x: g, y: g, z: g },
              v !== void 0 ? { x: v, y: v, z: v } : {},
            );
          }
          t.camZ !== void 0 &&
            f(
              a.position,
              { z: l * t.camZ },
              (i == null ? void 0 : i.camZ) !== void 0 ? { z: l * i.camZ } : {},
            );
        });
        ((this.scene3d = e),
          (this.canvasElm = t),
          Et.ticker.add(this.renderOwnerLast));
      }
    };
  var db = { type: 'change' },
    x_ = { type: 'start' },
    pb = { type: 'end' },
    rf = new Tr(),
    fb = new is(),
    EC = Math.cos(70 * Vt.DEG2RAD),
    Oi = new te(),
    In = 2 * Math.PI,
    ei = {
      NONE: -1,
      ROTATE: 0,
      DOLLY: 1,
      PAN: 2,
      TOUCH_ROTATE: 3,
      TOUCH_PAN: 4,
      TOUCH_DOLLY_PAN: 5,
      TOUCH_DOLLY_ROTATE: 6,
    },
    v_ = 1e-6,
    of = class extends Oc {
      constructor(e, t = null) {
        (super(e, t),
          (this.state = ei.NONE),
          (this.target = new te()),
          (this.cursor = new te()),
          (this.minDistance = 0),
          (this.maxDistance = 1 / 0),
          (this.minZoom = 0),
          (this.maxZoom = 1 / 0),
          (this.minTargetRadius = 0),
          (this.maxTargetRadius = 1 / 0),
          (this.minPolarAngle = 0),
          (this.maxPolarAngle = Math.PI),
          (this.minAzimuthAngle = -1 / 0),
          (this.maxAzimuthAngle = 1 / 0),
          (this.enableDamping = !1),
          (this.dampingFactor = 0.05),
          (this.enableZoom = !0),
          (this.zoomSpeed = 1),
          (this.enableRotate = !0),
          (this.rotateSpeed = 1),
          (this.keyRotateSpeed = 1),
          (this.enablePan = !0),
          (this.panSpeed = 1),
          (this.screenSpacePanning = !0),
          (this.keyPanSpeed = 7),
          (this.zoomToCursor = !1),
          (this.autoRotate = !1),
          (this.autoRotateSpeed = 2),
          (this.keys = {
            LEFT: 'ArrowLeft',
            UP: 'ArrowUp',
            RIGHT: 'ArrowRight',
            BOTTOM: 'ArrowDown',
          }),
          (this.mouseButtons = {
            LEFT: so.ROTATE,
            MIDDLE: so.DOLLY,
            RIGHT: so.PAN,
          }),
          (this.touches = { ONE: ro.ROTATE, TWO: ro.DOLLY_PAN }),
          (this.target0 = this.target.clone()),
          (this.position0 = this.object.position.clone()),
          (this.zoom0 = this.object.zoom),
          (this._cursorStyle = 'auto'),
          (this._domElementKeyEvents = null),
          (this._lastPosition = new te()),
          (this._lastQuaternion = new zi()),
          (this._lastTargetPosition = new te()),
          (this._quat = new zi().setFromUnitVectors(e.up, new te(0, 1, 0))),
          (this._quatInverse = this._quat.clone().invert()),
          (this._spherical = new Pr()),
          (this._sphericalDelta = new Pr()),
          (this._scale = 1),
          (this._panOffset = new te()),
          (this._rotateStart = new et()),
          (this._rotateEnd = new et()),
          (this._rotateDelta = new et()),
          (this._panStart = new et()),
          (this._panEnd = new et()),
          (this._panDelta = new et()),
          (this._dollyStart = new et()),
          (this._dollyEnd = new et()),
          (this._dollyDelta = new et()),
          (this._dollyDirection = new te()),
          (this._mouse = new et()),
          (this._performCursorZoom = !1),
          (this._pointers = []),
          (this._pointerPositions = {}),
          (this._controlActive = !1),
          (this._onPointerMove = MC.bind(this)),
          (this._onPointerDown = TC.bind(this)),
          (this._onPointerUp = wC.bind(this)),
          (this._onContextMenu = DC.bind(this)),
          (this._onMouseWheel = CC.bind(this)),
          (this._onKeyDown = PC.bind(this)),
          (this._onTouchStart = LC.bind(this)),
          (this._onTouchMove = IC.bind(this)),
          (this._onMouseDown = AC.bind(this)),
          (this._onMouseMove = RC.bind(this)),
          (this._interceptControlDown = OC.bind(this)),
          (this._interceptControlUp = NC.bind(this)),
          this.domElement !== null && this.connect(this.domElement),
          this.update());
      }
      set cursorStyle(e) {
        ((this._cursorStyle = e),
          e === 'grab'
            ? (this.domElement.style.cursor = 'grab')
            : (this.domElement.style.cursor = 'auto'));
      }
      get cursorStyle() {
        return this._cursorStyle;
      }
      connect(e) {
        (super.connect(e),
          this.domElement.addEventListener('pointerdown', this._onPointerDown),
          this.domElement.addEventListener('pointercancel', this._onPointerUp),
          this.domElement.addEventListener('contextmenu', this._onContextMenu),
          this.domElement.addEventListener('wheel', this._onMouseWheel, {
            passive: !1,
          }),
          this.domElement
            .getRootNode()
            .addEventListener('keydown', this._interceptControlDown, {
              passive: !0,
              capture: !0,
            }),
          (this.domElement.style.touchAction = 'none'));
      }
      disconnect() {
        (this.domElement.removeEventListener(
          'pointerdown',
          this._onPointerDown,
        ),
          this.domElement.ownerDocument.removeEventListener(
            'pointermove',
            this._onPointerMove,
          ),
          this.domElement.ownerDocument.removeEventListener(
            'pointerup',
            this._onPointerUp,
          ),
          this.domElement.removeEventListener(
            'pointercancel',
            this._onPointerUp,
          ),
          this.domElement.removeEventListener('wheel', this._onMouseWheel),
          this.domElement.removeEventListener(
            'contextmenu',
            this._onContextMenu,
          ),
          this.stopListenToKeyEvents(),
          this.domElement
            .getRootNode()
            .removeEventListener('keydown', this._interceptControlDown, {
              capture: !0,
            }),
          (this.domElement.style.touchAction = ''));
      }
      dispose() {
        this.disconnect();
      }
      getPolarAngle() {
        return this._spherical.phi;
      }
      getAzimuthalAngle() {
        return this._spherical.theta;
      }
      getDistance() {
        return this.object.position.distanceTo(this.target);
      }
      listenToKeyEvents(e) {
        (e.addEventListener('keydown', this._onKeyDown),
          (this._domElementKeyEvents = e));
      }
      stopListenToKeyEvents() {
        this._domElementKeyEvents !== null &&
          (this._domElementKeyEvents.removeEventListener(
            'keydown',
            this._onKeyDown,
          ),
          (this._domElementKeyEvents = null));
      }
      saveState() {
        (this.target0.copy(this.target),
          this.position0.copy(this.object.position),
          (this.zoom0 = this.object.zoom));
      }
      reset() {
        (this.target.copy(this.target0),
          this.object.position.copy(this.position0),
          (this.object.zoom = this.zoom0),
          this.object.updateProjectionMatrix(),
          this.dispatchEvent(db),
          this.update(),
          (this.state = ei.NONE));
      }
      pan(e, t) {
        (this._pan(e, t), this.update());
      }
      dollyIn(e) {
        (this._dollyIn(e), this.update());
      }
      dollyOut(e) {
        (this._dollyOut(e), this.update());
      }
      rotateLeft(e) {
        (this._rotateLeft(e), this.update());
      }
      rotateUp(e) {
        (this._rotateUp(e), this.update());
      }
      update(e = null) {
        let t = this.object.position;
        (Oi.copy(t).sub(this.target),
          Oi.applyQuaternion(this._quat),
          this._spherical.setFromVector3(Oi),
          this.autoRotate &&
            this.state === ei.NONE &&
            this._rotateLeft(this._getAutoRotationAngle(e)),
          this.enableDamping
            ? ((this._spherical.theta +=
                this._sphericalDelta.theta * this.dampingFactor),
              (this._spherical.phi +=
                this._sphericalDelta.phi * this.dampingFactor))
            : ((this._spherical.theta += this._sphericalDelta.theta),
              (this._spherical.phi += this._sphericalDelta.phi)));
        let i = this.minAzimuthAngle,
          n = this.maxAzimuthAngle;
        (isFinite(i) &&
          isFinite(n) &&
          (i < -Math.PI ? (i += In) : i > Math.PI && (i -= In),
          n < -Math.PI ? (n += In) : n > Math.PI && (n -= In),
          i <= n
            ? (this._spherical.theta = Math.max(
                i,
                Math.min(n, this._spherical.theta),
              ))
            : (this._spherical.theta =
                this._spherical.theta > (i + n) / 2
                  ? Math.max(i, this._spherical.theta)
                  : Math.min(n, this._spherical.theta))),
          (this._spherical.phi = Math.max(
            this.minPolarAngle,
            Math.min(this.maxPolarAngle, this._spherical.phi),
          )),
          this._spherical.makeSafe(),
          this.enableDamping === !0
            ? this.target.addScaledVector(this._panOffset, this.dampingFactor)
            : this.target.add(this._panOffset),
          this.target.sub(this.cursor),
          this.target.clampLength(this.minTargetRadius, this.maxTargetRadius),
          this.target.add(this.cursor));
        let r = !1;
        if (
          (this.zoomToCursor && this._performCursorZoom) ||
          this.object.isOrthographicCamera
        )
          this._spherical.radius = this._clampDistance(this._spherical.radius);
        else {
          let o = this._spherical.radius;
          ((this._spherical.radius = this._clampDistance(
            this._spherical.radius * this._scale,
          )),
            (r = o != this._spherical.radius));
        }
        if (
          (Oi.setFromSpherical(this._spherical),
          Oi.applyQuaternion(this._quatInverse),
          t.copy(this.target).add(Oi),
          this.object.lookAt(this.target),
          this.enableDamping === !0
            ? ((this._sphericalDelta.theta *= 1 - this.dampingFactor),
              (this._sphericalDelta.phi *= 1 - this.dampingFactor),
              this._panOffset.multiplyScalar(1 - this.dampingFactor))
            : (this._sphericalDelta.set(0, 0, 0), this._panOffset.set(0, 0, 0)),
          this.zoomToCursor && this._performCursorZoom)
        ) {
          let o = null;
          if (this.object.isPerspectiveCamera) {
            let a = Oi.length();
            o = this._clampDistance(a * this._scale);
            let l = a - o;
            (this.object.position.addScaledVector(this._dollyDirection, l),
              this.object.updateMatrixWorld(),
              (r = !!l));
          } else if (this.object.isOrthographicCamera) {
            let a = new te(this._mouse.x, this._mouse.y, 0);
            a.unproject(this.object);
            let l = this.object.zoom;
            ((this.object.zoom = Math.max(
              this.minZoom,
              Math.min(this.maxZoom, this.object.zoom / this._scale),
            )),
              this.object.updateProjectionMatrix(),
              (r = l !== this.object.zoom));
            let c = new te(this._mouse.x, this._mouse.y, 0);
            (c.unproject(this.object),
              this.object.position.sub(c).add(a),
              this.object.updateMatrixWorld(),
              (o = Oi.length()));
          } else this.zoomToCursor = !1;
          o !== null &&
            (this.screenSpacePanning
              ? this.target
                  .set(0, 0, -1)
                  .transformDirection(this.object.matrix)
                  .multiplyScalar(o)
                  .add(this.object.position)
              : (rf.origin.copy(this.object.position),
                rf.direction
                  .set(0, 0, -1)
                  .transformDirection(this.object.matrix),
                Math.abs(this.object.up.dot(rf.direction)) < EC
                  ? this.object.lookAt(this.target)
                  : (fb.setFromNormalAndCoplanarPoint(
                      this.object.up,
                      this.target,
                    ),
                    rf.intersectPlane(fb, this.target))));
        } else if (this.object.isOrthographicCamera) {
          let o = this.object.zoom;
          ((this.object.zoom = Math.max(
            this.minZoom,
            Math.min(this.maxZoom, this.object.zoom / this._scale),
          )),
            o !== this.object.zoom &&
              (this.object.updateProjectionMatrix(), (r = !0)));
        }
        return (
          (this._scale = 1),
          (this._performCursorZoom = !1),
          r ||
          this._lastPosition.distanceToSquared(this.object.position) > v_ ||
          8 * (1 - this._lastQuaternion.dot(this.object.quaternion)) > v_ ||
          this._lastTargetPosition.distanceToSquared(this.target) > v_
            ? (this.dispatchEvent(db),
              this._lastPosition.copy(this.object.position),
              this._lastQuaternion.copy(this.object.quaternion),
              this._lastTargetPosition.copy(this.target),
              !0)
            : !1
        );
      }
      _getAutoRotationAngle(e) {
        return e !== null
          ? (In / 60) * this.autoRotateSpeed * e
          : (In / 60 / 60) * this.autoRotateSpeed;
      }
      _getZoomScale(e) {
        let t = Math.abs(e * 0.01);
        return Math.pow(0.95, this.zoomSpeed * t);
      }
      _rotateLeft(e) {
        this._sphericalDelta.theta -= e;
      }
      _rotateUp(e) {
        this._sphericalDelta.phi -= e;
      }
      _panLeft(e, t) {
        (Oi.setFromMatrixColumn(t, 0),
          Oi.multiplyScalar(-e),
          this._panOffset.add(Oi));
      }
      _panUp(e, t) {
        (this.screenSpacePanning === !0
          ? Oi.setFromMatrixColumn(t, 1)
          : (Oi.setFromMatrixColumn(t, 0), Oi.crossVectors(this.object.up, Oi)),
          Oi.multiplyScalar(e),
          this._panOffset.add(Oi));
      }
      _pan(e, t) {
        let i = this.domElement;
        if (this.object.isPerspectiveCamera) {
          let n = this.object.position;
          Oi.copy(n).sub(this.target);
          let r = Oi.length();
          ((r *= Math.tan(((this.object.fov / 2) * Math.PI) / 180)),
            this._panLeft((2 * e * r) / i.clientHeight, this.object.matrix),
            this._panUp((2 * t * r) / i.clientHeight, this.object.matrix));
        } else
          this.object.isOrthographicCamera
            ? (this._panLeft(
                (e * (this.object.right - this.object.left)) /
                  this.object.zoom /
                  i.clientWidth,
                this.object.matrix,
              ),
              this._panUp(
                (t * (this.object.top - this.object.bottom)) /
                  this.object.zoom /
                  i.clientHeight,
                this.object.matrix,
              ))
            : (this.enablePan = !1);
      }
      _dollyOut(e) {
        this.object.isPerspectiveCamera || this.object.isOrthographicCamera
          ? (this._scale /= e)
          : (this.enableZoom = !1);
      }
      _dollyIn(e) {
        this.object.isPerspectiveCamera || this.object.isOrthographicCamera
          ? (this._scale *= e)
          : (this.enableZoom = !1);
      }
      _updateZoomParameters(e, t) {
        if (!this.zoomToCursor) return;
        this._performCursorZoom = !0;
        let i = this.domElement.getBoundingClientRect(),
          n = e - i.left,
          r = t - i.top,
          o = i.width,
          a = i.height;
        ((this._mouse.x = (n / o) * 2 - 1),
          (this._mouse.y = -(r / a) * 2 + 1),
          this._dollyDirection
            .set(this._mouse.x, this._mouse.y, 1)
            .unproject(this.object)
            .sub(this.object.position)
            .normalize());
      }
      _clampDistance(e) {
        return Math.max(this.minDistance, Math.min(this.maxDistance, e));
      }
      _handleMouseDownRotate(e) {
        this._rotateStart.set(e.clientX, e.clientY);
      }
      _handleMouseDownDolly(e) {
        (this._updateZoomParameters(e.clientX, e.clientX),
          this._dollyStart.set(e.clientX, e.clientY));
      }
      _handleMouseDownPan(e) {
        this._panStart.set(e.clientX, e.clientY);
      }
      _handleMouseMoveRotate(e) {
        (this._rotateEnd.set(e.clientX, e.clientY),
          this._rotateDelta
            .subVectors(this._rotateEnd, this._rotateStart)
            .multiplyScalar(this.rotateSpeed));
        let t = this.domElement;
        (this._rotateLeft((In * this._rotateDelta.x) / t.clientHeight),
          this._rotateUp((In * this._rotateDelta.y) / t.clientHeight),
          this._rotateStart.copy(this._rotateEnd),
          this.update());
      }
      _handleMouseMoveDolly(e) {
        (this._dollyEnd.set(e.clientX, e.clientY),
          this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart),
          this._dollyDelta.y > 0
            ? this._dollyOut(this._getZoomScale(this._dollyDelta.y))
            : this._dollyDelta.y < 0 &&
              this._dollyIn(this._getZoomScale(this._dollyDelta.y)),
          this._dollyStart.copy(this._dollyEnd),
          this.update());
      }
      _handleMouseMovePan(e) {
        (this._panEnd.set(e.clientX, e.clientY),
          this._panDelta
            .subVectors(this._panEnd, this._panStart)
            .multiplyScalar(this.panSpeed),
          this._pan(this._panDelta.x, this._panDelta.y),
          this._panStart.copy(this._panEnd),
          this.update());
      }
      _handleMouseWheel(e) {
        (this._updateZoomParameters(e.clientX, e.clientY),
          e.deltaY < 0
            ? this._dollyIn(this._getZoomScale(e.deltaY))
            : e.deltaY > 0 && this._dollyOut(this._getZoomScale(e.deltaY)),
          this.update());
      }
      _handleKeyDown(e) {
        let t = !1;
        switch (e.code) {
          case this.keys.UP:
            (e.ctrlKey || e.metaKey || e.shiftKey
              ? this.enableRotate &&
                this._rotateUp(
                  (In * this.keyRotateSpeed) / this.domElement.clientHeight,
                )
              : this.enablePan && this._pan(0, this.keyPanSpeed),
              (t = !0));
            break;
          case this.keys.BOTTOM:
            (e.ctrlKey || e.metaKey || e.shiftKey
              ? this.enableRotate &&
                this._rotateUp(
                  (-In * this.keyRotateSpeed) / this.domElement.clientHeight,
                )
              : this.enablePan && this._pan(0, -this.keyPanSpeed),
              (t = !0));
            break;
          case this.keys.LEFT:
            (e.ctrlKey || e.metaKey || e.shiftKey
              ? this.enableRotate &&
                this._rotateLeft(
                  (In * this.keyRotateSpeed) / this.domElement.clientHeight,
                )
              : this.enablePan && this._pan(this.keyPanSpeed, 0),
              (t = !0));
            break;
          case this.keys.RIGHT:
            (e.ctrlKey || e.metaKey || e.shiftKey
              ? this.enableRotate &&
                this._rotateLeft(
                  (-In * this.keyRotateSpeed) / this.domElement.clientHeight,
                )
              : this.enablePan && this._pan(-this.keyPanSpeed, 0),
              (t = !0));
            break;
        }
        t && (e.preventDefault(), this.update());
      }
      _handleTouchStartRotate(e) {
        if (this._pointers.length === 1)
          this._rotateStart.set(e.pageX, e.pageY);
        else {
          let t = this._getSecondPointerPosition(e),
            i = 0.5 * (e.pageX + t.x),
            n = 0.5 * (e.pageY + t.y);
          this._rotateStart.set(i, n);
        }
      }
      _handleTouchStartPan(e) {
        if (this._pointers.length === 1) this._panStart.set(e.pageX, e.pageY);
        else {
          let t = this._getSecondPointerPosition(e),
            i = 0.5 * (e.pageX + t.x),
            n = 0.5 * (e.pageY + t.y);
          this._panStart.set(i, n);
        }
      }
      _handleTouchStartDolly(e) {
        let t = this._getSecondPointerPosition(e),
          i = e.pageX - t.x,
          n = e.pageY - t.y,
          r = Math.sqrt(i * i + n * n);
        this._dollyStart.set(0, r);
      }
      _handleTouchStartDollyPan(e) {
        (this.enableZoom && this._handleTouchStartDolly(e),
          this.enablePan && this._handleTouchStartPan(e));
      }
      _handleTouchStartDollyRotate(e) {
        (this.enableZoom && this._handleTouchStartDolly(e),
          this.enableRotate && this._handleTouchStartRotate(e));
      }
      _handleTouchMoveRotate(e) {
        if (this._pointers.length == 1) this._rotateEnd.set(e.pageX, e.pageY);
        else {
          let i = this._getSecondPointerPosition(e),
            n = 0.5 * (e.pageX + i.x),
            r = 0.5 * (e.pageY + i.y);
          this._rotateEnd.set(n, r);
        }
        this._rotateDelta
          .subVectors(this._rotateEnd, this._rotateStart)
          .multiplyScalar(this.rotateSpeed);
        let t = this.domElement;
        (this._rotateLeft((In * this._rotateDelta.x) / t.clientHeight),
          this._rotateUp((In * this._rotateDelta.y) / t.clientHeight),
          this._rotateStart.copy(this._rotateEnd));
      }
      _handleTouchMovePan(e) {
        if (this._pointers.length === 1) this._panEnd.set(e.pageX, e.pageY);
        else {
          let t = this._getSecondPointerPosition(e),
            i = 0.5 * (e.pageX + t.x),
            n = 0.5 * (e.pageY + t.y);
          this._panEnd.set(i, n);
        }
        (this._panDelta
          .subVectors(this._panEnd, this._panStart)
          .multiplyScalar(this.panSpeed),
          this._pan(this._panDelta.x, this._panDelta.y),
          this._panStart.copy(this._panEnd));
      }
      _handleTouchMoveDolly(e) {
        let t = this._getSecondPointerPosition(e),
          i = e.pageX - t.x,
          n = e.pageY - t.y,
          r = Math.sqrt(i * i + n * n);
        (this._dollyEnd.set(0, r),
          this._dollyDelta.set(
            0,
            Math.pow(this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed),
          ),
          this._dollyOut(this._dollyDelta.y),
          this._dollyStart.copy(this._dollyEnd));
        let o = (e.pageX + t.x) * 0.5,
          a = (e.pageY + t.y) * 0.5;
        this._updateZoomParameters(o, a);
      }
      _handleTouchMoveDollyPan(e) {
        (this.enableZoom && this._handleTouchMoveDolly(e),
          this.enablePan && this._handleTouchMovePan(e));
      }
      _handleTouchMoveDollyRotate(e) {
        (this.enableZoom && this._handleTouchMoveDolly(e),
          this.enableRotate && this._handleTouchMoveRotate(e));
      }
      _addPointer(e) {
        this._pointers.push(e.pointerId);
      }
      _removePointer(e) {
        delete this._pointerPositions[e.pointerId];
        for (let t = 0; t < this._pointers.length; t++)
          if (this._pointers[t] == e.pointerId) {
            this._pointers.splice(t, 1);
            return;
          }
      }
      _isTrackingPointer(e) {
        for (let t = 0; t < this._pointers.length; t++)
          if (this._pointers[t] == e.pointerId) return !0;
        return !1;
      }
      _trackPointer(e) {
        let t = this._pointerPositions[e.pointerId];
        (t === void 0 &&
          ((t = new et()), (this._pointerPositions[e.pointerId] = t)),
          t.set(e.pageX, e.pageY));
      }
      _getSecondPointerPosition(e) {
        let t =
          e.pointerId === this._pointers[0]
            ? this._pointers[1]
            : this._pointers[0];
        return this._pointerPositions[t];
      }
      _customWheelEvent(e) {
        let t = e.deltaMode,
          i = { clientX: e.clientX, clientY: e.clientY, deltaY: e.deltaY };
        switch (t) {
          case 1:
            i.deltaY *= 16;
            break;
          case 2:
            i.deltaY *= 100;
            break;
        }
        return (e.ctrlKey && !this._controlActive && (i.deltaY *= 10), i);
      }
    };
  function TC(s) {
    this.enabled !== !1 &&
      (this._pointers.length === 0 &&
        (this.domElement.setPointerCapture(s.pointerId),
        this.domElement.ownerDocument.addEventListener(
          'pointermove',
          this._onPointerMove,
        ),
        this.domElement.ownerDocument.addEventListener(
          'pointerup',
          this._onPointerUp,
        )),
      !this._isTrackingPointer(s) &&
        (this._addPointer(s),
        s.pointerType === 'touch'
          ? this._onTouchStart(s)
          : this._onMouseDown(s),
        this._cursorStyle === 'grab' &&
          (this.domElement.style.cursor = 'grabbing')));
  }
  function MC(s) {
    this.enabled !== !1 &&
      (s.pointerType === 'touch' ? this._onTouchMove(s) : this._onMouseMove(s));
  }
  function wC(s) {
    switch ((this._removePointer(s), this._pointers.length)) {
      case 0:
        (this.domElement.releasePointerCapture(s.pointerId),
          this.domElement.ownerDocument.removeEventListener(
            'pointermove',
            this._onPointerMove,
          ),
          this.domElement.ownerDocument.removeEventListener(
            'pointerup',
            this._onPointerUp,
          ),
          this.dispatchEvent(pb),
          (this.state = ei.NONE),
          this._cursorStyle === 'grab' &&
            (this.domElement.style.cursor = 'grab'));
        break;
      case 1:
        let e = this._pointers[0],
          t = this._pointerPositions[e];
        this._onTouchStart({ pointerId: e, pageX: t.x, pageY: t.y });
        break;
    }
  }
  function AC(s) {
    let e;
    switch (s.button) {
      case 0:
        e = this.mouseButtons.LEFT;
        break;
      case 1:
        e = this.mouseButtons.MIDDLE;
        break;
      case 2:
        e = this.mouseButtons.RIGHT;
        break;
      default:
        e = -1;
    }
    switch (e) {
      case so.DOLLY:
        if (this.enableZoom === !1) return;
        (this._handleMouseDownDolly(s), (this.state = ei.DOLLY));
        break;
      case so.ROTATE:
        if (s.ctrlKey || s.metaKey || s.shiftKey) {
          if (this.enablePan === !1) return;
          (this._handleMouseDownPan(s), (this.state = ei.PAN));
        } else {
          if (this.enableRotate === !1) return;
          (this._handleMouseDownRotate(s), (this.state = ei.ROTATE));
        }
        break;
      case so.PAN:
        if (s.ctrlKey || s.metaKey || s.shiftKey) {
          if (this.enableRotate === !1) return;
          (this._handleMouseDownRotate(s), (this.state = ei.ROTATE));
        } else {
          if (this.enablePan === !1) return;
          (this._handleMouseDownPan(s), (this.state = ei.PAN));
        }
        break;
      default:
        this.state = ei.NONE;
    }
    this.state !== ei.NONE && this.dispatchEvent(x_);
  }
  function RC(s) {
    switch (this.state) {
      case ei.ROTATE:
        if (this.enableRotate === !1) return;
        this._handleMouseMoveRotate(s);
        break;
      case ei.DOLLY:
        if (this.enableZoom === !1) return;
        this._handleMouseMoveDolly(s);
        break;
      case ei.PAN:
        if (this.enablePan === !1) return;
        this._handleMouseMovePan(s);
        break;
    }
  }
  function CC(s) {
    this.enabled === !1 ||
      this.enableZoom === !1 ||
      this.state !== ei.NONE ||
      (s.preventDefault(),
      this.dispatchEvent(x_),
      this._handleMouseWheel(this._customWheelEvent(s)),
      this.dispatchEvent(pb));
  }
  function PC(s) {
    this.enabled !== !1 && this._handleKeyDown(s);
  }
  function LC(s) {
    switch ((this._trackPointer(s), this._pointers.length)) {
      case 1:
        switch (this.touches.ONE) {
          case ro.ROTATE:
            if (this.enableRotate === !1) return;
            (this._handleTouchStartRotate(s), (this.state = ei.TOUCH_ROTATE));
            break;
          case ro.PAN:
            if (this.enablePan === !1) return;
            (this._handleTouchStartPan(s), (this.state = ei.TOUCH_PAN));
            break;
          default:
            this.state = ei.NONE;
        }
        break;
      case 2:
        switch (this.touches.TWO) {
          case ro.DOLLY_PAN:
            if (this.enableZoom === !1 && this.enablePan === !1) return;
            (this._handleTouchStartDollyPan(s),
              (this.state = ei.TOUCH_DOLLY_PAN));
            break;
          case ro.DOLLY_ROTATE:
            if (this.enableZoom === !1 && this.enableRotate === !1) return;
            (this._handleTouchStartDollyRotate(s),
              (this.state = ei.TOUCH_DOLLY_ROTATE));
            break;
          default:
            this.state = ei.NONE;
        }
        break;
      default:
        this.state = ei.NONE;
    }
    this.state !== ei.NONE && this.dispatchEvent(x_);
  }
  function IC(s) {
    switch ((this._trackPointer(s), this.state)) {
      case ei.TOUCH_ROTATE:
        if (this.enableRotate === !1) return;
        (this._handleTouchMoveRotate(s), this.update());
        break;
      case ei.TOUCH_PAN:
        if (this.enablePan === !1) return;
        (this._handleTouchMovePan(s), this.update());
        break;
      case ei.TOUCH_DOLLY_PAN:
        if (this.enableZoom === !1 && this.enablePan === !1) return;
        (this._handleTouchMoveDollyPan(s), this.update());
        break;
      case ei.TOUCH_DOLLY_ROTATE:
        if (this.enableZoom === !1 && this.enableRotate === !1) return;
        (this._handleTouchMoveDollyRotate(s), this.update());
        break;
      default:
        this.state = ei.NONE;
    }
  }
  function DC(s) {
    this.enabled !== !1 && s.preventDefault();
  }
  function OC(s) {
    s.key === 'Control' &&
      ((this._controlActive = !0),
      this.domElement
        .getRootNode()
        .addEventListener('keyup', this._interceptControlUp, {
          passive: !0,
          capture: !0,
        }));
  }
  function NC(s) {
    s.key === 'Control' &&
      ((this._controlActive = !1),
      this.domElement
        .getRootNode()
        .removeEventListener('keyup', this._interceptControlUp, {
          passive: !0,
          capture: !0,
        }));
  }
  var mb = 160,
    af = class {
      constructor(e) {
        y(this, 'scene3d');
        y(this, 'canvasElm');
        y(this, 'viewerElm');
        y(this, 'overlayElm');
        y(this, 'onEnter');
        y(this, 'onExit');
        y(this, 'isManualControl');
        y(this, 'config');
        y(this, 'controls', null);
        y(this, 'active', !1);
        y(this, 'enterTweens', []);
        y(this, 'viewOffsetApplied', !1);
        y(this, 'zoomValue', 0);
        y(this, 'zoomTrackElm', null);
        y(this, 'boxElm', null);
        y(this, 'resetTl', null);
        y(this, 'largeVh', 0);
        y(this, 'operableTimerId', 0);
        y(this, 'bind', () => {
          if (!this.viewerElm) return;
          (new IntersectionObserver(
            (t) => {
              t.forEach((i) => {
                i.intersectionRatio >= 0.5
                  ? this.enter()
                  : i.isIntersecting || this.exit();
              });
            },
            { root: null, threshold: [0, 0.5] },
          ).observe(this.viewerElm),
            (this.largeVh = __()),
            this.bindZoom(),
            this.bindReset(),
            this.bindOperableGate());
        });
        y(this, 'update', () => {
          this.active && this.controls && this.controls.update();
        });
        y(this, 'applyScrollFollow', () => {
          var a;
          if (!this.viewerElm) return !1;
          let e = window.innerWidth,
            t = window.innerHeight;
          if (t === 0) return !1;
          let i = this.viewerElm.getBoundingClientRect();
          if (i.bottom <= 0 || i.top >= t) return (this.clearViewOffset(), !1);
          let r = (
              (a = this.boxElm) != null ? a : this.viewerElm
            ).getBoundingClientRect(),
            o = r.top + r.height / 2 - t / 2 + (Xt() ? Qv : 0);
          return (
            this.scene3d.camera.setViewOffset(e, t, 0, -o, e, t),
            (this.viewOffsetApplied = !0),
            !0
          );
        });
        y(this, 'updateConfig', (e) => {
          ((this.config = e), this.active && this.applyZoom());
        });
        y(this, 'onResized', () => {
          ((this.largeVh = __()), this.active && this.applyZoom());
        });
        y(this, 'reapplyOwnership', () => {
          var r, o;
          if (!this.active) return;
          let { camera: e, baseCameraZ: t } = this.scene3d,
            i = this.config.viewer;
          this.applyViewerPose(i.pose);
          let n = new Pr().setFromVector3(e.position);
          ((n.radius = t * ((r = i.pose.camZ) != null ? r : 1)),
            e.position.setFromSpherical(n),
            e.up.set(0, 1, 0),
            e.lookAt(0, 0, 0),
            (o = this.controls) == null || o.target.set(0, 0, 0),
            this.applyZoom(),
            Et.set(this.canvasElm, { opacity: 1 }),
            this.scene3d.setReflectionVisible(!0),
            this.scene3d.invalidateReflection());
        });
        y(this, 'enter', () => {
          var n, r;
          if (
            this.active ||
            ((n = this.isManualControl) != null && n.call(this))
          )
            return;
          ((this.active = !0), this.onEnter());
          let { camera: e, baseCameraZ: t } = this.scene3d,
            i = this.config.viewer;
          (this.applyViewerPose(i.pose),
            e.position.set(0, 0, t * ((r = i.pose.camZ) != null ? r : 1)),
            e.up.set(0, 1, 0),
            e.lookAt(0, 0, 0),
            (this.zoomValue = 0),
            this.applyZoom(),
            this.updateZoomKnob(),
            this.setBoxHidden(!1),
            this.scene3d.setReflectionVisible(!0),
            this.scene3d.invalidateReflection(),
            (this.enterTweens = [
              Et.to(this.canvasElm, { opacity: 1, duration: i.enterDuration }),
            ]),
            this.setupControls());
        });
        y(this, 'exit', () => {
          var e;
          if (this.active) {
            if (
              ((this.active = !1),
              this.enterTweens.forEach((t) => t.kill()),
              (this.enterTweens = []),
              this.killResetTween(),
              this.controls &&
                (this.controls.dispose(), (this.controls = null)),
              this.canvasElm.classList.remove('is-interactive'),
              this.scene3d.setReflectionVisible(!1),
              !((e = this.isManualControl) != null && e.call(this)))
            ) {
              let { camera: t, baseCameraZ: i } = this.scene3d;
              (t.position.set(0, 0, i),
                t.rotation.set(0, 0, 0),
                t.up.set(0, 1, 0),
                this.scene3d.applyBaseZoom(),
                Et.set(this.canvasElm, { opacity: 0 }));
            }
            this.onExit();
          }
        });
        y(this, 'clearViewOffset', () => {
          this.viewOffsetApplied &&
            (this.scene3d.camera.clearViewOffset(),
            (this.viewOffsetApplied = !1));
        });
        y(this, 'bindOperableGate', () => {
          (window.addEventListener(
            'scroll',
            () => {
              Xt() &&
                (this.setOperable(!1),
                window.clearTimeout(this.operableTimerId),
                (this.operableTimerId = window.setTimeout(
                  this.updateOperable,
                  mb,
                )));
            },
            { passive: !0 },
          ),
            window.addEventListener('resize', () => {
              (window.clearTimeout(this.operableTimerId),
                (this.operableTimerId = window.setTimeout(
                  this.updateOperable,
                  mb,
                )));
            }),
            this.updateOperable());
        });
        y(this, 'updateOperable', () => {
          if (!this.overlayElm) return;
          if (!Xt()) {
            this.setOperable(!0);
            return;
          }
          let e = this.overlayElm.getBoundingClientRect(),
            t =
              e.top >= 0 &&
              e.left >= 0 &&
              e.bottom <= window.innerHeight &&
              e.right <= window.innerWidth;
          this.setOperable(t);
        });
        y(this, 'setOperable', (e) => {
          var t;
          (t = this.viewerElm) == null || t.classList.toggle('is-operable', e);
        });
        y(this, 'bindZoom', () => {
          var r, o;
          if (!this.viewerElm) return;
          let e = this.viewerElm,
            t = (a) => Ye(`[${a}]`, e),
            i = t(ct.viewerZoomTrack);
          if (((this.zoomTrackElm = i), i)) {
            let a = (l) => {
              let c = i.getBoundingClientRect();
              if (c.height === 0) return;
              let u = (l.clientY - c.top) / c.height;
              this.setZoomValue(1 - u);
            };
            (i.addEventListener('pointerdown', (l) => {
              (l.stopPropagation(),
                l.preventDefault(),
                i.setPointerCapture(l.pointerId),
                a(l));
            }),
              i.addEventListener('pointermove', (l) => {
                i.hasPointerCapture(l.pointerId) && a(l);
              }));
          }
          let n = (a) => (l) => {
            (l.stopPropagation(),
              l.preventDefault(),
              this.setZoomValue(this.zoomValue + a));
          };
          ((r = t(ct.viewerZoomIn)) == null ||
            r.addEventListener('pointerdown', n(0.15)),
            (o = t(ct.viewerZoomOut)) == null ||
              o.addEventListener('pointerdown', n(-0.15)),
            this.updateZoomKnob());
        });
        y(this, 'setZoomValue', (e) => {
          this.killResetTween();
          let t = Math.min(1, Math.max(0, e));
          (t !== this.zoomValue && this.setBoxHidden(!0),
            (this.zoomValue = t),
            this.applyZoom(),
            this.updateZoomKnob());
        });
        y(this, 'applyZoom', () => {
          let { min: e, max: t } = this.config.viewer.zoom,
            i = e + (t - e) * this.zoomValue,
            n = window.innerHeight || this.largeVh,
            r = this.largeVh > Ps ? Ps / this.largeVh : 1,
            o = this.largeVh && n ? (this.largeVh / n) * r : 1,
            a = Xt() ? Jd() : o,
            l = Xt() ? Math.min(as(), 1) : as();
          ((this.scene3d.camera.zoom = l * i * a),
            this.scene3d.camera.updateProjectionMatrix());
        });
        y(this, 'updateZoomKnob', () => {
          var e;
          (e = this.zoomTrackElm) == null ||
            e.style.setProperty('--zoom', String(this.zoomValue));
        });
        y(this, 'setupControls', () => {
          var i;
          let e = (i = this.overlayElm) != null ? i : this.canvasElm;
          this.canvasElm.classList.add('is-interactive');
          let t = new of(this.scene3d.camera, e);
          ((t.enablePan = !1),
            (t.enableRotate = !0),
            (t.enableZoom = !1),
            (t.autoRotate = !1),
            t.target.set(0, 0, 0),
            t.update(),
            t.addEventListener('change', this.onControlChange),
            (this.controls = t));
        });
        y(this, 'onControlChange', () => {
          this.setBoxHidden(!0);
        });
        y(this, 'bindReset', () => {
          if (!this.viewerElm) return;
          this.boxElm = Ye(`[${ct.viewerBox}]`, this.viewerElm);
          let e = Ye(`[${ct.viewerReset}]`, this.viewerElm);
          e == null ||
            e.addEventListener('click', (t) => {
              (t.preventDefault(), this.reset());
            });
        });
        y(this, 'setBoxHidden', (e) => {
          var t;
          (t = this.boxElm) == null || t.classList.toggle('is-hidden', e);
        });
        y(this, 'reset', () => {
          var a, l;
          if (!this.active) return;
          this.killResetTween();
          let { camera: e, baseCameraZ: t } = this.scene3d,
            i = this.config.viewer;
          (this.applyViewerPose(i.pose),
            (a = this.controls) == null || a.target.set(0, 0, 0));
          let n = new Pr().setFromVector3(e.position),
            r = () => {
              (e.position.setFromSpherical(n),
                e.up.set(0, 1, 0),
                e.lookAt(0, 0, 0));
            };
          this.controls && (this.controls.enabled = !1);
          let o = Et.timeline({
            defaults: { duration: i.resetDuration, ease: 'power2.inOut' },
            onComplete: () => {
              this.resetTl = null;
            },
          });
          (o.to(
            n,
            {
              radius: t * ((l = i.pose.camZ) != null ? l : 1),
              theta: 0,
              phi: Math.PI / 2,
              onUpdate: r,
            },
            0,
          ),
            o.to(
              this,
              {
                zoomValue: 0,
                onUpdate: () => {
                  (this.applyZoom(), this.updateZoomKnob());
                },
              },
              0,
            ),
            o.call(
              () => {
                var c;
                ((c = this.controls) == null || c.update(),
                  this.controls && (this.controls.enabled = !0));
              },
              void 0,
              i.resetDuration,
            ),
            o.call(
              () => this.setBoxHidden(!1),
              void 0,
              i.resetDuration + i.resetBoxDelay,
            ),
            (this.resetTl = o));
        });
        y(this, 'killResetTween', () => {
          this.resetTl &&
            (this.resetTl.kill(),
            (this.resetTl = null),
            this.controls && (this.controls.enabled = !0));
        });
        y(this, 'applyViewerPose', (e) => {
          var n, r, o, a, l, c, u;
          this.scene3d.spinGroup.rotation.y = 0;
          let { modelGroup: t } = this.scene3d,
            i = Vt.degToRad;
          (t.rotation.set(
            i((n = e.rx) != null ? n : 0),
            i((r = e.ry) != null ? r : 0),
            i((o = e.rz) != null ? o : 0),
          ),
            t.position.set(
              (a = e.px) != null ? a : 0,
              (l = e.py) != null ? l : 0,
              (c = e.pz) != null ? c : 0,
            ),
            t.scale.setScalar((u = e.scale) != null ? u : 1));
        });
        ((this.scene3d = e.scene3d),
          (this.canvasElm = e.canvasElm),
          (this.viewerElm = e.viewerElm),
          (this.overlayElm = e.overlayElm),
          (this.config = e.config),
          (this.onEnter = e.onEnter),
          (this.onExit = e.onExit),
          (this.isManualControl = e.isManualControl));
      }
      get isActive() {
        return this.active;
      }
    };
  var fo = `
varying vec2 vUv;
void main() {
  vUv = uv;
  gl_Position = vec4(position.xy, 0.0, 1.0);
}
`,
    ml = `
uniform sampler2D tDiffuse;
uniform vec2 uDir;
varying vec2 vUv;
void main() {
  vec4 sum = texture2D(tDiffuse, vUv) * 0.2270270270;
  vec2 o1 = uDir * 1.3846153846;
  vec2 o2 = uDir * 3.2307692308;
  sum += texture2D(tDiffuse, vUv + o1) * 0.3162162162;
  sum += texture2D(tDiffuse, vUv - o1) * 0.3162162162;
  sum += texture2D(tDiffuse, vUv + o2) * 0.0702702703;
  sum += texture2D(tDiffuse, vUv - o2) * 0.0702702703;
  gl_FragColor = sum;
}
`,
    ls = (s, e) =>
      new xn(Math.max(1, s), Math.max(1, e), {
        depthBuffer: !1,
        stencilBuffer: !1,
        colorSpace: zt,
      });
  var FC = `
uniform sampler2D tDiffuse;
uniform vec2 uCenter;
uniform vec2 uRadius;
uniform float uFeather;
varying vec2 vUv;
void main() {
  vec4 c = texture2D(tDiffuse, vUv);
  vec2 d = (vUv - uCenter) / uRadius;
  float r = length(d);
  float m = 1.0 - smoothstep(1.0 - uFeather, 1.0, r);
  gl_FragColor = vec4(c.rgb, c.a * m);
}
`,
    lf = class {
      constructor(e = 0.25, t = 3) {
        y(this, 'captureRT');
        y(this, 'rtA');
        y(this, 'rtB');
        y(this, 'quadScene', new Wn());
        y(this, 'quadCamera', new Ms());
        y(this, 'quad');
        y(this, 'blurMat');
        y(this, 'compositeMat');
        y(this, 'scale');
        y(this, 'iterations');
        y(this, 'prevClearColor', new je());
        y(this, 'setSize', (e, t) => {
          let i = Math.max(1, Math.round(e * this.scale)),
            n = Math.max(1, Math.round(t * this.scale));
          (this.captureRT.setSize(i, n),
            this.rtA.setSize(i, n),
            this.rtB.setSize(i, n));
        });
        y(this, 'capture', (e, t) => {
          let i = e.getClearColor(this.prevClearColor),
            n = e.getClearAlpha();
          (e.setRenderTarget(this.captureRT),
            e.setClearColor(0, 0),
            e.clear(),
            t());
          let r = this.rtA.width,
            o = this.rtA.height,
            a = this.captureRT.texture;
          for (let l = 0; l < this.iterations; l += 1)
            ((this.blurMat.uniforms.tDiffuse.value = a),
              this.blurMat.uniforms.uDir.value.set(1 / r, 0),
              e.setRenderTarget(this.rtA),
              e.clear(),
              e.render(this.quadScene, this.quadCamera),
              (this.blurMat.uniforms.tDiffuse.value = this.rtA.texture),
              this.blurMat.uniforms.uDir.value.set(0, 1 / o),
              e.setRenderTarget(this.rtB),
              e.clear(),
              e.render(this.quadScene, this.quadCamera),
              (a = this.rtB.texture));
          (e.setRenderTarget(null), e.setClearColor(i, n));
        });
        y(this, 'setMask', (e, t, i, n, r) => {
          let o = this.compositeMat.uniforms;
          (o.uCenter.value.set(e, t),
            o.uRadius.value.set(i, n),
            (o.uFeather.value = r));
        });
        y(this, 'composite', (e) => {
          ((this.compositeMat.uniforms.tDiffuse.value = this.rtB.texture),
            (this.quad.material = this.compositeMat));
          let t = e.autoClear;
          ((e.autoClear = !1),
            e.render(this.quadScene, this.quadCamera),
            (e.autoClear = t),
            (this.quad.material = this.blurMat));
        });
        ((this.scale = e),
          (this.iterations = t),
          (this.blurMat = new vi({
            uniforms: { tDiffuse: { value: null }, uDir: { value: new et() } },
            vertexShader: fo,
            fragmentShader: ml,
            depthTest: !1,
            depthWrite: !1,
          })),
          (this.compositeMat = new vi({
            uniforms: {
              tDiffuse: { value: null },
              uCenter: { value: new et(0.5, 0.35) },
              uRadius: { value: new et(0.2, 0.15) },
              uFeather: { value: 0.55 },
            },
            vertexShader: fo,
            fragmentShader: FC,
            transparent: !0,
            depthTest: !1,
            depthWrite: !1,
          })),
          (this.quad = new ri(new ss(2, 2), this.blurMat)),
          (this.quad.frustumCulled = !1),
          this.quadScene.add(this.quad),
          (this.captureRT = ls(1, 1)),
          (this.rtA = ls(1, 1)),
          (this.rtB = ls(1, 1)));
      }
    };
  var UC = `
uniform sampler2D tDiffuse;
uniform float uStrength;
varying vec2 vUv;
void main() {
  vec4 c = texture2D(tDiffuse, vUv);
  gl_FragColor = vec4(c.rgb * uStrength, c.a * uStrength);
}
`,
    cf = class {
      constructor(e = 0.25, t = 3) {
        y(this, 'isInitialized', !1);
        y(this, 'captureRT', null);
        y(this, 'rtA', null);
        y(this, 'rtB', null);
        y(this, 'quadScene', new Wn());
        y(this, 'quadCamera', new Ms());
        y(this, 'quad', null);
        y(this, 'blurMat', null);
        y(this, 'compositeMat', null);
        y(this, 'scale');
        y(this, 'iterations');
        y(this, 'width', 1);
        y(this, 'height', 1);
        y(this, 'prevClearColor', new je());
        y(this, 'setSize', (e, t) => {
          var r, o, a;
          if (((this.width = e), (this.height = t), !this.isInitialized))
            return;
          let i = Math.max(1, Math.round(e * this.scale)),
            n = Math.max(1, Math.round(t * this.scale));
          ((r = this.captureRT) == null || r.setSize(i, n),
            (o = this.rtA) == null || o.setSize(i, n),
            (a = this.rtB) == null || a.setSize(i, n));
        });
        y(this, 'capture', (e, t) => {
          if (
            (this.init(),
            !this.captureRT || !this.rtA || !this.rtB || !this.blurMat)
          )
            return;
          let i = e.getClearColor(this.prevClearColor),
            n = e.getClearAlpha();
          (e.setRenderTarget(this.captureRT),
            e.setClearColor(0, 0),
            e.clear(),
            t());
          let r = this.rtA.width,
            o = this.rtA.height,
            a = this.captureRT.texture;
          for (let l = 0; l < this.iterations; l += 1)
            ((this.blurMat.uniforms.tDiffuse.value = a),
              this.blurMat.uniforms.uDir.value.set(1 / r, 0),
              e.setRenderTarget(this.rtA),
              e.clear(),
              e.render(this.quadScene, this.quadCamera),
              (this.blurMat.uniforms.tDiffuse.value = this.rtA.texture),
              this.blurMat.uniforms.uDir.value.set(0, 1 / o),
              e.setRenderTarget(this.rtB),
              e.clear(),
              e.render(this.quadScene, this.quadCamera),
              (a = this.rtB.texture));
          (e.setRenderTarget(null), e.setClearColor(i, n));
        });
        y(this, 'composite', (e, t) => {
          if (!this.quad || !this.blurMat || !this.compositeMat || !this.rtB)
            return;
          ((this.compositeMat.uniforms.tDiffuse.value = this.rtB.texture),
            (this.compositeMat.uniforms.uStrength.value = t),
            (this.quad.material = this.compositeMat));
          let i = e.autoClear;
          ((e.autoClear = !1),
            e.render(this.quadScene, this.quadCamera),
            (e.autoClear = i),
            (this.quad.material = this.blurMat));
        });
        y(this, 'init', () => {
          this.isInitialized ||
            ((this.isInitialized = !0),
            this.createMaterials(),
            this.createQuad(),
            this.createRenderTargets());
        });
        y(this, 'createMaterials', () => {
          ((this.blurMat = new vi({
            uniforms: { tDiffuse: { value: null }, uDir: { value: new et() } },
            vertexShader: fo,
            fragmentShader: ml,
            depthTest: !1,
            depthWrite: !1,
          })),
            (this.compositeMat = new vi({
              uniforms: { tDiffuse: { value: null }, uStrength: { value: 1 } },
              vertexShader: fo,
              fragmentShader: UC,
              transparent: !0,
              blending: Fc,
              depthTest: !1,
              depthWrite: !1,
            })));
        });
        y(this, 'createQuad', () => {
          this.blurMat &&
            ((this.quad = new ri(new ss(2, 2), this.blurMat)),
            (this.quad.frustumCulled = !1),
            this.quadScene.add(this.quad));
        });
        y(this, 'createRenderTargets', () => {
          let e = Math.max(1, Math.round(this.width * this.scale)),
            t = Math.max(1, Math.round(this.height * this.scale));
          ((this.captureRT = ls(e, t)),
            (this.rtA = ls(e, t)),
            (this.rtB = ls(e, t)));
        });
        ((this.scale = e), (this.iterations = t));
      }
    };
  var gb = 0.01,
    BC = `
varying vec2 vUv;
void main() {
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`,
    kC = `
uniform sampler2D tShadow;
uniform vec2 uResolution;
uniform vec2 uAnchor;
uniform vec2 uShadowOffset;
uniform float uShadowSquash;
uniform float uShadowStrength;
uniform vec3 uColor;
uniform float uStrength;
uniform float uEllipse;
uniform float uBottomFade;
uniform float uOpacity;
varying vec2 vUv;
void main() {
  // \u5149\u3060\u307E\u308A: quad \u4E2D\u5FC3\u304B\u3089\u306E\u653E\u5C04\u30D5\u30A9\u30FC\u30EB\u30AA\u30D5\uFF08\u4E2D\u5FC3 1 \u2192 \u7AEF 0\uFF09\u3002uEllipse \u3067\u7E26\u306E\u5E83\u304C\u308A\u3060\u3051\u3092\u8ABF\u6574\u3059\u308B
  vec2 d = (vUv - 0.5) * 2.0;
  d.y /= max(uEllipse, 0.001);
  float pool = 1.0 - smoothstep(0.0, 1.0, length(d));
  // \u4E0B\u7AEF\u30D5\u30A7\u30FC\u30C9: quad \u4E0B\u90E8\uFF08uv.y < uBottomFade\uFF09\u3092\u8FFD\u52A0\u3067\u6E1B\u8870\u3055\u305B\u308B\u3002\u5149\u3060\u307E\u308A\u306E\u4E0B\u7AEF\u304C
  // led \u533A\u9593\u306E\u5916\u3078\u306F\u307F\u51FA\u3059\u3068\u3001\u5F8C\u7D9A\u30BB\u30AF\u30B7\u30E7\u30F3\uFF08movie \u306E\u660E\u80CC\u666F\uFF09\u304C canvas \u3088\u308A\u524D\u9762\u3067
  // \u76F4\u7DDA\u306B\u8986\u3044\u300C\u6298\u308C\u30FB\u3081\u308A\u8FBC\u307F\u300D\u306B\u898B\u3048\u308B\u305F\u3081\u3001\u7D99\u304E\u76EE\u306B\u5C4A\u304F\u524D\u306B\u5149\u3092 0 \u3078\u843D\u3068\u3059
  pool *= smoothstep(0.0, max(uBottomFade, 0.001), vUv.y);
  // \u63A5\u5730\u5F71: \u30A2\u30F3\u30AB\u30FC\uFF08\u30E2\u30C7\u30EB\u4E0B\u7AEF + uShadowOffset\uFF09\u3088\u308A\u4E0B\u306E\u30D5\u30E9\u30B0\u30E1\u30F3\u30C8\u304C\u3001\u30E2\u30C7\u30EB\u4E0B\u7AEF\u304B\u3089\u4E0A\u306E
  // \u30B7\u30EB\u30A8\u30C3\u30C8\u3092 1/uShadowSquash \u500D\u3067\u8AAD\u3080\uFF1D\u7E26\u306B\u6F70\u308C\u305F\u93E1\u6620\uFF08\u5358\u4E00\u30D6\u30ED\u30D6\uFF09\u3002
  // \u30A2\u30F3\u30AB\u30FC\u306E\u6298\u308A\u76EE\u306F\u30D5\u30A7\u30B6\u30FC\uFF08band\uFF09\u3067\u6ED1\u3089\u304B\u306B 0 \u3078\u843D\u3068\u3059: \u786C\u3044\u6C34\u5E73\u7DDA\u304C\u51FA\u306A\u3044
  // \uFF08\u4E0A\u4E0B\u5BFE\u79F0\u306E\u93E1\u6620\u3060\u3068\u9732\u51FA\u6642\u306B\u5F71\u304C 2 \u3064\u306B\u898B\u3048\u3001\u30D5\u30A7\u30B6\u30FC\u7121\u3057\u3060\u3068\u6298\u308C\u7DDA\u304C\u898B\u3048\u308B\uFF1D\u3069\u3061\u3089\u3082\u5B9F\u6A5F\u3067\u78BA\u8A8D\uFF09\u3002
  // \u26A0 suv.y \u306E\u57FA\u6E96\u306F\u610F\u56F3\u7684\u306B uAnchor.y\uFF08= \u30B7\u30EB\u30A8\u30C3\u30C8\u306E\u5B9F\u4E0B\u7AEF\uFF09\u306E\u307E\u307E: anchor.y\uFF08\u30AA\u30D5\u30BB\u30C3\u30C8\u8FBC\u307F\uFF09\u306B
  // \u3059\u308B\u3068 uShadowOffset \u3067\u300C\u5F71\u306E\u4F4D\u7F6E\u300D\u3067\u306F\u306A\u304F\u300C\u5207\u308A\u51FA\u3057\u7A93\u300D\u304C\u305A\u308C\u3066\u5F62\u304C\u5909\u308F\u3063\u3066\u3057\u307E\u3046
  // \uFF08uShadowOffset \u306F\u914D\u7F6E\u306E\u79FB\u52D5\u30FBuAnchor \u306F\u30C6\u30AF\u30B9\u30C1\u30E3\u5185\u5BB9\u306E\u57FA\u6E96\u3001\u3068\u5F79\u5272\u3092\u5206\u96E2\u3057\u3066\u3044\u308B\uFF09
  vec2 anchor = uAnchor + uShadowOffset;
  vec2 rel = gl_FragCoord.xy / uResolution - anchor;
  vec2 suv = vec2(anchor.x + rel.x, uAnchor.y - rel.y / max(uShadowSquash, 0.001));
  float band = 1.0 - smoothstep(-0.025, 0.0, rel.y);
  float shadow = texture2D(tShadow, suv).a * uShadowStrength * band;
  float alpha = pool * uStrength * (1.0 - shadow) * uOpacity;
  gl_FragColor = vec4(uColor, clamp(alpha, 0.0, 1.0));
}
`,
    hf = class {
      constructor(e, t) {
        y(this, 'isInitialized', !1);
        y(this, 'captureRT', null);
        y(this, 'rtA', null);
        y(this, 'rtB', null);
        y(this, 'blurScene', new Wn());
        y(this, 'blurCamera', new Ms());
        y(this, 'blurQuad', null);
        y(this, 'blurMat', null);
        y(this, 'quad', null);
        y(this, 'spotMat', null);
        y(this, 'silhouetteMat', null);
        y(this, 'scene');
        y(this, 'config');
        y(this, 'fadeState', { value: 0 });
        y(this, 'fadeTween', null);
        y(this, 'width', 1);
        y(this, 'height', 1);
        y(this, 'drawingBufferSize', new et());
        y(this, 'scratch', new te());
        y(this, 'prevClearColor', new je());
        y(this, 'fade', (e, t) => {
          var n;
          if (!e && !this.isInitialized) return;
          this.init();
          let i = e ? 1 : 0;
          if (
            ((n = this.fadeTween) == null || n.kill(),
            (this.fadeTween = null),
            t <= 0)
          ) {
            ((this.fadeState.value = i), this.applyFade());
            return;
          }
          this.fadeTween = Et.to(this.fadeState, {
            value: i,
            duration: t,
            ease: 'power2.out',
            onUpdate: this.applyFade,
          });
        });
        y(this, 'setSize', (e, t) => {
          ((this.width = e), (this.height = t), this.resizeRenderTargets());
        });
        y(this, 'applyConfig', (e) => {
          if (((this.config = e), this.spotMat)) {
            let t = this.spotMat.uniforms;
            (t.uColor.value.setHex(e.color, zt),
              (t.uStrength.value = e.strength),
              (t.uEllipse.value = e.ellipse),
              (t.uBottomFade.value = e.bottomFade),
              t.uShadowOffset.value.set(e.shadowOffset[0], e.shadowOffset[1]),
              (t.uShadowSquash.value = e.shadowSquash),
              (t.uShadowStrength.value = e.shadowStrength));
          }
          this.resizeRenderTargets();
        });
        y(this, 'follow', (e, t, i, n) => {
          if (!this.quad || !this.spotMat) return;
          let r = this.config,
            o = Math.max(1e-6, t.position.z - e.z),
            a = Math.max(0.001, (o - r.offsetZ) / o);
          (this.quad.position.set(
            e.x + r.offsetX * a,
            e.y + r.offsetY * a,
            e.z + r.offsetZ,
          ),
            this.quad.scale.set(r.width * a, r.height * a, 1),
            this.scratch.set(n.x, n.y - i, n.z),
            this.scratch.project(t),
            this.spotMat.uniforms.uAnchor.value.set(
              (this.scratch.x + 1) / 2,
              (this.scratch.y + 1) / 2,
            ));
        });
        y(this, 'capture', (e, t) => {
          if (
            !this.captureRT ||
            !this.rtA ||
            !this.rtB ||
            !this.blurMat ||
            !this.quad ||
            !this.spotMat ||
            !this.silhouetteMat
          )
            return;
          let i = e.getClearColor(this.prevClearColor),
            n = e.getClearAlpha(),
            r = this.scene.overrideMaterial,
            o = this.quad.visible;
          this.quad.visible = !1;
          try {
            ((this.scene.overrideMaterial = this.silhouetteMat),
              e.setRenderTarget(this.captureRT),
              e.setClearColor(0, 0),
              e.clear(),
              e.render(this.scene, t));
          } finally {
            ((this.scene.overrideMaterial = r), (this.quad.visible = o));
          }
          let a = this.rtA.width,
            l = this.rtA.height,
            c = this.captureRT.texture;
          for (let u = 0; u < this.config.blurIterations; u += 1)
            ((this.blurMat.uniforms.tDiffuse.value = c),
              this.blurMat.uniforms.uDir.value.set(1 / a, 0),
              e.setRenderTarget(this.rtA),
              e.clear(),
              e.render(this.blurScene, this.blurCamera),
              (this.blurMat.uniforms.tDiffuse.value = this.rtA.texture),
              this.blurMat.uniforms.uDir.value.set(0, 1 / l),
              e.setRenderTarget(this.rtB),
              e.clear(),
              e.render(this.blurScene, this.blurCamera),
              (c = this.rtB.texture));
          (e.setRenderTarget(null),
            e.setClearColor(i, n),
            e.getDrawingBufferSize(this.drawingBufferSize),
            (this.spotMat.uniforms.tShadow.value = this.rtB.texture),
            this.spotMat.uniforms.uResolution.value.copy(
              this.drawingBufferSize,
            ));
        });
        y(this, 'init', () => {
          this.isInitialized ||
            ((this.isInitialized = !0),
            this.createMaterials(),
            this.createQuads(),
            this.createRenderTargets(),
            this.applyConfig(this.config),
            this.applyFade());
        });
        y(this, 'createMaterials', () => {
          ((this.blurMat = new vi({
            uniforms: { tDiffuse: { value: null }, uDir: { value: new et() } },
            vertexShader: fo,
            fragmentShader: ml,
            depthTest: !1,
            depthWrite: !1,
          })),
            (this.spotMat = new vi({
              uniforms: {
                tShadow: { value: null },
                uResolution: { value: new et(1, 1) },
                uAnchor: { value: new et() },
                uShadowOffset: { value: new et() },
                uShadowSquash: { value: 1 },
                uShadowStrength: { value: 0 },
                uColor: { value: new je(16777215) },
                uStrength: { value: 0 },
                uEllipse: { value: 1 },
                uBottomFade: { value: 0 },
                uOpacity: { value: 0 },
              },
              vertexShader: BC,
              fragmentShader: kC,
              transparent: !0,
              depthWrite: !1,
            })),
            (this.silhouetteMat = new rn({ color: 0 })));
        });
        y(this, 'createQuads', () => {
          !this.blurMat ||
            !this.spotMat ||
            ((this.blurQuad = new ri(new ss(2, 2), this.blurMat)),
            (this.blurQuad.frustumCulled = !1),
            this.blurScene.add(this.blurQuad),
            (this.quad = new ri(new ss(1, 1), this.spotMat)),
            (this.quad.renderOrder = -1),
            (this.quad.visible = !1),
            this.scene.add(this.quad));
        });
        y(this, 'createRenderTargets', () => {
          let [e, t] = this.resolveRTSize();
          ((this.captureRT = ls(e, t)),
            (this.rtA = ls(e, t)),
            (this.rtB = ls(e, t)));
        });
        y(this, 'resizeRenderTargets', () => {
          if (!this.captureRT || !this.rtA || !this.rtB) return;
          let [e, t] = this.resolveRTSize();
          (this.captureRT.setSize(e, t),
            this.rtA.setSize(e, t),
            this.rtB.setSize(e, t));
        });
        y(this, 'resolveRTSize', () => {
          let e = Math.max(1, Math.round(this.config.resolution)),
            t = Math.max(
              1,
              Math.round((e * this.height) / Math.max(1, this.width)),
            );
          return [e, t];
        });
        y(this, 'applyFade', () => {
          !this.spotMat ||
            !this.quad ||
            ((this.spotMat.uniforms.uOpacity.value = this.fadeState.value),
            (this.quad.visible = this.fadeState.value > gb));
        });
        ((this.scene = e), (this.config = t));
      }
      get isActive() {
        return this.isInitialized && this.fadeState.value > gb;
      }
    };
  var _b = 160,
    HC = (s, e) => {
      if (!s) return 0;
      if (s.includes('center')) return e * 0.5;
      let t = /top (\d+)%/.exec(s);
      return t ? (Number(t[1]) / 100) * e : 0;
    },
    uf = class {
      constructor() {
        y(this, 'modelReady');
        y(this, 'introScrollLock', null);
        y(this, 'canvasElm');
        y(this, 'viewerElm');
        y(this, 'overlayElm');
        y(this, 'renderer', null);
        y(this, 'scene3d', null);
        y(this, 'choreography', null);
        y(this, 'viewer', null);
        y(this, 'poseDebugger', null);
        y(this, 'pmrem', null);
        y(this, 'envFrame', 0);
        y(this, 'reflectionBlur', null);
        y(this, 'ledGlow', null);
        y(this, 'ledSpotlight', null);
        y(this, 'ledSpotlightAnchor', new te());
        y(this, 'ledSpotlightGeneratorEl', null);
        y(this, 'cursorTilt', null);
        y(this, 'isPoseDebug', !1);
        y(this, 'isPoseProbe', !1);
        y(this, 'poseProbe', null);
        y(this, 'config', ec(Xt()));
        y(this, 'rafId', 0);
        y(this, 'isInitialized', !1);
        y(this, 'resolveModelReady');
        y(this, 'isInViewSet', new Set());
        y(this, 'scrollAwayEls', []);
        y(this, 'ledGeneratorElm', null);
        y(this, 'bluetoothTextElm', null);
        y(this, 'bluetoothSectionElm', null);
        y(this, 'bluetoothDepartLineYCache', null);
        y(this, 'ctaContentsElm', null);
        y(this, 'ctaDepartLineYCache', null);
        y(this, 'introArmed', !1);
        y(this, 'liteIntroArmed', !1);
        y(this, 'introPlaying', !1);
        y(this, 'loadingDismissed', !1);
        y(this, 'topTitleElm', null);
        y(this, 'viewerBaseAmbientIntensity', null);
        y(this, 'sceneSectionElm', null);
        y(this, 'playbackSectionElm', null);
        y(this, 'manualControl', !1);
        y(this, 'departedScrollAwayEls', new Set());
        y(this, 'ledPyDesign', 0);
        y(this, 'bluetoothPyDesign');
        y(this, 'soniclinkPyDesign');
        y(this, 'soniclinkCamZDesign');
        y(this, 'desyncLastScrollY', window.scrollY);
        y(this, 'desyncSettledAt', performance.now());
        y(this, 'desyncSawTail', !1);
        y(this, 'desyncBoundaryResynced', !1);
        y(this, 'holdFrameForResync', !1);
        y(this, 'onResized', (e = !1) => {
          var a, l, c, u, f, d;
          if (!this.renderer || !this.scene3d) return;
          let t = window.innerWidth,
            i = window.innerHeight;
          (this.renderer.setPixelRatio(
            Math.min(window.devicePixelRatio, this.config.maxPixelRatio),
          ),
            this.renderer.setSize(t, i, !1),
            this.scene3d.onResize(t, i),
            (a = this.reflectionBlur) == null || a.setSize(t, i),
            (l = this.ledGlow) == null || l.setSize(t, i),
            (c = this.ledSpotlight) == null || c.setSize(t, i),
            this.scene3d.invalidateReflection(),
            (u = this.viewer) != null && u.isActive
              ? this.viewer.onResized()
              : this.scene3d.applyBaseZoom());
          let n = this.applyLedViewportPy(),
            r = this.applyBluetoothViewportPy(),
            o = this.applySoniclinkViewportPy();
          (this.refreshBluetoothDepartLine(),
            this.refreshCtaDepartLine(),
            !e &&
              (n ||
                r ||
                o ||
                ((f = this.choreography) != null && f.isFitStale())) &&
              !((d = this.viewer) != null && d.isActive) &&
              !this.manualControl &&
              this.resyncChoreography());
        });
        y(this, 'onLoadingDismissed', () => {
          var e, t, i;
          ((this.loadingDismissed = !0), Je.refresh());
          try {
            if (this.playIntroEntrance() || this.playLiteIntro()) return;
          } catch (n) {
            ((this.introPlaying = !1),
              (e = this.introScrollLock) == null || e.start());
          }
          (this.revealTopTitle(),
            (t = this.cursorTilt) == null || t.start(),
            this.choreography &&
              !((i = this.viewer) != null && i.isActive) &&
              !this.manualControl &&
              this.resyncChoreography());
        });
        y(this, 'setLedColor', (e, t = !1) => {
          var i;
          (i = this.scene3d) == null ||
            i.setLedColor(e, t ? this.config.ledMaterial.fadeDuration : 0, !0);
        });
        y(this, 'setLedSpotlight', (e) => {
          var t;
          (t = this.ledSpotlight) == null ||
            t.fade(e, this.config.ledMaterial.fadeDuration);
        });
        y(this, 'applyIntroEntranceStart', () => {
          if (hdjf9Story) return false;
          var L, R, U, O;
          if (
            !this.scene3d ||
            this.manualControl ||
            window.scrollY > window.innerHeight * 0.5
          )
            return !1;
          let e = window.innerHeight;
          if (e === 0) return !1;
          let { camera: t, baseCameraZ: i, modelGroup: n } = this.scene3d;
          if (Yh()) {
            (this.canvasElm && Et.set(this.canvasElm, { opacity: 0 }),
              (n.position.y =
                ((L = this.config.initial.pose.py) != null ? L : 0) -
                Ws.riseWorld));
            {
              let N = this.config.initial.pose,
                M = Vt.degToRad;
              ((n.rotation.x = M(
                ((R = N.rx) != null ? R : 0) + Ws.startRxOffset,
              )),
                (n.rotation.y = M(
                  ((U = N.ry) != null ? U : 0) + Ws.startRyOffset,
                )));
            }
            return ((this.liteIntroArmed = !0), !1);
          }
          let { startPose: r, offscreenMarginPx: o } = mr,
            a = this.config.initial.fitHeight,
            l = (O = this.config.initial.pose.camZ) != null ? O : 1,
            c = a ? Is(l, a) : l,
            u = a ? pl(a, c, e) : e,
            f = Ls(t.fov, i, c),
            d = e / 2 + (u * r.scale) / 2 + o,
            p = Vt.degToRad;
          (n.rotation.set(p(r.rx), p(r.ry), p(r.rz)),
            (this.scene3d.spinGroup.rotation.y = 0),
            n.scale.setScalar(r.scale),
            (n.position.y = -(d / e) * f));
          let {
            ambient: _,
            directional: x,
            accentLight1: g,
            accentLight2: v,
            accentLight3: w,
          } = this.scene3d;
          return (
            (_.intensity = 0),
            (x.intensity = 0),
            (g.intensity = 0),
            (v.intensity = 0),
            (w.intensity = 0),
            this.scene3d.setEnvHold(!0),
            this.scene3d.setLedColor('rgb(0, 0, 0)', 0),
            !0
          );
        });
        y(this, 'applyIntroLightsOn', (e, t = !0) => {
          if (!this.scene3d) return;
          let { lights: i } = this.config,
            n = this.scene3d;
          ([
            [n.ambient, i.ambientIntensity],
            [n.directional, i.directionalIntensity],
            [n.accentLight1, i.accent1.intensity],
            [n.accentLight2, i.accent2.intensity],
            [n.accentLight3, i.accent3.intensity],
          ].forEach(([o, a]) => {
            if (e > 0)
              Et.to(o, { intensity: a, duration: e, ease: 'power1.inOut' });
            else {
              let l = o;
              l.intensity = a;
            }
          }),
            n.setEnvHold(!1),
            t && n.setLedColor(null, e));
        });
        y(this, 'applyViewerLightBoost', (e) => {
          let t = this.scene3d;
          if (t)
            if (e) {
              if (this.viewerBaseAmbientIntensity !== null) return;
              ((this.viewerBaseAmbientIntensity = t.ambient.intensity),
                (t.ambient.intensity = this.config.viewer.ambientIntensity));
            } else {
              if (this.viewerBaseAmbientIntensity === null) return;
              ((t.ambient.intensity = this.viewerBaseAmbientIntensity),
                (this.viewerBaseAmbientIntensity = null));
            }
        });
        y(this, 'playLiteIntro', () => {
          var r, o, a, l, c, u, f;
          if (
            !this.liteIntroArmed ||
            this.introPlaying ||
            ((this.liteIntroArmed = !1),
            !this.scene3d || !this.choreography || !this.canvasElm)
          )
            return !1;
          if (
            ((r = this.viewer) != null && r.isActive) ||
            this.manualControl ||
            window.scrollY > window.innerHeight * 0.5
          )
            return (
              (o = this.viewer) != null && o.isActive
                ? Et.set(this.canvasElm, {
                    opacity: this.config.initial.opacity,
                  })
                : this.choreography.applyInitial(this.config),
              !1
            );
          (this.applyIntroEntranceStart(),
            (this.liteIntroArmed = !1),
            (this.scene3d.spinGroup.rotation.y = Vt.degToRad(
              (a = this.config.initial.spinY) != null ? a : 0,
            )));
          let { modelGroup: e } = this.scene3d,
            t = this.config.initial.pose,
            i = (l = t.py) != null ? l : 0;
          ((this.introPlaying = !0),
            this.choreography.disable(),
            (c = this.introScrollLock) == null || c.stop(),
            (hdjf9Story || document.body).classList.remove(tc),
            this.revealTopTitle());
          let n = Et.timeline({
            onComplete: () => {
              var d, p;
              ((this.introPlaying = !1),
                this.resyncChoreography(),
                (d = this.introScrollLock) == null || d.start(),
                (p = this.cursorTilt) == null || p.start());
            },
          });
          return (
            n.to(
              this.canvasElm,
              {
                opacity: this.config.initial.opacity,
                duration: Ws.duration,
                ease: Ws.ease,
              },
              0,
            ),
            n.to(e.position, { y: i, duration: Ws.duration, ease: Ws.ease }, 0),
            n.to(
              e.rotation,
              {
                x: Vt.degToRad((u = t.rx) != null ? u : 0),
                y: Vt.degToRad((f = t.ry) != null ? f : 0),
                duration: Ws.duration,
                ease: Ws.ease,
              },
              0,
            ),
            !0
          );
        });
        y(this, 'playIntroEntrance', () => {
          var g, v, w, L, R, U, O, N, M, I, z;
          if (
            !this.introArmed ||
            this.introPlaying ||
            ((this.introArmed = !1), !this.scene3d || !this.choreography)
          )
            return !1;
          if (
            ((g = this.viewer) != null && g.isActive) ||
            this.manualControl ||
            window.scrollY > window.innerHeight * 0.5
          )
            return (
              ((v = this.viewer) != null && v.isActive) ||
                this.choreography.applyInitial(this.config),
              this.applyIntroLightsOn(0),
              !1
            );
          this.applyIntroEntranceStart();
          let { scene3d: e } = this,
            { modelGroup: t } = e,
            i = this.config.initial.pose,
            n = Vt.degToRad,
            {
              risePy: r,
              riseDuration: o,
              riseEase: a,
              settleDelay: l,
              settleDuration: c,
              settleEase: u,
              ledColor: f,
              ledOnFade: d,
              ledOffFade: p,
              lightsOnFade: _,
            } = mr;
          try {
            window.sessionStorage.setItem(rm, '1');
          } catch (W) {}
          ((this.introPlaying = !0),
            this.choreography.disable(),
            (w = this.introScrollLock) == null || w.stop());
          let x = Et.timeline({
            onComplete: () => {
              var W, q;
              ((this.introPlaying = !1),
                this.resyncChoreography(),
                (W = this.introScrollLock) == null || W.start(),
                (q = this.cursorTilt) == null || q.start());
            },
          });
          return (
            x.to(t.position, { y: r, duration: o, ease: a }),
            x.call(
              () => e.setLedColor(f, d),
              void 0,
              Math.max(0, o - mr.ledOnLead),
            ),
            x.addLabel('settle', Math.max(0, o + l)),
            x.call(() => this.applyIntroLightsOn(_, !1), void 0, 'settle'),
            x.call(
              () => e.fadeLedEmissiveOut(p),
              void 0,
              `settle+=${mr.ledOffDelay}`,
            ),
            x.call(
              () => e.setLedColor(null, mr.ledRestoreFade),
              void 0,
              `settle+=${mr.ledOffDelay + p}`,
            ),
            x.to(
              t.rotation,
              {
                x: n((L = i.rx) != null ? L : 0),
                y: n((R = i.ry) != null ? R : 0),
                z: n((U = i.rz) != null ? U : 0),
                duration: c,
                ease: u,
              },
              'settle',
            ),
            x.to(
              e.spinGroup.rotation,
              {
                y: n((O = this.config.initial.spinY) != null ? O : 0),
                duration: c,
                ease: u,
              },
              'settle',
            ),
            x.to(
              t.scale,
              {
                x: (N = i.scale) != null ? N : 1,
                y: (M = i.scale) != null ? M : 1,
                z: (I = i.scale) != null ? I : 1,
                duration: c,
                ease: u,
              },
              'settle',
            ),
            x.to(
              t.position,
              { y: (z = i.py) != null ? z : 0, duration: c, ease: u },
              'settle',
            ),
            x.call(
              this.revealTopTitle,
              void 0,
              `settle+=${Math.max(0, c - mr.titleRevealLead)}`,
            ),
            !0
          );
        });
        y(this, 'revealTopTitle', () => {
          window.setTimeout(() => {
            (hdjf9Story || document.body).classList.remove(tc);
          }, mr.introHoldReleaseDelay * 1e3);
          let e = this.topTitleElm;
          if (!e) return;
          e.classList.add(wt.inview);
          let t = Ye(ct.topSection);
          t &&
            t.getBoundingClientRect().top < window.innerHeight * om &&
            e.classList.add(wt.leaveBack);
        });
        y(this, 'observeTopTitleLeave', () => {
          let e = this.topTitleElm;
          if (!e) return;
          let t = (n) => {
            (n &&
              !(
                e.classList.contains(wt.inview) &&
                !e.classList.contains(wt.leave)
              )) ||
              e.classList.toggle(wt.leaveBack, n);
          };
          Je.create(
            pt(
              {
                trigger: ct.topSection,
                start: Jv,
                onEnter: () => t(!0),
                onLeaveBack: () => t(!1),
              },
              ks(e, 'title-leave'),
            ),
          );
          let i = Je.create(
            pt(
              {
                trigger: ct.topSection,
                start: 'top bottom',
                end: 'bottom top',
                onToggle: (n) => e.classList.toggle(wt.offstage, !n.isActive),
              },
              ks(e, 'offstage'),
            ),
          );
          e.classList.toggle(wt.offstage, !i.isActive);
        });
        y(this, 'resyncChoreography', () => {
          this.choreography &&
            (this.introPlaying ||
              ((this.holdFrameForResync = !0),
              this.choreography.resync(this.config, () => {
                this.holdFrameForResync = !1;
              }),
              this.resetDesyncState()));
        });
        y(this, 'resetDesyncState', () => {
          ((this.desyncSawTail = !1),
            (this.desyncSettledAt = performance.now()),
            (this.desyncLastScrollY = window.scrollY));
        });
        y(this, 'applyLedViewportPy', () => {
          var n, r;
          let { led: e } = this.config.steps;
          if (!this.scene3d || !(e != null && e.pose) || !e.fitHeight)
            return !1;
          let t = window.innerHeight,
            i = this.ledPyDesign;
          if (!Xt() && t > Ps) {
            let { camera: o, baseCameraZ: a } = this.scene3d,
              l = Math.tan(Vt.degToRad(o.fov) / 2),
              c = (n = e.pose.camZ) != null ? n : 1,
              u = 2 * a * c * l,
              f = (-this.ledPyDesign / u) * Ps,
              d = Ps / 2 - f,
              p = Is(c, e.fitHeight),
              _ = Ls(o.fov, a, p),
              g = -((t / 2 - d * as()) / t) * _;
            i = Math.min(this.ledPyDesign, g);
          }
          return Math.abs(
            i - ((r = e.pose.py) != null ? r : this.ledPyDesign),
          ) < 1e-4
            ? !1
            : ((e.pose.py = i), !0);
        });
        y(this, 'applyBluetoothViewportPy', () => {
          var l, c, u;
          let e = this.config.steps.bluetooth,
            t = this.bluetoothPyDesign;
          if (
            !this.scene3d ||
            !(e != null && e.pose) ||
            !e.fitHeight ||
            t === void 0
          )
            return !1;
          let i = t,
            n = window.innerHeight,
            { camera: r, baseCameraZ: o } = this.scene3d,
            a = e.fitHeight;
          if (Xt() && n > 0) {
            let f = Is((l = e.pose.camZ) != null ? l : 1, a),
              d = pl(a, f, n),
              p = Ls(r.fov, o, f),
              x = -((n / 2 - ex - d / 2) / n) * p;
            i = Math.max(t, x);
          } else if (!Xt() && n > Ps) {
            let f = Math.tan(Vt.degToRad(r.fov) / 2),
              d = (c = e.pose.camZ) != null ? c : 1,
              p = 2 * o * d * f,
              _ = (-t / p) * Ps,
              x = Ps / 2 - _,
              g = Is(d, a),
              v = Ls(r.fov, o, g),
              L = -((n / 2 - x * as()) / n) * v;
            i = Math.min(t, L);
          }
          return Math.abs(i - ((u = e.pose.py) != null ? u : t)) < 1e-4
            ? !1
            : ((e.pose.py = i), !0);
        });
        y(this, 'applySoniclinkViewportPy', () => {
          var a, l, c, u, f, d;
          let e = this.config.steps.soniclink,
            t = this.soniclinkPyDesign,
            i = this.soniclinkCamZDesign;
          if (
            !this.scene3d ||
            !(e != null && e.pose) ||
            t === void 0 ||
            i === void 0
          )
            return !1;
          let n = t,
            r = i,
            o = window.innerHeight;
          if (Xt() && o > 0) {
            let p = this.scene3d,
              { camera: _, baseCameraZ: x } = p,
              { pose: g } = e,
              w = new yt().makeRotationFromEuler(
                new Ts(
                  Vt.degToRad((a = g.rx) != null ? a : 0),
                  Vt.degToRad((l = g.ry) != null ? l : 0),
                  Vt.degToRad((c = g.rz) != null ? c : 0),
                ),
              ).elements,
              L =
                (p.modelHalfWidth * Math.abs(w[1]) +
                  p.modelHalfHeight * Math.abs(w[5]) +
                  p.modelHalfDepth * Math.abs(w[9])) *
                ((u = g.scale) != null ? u : 1),
              R = Ls(_.fov, x, i),
              U = ((L * 2) / R) * o,
              O = (t / R) * o,
              N = o / 2 - O - U / 2,
              M = tx * as(),
              I = Math.max(0, -N) / U;
            if (N < M && I < ix) {
              let W = o / 2 - O + U / 2 - M;
              if (W > 0) {
                r = i * (U / W);
                let q = Ls(_.fov, x, r);
                n = ((o / 2 - M - W / 2) / o) * q;
              }
            }
          }
          return Math.abs(n - ((f = e.pose.py) != null ? f : t)) < 1e-4 &&
            Math.abs(r - ((d = e.pose.camZ) != null ? d : i)) < 1e-4
            ? !1
            : ((e.pose.py = n),
              (e.pose.camZ = r),
              e.poseFrom && (e.poseFrom.camZ = r),
              !0);
        });
        y(this, 'init', () => {
          if (!this.canvasElm) {
            this.resolveModelReady();
            return;
          }
          let e = ct.inViewRoots
              .map((i) => document.querySelector(i))
              .filter((i) => i !== null),
            t = new IntersectionObserver(this.onIntersect, {
              root: null,
              rootMargin: '200px 0px',
              threshold: 0,
            });
          (e.forEach((i) => t.observe(i)),
            document.addEventListener('visibilitychange', this.updateRunning),
            li.subscribe(this.updateRunning),
            xl.addEventListener('change', this.applyDeviceConfig));
        });
        y(this, 'onIntersect', (e) => {
          (e.forEach((t) => {
            t.isIntersecting
              ? this.isInViewSet.add(t.target)
              : this.isInViewSet.delete(t.target);
          }),
            this.isInViewSet.size > 0 && !this.isInitialized && this.setup(),
            this.updateRunning());
        });
        y(this, 'updateRunning', () => {
          this.isInitialized &&
          document.visibilityState === 'visible' &&
          !li.isOpen &&
          (this.isPoseDebug || this.isInViewSet.size > 0)
            ? this.start()
            : this.stop();
        });
        y(this, 'start', () => {
          this.rafId ||
            (this.rafId = window.requestAnimationFrame(this.animate));
        });
        y(this, 'stop', () => {
          var e;
          this.rafId &&
            (window.cancelAnimationFrame(this.rafId),
            (this.rafId = 0),
            (e = this.choreography) != null &&
              e.hasActiveTail() &&
              (this.desyncSawTail = !0));
        });
        y(this, 'setup', () => {
          if (!this.canvasElm || this.isInitialized) return;
          this.isInitialized = !0;
          let e = window.innerWidth,
            t = window.innerHeight;
          ((this.renderer = new hl({
            canvas: this.canvasElm,
            antialias: !0,
            alpha: !0,
          })),
            this.renderer.setPixelRatio(
              Math.min(window.devicePixelRatio, this.config.maxPixelRatio),
            ),
            this.renderer.setSize(e, t, !1),
            (this.scene3d = new $d(this.config)),
            this.scene3d.onResize(e, t),
            (this.reflectionBlur = new lf()),
            this.reflectionBlur.setSize(e, t));
          let { glow: i } = this.config.ledMaterial;
          ((this.ledGlow = new cf(i.scale, i.iterations)),
            this.ledGlow.setSize(e, t),
            (this.ledSpotlight = new hf(
              this.scene3d.scene,
              this.config.ledSpotlight,
            )),
            this.ledSpotlight.setSize(e, t),
            (this.choreography = new tf(this.scene3d, this.canvasElm)),
            (this.cursorTilt = new Xd(this.scene3d.cursorGroup)));
          let n = Ye(`[${ct.bgVideo}]`);
          (n &&
            (this.scene3d.setupEnvironment(n),
            (this.pmrem = new cl(this.renderer)),
            this.pmrem.compileEquirectangularShader()),
            this.bindContextLoss(),
            this.scene3d
              .loadModel()
              .then(() =>
                Ns(this, null, function* () {
                  !this.scene3d ||
                    !this.choreography ||
                    !this.canvasElm ||
                    (this.choreography.applyInitial(this.config),
                    this.scene3d.applyBaseZoom(),
                    (this.introArmed = this.loadingDismissed
                      ? !1
                      : this.applyIntroEntranceStart()),
                    this.resolveModelReady(),
                    (this.scrollAwayEls = Array.from(xi(`[${ct.scrollAway}]`))),
                    (this.ledGeneratorElm = Ye(
                      `[${ct.sections.ledGenerator}]`,
                    )),
                    (this.bluetoothTextElm = Ye(`[${ct.bluetoothText}]`)),
                    (this.bluetoothSectionElm = Ye(
                      `[${ct.sections.bluetooth}]`,
                    )),
                    (this.ctaContentsElm = Ye(`[${ct.ctaContents}]`)),
                    (this.sceneSectionElm = Ye(`[${ct.sections.scene}]`)),
                    (this.playbackSectionElm = Ye(`[${ct.sections.playback}]`)),
                    this.applyLedViewportPy(),
                    this.applyBluetoothViewportPy(),
                    this.applySoniclinkViewportPy(),
                    this.refreshBluetoothDepartLine(),
                    this.refreshCtaDepartLine(),
                    this.choreography.build(this.config),
                    (this.viewer = new af({
                      scene3d: this.scene3d,
                      canvasElm: this.canvasElm,
                      viewerElm: this.viewerElm,
                      overlayElm: this.overlayElm,
                      config: this.config,
                      onEnter: () => {
                        var o, a;
                        ((o = this.choreography) == null || o.disable(),
                          this.applyViewerLightBoost(!0),
                          (a = this.poseDebugger) == null ||
                            a.setOverlayInteractive(!1));
                      },
                      onExit: () => {
                        var o;
                        (this.applyViewerLightBoost(!1),
                          (o = this.poseDebugger) == null ||
                            o.setOverlayInteractive(!0),
                          !this.manualControl && this.resyncChoreography());
                      },
                      isManualControl: () => this.manualControl,
                    })),
                    this.viewer.bind(),
                    Je.refresh());
                }),
              )
              .catch((r) => {
                this.resolveModelReady();
              }));
        });
        y(this, 'applyDeviceConfig', () => {
          var i, n, r, o, a, l, c, u, f, d, p, _, x;
          if (!this.scene3d || !this.choreography) return;
          ((this.config = ec(Xt())),
            (this.ledPyDesign =
              (r =
                (n = (i = this.config.steps.led) == null ? void 0 : i.pose) ==
                null
                  ? void 0
                  : n.py) != null
                ? r
                : 0),
            (this.bluetoothPyDesign =
              (a =
                (o = this.config.steps.bluetooth) == null ? void 0 : o.pose) ==
              null
                ? void 0
                : a.py),
            (this.soniclinkPyDesign =
              (c =
                (l = this.config.steps.soniclink) == null ? void 0 : l.pose) ==
              null
                ? void 0
                : c.py),
            (this.soniclinkCamZDesign =
              (f =
                (u = this.config.steps.soniclink) == null ? void 0 : u.pose) ==
              null
                ? void 0
                : f.camZ),
            this.applyLedViewportPy(),
            this.applyBluetoothViewportPy(),
            this.applySoniclinkViewportPy(),
            this.refreshBluetoothDepartLine(),
            this.refreshCtaDepartLine());
          let e =
            (p = (d = this.viewer) == null ? void 0 : d.isActive) != null
              ? p
              : !1;
          (e && this.applyViewerLightBoost(!1),
            this.scene3d.applyConfig(this.config),
            (_ = this.viewer) == null || _.updateConfig(this.config),
            (x = this.ledSpotlight) == null ||
              x.applyConfig(this.config.ledSpotlight));
          let t = () => {
            var g;
            e &&
              ((g = this.viewer) == null || g.reapplyOwnership(),
              this.applyViewerLightBoost(!0));
          };
          if (this.isPoseDebug) {
            t();
            return;
          }
          (e
            ? ((this.holdFrameForResync = !0),
              this.choreography.resync(this.config, () => {
                this.holdFrameForResync = !1;
              }),
              this.choreography.disable())
            : (this.choreography.clear(),
              this.choreography.applyInitial(this.config),
              this.choreography.build(this.config)),
            t(),
            Je.refresh(),
            this.resetDesyncState());
        });
        y(this, 'applyScrollAway', () => {
          var f, d, p, _, x;
          if (!this.scene3d || this.scrollAwayEls.length === 0) return;
          let e = window.innerHeight;
          if (e === 0) return;
          let { camera: t, modelGroup: i } = this.scene3d,
            n = null,
            r = 0,
            o = null;
          if (
            (this.scrollAwayEls.forEach((g) => {
              let v = g.getBoundingClientRect();
              v.bottom <= 0 ||
                v.top >= e ||
                ((n === null || Math.abs(v.top) < Math.abs(n)) &&
                  ((n = v.top), (r = v.height), (o = g)));
            }),
            n === null || !o)
          ) {
            this.applyBluetoothExitPark();
            return;
          }
          let a = this.resolveScrollAwayBehavior(o),
            l = n;
          (a.departLine === 'center'
            ? (l = n + r / 2 - e / 2)
            : a.departLine === 'bottom'
              ? (l = n + r - e)
              : a.departLine === 'text-bottom'
                ? (l =
                    (f = this.bluetoothDepartOvershoot()) != null
                      ? f
                      : n + r - e)
                : a.departLine === 'contents-gap' &&
                  (l = (d = this.ctaContentsGapOvershoot()) != null ? d : n),
            (l -= ((p = a.departOffsetVhRatio) != null ? p : 0) * e));
          let c = a.stepKey ? this.config.steps[a.stepKey] : void 0,
            u =
              (x = (_ = c == null ? void 0 : c.pose) == null ? void 0 : _.py) !=
              null
                ? x
                : 0;
          if (l >= 0) {
            ((a.approachPin || this.departedScrollAwayEls.has(o)) &&
              (i.position.y = u),
              this.departedScrollAwayEls.clear());
            return;
          }
          (this.departedScrollAwayEls.add(o),
            (i.position.y = u - (l / e) * jd(t)));
        });
        y(this, 'applyBluetoothExitPark', () => {
          var a, l, c, u;
          let e = this.config.bluetoothDepart;
          if (!this.scene3d || (e !== 'text-bottom' && e !== 'top')) return;
          let t = window.innerHeight;
          if (t === 0) return;
          let i = null;
          if (
            (e === 'text-bottom'
              ? (i = this.bluetoothDepartOvershoot())
              : this.bluetoothSectionElm &&
                (i =
                  this.bluetoothSectionElm.getBoundingClientRect().top -
                  ((a = this.config.bluetoothDepartTopRatio) != null ? a : 0) *
                    t),
            i === null || i >= 0)
          )
            return;
          let { camera: n, modelGroup: r } = this.scene3d,
            o =
              (u =
                (c =
                  (l = this.config.steps.bluetooth) == null
                    ? void 0
                    : l.pose) == null
                  ? void 0
                  : c.py) != null
                ? u
                : 0;
          r.position.y = o - (i / t) * jd(n);
        });
        y(this, 'resolveScrollAwayBehavior', (e) => {
          var t, i;
          return e.hasAttribute(ct.sections.ledGenerator)
            ? {
                departLine:
                  (t = this.config.ledGeneratorDepart) != null ? t : 'top',
                approachPin: !1,
                stepKey: 'led',
              }
            : e.hasAttribute(ct.sections.bluetooth)
              ? Fi(
                  pt(
                    {
                      departLine:
                        (i = this.config.bluetoothDepart) != null
                          ? i
                          : 'bottom',
                    },
                    this.config.bluetoothDepart === 'top' &&
                      this.config.bluetoothDepartTopRatio !== void 0
                      ? {
                          departOffsetVhRatio:
                            this.config.bluetoothDepartTopRatio,
                        }
                      : {},
                  ),
                  { approachPin: !1, stepKey: 'bluetooth' },
                )
              : e.hasAttribute(ct.sections.cta)
                ? {
                    departLine:
                      this.config.ctaDepart === 'contents-gap'
                        ? 'contents-gap'
                        : 'top',
                    approachPin: !0,
                    stepKey: 'cta',
                  }
                : { departLine: 'top', approachPin: !0 };
        });
        y(this, 'bluetoothDepartOvershoot', () => {
          let e = this.bluetoothTextElm;
          if (!this.scene3d || !e) return null;
          this.bluetoothDepartLineYCache === null &&
            (this.bluetoothDepartLineYCache = nf(this.config, this.scene3d));
          let t = this.bluetoothDepartLineYCache;
          return t === null ? null : e.getBoundingClientRect().bottom - t;
        });
        y(this, 'refreshBluetoothDepartLine', () => {
          this.bluetoothDepartLineYCache = this.scene3d
            ? nf(this.config, this.scene3d)
            : null;
        });
        y(this, 'ctaContentsGapOvershoot', () => {
          let e = this.ctaContentsElm;
          if (!this.scene3d || !e) return null;
          this.ctaDepartLineYCache === null &&
            (this.ctaDepartLineYCache = sf(this.config, this.scene3d));
          let t = this.ctaDepartLineYCache;
          return t === null ? null : e.getBoundingClientRect().top - t;
        });
        y(this, 'refreshCtaDepartLine', () => {
          this.ctaDepartLineYCache = this.scene3d
            ? sf(this.config, this.scene3d)
            : null;
        });
        y(this, 'applyLedExitHide', () => {
          if (!this.ledGeneratorElm || !this.sceneSectionElm || !this.scene3d)
            return;
          let e = window.innerHeight;
          if (e === 0) return;
          let t = this.ledGeneratorElm.getBoundingClientRect(),
            i = this.sceneSectionElm.getBoundingClientRect();
          t.height === 0 ||
            i.height === 0 ||
            (t.bottom > 0 && t.top < e
              ? this.scene3d.modelGroup.scale.setScalar(1)
              : t.bottom <= 0 &&
                i.bottom > 0 &&
                this.scene3d.modelGroup.scale.setScalar(0));
        });
        y(this, 'applySceneEmergePy', () => {
          var c;
          if (!this.sceneSectionElm || !this.scene3d) return;
          let e = window.innerHeight;
          if (e === 0) return;
          let t = this.sceneSectionElm.getBoundingClientRect();
          if (t.height === 0 || t.bottom > 0) return;
          let { camera: i, modelGroup: n } = this.scene3d,
            r = -t.bottom / (e * this.config.sceneEmergeViewportRatio);
          if (r >= 1) {
            if (!this.playbackSectionElm) {
              n.position.y = 0;
              return;
            }
            this.playbackSectionElm.getBoundingClientRect().top >
              HC(
                (c = this.config.steps.playback) == null ? void 0 : c.start,
                e,
              ) && (n.position.y = 0);
            return;
          }
          let o = Kv * as(),
            a = jd(i),
            l = Zi(1 - r, 2);
          n.position.y = (-o / e) * a * l;
        });
        y(this, 'repairFrozenDesync', () => {
          var n, r;
          let e = window.scrollY,
            t = performance.now(),
            i = Math.abs(e - this.desyncLastScrollY) >= 1;
          if (
            (i && (this.desyncBoundaryResynced = !1),
            i && (this.desyncSettledAt = t),
            (this.desyncLastScrollY = e),
            (n = this.choreography) != null && n.hasActiveTail())
          ) {
            (i && (this.desyncSawTail = !0),
              !i &&
                !this.desyncBoundaryResynced &&
                t - this.desyncSettledAt >= _b &&
                this.choreography.hasBoundaryTail() &&
                ((this.desyncBoundaryResynced = !0),
                this.resyncChoreography()));
            return;
          }
          t - this.desyncSettledAt < _b ||
            (!this.desyncSawTail &&
              !((r = this.choreography) != null && r.hasFrozenDesync())) ||
            this.resyncChoreography();
        });
        y(this, 'animate', () => {
          var e, t, i, n;
          ((this.rafId = window.requestAnimationFrame(this.animate)),
            !(!this.renderer || !this.scene3d) &&
              (this.manualControl ||
                (!(
                  (t =
                    (e = this.viewer) == null
                      ? void 0
                      : e.applyScrollFollow()) != null && t
                ) &&
                  !this.introPlaying &&
                  (!this.introArmed &&
                    !this.liteIntroArmed &&
                    this.repairFrozenDesync(),
                  this.applySceneEmergePy(),
                  this.applyScrollAway(),
                  this.applyLedExitHide())),
              (i = this.cursorTilt) == null || i.update(),
              (n = this.viewer) == null || n.update(),
              this.scene3d.updateEnvVisibility(),
              this.pmrem &&
                this.scene3d.envTexture &&
                (this.envFrame % this.config.envMap.updateInterval === 0 &&
                  this.scene3d.updateEnvironment(this.pmrem),
                (this.envFrame += 1)),
              this.holdFrameForResync || this.renderReflectionOrScene()));
        });
        y(this, 'renderReflectionOrScene', () => {
          var i;
          if (!this.renderer || !this.scene3d) return;
          let { scene: e, camera: t } = this.scene3d;
          if (
            (this.renderLedSpotlight(),
            (i = this.viewer) != null &&
              i.isActive &&
              this.scene3d.hasReflection &&
              this.reflectionBlur)
          ) {
            if (
              (this.scene3d.syncReflectionCamera(),
              this.scene3d.consumeReflectionDirty())
            ) {
              (this.scene3d.setModelVisible(!1),
                this.scene3d.setReflectionVisible(!0));
              let r = this.scene3d.reflectionCamera;
              (this.reflectionBlur.capture(this.renderer, () => {
                var a;
                return (a = this.renderer) == null ? void 0 : a.render(e, r);
              }),
                this.scene3d.setModelVisible(!0),
                this.scene3d.setReflectionVisible(!1));
              let o = this.scene3d.computeFloorMask();
              this.reflectionBlur.setMask(
                o.cx,
                o.cy,
                o.rx,
                o.ry,
                this.config.viewer.reflection.feather,
              );
            }
            (this.renderer.setRenderTarget(null),
              this.renderer.clear(),
              this.reflectionBlur.composite(this.renderer),
              this.scene3d.setModelVisible(!0),
              this.scene3d.setReflectionVisible(!1));
            let n = this.renderer.autoClear;
            ((this.renderer.autoClear = !1),
              this.renderer.render(e, t),
              (this.renderer.autoClear = n));
            return;
          }
          (this.renderer.render(e, t), this.renderLedGlow());
        });
        y(this, 'renderLedSpotlight', () => {
          var r;
          if (
            !this.renderer ||
            !this.scene3d ||
            !this.ledSpotlight ||
            !this.ledSpotlight.isActive
          )
            return;
          let { camera: e, modelGroup: t } = this.scene3d,
            i = this.scene3d.modelHalfHeight * t.scale.y,
            n = (r = this.resolveLedSpotlightAnchor()) != null ? r : t.position;
          (this.ledSpotlight.follow(n, e, i, t.position),
            this.ledSpotlight.capture(this.renderer, e));
        });
        y(this, 'resolveLedSpotlightAnchor', () => {
          var u, f;
          let { led: e } = this.config.steps;
          if (!this.scene3d || !(e != null && e.pose)) return null;
          this.ledSpotlightGeneratorEl ||
            (this.ledSpotlightGeneratorEl = Ye(
              `[${ct.sections.ledGenerator}]`,
            ));
          let t = this.ledSpotlightGeneratorEl,
            i = window.innerHeight;
          if (!t || i === 0) return null;
          let n = t.getBoundingClientRect(),
            r = Xt() ? i / 2 - n.height / 2 : 0,
            o = n.top - r,
            { camera: a, baseCameraZ: l } = this.scene3d,
            c = Ls(a.fov, l, a.position.z / l);
          return (
            this.ledSpotlightAnchor.set(
              (u = e.pose.px) != null ? u : 0,
              ((f = e.pose.py) != null ? f : 0) - (o / i) * c,
              0,
            ),
            this.ledSpotlightAnchor
          );
        });
        y(this, 'renderLedGlow', () => {
          if (!this.renderer || !this.scene3d || !this.ledGlow) return;
          let e = this.scene3d.ledGlowStrength;
          if (e <= 0) return;
          let { scene: t, camera: i } = this.scene3d,
            { renderer: n, ledGlow: r } = this,
            o = i.layers.mask;
          try {
            (i.layers.set(g_), r.capture(n, () => n.render(t, i)));
          } finally {
            i.layers.mask = o;
          }
          r.composite(n, e * this.config.ledMaterial.glow.strength);
        });
        y(this, 'bindContextLoss', () => {
          this.canvasElm &&
            (this.canvasElm.addEventListener(
              'webglcontextlost',
              this.onContextLost,
            ),
            this.canvasElm.addEventListener(
              'webglcontextrestored',
              this.onContextRestored,
            ));
        });
        y(this, 'onContextLost', (e) => {
          (e.preventDefault(), this.stop());
        });
        y(this, 'onContextRestored', () => {
          var e;
          ((e = this.scene3d) == null || e.invalidateReflection(),
            this.updateRunning());
        });
        var e, t, i, n, r, o, a, l, c;
        ((this.modelReady = new Promise((u) => {
          this.resolveModelReady = u;
        })),
          (this.canvasElm = Ye(`[${ct.canvas}]`)),
          (this.viewerElm = Ye(`[${ct.viewer}]`)),
          (this.overlayElm = Ye(`[${ct.viewerOverlay}]`)),
          (this.topTitleElm = Ye(`[${ct.topTitle}]`)),
          this.observeTopTitleLeave(),
          document.addEventListener(Mh, () => {
            var u;
            ((u = this.viewer) != null && u.isActive) ||
              this.manualControl ||
              this.resyncChoreography();
          }),
          (this.ledPyDesign =
            (i =
              (t = (e = this.config.steps.led) == null ? void 0 : e.pose) ==
              null
                ? void 0
                : t.py) != null
              ? i
              : 0),
          (this.bluetoothPyDesign =
            (r = (n = this.config.steps.bluetooth) == null ? void 0 : n.pose) ==
            null
              ? void 0
              : r.py),
          (this.soniclinkPyDesign =
            (a = (o = this.config.steps.soniclink) == null ? void 0 : o.pose) ==
            null
              ? void 0
              : a.py),
          (this.soniclinkCamZDesign =
            (c = (l = this.config.steps.soniclink) == null ? void 0 : l.pose) ==
            null
              ? void 0
              : c.camZ),
          this.init());
      }
    };
  var vb = { video: 'data-in-view-video' },
    xb = { rootMargin: '100% 0px' };
  var df = class {
    constructor() {
      y(this, 'videoElms');
      y(this, 'inViewVideos', new Set());
      y(this, 'init', () => {
        this.checkElements() &&
          (Fs({
            targets: Array.from(this.videoElms),
            options: xb,
            callback: this.onIntersect,
          }),
          li.subscribe(this.onModalToggled));
      });
      y(this, 'checkElements', () => this.videoElms.length > 0);
      y(this, 'onIntersect', (e) => {
        let t = e.target;
        (e.isIntersecting
          ? this.inViewVideos.add(t)
          : this.inViewVideos.delete(t),
          this.updateVideo(t));
      });
      y(this, 'onModalToggled', () => {
        this.inViewVideos.forEach((e) => this.updateVideo(e));
      });
      y(this, 'updateVideo', (e) => {
        this.inViewVideos.has(e) && !li.isOpen
          ? e.paused && e.play().catch(() => {})
          : e.paused || e.pause();
      });
      ((this.videoElms = xi(`[${vb.video}]`)), this.init());
    }
  };
  var gl = {
      start: 'data-bg-scroll-start',
      mid: 'data-bg-scroll-mid',
      end: 'data-bg-scroll-end',
    },
    yb = { light: '#eff5f6', mid: '#c7cdd7' };
  var y_ = {
      root: 'data-led-root',
      slider: 'data-led-hue-slider',
      knob: 'data-led-hue-knob',
    },
    cs = { keyFocus: 'is-key-focus', active: 'is-active', nudge: 'is-nudge' },
    bb = [
      { pos: 0.05, color: '#0ea441' },
      { pos: 0.1648, color: '#85b91d' },
      { pos: 0.2814, color: '#ffe600' },
      { pos: 0.39, color: '#ff0000' },
      { pos: 0.49, color: '#ff00c7' },
      { pos: 0.61, color: '#ad00ff' },
      { pos: 0.72, color: '#0500ff' },
      { pos: 1, color: '#00a3ff' },
    ],
    _l = 0.39,
    Sb = '0px 0px -65% 0px',
    b_ = 0.02,
    Ds = {
      up: 0,
      down: 1,
      upDuration: 0.6,
      downDuration: 0.9,
      settleDuration: 0.7,
      delay: 0.1,
      nudgeDelay: 1.2,
      ease: 'power2.inOut',
    };
  var Kc = (s) => ({
      r: parseInt(s.slice(1, 3), 16),
      g: parseInt(s.slice(3, 5), 16),
      b: parseInt(s.slice(5, 7), 16),
    }),
    S_ = (s, e, t) => s + (e - s) * t,
    Eb = (s) => {
      let e = bb,
        t = e[0],
        i = e[e.length - 1];
      if (s <= t.pos) return Kc(t.color);
      if (s >= i.pos) return Kc(i.color);
      for (let n = 0; n < e.length - 1; n += 1) {
        let r = e[n],
          o = e[n + 1];
        if (s >= r.pos && s <= o.pos) {
          let a = (s - r.pos) / (o.pos - r.pos),
            l = Kc(r.color),
            c = Kc(o.color);
          return {
            r: Math.round(S_(l.r, c.r, a)),
            g: Math.round(S_(l.g, c.g, a)),
            b: Math.round(S_(l.b, c.b, a)),
          };
        }
      }
      return Kc(i.color);
    },
    zC = ({ r: s, g: e, b: t }) => {
      let i = s / 255,
        n = e / 255,
        r = t / 255,
        o = Math.max(i, n, r),
        a = Math.min(i, n, r),
        l = o - a;
      if (l === 0) return 0;
      let c;
      return (
        o === i
          ? (c = ((n - r) / l) % 6)
          : o === n
            ? (c = (r - i) / l + 2)
            : (c = (i - n) / l + 4),
        (c *= 60),
        c < 0 && (c += 360),
        c
      );
    },
    VC = (s) =>
      s < 15
        ? 'Red'
        : s < 45
          ? 'Orange'
          : s < 70
            ? 'Yellow'
            : s < 160
              ? 'Green'
              : s < 200
                ? 'Cyan'
                : s < 250
                  ? 'Blue'
                  : s < 290
                    ? 'Purple'
                    : s < 330
                      ? 'Pink'
                      : 'Red',
    ff = class {
      constructor(e) {
        this.product3d = e;
        y(this, 'sliderElm');
        y(this, 'rootElm');
        y(this, 'ratio', _l);
        y(this, 'isInView', !1);
        y(this, 'pointerFocusing', !1);
        y(this, 'demoTl', null);
        y(this, 'nudgeCall', null);
        y(this, 'demoPlayed', !1);
        y(this, 'isLit', !1);
        y(this, 'isDimmed', !1);
        y(this, 'init', () => {
          let e = this.sliderElm;
          e &&
            (this.applyRatio(_l, !1),
            e.addEventListener('pointerdown', this.onPointerDown),
            e.addEventListener('pointermove', this.onPointerMove),
            e.addEventListener('pointerup', this.onPointerUp),
            e.addEventListener('pointercancel', this.onPointerUp),
            e.addEventListener('keydown', this.onKeyDown),
            e.addEventListener('focus', this.onFocus),
            e.addEventListener('blur', this.onBlur),
            this.observeSection(),
            this.observeSpotlight());
        });
        y(this, 'observeSpotlight', () => {
          let e = Ye(`[${ct.sections.ledGenerator}]`);
          if (!e) return;
          Je.create({
            trigger: e,
            start: () => ec(Xt()).steps.led.end,
            onEnter: () => {
              ((this.isLit = !0), this.applySpotlight());
            },
            onLeaveBack: () => {
              ((this.isLit = !1), this.applySpotlight(), this.stopDemo(!0));
            },
          });
          let t = Ye(`[${gl.start}]`);
          t &&
            Je.create({
              trigger: t,
              start: () => (Xt() ? 'top 50%' : 'top 65%'),
              onEnter: () => {
                ((this.isDimmed = !0), this.applySpotlight());
              },
              onLeaveBack: () => {
                ((this.isDimmed = !1), this.applySpotlight());
              },
            });
        });
        y(this, 'applySpotlight', () => {
          this.product3d.setLedSpotlight(this.isLit && !this.isDimmed);
        });
        y(this, 'playDemo', () => {
          let e = this.sliderElm;
          if (!e || this.demoPlayed) return;
          ((this.demoPlayed = !0), this.stopDemo(!1));
          let t = { value: this.ratio },
            i = () => this.applyRatio(t.value, !0);
          e.classList.add(cs.active);
          let n = Et.timeline({
            delay: Ds.delay,
            onComplete: () => {
              (e.classList.remove(cs.active),
                (this.demoTl = null),
                (this.nudgeCall = Et.delayedCall(Ds.nudgeDelay, () => {
                  ((this.nudgeCall = null), e.classList.add(cs.nudge));
                })));
            },
          });
          (n.to(t, {
            value: Ds.up,
            duration: Ds.upDuration,
            ease: Ds.ease,
            onUpdate: i,
          }),
            n.to(t, {
              value: Ds.down,
              duration: Ds.downDuration,
              ease: Ds.ease,
              onUpdate: i,
            }),
            n.to(t, {
              value: _l,
              duration: Ds.settleDuration,
              ease: Ds.ease,
              onUpdate: i,
            }),
            (this.demoTl = n));
        });
        y(this, 'stopDemo', (e) => {
          var t, i;
          ((t = this.sliderElm) == null ||
            t.classList.remove(cs.active, cs.nudge),
            (i = this.nudgeCall) == null || i.kill(),
            (this.nudgeCall = null),
            this.demoTl &&
              (this.demoTl.kill(),
              (this.demoTl = null),
              e && this.applyRatio(_l, !0)));
        });
        y(this, 'applyRatio', (e, t) => {
          let i = this.sliderElm;
          if (!i) return;
          this.ratio = qn(e, 0, 1);
          let { r: n, g: r, b: o } = Eb(this.ratio),
            a = `rgb(${n}, ${r}, ${o})`;
          (i.style.setProperty('--led-ratio', String(this.ratio)),
            i.style.setProperty('--led-color', a),
            i.style.setProperty('--led-glow', `rgba(${n}, ${r}, ${o}, 0.7)`));
          let l = Math.round(zC({ r: n, g: r, b: o }));
          (i.setAttribute(
            'aria-valuenow',
            String(Math.round(this.ratio * 360)),
          ),
            i.setAttribute('aria-valuetext', VC(l)),
            t && this.isInView && this.product3d.setLedColor(a));
        });
        y(this, 'ratioFromClientY', (e, t) =>
          t.height === 0 ? this.ratio : qn((e - t.top) / t.height, 0, 1),
        );
        y(this, 'onPointerDown', (e) => {
          let t = this.sliderElm;
          !t ||
            e.button !== 0 ||
            (e.preventDefault(),
            this.stopDemo(!1),
            (this.pointerFocusing = !0),
            t.classList.remove(cs.keyFocus),
            t.focus(),
            (this.pointerFocusing = !1),
            t.classList.add(cs.active),
            t.setPointerCapture(e.pointerId),
            this.applyRatio(
              this.ratioFromClientY(e.clientY, t.getBoundingClientRect()),
              !0,
            ));
        });
        y(this, 'onPointerMove', (e) => {
          let t = this.sliderElm;
          !t ||
            !t.hasPointerCapture(e.pointerId) ||
            this.applyRatio(
              this.ratioFromClientY(e.clientY, t.getBoundingClientRect()),
              !0,
            );
        });
        y(this, 'onPointerUp', (e) => {
          let t = this.sliderElm;
          t &&
            (t.classList.remove(cs.active),
            t.hasPointerCapture(e.pointerId) &&
              t.releasePointerCapture(e.pointerId));
        });
        y(this, 'onKeyDown', (e) => {
          var i;
          let t;
          switch (e.key) {
            case 'ArrowUp':
            case 'ArrowLeft':
              t = this.ratio - b_;
              break;
            case 'ArrowDown':
            case 'ArrowRight':
              t = this.ratio + b_;
              break;
            case 'Home':
              t = 0;
              break;
            case 'End':
              t = 1;
              break;
            default:
              return;
          }
          (e.preventDefault(),
            this.stopDemo(!1),
            (i = this.sliderElm) == null || i.classList.add(cs.keyFocus),
            this.applyRatio(t, !0));
        });
        y(this, 'onFocus', () => {
          var e;
          this.pointerFocusing ||
            (e = this.sliderElm) == null ||
            e.classList.add(cs.keyFocus);
        });
        y(this, 'onBlur', () => {
          var e;
          (e = this.sliderElm) == null || e.classList.remove(cs.keyFocus);
        });
        y(this, 'observeSection', () => {
          let e = this.rootElm;
          if (!e) return;
          new IntersectionObserver(this.onIntersect, {
            root: null,
            rootMargin: Sb,
            threshold: 0,
          }).observe(e);
        });
        y(this, 'onIntersect', (e) => {
          e.forEach((t) => {
            ((this.isInView = t.isIntersecting),
              t.isIntersecting ? this.onEnterSection() : this.onExitSection());
          });
        });
        y(this, 'onEnterSection', () => {
          ((this.demoPlayed = !1),
            this.applyRatio(_l, !1),
            this.playDemo(),
            this.product3d.modelReady.then(() => {
              if (!this.isInView) return;
              let { r: e, g: t, b: i } = Eb(this.ratio);
              this.product3d.setLedColor(`rgb(${e}, ${t}, ${i})`, !0);
            }));
        });
        y(this, 'onExitSection', () => {
          (this.stopDemo(!1), this.product3d.setLedColor(null, !0));
        });
        ((this.sliderElm = Ye(`[${y_.slider}]`)),
          (this.rootElm = Ye(`[${y_.root}]`)),
          this.init());
      }
    };
  var pf = class {
    constructor() {
      y(this, 'appElm');
      y(this, 'startElm');
      y(this, 'midElm');
      y(this, 'endElm');
      y(this, 'init', () => {
        this.checkElements() && this.bindScrollTriggers();
      });
      y(
        this,
        'checkElements',
        () => !!(this.appElm && this.startElm && this.midElm && this.endElm),
      );
      y(this, 'bindScrollTriggers', () => {
        let { appElm: e, startElm: t, midElm: i, endElm: n } = this;
        if (!e || !t || !i || !n) return;
        let { light: r, mid: o } = yb,
          a = getComputedStyle(e).backgroundColor,
          l = (c, u, f, d, p, _) => {
            Et.fromTo(
              e,
              { backgroundColor: c },
              {
                backgroundColor: u,
                ease: 'none',
                immediateRender: !1,
                scrollTrigger: {
                  trigger: f,
                  start: d,
                  endTrigger: p,
                  end: _,
                  scrub: !0,
                },
              },
            );
          };
        (l(a, r, t, 'top center', t, 'center center'),
          l(r, o, t, 'center center', i, 'top center'),
          l(o, a, i, 'top center', n, 'top center'));
      });
      ((this.appElm = Ye('#App')),
        (this.startElm = Ye(`[${gl.start}]`)),
        (this.midElm = Ye(`[${gl.mid}]`)),
        (this.endElm = Ye(`[${gl.end}]`)),
        this.init());
    }
  };
  var po = {
      root: 'data-playstyle',
      sticky: 'data-playstyle-sticky',
      stage: 'data-playstyle-stage',
      slides: 'data-playstyle-slides',
      slot: 'data-playstyle-slot',
      finder: 'data-playstyle-finder',
    },
    Tb = {
      revealEnd: 0.04,
      cropStart: 0.06,
      cropEnd: 0.17,
      finderOutStart: 0.11,
      finderOutEnd: 0.17,
      formStart: 0.18,
      formEnd: 0.33,
      rotateStart: 0.36,
      rotateEnd: 0.92,
    },
    E_ = { gap: 24, gapSp: 5.6, angle: 77, angleSp: 80 },
    Mb = {
      duration: 0.4,
      steps: [
        [0, 0],
        [0.12, 1],
        [0.24, 0],
        [0.36, 1],
        [0.52, 0.2],
        [0.64, 1],
        [0.8, 0.5],
        [1, 1],
      ],
    };
  var $c = (s, e, t) =>
      t - e <= 0 ? (s < t ? 0 : 1) : qn((s - e) / (t - e), 0, 1),
    mf = class {
      constructor() {
        y(this, 'stageElm');
        y(this, 'slidesElm');
        y(this, 'finderElm');
        y(this, 'panels', []);
        y(this, 'panelW', 0);
        y(this, 'perspective', 1600);
        y(this, 'angle', E_.angle);
        y(this, 'radius', 0);
        y(this, 'lastVars', {});
        y(this, 'lastTransforms', []);
        y(this, 'lastOpacities', []);
        y(this, 'lastProgress', 0);
        y(this, 'revealed', !1);
        y(this, 'refreshing', !1);
        y(this, 'flickerTl', null);
        y(this, 'onResized', () => {
          this.slidesElm &&
            (this.measure(), this.applyProgress(this.lastProgress));
        });
        y(this, 'measure', () => {
          if (!this.slidesElm || !this.stageElm) return;
          let e = this.stageElm.style.getPropertyValue('--crop');
          (this.stageElm.style.setProperty('--crop', '1'),
            (this.panelW = this.slidesElm.clientWidth),
            e
              ? this.stageElm.style.setProperty('--crop', e)
              : this.stageElm.style.removeProperty('--crop'));
          let t = parseFloat(getComputedStyle(this.stageElm).perspective);
          (Number.isFinite(t) && t > 0 && (this.perspective = t),
            this.computeCylinder());
        });
        y(this, 'computeCylinder', () => {
          let { gap: e, gapSp: t, angle: i, angleSp: n } = E_,
            r = Xt() && D_();
          this.angle = r ? n : i;
          let o = (this.angle * Math.PI) / 180,
            a = Math.max(Math.sin(o), 1e-4),
            l = Math.cos(o),
            c = document.documentElement.clientWidth,
            u = r ? (t / 390) * c : (e / 1440) * c,
            f = this.panelW / 2,
            d = f + u,
            p = (d + f * l) / a;
          for (let _ = 0; _ < 2; _ += 1) {
            let x = p * (1 - l) - f * a;
            p = ((d * (this.perspective - x)) / this.perspective + f * l) / a;
          }
          this.radius = p;
        });
        y(this, 'setStageVar', (e, t) => {
          var i;
          this.lastVars[e] !== t &&
            ((this.lastVars[e] = t),
            (i = this.stageElm) == null || i.style.setProperty(e, t));
        });
        y(this, 'applyProgress', (e) => {
          if (!this.stageElm) return;
          this.lastProgress = e;
          let {
              revealEnd: t,
              cropStart: i,
              cropEnd: n,
              finderOutStart: r,
              finderOutEnd: o,
              formStart: a,
              formEnd: l,
              rotateStart: c,
              rotateEnd: u,
            } = Tb,
            f = $c(e, 0, t),
            d = $c(e, i, n),
            p = $c(e, r, o),
            _ = $c(e, a, l),
            x = $c(e, c, u);
          (this.setStageVar('--reveal', f.toFixed(4)),
            this.setStageVar('--crop', d.toFixed(4)),
            this.setStageVar('--finder-out', p.toFixed(4)),
            this.setStageVar('--form', _.toFixed(4)));
          let g = f >= 1;
          (g !== this.revealed &&
            ((this.revealed = g),
            this.stageElm.classList.toggle('is-revealed', g),
            g && !this.refreshing ? this.flicker() : g || this.killFlicker()),
            this.layoutCoverflow(_, x));
        });
        y(this, 'flicker', () => {
          let { finderElm: e } = this;
          if (!e) return;
          this.killFlicker();
          let { duration: t, steps: i } = Mb;
          ((this.flickerTl = Et.timeline({ onComplete: this.killFlicker })),
            i.forEach(([n, r]) => {
              var o;
              (o = this.flickerTl) == null || o.set(e, { opacity: r }, n * t);
            }));
        });
        y(this, 'killFlicker', () => {
          this.flickerTl &&
            (this.flickerTl.kill(),
            (this.flickerTl = null),
            this.finderElm &&
              Et.set(this.finderElm, { clearProps: 'opacity' }));
        });
        y(this, 'layoutCoverflow', (e, t) => {
          let i = this.panels.length,
            n = e + t * (i - 2);
          this.panels.forEach((r, o) => {
            let a = o - n;
            a < -i / 2 && (a += i);
            let l = Math.abs(a),
              c = -a * this.angle,
              u = `translateZ(${this.radius}px) rotateY(${c}deg) translateZ(${-this.radius}px)`;
            this.lastTransforms[o] !== u &&
              ((this.lastTransforms[o] = u),
              r.style.setProperty('transform', u));
            let f = qn(1 - (l - 1) / 0.5, 0, 1),
              d = e * e,
              p = (o === 0 ? Math.max(f, 1 - e) : f * d).toFixed(3);
            this.lastOpacities[o] !== p &&
              ((this.lastOpacities[o] = p), r.style.setProperty('opacity', p));
          });
        });
        var o;
        let e = Ye(`[${po.root}]`),
          t = e ? Ye(`[${po.sticky}]`, e) : null;
        if (
          ((this.stageElm = e ? Ye(`[${po.stage}]`, e) : null),
          (this.slidesElm = e ? Ye(`[${po.slides}]`, e) : null),
          (this.finderElm = e ? Ye(`[${po.finder}]`, e) : null),
          !e || !t || !this.stageElm || !this.slidesElm)
        )
          return;
        let i = Array.from(
            xi(`[${po.slot}]`, (o = this.slidesElm) != null ? o : void 0),
          ),
          n = i.find((a) => a.getAttribute(po.slot) === 'center'),
          r = i.filter((a) => a !== n);
        !n ||
          r.length === 0 ||
          (this.panels.push(n, ...r),
          this.measure(),
          Je.addEventListener('refreshInit', () => {
            this.refreshing = !0;
          }),
          Je.addEventListener('refresh', () => {
            this.refreshing = !1;
          }),
          Je.create({
            trigger: e,
            start: 'top top',
            end: 'bottom bottom',
            pin: t,
            pinType: 'fixed',
            pinSpacing: !1,
            scrub: !0,
            onUpdate: (a) => this.applyProgress(a.progress),
            onToggle: (a) => e.classList.toggle('is-active', a.isActive),
          }),
          this.applyProgress(0));
      }
    };
  var T_ = { root: 'data-scene-slider', canvas: 'data-scene-canvas' },
    hs = {
      images: [
        hdjf9AssetBase + 'hdjf9-img-scene-img-slide01.jpg',
        hdjf9AssetBase + 'hdjf9-img-scene-img-slide02.jpg',
        hdjf9AssetBase + 'hdjf9-img-scene-img-slide03.jpg',
        hdjf9AssetBase + 'hdjf9-img-scene-img-slide04.jpg',
        hdjf9AssetBase + 'hdjf9-img-scene-img-slide05.jpg',
        hdjf9AssetBase + 'hdjf9-img-scene-img-slide06.jpg',
        hdjf9AssetBase + 'hdjf9-img-scene-img-slide07.jpg',
      ],
      ring: { radius: 6 },
      layout: { pcSideMargin: 120, spSlideWidth: 320, spSlideHeight: 200 },
      panel: {
        height: 3.2,
        radialSegments: 20,
        gap: 0.04,
        pcCornerRadius: 20,
        spCornerRadius: 12,
      },
      speed: {
        baseRotation: -0.0025,
        scrollBoost: 4e-5,
        damping: 0.92,
        maxRotation: 0.08,
      },
      tilt: { max: 0.32, cursorMax: 0.06, cursorLerp: 0.08 },
      camera: { fov: 25, near: 0.1, far: 200, z: 14 },
      maxPixelRatio: 2,
    };
  var GC = (s, e) => {
      let t = new je().setHSL(s / e, 0.5, 0.5);
      return new rn({ color: t, side: Gi });
    },
    gf = class {
      constructor(e) {
        y(this, 'rootElm');
        y(this, 'scene');
        y(this, 'camera');
        y(this, 'tiltGroup');
        y(this, 'cylinder');
        y(this, 'panels', []);
        y(this, 'textureLoader', new $o());
        y(this, 'cornerUniforms', {
          uRadius: { value: 0 },
          uAA: { value: 0 },
          uPanelSize: { value: new et(1, 1) },
        });
        y(this, 'rotation', 0);
        y(this, 'dragVelocity', 0);
        y(this, 'scrollVelocity', 0);
        y(this, 'lastScrollY', window.scrollY);
        y(this, 'isDragging', !1);
        y(this, 'lastPointerX', 0);
        y(this, 'dragRadPerPx', 0.003);
        y(this, 'pendingDrag', 0);
        y(this, 'cursorTiltTarget', 0);
        y(this, 'cursorTilt', 0);
        y(this, 'baseRotation', hs.speed.baseRotation);
        y(this, 'onResize', (e, t) => {
          if (e === 0 || t === 0) return;
          ((this.camera.aspect = e / t), this.camera.updateProjectionMatrix());
          let { camera: i, ring: n, panel: r, layout: o } = hs,
            a = Math.tan(Vt.degToRad(i.fov / 2)),
            l = a * this.camera.aspect,
            c = (Math.PI * 2) / hs.images.length,
            u = (c * (1 - r.gap)) / 2,
            f = e < 960,
            d;
          if (f) {
            let R = o.spSlideWidth / 390;
            d = n.radius * Math.cos(u) + (n.radius * Math.sin(u)) / (R * l);
          } else {
            let R = 1 - (2 * o.pcSideMargin) / 1440,
              U = Math.atan(R * l);
            d = n.radius / Math.sin(U);
          }
          this.camera.position.z = d;
          let p =
            ((n.radius * Math.sin(u)) / ((d - n.radius * Math.cos(u)) * l)) * e;
          this.dragRadPerPx = c / p;
          let _ = (2 * (d - n.radius) * a) / t,
            x = (o.spSlideHeight / 390) * e,
            g = f ? (x * _) / r.height : 1;
          this.cylinder.scale.y = g;
          let v = this.cornerUniforms.uPanelSize.value.x,
            w = r.height * g;
          this.cornerUniforms.uPanelSize.value.y = w;
          let L = f ? r.spCornerRadius : r.pcCornerRadius;
          ((this.cornerUniforms.uRadius.value = qn(
            L * _,
            0,
            Math.min(v, w) / 2,
          )),
            (this.cornerUniforms.uAA.value = _));
        });
        y(this, 'onFrame', (e, t) => {
          let i = hs.speed,
            { scrollY: n } = window,
            r = Math.abs(n - this.lastScrollY);
          ((this.lastScrollY = n),
            (this.scrollVelocity -= r * i.scrollBoost),
            (this.rotation += this.pendingDrag),
            this.isDragging
              ? (this.dragVelocity = this.pendingDrag)
              : (this.dragVelocity *= i.damping),
            (this.pendingDrag = 0),
            (this.scrollVelocity *= i.damping));
          let o = qn(
            this.baseRotation +
              this.scrollVelocity +
              (this.isDragging ? 0 : this.dragVelocity),
            -i.maxRotation,
            i.maxRotation,
          );
          ((this.rotation += o), (this.cylinder.rotation.y = this.rotation));
          let { tilt: a } = hs;
          ((this.cursorTilt +=
            (this.cursorTiltTarget - this.cursorTilt) * a.cursorLerp),
            (this.tiltGroup.rotation.x =
              a.max * (1 - t * 2) + this.cursorTilt));
        });
        y(this, 'onCursorMove', (e) => {
          this.cursorTiltTarget = e * hs.tilt.cursorMax;
        });
        y(this, 'onPointerDown', (e) => {
          ((this.isDragging = !0), (this.lastPointerX = e));
        });
        y(this, 'onPointerMove', (e) => {
          if (!this.isDragging) return;
          let t = e - this.lastPointerX;
          ((this.lastPointerX = e),
            (this.pendingDrag += t * this.dragRadPerPx));
        });
        y(this, 'onPointerUp', () => {
          this.isDragging = !1;
        });
        y(this, 'buildPanels', () => {
          let { images: e, ring: t, panel: i } = hs,
            n = e.length,
            r = (Math.PI * 2) / n,
            o = r * (1 - i.gap);
          this.cornerUniforms.uPanelSize.value.set(t.radius * o, i.height);
          for (let a = 0; a < n; a += 1) {
            let l = a * r + (r - o) / 2,
              c = new Ac(
                t.radius,
                t.radius,
                i.height,
                i.radialSegments,
                1,
                !0,
                l,
                o,
              ),
              u = new ri(c, this.applyRoundedCorners(GC(a, n)));
            (this.cylinder.add(u),
              this.panels.push(u),
              this.loadTexture(e[a], a));
          }
        });
        y(this, 'loadTexture', (e, t) => {
          this.textureLoader.load(e, (i) => {
            let n = i;
            n.colorSpace = zt;
            let r = this.panels[t],
              o = r.material;
            ((r.material = this.applyRoundedCorners(
              new rn({ map: n, side: Gi }),
            )),
              Array.isArray(o) ? o.forEach((a) => a.dispose()) : o.dispose());
          });
        });
        y(this, 'applyRoundedCorners', (e) => {
          let t = e;
          return (
            (t.transparent = !0),
            (t.defines = Fi(pt({}, t.defines), { USE_UV: '' })),
            (t.onBeforeCompile = (i) => {
              (Object.assign(i.uniforms, this.cornerUniforms),
                Object.assign(i, {
                  fragmentShader: i.fragmentShader
                    .replace(
                      '#include <common>',
                      [
                        '#include <common>',
                        'uniform float uRadius;',
                        'uniform float uAA;',
                        'uniform vec2 uPanelSize;',
                      ].join(`
`),
                    )
                    .replace(
                      '#include <alphamap_fragment>',
                      [
                        '#include <alphamap_fragment>',
                        'vec2 rcPos = (vUv - 0.5) * uPanelSize;',
                        'vec2 rcEdge = abs(rcPos) - (0.5 * uPanelSize - vec2(uRadius));',
                        'float rcDist = length(max(rcEdge, 0.0)) + min(max(rcEdge.x, rcEdge.y), 0.0) - uRadius;',
                        'diffuseColor.a *= 1.0 - smoothstep(-uAA, 0.0, rcDist);',
                      ].join(`
`),
                    ),
                }));
            }),
            t
          );
        });
        this.rootElm = e;
        let { camera: t } = hs;
        ((this.scene = new Wn()),
          (this.camera = new di(t.fov, 1, t.near, t.far)),
          (this.camera.position.z = t.z),
          this.camera.lookAt(0, 0, 0),
          (this.cylinder = new Ri()),
          (this.tiltGroup = new Ri()),
          this.tiltGroup.add(this.cylinder),
          this.scene.add(this.tiltGroup),
          this.buildPanels());
      }
    };
  var _f = class {
    constructor() {
      y(this, 'rootElm');
      y(this, 'canvasElm');
      y(this, 'renderer', null);
      y(this, 'item', null);
      y(this, 'rafId', 0);
      y(this, 'isInitialized', !1);
      y(this, 'isInView', !1);
      y(this, 'onResized', () => {
        if (!this.renderer || !this.item || !this.canvasElm) return;
        let e = this.canvasElm.clientWidth,
          t = this.canvasElm.clientHeight;
        e === 0 ||
          t === 0 ||
          (this.renderer.setPixelRatio(
            Math.min(window.devicePixelRatio, hs.maxPixelRatio),
          ),
          this.renderer.setSize(e, t, !1),
          this.item.onResize(e, t));
      });
      y(this, 'init', () => {
        !this.checkElements() ||
          !this.rootElm ||
          (Fs({
            targets: [this.rootElm],
            options: { rootMargin: '200px 0px' },
            callback: this.onIntersect,
          }),
          document.addEventListener('visibilitychange', this.updateRunning),
          li.subscribe(this.updateRunning));
      });
      y(this, 'checkElements', () => !!(this.rootElm && this.canvasElm));
      y(this, 'onIntersect', (e) => {
        ((this.isInView = e.isIntersecting),
          this.isInView && !this.isInitialized && this.setupRenderer(),
          this.updateRunning());
      });
      y(this, 'updateRunning', () => {
        this.isInitialized &&
        this.isInView &&
        document.visibilityState === 'visible' &&
        !li.isOpen
          ? this.start()
          : this.stop();
      });
      y(this, 'start', () => {
        this.rafId || (this.rafId = window.requestAnimationFrame(this.animate));
      });
      y(this, 'stop', () => {
        this.rafId &&
          (window.cancelAnimationFrame(this.rafId), (this.rafId = 0));
      });
      y(this, 'setupRenderer', () => {
        if (!this.canvasElm || !this.rootElm || this.isInitialized) return;
        this.isInitialized = !0;
        let e = this.canvasElm.clientWidth || 1,
          t = this.canvasElm.clientHeight || 1;
        ((this.renderer = new hl({
          canvas: this.canvasElm,
          antialias: !0,
          alpha: !0,
        })),
          this.renderer.setPixelRatio(
            Math.min(window.devicePixelRatio, hs.maxPixelRatio),
          ),
          this.renderer.setSize(e, t, !1),
          (this.item = new gf(this.rootElm)),
          this.item.onResize(e, t),
          this.bindControls(),
          this.bindContextLoss());
      });
      y(this, 'bindControls', () => {
        this.canvasElm &&
          (this.canvasElm.addEventListener('pointerdown', this.onPointerDown),
          window.addEventListener('pointermove', this.onCursorMove, {
            passive: !0,
          }));
      });
      y(this, 'onCursorMove', (e) => {
        var i;
        if (
          !this.isInView ||
          !((i = this.item) != null && i.onCursorMove) ||
          e.pointerType !== 'mouse'
        )
          return;
        let t = window.innerHeight;
        t !== 0 && this.item.onCursorMove(qn((e.clientY / t) * 2 - 1, -1, 1));
      });
      y(this, 'onPointerDown', (e) => {
        var t;
        e.button === 0 &&
          ((t = this.item) == null || t.onPointerDown(e.clientX),
          window.addEventListener('pointermove', this.onPointerMove),
          window.addEventListener('pointerup', this.onPointerUp),
          window.addEventListener('pointercancel', this.onPointerUp));
      });
      y(this, 'onPointerMove', (e) => {
        var t;
        (t = this.item) == null || t.onPointerMove(e.clientX);
      });
      y(this, 'onPointerUp', () => {
        var e;
        ((e = this.item) == null || e.onPointerUp(),
          window.removeEventListener('pointermove', this.onPointerMove),
          window.removeEventListener('pointerup', this.onPointerUp),
          window.removeEventListener('pointercancel', this.onPointerUp));
      });
      y(this, 'bindContextLoss', () => {
        this.canvasElm &&
          (this.canvasElm.addEventListener(
            'webglcontextlost',
            this.onContextLost,
          ),
          this.canvasElm.addEventListener(
            'webglcontextrestored',
            this.onContextRestored,
          ));
      });
      y(this, 'onContextLost', (e) => {
        (e.preventDefault(), this.stop());
      });
      y(this, 'onContextRestored', () => {
        var e, t;
        ((t = (e = this.item) == null ? void 0 : e.onContextRestored) == null ||
          t.call(e),
          this.updateRunning());
      });
      y(this, 'animate', () => {
        if (
          ((this.rafId = window.requestAnimationFrame(this.animate)),
          !this.renderer || !this.item || !this.rootElm)
        )
          return;
        let e = this.rootElm.getBoundingClientRect(),
          t = window.innerHeight,
          i = qn((t - e.top) / (t + e.height), 0, 1);
        (this.item.onFrame(e, i),
          this.renderer.render(this.item.scene, this.item.camera));
      });
      ((this.rootElm = Ye(`[${T_.root}]`)),
        (this.canvasElm = this.rootElm
          ? Ye(`[${T_.canvas}]`, this.rootElm)
          : null),
        this.init());
    }
  };
  var WC = (s) => {
      var r, o;
      let e = s.getAttribute(Un.end),
        t = s.hasAttribute(Un.once),
        i = s.getAttribute(Un.triggerEl),
        n = s;
      if (i)
        try {
          n = (r = s.closest(i)) != null ? r : s;
        } catch (a) {}
      (Je.create(
        pt(
          pt(
            pt(
              {
                trigger: n,
                start: (o = s.getAttribute(Un.start)) != null ? o : w0,
                end: e != null ? e : 'bottom top',
                once: t,
                onEnter: () => {
                  (s.classList.remove(wt.leave, wt.leaveBack),
                    s.classList.add(wt.inview));
                },
              },
              t
                ? {}
                : {
                    onLeaveBack: () => {
                      s.classList.contains(wt.inview) &&
                        !s.classList.contains(wt.leave) &&
                        s.classList.add(wt.leaveBack);
                    },
                  },
            ),
            e && !t
              ? {
                  onLeave: () => s.classList.add(wt.leave),
                  onEnterBack: () => s.classList.remove(wt.leave),
                }
              : {},
          ),
          ks(s, 'anm'),
        ),
      ),
        t ||
          ma(n, () => {
            s.classList.remove(wt.inview, wt.leave, wt.leaveBack);
          }));
    },
    vf = class {
      constructor() {
        y(this, 'armed', !1);
        y(this, 'arm', () => {
          this.armed ||
            ((this.armed = !0),
            xi(`[${Un.target}]`).forEach((e) => {
              e.hasAttribute(Un.manual) || WC(e);
            }));
        });
        Ye(`[${Wr.root}]`) || this.arm();
      }
    };
  var xf = class {
    constructor() {
      y(this, 'targets');
      y(this, 'onResized', () => {
        this.measure();
      });
      ((this.targets = xi(`[${Un.lineGroups}]`)), this.measure());
    }
    measure() {
      this.targets.forEach((e) => {
        let t = xi('.anm-line', e),
          i = 0,
          n;
        t.forEach((r) => {
          r.offsetHeight !== 0 &&
            (n === void 0
              ? (n = r.offsetTop)
              : Math.abs(r.offsetTop - n) > r.offsetHeight / 2 &&
                ((i += 1), (n = r.offsetTop)),
            r.style.setProperty(A0, String(i)));
        });
      });
    }
  };
  var wb = '1.3.23';
  function Cb(s, e, t) {
    return Math.max(s, Math.min(e, t));
  }
  function XC(s, e, t) {
    return (1 - t) * s + t * e;
  }
  function YC(s, e, t, i) {
    return XC(s, e, 1 - Math.exp(-t * i));
  }
  function qC(s, e) {
    return ((s % e) + e) % e;
  }
  var ZC = class {
    constructor() {
      y(this, 'isRunning', !1);
      y(this, 'value', 0);
      y(this, 'from', 0);
      y(this, 'to', 0);
      y(this, 'currentTime', 0);
      y(this, 'lerp');
      y(this, 'duration');
      y(this, 'easing');
      y(this, 'onUpdate');
    }
    advance(s) {
      var t;
      if (!this.isRunning) return;
      let e = !1;
      if (this.duration && this.easing) {
        this.currentTime += s;
        let i = Cb(0, this.currentTime / this.duration, 1);
        e = i >= 1;
        let n = e ? 1 : this.easing(i);
        this.value = this.from + (this.to - this.from) * n;
      } else
        this.lerp
          ? ((this.value = YC(this.value, this.to, this.lerp * 60, s)),
            Math.round(this.value) === Math.round(this.to) &&
              ((this.value = this.to), (e = !0)))
          : ((this.value = this.to), (e = !0));
      (e && this.stop(),
        (t = this.onUpdate) == null || t.call(this, this.value, e));
    }
    stop() {
      this.isRunning = !1;
    }
    fromTo(s, e, { lerp: t, duration: i, easing: n, onStart: r, onUpdate: o }) {
      ((this.from = this.value = s),
        (this.to = e),
        (this.lerp = t),
        (this.duration = i),
        (this.easing = n),
        (this.currentTime = 0),
        (this.isRunning = !0),
        r == null || r(),
        (this.onUpdate = o));
    }
  };
  function KC(s, e) {
    let t;
    return function (...i) {
      (clearTimeout(t),
        (t = setTimeout(() => {
          ((t = void 0), s.apply(this, i));
        }, e)));
    };
  }
  var $C = class {
      constructor(s, e, { autoResize: t = !0, debounce: i = 250 } = {}) {
        y(this, 'width', 0);
        y(this, 'height', 0);
        y(this, 'scrollHeight', 0);
        y(this, 'scrollWidth', 0);
        y(this, 'debouncedResize');
        y(this, 'wrapperResizeObserver');
        y(this, 'contentResizeObserver');
        y(this, 'resize', () => {
          (this.onWrapperResize(), this.onContentResize());
        });
        y(this, 'onWrapperResize', () => {
          this.wrapper instanceof Window
            ? ((this.width = window.innerWidth),
              (this.height = window.innerHeight))
            : ((this.width = this.wrapper.clientWidth),
              (this.height = this.wrapper.clientHeight));
        });
        y(this, 'onContentResize', () => {
          this.wrapper instanceof Window
            ? ((this.scrollHeight = this.content.scrollHeight),
              (this.scrollWidth = this.content.scrollWidth))
            : ((this.scrollHeight = this.wrapper.scrollHeight),
              (this.scrollWidth = this.wrapper.scrollWidth));
        });
        ((this.wrapper = s),
          (this.content = e),
          t &&
            ((this.debouncedResize = KC(this.resize, i)),
            this.wrapper instanceof Window
              ? window.addEventListener('resize', this.debouncedResize)
              : ((this.wrapperResizeObserver = new ResizeObserver(
                  this.debouncedResize,
                )),
                this.wrapperResizeObserver.observe(this.wrapper)),
            (this.contentResizeObserver = new ResizeObserver(
              this.debouncedResize,
            )),
            this.contentResizeObserver.observe(this.content)),
          this.resize());
      }
      destroy() {
        var s, e;
        ((s = this.wrapperResizeObserver) == null || s.disconnect(),
          (e = this.contentResizeObserver) == null || e.disconnect(),
          this.wrapper === window &&
            this.debouncedResize &&
            window.removeEventListener('resize', this.debouncedResize));
      }
      get limit() {
        return {
          x: this.scrollWidth - this.width,
          y: this.scrollHeight - this.height,
        };
      }
    },
    Pb = class {
      constructor() {
        y(this, 'events', {});
      }
      emit(s, ...e) {
        var i;
        let t = this.events[s] || [];
        for (let n = 0, r = t.length; n < r; n++)
          (i = t[n]) == null || i.call(t, ...e);
      }
      on(s, e) {
        return (
          this.events[s] ? this.events[s].push(e) : (this.events[s] = [e]),
          () => {
            var t;
            this.events[s] =
              (t = this.events[s]) == null ? void 0 : t.filter((i) => e !== i);
          }
        );
      }
      off(s, e) {
        var t;
        this.events[s] =
          (t = this.events[s]) == null ? void 0 : t.filter((i) => e !== i);
      }
      destroy() {
        this.events = {};
      }
    },
    jC = 100 / 6,
    mo = { passive: !1 };
  function Ab(s, e) {
    return s === 1 ? jC : s === 2 ? e : 1;
  }
  var JC = class {
      constructor(s, e = { wheelMultiplier: 1, touchMultiplier: 1 }) {
        y(this, 'touchStart', { x: 0, y: 0 });
        y(this, 'lastDelta', { x: 0, y: 0 });
        y(this, 'window', { width: 0, height: 0 });
        y(this, 'emitter', new Pb());
        y(this, 'onTouchStart', (s) => {
          let { clientX: e, clientY: t } = s.targetTouches
            ? s.targetTouches[0]
            : s;
          ((this.touchStart.x = e),
            (this.touchStart.y = t),
            (this.lastDelta = { x: 0, y: 0 }),
            this.emitter.emit('scroll', { deltaX: 0, deltaY: 0, event: s }));
        });
        y(this, 'onTouchMove', (s) => {
          let { clientX: e, clientY: t } = s.targetTouches
              ? s.targetTouches[0]
              : s,
            i = -(e - this.touchStart.x) * this.options.touchMultiplier,
            n = -(t - this.touchStart.y) * this.options.touchMultiplier;
          ((this.touchStart.x = e),
            (this.touchStart.y = t),
            (this.lastDelta = { x: i, y: n }),
            this.emitter.emit('scroll', { deltaX: i, deltaY: n, event: s }));
        });
        y(this, 'onTouchEnd', (s) => {
          this.emitter.emit('scroll', {
            deltaX: this.lastDelta.x,
            deltaY: this.lastDelta.y,
            event: s,
          });
        });
        y(this, 'onWheel', (s) => {
          let { deltaX: e, deltaY: t, deltaMode: i } = s,
            n = Ab(i, this.window.width),
            r = Ab(i, this.window.height);
          ((e *= n),
            (t *= r),
            (e *= this.options.wheelMultiplier),
            (t *= this.options.wheelMultiplier),
            this.emitter.emit('scroll', { deltaX: e, deltaY: t, event: s }));
        });
        y(this, 'onWindowResize', () => {
          this.window = {
            width: window.innerWidth,
            height: window.innerHeight,
          };
        });
        ((this.element = s),
          (this.options = e),
          window.addEventListener('resize', this.onWindowResize),
          this.onWindowResize(),
          this.element.addEventListener('wheel', this.onWheel, mo),
          this.element.addEventListener('touchstart', this.onTouchStart, mo),
          this.element.addEventListener('touchmove', this.onTouchMove, mo),
          this.element.addEventListener('touchend', this.onTouchEnd, mo));
      }
      on(s, e) {
        return this.emitter.on(s, e);
      }
      destroy() {
        (this.emitter.destroy(),
          window.removeEventListener('resize', this.onWindowResize),
          this.element.removeEventListener('wheel', this.onWheel, mo),
          this.element.removeEventListener('touchstart', this.onTouchStart, mo),
          this.element.removeEventListener('touchmove', this.onTouchMove, mo),
          this.element.removeEventListener('touchend', this.onTouchEnd, mo));
      }
    },
    Rb = (s) => Math.min(1, 1.001 - Zi(2, -10 * s)),
    Lb = class {
      constructor({
        wrapper: s = window,
        content: e = document.documentElement,
        eventsTarget: t = s,
        smoothWheel: i = !0,
        syncTouch: n = !1,
        syncTouchLerp: r = 0.075,
        touchInertiaExponent: o = 1.7,
        duration: a,
        easing: l,
        lerp: c = 0.1,
        infinite: u = !1,
        orientation: f = 'vertical',
        gestureOrientation: d = f === 'horizontal' ? 'both' : 'vertical',
        touchMultiplier: p = 1,
        wheelMultiplier: _ = 1,
        autoResize: x = !0,
        prevent: g,
        virtualScroll: v,
        overscroll: w = !0,
        autoRaf: L = !1,
        anchors: R = !1,
        autoToggle: U = !1,
        allowNestedScroll: O = !1,
        __experimental__naiveDimensions: N = !1,
        naiveDimensions: M = N,
        stopInertiaOnNavigate: I = !1,
      } = {}) {
        y(this, '_isScrolling', !1);
        y(this, '_isStopped', !1);
        y(this, '_isLocked', !1);
        y(this, '_preventNextNativeScrollEvent', !1);
        y(this, '_resetVelocityTimeout', null);
        y(this, '_rafId', null);
        y(this, 'isTouching');
        y(this, 'time', 0);
        y(this, 'userData', {});
        y(this, 'lastVelocity', 0);
        y(this, 'velocity', 0);
        y(this, 'direction', 0);
        y(this, 'options');
        y(this, 'targetScroll');
        y(this, 'animatedScroll');
        y(this, 'animate', new ZC());
        y(this, 'emitter', new Pb());
        y(this, 'dimensions');
        y(this, 'virtualScroll');
        y(this, 'onScrollEnd', (s) => {
          s instanceof CustomEvent ||
            ((this.isScrolling === 'smooth' || this.isScrolling === !1) &&
              s.stopPropagation());
        });
        y(this, 'dispatchScrollendEvent', () => {
          this.options.wrapper.dispatchEvent(
            new CustomEvent('scrollend', {
              bubbles: this.options.wrapper === window,
              detail: { lenisScrollEnd: !0 },
            }),
          );
        });
        y(this, 'onTransitionEnd', (s) => {
          var e;
          (e = s.propertyName) != null &&
            e.includes('overflow') &&
            s.target === this.rootElement &&
            this.checkOverflow();
        });
        y(this, 'onClick', (s) => {
          let e = s
              .composedPath()
              .filter((i) => i instanceof HTMLAnchorElement && i.href)
              .map((i) => new URL(i.href)),
            t = new URL(window.location.href);
          if (this.options.anchors) {
            let i = e.find(
              (n) => t.host === n.host && t.pathname === n.pathname && n.hash,
            );
            if (i) {
              let n =
                  typeof this.options.anchors == 'object' &&
                  this.options.anchors
                    ? this.options.anchors
                    : void 0,
                r = `#${i.hash.split('#')[1]}`;
              this.scrollTo(r, n);
              return;
            }
          }
          if (
            this.options.stopInertiaOnNavigate &&
            e.some((i) => t.host === i.host && t.pathname !== i.pathname)
          ) {
            this.reset();
            return;
          }
        });
        y(this, 'onPointerDown', (s) => {
          s.button === 1 && this.reset();
        });
        y(this, 'onVirtualScroll', (s) => {
          if (
            typeof this.options.virtualScroll == 'function' &&
            this.options.virtualScroll(s) === !1
          )
            return;
          let { deltaX: e, deltaY: t, event: i } = s;
          if (
            (this.emitter.emit('virtual-scroll', {
              deltaX: e,
              deltaY: t,
              event: i,
            }),
            i.ctrlKey || i.lenisStopPropagation)
          )
            return;
          let n = i.type.includes('touch'),
            r = i.type.includes('wheel');
          this.isTouching = i.type === 'touchstart' || i.type === 'touchmove';
          let o = e === 0 && t === 0;
          if (
            this.options.syncTouch &&
            n &&
            i.type === 'touchstart' &&
            o &&
            !this.isStopped &&
            !this.isLocked
          ) {
            this.reset();
            return;
          }
          let a =
            (this.options.gestureOrientation === 'vertical' && t === 0) ||
            (this.options.gestureOrientation === 'horizontal' && e === 0);
          if (o || a) return;
          let l = i.composedPath();
          l = l.slice(0, l.indexOf(this.rootElement));
          let c = this.options.prevent,
            u = Math.abs(e) >= Math.abs(t) ? 'horizontal' : 'vertical';
          if (
            l.find((_) => {
              var x, g, v, w, L;
              return (
                _ instanceof HTMLElement &&
                ((typeof c == 'function' && (c == null ? void 0 : c(_))) ||
                  ((x = _.hasAttribute) == null
                    ? void 0
                    : x.call(_, 'data-lenis-prevent')) ||
                  (u === 'vertical' &&
                    ((g = _.hasAttribute) == null
                      ? void 0
                      : g.call(_, 'data-lenis-prevent-vertical'))) ||
                  (u === 'horizontal' &&
                    ((v = _.hasAttribute) == null
                      ? void 0
                      : v.call(_, 'data-lenis-prevent-horizontal'))) ||
                  (n &&
                    ((w = _.hasAttribute) == null
                      ? void 0
                      : w.call(_, 'data-lenis-prevent-touch'))) ||
                  (r &&
                    ((L = _.hasAttribute) == null
                      ? void 0
                      : L.call(_, 'data-lenis-prevent-wheel'))) ||
                  (this.options.allowNestedScroll &&
                    this.hasNestedScroll(_, { deltaX: e, deltaY: t })))
              );
            })
          )
            return;
          if (this.isStopped || this.isLocked) {
            i.cancelable && i.preventDefault();
            return;
          }
          if (
            !((this.options.syncTouch && n) || (this.options.smoothWheel && r))
          ) {
            ((this.isScrolling = 'native'),
              this.animate.stop(),
              (i.lenisStopPropagation = !0));
            return;
          }
          let f = t;
          (this.options.gestureOrientation === 'both'
            ? (f = Math.abs(t) > Math.abs(e) ? t : e)
            : this.options.gestureOrientation === 'horizontal' && (f = e),
            (!this.options.overscroll ||
              this.options.infinite ||
              (this.options.wrapper !== window &&
                this.limit > 0 &&
                ((this.animatedScroll > 0 &&
                  this.animatedScroll < this.limit) ||
                  (this.animatedScroll === 0 && t > 0) ||
                  (this.animatedScroll === this.limit && t < 0)))) &&
              (i.lenisStopPropagation = !0),
            i.cancelable && i.preventDefault());
          let d = n && this.options.syncTouch,
            p = n && i.type === 'touchend';
          (p &&
            (f =
              Math.sign(f) *
              Zi(Math.abs(this.velocity), this.options.touchInertiaExponent)),
            this.scrollTo(
              this.targetScroll + f,
              pt(
                { programmatic: !1 },
                d
                  ? { lerp: p ? this.options.syncTouchLerp : 1 }
                  : {
                      lerp: this.options.lerp,
                      duration: this.options.duration,
                      easing: this.options.easing,
                    },
              ),
            ));
        });
        y(this, 'onNativeScroll', () => {
          if (
            (this._resetVelocityTimeout !== null &&
              (clearTimeout(this._resetVelocityTimeout),
              (this._resetVelocityTimeout = null)),
            this._preventNextNativeScrollEvent)
          ) {
            this._preventNextNativeScrollEvent = !1;
            return;
          }
          if (this.isScrolling === !1 || this.isScrolling === 'native') {
            let s = this.animatedScroll;
            ((this.animatedScroll = this.targetScroll = this.actualScroll),
              (this.lastVelocity = this.velocity),
              (this.velocity = this.animatedScroll - s),
              (this.direction = Math.sign(this.animatedScroll - s)),
              this.isStopped || (this.isScrolling = 'native'),
              this.emit(),
              this.velocity !== 0 &&
                (this._resetVelocityTimeout = setTimeout(() => {
                  ((this.lastVelocity = this.velocity),
                    (this.velocity = 0),
                    (this.isScrolling = !1),
                    this.emit());
                }, 400)));
          }
        });
        y(this, 'raf', (s) => {
          let e = s - (this.time || s);
          ((this.time = s),
            this.animate.advance(e * 0.001),
            this.options.autoRaf &&
              (this._rafId = requestAnimationFrame(this.raf)));
        });
        ((window.lenisVersion = wb),
          window.lenis || (window.lenis = {}),
          (window.lenis.version = wb),
          f === 'horizontal' && (window.lenis.horizontal = !0),
          n === !0 && (window.lenis.touch = !0),
          (!s || s === document.documentElement) && (s = window),
          typeof a == 'number' && typeof l != 'function'
            ? (l = Rb)
            : typeof l == 'function' && typeof a != 'number' && (a = 1),
          (this.options = {
            wrapper: s,
            content: e,
            eventsTarget: t,
            smoothWheel: i,
            syncTouch: n,
            syncTouchLerp: r,
            touchInertiaExponent: o,
            duration: a,
            easing: l,
            lerp: c,
            infinite: u,
            gestureOrientation: d,
            orientation: f,
            touchMultiplier: p,
            wheelMultiplier: _,
            autoResize: x,
            prevent: g,
            virtualScroll: v,
            overscroll: w,
            autoRaf: L,
            anchors: R,
            autoToggle: U,
            allowNestedScroll: O,
            naiveDimensions: M,
            stopInertiaOnNavigate: I,
          }),
          (this.dimensions = new $C(s, e, { autoResize: x })),
          this.updateClassName(),
          (this.targetScroll = this.animatedScroll = this.actualScroll),
          this.options.wrapper.addEventListener('scroll', this.onNativeScroll),
          this.options.wrapper.addEventListener('scrollend', this.onScrollEnd, {
            capture: !0,
          }),
          (this.options.anchors || this.options.stopInertiaOnNavigate) &&
            this.options.wrapper.addEventListener('click', this.onClick),
          this.options.wrapper.addEventListener(
            'pointerdown',
            this.onPointerDown,
          ),
          (this.virtualScroll = new JC(t, {
            touchMultiplier: p,
            wheelMultiplier: _,
          })),
          this.virtualScroll.on('scroll', this.onVirtualScroll),
          this.options.autoToggle &&
            (this.checkOverflow(),
            this.rootElement.addEventListener(
              'transitionend',
              this.onTransitionEnd,
            )),
          this.options.autoRaf &&
            (this._rafId = requestAnimationFrame(this.raf)));
      }
      destroy() {
        (this.emitter.destroy(),
          this.options.wrapper.removeEventListener(
            'scroll',
            this.onNativeScroll,
          ),
          this.options.wrapper.removeEventListener(
            'scrollend',
            this.onScrollEnd,
            { capture: !0 },
          ),
          this.options.wrapper.removeEventListener(
            'pointerdown',
            this.onPointerDown,
          ),
          (this.options.anchors || this.options.stopInertiaOnNavigate) &&
            this.options.wrapper.removeEventListener('click', this.onClick),
          this.virtualScroll.destroy(),
          this.dimensions.destroy(),
          this.cleanUpClassName(),
          this._rafId && cancelAnimationFrame(this._rafId));
      }
      on(s, e) {
        return this.emitter.on(s, e);
      }
      off(s, e) {
        return this.emitter.off(s, e);
      }
      get overflow() {
        let s = this.isHorizontal ? 'overflow-x' : 'overflow-y';
        return getComputedStyle(this.rootElement)[s];
      }
      checkOverflow() {
        ['hidden', 'clip'].includes(this.overflow)
          ? this.internalStop()
          : this.internalStart();
      }
      setScroll(s) {
        this.isHorizontal
          ? this.options.wrapper.scrollTo({ left: s, behavior: 'instant' })
          : this.options.wrapper.scrollTo({ top: s, behavior: 'instant' });
      }
      resize() {
        (this.dimensions.resize(),
          (this.animatedScroll = this.targetScroll = this.actualScroll),
          this.emit());
      }
      emit() {
        this.emitter.emit('scroll', this);
      }
      reset() {
        ((this.isLocked = !1),
          (this.isScrolling = !1),
          (this.animatedScroll = this.targetScroll = this.actualScroll),
          (this.lastVelocity = this.velocity = 0),
          this.animate.stop());
      }
      start() {
        if (this.isStopped) {
          if (this.options.autoToggle) {
            this.rootElement.style.removeProperty('overflow');
            return;
          }
          this.internalStart();
        }
      }
      internalStart() {
        this.isStopped && (this.reset(), (this.isStopped = !1), this.emit());
      }
      stop() {
        if (!this.isStopped) {
          if (this.options.autoToggle) {
            this.rootElement.style.setProperty('overflow', 'clip');
            return;
          }
          this.internalStop();
        }
      }
      internalStop() {
        this.isStopped || (this.reset(), (this.isStopped = !0), this.emit());
      }
      scrollTo(
        s,
        {
          offset: e = 0,
          immediate: t = !1,
          lock: i = !1,
          programmatic: n = !0,
          lerp: r = n ? this.options.lerp : void 0,
          duration: o = n ? this.options.duration : void 0,
          easing: a = n ? this.options.easing : void 0,
          onStart: l,
          onComplete: c,
          force: u = !1,
          userData: f,
        } = {},
      ) {
        if ((this.isStopped || this.isLocked) && !u) return;
        let d = s,
          p = e;
        if (typeof d == 'string' && ['top', 'left', 'start', '#'].includes(d))
          d = 0;
        else if (typeof d == 'string' && ['bottom', 'right', 'end'].includes(d))
          d = this.limit;
        else {
          let _ = null;
          if (
            (typeof d == 'string'
              ? ((_ = document.querySelector(d)),
                _ || (d === '#top' && (d = 0)))
              : d instanceof HTMLElement && d != null && d.nodeType && (_ = d),
            _)
          ) {
            if (this.options.wrapper !== window) {
              let R = this.rootElement.getBoundingClientRect();
              p -= this.isHorizontal ? R.left : R.top;
            }
            let x = _.getBoundingClientRect(),
              g = getComputedStyle(_),
              v = this.isHorizontal
                ? Number.parseFloat(g.scrollMarginLeft)
                : Number.parseFloat(g.scrollMarginTop),
              w = getComputedStyle(this.rootElement),
              L = this.isHorizontal
                ? Number.parseFloat(w.scrollPaddingLeft)
                : Number.parseFloat(w.scrollPaddingTop);
            d =
              (this.isHorizontal ? x.left : x.top) +
              this.animatedScroll -
              (Number.isNaN(v) ? 0 : v) -
              (Number.isNaN(L) ? 0 : L);
          }
        }
        if (typeof d == 'number') {
          if (((d += p), this.options.infinite)) {
            if (n) {
              this.targetScroll = this.animatedScroll = this.scroll;
              let _ = d - this.animatedScroll;
              _ > this.limit / 2
                ? (d -= this.limit)
                : _ < -this.limit / 2 && (d += this.limit);
            }
          } else d = Cb(0, d, this.limit);
          if (d === this.targetScroll) {
            (l == null || l(this), c == null || c(this));
            return;
          }
          if (((this.userData = f != null ? f : {}), t)) {
            ((this.animatedScroll = this.targetScroll = d),
              this.setScroll(this.scroll),
              this.reset(),
              this.preventNextNativeScrollEvent(),
              this.emit(),
              c == null || c(this),
              (this.userData = {}),
              requestAnimationFrame(() => {
                this.dispatchScrollendEvent();
              }));
            return;
          }
          (n || (this.targetScroll = d),
            typeof o == 'number' && typeof a != 'function'
              ? (a = Rb)
              : typeof a == 'function' && typeof o != 'number' && (o = 1),
            this.animate.fromTo(this.animatedScroll, d, {
              duration: o,
              easing: a,
              lerp: r,
              onStart: () => {
                (i && (this.isLocked = !0),
                  (this.isScrolling = 'smooth'),
                  l == null || l(this));
              },
              onUpdate: (_, x) => {
                ((this.isScrolling = 'smooth'),
                  (this.lastVelocity = this.velocity),
                  (this.velocity = _ - this.animatedScroll),
                  (this.direction = Math.sign(this.velocity)),
                  (this.animatedScroll = _),
                  this.setScroll(this.scroll),
                  n && (this.targetScroll = _),
                  x || this.emit(),
                  x &&
                    (this.reset(),
                    this.emit(),
                    c == null || c(this),
                    (this.userData = {}),
                    requestAnimationFrame(() => {
                      this.dispatchScrollendEvent();
                    }),
                    this.preventNextNativeScrollEvent()));
              },
            }));
        }
      }
      preventNextNativeScrollEvent() {
        ((this._preventNextNativeScrollEvent = !0),
          requestAnimationFrame(() => {
            this._preventNextNativeScrollEvent = !1;
          }));
      }
      hasNestedScroll(s, { deltaX: e, deltaY: t }) {
        var O;
        let i = Date.now();
        s._lenis || (s._lenis = {});
        let n = s._lenis,
          r,
          o,
          a,
          l,
          c,
          u,
          f,
          d,
          p,
          _;
        if (i - ((O = n.time) != null ? O : 0) > 2e3) {
          n.time = Date.now();
          let N = window.getComputedStyle(s);
          if (
            ((n.computedStyle = N),
            (r = ['auto', 'overlay', 'scroll'].includes(N.overflowX)),
            (o = ['auto', 'overlay', 'scroll'].includes(N.overflowY)),
            (c = ['auto'].includes(N.overscrollBehaviorX)),
            (u = ['auto'].includes(N.overscrollBehaviorY)),
            (n.hasOverflowX = r),
            (n.hasOverflowY = o),
            !(r || o))
          )
            return !1;
          ((f = s.scrollWidth),
            (d = s.scrollHeight),
            (p = s.clientWidth),
            (_ = s.clientHeight),
            (a = f > p),
            (l = d > _),
            (n.isScrollableX = a),
            (n.isScrollableY = l),
            (n.scrollWidth = f),
            (n.scrollHeight = d),
            (n.clientWidth = p),
            (n.clientHeight = _),
            (n.hasOverscrollBehaviorX = c),
            (n.hasOverscrollBehaviorY = u));
        } else
          ((a = n.isScrollableX),
            (l = n.isScrollableY),
            (r = n.hasOverflowX),
            (o = n.hasOverflowY),
            (f = n.scrollWidth),
            (d = n.scrollHeight),
            (p = n.clientWidth),
            (_ = n.clientHeight),
            (c = n.hasOverscrollBehaviorX),
            (u = n.hasOverscrollBehaviorY));
        if (!((r && a) || (o && l))) return !1;
        let x = Math.abs(e) >= Math.abs(t) ? 'horizontal' : 'vertical',
          g,
          v,
          w,
          L,
          R,
          U;
        if (x === 'horizontal')
          ((g = Math.round(s.scrollLeft)),
            (v = f - p),
            (w = e),
            (L = r),
            (R = a),
            (U = c));
        else if (x === 'vertical')
          ((g = Math.round(s.scrollTop)),
            (v = d - _),
            (w = t),
            (L = o),
            (R = l),
            (U = u));
        else return !1;
        return !U && (g >= v || g <= 0)
          ? !0
          : (w > 0 ? g < v : g > 0) && L && R;
      }
      get rootElement() {
        return this.options.wrapper === window
          ? document.documentElement
          : this.options.wrapper;
      }
      get limit() {
        return this.options.naiveDimensions
          ? this.isHorizontal
            ? this.rootElement.scrollWidth - this.rootElement.clientWidth
            : this.rootElement.scrollHeight - this.rootElement.clientHeight
          : this.dimensions.limit[this.isHorizontal ? 'x' : 'y'];
      }
      get isHorizontal() {
        return this.options.orientation === 'horizontal';
      }
      get actualScroll() {
        var e, t;
        let s = this.options.wrapper;
        return this.isHorizontal
          ? (e = s.scrollX) != null
            ? e
            : s.scrollLeft
          : (t = s.scrollY) != null
            ? t
            : s.scrollTop;
      }
      get scroll() {
        return this.options.infinite
          ? qC(this.animatedScroll, this.limit)
          : this.animatedScroll;
      }
      get progress() {
        return this.limit === 0 ? 1 : this.scroll / this.limit;
      }
      get isScrolling() {
        return this._isScrolling;
      }
      set isScrolling(s) {
        this._isScrolling !== s &&
          ((this._isScrolling = s), this.updateClassName());
      }
      get isStopped() {
        return this._isStopped;
      }
      set isStopped(s) {
        this._isStopped !== s &&
          ((this._isStopped = s), this.updateClassName());
      }
      get isLocked() {
        return this._isLocked;
      }
      set isLocked(s) {
        this._isLocked !== s && ((this._isLocked = s), this.updateClassName());
      }
      get isSmooth() {
        return this.isScrolling === 'smooth';
      }
      get className() {
        let s = 'lenis';
        return (
          this.options.autoToggle && (s += ' lenis-autoToggle'),
          this.isStopped && (s += ' lenis-stopped'),
          this.isLocked && (s += ' lenis-locked'),
          this.isScrolling && (s += ' lenis-scrolling'),
          this.isScrolling === 'smooth' && (s += ' lenis-smooth'),
          s
        );
      }
      updateClassName() {
        (this.cleanUpClassName(),
          this.className.split(' ').forEach((s) => {
            this.rootElement.classList.add(s);
          }));
      }
      cleanUpClassName() {
        for (let s of Array.from(this.rootElement.classList))
          (s === 'lenis' || s.startsWith('lenis-')) &&
            this.rootElement.classList.remove(s);
      }
    };
  var yf = class {
    constructor() {
      y(this, 'lenis');
      y(this, 'lockSources', new Set());
      y(this, 'bfcacheLeaveY', 0);
      y(this, 'onResized', () => {
        (this.lenis.resize(), Je.refresh());
      });
      y(this, 'syncScroll', (e) => {
        this.lenis.scrollTo(e, { immediate: !0, force: !0 });
      });
      y(this, 'stop', (e) => {
        (this.lockSources.add(e), this.lenis.stop());
      });
      y(this, 'start', (e) => {
        (this.lockSources.delete(e),
          this.lockSources.size === 0 && this.lenis.start());
      });
      y(this, 'onTick', (e) => {
        this.lenis.raf(e * 1e3);
      });
      y(this, 'onModalToggle', (e) => {
        e ? this.stop('modal') : this.start('modal');
      });
      y(this, 'injectScrollAnchor', () => {
        this.applyScrollAnchor() ||
          document.addEventListener(
            go.ready,
            () => {
              this.applyScrollAnchor();
            },
            { once: !0 },
          );
      });
      y(this, 'applyScrollAnchor', () => {
        var t;
        let e = (t = window.atCmn) == null ? void 0 : t.scrollAnchor;
        return e
          ? (e.setScrollTo((i) => {
              let n = i <= 0 ? 0 : Math.ceil(i) + 1;
              document.dispatchEvent(
                new CustomEvent(Th, { detail: { top: n } }),
              );
              let r = Math.min(
                N0,
                Math.max(O0, Math.abs(n - window.scrollY) / D0),
              );
              this.lenis.scrollTo(n, {
                duration: r,
                easing: F0,
                onComplete: () => {
                  document.dispatchEvent(new Event(Mh));
                },
              });
            }),
            !0)
          : !1;
      });
      (Et.registerPlugin(Je),
        Je.config({ ignoreMobileResize: !0 }),
        (this.lenis = new Lb(hdjf9Story ? { ...U0, smoothWheel: false, syncTouch: false, prevent: (element) => !hdjf9Story.contains(element) || U0.prevent(element) } : U0)),
        this.lenis.on('scroll', () => Je.update()),
        Et.ticker.add(this.onTick),
        Et.ticker.lagSmoothing(0),
        window.addEventListener('pagehide', () => {
          this.bfcacheLeaveY = window.scrollY;
        }),
        window.addEventListener('pageshow', (e) => {
          e.persisted && (this.syncScroll(this.bfcacheLeaveY), Je.update());
        }),
        li.subscribe(this.onModalToggle),
        this.injectScrollAnchor());
    }
  };
  var kb = Jb(Db());
  var na = {
      pinArea: 'data-soniclink-pin-area',
      sticky: 'data-soniclink-sticky',
      catchPinArea: 'data-soniclink-catch-pin-area',
      catchSticky: 'data-soniclink-catch-sticky',
      bg: 'data-soniclink-bg',
      canvas: 'data-soniclink-canvas',
    },
    jc = {
      in: { start: 'top center', end: 'top top' },
      out: { start: 'bottom bottom', end: 'bottom center' },
    },
    M_ = { start: 'top bottom+=100%', end: 'bottom top-=100%' },
    Ob = 0.75,
    Nb = 0.24,
    Fb = 0.3,
    Ub = 0.6,
    Bb = 0.5,
    w_ = { pc: 1.5, sp: 0.7 },
    A_ = { velocityDivisor: 1500, maxBoost: 3, decaySeconds: 0.8 };
  var Sf = class {
    constructor() {
      y(this, 'scene', null);
      y(this, 'speedLayers', []);
      y(this, 'speedFactor', { value: 1 });
      y(
        this,
        'decayTween',
        Et.to(this.speedFactor, {
          value: 1,
          duration: A_.decaySeconds,
          ease: 'power2.out',
          paused: !0,
          onUpdate: () => this.applySpeed(),
        }),
      );
      y(this, 'canvasHostElm', null);
      y(this, 'bgActive', !1);
      y(this, 'initStarted', !1);
      y(this, 'contentAnm', null);
      y(this, 'onBgActiveToggle', (e) => {
        ((this.bgActive = e.isActive),
          e.isActive &&
            !this.initStarted &&
            this.canvasHostElm &&
            ((this.initStarted = !0), this.initScene(this.canvasHostElm)),
          this.applyPausedState());
      });
      y(this, 'initScene', (e) => {
        (e.setAttribute('data-us-dpi', String(Xt() ? w_.sp : w_.pc)),
          kb.default
            .init()
            .then((t) => {
              var i, n, r;
              ((this.scene =
                (i = t.find((o) => o.element === e)) != null ? i : null),
                (this.speedLayers = (
                  (r = (n = this.scene) == null ? void 0 : n.layers) != null
                    ? r
                    : []
                )
                  .filter((o) => typeof o.speed == 'number')
                  .map((o) => ({ layer: o, base: o.speed }))),
                this.applyPausedState());
            })
            .catch(() => {}));
      });
      y(this, 'onPinUpdate', (e) => {
        var r;
        if (
          ((r = this.contentAnm) == null || r.applyLeave(e.progress >= Ob),
          this.speedLayers.length === 0)
        )
          return;
        let { velocityDivisor: t, maxBoost: i } = A_,
          n = 1 + Math.min(Math.abs(e.getVelocity()) / t, i);
        (n > this.speedFactor.value &&
          ((this.speedFactor.value = n), this.applySpeed()),
          this.decayTween.invalidate().restart());
      });
      y(this, 'applySpeed', () => {
        this.speedLayers.forEach(({ layer: e, base: t }) => {
          e.speed = t * this.speedFactor.value;
        });
      });
      y(this, 'applyPausedState', () => {
        if (!this.scene) return;
        let e = li.isOpen || !this.bgActive;
        this.scene.paused = e;
      });
      let e = Ye(`[${na.pinArea}]`),
        t = Ye(`[${na.sticky}]`),
        i = Ye(`[${na.catchPinArea}]`),
        n = Ye(`[${na.catchSticky}]`),
        r = Ye(`[${na.bg}]`),
        o = Ye(`[${na.canvas}]`),
        a = null;
      if (i && n) {
        a = wo(i, void 0, i);
        let l = a,
          c = 0;
        Ao(
          i,
          n,
          {
            onUpdate: (u) => {
              let { progress: f } = u,
                d = Xt() ? Fb : Nb,
                p = Xt() ? Bb : Ub;
              (c < d && f >= d ? l.enter() : c >= d && f < d && l.leaveBack(),
                l.applyLeave(f >= p),
                (c = f));
            },
            onLeave: () => l.applyLeave(!0),
            onLeaveBack: l.leaveBack,
            onEnterBack: () => {
              var u;
              return (u = this.contentAnm) == null ? void 0 : u.reset();
            },
          },
          { end: 'bottom top' },
        );
      }
      (e &&
        t &&
        ((this.contentAnm = wo(e, void 0, e)),
        Ao(e, t, {
          onUpdate: this.onPinUpdate,
          onEnter: () => {
            var l;
            return (l = this.contentAnm) == null ? void 0 : l.enter();
          },
          onLeave: () => {
            var l;
            return (l = this.contentAnm) == null ? void 0 : l.applyLeave(!0);
          },
          onLeaveBack: () => {
            var l;
            return (l = this.contentAnm) == null ? void 0 : l.leaveBack();
          },
        })),
        !(!e || !r || !o) &&
          ((this.canvasHostElm = o),
          Et.to(r, {
            opacity: 1,
            ease: 'none',
            scrollTrigger: {
              trigger: e,
              start: jc.in.start,
              end: jc.in.end,
              scrub: !0,
            },
          }),
          Et.to(r, {
            opacity: 0,
            ease: 'none',
            immediateRender: !1,
            scrollTrigger: {
              trigger: e,
              start: jc.out.start,
              end: jc.out.end,
              scrub: !0,
            },
          }),
          Je.create({
            trigger: e,
            start: M_.start,
            end: M_.end,
            onToggle: this.onBgActiveToggle,
          }),
          li.subscribe(this.applyPausedState)));
    }
  };
  var Ef = {
      root: 'data-testimonial',
      sticky: 'data-testimonial-sticky',
      track: 'data-testimonial-track',
    },
    Hb = { cardActive: 'is-active' },
    zb = 0.8,
    Vb = 0.85;
  var QC = () => (xl.matches ? Vb : zb),
    eP = 3,
    tP = { min: 0.2, max: 0.6 },
    iP = 'power2.out',
    nP = 0.1,
    Tf = class {
      constructor() {
        y(this, 'rootElm');
        y(this, 'stickyElm');
        y(this, 'trackElm');
        y(this, 'cardEls', []);
        y(this, 'originalCount', 0);
        y(this, 'step', 0);
        y(this, 'cycle', 0);
        y(this, 'centerOffset', 0);
        y(this, 'cardWidth', 0);
        y(this, 'cardCenters', []);
        y(this, 'lastTransform', '');
        y(this, 'activeElIndex', -1);
        y(this, 'init', () => {
          !this.checkElements() ||
            !this.rootElm ||
            !this.stickyElm ||
            (this.setupLoopClones(),
            Je.create({
              trigger: this.rootElm,
              start: 'top top',
              end: () => `+=${this.step * (this.originalCount - 1)}`,
              pin: this.stickyElm,
              pinType: 'fixed',
              pinSpacing: !0,
              invalidateOnRefresh: !0,
              onUpdate: (e) => {
                this.render(e.progress * (this.originalCount - 1));
              },
              snap: {
                snapTo: 1 / (this.originalCount - 1),
                duration: tP,
                ease: iP,
                delay: nP,
              },
              onToggle: (e) => {
                var t;
                (t = this.rootElm) == null ||
                  t.classList.toggle('is-active', e.isActive);
              },
              onRefresh: (e) => {
                (this.measure(),
                  this.render(e.progress * (this.originalCount - 1)));
              },
            }),
            this.measure(),
            this.render(0));
        });
        y(
          this,
          'checkElements',
          () => !!(this.rootElm && this.stickyElm && this.trackElm),
        );
        y(this, 'setupLoopClones', () => {
          if (!this.trackElm) return;
          let e = Array.from(this.trackElm.children);
          this.originalCount = e.length;
          for (let t = 1; t < eP; t += 1)
            e.forEach((i) => {
              var r;
              let n = i.cloneNode(!0);
              (n.setAttribute('aria-hidden', 'true'),
                (r = this.trackElm) == null || r.appendChild(n));
            });
          this.cardEls = Array.from(this.trackElm.children);
        });
        y(this, 'measure', () => {
          if (!this.stickyElm || this.cardEls.length < 2) return;
          let [e, t] = this.cardEls;
          ((this.step = t.offsetLeft - e.offsetLeft),
            (this.cycle = this.step * this.originalCount),
            (this.centerOffset =
              this.stickyElm.clientWidth / 2 -
              (e.offsetLeft + e.offsetWidth / 2)),
            (this.cardWidth = e.offsetWidth),
            (this.cardCenters = this.cardEls.map(
              (i) => i.offsetLeft + i.offsetWidth / 2,
            )));
        });
        y(this, 'render', (e) => {
          if (!this.trackElm || this.cycle <= 0 || !this.stickyElm) return;
          let i =
              (((e * this.step - this.centerOffset) % this.cycle) +
                this.cycle) %
              this.cycle,
            n = `translate3d(${(-i).toFixed(2)}px, 0, 0)`;
          (n !== this.lastTransform &&
            ((this.lastTransform = n), (this.trackElm.style.transform = n)),
            this.applyCardStates(i));
        });
        y(this, 'applyCardStates', (e) => {
          if (this.step <= 0 || this.cardEls.length === 0 || !this.stickyElm)
            return;
          let t = e + this.stickyElm.clientWidth / 2,
            i = QC(),
            n = 1 - i,
            r = this.cardEls.length,
            o = this.cardCenters.map((d) =>
              Math.max(0, 1 - Math.abs(d - t) / this.step),
            ),
            a = new Array(r);
          a[0] = 0;
          for (let d = 1; d < r; d += 1)
            a[d] = a[d - 1] + (this.cardWidth * n * (o[d - 1] + o[d])) / 2;
          let l = Math.min(
              Math.max(Math.floor((t - this.cardCenters[0]) / this.step), 0),
              r - 2,
            ),
            c = Math.min(Math.max((t - this.cardCenters[l]) / this.step, 0), 1),
            u = a[l] + c * (a[l + 1] - a[l]);
          this.cardEls.forEach((d, p) => {
            let _ = i + n * o[p],
              x = d;
            x.style.transform = `translate3d(${(a[p] - u).toFixed(2)}px, 0, 0) scale(${_.toFixed(4)})`;
          });
          let f = Math.min(
            Math.max(Math.round((t - this.cardCenters[0]) / this.step), 0),
            r - 1,
          );
          f !== this.activeElIndex &&
            ((this.activeElIndex = f),
            this.cardEls.forEach((d, p) => {
              d.classList.toggle(Hb.cardActive, p === f);
            }));
        });
        ((this.rootElm = Ye(`[${Ef.root}]`)),
          (this.stickyElm = this.rootElm
            ? Ye(`[${Ef.sticky}]`, this.rootElm)
            : null),
          (this.trackElm = this.rootElm
            ? Ye(`[${Ef.track}]`, this.rootElm)
            : null),
          this.init());
      }
    };
  var sP = 250,
    Mf = class {
      constructor() {
        y(this, 'smoothScroll');
        y(this, 'bgVideo');
        y(this, 'loading');
        y(this, 'inViewVideo');
        y(this, 'led');
        y(this, 'featureAccordionVideo');
        y(this, 'featureSliderVideo');
        y(this, 'sceneSlider');
        y(this, 'playStyleSlider');
        y(this, 'testimonial');
        y(this, 'introduction');
        y(this, 'playback');
        y(this, 'bluetooth');
        y(this, 'soniclink');
        y(this, 'scrollAnm');
        y(this, 'scrollAnmLineGroups');
        y(this, 'product3d');
        y(this, 'pageBackground');
        y(this, 'lastInnerWidth', window.innerWidth);
        y(this, 'lastDocHeight', document.documentElement.scrollHeight);
        y(this, 'reflowRefreshTimerId', 0);
        y(this, 'onResized', () => {
          let e =
            window.innerWidth === this.lastInnerWidth &&
            window.matchMedia('(hover: none) and (pointer: coarse)').matches;
          if (
            ((this.lastInnerWidth = window.innerWidth),
            e || this.smoothScroll.onResized(),
            e || this.scrollAnmLineGroups.onResized(),
            this.featureSliderVideo.onResized(),
            this.sceneSlider.onResized(),
            this.playStyleSlider.onResized(),
            this.product3d.onResized(e),
            !e)
          ) {
            this.lastDocHeight = document.documentElement.scrollHeight;
            return;
          }
          document.documentElement.scrollHeight !== this.lastDocHeight &&
            (window.clearTimeout(this.reflowRefreshTimerId),
            (this.reflowRefreshTimerId = window.setTimeout(() => {
              ((this.lastDocHeight = document.documentElement.scrollHeight),
                this.smoothScroll.onResized(),
                this.product3d.onResized());
            }, sP)));
        });
        ((this.smoothScroll = new yf()),
          (this.bgVideo = new Jc()),
          (this.product3d = new uf()),
          (this.product3d.introScrollLock = {
            stop: () => this.smoothScroll.stop('product-intro'),
            start: () => this.smoothScroll.start('product-intro'),
          }),
          (this.loading = new qh(
            this.smoothScroll,
            this.bgVideo,
            this.product3d.modelReady,
            () => {
              (this.product3d.onLoadingDismissed(), this.scrollAnm.arm());
            },
          )),
          (this.pageBackground = new pf()),
          (this.inViewVideo = new df()),
          (this.led = new ff(this.product3d)),
          (this.featureAccordionVideo = new Bl()),
          (this.featureSliderVideo = new kl()),
          (this.sceneSlider = new _f()),
          (this.playStyleSlider = new mf()),
          (this.testimonial = new Tf()),
          (this.introduction = new wh()),
          (this.playback = new Zh()),
          (this.bluetooth = new Eh()),
          (this.soniclink = new Sf()),
          (this.scrollAnm = new vf()),
          (this.scrollAnmLineGroups = new xf()));
        if (hdjf9Story) {
          this.scrollAnm.arm();
          this.product3d.modelReady.then(() => this.product3d.onLoadingDismissed());
        }
      }
    };
  var R_ = class {
    constructor() {
      y(this, 'pageMain');
      y(this, 'resizeTimeoutId');
      y(this, 'init', () => {
        (window.addEventListener('DOMContentLoaded', this.onContentLoaded, {
          once: !0,
        }),
          window.addEventListener('load', this.onLoaded, { once: !0 }),
          window.addEventListener('resize', this.onResized));
      });
      y(this, 'onContentLoaded', () => {
        this.pageMain = new Mf();
      });
      y(this, 'onLoaded', () => {});
      y(this, 'onResized', () => {
        (this.resizeTimeoutId && clearTimeout(this.resizeTimeoutId),
          (this.resizeTimeoutId = window.setTimeout(() => {
            var t;
            (t = this.pageMain) == null || t.onResized();
          }, 200)));
      });
      ((this.pageMain = null), this.init());
    }
  };
  new R_();
})();
/*! Bundled license information:

gsap/Observer.js:
  (*!
   * Observer 3.15.0
   * https://gsap.com
   *
   * @license Copyright 2008-2026, GreenSock. All rights reserved.
   * Subject to the terms at https://gsap.com/standard-license
   * @author: Jack Doyle, jack@greensock.com
  *)

gsap/ScrollTrigger.js:
  (*!
   * ScrollTrigger 3.15.0
   * https://gsap.com
   *
   * @license Copyright 2008-2026, GreenSock. All rights reserved.
   * Subject to the terms at https://gsap.com/standard-license
   * @author: Jack Doyle, jack@greensock.com
  *)

gsap/gsap-core.js:
  (*!
   * GSAP 3.15.0
   * https://gsap.com
   *
   * @license Copyright 2008-2026, GreenSock. All rights reserved.
   * Subject to the terms at https://gsap.com/standard-license
   * @author: Jack Doyle, jack@greensock.com
  *)

gsap/CSSPlugin.js:
  (*!
   * CSSPlugin 3.15.0
   * https://gsap.com
   *
   * Copyright 2008-2026, GreenSock. All rights reserved.
   * Subject to the terms at https://gsap.com/standard-license
   * @author: Jack Doyle, jack@greensock.com
  *)

three/build/three.core.js:
three/build/three.module.js:
  (**
   * @license
   * Copyright 2010-2026 Three.js Authors
   * SPDX-License-Identifier: MIT
   *)
*/
